(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8bdb"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8bdb"] = parcelRequire;
}
parcelRequire.register("bRvn3", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $8a2cfa87cf2f491f$export$6503ec6e8aabbaf; }, function (v) { return $8a2cfa87cf2f491f$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $8a2cfa87cf2f491f$export$f7ad0328861e2f03; }, function (v) { return $8a2cfa87cf2f491f$export$f7ad0328861e2f03 = v; });
var $8a2cfa87cf2f491f$export$6503ec6e8aabbaf;
var $8a2cfa87cf2f491f$export$f7ad0328861e2f03;
"use strict";
var $8a2cfa87cf2f491f$var$mapping = {};
function $8a2cfa87cf2f491f$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$8a2cfa87cf2f491f$var$mapping[keys[i]] = pairs[keys[i]];
}
function $8a2cfa87cf2f491f$var$resolve(id) {
    var resolved = $8a2cfa87cf2f491f$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$8a2cfa87cf2f491f$export$6503ec6e8aabbaf = $8a2cfa87cf2f491f$var$register;
$8a2cfa87cf2f491f$export$f7ad0328861e2f03 = $8a2cfa87cf2f491f$var$resolve;

});

parcelRequire.register("kgVKs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ec2218e5cc505a92$export$2e2bcd8739ae039; });

var $do9pw = parcelRequire("do9pw");

var $l0HdX = parcelRequire("l0HdX");

var $6QBky = parcelRequire("6QBky");

var $cdQSr = parcelRequire("cdQSr");
var $ec2218e5cc505a92$export$2e2bcd8739ae039 = {
    data: function() {
        return (0, $do9pw._)({}, (0, $cdQSr.default)());
    },
    props: [
        "thrConfig"
    ],
    mounted: function() {
        var _this = this;
        // Preselected category if configured
        if (typeof this.thrConfig.preselectCategory === "string") {
            this.$log.debug("Category Preselect: " + this.thrConfig.preselectCategory);
            if (this.selectCategory(this.thrConfig.preselectCategory)) this.showScreen("animalSelection");
            // Preselected category if configured
            if (typeof this.thrConfig.preselectAnimal === "string") {
                this.$log.debug("Animal Preselect: " + this.thrConfig.preselectAnimal);
                if (this.selectAnimal(this.thrConfig.preselectAnimal)) this.showScreen("numberOfAnimals");
            }
        }
        if (this.thrConfig.historyMode === "browser") history.pushState({
            thrScreen: this.screen
        }, null, window.location);
        // Attach onpopstate event handler
        window.onpopstate = function() {
            if (history.state !== null && "thrScreen" in history.state && _this.previousScreens[_this.previousScreens.length - 1] === history.state.thrScreen) _this.previousScreen(true);
        };
        // Esc key event handler
        if (this.thrConfig.style === "button") document.addEventListener("keydown", function(param) {
            var key = param.key;
            if (key === "Escape") _this.closeOverlay();
        });
    },
    methods: {
        logoBlv: function() {
            if (document.getElementById("trApp").offsetWidth > 756) {
                if (this.thrConfig.locale == "fr_CH") return this.logoBlvFR;
                else if (this.thrConfig.locale == "it_CH") return this.logoBlvIT;
                else return this.logoBlvDE;
            } else {
                if (this.thrConfig.locale == "fr_CH") return this.logoBlvFRMobile;
                else if (this.thrConfig.locale == "it_CH") return this.logoBlvITMobile;
                else return this.logoBlvDEMobile;
            }
        },
        logoSts: function() {
            if (this.thrConfig.locale == "fr_CH") return this.logoStsFR;
            else if (this.thrConfig.locale == "it_CH") return this.logoStsIT;
            else return this.logoStsDE;
        },
        selectCategory: function(category) {
            if (typeof category === "object") this.category = category;
            else if (typeof category === "string") {
                for(var categoryName in this.categories)if (categoryName === category) {
                    this.category = this.categories[categoryName];
                    break;
                }
            }
            this.$log.debug("Category selected: " + category);
            this.$log.debug("Category type: " + (typeof category === "undefined" ? "undefined" : (0, $l0HdX._)(category)));
            this.$log.debug("Animals in this category: " + this.animals[category.index]);
            if (typeof this.category === "object") return true;
            else return false;
        },
        selectAnimal: function(animal) {
            if (typeof animal === "object") this.animal = animal;
            else if (typeof animal === "string") {
                for(var animalName in this.animals[this.category.index])if (animalName === animal) {
                    this.animal = this.animals[this.category.index][animalName];
                    break;
                }
            }
            if (typeof this.animal === "object") {
                if (this.animal.hasWeightOption) this.animalWeight = this.animal.weightOptions["0"];
                return true;
            } else return false;
        },
        showScreen: function(screenName) {
            this.$log.debug("Previous Screens:", this.previousScreens);
            this.$log.debug("Current screen: " + this.screen);
            this.$log.debug("screenName: " + screenName);
            this.$log.debug("numberOfAnimals:" + this.numberOfAnimals);
            this.$log.debug("animal:" + this.animal);
            if (this.animal !== false) {
                this.$log.debug(this.animal);
                if (typeof this.animal.minHardLimit == "undefined") this.animal.minHardLimit = 1;
                if (typeof this.animal.maxHardLimit == "undefined") this.animal.maxHardLimit = 99;
                this.$log.debug("minHardLimit: " + this.animal.minHardLimit);
                this.$log.debug("maxHardLimit: " + this.animal.maxHardLimit);
                this.$log.debug("hasWeightOptions: " + this.animal.hasWeightOption);
                // Validate input
                if (screenName === "weight" && this.numberOfAnimals < this.animal.minHardLimit || screenName === "weight" && this.numberOfAnimals > this.animal.maxHardLimit) {
                    // Warning if number of animals is under/over min/max limit
                    this.$log.debug("Show warning");
                    this.showNumberError = true;
                    // Scroll to top of the widget
                    this.$refs.mainTitle.scrollIntoView();
                    return;
                }
                if (screenName === "weight" && typeof this.animalWeight === "undefined" && "weightOptions" in this.animal) this.animalWeight = this.animal.weightOptions[this.thrConfig.locale][0];
                // Validate animal length
                if (screenName === "results" && this.animalLength < this.animal.minLength || screenName === "results" && this.animalLength > this.animal.maxLength) {
                    this.$log.debug("LENGTH ERROR: Show length error");
                    this.showLengthError = true;
                    // Scroll to top of the widget
                    this.$refs.mainTitle.scrollIntoView();
                    return;
                }
                // Validate animals withersHeight
                if (screenName === "results") {
                    var heights = this.animalWithersHeights;
                    for(var i in heights)if (heights[i] < this.animal.minWithersHeight || heights[i] > this.animal.maxWithersHeight) {
                        this.$log.debug("WITHERS HEIGHT ERROR: Show withers height error");
                        this.showWithersHeightError = true;
                        // Scroll to top of the widget
                        this.$refs.mainTitle.scrollIntoView();
                        return;
                    }
                }
            }
            var screenIndex = this.availableScreens.indexOf(screenName);
            var nextScreenIndex = -1;
            if (screenIndex > -1) {
                nextScreenIndex = screenIndex;
                this.$log.debug("nextScreenIndex by name");
            } else {
                // Select next screen in order of available screens
                this.$log.debug(this.availableScreens);
                var nextScreenIndex1 = this.availableScreens.indexOf(this.screen) + 1;
                this.$log.debug("nextScreenIndex by list order");
            }
            this.$log.debug("Next screen index: " + nextScreenIndex);
            this.$log.debug("Next screen: " + this.availableScreens[nextScreenIndex]);
            // Skip screens that are optional
            if (this.availableScreens[nextScreenIndex] === "weight" && this.animal.hasWeightOption !== true) {
                nextScreenIndex++;
                this.$log.debug("Skipping screen: weight");
            }
            if (this.availableScreens[nextScreenIndex] === "length" && this.animal.hasLengthOption !== true) {
                nextScreenIndex++;
                this.$log.debug("Skipping screen: length");
            }
            if (this.availableScreens[nextScreenIndex] === "withersHeight" && this.animal.hasWithersHeightOption !== true) {
                nextScreenIndex++;
                this.$log.debug("Skipping screen: withersHeight");
            }
            // Set image to use in length screen
            if (this.availableScreens[nextScreenIndex] === "length") this.lengthImage = this.lengthImages[this.animal.lengthMeasurementCategory];
            // Save previous screens path
            this.previousScreens.push(this.screen);
            // Change to new screen
            this.screen = this.availableScreens[nextScreenIndex];
            if (this.thrConfig.historyMode === "browser") history.pushState({
                thrScreen: this.screen
            }, null, "");
            this.$log.debug("New screen: " + this.screen);
            // Make sure the animalWithersHeights array contains the correct number of elements
            if (this.screen === "withersHeight") {
                this.animalWithersHeights.length = this.numberOfAnimals;
                this.$log.debug("Prepare this.animalWithersHeights array");
                this.$log.debug(this.animalWithersHeights);
                // Set the value to an empty string unless it's already a number. If that's the case, we already have values entered by the user.
                for(var i1 = 0; i1 < this.animalWithersHeights.length; ++i1)if (typeof this.animalWithersHeights[i1] !== "number") this.animalWithersHeights[i1] = "";
            }
            if (this.screen === "results") {
                // Set ratios for the 3d visual
                var cubeContainer = document.getElementById("results-cube-container");
                if (cubeContainer.style.display !== "none") {
                    var ratios = this.stsRecommendedValuesRatios;
                    //cubeContainer.querySelector(".cube").style.transform = "scale3d(" + ratios.length + ", " + ratios.height + ", " + ratios.width + ")";
                    var root = document.documentElement;
                    root.style.setProperty("--tr-visual-3d-scale-x", ratios.length);
                    root.style.setProperty("--tr-visual-3d-scale-y", ratios.width);
                    root.style.setProperty("--tr-visual-3d-scale-z", ratios.height);
                }
            }
            // Analytics Event
            /* global gtagTR */ if (typeof gtagTR === "function") {
                this.$log.debug("Send UA4 event for screen change.");
                gtagTR("event", "show_screen", {
                    screen: this.screen,
                    animal: this.animal.index,
                    numberOfAnimals: this.numberOfAnimals
                });
            } else this.$log.debug("Not sending UA4 event for screen change. gtagTR not a function.");
        },
        previousScreen: function() {
            var isBrowserHistoryEvent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            this.$log.debug(this.previousScreens);
            if (typeof this.previousScreens === "object") {
                this.screen = this.previousScreens[this.previousScreens.length - 1];
                this.previousScreens.splice(this.previousScreens.length - 1, 1);
            }
            // reset animal selection when restarted
            if (this.screen === this.availableScreens[0]) this.animal = false;
            if (!isBrowserHistoryEvent && this.thrConfig.historyMode === "browser") // Trigger history event manually
            history.back();
        },
        lawMinimalHeight: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.height === "string") return this.animal.laws.height;
                else if (typeof this.animal.laws.height === "function") {
                    var height;
                    if (this.animal.hasWeightOption) height = this.animal.laws.height(this.numberOfAnimals, this.animalWeight);
                    else if (this.animal.hasLengthOption) {
                        height = this.animal.laws.height(this.animalLength);
                        this.$log.debug("Found minimal height for " + this.animal.index + " with length " + this.animalLength + ": " + height + " cm");
                    } else height = this.animal.laws.height(this.numberOfAnimals);
                    this.$log.debug("Found minimal height for " + this.animal.index + ": " + height + " cm");
                    return height + " cm";
                }
            }
            return "";
        },
        animalTextExists: function(key) {
            if (typeof key === "string" && this.animal && this.category) {
                var text = (0, (/*@__PURE__*/$parcel$interopDefault($6QBky)))(this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index], key);
                this.$log.debug("Looking for animal text of for key " + key, "Text found: " + text);
                if (typeof text === "string") {
                    this.$log.debug("Found animal text for key " + key + ": " + text);
                    return true;
                }
            }
            this.$log.debug("Could not find animal text for key " + key);
            return false;
        },
        animalTextsExist: function(keys) {
            var _this = this;
            this.$log.debug("Check multiple animal texts: " + keys);
            var found = false;
            if (typeof keys === "object" && this.animal) keys.forEach(function(key) {
                if (_this.animalTextExists(key) === true) found = true;
            });
            return found;
        },
        openOverlay: function(event) {
            console.log(event.target);
            event.target.closest(".sts-tierhaltungsrechner").querySelector(".tr-wrapper").classList.add("open");
            // Customizations for specific websites
            if (window.location.hostname.includes("tierschutz.com")) {
                var appElement = document.querySelector("#trApp .tr-wrapper");
                var parentElement = document.querySelector("body");
                // Move app element into body tag
                if (appElement !== null) parentElement.append(appElement);
                appElement.classList.add("tierschutzcom");
                // Create additional element for lightbox formatting
                var lbDiv = document.createElement("div");
                lbDiv.classList.add("tierhaltungsrechner");
                lbDiv.classList.add("modal-bg");
                parentElement.append(lbDiv);
            }
        },
        closeOverlay: function() {
            var event = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
            if (event !== false) {
                event.target.closest(".sts-tierhaltungsrechner").querySelector(".tr-button").classList.remove("hidden");
                event.target.closest(".sts-tierhaltungsrechner").querySelector(".tr-wrapper").classList.remove("open");
            } else {
                document.querySelectorAll(".sts-tierhaltungsrechner .tr-button").forEach(function(element) {
                    element.classList.remove("hidden");
                });
                document.querySelectorAll(".sts-tierhaltungsrechner .tr-wrapper").forEach(function(element) {
                    element.classList.remove("open");
                });
            }
        },
        showMessage: function(elementId) {
            console.log(elementId);
            var element = document.getElementById(elementId);
            if (element !== null) element.style.display = "block";
        }
    },
    watch: {
        numberOfAnimals: function numberOfAnimals(val, oldVal) {
            if (val < 1 && val !== "") this.numberOfAnimals = 1;
        }
    },
    computed: {
        weightOptions: function() {
            if (this.animal !== false && "weightOptions" in this.animal) return this.animal.weightOptions[this.thrConfig.locale];
            else return {};
        },
        numberErrorType: function() {
            if (this.animal.minHardLimit > this.numberOfAnimals) return "under";
            else if (this.animal.maxHardLimit < this.numberOfAnimals) return "over";
            else this.showNumberError = false;
        },
        numberWarningType: function() {
            if (this.animal.minSoftLimit > this.numberOfAnimals) return "under";
            else if (this.animal.maxSoftLimit < this.numberOfAnimals) return "over";
            else this.showNumberError = false;
        },
        stsRecommendedArea: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.area === "number") return this.animal.recommendations.area;
                else if (typeof this.animal.recommendations.area === "string") return this.animal.recommendations.area;
                else if (typeof this.animal.recommendations.area === "function") {
                    var area = this.animal.recommendations.area(this.numberOfAnimals);
                    area = Math.round((area + Number.EPSILON) * 100) / 100;
                    this.$log.debug("stsRecommendedArea: " + area);
                    return area;
                }
            }
            return "";
        },
        stsRecommendedLength: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.length === "string") return this.animal.recommendations.length;
            }
            return "";
        },
        stsRecommendedWidth: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.width === "string") return this.animal.recommendations.width;
            }
            return "";
        },
        stsRecommendedHeight: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.height === "string") return this.animal.recommendations.height;
                else if (typeof this.animal.recommendations.height === "function") {
                    if (this.category.index === "reptiles") return this.animal.recommendations.height(this.animalLength);
                    else {
                        var height = this.animal.recommendations.height(this.numberOfAnimals);
                        height = Math.round((height + Number.EPSILON) * 100) / 100;
                        this.$log.debug("stsHeightRecommendation: " + height);
                        return height;
                    }
                } else if (typeof this.animal.recommendations.clearHeight === "function") {
                    var height1 = this.animal.recommendations.clearHeight(this.animalWithersHeights);
                    this.$log.info("stsHeightRecommendation 1: " + height1.value);
                    height1 = Math.round((height1.value + Number.EPSILON) * 100) / 100;
                    this.$log.info(this.animalWithersHeights);
                    this.$log.info("stsHeightRecommendation 2: " + height1);
                    return height1 + " m";
                }
            }
            return "";
        },
        stsRecommendedBedding: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.bedding === "string") return this.animal.recommendations.bedding;
                else if (typeof this.animal.recommendations.bedding === "function") {
                    var bedding = this.animal.recommendations.bedding(this.numberOfAnimals);
                    bedding = Math.round((bedding + Number.EPSILON) * 100) / 100;
                    this.$log.debug("stsBeddingRecommendation: " + bedding);
                    return bedding;
                }
            }
            return "";
        },
        stsLatticeSpacing: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.latticeSpacing === "string") return this.animal.recommendations.latticeSpacing;
            }
        },
        stsRecommendedWidthExample: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                var recommendedArea = 0;
                if (typeof this.animal.recommendations.area === "function") recommendedArea = this.animal.recommendations.area(this.numberOfAnimals);
                else if (typeof this.animal.recommendations.layingArea === "function") recommendedArea = this.animal.recommendations.layingArea(this.animalWithersHeights);
                else return 0;
                this.$log.info("Example area: " + recommendedArea);
                // Rectangle with aspect ratio of 1:2, short side
                var width = Math.sqrt(recommendedArea / 2);
                // Round to nearest 10cm
                width = Math.round(width * 10) / 10;
                // Consider minimum width
                if ("width" in this.animal.recommendations) {
                    var widthNumber = this.animal.recommendations.width.match(/\d+/)[0] / 100;
                    this.$log.debug("AREA: Animal has recommended min width: " + widthNumber);
                    if (width < widthNumber) {
                        this.$log.debug("AREA: Set width to " + widthNumber + " insead of: " + width);
                        width = widthNumber;
                    }
                }
                // Consider minumum clearWidth for equidae
                if ("clearWidth" in this.animal.recommendations) {
                    var widthNumber1 = this.animal.recommendations.clearWidth(this.animalWithersHeights);
                    this.$log.info("AREA: this.animalsWithersHeights: " + this.animalWithersHeights);
                    this.$log.info("AREA: Animal has recommended min width: " + widthNumber1);
                    if (width < widthNumber1) {
                        this.$log.info("AREA: Set width to " + widthNumber1 + " insead of: " + width);
                        width = widthNumber1;
                    }
                }
                // Consider minimum length
                if ("length" in this.animal.recommendations) {
                    var minimalLengthNumber = this.animal.recommendations.length.match(/\d+/)[0] / 100;
                    this.$log.info("AREA: Animal has recommended min length: " + minimalLengthNumber);
                    var currentExampleLength = recommendedArea / width;
                    if (currentExampleLength < minimalLengthNumber) {
                        this.$log.debug("AREA: currentExampleLength " + currentExampleLength + "m is shorter than the recommended " + this.animal.recommendations.length);
                        width = recommendedArea / minimalLengthNumber;
                    }
                }
                // Consider certain animal special cases
                if (this.animal.index === "madagascarDayGecko" || this.animal.index === "goldDustDayGecko") {
                    // Needs a square area
                    width = Math.sqrt(recommendedArea);
                    this.$log.debug("AREA: Set area to square for day geckos. Width: " + width);
                }
                this.$log.info("stsRecommendedWidthExample: " + Math.round((width + Number.EPSILON) * 100));
                return Math.round((width + Number.EPSILON) * 100);
            }
            return 0;
        },
        stsRecommendedLengthExample: function() {
            this.$log.info(this.animal);
            this.$log.info(this.animalWithersHeights);
            this.$log.info("stsRecommendedWidthExample: " + this.stsRecommendedWidthExample);
            if (this.animal !== false && "recommendations" in this.animal) {
                var length = 0;
                if (typeof this.animal.recommendations.area === "function") length = this.animal.recommendations.area(this.numberOfAnimals) / (this.stsRecommendedWidthExample / 100);
                else if (typeof this.animal.recommendations.layingArea === "function") length = this.animal.recommendations.layingArea(this.animalWithersHeights) / (this.stsRecommendedWidthExample / 100);
                else return 0;
                // Consider minimum length
                // this.stsRecommendedWidthExample already adapts to minimum width, due to rounding we sometimes need to increase the number for the length as well
                if ("length" in this.animal.recommendations) {
                    var minimalLengthNumber = this.animal.recommendations.length.match(/\d+/)[0] / 100;
                    if (minimalLengthNumber > length) length = minimalLengthNumber;
                }
                this.$log.info("stsRecommendedLengthExample: " + Math.round((length + Number.EPSILON) * 100));
                return Math.round((length + Number.EPSILON) * 100);
            }
            this.$log.info("stsRecommendedLengthExample: not calculated");
            return 0;
        },
        stsRecommendedLengthExampleText: function() {
            var length = this.stsRecommendedLengthExample;
            if (length >= 100) return length / 100 + " m";
            else return length + " cm";
        },
        stsRecommendedWidthExampleText: function() {
            var width = this.stsRecommendedWidthExample;
            if (width >= 100) return width / 100 + " m";
            else return width + " cm";
        },
        stsRecommendedValuesRatios: function() {
            var exampleDimensions = {};
            this.$log.info(this.category.index);
            if (this.category.index === "equidae") {
                this.$log.info(this.animal.recommendations.clearHeight());
                this.$log.info(this.animal.recommendations.clearHeight().value);
                exampleDimensions = {
                    length: this.stsRecommendedLengthExample,
                    width: this.stsRecommendedWidthExample,
                    height: this.animal.recommendations.clearHeight().value * 100
                };
            } else exampleDimensions = {
                length: this.stsRecommendedLengthExample,
                width: this.stsRecommendedWidthExample,
                height: this.animal.recommendations.heightNumeric
            };
            this.$log.info("exampleDimensions");
            this.$log.info(exampleDimensions);
            var largestNumber = Math.max(exampleDimensions.length, exampleDimensions.width, exampleDimensions.height);
            // Arbitrary number we scale by
            var factor = 1.2;
            var ratios = {
                "width": exampleDimensions.width / largestNumber * factor,
                "length": exampleDimensions.length / largestNumber * factor,
                "height": exampleDimensions.height / largestNumber * factor
            };
            this.$log.info(ratios);
            return ratios;
        },
        stsRecommendedWaterBasin: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                var waterBasinText = "";
                // Get formulas
                if ("waterBasin" in this.animal.recommendations) {
                    if (typeof this.animal.recommendations.waterBasin === "function") waterBasinText = this.animal.recommendations.waterBasin(this.numberOfAnimals, this.animalLength);
                }
                // Grab texts
                var recommendationTexts = this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index].recommendations;
                this.$log.debug("recommendationTexts: " + recommendationTexts);
                if ("waterBasin" in recommendationTexts) waterBasinText += recommendationTexts.waterBasin;
                return waterBasinText;
            }
            return "";
        },
        stsRecommendedLayingArea: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.layingArea === "string") return this.animal.recommendations.layingArea;
                else if (typeof this.animal.recommendations.layingArea === "function") return this.animal.recommendations.layingArea(this.animalWithersHeights);
            }
            return "";
        },
        stsRecommendedClearWidth: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.clearWidth === "string") return this.animal.recommendations.clearWidth;
                else if (typeof this.animal.recommendations.clearWidth === "function") return this.animal.recommendations.clearWidth(this.animalWithersHeights);
            }
            return "";
        },
        stsRecommendedClearHeight: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.clearHeight === "string") return this.animal.recommendations.clearHeight;
                else if (typeof this.animal.recommendations.clearHeight === "function") return this.animal.recommendations.clearHeight(this.animalWithersHeights);
            }
            return "";
        },
        stsRecommendedRunoutArea: function() {
            if (this.animal !== false && "recommendations" in this.animal) {
                if (typeof this.animal.recommendations.runoutArea === "string") return this.animal.recommendations.runoutArea;
                else if (typeof this.animal.recommendations.runoutArea === "function") return this.animal.recommendations.runoutArea(this.numberOfAnimals);
            }
            return "";
        },
        lawMinimalArea: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.area === "string") return this.animal.laws.area;
                else if (typeof this.animal.laws.area === "function") {
                    var area;
                    if (this.animal.hasWeightOption && this.category.index === "rodents") area = this.animal.laws.area(this.numberOfAnimals, this.animalWeight);
                    else if (this.category.index === "reptiles") area = this.animal.laws.area(this.numberOfAnimals, this.animalLength / 100);
                    else area = this.animal.laws.area(this.numberOfAnimals);
                    area = Math.round((area + Number.EPSILON) * 100) / 100;
                    this.$log.debug("minimalArea: " + area);
                    return area + " m\xb2";
                }
            }
            return "";
        },
        lawMinimalLength: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.length === "string") return this.animal.laws.length;
                else if (typeof this.animal.laws.length === "function") {
                    var length = this.animal.laws.length(this.animalLength);
                    length = Math.round((length + Number.EPSILON) * 100) / 100;
                    this.$log.debug("minimalLength: " + length);
                    return length + " cm";
                }
            }
            return "";
        },
        lawMinimalWidth: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.width === "string") return this.animal.laws.width;
                else if (typeof this.animal.laws.width === "function") {
                    var width = this.animal.laws.width(this.animalLength);
                    width = Math.round((width + Number.EPSILON) * 100) / 100;
                    this.$log.debug("minimalLength: " + width);
                    return width + " cm";
                }
            }
            return "";
        },
        lawMinimalBedding: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.bedding === "string") return this.animal.laws.bedding;
                else if (typeof this.animal.laws.bedding === "function") {
                    var bedding = this.animal.laws.bedding(this.numberOfAnimals);
                    bedding = Math.round((bedding + Number.EPSILON) * 100) / 100;
                    this.$log.debug("bedding: " + bedding);
                    return bedding + " m";
                }
            }
            return "";
        },
        lawWaterBasin: function() {
            if (this.animal !== false && "laws" in this.animal) {
                var waterBasinText = "";
                // Get formulas
                if ("waterBasin" in this.animal.laws) {
                    if (typeof this.animal.laws.waterBasin === "function") waterBasinText = this.animal.laws.waterBasin(this.numberOfAnimals, this.animalLength);
                }
                // Grab texts
                var lawTexts = this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index].laws;
                this.$log.debug("lawTexts: " + lawTexts);
                if ("waterBasin" in lawTexts) waterBasinText += lawTexts.waterBasin;
                return waterBasinText;
            }
            return "";
        },
        lawVolume: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.volume === "string") return this.animal.laws.volume;
                else if (typeof this.animal.laws.volume === "function") {
                    var volume = this.animal.laws.volume(this.numberOfAnimals);
                    volume = Math.round((volume + Number.EPSILON) * 100) / 100;
                    this.$log.debug("volume: " + volume);
                    return volume + " m\xb3";
                }
            }
            return "";
        },
        lawLayingArea: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.layingArea === "string") return this.animal.laws.layingArea;
                else if (typeof this.animal.laws.layingArea === "function") return this.animal.laws.layingArea(this.animalWithersHeights);
            }
            return "";
        },
        lawLayingAreaMultiroom: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.layingAreaMultiroom === "string") return this.animal.laws.layingAreaMultiroom;
                else if (typeof this.animal.laws.layingAreaMultiroom === "function") return this.animal.laws.layingAreaMultiroom(this.animalWithersHeights);
            }
            return "";
        },
        lawClearWidth: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.clearWidth === "string") return this.animal.laws.clearWidth;
                else if (typeof this.animal.laws.clearWidth === "function") return this.animal.laws.clearWidth(this.animalWithersHeights);
            }
            return "";
        },
        lawClearHeight: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.clearHeight === "string") return this.animal.laws.clearHeight;
                else if (typeof this.animal.laws.clearHeight === "function") return this.animal.laws.clearHeight(this.animalWithersHeights);
            }
            return "";
        },
        lawRunoutArea: function() {
            if (this.animal !== false && "laws" in this.animal) {
                if (typeof this.animal.laws.runoutArea === "string") return this.animal.laws.runoutArea;
                else if (typeof this.animal.laws.runoutArea === "function") return this.animal.laws.runoutArea(this.animalWithersHeights);
            }
            return "";
        },
        showNumberWarning: function() {
            if (this.animal.minSoftLimit > this.numberOfAnimals || this.animal.maxSoftLimit < this.numberOfAnimals) return true;
            else return false;
        },
        animalLinks: function() {
            if (this.animal) return this.$i18n.messages[this.thrConfig.locale].txt.animals[this.category.index][this.animal.index].links;
            return false;
        }
    }
};

});
parcelRequire.register("do9pw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9bf4d105a019f48b$export$581ff339ea0ba762; });

var $3sHb8 = parcelRequire("3sHb8");
function $9bf4d105a019f48b$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $3sHb8._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRequire.register("3sHb8", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $28557b013f37bb6b$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $28557b013f37bb6b$export$1e71eb4bef00f6b0; });
function $28557b013f37bb6b$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRequire.register("l0HdX", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $f4bb2077aa61b74c$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $f4bb2077aa61b74c$export$5f0017c582d45a2d; });
function $f4bb2077aa61b74c$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRequire.register("6QBky", function(module, exports) {

var $c2xhj = parcelRequire("c2xhj");
/**
 *
 * @param {Object} o
 * @param {String} path
 * @returns {*}
 */ module.exports = function(o, path) {
    if (typeof path !== "string") throw new TypeError("path must be a string");
    if (typeof o !== "object") throw new TypeError("object must be passed");
    var pathObj = $c2xhj.get(path);
    if (!pathObj.valid) throw new Error("path is not a valid object path");
    return pathObj.getValueFrom(o);
};

});
parcelRequire.register("c2xhj", function(module, exports) {
// gutted from https://github.com/Polymer/observe-js/blob/master/src/observe.js
function $8c3f7c482cdb352e$var$noop() {}
function $8c3f7c482cdb352e$var$detectEval() {
    // Don't test for eval if we're running in a Chrome App environment.
    // We check for APIs set that only exist in a Chrome App context.
    if (typeof chrome !== "undefined" && chrome.app && chrome.app.runtime) return false;
    // Firefox OS Apps do not allow eval. This feature detection is very hacky
    // but even if some other platform adds support for this function this code
    // will continue to work.
    if (typeof navigator != "undefined" && navigator.getDeviceStorage) return false;
    try {
        var f = new Function("", "return true;");
        return f();
    } catch (ex) {
        return false;
    }
}
var $8c3f7c482cdb352e$var$hasEval = $8c3f7c482cdb352e$var$detectEval();
function $8c3f7c482cdb352e$var$isIndex(s) {
    return +s === s >>> 0 && s !== "";
}
function $8c3f7c482cdb352e$var$isObject(obj) {
    return obj === Object(obj);
}
var $8c3f7c482cdb352e$var$createObject = "__proto__" in {} ? function createObject(obj) {
    return obj;
} : function(obj) {
    var proto = obj.__proto__;
    if (!proto) return obj;
    var newObject = Object.create(proto);
    Object.getOwnPropertyNames(obj).forEach(function(name) {
        Object.defineProperty(newObject, name, Object.getOwnPropertyDescriptor(obj, name));
    });
    return newObject;
};
function $8c3f7c482cdb352e$var$parsePath(path) {
    var maybeUnescapeQuote = function maybeUnescapeQuote() {
        if (index >= path.length) return;
        var nextChar = path[index + 1];
        if (mode == "inSingleQuote" && nextChar == "'" || mode == "inDoubleQuote" && nextChar == '"') {
            index++;
            newChar = nextChar;
            actions.append();
            return true;
        }
    };
    var keys = [];
    var index = -1;
    var c, newChar, key, type, transition, action, typeMap, mode = "beforePath";
    var actions = {
        push: function push() {
            if (key === undefined) return;
            keys.push(key);
            key = undefined;
        },
        append: function append() {
            if (key === undefined) key = newChar;
            else key += newChar;
        }
    };
    while(mode){
        index++;
        c = path[index];
        if (c == "\\" && maybeUnescapeQuote(mode)) continue;
        type = $8c3f7c482cdb352e$var$getPathCharType(c);
        typeMap = $8c3f7c482cdb352e$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["else"] || "error";
        if (transition == "error") return; // parse error
        mode = transition[0];
        action = actions[transition[1]] || $8c3f7c482cdb352e$var$noop;
        newChar = transition[2] === undefined ? c : transition[2];
        action();
        if (mode === "afterPath") return keys;
    }
    return; // parse error
}
var $8c3f7c482cdb352e$var$identStart = "[$_a-zA-Z]";
var $8c3f7c482cdb352e$var$identPart = "[$_a-zA-Z0-9]";
var $8c3f7c482cdb352e$var$identRegExp = new RegExp("^" + $8c3f7c482cdb352e$var$identStart + "+" + $8c3f7c482cdb352e$var$identPart + "*" + "$");
function $8c3f7c482cdb352e$var$isIdent(s) {
    return $8c3f7c482cdb352e$var$identRegExp.test(s);
}
var $8c3f7c482cdb352e$var$constructorIsPrivate = {};
function $8c3f7c482cdb352e$var$Path(parts, privateToken) {
    if (privateToken !== $8c3f7c482cdb352e$var$constructorIsPrivate) throw Error("Use Path.get to retrieve path objects");
    for(var i = 0; i < parts.length; i++)this.push(String(parts[i]));
    if ($8c3f7c482cdb352e$var$hasEval && this.length) this.getValueFrom = this.compiledGetValueFromFn();
}
var $8c3f7c482cdb352e$var$pathCache = {};
function $8c3f7c482cdb352e$var$getPath(pathString) {
    if (pathString instanceof $8c3f7c482cdb352e$var$Path) return pathString;
    if (pathString == null || pathString.length == 0) pathString = "";
    if (typeof pathString != "string") {
        if ($8c3f7c482cdb352e$var$isIndex(pathString.length)) // Constructed with array-like (pre-parsed) keys
        return new $8c3f7c482cdb352e$var$Path(pathString, $8c3f7c482cdb352e$var$constructorIsPrivate);
        pathString = String(pathString);
    }
    var path = $8c3f7c482cdb352e$var$pathCache[pathString];
    if (path) return path;
    var parts = $8c3f7c482cdb352e$var$parsePath(pathString);
    if (!parts) return $8c3f7c482cdb352e$var$invalidPath;
    var path = new $8c3f7c482cdb352e$var$Path(parts, $8c3f7c482cdb352e$var$constructorIsPrivate);
    $8c3f7c482cdb352e$var$pathCache[pathString] = path;
    return path;
}
$8c3f7c482cdb352e$var$Path.get = $8c3f7c482cdb352e$var$getPath;
function $8c3f7c482cdb352e$var$formatAccessor(key) {
    if ($8c3f7c482cdb352e$var$isIndex(key)) return "[" + key + "]";
    else return '["' + key.replace(/"/g, '\\"') + '"]';
}
$8c3f7c482cdb352e$var$Path.prototype = $8c3f7c482cdb352e$var$createObject({
    __proto__: [],
    valid: true,
    toString: function toString() {
        var pathString = "";
        for(var i = 0; i < this.length; i++){
            var key = this[i];
            if ($8c3f7c482cdb352e$var$isIdent(key)) pathString += i ? "." + key : key;
            else pathString += $8c3f7c482cdb352e$var$formatAccessor(key);
        }
        return pathString;
    },
    getValueFrom: function getValueFrom(obj, directObserver) {
        for(var i = 0; i < this.length; i++){
            if (obj == null) return;
            obj = obj[this[i]];
        }
        return obj;
    },
    iterateObjects: function iterateObjects(obj, observe) {
        for(var i = 0; i < this.length; i++){
            if (i) obj = obj[this[i - 1]];
            if (!$8c3f7c482cdb352e$var$isObject(obj)) return;
            observe(obj, this[i]);
        }
    },
    compiledGetValueFromFn: function compiledGetValueFromFn() {
        var str = "";
        var pathString = "obj";
        str += "if (obj != null";
        var i = 0;
        var key;
        for(; i < this.length - 1; i++){
            key = this[i];
            pathString += $8c3f7c482cdb352e$var$isIdent(key) ? "." + key : $8c3f7c482cdb352e$var$formatAccessor(key);
            str += " &&\n     " + pathString + " != null";
        }
        str += ")\n";
        var key = this[i];
        pathString += $8c3f7c482cdb352e$var$isIdent(key) ? "." + key : $8c3f7c482cdb352e$var$formatAccessor(key);
        str += "  return " + pathString + ";\nelse\n  return undefined;";
        return new Function("obj", str);
    },
    setValueFrom: function setValueFrom(obj, value) {
        if (!this.length) return false;
        for(var i = 0; i < this.length - 1; i++){
            if (!$8c3f7c482cdb352e$var$isObject(obj)) return false;
            obj = obj[this[i]];
        }
        if (!$8c3f7c482cdb352e$var$isObject(obj)) return false;
        obj[this[i]] = value;
        return true;
    }
});
function $8c3f7c482cdb352e$var$getPathCharType(char) {
    if (char === undefined) return "eof";
    var code = char.charCodeAt(0);
    switch(code){
        case 0x5B:
        case 0x5D:
        case 0x2E:
        case 0x22:
        case 0x27:
        case 0x30:
            return char;
        case 0x5F:
        case 0x24:
            return "ident";
        case 0x20:
        case 0x09:
        case 0x0A:
        case 0x0D:
        case 0xA0:
        case 0xFEFF:
        case 0x2028:
        case 0x2029:
            return "ws";
    }
    // a-z, A-Z
    if (0x61 <= code && code <= 0x7A || 0x41 <= code && code <= 0x5A) return "ident";
    // 1-9
    if (0x31 <= code && code <= 0x39) return "number";
    return "else";
}
var $8c3f7c482cdb352e$var$pathStateMachine = {
    "beforePath": {
        "ws": [
            "beforePath"
        ],
        "ident": [
            "inIdent",
            "append"
        ],
        "[": [
            "beforeElement"
        ],
        "eof": [
            "afterPath"
        ]
    },
    "inPath": {
        "ws": [
            "inPath"
        ],
        ".": [
            "beforeIdent"
        ],
        "[": [
            "beforeElement"
        ],
        "eof": [
            "afterPath"
        ]
    },
    "beforeIdent": {
        "ws": [
            "beforeIdent"
        ],
        "ident": [
            "inIdent",
            "append"
        ]
    },
    "inIdent": {
        "ident": [
            "inIdent",
            "append"
        ],
        "0": [
            "inIdent",
            "append"
        ],
        "number": [
            "inIdent",
            "append"
        ],
        "ws": [
            "inPath",
            "push"
        ],
        ".": [
            "beforeIdent",
            "push"
        ],
        "[": [
            "beforeElement",
            "push"
        ],
        "eof": [
            "afterPath",
            "push"
        ]
    },
    "beforeElement": {
        "ws": [
            "beforeElement"
        ],
        "0": [
            "afterZero",
            "append"
        ],
        "number": [
            "inIndex",
            "append"
        ],
        "'": [
            "inSingleQuote",
            "append",
            ""
        ],
        '"': [
            "inDoubleQuote",
            "append",
            ""
        ]
    },
    "afterZero": {
        "ws": [
            "afterElement",
            "push"
        ],
        "]": [
            "inPath",
            "push"
        ]
    },
    "inIndex": {
        "0": [
            "inIndex",
            "append"
        ],
        "number": [
            "inIndex",
            "append"
        ],
        "ws": [
            "afterElement"
        ],
        "]": [
            "inPath",
            "push"
        ]
    },
    "inSingleQuote": {
        "'": [
            "afterElement"
        ],
        "eof": [
            "error"
        ],
        "else": [
            "inSingleQuote",
            "append"
        ]
    },
    "inDoubleQuote": {
        '"': [
            "afterElement"
        ],
        "eof": [
            "error"
        ],
        "else": [
            "inDoubleQuote",
            "append"
        ]
    },
    "afterElement": {
        "ws": [
            "afterElement"
        ],
        "]": [
            "inPath",
            "push"
        ]
    }
};
var $8c3f7c482cdb352e$var$invalidPath = new $8c3f7c482cdb352e$var$Path("", $8c3f7c482cdb352e$var$constructorIsPrivate);
$8c3f7c482cdb352e$var$invalidPath.valid = false;
$8c3f7c482cdb352e$var$invalidPath.getValueFrom = $8c3f7c482cdb352e$var$invalidPath.setValueFrom = function() {};
module.exports = $8c3f7c482cdb352e$var$Path;

});


parcelRequire.register("cdQSr", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e5fb733627e8cf7$export$2e2bcd8739ae039; });
















































































































































































































function $8e5fb733627e8cf7$export$2e2bcd8739ae039() {
    return {
        title: "Tierhaltungs-Rechner",
        logoStsDE: (parcelRequire("4vugx")),
        logoStsFR: (parcelRequire("cC5Zd")),
        logoStsIT: (parcelRequire("1bPYp")),
        logoBlvDE: (parcelRequire("hbCDv")),
        logoBlvDEMobile: (parcelRequire("kNmn8")),
        logoBlvFR: (parcelRequire("2kq6y")),
        logoBlvFRMobile: (parcelRequire("chjOx")),
        logoBlvIT: (parcelRequire("5F8Ek")),
        logoBlvITMobile: (parcelRequire("5khZv")),
        icon68: (parcelRequire("aIJeH")),
        iconWarning: (parcelRequire("iFCVw")),
        iconWarningWhite: (parcelRequire("aGbQ8")),
        screen: "categorySelection",
        category: false,
        animal: false,
        numberOfAnimals: 1,
        animalWeight: false,
        animalLength: false,
        lengthImage: null,
        lengthImages: {
            lizards: (parcelRequire("hGJbG")),
            snakes: (parcelRequire("01KKm")),
            turtles: (parcelRequire("6l66h"))
        },
        animalWithersHeights: [],
        withersHeightImage: (parcelRequire("mFOFh")),
        showNumberError: false,
        showLengthError: false,
        showWithersHeightError: false,
        availableScreens: [
            "categorySelection",
            "animalSelection",
            "multipleBirds",
            "numberOfAnimals",
            "weight",
            "length",
            "withersHeight",
            "results"
        ],
        previousScreens: [],
        categories: {
            rodents: {
                index: "rodents",
                img: (parcelRequire("dxPQn")),
                imgSmall: (parcelRequire("5R00h")),
                imgMedium: (parcelRequire("1pNkE")),
                imgLarge: (parcelRequire("dZ6Qh"))
            },
            reptiles: {
                index: "reptiles",
                img: (parcelRequire("gjs0b")),
                imgSmall: (parcelRequire("4rpxu")),
                imgMedium: (parcelRequire("RbKkV")),
                imgLarge: (parcelRequire("5h4FS"))
            },
            birds: {
                index: "birds",
                img: (parcelRequire("40RLs")),
                imgSmall: (parcelRequire("52oJg")),
                imgMedium: (parcelRequire("ubo2S")),
                imgLarge: (parcelRequire("ct7WS")),
                imgMultiple: (parcelRequire("7rM3z")),
                imgMultipleSmall: (parcelRequire("7sAQ1")),
                imgMultipleMedium: (parcelRequire("gQNGp")),
                imgMultipleLarge: (parcelRequire("aBEKv"))
            },
            equidae: {
                index: "equidae",
                img: (parcelRequire("9kMyW")),
                imgSmall: (parcelRequire("ai3hr")),
                imgMedium: (parcelRequire("f1qwt")),
                imgLarge: (parcelRequire("i5iZy"))
            }
        },
        animals: {
            rodents: {
                degu: {
                    index: "degu",
                    img: (parcelRequire("jjaZI")),
                    imgSmall: (parcelRequire("5O59F")),
                    imgMedium: (parcelRequire("e4RQx")),
                    imgLarge: (parcelRequire("3yEbd")),
                    minHardLimit: 2,
                    maxSoftLimit: 5,
                    maxHardLimit: 8,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 5, 0) * 0.4;
                        },
                        height: "200 cm",
                        bedding: "50 - 60 cm",
                        latticeSpacing: "1.3 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 5, 0) * 0.2;
                        },
                        height: "70 cm",
                        bedding: "30 cm"
                    }
                },
                fancyMouse: {
                    index: "fancyMouse",
                    img: (parcelRequire("g0HSb")),
                    imgSmall: (parcelRequire("avfXs")),
                    imgMedium: (parcelRequire("6UJi3")),
                    imgLarge: (parcelRequire("j0dQZ")),
                    minHardLimit: 2,
                    maxSoftLimit: 6,
                    maxHardLimit: 10,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 0.8 + Math.max(numberOfAnimals - 2, 0) * 0.3;
                        },
                        height: "100 cm",
                        bedding: "20 - 40 cm",
                        latticeSpacing: "0.7 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.18 + Math.max(numberOfAnimals - 2, 0) * 0.05;
                        },
                        height: "-",
                        bedding: "-"
                    }
                },
                goldenHamster: {
                    index: "goldenHamster",
                    img: (parcelRequire("7Mjmn")),
                    imgSmall: (parcelRequire("g1N83")),
                    imgMedium: (parcelRequire("bbvsH")),
                    imgLarge: (parcelRequire("dRKJP")),
                    maxHardLimit: 1,
                    recommendations: {
                        area: function area() {
                            return 1;
                        },
                        height: "100 cm",
                        bedding: "40 - 80 cm",
                        latticeSpacing: "0.7 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.18;
                        },
                        height: "-",
                        bedding: "15 cm"
                    }
                },
                rabbit: {
                    index: "rabbit",
                    img: (parcelRequire("inGTN")),
                    imgSmall: (parcelRequire("3Li3I")),
                    imgMedium: (parcelRequire("fxzDh")),
                    imgLarge: (parcelRequire("bzGW1")),
                    minHardLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 6,
                    hasWeightOption: true,
                    weightOptions: {
                        de_CH: {
                            0: "bis 2.3 Kg",
                            1: "2.3 bis 3.5 Kg",
                            2: "3.5 bis 5.5 Kg",
                            3: "mehr als 5.5 Kg"
                        },
                        fr_CH: {
                            0: "jusqu'\xe0 2,3 kg",
                            1: "entre 2,3 et 3,5 kg",
                            2: "entre 3,5 et 5,5 kg",
                            3: "plus de 5,5 kg"
                        },
                        it_CH: {
                            0: "fino a 2.3 Kg",
                            1: "da 2.3 a 3.5 Kg",
                            2: "da 3.5 a 5.5 Kg",
                            3: "pi\xf9 di 5.5 Kg"
                        }
                    },
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 6 + Math.max(numberOfAnimals - 2, 0) * 0.5;
                        },
                        height: "70 - 100 cm",
                        bedding: "5 - 10 cm",
                        latticeSpacing: "2.5 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            var animalWeight = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                            var weightOptionStrings = {
                                "bis 2.3 Kg": "bis 2.3 Kg",
                                "2.3 bis 3.5 Kg": "2.3 bis 3.5 Kg",
                                "3.5 bis 5.5 Kg": "3.5 bis 5.5 Kg",
                                "mehr als 5.5 Kg": "mehr als 5.5 Kg",
                                "jusqu'\xe0 2,3 kg": "bis 2.3 Kg",
                                "entre 2,3 et 3,5 kg": "2.3 bis 3.5 Kg",
                                "entre 3,5 et 5,5 kg": "3.5 bis 5.5 Kg",
                                "plus de 5,5 kg": "mehr als 5.5 Kg",
                                "fino a 2.3 Kg": "bis 2.3 Kg",
                                "da 2.3 a 3.5 Kg": "2.3 bis 3.5 Kg",
                                "da 3.5 a 5.5 Kg": "3.5 bis 5.5 Kg",
                                "pi\xf9 di 5.5 Kg": "mehr als 5.5 Kg"
                            };
                            animalWeight = weightOptionStrings[animalWeight];
                            var values = {
                                "bis 2.3 Kg": {
                                    2: 0.48,
                                    3: 0.815,
                                    4: 1.15,
                                    5: 1.418,
                                    6: 1.686
                                },
                                "2.3 bis 3.5 Kg": {
                                    2: 0.48,
                                    3: 0.815,
                                    4: 1.15,
                                    5: 1.418,
                                    6: 1.686
                                },
                                "3.5 bis 5.5 Kg": {
                                    2: 0.72,
                                    3: 1.22,
                                    4: 1.72,
                                    5: 2.12,
                                    6: 2.52
                                },
                                "mehr als 5.5 Kg": {
                                    2: 0.93,
                                    3: 1.53,
                                    4: 2.28,
                                    5: 2.76,
                                    6: 3.24
                                }
                            };
                            if (animalWeight in values && numberOfAnimals in values[animalWeight]) {
                                var area = values[animalWeight][numberOfAnimals];
                                return area;
                            } else return "0";
                        },
                        height: function height(numberOfAnimals, animalWeight) {
                            var weightOptionStrings = {
                                "bis 2.3 Kg": "bis 2.3 Kg",
                                "2.3 bis 3.5 Kg": "2.3 bis 3.5 Kg",
                                "3.5 bis 5.5 Kg": "3.5 bis 5.5 Kg",
                                "mehr als 5.5 Kg": "mehr als 5.5 Kg",
                                "jusqu'\xe0 2,3 kg": "bis 2.3 Kg",
                                "entre 2,3 et 3,5 kg": "2.3 bis 3.5 Kg",
                                "entre 3,5 et 5,5 kg": "3.5 bis 5.5 Kg",
                                "plus de 5,5 kg": "mehr als 5.5 Kg",
                                "fino a 2.3 Kg": "bis 2.3 Kg",
                                "da 2.3 a 3.5 Kg": "2.3 bis 3.5 Kg",
                                "da 3.5 a 5.5 Kg": "3.5 bis 5.5 Kg",
                                "pi\xf9 di 5.5 Kg": "mehr als 5.5 Kg"
                            };
                            animalWeight = weightOptionStrings[animalWeight];
                            switch(animalWeight){
                                case "bis 2.3 Kg":
                                    return "40 ";
                                case "2.3 bis 3.5 Kg":
                                    return "50 ";
                                case "3.5 bis 5.5 Kg":
                                    return "60 ";
                                case "mehr als 5.5 Kg":
                                    return "60 ";
                                default:
                                    return 0;
                            }
                        },
                        bedding: "-"
                    }
                },
                guineaPig: {
                    index: "guineaPig",
                    img: (parcelRequire("3cp0U")),
                    imgSmall: (parcelRequire("kMxp0")),
                    imgMedium: (parcelRequire("h0YEN")),
                    imgLarge: (parcelRequire("7Vg4L")),
                    minHardLimit: 2,
                    maxSoftLimit: 6,
                    maxHardLimit: 8,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 4 + Math.max(numberOfAnimals - 4, 0) * 0.5;
                        },
                        height: "50 cm",
                        bedding: "5 - 10 cm",
                        latticeSpacing: "2.5 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 2, 0) * 0.2;
                        },
                        height: "-",
                        bedding: "-"
                    }
                },
                rat: {
                    index: "rat",
                    img: (parcelRequire("chFci")),
                    imgSmall: (parcelRequire("eqyx7")),
                    imgMedium: (parcelRequire("5Ojb3")),
                    imgLarge: (parcelRequire("3BxgW")),
                    minHardLimit: 2,
                    maxSoftLimit: 6,
                    maxHardLimit: 8,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 5, 0) * 0.4;
                        },
                        height: "200 cm",
                        bedding: "-",
                        latticeSpacing: "1.2 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 5, 0) * 0.05;
                        },
                        height: "70 cm",
                        bedding: "-"
                    }
                },
                gerbil: {
                    index: "gerbil",
                    img: (parcelRequire("7gWqx")),
                    imgSmall: (parcelRequire("hQPYn")),
                    imgMedium: (parcelRequire("WnHWD")),
                    imgLarge: (parcelRequire("hNzxi")),
                    minHardLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 5,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 1 + Math.max(numberOfAnimals - 2, 0) * 0.4;
                        },
                        height: "100 cm",
                        bedding: "40 - 80 cm",
                        latticeSpacing: "1 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 5, 0) * 0.05;
                        },
                        height: "-",
                        bedding: "25 cm"
                    }
                },
                dwarfHamster: {
                    index: "dwarfHamster",
                    img: (parcelRequire("kOAw9")),
                    imgSmall: (parcelRequire("12nMW")),
                    imgMedium: (parcelRequire("Nmdt2")),
                    imgLarge: (parcelRequire("aH7iG")),
                    minSoftLimit: 4,
                    maxHardLimit: 5,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 0.8 + Math.max(numberOfAnimals - 2, 0) * 0.3;
                        },
                        height: "100 cm",
                        bedding: "40 - 80 cm",
                        latticeSpacing: "0.7 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.18 + Math.max(numberOfAnimals - 1, 0) * 0.05;
                        },
                        height: "-",
                        bedding: "15 cm"
                    }
                }
            },
            reptiles: {
                royalPython: {
                    index: "royalPython",
                    img: (parcelRequire("9HhZp")),
                    imgSmall: (parcelRequire("3fvWB")),
                    imgMedium: (parcelRequire("asrpl")),
                    imgLarge: (parcelRequire("h9vNX")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 5,
                    minLength: 20,
                    maxLength: 140,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 1.8 + Math.max(numberOfAnimals - 2, 0) * 0.5;
                        },
                        length: "180 cm",
                        width: "100 cm",
                        height: function height(animalLength) {
                            if (animalLength >= 130) return "110 cm";
                            else return "100 cm";
                        }
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 0.5 * animalLength + Math.max(numberOfAnimals - 2, 0) * 0.2 * animalLength * 0.5 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength;
                        },
                        width: function width(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function height(animalLength) {
                            return Math.round(animalLength * 0.75 + Number.EPSILON);
                        }
                    }
                },
                cornSnake: {
                    index: "cornSnake",
                    img: (parcelRequire("iUpWs")),
                    imgSmall: (parcelRequire("4x00d")),
                    imgMedium: (parcelRequire("ag54h")),
                    imgLarge: (parcelRequire("3NvLV")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 3,
                    maxHardLimit: 5,
                    minLength: 20,
                    maxLength: 150,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 1.44 + Math.max(numberOfAnimals - 2, 0) * 0.4;
                        },
                        length: "180 cm",
                        width: "80 cm",
                        height: function height(animalLength) {
                            if (animalLength >= 140) return "110 cm";
                            else return "100 cm";
                        }
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 0.5 * animalLength + Math.max(numberOfAnimals - 2, 0) * 0.2 * animalLength * 0.5 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength;
                        },
                        width: function width(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function height(animalLength) {
                            return Math.round(animalLength * 0.7 + Number.EPSILON);
                        }
                    }
                },
                greekTortoise: {
                    index: "greekTortoise",
                    img: (parcelRequire("2Mr5P")),
                    imgSmall: (parcelRequire("ju6gu")),
                    imgMedium: (parcelRequire("f3rLh")),
                    imgLarge: (parcelRequire("acd7l")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 9,
                    minLength: 3,
                    maxLength: 40,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 10 + Math.max(numberOfAnimals - 4, 0) * 2.5;
                        },
                        length: "400 cm",
                        width: "250 cm",
                        height: "-"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 8 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 8;
                        },
                        width: function width(animalLength) {
                            return animalLength * 4;
                        },
                        height: "-"
                    }
                },
                moorishTortoise: {
                    index: "moorishTortoise",
                    img: (parcelRequire("f1FyG")),
                    imgSmall: (parcelRequire("euibr")),
                    imgMedium: (parcelRequire("iF8XL")),
                    imgLarge: (parcelRequire("er0eb")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 9,
                    minLength: 3,
                    maxLength: 40,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 10 + Math.max(numberOfAnimals - 4, 0) * 2.5;
                        },
                        length: "400 cm",
                        width: "250 cm",
                        height: "-"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 8 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 8;
                        },
                        width: function width(animalLength) {
                            return animalLength * 4;
                        },
                        height: "-"
                    }
                },
                wideShelledTortoise: {
                    index: "wideShelledTortoise",
                    img: (parcelRequire("lwZp8")),
                    imgSmall: (parcelRequire("dDfOf")),
                    imgMedium: (parcelRequire("ekRI0")),
                    imgLarge: (parcelRequire("hVqD4")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 9,
                    minLength: 3,
                    maxLength: 40,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 10 + Math.max(numberOfAnimals - 4, 0) * 2.5;
                        },
                        length: "400 cm",
                        width: "250 cm",
                        height: "-"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 8 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 8;
                        },
                        width: function width(animalLength) {
                            return animalLength * 4;
                        },
                        height: "-"
                    }
                },
                crownedGecko: {
                    index: "crownedGecko",
                    img: (parcelRequire("59REH")),
                    imgSmall: (parcelRequire("4B6Zu")),
                    imgMedium: (parcelRequire("dYk2A")),
                    imgLarge: (parcelRequire("b7293")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 1,
                    maxLength: 12,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 0.48 + Math.max(numberOfAnimals - 2, 0) * 0.2;
                        },
                        length: "80 cm",
                        width: "60 cm",
                        height: "120 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 2 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 6;
                        },
                        width: function width(animalLength) {
                            return animalLength * 2;
                        },
                        height: function height(animalLength) {
                            return animalLength * 8;
                        }
                    }
                },
                boaConstrictor: {
                    index: "boaConstrictor",
                    img: (parcelRequire("bp0bh")),
                    imgSmall: (parcelRequire("hjkjG")),
                    imgMedium: (parcelRequire("bEw5B")),
                    imgLarge: (parcelRequire("jFXRe")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 20,
                    maxLength: 300,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 5.25 + Math.max(numberOfAnimals - 2, 0) * 1;
                        },
                        length: "350 cm",
                        width: "150 cm",
                        height: function height(animalLength) {
                            if (animalLength >= 260) return "225 cm";
                            else return "200 cm";
                        }
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 1 * animalLength * 0.5 + Math.max(numberOfAnimals - 2, 0) * 0.5 * animalLength * 0.2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 1;
                        },
                        width: function width(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function height(animalLength) {
                            return Math.round(animalLength * 0.75 + Number.EPSILON);
                        }
                    }
                },
                muskTurtle: {
                    index: "muskTurtle",
                    img: (parcelRequire("i0b7v")),
                    imgSmall: (parcelRequire("kFvLB")),
                    imgMedium: (parcelRequire("4Ff2h")),
                    imgLarge: (parcelRequire("iBi3c")),
                    lengthMeasurementCategory: "turtles",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 4,
                    minLength: 2,
                    maxLength: 15,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 0.9 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        length: "150 cm",
                        width: "60 cm",
                        height: "50 cm",
                        waterBasin: function waterBasin(numberOfAnimals, animalLength) {
                            var area = 0.9 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                            return Math.round(area * 67 + Number.EPSILON) / 100 + " m\xb2 ";
                        }
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 2 * animalLength * 2 + Math.max(numberOfAnimals - 2, 0) * 1 * animalLength * 1 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 2;
                        },
                        width: function width(animalLength) {
                            return animalLength * 2;
                        },
                        height: "-",
                        waterBasin: function waterBasin(numberOfAnimals, animalLength) {
                            var area = animalLength * 4 * animalLength * 3 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                            return Math.ceil(area / 100 + Number.EPSILON) / 100 + " m\xb2 ";
                        }
                    }
                },
                kingSnake: {
                    index: "kingSnake",
                    img: (parcelRequire("kawZX")),
                    imgSmall: (parcelRequire("cOZbM")),
                    imgMedium: (parcelRequire("6tdWd")),
                    imgLarge: (parcelRequire("cEETP")),
                    lengthMeasurementCategory: "snakes",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 1,
                    maxHardLimit: 5,
                    minLength: 15,
                    maxLength: 140,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 1.44 + Math.max(numberOfAnimals - 2, 0) * 0.4;
                        },
                        length: "180 cm",
                        width: "80 cm",
                        height: "80 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 1 * animalLength * 0.5 + Math.max(numberOfAnimals - 2, 0) * 0.5 * animalLength * 0.2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 1;
                        },
                        width: function width(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        },
                        height: function height(animalLength) {
                            return Math.round(animalLength * 0.5 + Number.EPSILON);
                        }
                    }
                },
                madagascarDayGecko: {
                    index: "madagascarDayGecko",
                    img: (parcelRequire("19XcZ")),
                    imgSmall: (parcelRequire("75yiU")),
                    imgMedium: (parcelRequire("15Ynv")),
                    imgLarge: (parcelRequire("lHhON")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 4,
                    minLength: 2,
                    maxLength: 15,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 1 + Math.max(numberOfAnimals - 2, 0) * 0.25;
                        },
                        length: "100 cm",
                        width: "100 cm",
                        height: "150 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 6 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 6;
                        },
                        width: function width(animalLength) {
                            return animalLength * 6;
                        },
                        height: function height(animalLength) {
                            return animalLength * 8;
                        }
                    }
                },
                goldDustDayGecko: {
                    index: "goldDustDayGecko",
                    img: (parcelRequire("heG4Z")),
                    imgSmall: (parcelRequire("dTmUi")),
                    imgMedium: (parcelRequire("fg8ZF")),
                    imgLarge: (parcelRequire("i2Uvn")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 4,
                    minLength: 1,
                    maxLength: 7,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 0.25 + Math.max(numberOfAnimals - 2, 0) * 0.15;
                        },
                        length: "50 cm",
                        width: "50 cm",
                        height: "70 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 6 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 6;
                        },
                        width: function width(animalLength) {
                            return animalLength * 6;
                        },
                        height: function height(animalLength) {
                            return animalLength * 8;
                        }
                    }
                },
                leopardGecko: {
                    index: "leopardGecko",
                    img: (parcelRequire("gjs0b")),
                    imgSmall: (parcelRequire("4rpxu")),
                    imgMedium: (parcelRequire("RbKkV")),
                    imgLarge: (parcelRequire("5h4FS")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 2,
                    maxLength: 12,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 1.05 + Math.max(numberOfAnimals - 2, 0) * 0.15;
                        },
                        length: "140 cm",
                        width: "75 cm",
                        height: "75 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 6 * animalLength * 6 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 6;
                        },
                        width: function width(animalLength) {
                            return animalLength * 6;
                        },
                        height: function height(animalLength) {
                            return animalLength * 2;
                        }
                    }
                },
                dwarfBeardedDragon: {
                    index: "dwarfBeardedDragon",
                    img: (parcelRequire("d3VlM")),
                    imgSmall: (parcelRequire("clSAQ")),
                    imgMedium: (parcelRequire("6h3Sh")),
                    imgLarge: (parcelRequire("4PCd9")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 2,
                    maxLength: 14,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 0.9 + Math.max(numberOfAnimals - 2, 0) * 0.2;
                        },
                        length: "150 cm",
                        width: "60 cm",
                        height: "100 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 5 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 5;
                        },
                        width: function width(animalLength) {
                            return animalLength * 4;
                        },
                        height: function height(animalLength) {
                            return animalLength * 4;
                        }
                    }
                },
                centralBeardedDragon: {
                    index: "centralBeardedDragon",
                    img: (parcelRequire("6Zd3e")),
                    imgSmall: (parcelRequire("3nRAe")),
                    imgMedium: (parcelRequire("5OOXz")),
                    imgLarge: (parcelRequire("aReoA")),
                    lengthMeasurementCategory: "lizards",
                    minHardLimit: 0,
                    minSoftLimit: 2,
                    maxSoftLimit: 2,
                    maxHardLimit: 3,
                    minLength: 2,
                    maxLength: 20,
                    hasLengthOption: true,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 2, 0) * 0.5;
                        },
                        length: "250 cm",
                        width: "80 cm",
                        height: "100 cm"
                    },
                    laws: {
                        area: function area(numberOfAnimals, animalLength) {
                            return animalLength * 5 * animalLength * 4 + Math.max(numberOfAnimals - 2, 0) * 2 * animalLength * 2 * animalLength;
                        },
                        length: function length(animalLength) {
                            return animalLength * 5;
                        },
                        width: function width(animalLength) {
                            return animalLength * 4;
                        },
                        height: function height(animalLength) {
                            return animalLength * 4;
                        }
                    }
                }
            },
            birds: {
                budgerigar: {
                    index: "budgerigar",
                    img: (parcelRequire("3Lf6Q")),
                    imgSmall: (parcelRequire("7FhmS")),
                    imgMedium: (parcelRequire("e0dyy")),
                    imgLarge: (parcelRequire("djrRE")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                cockatiel: {
                    index: "cockatiel",
                    img: (parcelRequire("40RLs")),
                    imgSmall: (parcelRequire("52oJg")),
                    imgMedium: (parcelRequire("ubo2S")),
                    imgLarge: (parcelRequire("ct7WS")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                agapornid: {
                    index: "agapornid",
                    img: (parcelRequire("2iyHd")),
                    imgSmall: (parcelRequire("41dWx")),
                    imgMedium: (parcelRequire("guR3J")),
                    imgLarge: (parcelRequire("kEmdN")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                amazon: {
                    index: "amazon",
                    img: (parcelRequire("1ocVi")),
                    imgSmall: (parcelRequire("i7xl6")),
                    imgMedium: (parcelRequire("fkpZZ")),
                    imgLarge: (parcelRequire("03s9W")),
                    minHardLimit: 2,
                    maxSoftLimit: 5,
                    maxHardLimit: 6,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 6 + Math.max(numberOfAnimals - 4, 0) * 1;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.7 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        height: "1.2 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.84 + Math.max(numberOfAnimals - 2, 0) * 0.12;
                        }
                    }
                },
                congoGreyParrot: {
                    index: "congoGreyParrot",
                    img: (parcelRequire("4QhmC")),
                    imgSmall: (parcelRequire("1N18O")),
                    imgMedium: (parcelRequire("ewmhY")),
                    imgLarge: (parcelRequire("j0q29")),
                    minHardLimit: 2,
                    maxSoftLimit: 4,
                    maxHardLimit: 6,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 6 + Math.max(numberOfAnimals - 4, 0) * 1;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.7 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        height: "1.2 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.84 + Math.max(numberOfAnimals - 2, 0) * 0.12;
                        }
                    }
                },
                tarantaParrot: {
                    index: "tarantaParrot",
                    img: (parcelRequire("hHEwR")),
                    imgSmall: (parcelRequire("7LPsu")),
                    imgMedium: (parcelRequire("5Xfft")),
                    imgLarge: (parcelRequire("Ph9vA")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                rosellaConure: {
                    index: "rosellaConure",
                    img: (parcelRequire("9F2Ds")),
                    imgSmall: (parcelRequire("8oHTQ")),
                    imgMedium: (parcelRequire("cPGSb")),
                    imgLarge: (parcelRequire("hoiBf")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 6;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.7 + Math.max(numberOfAnimals - 2, 0) * 0.1;
                        },
                        height: "1.2 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.84 + Math.max(numberOfAnimals - 2, 0) * 0.12;
                        }
                    }
                },
                beautifulParakeet: {
                    index: "beautifulParakeet",
                    img: (parcelRequire("egpIs")),
                    imgSmall: (parcelRequire("DoAq2")),
                    imgMedium: (parcelRequire("6KMe3")),
                    imgLarge: (parcelRequire("iTNmw")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                canary: {
                    index: "canary",
                    img: (parcelRequire("hBMFr")),
                    imgSmall: (parcelRequire("81wvf")),
                    imgMedium: (parcelRequire("cjBla")),
                    imgLarge: (parcelRequire("fIPDI")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                gouldianMadine: {
                    index: "gouldianMadine",
                    img: (parcelRequire("f9biR")),
                    imgSmall: (parcelRequire("5xZH1")),
                    imgMedium: (parcelRequire("4r1dV")),
                    imgLarge: (parcelRequire("6I1Bt")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                zebraFinch: {
                    index: "zebraFinch",
                    img: (parcelRequire("6SZ8H")),
                    imgSmall: (parcelRequire("63cnI")),
                    imgMedium: (parcelRequire("cGPFC")),
                    imgLarge: (parcelRequire("kAq3i")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                goldenBreasted: {
                    index: "goldenBreasted",
                    img: (parcelRequire("aV7qg")),
                    imgSmall: (parcelRequire("lnP93")),
                    imgMedium: (parcelRequire("2ftoy")),
                    imgLarge: (parcelRequire("erKcH")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                grayWaxbill: {
                    index: "grayWaxbill",
                    img: (parcelRequire("8fI4S")),
                    imgSmall: (parcelRequire("ljNFh")),
                    imgMedium: (parcelRequire("jGNrw")),
                    imgLarge: (parcelRequire("7Rv6L")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.24 + Math.max(numberOfAnimals - 4, 0) * 0.05;
                        },
                        height: "0.5 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.12 + Math.max(numberOfAnimals - 4, 0) * 0.025;
                        }
                    }
                },
                diamondDove: {
                    index: "diamondDove",
                    img: (parcelRequire("75kDN")),
                    imgSmall: (parcelRequire("lEiFk")),
                    imgMedium: (parcelRequire("bS63f")),
                    imgLarge: (parcelRequire("egUpJ")),
                    minHardLimit: 2,
                    maxSoftLimit: 8,
                    maxHardLimit: 20,
                    recommendations: {
                        area: function area(numberOfAnimals) {
                            return 2 + Math.max(numberOfAnimals - 6, 0) * 0.2;
                        },
                        height: "2 m",
                        heightNumeric: 200
                    },
                    laws: {
                        area: function area(numberOfAnimals) {
                            return 0.5 + Math.max(numberOfAnimals - 6, 0) * 0.05;
                        },
                        height: "0.6 m",
                        volume: function volume(numberOfAnimals) {
                            return 0.3 + Math.max(numberOfAnimals - 6, 0) * 0.03;
                        }
                    }
                },
                macaw: {
                    index: "macaw",
                    img: (parcelRequire("jlWLb")),
                    imgSmall: (parcelRequire("knDVd")),
                    imgMedium: (parcelRequire("eG8T8")),
                    imgLarge: (parcelRequire("azHIx")),
                    minHardLimit: 2,
                    maxSoftLimit: 1,
                    maxHardLimit: 2,
                    recommendations: {
                        area: "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Ara-Haltung ab. Der Platzbedarf f\xfcr eine tiergerechte Ara-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden.",
                        height: "-"
                    },
                    laws: {
                        area: "10 m\xb2",
                        height: "3 m (zu erg\xe4nzen mit 80%-Regelung)",
                        volume: function volume(numberOfAnimals) {
                            return 30 + Math.max(numberOfAnimals - 2, 0) * 3;
                        }
                    }
                },
                cockatoo: {
                    index: "cockatoo",
                    img: (parcelRequire("i3qT5")),
                    imgSmall: (parcelRequire("35cse")),
                    imgMedium: (parcelRequire("ivC7A")),
                    imgLarge: (parcelRequire("kHn4w")),
                    minHardLimit: 2,
                    maxSoftLimit: 1,
                    maxHardLimit: 2,
                    recommendations: {
                        area: "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Kakadu-Haltung ab (ausser Nymphensittich). Der Platzbedarf f\xfcr eine tiergerechte Kakadu-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden. ",
                        height: "-"
                    },
                    laws: {
                        area: "10 m\xb2",
                        height: "3 m (zu erg\xe4nzen mit 80%-Regelung)",
                        volume: function volume(numberOfAnimals) {
                            return 30 + Math.max(numberOfAnimals - 2, 0) * 3;
                        }
                    }
                }
            },
            equidae: {
                horse: {
                    index: "horse",
                    img: (parcelRequire("9kMyW")),
                    imgSmall: (parcelRequire("ai3hr")),
                    imgMedium: (parcelRequire("f1qwt")),
                    imgLarge: (parcelRequire("i5iZy")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 149,
                    maxWithersHeight: 200,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = 0;
                            for(var i in witherHeights){
                                if (witherHeights[i] < 162) layingArea += 13.5;
                                else if (witherHeights[i] < 175) layingArea += 15.75;
                                else layingArea += 18;
                            }
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else if (witherHeights[i] < 175) {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                } else {
                                    layingArea.value += 12;
                                    layingArea.tolerance += 10.5;
                                    layingArea.multiroom += 8;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = layingArea.multiroom * 0.8;
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(witherHeights) {
                            var runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else if (witherHeights[i] < 175) {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                pony: {
                    index: "pony",
                    img: (parcelRequire("9LYwU")),
                    imgSmall: (parcelRequire("3aKxS")),
                    imgMedium: (parcelRequire("93yJD")),
                    imgLarge: (parcelRequire("cBMnp")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 40,
                    maxWithersHeight: 148,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = 0;
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else layingArea += 12;
                            }
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                }
                            }
                            if (layingArea.tolerance >= layingArea.value) layingArea.tolerance = 0;
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else clearHeight = {
                                value: 2.1,
                                tolerance: 2.0
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(witherHeights) {
                            var runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                donkey: {
                    index: "donkey",
                    img: (parcelRequire("8ZDWa")),
                    imgSmall: (parcelRequire("nkV3x")),
                    imgMedium: (parcelRequire("2SrYz")),
                    imgLarge: (parcelRequire("kxbpG")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 40,
                    maxWithersHeight: 180,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = 0;
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else if (witherHeights[i] < 148) layingArea += 12;
                                else if (witherHeights[i] < 162) layingArea += 13.5;
                                else layingArea += 15.75;
                            }
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else if (witherHeights[i] < 148) {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                } else if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(witherHeights) {
                            var runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else if (witherHeights[i] < 148) {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                } else if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                mule: {
                    index: "mule",
                    img: (parcelRequire("apPYz")),
                    imgSmall: (parcelRequire("5ougx")),
                    imgMedium: (parcelRequire("fV2Dp")),
                    imgLarge: (parcelRequire("8RTDj")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 80,
                    maxWithersHeight: 190,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = 0;
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else if (witherHeights[i] < 148) layingArea += 12;
                                else if (witherHeights[i] < 162) layingArea += 13.5;
                                else layingArea += 15.75;
                            }
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else if (witherHeights[i] < 148) {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                } else if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(witherHeights) {
                            var runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else if (witherHeights[i] < 148) {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                } else if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                },
                hinny: {
                    index: "hinny",
                    img: (parcelRequire("iPvcC")),
                    imgSmall: (parcelRequire("dy6mf")),
                    imgMedium: (parcelRequire("3sspN")),
                    imgLarge: (parcelRequire("hhmL6")),
                    minSoftLimit: 2,
                    maxSoftLimit: 4,
                    minWithersHeight: 80,
                    maxWithersHeight: 190,
                    hasWithersHeightOption: true,
                    recommendations: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = 0;
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) layingArea += 7.75;
                                else if (witherHeights[i] < 134) layingArea += 10.5;
                                else if (witherHeights[i] < 148) layingArea += 12;
                                else if (witherHeights[i] < 162) layingArea += 13.5;
                                else layingArea += 15.75;
                            }
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 2 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else if (highest < 175) clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(numberOfAnimals) {
                            return 150 * numberOfAnimals;
                        }
                    },
                    laws: {
                        layingArea: function layingArea(witherHeights) {
                            var layingArea = {
                                value: 0,
                                tolerance: 0,
                                multiroom: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    layingArea.value += 5.5;
                                    layingArea.tolerance += 5.5;
                                    layingArea.multiroom += 4;
                                } else if (witherHeights[i] < 134) {
                                    layingArea.value += 7;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 4.5;
                                } else if (witherHeights[i] < 148) {
                                    layingArea.value += 8;
                                    layingArea.tolerance += 7;
                                    layingArea.multiroom += 5.5;
                                } else if (witherHeights[i] < 162) {
                                    layingArea.value += 9;
                                    layingArea.tolerance += 8;
                                    layingArea.multiroom += 6;
                                } else {
                                    layingArea.value += 10.5;
                                    layingArea.tolerance += 9;
                                    layingArea.multiroom += 7.5;
                                }
                            }
                            if (witherHeights.length >= 5) layingArea.multiroom = Math.round(layingArea.multiroom * 8) / 10;
                            return layingArea;
                        },
                        clearWidth: function clearWidth(witherHeights) {
                            var highest = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            return highest * 1.5 / 100;
                        },
                        clearHeight: function clearHeight(witherHeights) {
                            var highest = 0;
                            var clearHeight = 0;
                            for(var i in witherHeights)if (witherHeights[i] > highest) highest = witherHeights[i];
                            if (highest < 120) clearHeight = {
                                value: 1.8,
                                tolerance: 0
                            };
                            else if (highest < 134) clearHeight = {
                                value: 1.9,
                                tolerance: 0
                            };
                            else if (highest < 148) clearHeight = {
                                value: 2.1,
                                tolerance: 2
                            };
                            else if (highest < 162) clearHeight = {
                                value: 2.3,
                                tolerance: 2.2
                            };
                            else clearHeight = {
                                value: 2.5,
                                tolerance: 2.2
                            };
                            return clearHeight;
                        },
                        runoutArea: function runoutArea(witherHeights) {
                            var runoutArea = {
                                adjacent: 0,
                                nonadjacent: 0
                            };
                            for(var i in witherHeights){
                                if (witherHeights[i] < 120) {
                                    runoutArea.adjacent += 12;
                                    runoutArea.nonadjacent += 18;
                                } else if (witherHeights[i] < 134) {
                                    runoutArea.adjacent += 14;
                                    runoutArea.nonadjacent += 21;
                                } else if (witherHeights[i] < 148) {
                                    runoutArea.adjacent += 16;
                                    runoutArea.nonadjacent += 24;
                                } else if (witherHeights[i] < 162) {
                                    runoutArea.adjacent += 20;
                                    runoutArea.nonadjacent += 30;
                                } else {
                                    runoutArea.adjacent += 24;
                                    runoutArea.nonadjacent += 36;
                                }
                            }
                            return runoutArea;
                        }
                    }
                }
            }
        }
    };
}

});
parcelRequire.register("4vugx", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("ja4MD");

});
parcelRequire.register("6Aq0R", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $4cba487fb552c90c$export$bdfd709ae4826697; }, function (v) { return $4cba487fb552c90c$export$bdfd709ae4826697 = v; });
var $4cba487fb552c90c$export$bdfd709ae4826697;
var $4cba487fb552c90c$export$c9e73fbda7da57b6;
var $4cba487fb552c90c$export$5a759dc7a1cfb72a;
"use strict";
var $4cba487fb552c90c$var$bundleURL = {};
function $4cba487fb552c90c$var$getBundleURLCached(id) {
    var value = $4cba487fb552c90c$var$bundleURL[id];
    if (!value) {
        value = $4cba487fb552c90c$var$getBundleURL();
        $4cba487fb552c90c$var$bundleURL[id] = value;
    }
    return value;
}
function $4cba487fb552c90c$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $4cba487fb552c90c$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $4cba487fb552c90c$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $4cba487fb552c90c$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$4cba487fb552c90c$export$bdfd709ae4826697 = $4cba487fb552c90c$var$getBundleURLCached;
$4cba487fb552c90c$export$c9e73fbda7da57b6 = $4cba487fb552c90c$var$getBaseURL;
$4cba487fb552c90c$export$5a759dc7a1cfb72a = $4cba487fb552c90c$var$getOrigin;

});


parcelRequire.register("cC5Zd", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5SBlC");

});

parcelRequire.register("1bPYp", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6VrDU");

});

parcelRequire.register("hbCDv", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8RU2F");

});

parcelRequire.register("kNmn8", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5IKFz");

});

parcelRequire.register("2kq6y", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lJI6R");

});

parcelRequire.register("chjOx", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("7UjrZ");

});

parcelRequire.register("5F8Ek", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("cnqJK");

});

parcelRequire.register("5khZv", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("352jE");

});

parcelRequire.register("aIJeH", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("cX2Bz");

});

parcelRequire.register("iFCVw", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5KKNR");

});

parcelRequire.register("aGbQ8", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("e3ttH");

});

parcelRequire.register("hGJbG", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("hWl48");

});

parcelRequire.register("01KKm", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5oQro");

});

parcelRequire.register("6l66h", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dezXr");

});

parcelRequire.register("mFOFh", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("kbWRv");

});

parcelRequire.register("dxPQn", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("12710");

});

parcelRequire.register("5R00h", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dWO64");

});

parcelRequire.register("1pNkE", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("axomw");

});

parcelRequire.register("dZ6Qh", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("aqakd");

});

parcelRequire.register("gjs0b", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("bx9Gx");

});

parcelRequire.register("4rpxu", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8uMmT");

});

parcelRequire.register("RbKkV", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("blAG8");

});

parcelRequire.register("5h4FS", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("cH7hC");

});

parcelRequire.register("40RLs", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("XIcAI");

});

parcelRequire.register("52oJg", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("ax7c0");

});

parcelRequire.register("ubo2S", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9rvAe");

});

parcelRequire.register("ct7WS", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("oMKRy");

});

parcelRequire.register("7rM3z", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("76WFY");

});

parcelRequire.register("7sAQ1", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jPi7p");

});

parcelRequire.register("gQNGp", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9nrhP");

});

parcelRequire.register("aBEKv", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("cZFzF");

});

parcelRequire.register("9kMyW", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("k0xjp");

});

parcelRequire.register("ai3hr", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9ugT7");

});

parcelRequire.register("f1qwt", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lhg4Z");

});

parcelRequire.register("i5iZy", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dt3FV");

});

parcelRequire.register("jjaZI", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("apW5B");

});

parcelRequire.register("5O59F", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("hLb2L");

});

parcelRequire.register("e4RQx", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6qTcm");

});

parcelRequire.register("3yEbd", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fZAb4");

});

parcelRequire.register("g0HSb", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("aasyh");

});

parcelRequire.register("avfXs", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dT2RT");

});

parcelRequire.register("6UJi3", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lV953");

});

parcelRequire.register("j0dQZ", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("k8bnH");

});

parcelRequire.register("7Mjmn", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fgyfY");

});

parcelRequire.register("g1N83", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("bxRkK");

});

parcelRequire.register("bbvsH", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lNl61");

});

parcelRequire.register("dRKJP", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dPgsb");

});

parcelRequire.register("inGTN", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6YQ26");

});

parcelRequire.register("3Li3I", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8jgZ5");

});

parcelRequire.register("fxzDh", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4q3zP");

});

parcelRequire.register("bzGW1", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("GICf6");

});

parcelRequire.register("3cp0U", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6wIu0");

});

parcelRequire.register("kMxp0", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5csR4");

});

parcelRequire.register("h0YEN", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("b5r04");

});

parcelRequire.register("7Vg4L", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("iAGdv");

});

parcelRequire.register("chFci", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("2TTkF");

});

parcelRequire.register("eqyx7", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fqVmk");

});

parcelRequire.register("5Ojb3", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("axZW5");

});

parcelRequire.register("3BxgW", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("hZ2ko");

});

parcelRequire.register("7gWqx", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fHJhc");

});

parcelRequire.register("hQPYn", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8sZ2x");

});

parcelRequire.register("WnHWD", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("eh5mz");

});

parcelRequire.register("hNzxi", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("a22iY");

});

parcelRequire.register("kOAw9", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("2f6SF");

});

parcelRequire.register("12nMW", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("3DOg3");

});

parcelRequire.register("Nmdt2", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("h2Mdc");

});

parcelRequire.register("aH7iG", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jBBrJ");

});

parcelRequire.register("9HhZp", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4fecT");

});

parcelRequire.register("3fvWB", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dhcMT");

});

parcelRequire.register("asrpl", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8LXue");

});

parcelRequire.register("h9vNX", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("iol6v");

});

parcelRequire.register("iUpWs", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dna2y");

});

parcelRequire.register("4x00d", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jsdks");

});

parcelRequire.register("ag54h", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("gap2c");

});

parcelRequire.register("3NvLV", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("b6D9F");

});

parcelRequire.register("2Mr5P", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("b9giA");

});

parcelRequire.register("ju6gu", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("guXWy");

});

parcelRequire.register("f3rLh", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9BwQf");

});

parcelRequire.register("acd7l", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("a4cjX");

});

parcelRequire.register("f1FyG", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("aONSO");

});

parcelRequire.register("euibr", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5B6yC");

});

parcelRequire.register("iF8XL", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("47tRl");

});

parcelRequire.register("er0eb", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("7h9bs");

});

parcelRequire.register("lwZp8", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jxKrQ");

});

parcelRequire.register("dDfOf", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("kxDVC");

});

parcelRequire.register("ekRI0", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jqxWd");

});

parcelRequire.register("hVqD4", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8PGSz");

});

parcelRequire.register("59REH", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("hmls9");

});

parcelRequire.register("4B6Zu", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lJ0qR");

});

parcelRequire.register("dYk2A", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lXIyR");

});

parcelRequire.register("b7293", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fYpw3");

});

parcelRequire.register("bp0bh", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9wgmL");

});

parcelRequire.register("hjkjG", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("622P1");

});

parcelRequire.register("bEw5B", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6kVrE");

});

parcelRequire.register("jFXRe", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dSz5c");

});

parcelRequire.register("i0b7v", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9xvHM");

});

parcelRequire.register("kFvLB", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("WbF4i");

});

parcelRequire.register("4Ff2h", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("c9r1H");

});

parcelRequire.register("iBi3c", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("uyYP1");

});

parcelRequire.register("kawZX", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4xCrD");

});

parcelRequire.register("cOZbM", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("2i9JN");

});

parcelRequire.register("6tdWd", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fEHCL");

});

parcelRequire.register("cEETP", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5Sl7O");

});

parcelRequire.register("19XcZ", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("uC2CL");

});

parcelRequire.register("75yiU", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("7kJXl");

});

parcelRequire.register("15Ynv", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("2F1Fs");

});

parcelRequire.register("lHhON", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("7KYmj");

});

parcelRequire.register("heG4Z", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("cq7Ig");

});

parcelRequire.register("dTmUi", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4F7hs");

});

parcelRequire.register("fg8ZF", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("gatDg");

});

parcelRequire.register("i2Uvn", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("21YTn");

});

parcelRequire.register("d3VlM", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("3N6HV");

});

parcelRequire.register("clSAQ", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("54isN");

});

parcelRequire.register("6h3Sh", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("aIbhY");

});

parcelRequire.register("4PCd9", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6XUpp");

});

parcelRequire.register("6Zd3e", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("l6a6t");

});

parcelRequire.register("3nRAe", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("2VESc");

});

parcelRequire.register("5OOXz", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("cyB2u");

});

parcelRequire.register("aReoA", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("3KCd6");

});

parcelRequire.register("3Lf6Q", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("bqesX");

});

parcelRequire.register("7FhmS", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5Ufi5");

});

parcelRequire.register("e0dyy", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lIVjI");

});

parcelRequire.register("djrRE", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jtOYA");

});

parcelRequire.register("2iyHd", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("5GeT0");

});

parcelRequire.register("41dWx", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("2bg71");

});

parcelRequire.register("guR3J", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dcsFO");

});

parcelRequire.register("kEmdN", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lzP8F");

});

parcelRequire.register("1ocVi", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("iacW9");

});

parcelRequire.register("i7xl6", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6riQC");

});

parcelRequire.register("fkpZZ", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("gIZOQ");

});

parcelRequire.register("03s9W", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("evHxn");

});

parcelRequire.register("4QhmC", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("iPiKB");

});

parcelRequire.register("1N18O", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4KV4x");

});

parcelRequire.register("ewmhY", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fQk7Y");

});

parcelRequire.register("j0q29", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fKVwA");

});

parcelRequire.register("hHEwR", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("kVIqW");

});

parcelRequire.register("7LPsu", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("7wELn");

});

parcelRequire.register("5Xfft", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("eFz0B");

});

parcelRequire.register("Ph9vA", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("NF8TK");

});

parcelRequire.register("9F2Ds", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("dYrEN");

});

parcelRequire.register("8oHTQ", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("hYlJJ");

});

parcelRequire.register("cPGSb", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6eZah");

});

parcelRequire.register("hoiBf", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("3LOig");

});

parcelRequire.register("egpIs", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("asiUz");

});

parcelRequire.register("DoAq2", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6ZUhx");

});

parcelRequire.register("6KMe3", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9s7Cd");

});

parcelRequire.register("iTNmw", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("ieySe");

});

parcelRequire.register("hBMFr", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("htxvf");

});

parcelRequire.register("81wvf", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4ABfC");

});

parcelRequire.register("cjBla", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jxBMP");

});

parcelRequire.register("fIPDI", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("kLU9d");

});

parcelRequire.register("f9biR", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4AOCg");

});

parcelRequire.register("5xZH1", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9q6bx");

});

parcelRequire.register("4r1dV", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("49En6");

});

parcelRequire.register("6I1Bt", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("ftZQX");

});

parcelRequire.register("6SZ8H", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("gHCIh");

});

parcelRequire.register("63cnI", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("3vCHu");

});

parcelRequire.register("cGPFC", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("21ugb");

});

parcelRequire.register("kAq3i", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fg2XQ");

});

parcelRequire.register("aV7qg", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("e4Ch4");

});

parcelRequire.register("lnP93", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fw7G1");

});

parcelRequire.register("2ftoy", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("gyQzD");

});

parcelRequire.register("erKcH", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4J5Vd");

});

parcelRequire.register("8fI4S", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("3SL2G");

});

parcelRequire.register("ljNFh", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("hyMyY");

});

parcelRequire.register("jGNrw", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("3m4ra");

});

parcelRequire.register("7Rv6L", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("kKFsP");

});

parcelRequire.register("75kDN", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("4zfhK");

});

parcelRequire.register("lEiFk", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lrQ3X");

});

parcelRequire.register("bS63f", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9pT2i");

});

parcelRequire.register("egUpJ", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("kqnGH");

});

parcelRequire.register("jlWLb", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("huYVs");

});

parcelRequire.register("knDVd", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lQ8lF");

});

parcelRequire.register("eG8T8", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("12D4m");

});

parcelRequire.register("azHIx", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("7SaQo");

});

parcelRequire.register("i3qT5", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("doB6t");

});

parcelRequire.register("35cse", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("1Vmyf");

});

parcelRequire.register("ivC7A", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("1In9k");

});

parcelRequire.register("kHn4w", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("l6OPb");

});

parcelRequire.register("9LYwU", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("iY8b4");

});

parcelRequire.register("3aKxS", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("21oOb");

});

parcelRequire.register("93yJD", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jQ3yp");

});

parcelRequire.register("cBMnp", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("fei9n");

});

parcelRequire.register("8ZDWa", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("kE4Sj");

});

parcelRequire.register("nkV3x", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lDjP8");

});

parcelRequire.register("2SrYz", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("f8Hxw");

});

parcelRequire.register("kxbpG", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9pP1I");

});

parcelRequire.register("apPYz", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8CSZ7");

});

parcelRequire.register("5ougx", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("lK3k0");

});

parcelRequire.register("fV2Dp", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("8r0xG");

});

parcelRequire.register("8RTDj", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("6Wts2");

});

parcelRequire.register("iPvcC", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("9fUwQ");

});

parcelRequire.register("dy6mf", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("etGW5");

});

parcelRequire.register("3sspN", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("jZXhu");

});

parcelRequire.register("hhmL6", function(module, exports) {


module.exports = (parcelRequire("6Aq0R")).getBundleURL("cVWVU") + "images/" + (parcelRequire("bRvn3")).resolve("7r2vE");

});



parcelRequire.register("hMsms", function(module, exports) {

$parcel$export(module.exports, "render", function () { return $cf1ceb48ef55658e$export$b3890eb0ae9dca99; });

var $c6Xmf = parcelRequire("c6Xmf");
parcelRequire("dggmT");
var $lIPIy = parcelRequire("lIPIy");
var $hLodm = parcelRequire("hLodm");
var $i0Zoc = parcelRequire("i0Zoc");
var $cf1ceb48ef55658e$var$_withScopeId = function(n) {
    return (0, $lIPIy.pushScopeId)("data-v-e74703"), n = n(), (0, $lIPIy.popScopeId)(), n;
};
var $cf1ceb48ef55658e$var$_hoisted_1 = {
    class: "logo"
};
var $cf1ceb48ef55658e$var$_hoisted_2 = [
    "src"
];
var $cf1ceb48ef55658e$var$_hoisted_3 = {
    class: "content"
};
var $cf1ceb48ef55658e$var$_hoisted_4 = {
    class: "tr-icon"
};
var $cf1ceb48ef55658e$var$_hoisted_5 = [
    "src"
];
var $cf1ceb48ef55658e$var$_hoisted_6 = {
    class: "tr-button-text"
};
var $cf1ceb48ef55658e$var$_hoisted_7 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("span", {
        class: "icon-cross"
    }, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_8 = [
    $cf1ceb48ef55658e$var$_hoisted_7
];
var $cf1ceb48ef55658e$var$_hoisted_9 = {
    class: "screen reptiles-revision"
};
var $cf1ceb48ef55658e$var$_hoisted_10 = {
    class: "screen screen-category-selection"
};
var $cf1ceb48ef55658e$var$_hoisted_11 = {
    class: "buttons image-buttons"
};
var $cf1ceb48ef55658e$var$_hoisted_12 = [
    "onClick"
];
var $cf1ceb48ef55658e$var$_hoisted_13 = {
    class: "image-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_14 = [
    "src",
    "srcset"
];
var $cf1ceb48ef55658e$var$_hoisted_15 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("div", {
        style: {
            "min-width": "220px"
        }
    }, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_16 = {
    class: "screen screen-animal-selection"
};
var $cf1ceb48ef55658e$var$_hoisted_17 = {
    class: "buttons image-buttons"
};
var $cf1ceb48ef55658e$var$_hoisted_18 = [
    "onClick"
];
var $cf1ceb48ef55658e$var$_hoisted_19 = {
    class: "image-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_20 = [
    "src",
    "srcset"
];
var $cf1ceb48ef55658e$var$_hoisted_21 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("div", {
        style: {
            "min-width": "220px"
        }
    }, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_22 = {
    class: "image-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_23 = [
    "src",
    "srcset"
];
var $cf1ceb48ef55658e$var$_hoisted_24 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("div", {
        style: {
            "min-width": "220px"
        }
    }, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_25 = {
    class: "screen screen-multiple-birds"
};
var $cf1ceb48ef55658e$var$_hoisted_26 = {
    class: "warning"
};
var $cf1ceb48ef55658e$var$_hoisted_27 = {
    class: "details"
};
var $cf1ceb48ef55658e$var$_hoisted_28 = {
    class: "additional-recommendations"
};
var $cf1ceb48ef55658e$var$_hoisted_29 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_30 = {
    class: "screen screen-number"
};
var $cf1ceb48ef55658e$var$_hoisted_31 = {
    for: "numberOfAnimals"
};
var $cf1ceb48ef55658e$var$_hoisted_32 = {
    class: "screen-image-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_33 = [
    "src",
    "srcset"
];
var $cf1ceb48ef55658e$var$_hoisted_34 = {
    class: "number-input"
};
var $cf1ceb48ef55658e$var$_hoisted_35 = {
    key: 0,
    class: "error-overlay"
};
var $cf1ceb48ef55658e$var$_hoisted_36 = {
    class: "warning-icon"
};
var $cf1ceb48ef55658e$var$_hoisted_37 = [
    "data"
];
var $cf1ceb48ef55658e$var$_hoisted_38 = {
    key: 0
};
var $cf1ceb48ef55658e$var$_hoisted_39 = {
    key: 1
};
var $cf1ceb48ef55658e$var$_hoisted_40 = {
    class: "screen screen-weight"
};
var $cf1ceb48ef55658e$var$_hoisted_41 = {
    for: "animalWeight"
};
var $cf1ceb48ef55658e$var$_hoisted_42 = {
    class: "screen-image-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_43 = [
    "src",
    "srcset"
];
var $cf1ceb48ef55658e$var$_hoisted_44 = {
    class: "select-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_45 = {
    class: "screen screen-length"
};
var $cf1ceb48ef55658e$var$_hoisted_46 = {
    for: "animalLength"
};
var $cf1ceb48ef55658e$var$_hoisted_47 = {
    class: "screen-image-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_48 = [
    "src"
];
var $cf1ceb48ef55658e$var$_hoisted_49 = {
    class: "length-input"
};
var $cf1ceb48ef55658e$var$_hoisted_50 = {
    key: 0,
    class: "error-overlay"
};
var $cf1ceb48ef55658e$var$_hoisted_51 = {
    class: "warning-icon"
};
var $cf1ceb48ef55658e$var$_hoisted_52 = [
    "data"
];
var $cf1ceb48ef55658e$var$_hoisted_53 = {
    class: "screen screen-withers-height"
};
var $cf1ceb48ef55658e$var$_hoisted_54 = {
    for: "withersHeight"
};
var $cf1ceb48ef55658e$var$_hoisted_55 = {
    class: "screen-image-wrapper"
};
var $cf1ceb48ef55658e$var$_hoisted_56 = [
    "src"
];
var $cf1ceb48ef55658e$var$_hoisted_57 = {
    class: "withers-height-input"
};
var $cf1ceb48ef55658e$var$_hoisted_58 = [
    "onUpdate:modelValue"
];
var $cf1ceb48ef55658e$var$_hoisted_59 = {
    key: 0,
    class: "error-overlay"
};
var $cf1ceb48ef55658e$var$_hoisted_60 = {
    class: "warning-icon"
};
var $cf1ceb48ef55658e$var$_hoisted_61 = [
    "data"
];
var $cf1ceb48ef55658e$var$_hoisted_62 = {
    key: 0
};
var $cf1ceb48ef55658e$var$_hoisted_63 = {
    key: 1
};
var $cf1ceb48ef55658e$var$_hoisted_64 = {
    key: 2,
    class: "warning"
};
var $cf1ceb48ef55658e$var$_hoisted_65 = {
    class: "warning-icon"
};
var $cf1ceb48ef55658e$var$_hoisted_66 = [
    "data"
];
var $cf1ceb48ef55658e$var$_hoisted_67 = {
    key: 0
};
var $cf1ceb48ef55658e$var$_hoisted_68 = {
    key: 1
};
var $cf1ceb48ef55658e$var$_hoisted_69 = {
    class: "results"
};
var $cf1ceb48ef55658e$var$_hoisted_70 = {
    class: "results-panel results-visual"
};
var $cf1ceb48ef55658e$var$_hoisted_71 = {
    key: 0,
    class: "rectangle"
};
var $cf1ceb48ef55658e$var$_hoisted_72 = {
    class: "right-pane"
};
var $cf1ceb48ef55658e$var$_hoisted_73 = {
    class: "height"
};
var $cf1ceb48ef55658e$var$_hoisted_74 = {
    class: "bottom-pane"
};
var $cf1ceb48ef55658e$var$_hoisted_75 = {
    class: "width"
};
var $cf1ceb48ef55658e$var$_hoisted_76 = {
    class: "area"
};
var $cf1ceb48ef55658e$var$_hoisted_77 = {
    class: "caption"
};
var $cf1ceb48ef55658e$var$_hoisted_78 = {
    class: "cube-container",
    id: "results-cube-container"
};
var $cf1ceb48ef55658e$var$_hoisted_79 = {
    class: "cube"
};
var $cf1ceb48ef55658e$var$_hoisted_80 = /*#__PURE__*/ (0, $lIPIy.createStaticVNode)('<div class="face top" data-v-e74703></div><div class="face bottom" data-v-e74703></div><div class="face left" data-v-e74703></div><div class="face right" data-v-e74703></div><div class="face front" data-v-e74703></div><div class="face back" data-v-e74703></div>', 6);
var $cf1ceb48ef55658e$var$_hoisted_86 = {
    class: "measurement length"
};
var $cf1ceb48ef55658e$var$_hoisted_87 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_88 = {
    class: "measurement height"
};
var $cf1ceb48ef55658e$var$_hoisted_89 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_90 = {
    class: "measurement width"
};
var $cf1ceb48ef55658e$var$_hoisted_91 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_92 = {
    class: "results-panel results-text"
};
var $cf1ceb48ef55658e$var$_hoisted_93 = {
    class: "results-text-recommendations"
};
var $cf1ceb48ef55658e$var$_hoisted_94 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_95 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_96 = {
    class: "recommendation-length"
};
var $cf1ceb48ef55658e$var$_hoisted_97 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_98 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_99 = {
    class: "recommendation-width"
};
var $cf1ceb48ef55658e$var$_hoisted_100 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_101 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_102 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_103 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_104 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_105 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_106 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_107 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_108 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_109 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_110 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_111 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_112 = [
    "data-tooltip"
];
var $cf1ceb48ef55658e$var$_hoisted_113 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_114 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_115 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_116 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_117 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_118 = {
    key: 0,
    class: "tolerance"
};
var $cf1ceb48ef55658e$var$_hoisted_119 = [
    "data-tooltip"
];
var $cf1ceb48ef55658e$var$_hoisted_120 = {
    key: 1,
    class: "tolerance"
};
var $cf1ceb48ef55658e$var$_hoisted_121 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_122 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_123 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_124 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_125 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_126 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_127 = {
    class: "results-text-laws"
};
var $cf1ceb48ef55658e$var$_hoisted_128 = {
    key: 0
};
var $cf1ceb48ef55658e$var$_hoisted_129 = [
    "href"
];
var $cf1ceb48ef55658e$var$_hoisted_130 = {
    key: 1
};
var $cf1ceb48ef55658e$var$_hoisted_131 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_132 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_133 = {
    class: "law-length"
};
var $cf1ceb48ef55658e$var$_hoisted_134 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_135 = {
    class: "law-width"
};
var $cf1ceb48ef55658e$var$_hoisted_136 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_137 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_138 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_139 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_140 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_141 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_142 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_143 = [
    "data-tooltip"
];
var $cf1ceb48ef55658e$var$_hoisted_144 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_145 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_146 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_147 = {
    key: 0,
    class: "tolerance"
};
var $cf1ceb48ef55658e$var$_hoisted_148 = [
    "data-tooltip"
];
var $cf1ceb48ef55658e$var$_hoisted_149 = {
    key: 1,
    class: "tolerance"
};
var $cf1ceb48ef55658e$var$_hoisted_150 = [
    "data-tooltip"
];
var $cf1ceb48ef55658e$var$_hoisted_151 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_152 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_153 = [
    "data-tooltip"
];
var $cf1ceb48ef55658e$var$_hoisted_154 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_155 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_156 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_157 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_158 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_159 = {
    key: 0,
    class: "tolerance"
};
var $cf1ceb48ef55658e$var$_hoisted_160 = [
    "data-tooltip"
];
var $cf1ceb48ef55658e$var$_hoisted_161 = {
    key: 1,
    class: "tolerance"
};
var $cf1ceb48ef55658e$var$_hoisted_162 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_163 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_164 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_165 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_166 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_167 = {
    class: "value"
};
var $cf1ceb48ef55658e$var$_hoisted_168 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("br", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_169 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_170 = {
    class: "details"
};
var $cf1ceb48ef55658e$var$_hoisted_171 = {
    key: 0,
    class: "additional-recommendations"
};
var $cf1ceb48ef55658e$var$_hoisted_172 = {
    key: 0
};
var $cf1ceb48ef55658e$var$_hoisted_173 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_174 = {
    key: 1
};
var $cf1ceb48ef55658e$var$_hoisted_175 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_176 = {
    key: 2
};
var $cf1ceb48ef55658e$var$_hoisted_177 = {
    key: 0
};
var $cf1ceb48ef55658e$var$_hoisted_178 = {
    key: 1
};
var $cf1ceb48ef55658e$var$_hoisted_179 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_180 = {
    key: 3
};
var $cf1ceb48ef55658e$var$_hoisted_181 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_182 = {
    key: 4
};
var $cf1ceb48ef55658e$var$_hoisted_183 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_184 = {
    key: 5
};
var $cf1ceb48ef55658e$var$_hoisted_185 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_186 = {
    key: 6
};
var $cf1ceb48ef55658e$var$_hoisted_187 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_188 = {
    key: 7
};
var $cf1ceb48ef55658e$var$_hoisted_189 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_190 = {
    key: 8
};
var $cf1ceb48ef55658e$var$_hoisted_191 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_192 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("hr", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_193 = {
    key: 1,
    class: "additional-laws"
};
var $cf1ceb48ef55658e$var$_hoisted_194 = {
    key: 0
};
var $cf1ceb48ef55658e$var$_hoisted_195 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_196 = {
    key: 1
};
var $cf1ceb48ef55658e$var$_hoisted_197 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_198 = {
    key: 2
};
var $cf1ceb48ef55658e$var$_hoisted_199 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_200 = {
    key: 3
};
var $cf1ceb48ef55658e$var$_hoisted_201 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_202 = {
    key: 4
};
var $cf1ceb48ef55658e$var$_hoisted_203 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_204 = {
    key: 5
};
var $cf1ceb48ef55658e$var$_hoisted_205 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_206 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("hr", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_207 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_208 = [
    "innerHTML"
];
var $cf1ceb48ef55658e$var$_hoisted_209 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("hr", null, null, -1);
});
var $cf1ceb48ef55658e$var$_hoisted_210 = {
    key: 2,
    class: "links"
};
var $cf1ceb48ef55658e$var$_hoisted_211 = [
    "href"
];
var $cf1ceb48ef55658e$var$_hoisted_212 = {
    class: "bottom-navi"
};
var $cf1ceb48ef55658e$var$_hoisted_213 = {
    class: "footer"
};
var $cf1ceb48ef55658e$var$_hoisted_214 = {
    class: "backlinks"
};
var $cf1ceb48ef55658e$var$_hoisted_215 = {
    class: "website"
};
var $cf1ceb48ef55658e$var$_hoisted_216 = [
    "href"
];
var $cf1ceb48ef55658e$var$_hoisted_217 = /*#__PURE__*/ $cf1ceb48ef55658e$var$_withScopeId(function() {
    return /*#__PURE__*/ (0, $lIPIy.createElementVNode)("p", {
        class: "email"
    }, [
        /*#__PURE__*/ (0, $lIPIy.createElementVNode)("a", {
            href: "mailto:sts@tierschutz.com",
            rel: "noopener noreferrer",
            target: "_blank"
        }, "sts@tierschutz.com")
    ], -1);
});
var $cf1ceb48ef55658e$var$_hoisted_218 = {
    class: "logos logos-bottom"
};
var $cf1ceb48ef55658e$var$_hoisted_219 = {
    href: "https://www.tierschutz.com/",
    rel: "noopener noreferrer",
    target: "_blank"
};
var $cf1ceb48ef55658e$var$_hoisted_220 = [
    "src"
];
function $cf1ceb48ef55658e$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    var _$_ctx, _$_ctx1;
    var _component_i18n_t = (0, $lIPIy.resolveComponent)("i18n-t");
    return (0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)((0, $lIPIy.Fragment), null, [
        (0, $lIPIy.createElementVNode)("div", {
            class: (0, $hLodm.normalizeClass)("tr-button style-" + [
                _ctx.thrConfig.style
            ])
        }, [
            (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_1, [
                (0, $lIPIy.createElementVNode)("img", {
                    src: _ctx.logoSts(),
                    class: "logo logo-sts"
                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_2)
            ]),
            (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_3, [
                (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.trButton.cta")), 1),
                (0, $lIPIy.createElementVNode)("button", {
                    onClick: _cache[0] || (_cache[0] = function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        return _ctx.openOverlay && (_$_ctx = _ctx).openOverlay.apply(_$_ctx, (0, $c6Xmf._)(args));
                    })
                }, [
                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_4, [
                        (0, $lIPIy.createElementVNode)("img", {
                            src: _ctx.icon68
                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_5)
                    ]),
                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_6, (0, $hLodm.toDisplayString)(_ctx.$t("txt.trButton.buttonText")), 1)
                ])
            ])
        ], 2),
        (0, $lIPIy.createElementVNode)("div", {
            class: (0, $hLodm.normalizeClass)("tr-wrapper style-" + [
                _ctx.thrConfig.style
            ]),
            ref: "trWrapper"
        }, [
            (0, $lIPIy.createElementVNode)("button", {
                onClick: _cache[1] || (_cache[1] = function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return _ctx.closeOverlay && (_$_ctx1 = _ctx).closeOverlay.apply(_$_ctx1, (0, $c6Xmf._)(args));
                }),
                class: "close-button"
            }, $cf1ceb48ef55658e$var$_hoisted_8),
            (0, $lIPIy.createElementVNode)("div", {
                class: (0, $hLodm.normalizeClass)([
                    "tierschutz-rechner",
                    _ctx.thrConfig.reptilesRevision && _ctx.category.index == "reptiles" ? "reptiles-revision" : ""
                ])
            }, [
                (0, $lIPIy.createElementVNode)("h2", {
                    ref: "mainTitle"
                }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.title")), 513),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_9, [
                    (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.reptilesRevision")), 1)
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.thrConfig.reptilesRevision && _ctx.category.index == "reptiles"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_10, [
                    (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenCategory.title")), 1),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_11, [
                        ((0, $lIPIy.openBlock)(true), (0, $lIPIy.createElementBlock)((0, $lIPIy.Fragment), null, (0, $lIPIy.renderList)(_ctx.categories, function(category) {
                            return (0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("button", {
                                class: "image-button",
                                onClick: function($event) {
                                    return _ctx.selectCategory(category), _ctx.showScreen("animalSelection");
                                }
                            }, [
                                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_13, [
                                    category.img ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("img", {
                                        key: 0,
                                        class: "animal-image",
                                        src: category.img,
                                        srcset: "".concat(category.imgSmall, " 320w,").concat(category.imgMedium, " 480w,").concat(category.imgLarge, " 640w"),
                                        sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                                    }, null, 8, $cf1ceb48ef55658e$var$_hoisted_14)) : (0, $lIPIy.createCommentVNode)("", true),
                                    $cf1ceb48ef55658e$var$_hoisted_15
                                ]),
                                (0, $lIPIy.createElementVNode)("span", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.categories." + category.index + ".name")), 1)
                            ], 8, $cf1ceb48ef55658e$var$_hoisted_12);
                        }), 256))
                    ])
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "categorySelection"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_16, [
                    (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenAnimal.title")), 1),
                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", {
                        class: "animal-info"
                    }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenAnimal.equidaeInfo")), 513), [
                        [
                            (0, $i0Zoc.vShow),
                            _ctx.category.index == "equidae"
                        ]
                    ]),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_17, [
                        ((0, $lIPIy.openBlock)(true), (0, $lIPIy.createElementBlock)((0, $lIPIy.Fragment), null, (0, $lIPIy.renderList)(_ctx.animals[_ctx.category.index], function(animal) {
                            return (0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("button", {
                                class: "image-button",
                                onClick: function($event) {
                                    return _ctx.selectAnimal(animal), _ctx.showScreen("numberOfAnimals");
                                }
                            }, [
                                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_19, [
                                    animal.img ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("img", {
                                        key: 0,
                                        class: "animal-image",
                                        src: animal.img,
                                        srcset: "".concat(animal.imgSmall, " 320w,").concat(animal.imgMedium, " 480w,").concat(animal.imgLarge, " 640w"),
                                        sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                                    }, null, 8, $cf1ceb48ef55658e$var$_hoisted_20)) : (0, $lIPIy.createCommentVNode)("", true),
                                    $cf1ceb48ef55658e$var$_hoisted_21
                                ]),
                                (0, $lIPIy.createElementVNode)("span", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + animal.index + ".name")), 1)
                            ], 8, $cf1ceb48ef55658e$var$_hoisted_18);
                        }), 256)),
                        _ctx.category.index == "birds" ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("button", {
                            key: 0,
                            class: "image-button",
                            onClick: _cache[2] || (_cache[2] = function($event) {
                                return _ctx.selectAnimal(false), _ctx.showScreen("multipleBirds");
                            })
                        }, [
                            (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_22, [
                                _ctx.categories.birds.imgMultiple ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("img", {
                                    key: 0,
                                    class: "animal-image",
                                    src: _ctx.categories.birds.imgMultiple,
                                    srcset: "".concat(_ctx.categories.birds.imgMultipleSmall, " 320w,").concat(_ctx.categories.birds.imgMultipleMedium, " 480w,").concat(_ctx.categories.birds.imgMultipleLarge, " 640w"),
                                    sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_23)) : (0, $lIPIy.createCommentVNode)("", true),
                                $cf1ceb48ef55658e$var$_hoisted_24
                            ]),
                            (0, $lIPIy.createElementVNode)("span", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenAnimal.multipleBirdsButton")), 1)
                        ])) : (0, $lIPIy.createCommentVNode)("", true)
                    ])
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "animalSelection"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_25, [
                    (0, $lIPIy.createElementVNode)("h3", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenAnimal.multipleBirdsButton")) + ":", 1),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_26, [
                        (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenMultipleBirds.warning")), 1)
                    ]),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_27, [
                        (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_28, [
                            (0, $lIPIy.createElementVNode)("h4", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.title")), 1),
                            (0, $lIPIy.createElementVNode)("p", {
                                innerHTML: _ctx.$t("txt.screenMultipleBirds.infoText").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                            }, null, 8, $cf1ceb48ef55658e$var$_hoisted_29)
                        ])
                    ])
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "multipleBirds"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_30, [
                    (0, $lIPIy.createElementVNode)("label", $cf1ceb48ef55658e$var$_hoisted_31, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenNumber.title", {
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".namePlural")
                    })), 1),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_32, [
                        _ctx.animal.img ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("img", {
                            key: 0,
                            class: "animal-image",
                            src: _ctx.animal.img,
                            srcset: "".concat(_ctx.animal.imgSmall, " 320w,").concat(_ctx.animal.imgMedium, " 480w,").concat(_ctx.animal.imgLarge, " 640w"),
                            sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_33)) : (0, $lIPIy.createCommentVNode)("", true)
                    ]),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_34, [
                        (0, $lIPIy.createElementVNode)("button", {
                            onClick: _cache[3] || (_cache[3] = function($event) {
                                return _ctx.numberOfAnimals -= 1;
                            }),
                            class: "minus"
                        }),
                        (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("input", {
                            class: "quantity",
                            type: "number",
                            id: "numberOfAnimals",
                            ref: "numberOfAnimalsInput",
                            name: "numberOfAnimals",
                            min: "1",
                            max: "100",
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function($event) {
                                return _ctx.numberOfAnimals = $event;
                            }),
                            onKeyup: _cache[5] || (_cache[5] = (0, $i0Zoc.withKeys)(function($event) {
                                return _ctx.showScreen("weight");
                            }, [
                                "enter"
                            ]))
                        }, null, 544), [
                            [
                                (0, $i0Zoc.vModelText),
                                _ctx.numberOfAnimals
                            ]
                        ]),
                        (0, $lIPIy.createElementVNode)("button", {
                            onClick: _cache[6] || (_cache[6] = function($event) {
                                return _ctx.numberOfAnimals += 1;
                            }),
                            class: "plus"
                        })
                    ]),
                    (0, $lIPIy.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[7] || (_cache[7] = function($event) {
                            return _ctx.showScreen("weight");
                        })
                    }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonNext")), 1),
                    _ctx.showNumberError ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_35, [
                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_36, [
                            (0, $lIPIy.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarningWhite
                            }, null, 8, $cf1ceb48ef55658e$var$_hoisted_37)
                        ]),
                        _ctx.numberErrorType === "under" ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("p", $cf1ceb48ef55658e$var$_hoisted_38, (0, $hLodm.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".minAnimalsErrorMessage")), 1)) : (0, $lIPIy.createCommentVNode)("", true),
                        _ctx.numberErrorType === "over" ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("p", $cf1ceb48ef55658e$var$_hoisted_39, (0, $hLodm.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".maxAnimalsErrorMessage")), 1)) : (0, $lIPIy.createCommentVNode)("", true),
                        (0, $lIPIy.createElementVNode)("button", {
                            onClick: _cache[8] || (_cache[8] = function($event) {
                                return _ctx.showNumberError = false;
                            })
                        }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonAcceptWarning")), 1)
                    ])) : (0, $lIPIy.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "numberOfAnimals"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_40, [
                    (0, $lIPIy.createElementVNode)("label", $cf1ceb48ef55658e$var$_hoisted_41, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenWeight.title", {
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".namePlural")
                    })), 1),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_42, [
                        _ctx.animal.img ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("img", {
                            key: 0,
                            class: "animal-image",
                            src: _ctx.animal.img,
                            srcset: "".concat(_ctx.animal.imgSmall, " 320w,").concat(_ctx.animal.imgMedium, " 480w,").concat(_ctx.animal.imgLarge, " 640w"),
                            sizes: "(max-width: 600px)) 480px, ((min-width: 601px) 320px"
                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_43)) : (0, $lIPIy.createCommentVNode)("", true)
                    ]),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_44, [
                        (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("select", {
                            id: "animalWeight",
                            name: "animalWeight",
                            "onUpdate:modelValue": _cache[9] || (_cache[9] = function($event) {
                                return _ctx.animalWeight = $event;
                            }),
                            onKeyup: _cache[10] || (_cache[10] = (0, $i0Zoc.withKeys)(function($event) {
                                return _ctx.showScreen("results");
                            }, [
                                "enter"
                            ]))
                        }, [
                            ((0, $lIPIy.openBlock)(true), (0, $lIPIy.createElementBlock)((0, $lIPIy.Fragment), null, (0, $lIPIy.renderList)(_ctx.weightOptions, function(weightOption) {
                                return (0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("option", null, (0, $hLodm.toDisplayString)(weightOption), 1);
                            }), 256))
                        ], 544), [
                            [
                                (0, $i0Zoc.vModelSelect),
                                _ctx.animalWeight
                            ]
                        ])
                    ]),
                    (0, $lIPIy.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[11] || (_cache[11] = function($event) {
                            return _ctx.showScreen("results");
                        })
                    }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonNext")), 1)
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "weight"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_45, [
                    (0, $lIPIy.createElementVNode)("label", $cf1ceb48ef55658e$var$_hoisted_46, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenLength.title", {
                        article: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".article"),
                        animal: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".name")
                    })), 1),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_47, [
                        _ctx.lengthImage ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("img", {
                            key: 0,
                            class: "animal-length-image",
                            src: _ctx.lengthImage
                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_48)) : (0, $lIPIy.createCommentVNode)("", true)
                    ]),
                    (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".textLength")), 1),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_49, [
                        (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("input", {
                            class: "animalLength",
                            type: "number",
                            id: "animalLength",
                            ref: "animalLengthInput",
                            name: "animalLength",
                            min: "1",
                            max: "1000",
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = function($event) {
                                return _ctx.animalLength = $event;
                            }),
                            onKeyup: _cache[13] || (_cache[13] = (0, $i0Zoc.withKeys)(function($event) {
                                return _ctx.showScreen("results");
                            }, [
                                "enter"
                            ]))
                        }, null, 544), [
                            [
                                (0, $i0Zoc.vModelText),
                                _ctx.animalLength
                            ]
                        ]),
                        (0, $lIPIy.createTextVNode)(" cm")
                    ]),
                    (0, $lIPIy.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[14] || (_cache[14] = function($event) {
                            return _ctx.showScreen("results");
                        })
                    }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonNext")), 1),
                    _ctx.showLengthError ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_50, [
                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_51, [
                            (0, $lIPIy.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarningWhite
                            }, null, 8, $cf1ceb48ef55658e$var$_hoisted_52)
                        ]),
                        (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenLength.error", {
                            min: _ctx.animal.minLength,
                            max: _ctx.animal.maxLength
                        })), 1),
                        (0, $lIPIy.createElementVNode)("button", {
                            onClick: _cache[15] || (_cache[15] = function($event) {
                                return _ctx.showLengthError = false;
                            })
                        }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonAcceptWarning")), 1)
                    ])) : (0, $lIPIy.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "length"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_53, [
                    (0, $lIPIy.createElementVNode)("label", $cf1ceb48ef55658e$var$_hoisted_54, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenWithersHeight.title")), 1),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_55, [
                        _ctx.withersHeightImage ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("img", {
                            key: 0,
                            class: "animal-length-image",
                            src: _ctx.withersHeightImage
                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_56)) : (0, $lIPIy.createCommentVNode)("", true)
                    ]),
                    ((0, $lIPIy.openBlock)(true), (0, $lIPIy.createElementBlock)((0, $lIPIy.Fragment), null, (0, $lIPIy.renderList)(_ctx.animalWithersHeights, function(withersHeight, index) {
                        return (0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_57, [
                            (0, $lIPIy.createElementVNode)("span", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenWithersHeight.animal")) + " " + (0, $hLodm.toDisplayString)(index + 1) + ": ", 1),
                            (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("input", {
                                class: "animalWithersHeight",
                                type: "number",
                                id: "animalWithersHeight",
                                ref_for: true,
                                ref: "animalWithersHeightInput",
                                name: "animalWithersHeight",
                                min: "50",
                                max: "250",
                                "onUpdate:modelValue": function($event) {
                                    return _ctx.animalWithersHeights[index] = $event;
                                },
                                onKeyup: _cache[16] || (_cache[16] = (0, $i0Zoc.withKeys)(function($event) {
                                    return _ctx.showScreen("results");
                                }, [
                                    "enter"
                                ]))
                            }, null, 40, $cf1ceb48ef55658e$var$_hoisted_58), [
                                [
                                    (0, $i0Zoc.vModelText),
                                    _ctx.animalWithersHeights[index]
                                ]
                            ]),
                            (0, $lIPIy.createTextVNode)(" cm ")
                        ]);
                    }), 256)),
                    (0, $lIPIy.createElementVNode)("button", {
                        class: "button button-forward",
                        onClick: _cache[17] || (_cache[17] = function($event) {
                            return _ctx.showScreen("results");
                        })
                    }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonNext")), 1),
                    _ctx.showWithersHeightError ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_59, [
                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_60, [
                            (0, $lIPIy.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarning
                            }, null, 8, $cf1ceb48ef55658e$var$_hoisted_61)
                        ]),
                        (0, $lIPIy.createElementVNode)("p", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenWithersHeight.error", {
                            min: _ctx.animal.minWithersHeight,
                            max: _ctx.animal.maxWithersHeight
                        })), 1),
                        (0, $lIPIy.createElementVNode)("button", {
                            onClick: _cache[18] || (_cache[18] = function($event) {
                                return _ctx.showWithersHeightError = false;
                            })
                        }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonAcceptWarning")), 1)
                    ])) : (0, $lIPIy.createCommentVNode)("", true)
                ], 512), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "withersHeight"
                    ]
                ]),
                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", {
                    class: (0, $hLodm.normalizeClass)("screen screen-results " + [
                        _ctx.category.index
                    ] + " " + [
                        _ctx.animal.index
                    ])
                }, [
                    this.numberOfAnimals > 1 ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("h3", $cf1ceb48ef55658e$var$_hoisted_62, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.title", {
                        number: _ctx.numberOfAnimals,
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".namePlural")
                    })) + ":", 1)) : (0, $lIPIy.createCommentVNode)("", true),
                    this.numberOfAnimals === 1 ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("h3", $cf1ceb48ef55658e$var$_hoisted_63, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.title", {
                        number: _ctx.numberOfAnimals,
                        animals: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".name")
                    })) + ":", 1)) : (0, $lIPIy.createCommentVNode)("", true),
                    _ctx.showNumberWarning ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_64, [
                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_65, [
                            (0, $lIPIy.createElementVNode)("object", {
                                type: "image/svg+xml",
                                data: _ctx.iconWarning
                            }, null, 8, $cf1ceb48ef55658e$var$_hoisted_66)
                        ]),
                        _ctx.numberWarningType === "under" ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("p", $cf1ceb48ef55658e$var$_hoisted_67, (0, $hLodm.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".minAnimalsWarningMessage")), 1)) : (0, $lIPIy.createCommentVNode)("", true),
                        _ctx.numberWarningType === "over" ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("p", $cf1ceb48ef55658e$var$_hoisted_68, (0, $hLodm.toDisplayString)(_ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".maxAnimalsWarningMessage")), 1)) : (0, $lIPIy.createCommentVNode)("", true)
                    ])) : (0, $lIPIy.createCommentVNode)("", true),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_69, [
                        (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_70, [
                            typeof _ctx.stsRecommendedArea === "number" ? (0, $lIPIy.withDirectives)(((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_71, [
                                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_72, [
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_73, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedWidthExample) + " cm", 1)
                                ]),
                                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_74, [
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_75, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedLengthExample) + " cm", 1)
                                ]),
                                (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_76, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedArea) + " m\xb2", 1),
                                (0, $lIPIy.createElementVNode)("p", $cf1ceb48ef55658e$var$_hoisted_77, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.example")), 1)
                            ], 512)), [
                                [
                                    (0, $i0Zoc.vShow),
                                    _ctx.category.index != "birds"
                                ]
                            ]) : (0, $lIPIy.createCommentVNode)("", true),
                            (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_78, [
                                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_79, [
                                    $cf1ceb48ef55658e$var$_hoisted_80,
                                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_86, [
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_87, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedLengthExampleText), 1)
                                    ]),
                                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_88, [
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_89, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedHeight), 1)
                                    ]),
                                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_90, [
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_91, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedWidthExampleText), 1)
                                    ])
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", {
                                    class: "caption"
                                }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.exampleEquidae")), 513), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ])
                            ], 512), [
                                [
                                    (0, $i0Zoc.vShow),
                                    (_ctx.category.index == "birds" || _ctx.category.index == "equidae") && typeof _ctx.stsRecommendedLengthExample === "number" && _ctx.stsRecommendedLengthExample > 0
                                ]
                            ])
                        ]),
                        (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_92, [
                            (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_93, [
                                (0, $lIPIy.createElementVNode)("h4", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsRecommendation")), 1),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsAreaRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_94,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_95, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedArea) + " m\xb2", 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", $cf1ceb48ef55658e$var$_hoisted_96, [
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("span", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsLengthRecommendation.upto2reptiles")) + ": ", 1),
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_97, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedLength), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.numberOfAnimals <= 2
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("span", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsLengthRecommendation.morethan2reptiles")) + ": ", 1),
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_98, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedLength), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.numberOfAnimals > 2
                                        ]
                                    ])
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "reptiles"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", $cf1ceb48ef55658e$var$_hoisted_99, [
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("span", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsWidthRecommendation.upto2reptiles")) + ": ", 1),
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_100, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedWidth), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.numberOfAnimals <= 2
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("span", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsWidthRecommendation.morethan2reptiles")) + ": ", 1),
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_101, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedWidth), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.numberOfAnimals > 2
                                        ]
                                    ])
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "reptiles"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsHeightRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_102,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_103, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedHeight), 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsBeddingRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_104,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_105, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedBedding), 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "rodents"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsLatticeSpacing")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_106,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_107, (0, $hLodm.toDisplayString)(_ctx.stsLatticeSpacing), 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "rodents"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsWaterBasinRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_108,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_109, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedWaterBasin), 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "reptiles"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsLayingAreaRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_110,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_111, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedLayingArea) + " m\xb2", 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsClearWidthRecommendation")) + " ", 1),
                                    (0, $lIPIy.createElementVNode)("span", {
                                        "data-tooltip": _ctx.$t("txt.screenResults.stsClearWidthRecommendationInfo"),
                                        "data-flow": "down"
                                    }, "ⓘ", 8, $cf1ceb48ef55658e$var$_hoisted_112),
                                    $cf1ceb48ef55658e$var$_hoisted_113,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_114, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedClearWidth) + " m", 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsClearHeightRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_115,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_116, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedClearHeight.value) + " m", 1),
                                    $cf1ceb48ef55658e$var$_hoisted_117,
                                    _ctx.stsRecommendedClearHeight.tolerance ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("span", $cf1ceb48ef55658e$var$_hoisted_118, [
                                        (0, $lIPIy.createTextVNode)("(" + (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.tolerance")) + " " + (0, $hLodm.toDisplayString)(_ctx.stsRecommendedClearHeight.tolerance) + " m) ", 1),
                                        (0, $lIPIy.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.toleranceInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $cf1ceb48ef55658e$var$_hoisted_119)
                                    ])) : ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("span", $cf1ceb48ef55658e$var$_hoisted_120, "(" + (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.noTolerance")) + ")", 1))
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsRunoutTimeRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_121,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_122, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsRunoutTimeRecommendationText")), 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsRunoutAreaRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_123,
                                    (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_124, (0, $hLodm.toDisplayString)(_ctx.stsRecommendedRunoutArea) + " m\xb2", 1)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ]),
                                (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                    (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.stsPasturingRecommendation")), 1),
                                    $cf1ceb48ef55658e$var$_hoisted_125,
                                    (0, $lIPIy.createElementVNode)("span", {
                                        class: "value",
                                        innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.pasturing")
                                    }, null, 8, $cf1ceb48ef55658e$var$_hoisted_126)
                                ], 512), [
                                    [
                                        (0, $i0Zoc.vShow),
                                        _ctx.category.index == "equidae"
                                    ]
                                ])
                            ]),
                            (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_127, [
                                (0, $lIPIy.createElementVNode)("h4", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.law")), 1),
                                _ctx.category.index == "reptiles" && _ctx.numberOfAnimals > 2 ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_128, [
                                    (0, $lIPIy.createVNode)(_component_i18n_t, {
                                        keypath: "txt.screenResults.lawReptilesInfo.text",
                                        tag: "p",
                                        class: "reptiles-law-text"
                                    }, {
                                        link: (0, $lIPIy.withCtx)(function() {
                                            return [
                                                (0, $lIPIy.createElementVNode)("a", {
                                                    href: _ctx.$t("txt.screenResults.lawReptilesInfo.linkURL")
                                                }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawReptilesInfo.linkText")), 9, $cf1ceb48ef55658e$var$_hoisted_129)
                                            ];
                                        }),
                                        _: 1
                                    })
                                ])) : ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_130, [
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalArea")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_131,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_132, (0, $hLodm.toDisplayString)(_ctx.lawMinimalArea), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", $cf1ceb48ef55658e$var$_hoisted_133, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalLength")) + ": ", 1),
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_134, (0, $hLodm.toDisplayString)(_ctx.lawMinimalLength), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "reptiles"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", $cf1ceb48ef55658e$var$_hoisted_135, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalWidth")) + ": ", 1),
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_136, (0, $hLodm.toDisplayString)(_ctx.lawMinimalWidth), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "reptiles"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalHeight")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_137,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_138, (0, $hLodm.toDisplayString)(_ctx.lawMinimalHeight()), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "rodents" || _ctx.category.index == "reptiles" || _ctx.category.index == "birds"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawMinimalBedding")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_139,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_140, (0, $hLodm.toDisplayString)(_ctx.lawMinimalBedding), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "rodents"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawWaterBasin")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_141,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_142, (0, $hLodm.toDisplayString)(_ctx.lawWaterBasin), 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "reptiles"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawLayingArea")) + " ", 1),
                                        (0, $lIPIy.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.layingAreaInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $cf1ceb48ef55658e$var$_hoisted_143),
                                        $cf1ceb48ef55658e$var$_hoisted_144,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_145, (0, $hLodm.toDisplayString)(_ctx.lawLayingArea.value) + " m\xb2", 1),
                                        (0, $lIPIy.createTextVNode)(),
                                        $cf1ceb48ef55658e$var$_hoisted_146,
                                        _ctx.lawLayingArea.tolerance ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("span", $cf1ceb48ef55658e$var$_hoisted_147, [
                                            (0, $lIPIy.createTextVNode)("(" + (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.tolerance")) + " " + (0, $hLodm.toDisplayString)(_ctx.lawLayingArea.tolerance) + " m\xb2) ", 1),
                                            (0, $lIPIy.createElementVNode)("span", {
                                                "data-tooltip": _ctx.$t("txt.screenResults.toleranceInfo"),
                                                "data-flow": "down"
                                            }, "ⓘ", 8, $cf1ceb48ef55658e$var$_hoisted_148)
                                        ])) : ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("span", $cf1ceb48ef55658e$var$_hoisted_149, "(" + (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.noTolerance")) + ")", 1))
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawLayingAreaMultiroom")) + " ", 1),
                                        (0, $lIPIy.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.layingAreaMultiroomInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $cf1ceb48ef55658e$var$_hoisted_150),
                                        $cf1ceb48ef55658e$var$_hoisted_151,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_152, (0, $hLodm.toDisplayString)(_ctx.lawLayingArea.multiroom) + " m\xb2", 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawClearWidth")) + " ", 1),
                                        (0, $lIPIy.createElementVNode)("span", {
                                            "data-tooltip": _ctx.$t("txt.screenResults.lawClearWidthInfo"),
                                            "data-flow": "down"
                                        }, "ⓘ", 8, $cf1ceb48ef55658e$var$_hoisted_153),
                                        $cf1ceb48ef55658e$var$_hoisted_154,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_155, (0, $hLodm.toDisplayString)(_ctx.lawClearWidth) + " m", 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawClearHeight")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_156,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_157, (0, $hLodm.toDisplayString)(_ctx.lawClearHeight.value) + " m", 1),
                                        $cf1ceb48ef55658e$var$_hoisted_158,
                                        _ctx.lawClearHeight.tolerance ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("span", $cf1ceb48ef55658e$var$_hoisted_159, [
                                            (0, $lIPIy.createTextVNode)("(" + (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.tolerance")) + " " + (0, $hLodm.toDisplayString)(_ctx.lawClearHeight.tolerance) + " m) ", 1),
                                            (0, $lIPIy.createElementVNode)("span", {
                                                "data-tooltip": _ctx.$t("txt.screenResults.toleranceInfo"),
                                                "data-flow": "down"
                                            }, "ⓘ", 8, $cf1ceb48ef55658e$var$_hoisted_160)
                                        ])) : ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("span", $cf1ceb48ef55658e$var$_hoisted_161, "(" + (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.noTolerance")) + ")", 1))
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawRunoutTime")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_162,
                                        (0, $lIPIy.createElementVNode)("span", {
                                            class: "value",
                                            innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.runoutTime")
                                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_163)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawRunoutAreaAdjacent")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_164,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_165, (0, $hLodm.toDisplayString)(_ctx.lawRunoutArea.adjacent) + " m\xb2", 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawRunoutAreaNonadjacent")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_166,
                                        (0, $lIPIy.createElementVNode)("span", $cf1ceb48ef55658e$var$_hoisted_167, (0, $hLodm.toDisplayString)(_ctx.lawRunoutArea.nonadjacent) + " m\xb2", 1)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ]),
                                    (0, $lIPIy.withDirectives)((0, $lIPIy.createElementVNode)("p", null, [
                                        (0, $lIPIy.createTextVNode)((0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.lawPasturing")), 1),
                                        $cf1ceb48ef55658e$var$_hoisted_168,
                                        (0, $lIPIy.createElementVNode)("span", {
                                            class: "value",
                                            innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.pasturing")
                                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_169)
                                    ], 512), [
                                        [
                                            (0, $i0Zoc.vShow),
                                            _ctx.category.index == "equidae"
                                        ]
                                    ])
                                ]))
                            ])
                        ])
                    ]),
                    (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_170, [
                        _ctx.animalTextsExist([
                            "recommendations.general",
                            "recommendations.furnishing",
                            "recommendations.socialStructure"
                        ]) ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_171, [
                            (0, $lIPIy.createElementVNode)("h4", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.title")), 1),
                            _ctx.animalTextExists("recommendations.general") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_172, [
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.general").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_173)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.furnishing") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_174, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.furnishing")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.furnishing").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_175)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.socialStructure") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_176, [
                                _ctx.category.index == "reptiles" ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("h5", $cf1ceb48ef55658e$var$_hoisted_177, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.socialSturctureAndSpecificNeeds")), 1)) : (0, $lIPIy.createCommentVNode)("", true),
                                _ctx.category.index != "reptiles" ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("h5", $cf1ceb48ef55658e$var$_hoisted_178, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.socialStructure")), 1)) : (0, $lIPIy.createCommentVNode)("", true),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.socialStructure").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_179)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.indoor") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_180, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.indoor")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.indoor").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_181)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.outdoor") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_182, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.outdoor")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.outdoor").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_183)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.specificNeeds") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_184, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.specificNeeds")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.specificNeeds").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_185)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.specialRequirements") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_186, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.specialRequirements")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.specialRequirements").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_187)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.activity") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_188, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.activity")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.activity").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_189)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("recommendations.more") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_190, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalRecommendations.more")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".recommendations.more").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_191)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            $cf1ceb48ef55658e$var$_hoisted_192
                        ])) : (0, $lIPIy.createCommentVNode)("", true),
                        _ctx.animalTextsExist([
                            "laws.furnishing",
                            "laws.raisedAreas",
                            "laws.socialStructure"
                        ]) ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_193, [
                            (0, $lIPIy.createElementVNode)("h4", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.title")), 1),
                            _ctx.animalTextExists("laws.furnishing") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_194, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.furnishing")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.furnishing").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_195)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.raisedAreas") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_196, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.raisedAreas")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.raisedAreas").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_197)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.socialStructure") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_198, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.socialStructure")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.socialStructure").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_199)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.structuring") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_200, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.structuring")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.structuring").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_201)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.activity") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_202, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.activity")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.activity").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_203)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            _ctx.animalTextExists("laws.exercise") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_204, [
                                (0, $lIPIy.createElementVNode)("h5", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalLaws.exercise")), 1),
                                (0, $lIPIy.createElementVNode)("p", {
                                    innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.exercise").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                                }, null, 8, $cf1ceb48ef55658e$var$_hoisted_205)
                            ])) : (0, $lIPIy.createCommentVNode)("", true),
                            $cf1ceb48ef55658e$var$_hoisted_206,
                            _ctx.animalTextExists("laws.lawDetails") ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("p", {
                                key: 6,
                                innerHTML: _ctx.$t("txt.animals." + _ctx.category.index + "." + _ctx.animal.index + ".laws.lawDetails").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                            }, null, 8, $cf1ceb48ef55658e$var$_hoisted_207)) : ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("p", {
                                key: 7,
                                innerHTML: _ctx.$t("txt.screenResults.lawDetails").replace(/(?:\r\n|\r|\n)/g, "<br><br>")
                            }, null, 8, $cf1ceb48ef55658e$var$_hoisted_208)),
                            $cf1ceb48ef55658e$var$_hoisted_209
                        ])) : (0, $lIPIy.createCommentVNode)("", true),
                        _ctx.animalLinks ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("div", $cf1ceb48ef55658e$var$_hoisted_210, [
                            (0, $lIPIy.createElementVNode)("h4", null, (0, $hLodm.toDisplayString)(_ctx.$t("txt.screenResults.additionalInfo")), 1),
                            (0, $lIPIy.createElementVNode)("ul", null, [
                                ((0, $lIPIy.openBlock)(true), (0, $lIPIy.createElementBlock)((0, $lIPIy.Fragment), null, (0, $lIPIy.renderList)(_ctx.animalLinks, function(link) {
                                    return (0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("li", null, [
                                        (0, $lIPIy.createElementVNode)("a", {
                                            href: link.file,
                                            rel: "noopener noreferrer",
                                            target: "_blank"
                                        }, (0, $hLodm.toDisplayString)(link.text), 9, $cf1ceb48ef55658e$var$_hoisted_211)
                                    ]);
                                }), 256))
                            ])
                        ])) : (0, $lIPIy.createCommentVNode)("", true)
                    ])
                ], 2), [
                    [
                        (0, $i0Zoc.vShow),
                        _ctx.screen == "results"
                    ]
                ]),
                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_212, [
                    _ctx.previousScreens.length > 0 ? ((0, $lIPIy.openBlock)(), (0, $lIPIy.createElementBlock)("button", {
                        key: 0,
                        class: "button button-back",
                        onClick: _cache[19] || (_cache[19] = function($event) {
                            return _ctx.previousScreen();
                        })
                    }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.buttonPrevious")), 1)) : (0, $lIPIy.createCommentVNode)("", true)
                ])
            ], 2),
            (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_213, [
                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_214, [
                    (0, $lIPIy.createElementVNode)("p", $cf1ceb48ef55658e$var$_hoisted_215, [
                        (0, $lIPIy.createElementVNode)("a", {
                            href: _ctx.$t("txt.link"),
                            rel: "noopener noreferrer",
                            target: "_blank"
                        }, (0, $hLodm.toDisplayString)(_ctx.$t("txt.domain")), 9, $cf1ceb48ef55658e$var$_hoisted_216)
                    ]),
                    $cf1ceb48ef55658e$var$_hoisted_217
                ]),
                (0, $lIPIy.createElementVNode)("div", $cf1ceb48ef55658e$var$_hoisted_218, [
                    (0, $lIPIy.createElementVNode)("a", $cf1ceb48ef55658e$var$_hoisted_219, [
                        (0, $lIPIy.createElementVNode)("img", {
                            src: _ctx.logoSts(),
                            class: "logo logo-sts"
                        }, null, 8, $cf1ceb48ef55658e$var$_hoisted_220)
                    ])
                ])
            ])
        ], 2)
    ], 64);
}

});
parcelRequire.register("c6Xmf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8d1416c8f734345e$export$1b5e630bc3aea29f; });

var $2BACi = parcelRequire("2BACi");

var $djrl5 = parcelRequire("djrl5");

var $jix3C = parcelRequire("jix3C");

var $1hjNY = parcelRequire("1hjNY");
function $8d1416c8f734345e$export$1b5e630bc3aea29f(arr) {
    return (0, $2BACi._array_without_holes)(arr) || (0, $djrl5._iterable_to_array)(arr) || (0, $1hjNY._unsupported_iterable_to_array)(arr) || (0, $jix3C._non_iterable_spread)();
}

});
parcelRequire.register("2BACi", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $1e5b70c2c2307a84$export$7e0947b5ad3404e2; });

var $QCMVH = parcelRequire("QCMVH");
function $1e5b70c2c2307a84$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $QCMVH._array_like_to_array)(arr);
}

});
parcelRequire.register("QCMVH", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $09e2f1f84ceddf09$export$79e617b1955a2616; });
function $09e2f1f84ceddf09$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("djrl5", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $9b1241b318447a2a$export$1eb58a6e75231000; });
function $9b1241b318447a2a$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("jix3C", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $e0c9573dc9b3384a$export$e6f3c4780d19eb2b; });
function $e0c9573dc9b3384a$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("1hjNY", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $0ee6bdd820e270f4$export$a5be06335b3a083c; });

var $QCMVH = parcelRequire("QCMVH");
function $0ee6bdd820e270f4$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $QCMVH._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $QCMVH._array_like_to_array)(o, minLen);
}

});


parcelRequire.register("dggmT", function(module, exports) {
$parcel$export(module.exports, "computed", function () { return (parcelRequire("lIPIy")).computed; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("lIPIy")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("lIPIy")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("lIPIy")).createElementVNode; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("lIPIy")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("lIPIy")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("lIPIy")).createVNode; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("lIPIy")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("lIPIy")).getCurrentInstance; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("lIPIy")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("lIPIy")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("lIPIy")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("yQ0Ka")).isRef; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("hLodm")).normalizeClass; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("lIPIy")).onBeforeMount; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("lIPIy")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("lIPIy")).onUnmounted; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("lIPIy")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("lIPIy")).popScopeId; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("lIPIy")).pushScopeId; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("yQ0Ka")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("lIPIy")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("lIPIy")).resolveComponent; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("lIPIy")).Text; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("lIPIy")).watch; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("lIPIy")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("lIPIy")).withDirectives; });
$parcel$export(module.exports, "createApp", function () { return (parcelRequire("i0Zoc")).createApp; });
$parcel$export(module.exports, "vModelSelect", function () { return (parcelRequire("i0Zoc")).vModelSelect; });
$parcel$export(module.exports, "vModelText", function () { return (parcelRequire("i0Zoc")).vModelText; });
$parcel$export(module.exports, "vShow", function () { return (parcelRequire("i0Zoc")).vShow; });
$parcel$export(module.exports, "withKeys", function () { return (parcelRequire("i0Zoc")).withKeys; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("yQ0Ka")).effectScope; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("yQ0Ka")).shallowRef; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("hLodm")).toDisplayString; });

var $lIPIy = parcelRequire("lIPIy");parcelRequire("i0Zoc");parcelRequire("yQ0Ka");parcelRequire("hLodm");
function $9a79775f00fb7b9d$var$initDev() {
    (0, $lIPIy.initCustomFormatter)();
}
var $9a79775f00fb7b9d$export$ef7acd7185315e22 = function() {};

});
parcelRequire.register("lIPIy", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $fd05d31532de2fc2$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return $fd05d31532de2fc2$export$dae85862a8d94378; });
$parcel$export(module.exports, "nextTick", function () { return $fd05d31532de2fc2$export$bdd553fddd433dcb; });
$parcel$export(module.exports, "Fragment", function () { return $fd05d31532de2fc2$export$ffb0004e005737fa; });
$parcel$export(module.exports, "Text", function () { return $fd05d31532de2fc2$export$5f1af8db9871e1d6; });
$parcel$export(module.exports, "Static", function () { return $fd05d31532de2fc2$export$c1b9a1d3af45b7b6; });
$parcel$export(module.exports, "pushScopeId", function () { return $fd05d31532de2fc2$export$ac020265ca2cc4cd; });
$parcel$export(module.exports, "popScopeId", function () { return $fd05d31532de2fc2$export$f2dc6805dc11834e; });
$parcel$export(module.exports, "withCtx", function () { return $fd05d31532de2fc2$export$694b237e827a3d23; });
$parcel$export(module.exports, "createVNode", function () { return $fd05d31532de2fc2$export$bf5c4cf060303d58; });
$parcel$export(module.exports, "openBlock", function () { return $fd05d31532de2fc2$export$e7eaa45e502fe5cc; });
$parcel$export(module.exports, "watchPostEffect", function () { return $fd05d31532de2fc2$export$b7f27ea67102d543; });
$parcel$export(module.exports, "watch", function () { return $fd05d31532de2fc2$export$3db5d71bdb2d5499; });
$parcel$export(module.exports, "withDirectives", function () { return $fd05d31532de2fc2$export$49729353e7c1e6c5; });
$parcel$export(module.exports, "useTransitionState", function () { return $fd05d31532de2fc2$export$d2a0a1bc267c90f6; });
$parcel$export(module.exports, "onMounted", function () { return $fd05d31532de2fc2$export$6d1641039221b5cb; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return $fd05d31532de2fc2$export$b876c99684f8cf3b; });
$parcel$export(module.exports, "getCurrentInstance", function () { return $fd05d31532de2fc2$export$f13e630aa3915748; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return $fd05d31532de2fc2$export$a67f9b1229c7c97a; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return $fd05d31532de2fc2$export$76ac1779589cd824; });
$parcel$export(module.exports, "setTransitionHooks", function () { return $fd05d31532de2fc2$export$7770a22486565649; });
$parcel$export(module.exports, "BaseTransition", function () { return $fd05d31532de2fc2$export$abd95b5f5e8a8837; });
$parcel$export(module.exports, "defineComponent", function () { return $fd05d31532de2fc2$export$afa64b67e5a01c3b; });
$parcel$export(module.exports, "onUpdated", function () { return $fd05d31532de2fc2$export$5876c47052fb88b1; });
$parcel$export(module.exports, "onUnmounted", function () { return $fd05d31532de2fc2$export$13348a43ccacfe58; });
$parcel$export(module.exports, "onBeforeMount", function () { return $fd05d31532de2fc2$export$23b7aeb0d671f804; });
$parcel$export(module.exports, "resolveComponent", function () { return $fd05d31532de2fc2$export$681d65eec9d1d1e8; });
$parcel$export(module.exports, "renderList", function () { return $fd05d31532de2fc2$export$4bf387f59bfc6d67; });
$parcel$export(module.exports, "computed", function () { return $fd05d31532de2fc2$export$2983e091f1a1e8e2; });
$parcel$export(module.exports, "inject", function () { return $fd05d31532de2fc2$export$a976684a0efeb93f; });
$parcel$export(module.exports, "createTextVNode", function () { return $fd05d31532de2fc2$export$22f9b5ffd89dac9; });
$parcel$export(module.exports, "createRenderer", function () { return $fd05d31532de2fc2$export$53ae2f996c64e9a; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return $fd05d31532de2fc2$export$200524cf0d997ff0; });
$parcel$export(module.exports, "createElementBlock", function () { return $fd05d31532de2fc2$export$167055419fc69ec1; });
$parcel$export(module.exports, "createElementVNode", function () { return $fd05d31532de2fc2$export$42098e0eaa15c48e; });
$parcel$export(module.exports, "createStaticVNode", function () { return $fd05d31532de2fc2$export$33a9f6dd2840e6bb; });
$parcel$export(module.exports, "createCommentVNode", function () { return $fd05d31532de2fc2$export$49553837c7236d3c; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return $fd05d31532de2fc2$export$c93a9c496c5211fa; });
$parcel$export(module.exports, "h", function () { return $fd05d31532de2fc2$export$dda1d9f60106f0e9; });
$parcel$export(module.exports, "initCustomFormatter", function () { return $fd05d31532de2fc2$export$aed4979be6a60047; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("yQ0Ka")).isRef; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("yQ0Ka")).ref; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("yQ0Ka")).toRaw; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("hLodm")).camelize; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("hLodm")).normalizeClass; });

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $yQ0Ka = parcelRequire("yQ0Ka");

var $hLodm = parcelRequire("hLodm");
var $fd05d31532de2fc2$var$stack = [];
function $fd05d31532de2fc2$var$pushWarningContext(vnode) {
    $fd05d31532de2fc2$var$stack.push(vnode);
}
function $fd05d31532de2fc2$var$popWarningContext() {
    $fd05d31532de2fc2$var$stack.pop();
}
function $fd05d31532de2fc2$export$c106dd0671a0fc2d(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var vnode;
    return;
}
function $fd05d31532de2fc2$var$getComponentTrace() {
    var currentVNode = $fd05d31532de2fc2$var$stack[$fd05d31532de2fc2$var$stack.length - 1];
    if (!currentVNode) return [];
    var normalizedStack = [];
    while(currentVNode){
        var last = normalizedStack[0];
        if (last && last.vnode === currentVNode) last.recurseCount++;
        else normalizedStack.push({
            vnode: currentVNode,
            recurseCount: 0
        });
        var parentInstance = currentVNode.component && currentVNode.component.parent;
        currentVNode = parentInstance && parentInstance.vnode;
    }
    return normalizedStack;
}
function $fd05d31532de2fc2$var$formatTrace(trace) {
    var logs = [];
    trace.forEach(function(entry, i) {
        var _logs;
        (_logs = logs).push.apply(_logs, (0, $c6Xmf._)(i === 0 ? [] : [
            "\n"
        ]).concat((0, $c6Xmf._)($fd05d31532de2fc2$var$formatTraceEntry(entry))));
    });
    return logs;
}
function $fd05d31532de2fc2$var$formatTraceEntry(param) {
    var vnode = param.vnode, recurseCount = param.recurseCount;
    var postfix = recurseCount > 0 ? "... (".concat(recurseCount, " recursive calls)") : "";
    var isRoot = vnode.component ? vnode.component.parent == null : false;
    var open = " at <".concat($fd05d31532de2fc2$var$formatComponentName(vnode.component, vnode.type, isRoot));
    var close = ">" + postfix;
    return vnode.props ? [
        open
    ].concat((0, $c6Xmf._)($fd05d31532de2fc2$var$formatProps(vnode.props)), [
        close
    ]) : [
        open + close
    ];
}
function $fd05d31532de2fc2$var$formatProps(props) {
    var res = [];
    var keys = Object.keys(props);
    keys.slice(0, 3).forEach(function(key) {
        var _res;
        (_res = res).push.apply(_res, (0, $c6Xmf._)($fd05d31532de2fc2$var$formatProp(key, props[key])));
    });
    if (keys.length > 3) res.push(" ...");
    return res;
}
function $fd05d31532de2fc2$var$formatProp(key, value1, raw) {
    if ((0, $hLodm.isString)(value1)) {
        value1 = JSON.stringify(value1);
        return raw ? value1 : [
            "".concat(key, "=").concat(value1)
        ];
    } else if (typeof value1 === "number" || typeof value1 === "boolean" || value1 == null) return raw ? value1 : [
        "".concat(key, "=").concat(value1)
    ];
    else if ((0, $yQ0Ka.isRef)(value1)) {
        value1 = $fd05d31532de2fc2$var$formatProp(key, (0, $yQ0Ka.toRaw)(value1.value), true);
        return raw ? value1 : [
            "".concat(key, "=Ref<"),
            value1,
            ">"
        ];
    } else if ((0, $hLodm.isFunction)(value1)) return [
        "".concat(key, "=fn").concat(value1.name ? "<".concat(value1.name, ">") : "")
    ];
    else {
        value1 = (0, $yQ0Ka.toRaw)(value1);
        return raw ? value1 : [
            "".concat(key, "="),
            value1
        ];
    }
}
function $fd05d31532de2fc2$export$dfbcecb440255e4a(val, type) {
    return;
}
var $fd05d31532de2fc2$var$_obj;
var $fd05d31532de2fc2$var$ErrorTypeStrings = ($fd05d31532de2fc2$var$_obj = {}, (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "sp", "serverPrefetch hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "bc", "beforeCreate hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "c", "created hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "bm", "beforeMount hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "m", "mounted hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "bu", "beforeUpdate hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "u", "updated"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "bum", "beforeUnmount hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "um", "unmounted hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "a", "activated hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "da", "deactivated hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "ec", "errorCaptured hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "rtc", "renderTracked hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, "rtg", "renderTriggered hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 0, "setup function"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 1, "render function"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 2, "watcher getter"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 3, "watcher callback"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 4, "watcher cleanup function"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 5, "native event handler"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 6, "component event handler"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 7, "vnode hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 8, "directive hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 9, "transition hook"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 10, "app errorHandler"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 11, "app warnHandler"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 12, "ref function"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 13, "async component loader"), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj, 14, "scheduler flush. This is likely a Vue internals bug. Please open an issue at https://new-issue.vuejs.org/?repo=vuejs/core"), $fd05d31532de2fc2$var$_obj);
function $fd05d31532de2fc2$export$b22fcaf88446e9bf(fn, instance, type, args) {
    var res;
    try {
        res = args ? fn.apply(void 0, (0, $c6Xmf._)(args)) : fn();
    } catch (err) {
        $fd05d31532de2fc2$export$d3da1ecaf1206c58(err, instance, type);
    }
    return res;
}
function $fd05d31532de2fc2$export$dae85862a8d94378(fn, instance, type, args) {
    if ((0, $hLodm.isFunction)(fn)) {
        var res = $fd05d31532de2fc2$export$b22fcaf88446e9bf(fn, instance, type, args);
        if (res && (0, $hLodm.isPromise)(res)) res.catch(function(err) {
            $fd05d31532de2fc2$export$d3da1ecaf1206c58(err, instance, type);
        });
        return res;
    }
    var values = [];
    for(var i = 0; i < fn.length; i++)values.push($fd05d31532de2fc2$export$dae85862a8d94378(fn[i], instance, type, args));
    return values;
}
function $fd05d31532de2fc2$export$d3da1ecaf1206c58(err, instance, type) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    var contextVNode = instance ? instance.vnode : null;
    if (instance) {
        var cur = instance.parent;
        var exposedInstance = instance.proxy;
        var errorInfo = type;
        while(cur){
            var errorCapturedHooks = cur.ec;
            if (errorCapturedHooks) for(var i = 0; i < errorCapturedHooks.length; i++){
                if (errorCapturedHooks[i](err, exposedInstance, errorInfo) === false) return;
            }
            cur = cur.parent;
        }
        var appErrorHandler = instance.appContext.config.errorHandler;
        if (appErrorHandler) {
            $fd05d31532de2fc2$export$b22fcaf88446e9bf(appErrorHandler, null, 10, [
                err,
                exposedInstance,
                errorInfo
            ]);
            return;
        }
    }
    $fd05d31532de2fc2$var$logError(err, type, contextVNode, throwInDev);
}
function $fd05d31532de2fc2$var$logError(err, type, contextVNode) {
    var throwInDev = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
    console.error(err);
}
var $fd05d31532de2fc2$var$isFlushing = false;
var $fd05d31532de2fc2$var$isFlushPending = false;
var $fd05d31532de2fc2$var$queue = [];
var $fd05d31532de2fc2$var$flushIndex = 0;
var $fd05d31532de2fc2$var$pendingPostFlushCbs = [];
var $fd05d31532de2fc2$var$activePostFlushCbs = null;
var $fd05d31532de2fc2$var$postFlushIndex = 0;
var $fd05d31532de2fc2$var$resolvedPromise = /* @__PURE__ */ Promise.resolve();
var $fd05d31532de2fc2$var$currentFlushPromise = null;
var $fd05d31532de2fc2$var$RECURSION_LIMIT = 100;
function $fd05d31532de2fc2$export$bdd553fddd433dcb(fn) {
    var p = $fd05d31532de2fc2$var$currentFlushPromise || $fd05d31532de2fc2$var$resolvedPromise;
    return fn ? p.then(this ? fn.bind(this) : fn) : p;
}
function $fd05d31532de2fc2$var$findInsertionIndex(id) {
    var start = $fd05d31532de2fc2$var$flushIndex + 1;
    var end = $fd05d31532de2fc2$var$queue.length;
    while(start < end){
        var middle = start + end >>> 1;
        var middleJobId = $fd05d31532de2fc2$var$getId($fd05d31532de2fc2$var$queue[middle]);
        middleJobId < id ? start = middle + 1 : end = middle;
    }
    return start;
}
function $fd05d31532de2fc2$var$queueJob(job) {
    if (!$fd05d31532de2fc2$var$queue.length || !$fd05d31532de2fc2$var$queue.includes(job, $fd05d31532de2fc2$var$isFlushing && job.allowRecurse ? $fd05d31532de2fc2$var$flushIndex + 1 : $fd05d31532de2fc2$var$flushIndex)) {
        if (job.id == null) $fd05d31532de2fc2$var$queue.push(job);
        else $fd05d31532de2fc2$var$queue.splice($fd05d31532de2fc2$var$findInsertionIndex(job.id), 0, job);
        $fd05d31532de2fc2$var$queueFlush();
    }
}
function $fd05d31532de2fc2$var$queueFlush() {
    if (!$fd05d31532de2fc2$var$isFlushing && !$fd05d31532de2fc2$var$isFlushPending) {
        $fd05d31532de2fc2$var$isFlushPending = true;
        $fd05d31532de2fc2$var$currentFlushPromise = $fd05d31532de2fc2$var$resolvedPromise.then($fd05d31532de2fc2$var$flushJobs);
    }
}
function $fd05d31532de2fc2$var$invalidateJob(job) {
    var i = $fd05d31532de2fc2$var$queue.indexOf(job);
    if (i > $fd05d31532de2fc2$var$flushIndex) $fd05d31532de2fc2$var$queue.splice(i, 1);
}
function $fd05d31532de2fc2$export$59536a0199721cab(cb) {
    var _pendingPostFlushCbs;
    if (!(0, $hLodm.isArray)(cb)) {
        if (!$fd05d31532de2fc2$var$activePostFlushCbs || !$fd05d31532de2fc2$var$activePostFlushCbs.includes(cb, cb.allowRecurse ? $fd05d31532de2fc2$var$postFlushIndex + 1 : $fd05d31532de2fc2$var$postFlushIndex)) $fd05d31532de2fc2$var$pendingPostFlushCbs.push(cb);
    } else (_pendingPostFlushCbs = $fd05d31532de2fc2$var$pendingPostFlushCbs).push.apply(_pendingPostFlushCbs, (0, $c6Xmf._)(cb));
    $fd05d31532de2fc2$var$queueFlush();
}
function $fd05d31532de2fc2$var$flushPreFlushCbs(seen) {
    var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fd05d31532de2fc2$var$isFlushing ? $fd05d31532de2fc2$var$flushIndex + 1 : 0;
    for(; i < $fd05d31532de2fc2$var$queue.length; i++){
        var cb = $fd05d31532de2fc2$var$queue[i];
        if (cb && cb.pre) {
            $fd05d31532de2fc2$var$queue.splice(i, 1);
            i--;
            cb();
        }
    }
}
function $fd05d31532de2fc2$var$flushPostFlushCbs(seen) {
    if ($fd05d31532de2fc2$var$pendingPostFlushCbs.length) {
        var deduped = (0, $c6Xmf._)(new Set($fd05d31532de2fc2$var$pendingPostFlushCbs));
        $fd05d31532de2fc2$var$pendingPostFlushCbs.length = 0;
        if ($fd05d31532de2fc2$var$activePostFlushCbs) {
            var _activePostFlushCbs;
            (_activePostFlushCbs = $fd05d31532de2fc2$var$activePostFlushCbs).push.apply(_activePostFlushCbs, (0, $c6Xmf._)(deduped));
            return;
        }
        $fd05d31532de2fc2$var$activePostFlushCbs = deduped;
        $fd05d31532de2fc2$var$activePostFlushCbs.sort(function(a, b) {
            return $fd05d31532de2fc2$var$getId(a) - $fd05d31532de2fc2$var$getId(b);
        });
        for($fd05d31532de2fc2$var$postFlushIndex = 0; $fd05d31532de2fc2$var$postFlushIndex < $fd05d31532de2fc2$var$activePostFlushCbs.length; $fd05d31532de2fc2$var$postFlushIndex++)$fd05d31532de2fc2$var$activePostFlushCbs[$fd05d31532de2fc2$var$postFlushIndex]();
        $fd05d31532de2fc2$var$activePostFlushCbs = null;
        $fd05d31532de2fc2$var$postFlushIndex = 0;
    }
}
var $fd05d31532de2fc2$var$getId = function(job) {
    return job.id == null ? Infinity : job.id;
};
var $fd05d31532de2fc2$var$comparator = function(a, b) {
    var diff = $fd05d31532de2fc2$var$getId(a) - $fd05d31532de2fc2$var$getId(b);
    if (diff === 0) {
        if (a.pre && !b.pre) return -1;
        if (b.pre && !a.pre) return 1;
    }
    return diff;
};
function $fd05d31532de2fc2$var$flushJobs(seen) {
    $fd05d31532de2fc2$var$isFlushPending = false;
    $fd05d31532de2fc2$var$isFlushing = true;
    $fd05d31532de2fc2$var$queue.sort($fd05d31532de2fc2$var$comparator);
    var check = (0, $hLodm.NOOP);
    try {
        for($fd05d31532de2fc2$var$flushIndex = 0; $fd05d31532de2fc2$var$flushIndex < $fd05d31532de2fc2$var$queue.length; $fd05d31532de2fc2$var$flushIndex++){
            var job = $fd05d31532de2fc2$var$queue[$fd05d31532de2fc2$var$flushIndex];
            if (job && job.active !== false) $fd05d31532de2fc2$export$b22fcaf88446e9bf(job, null, 14);
        }
    } finally{
        $fd05d31532de2fc2$var$flushIndex = 0;
        $fd05d31532de2fc2$var$queue.length = 0;
        $fd05d31532de2fc2$var$flushPostFlushCbs(seen);
        $fd05d31532de2fc2$var$isFlushing = false;
        $fd05d31532de2fc2$var$currentFlushPromise = null;
        if ($fd05d31532de2fc2$var$queue.length || $fd05d31532de2fc2$var$pendingPostFlushCbs.length) $fd05d31532de2fc2$var$flushJobs(seen);
    }
}
function $fd05d31532de2fc2$var$checkRecursiveUpdates(seen, fn) {
    if (!seen.has(fn)) seen.set(fn, 1);
    else {
        var count = seen.get(fn);
        if (count > $fd05d31532de2fc2$var$RECURSION_LIMIT) {
            var instance = fn.ownerInstance;
            var componentName = instance && $fd05d31532de2fc2$var$getComponentName(instance.type);
            $fd05d31532de2fc2$export$c106dd0671a0fc2d("Maximum recursive updates exceeded".concat(componentName ? " in component <".concat(componentName, ">") : "", ". This means you have a reactive effect that is mutating its own dependencies and thus recursively triggering itself. Possible sources include component template, render function, updated hook or watcher source function."));
            return true;
        } else seen.set(fn, count + 1);
    }
}
var $fd05d31532de2fc2$var$isHmrUpdating = false;
var $fd05d31532de2fc2$var$hmrDirtyComponents = /* @__PURE__ */ new Set();
var $fd05d31532de2fc2$var$map = /* @__PURE__ */ new Map();
function $fd05d31532de2fc2$var$registerHMR(instance) {
    var id = instance.type.__hmrId;
    var record = $fd05d31532de2fc2$var$map.get(id);
    if (!record) {
        $fd05d31532de2fc2$var$createRecord(id, instance.type);
        record = $fd05d31532de2fc2$var$map.get(id);
    }
    record.instances.add(instance);
}
function $fd05d31532de2fc2$var$unregisterHMR(instance) {
    $fd05d31532de2fc2$var$map.get(instance.type.__hmrId).instances.delete(instance);
}
function $fd05d31532de2fc2$var$createRecord(id, initialDef) {
    if ($fd05d31532de2fc2$var$map.has(id)) return false;
    $fd05d31532de2fc2$var$map.set(id, {
        initialDef: $fd05d31532de2fc2$var$normalizeClassComponent(initialDef),
        instances: /* @__PURE__ */ new Set()
    });
    return true;
}
function $fd05d31532de2fc2$var$normalizeClassComponent(component) {
    return $fd05d31532de2fc2$var$isClassComponent(component) ? component.__vccOpts : component;
}
function $fd05d31532de2fc2$var$rerender(id, newRender) {
    var record = $fd05d31532de2fc2$var$map.get(id);
    if (!record) return;
    record.initialDef.render = newRender;
    (0, $c6Xmf._)(record.instances).forEach(function(instance) {
        if (newRender) {
            instance.render = newRender;
            $fd05d31532de2fc2$var$normalizeClassComponent(instance.type).render = newRender;
        }
        instance.renderCache = [];
        $fd05d31532de2fc2$var$isHmrUpdating = true;
        instance.update();
        $fd05d31532de2fc2$var$isHmrUpdating = false;
    });
}
function $fd05d31532de2fc2$var$reload(id, newComp) {
    var record = $fd05d31532de2fc2$var$map.get(id);
    if (!record) return;
    newComp = $fd05d31532de2fc2$var$normalizeClassComponent(newComp);
    $fd05d31532de2fc2$var$updateComponentDef(record.initialDef, newComp);
    var instances = (0, $c6Xmf._)(record.instances);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var instance = _step.value;
            var oldComp = $fd05d31532de2fc2$var$normalizeClassComponent(instance.type);
            if (!$fd05d31532de2fc2$var$hmrDirtyComponents.has(oldComp)) {
                if (oldComp !== record.initialDef) $fd05d31532de2fc2$var$updateComponentDef(oldComp, newComp);
                $fd05d31532de2fc2$var$hmrDirtyComponents.add(oldComp);
            }
            instance.appContext.propsCache.delete(instance.type);
            instance.appContext.emitsCache.delete(instance.type);
            instance.appContext.optionsCache.delete(instance.type);
            if (instance.ceReload) {
                $fd05d31532de2fc2$var$hmrDirtyComponents.add(oldComp);
                instance.ceReload(newComp.styles);
                $fd05d31532de2fc2$var$hmrDirtyComponents.delete(oldComp);
            } else if (instance.parent) $fd05d31532de2fc2$var$queueJob(instance.parent.update);
            else if (instance.appContext.reload) instance.appContext.reload();
            else if (typeof window !== "undefined") window.location.reload();
            else console.warn("[HMR] Root or manually mounted instance modified. Full reload required.");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    $fd05d31532de2fc2$export$59536a0199721cab(function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var instance = _step.value;
                $fd05d31532de2fc2$var$hmrDirtyComponents.delete($fd05d31532de2fc2$var$normalizeClassComponent(instance.type));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
}
function $fd05d31532de2fc2$var$updateComponentDef(oldComp, newComp) {
    (0, $hLodm.extend)(oldComp, newComp);
    for(var key in oldComp)if (key !== "__file" && !(key in newComp)) delete oldComp[key];
}
function $fd05d31532de2fc2$var$tryWrap(fn) {
    return function(id, arg) {
        try {
            return fn(id, arg);
        } catch (e) {
            console.error(e);
            console.warn("[HMR] Something went wrong during Vue component hot-reload. Full reload required.");
        }
    };
}
var $fd05d31532de2fc2$export$6922d3b3a607469e;
var $fd05d31532de2fc2$var$buffer = [];
var $fd05d31532de2fc2$var$devtoolsNotInstalled = false;
function $fd05d31532de2fc2$var$emit$1(event) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _devtools;
    if ($fd05d31532de2fc2$export$6922d3b3a607469e) (_devtools = $fd05d31532de2fc2$export$6922d3b3a607469e).emit.apply(_devtools, [
        event
    ].concat((0, $c6Xmf._)(args)));
    else if (!$fd05d31532de2fc2$var$devtoolsNotInstalled) $fd05d31532de2fc2$var$buffer.push({
        event: event,
        args: args
    });
}
function $fd05d31532de2fc2$export$b0c258b32c26c785(hook, target) {
    var _a, _b;
    $fd05d31532de2fc2$export$6922d3b3a607469e = hook;
    if ($fd05d31532de2fc2$export$6922d3b3a607469e) {
        var _devtools;
        $fd05d31532de2fc2$export$6922d3b3a607469e.enabled = true;
        $fd05d31532de2fc2$var$buffer.forEach(function(param) {
            var event = param.event, args = param.args;
            return (_devtools = $fd05d31532de2fc2$export$6922d3b3a607469e).emit.apply(_devtools, [
                event
            ].concat((0, $c6Xmf._)(args)));
        });
        $fd05d31532de2fc2$var$buffer = [];
    } else if (// handle late devtools injection - only do this if we are in an actual
    // browser environment to avoid the timer handle stalling test runner exit
    // (#4815)
    typeof window !== "undefined" && // some envs mock window but not fully
    window.HTMLElement && // also exclude jsdom
    !((_b = (_a = window.navigator) == null ? void 0 : _a.userAgent) == null ? void 0 : _b.includes("jsdom"))) {
        var replay = target.__VUE_DEVTOOLS_HOOK_REPLAY__ = target.__VUE_DEVTOOLS_HOOK_REPLAY__ || [];
        replay.push(function(newHook) {
            $fd05d31532de2fc2$export$b0c258b32c26c785(newHook, target);
        });
        setTimeout(function() {
            if (!$fd05d31532de2fc2$export$6922d3b3a607469e) {
                target.__VUE_DEVTOOLS_HOOK_REPLAY__ = null;
                $fd05d31532de2fc2$var$devtoolsNotInstalled = true;
                $fd05d31532de2fc2$var$buffer = [];
            }
        }, 3e3);
    } else {
        $fd05d31532de2fc2$var$devtoolsNotInstalled = true;
        $fd05d31532de2fc2$var$buffer = [];
    }
}
function $fd05d31532de2fc2$var$devtoolsInitApp(app, version) {
    $fd05d31532de2fc2$var$emit$1("app:init" /* APP_INIT */ , app, version, {
        Fragment: $fd05d31532de2fc2$export$ffb0004e005737fa,
        Text: $fd05d31532de2fc2$export$5f1af8db9871e1d6,
        Comment: $fd05d31532de2fc2$export$4d299b491347818a,
        Static: $fd05d31532de2fc2$export$c1b9a1d3af45b7b6
    });
}
function $fd05d31532de2fc2$var$devtoolsUnmountApp(app) {
    $fd05d31532de2fc2$var$emit$1("app:unmount" /* APP_UNMOUNT */ , app);
}
var $fd05d31532de2fc2$var$devtoolsComponentAdded = /* @__PURE__ */ $fd05d31532de2fc2$var$createDevtoolsComponentHook("component:added" /* COMPONENT_ADDED */ );
var $fd05d31532de2fc2$var$devtoolsComponentUpdated = /* @__PURE__ */ $fd05d31532de2fc2$var$createDevtoolsComponentHook("component:updated" /* COMPONENT_UPDATED */ );
var $fd05d31532de2fc2$var$_devtoolsComponentRemoved = /* @__PURE__ */ $fd05d31532de2fc2$var$createDevtoolsComponentHook("component:removed" /* COMPONENT_REMOVED */ );
var $fd05d31532de2fc2$var$devtoolsComponentRemoved = function(component) {
    if ($fd05d31532de2fc2$export$6922d3b3a607469e && typeof $fd05d31532de2fc2$export$6922d3b3a607469e.cleanupBuffer === "function" && // remove the component if it wasn't buffered
    !$fd05d31532de2fc2$export$6922d3b3a607469e.cleanupBuffer(component)) $fd05d31532de2fc2$var$_devtoolsComponentRemoved(component);
};
function $fd05d31532de2fc2$var$createDevtoolsComponentHook(hook) {
    return function(component) {
        $fd05d31532de2fc2$var$emit$1(hook, component.appContext.app, component.uid, component.parent ? component.parent.uid : void 0, component);
    };
}
var $fd05d31532de2fc2$var$devtoolsPerfStart = /* @__PURE__ */ $fd05d31532de2fc2$var$createDevtoolsPerformanceHook("perf:start" /* PERFORMANCE_START */ );
var $fd05d31532de2fc2$var$devtoolsPerfEnd = /* @__PURE__ */ $fd05d31532de2fc2$var$createDevtoolsPerformanceHook("perf:end" /* PERFORMANCE_END */ );
function $fd05d31532de2fc2$var$createDevtoolsPerformanceHook(hook) {
    return function(component, type, time) {
        $fd05d31532de2fc2$var$emit$1(hook, component.appContext.app, component.uid, component, type, time);
    };
}
function $fd05d31532de2fc2$var$devtoolsComponentEmit(component, event, params) {
    $fd05d31532de2fc2$var$emit$1("component:emit" /* COMPONENT_EMIT */ , component.appContext.app, component, event, params);
}
function $fd05d31532de2fc2$var$emit(instance, event) {
    for(var _len = arguments.length, rawArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        rawArgs[_key - 2] = arguments[_key];
    }
    if (instance.isUnmounted) return;
    var props = instance.vnode.props || (0, $hLodm.EMPTY_OBJ);
    var args = rawArgs;
    var isModelListener = event.startsWith("update:");
    var modelArg = isModelListener && event.slice(7);
    if (modelArg && modelArg in props) {
        var modifiersKey = "".concat(modelArg === "modelValue" ? "model" : modelArg, "Modifiers");
        var _ref = props[modifiersKey] || (0, $hLodm.EMPTY_OBJ), number = _ref.number, trim = _ref.trim;
        if (trim) args = rawArgs.map(function(a) {
            return (0, $hLodm.isString)(a) ? a.trim() : a;
        });
        if (number) args = rawArgs.map((0, $hLodm.looseToNumber));
    }
    if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsComponentEmit(instance, event, args);
    var handlerName;
    var handler = props[handlerName = (0, $hLodm.toHandlerKey)(event)] || // also try camelCase event handler (#2249)
    props[handlerName = (0, $hLodm.toHandlerKey)((0, $hLodm.camelize)(event))];
    if (!handler && isModelListener) handler = props[handlerName = (0, $hLodm.toHandlerKey)((0, $hLodm.hyphenate)(event))];
    if (handler) $fd05d31532de2fc2$export$dae85862a8d94378(handler, instance, 6, args);
    var onceHandler = props[handlerName + "Once"];
    if (onceHandler) {
        if (!instance.emitted) instance.emitted = {};
        else if (instance.emitted[handlerName]) return;
        instance.emitted[handlerName] = true;
        $fd05d31532de2fc2$export$dae85862a8d94378(onceHandler, instance, 6, args);
    }
}
function $fd05d31532de2fc2$var$normalizeEmitsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = appContext.emitsCache;
    var cached = cache.get(comp);
    if (cached !== void 0) return cached;
    var raw = comp.emits;
    var normalized = {};
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $hLodm.isFunction)(comp)) {
        var extendEmits = function(raw2) {
            var normalizedFromExtend = $fd05d31532de2fc2$var$normalizeEmitsOptions(raw2, appContext, true);
            if (normalizedFromExtend) {
                hasExtends = true;
                (0, $hLodm.extend)(normalized, normalizedFromExtend);
            }
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendEmits);
        if (comp.extends) extendEmits(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendEmits);
    }
    if (!raw && !hasExtends) {
        if ((0, $hLodm.isObject)(comp)) cache.set(comp, null);
        return null;
    }
    if ((0, $hLodm.isArray)(raw)) raw.forEach(function(key) {
        return normalized[key] = null;
    });
    else (0, $hLodm.extend)(normalized, raw);
    if ((0, $hLodm.isObject)(comp)) cache.set(comp, normalized);
    return normalized;
}
function $fd05d31532de2fc2$var$isEmitListener(options, key) {
    if (!options || !(0, $hLodm.isOn)(key)) return false;
    key = key.slice(2).replace(/Once$/, "");
    return (0, $hLodm.hasOwn)(options, key[0].toLowerCase() + key.slice(1)) || (0, $hLodm.hasOwn)(options, (0, $hLodm.hyphenate)(key)) || (0, $hLodm.hasOwn)(options, key);
}
var $fd05d31532de2fc2$var$currentRenderingInstance = null;
var $fd05d31532de2fc2$var$currentScopeId = null;
function $fd05d31532de2fc2$var$setCurrentRenderingInstance(instance) {
    var prev = $fd05d31532de2fc2$var$currentRenderingInstance;
    $fd05d31532de2fc2$var$currentRenderingInstance = instance;
    $fd05d31532de2fc2$var$currentScopeId = instance && instance.type.__scopeId || null;
    return prev;
}
function $fd05d31532de2fc2$export$ac020265ca2cc4cd(id) {
    $fd05d31532de2fc2$var$currentScopeId = id;
}
function $fd05d31532de2fc2$export$f2dc6805dc11834e() {
    $fd05d31532de2fc2$var$currentScopeId = null;
}
var $fd05d31532de2fc2$export$15ba313e13f3dd04 = function(_id) {
    return $fd05d31532de2fc2$export$694b237e827a3d23;
};
function $fd05d31532de2fc2$export$694b237e827a3d23(fn) {
    var ctx = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fd05d31532de2fc2$var$currentRenderingInstance, isNonScopedSlot = arguments.length > 2 ? arguments[2] : void 0;
    if (!ctx) return fn;
    if (fn._n) return fn;
    var renderFnWithContext = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        if (renderFnWithContext._d) $fd05d31532de2fc2$export$c20bee82f26f1e27(-1);
        var prevInstance = $fd05d31532de2fc2$var$setCurrentRenderingInstance(ctx);
        var res;
        try {
            res = fn.apply(void 0, (0, $c6Xmf._)(args));
        } finally{
            $fd05d31532de2fc2$var$setCurrentRenderingInstance(prevInstance);
            if (renderFnWithContext._d) $fd05d31532de2fc2$export$c20bee82f26f1e27(1);
        }
        if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsComponentUpdated(ctx);
        return res;
    };
    renderFnWithContext._n = true;
    renderFnWithContext._c = true;
    renderFnWithContext._d = true;
    return renderFnWithContext;
}
var $fd05d31532de2fc2$var$accessedAttrs = false;
function $fd05d31532de2fc2$var$markAttrsAccessed() {
    $fd05d31532de2fc2$var$accessedAttrs = true;
}
function $fd05d31532de2fc2$var$renderComponentRoot(instance) {
    var Component = instance.type, vnode = instance.vnode, proxy = instance.proxy, withProxy = instance.withProxy, props = instance.props, _instance_propsOptions = (0, $cv9Rk._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0], slots = instance.slots, attrs = instance.attrs, emit = instance.emit, render = instance.render, renderCache = instance.renderCache, data = instance.data, setupState = instance.setupState, ctx = instance.ctx, inheritAttrs = instance.inheritAttrs;
    var result;
    var fallthroughAttrs;
    var prev = $fd05d31532de2fc2$var$setCurrentRenderingInstance(instance);
    try {
        if (vnode.shapeFlag & 4) {
            var proxyToUse = withProxy || proxy;
            result = $fd05d31532de2fc2$var$normalizeVNode(render.call(proxyToUse, proxyToUse, renderCache, props, setupState, data, ctx));
            fallthroughAttrs = attrs;
        } else {
            var render2 = Component;
            result = $fd05d31532de2fc2$var$normalizeVNode(render2.length > 1 ? render2(props, {
                attrs: attrs,
                slots: slots,
                emit: emit
            }) : render2(props, null));
            fallthroughAttrs = Component.props ? attrs : $fd05d31532de2fc2$var$getFunctionalFallthrough(attrs);
        }
    } catch (err) {
        $fd05d31532de2fc2$var$blockStack.length = 0;
        $fd05d31532de2fc2$export$d3da1ecaf1206c58(err, instance, 1);
        result = $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$4d299b491347818a);
    }
    var root = result;
    var setRoot = void 0;
    if (fallthroughAttrs && inheritAttrs !== false) {
        var keys = Object.keys(fallthroughAttrs);
        var shapeFlag = root.shapeFlag;
        if (keys.length) {
            if (shapeFlag & 7) {
                if (propsOptions && keys.some((0, $hLodm.isModelListener))) fallthroughAttrs = $fd05d31532de2fc2$var$filterModelListeners(fallthroughAttrs, propsOptions);
                root = $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(root, fallthroughAttrs);
            }
        }
    }
    if (vnode.dirs) {
        root = $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(root);
        root.dirs = root.dirs ? root.dirs.concat(vnode.dirs) : vnode.dirs;
    }
    if (vnode.transition) root.transition = vnode.transition;
    result = root;
    $fd05d31532de2fc2$var$setCurrentRenderingInstance(prev);
    return result;
}
var $fd05d31532de2fc2$var$getChildRoot = function(vnode) {
    var rawChildren = vnode.children;
    var dynamicChildren = vnode.dynamicChildren;
    var childRoot = $fd05d31532de2fc2$var$filterSingleRoot(rawChildren);
    if (!childRoot) return [
        vnode,
        void 0
    ];
    var index = rawChildren.indexOf(childRoot);
    var dynamicIndex = dynamicChildren ? dynamicChildren.indexOf(childRoot) : -1;
    var setRoot = function(updatedRoot) {
        rawChildren[index] = updatedRoot;
        if (dynamicChildren) {
            if (dynamicIndex > -1) dynamicChildren[dynamicIndex] = updatedRoot;
            else if (updatedRoot.patchFlag > 0) vnode.dynamicChildren = (0, $c6Xmf._)(dynamicChildren).concat([
                updatedRoot
            ]);
        }
    };
    return [
        $fd05d31532de2fc2$var$normalizeVNode(childRoot),
        setRoot
    ];
};
function $fd05d31532de2fc2$var$filterSingleRoot(children) {
    var singleRoot;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        if ($fd05d31532de2fc2$export$3868d13f8734ae81(child)) {
            if (child.type !== $fd05d31532de2fc2$export$4d299b491347818a || child.children === "v-if") {
                if (singleRoot) return;
                else singleRoot = child;
            }
        } else return;
    }
    return singleRoot;
}
var $fd05d31532de2fc2$var$getFunctionalFallthrough = function(attrs) {
    var res;
    for(var key in attrs)if (key === "class" || key === "style" || (0, $hLodm.isOn)(key)) (res || (res = {}))[key] = attrs[key];
    return res;
};
var $fd05d31532de2fc2$var$filterModelListeners = function(attrs, props) {
    var res = {};
    for(var key in attrs)if (!(0, $hLodm.isModelListener)(key) || !(key.slice(9) in props)) res[key] = attrs[key];
    return res;
};
var $fd05d31532de2fc2$var$isElementRoot = function(vnode) {
    return vnode.shapeFlag & 7 || vnode.type === $fd05d31532de2fc2$export$4d299b491347818a;
};
function $fd05d31532de2fc2$var$shouldUpdateComponent(prevVNode, nextVNode, optimized) {
    var prevProps = prevVNode.props, prevChildren = prevVNode.children, component = prevVNode.component;
    var nextProps = nextVNode.props, nextChildren = nextVNode.children, patchFlag = nextVNode.patchFlag;
    var emits = component.emitsOptions;
    if (nextVNode.dirs || nextVNode.transition) return true;
    if (optimized && patchFlag >= 0) {
        if (patchFlag & 1024) return true;
        if (patchFlag & 16) {
            if (!prevProps) return !!nextProps;
            return $fd05d31532de2fc2$var$hasPropsChanged(prevProps, nextProps, emits);
        } else if (patchFlag & 8) {
            var dynamicProps = nextVNode.dynamicProps;
            for(var i = 0; i < dynamicProps.length; i++){
                var key = dynamicProps[i];
                if (nextProps[key] !== prevProps[key] && !$fd05d31532de2fc2$var$isEmitListener(emits, key)) return true;
            }
        }
    } else {
        if (prevChildren || nextChildren) {
            if (!nextChildren || !nextChildren.$stable) return true;
        }
        if (prevProps === nextProps) return false;
        if (!prevProps) return !!nextProps;
        if (!nextProps) return true;
        return $fd05d31532de2fc2$var$hasPropsChanged(prevProps, nextProps, emits);
    }
    return false;
}
function $fd05d31532de2fc2$var$hasPropsChanged(prevProps, nextProps, emitsOptions) {
    var nextKeys = Object.keys(nextProps);
    if (nextKeys.length !== Object.keys(prevProps).length) return true;
    for(var i = 0; i < nextKeys.length; i++){
        var key = nextKeys[i];
        if (nextProps[key] !== prevProps[key] && !$fd05d31532de2fc2$var$isEmitListener(emitsOptions, key)) return true;
    }
    return false;
}
function $fd05d31532de2fc2$var$updateHOCHostEl(param, el) {
    var vnode = param.vnode, parent = param.parent;
    while(parent && parent.subTree === vnode){
        (vnode = parent.vnode).el = el;
        parent = parent.parent;
    }
}
var $fd05d31532de2fc2$var$isSuspense = function(type) {
    return type.__isSuspense;
};
var $fd05d31532de2fc2$var$SuspenseImpl = {
    name: "Suspense",
    // In order to make Suspense tree-shakable, we need to avoid importing it
    // directly in the renderer. The renderer checks for the __isSuspense flag
    // on a vnode's type and calls the `process` method, passing in renderer
    // internals.
    __isSuspense: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
        if (n1 == null) $fd05d31532de2fc2$var$mountSuspense(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals);
        else $fd05d31532de2fc2$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, rendererInternals);
    },
    hydrate: $fd05d31532de2fc2$var$hydrateSuspense,
    create: $fd05d31532de2fc2$var$createSuspenseBoundary,
    normalize: $fd05d31532de2fc2$var$normalizeSuspenseChildren
};
var $fd05d31532de2fc2$export$74bf444e3cd11ea5 = $fd05d31532de2fc2$var$SuspenseImpl;
function $fd05d31532de2fc2$var$triggerEvent(vnode, name) {
    var eventListener = vnode.props && vnode.props[name];
    if ((0, $hLodm.isFunction)(eventListener)) eventListener();
}
function $fd05d31532de2fc2$var$mountSuspense(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals) {
    var patch = rendererInternals.p, createElement = rendererInternals.o.createElement;
    var hiddenContainer = createElement("div");
    var suspense = vnode.suspense = $fd05d31532de2fc2$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals);
    patch(null, suspense.pendingBranch = vnode.ssContent, hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds);
    if (suspense.deps > 0) {
        $fd05d31532de2fc2$var$triggerEvent(vnode, "onPending");
        $fd05d31532de2fc2$var$triggerEvent(vnode, "onFallback");
        patch(null, vnode.ssFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
        isSVG, slotScopeIds);
        $fd05d31532de2fc2$var$setActiveBranch(suspense, vnode.ssFallback);
    } else suspense.resolve(false, true);
}
function $fd05d31532de2fc2$var$patchSuspense(n1, n2, container, anchor, parentComponent, isSVG, slotScopeIds, optimized, param) {
    var patch = param.p, unmount = param.um, createElement = param.o.createElement;
    var suspense = n2.suspense = n1.suspense;
    suspense.vnode = n2;
    n2.el = n1.el;
    var newBranch = n2.ssContent;
    var newFallback = n2.ssFallback;
    var activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, isInFallback = suspense.isInFallback, isHydrating = suspense.isHydrating;
    if (pendingBranch) {
        suspense.pendingBranch = newBranch;
        if ($fd05d31532de2fc2$var$isSameVNodeType(newBranch, pendingBranch)) {
            patch(pendingBranch, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
            if (suspense.deps <= 0) suspense.resolve();
            else if (isInFallback) {
                patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                isSVG, slotScopeIds, optimized);
                $fd05d31532de2fc2$var$setActiveBranch(suspense, newFallback);
            }
        } else {
            suspense.pendingId++;
            if (isHydrating) {
                suspense.isHydrating = false;
                suspense.activeBranch = pendingBranch;
            } else unmount(pendingBranch, parentComponent, suspense);
            suspense.deps = 0;
            suspense.effects.length = 0;
            suspense.hiddenContainer = createElement("div");
            if (isInFallback) {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
                else {
                    patch(activeBranch, newFallback, container, anchor, parentComponent, null, // fallback tree will not have suspense context
                    isSVG, slotScopeIds, optimized);
                    $fd05d31532de2fc2$var$setActiveBranch(suspense, newFallback);
                }
            } else if (activeBranch && $fd05d31532de2fc2$var$isSameVNodeType(newBranch, activeBranch)) {
                patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                suspense.resolve(true);
            } else {
                patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
                if (suspense.deps <= 0) suspense.resolve();
            }
        }
    } else if (activeBranch && $fd05d31532de2fc2$var$isSameVNodeType(newBranch, activeBranch)) {
        patch(activeBranch, newBranch, container, anchor, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        $fd05d31532de2fc2$var$setActiveBranch(suspense, newBranch);
    } else {
        $fd05d31532de2fc2$var$triggerEvent(n2, "onPending");
        suspense.pendingBranch = newBranch;
        suspense.pendingId++;
        patch(null, newBranch, suspense.hiddenContainer, null, parentComponent, suspense, isSVG, slotScopeIds, optimized);
        if (suspense.deps <= 0) suspense.resolve();
        else {
            var timeout = suspense.timeout, pendingId = suspense.pendingId;
            if (timeout > 0) setTimeout(function() {
                if (suspense.pendingId === pendingId) suspense.fallback(newFallback);
            }, timeout);
            else if (timeout === 0) suspense.fallback(newFallback);
        }
    }
}
var $fd05d31532de2fc2$var$hasWarned = false;
function $fd05d31532de2fc2$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, container, hiddenContainer, anchor, isSVG, slotScopeIds, optimized, rendererInternals) {
    var isHydrating = arguments.length > 10 && arguments[10] !== void 0 ? arguments[10] : false;
    var patch = rendererInternals.p, move = rendererInternals.m, unmount = rendererInternals.um, next = rendererInternals.n, _rendererInternals_o = rendererInternals.o, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove;
    var parentSuspenseId;
    var isSuspensible = $fd05d31532de2fc2$var$isVNodeSuspensible(vnode);
    if (isSuspensible) {
        if (parentSuspense == null ? void 0 : parentSuspense.pendingBranch) {
            parentSuspenseId = parentSuspense.pendingId;
            parentSuspense.deps++;
        }
    }
    var timeout = vnode.props ? (0, $hLodm.toNumber)(vnode.props.timeout) : void 0;
    var _obj;
    var suspense = (_obj = {
        vnode: vnode,
        parent: parentSuspense,
        parentComponent: parentComponent,
        isSVG: isSVG,
        container: container,
        hiddenContainer: hiddenContainer,
        anchor: anchor,
        deps: 0,
        pendingId: 0,
        timeout: typeof timeout === "number" ? timeout : -1,
        activeBranch: null,
        pendingBranch: null,
        isInFallback: true,
        isHydrating: isHydrating,
        isUnmounted: false,
        effects: []
    }, (0, $3sHb8._)(_obj, "resolve", function() {
        var resume = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, sync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
        var vnode2 = suspense["vnode"], activeBranch = suspense.activeBranch, pendingBranch = suspense.pendingBranch, pendingId = suspense.pendingId, effects = suspense.effects, parentComponent2 = suspense["parentComponent"], container2 = suspense["container"];
        if (suspense.isHydrating) suspense.isHydrating = false;
        else if (!resume) {
            var delayEnter = activeBranch && pendingBranch.transition && pendingBranch.transition.mode === "out-in";
            if (delayEnter) activeBranch.transition.afterLeave = function() {
                if (pendingId === suspense.pendingId) move(pendingBranch, container2, anchor2, 0);
            };
            var anchor2 = suspense["anchor"];
            if (activeBranch) {
                anchor2 = next(activeBranch);
                unmount(activeBranch, parentComponent2, suspense, true);
            }
            if (!delayEnter) move(pendingBranch, container2, anchor2, 0);
        }
        $fd05d31532de2fc2$var$setActiveBranch(suspense, pendingBranch);
        suspense.pendingBranch = null;
        suspense.isInFallback = false;
        var parent = suspense.parent;
        var hasUnresolvedAncestor = false;
        while(parent){
            if (parent.pendingBranch) {
                var _parent_effects;
                (_parent_effects = parent.effects).push.apply(_parent_effects, (0, $c6Xmf._)(effects));
                hasUnresolvedAncestor = true;
                break;
            }
            parent = parent.parent;
        }
        if (!hasUnresolvedAncestor) $fd05d31532de2fc2$export$59536a0199721cab(effects);
        suspense.effects = [];
        if (isSuspensible) {
            if (parentSuspense && parentSuspense.pendingBranch && parentSuspenseId === parentSuspense.pendingId) {
                parentSuspense.deps--;
                if (parentSuspense.deps === 0 && !sync) parentSuspense.resolve();
            }
        }
        $fd05d31532de2fc2$var$triggerEvent(vnode2, "onResolve");
    }), (0, $3sHb8._)(_obj, "fallback", function(fallbackVNode) {
        if (!suspense.pendingBranch) return;
        var vnode2 = suspense["vnode"], activeBranch = suspense.activeBranch, parentComponent2 = suspense["parentComponent"], container2 = suspense["container"], isSVG2 = suspense["isSVG"];
        $fd05d31532de2fc2$var$triggerEvent(vnode2, "onFallback");
        var anchor2 = next(activeBranch);
        var mountFallback = function() {
            if (!suspense.isInFallback) return;
            patch(null, fallbackVNode, container2, anchor2, parentComponent2, null, // fallback tree will not have suspense context
            isSVG2, slotScopeIds, optimized);
            $fd05d31532de2fc2$var$setActiveBranch(suspense, fallbackVNode);
        };
        var delayEnter = fallbackVNode.transition && fallbackVNode.transition.mode === "out-in";
        if (delayEnter) activeBranch.transition.afterLeave = mountFallback;
        suspense.isInFallback = true;
        unmount(activeBranch, parentComponent2, null, // no suspense so unmount hooks fire now
        true);
        if (!delayEnter) mountFallback();
    }), (0, $3sHb8._)(_obj, "move", function(container2, anchor2, type) {
        suspense.activeBranch && move(suspense.activeBranch, container2, anchor2, type);
        suspense.container = container2;
    }), (0, $3sHb8._)(_obj, "next", function() {
        return suspense.activeBranch && next(suspense.activeBranch);
    }), (0, $3sHb8._)(_obj, "registerDep", function(instance, setupRenderEffect) {
        var isInPendingSuspense = !!suspense.pendingBranch;
        if (isInPendingSuspense) suspense.deps++;
        var hydratedEl = instance.vnode.el;
        instance.asyncDep.catch(function(err) {
            $fd05d31532de2fc2$export$d3da1ecaf1206c58(err, instance, 0);
        }).then(function(asyncSetupResult) {
            if (instance.isUnmounted || suspense.isUnmounted || suspense.pendingId !== instance.suspenseId) return;
            instance.asyncResolved = true;
            var vnode2 = instance.vnode;
            $fd05d31532de2fc2$var$handleSetupResult(instance, asyncSetupResult, false);
            if (hydratedEl) vnode2.el = hydratedEl;
            var placeholder = !hydratedEl && instance.subTree.el;
            setupRenderEffect(instance, vnode2, // component may have been moved before resolve.
            // if this is not a hydration, instance.subTree will be the comment
            // placeholder.
            parentNode(hydratedEl || instance.subTree.el), // anchor will not be used if this is hydration, so only need to
            // consider the comment placeholder case.
            hydratedEl ? null : next(instance.subTree), suspense, isSVG, optimized);
            if (placeholder) remove(placeholder);
            $fd05d31532de2fc2$var$updateHOCHostEl(instance, vnode2.el);
            if (isInPendingSuspense && --suspense.deps === 0) suspense.resolve();
        });
    }), (0, $3sHb8._)(_obj, "unmount", function(parentSuspense2, doRemove) {
        suspense.isUnmounted = true;
        if (suspense.activeBranch) unmount(suspense.activeBranch, parentComponent, parentSuspense2, doRemove);
        if (suspense.pendingBranch) unmount(suspense.pendingBranch, parentComponent, parentSuspense2, doRemove);
    }), _obj);
    return suspense;
}
function $fd05d31532de2fc2$var$hydrateSuspense(node, vnode, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, rendererInternals, hydrateNode) {
    var suspense = vnode.suspense = $fd05d31532de2fc2$var$createSuspenseBoundary(vnode, parentSuspense, parentComponent, node.parentNode, document.createElement("div"), null, isSVG, slotScopeIds, optimized, rendererInternals, true);
    var result = hydrateNode(node, suspense.pendingBranch = vnode.ssContent, parentComponent, suspense, slotScopeIds, optimized);
    if (suspense.deps === 0) suspense.resolve(false, true);
    return result;
}
function $fd05d31532de2fc2$var$normalizeSuspenseChildren(vnode) {
    var shapeFlag = vnode.shapeFlag, children = vnode.children;
    var isSlotChildren = shapeFlag & 32;
    vnode.ssContent = $fd05d31532de2fc2$var$normalizeSuspenseSlot(isSlotChildren ? children.default : children);
    vnode.ssFallback = isSlotChildren ? $fd05d31532de2fc2$var$normalizeSuspenseSlot(children.fallback) : $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$4d299b491347818a);
}
function $fd05d31532de2fc2$var$normalizeSuspenseSlot(s) {
    var block;
    if ((0, $hLodm.isFunction)(s)) {
        var trackBlock = $fd05d31532de2fc2$var$isBlockTreeEnabled && s._c;
        if (trackBlock) {
            s._d = false;
            $fd05d31532de2fc2$export$e7eaa45e502fe5cc();
        }
        s = s();
        if (trackBlock) {
            s._d = true;
            block = $fd05d31532de2fc2$var$currentBlock;
            $fd05d31532de2fc2$var$closeBlock();
        }
    }
    if ((0, $hLodm.isArray)(s)) {
        var singleChild = $fd05d31532de2fc2$var$filterSingleRoot(s);
        s = singleChild;
    }
    s = $fd05d31532de2fc2$var$normalizeVNode(s);
    if (block && !s.dynamicChildren) s.dynamicChildren = block.filter(function(c) {
        return c !== s;
    });
    return s;
}
function $fd05d31532de2fc2$var$queueEffectWithSuspense(fn, suspense) {
    if (suspense && suspense.pendingBranch) {
        var _suspense_effects;
        if ((0, $hLodm.isArray)(fn)) (_suspense_effects = suspense.effects).push.apply(_suspense_effects, (0, $c6Xmf._)(fn));
        else suspense.effects.push(fn);
    } else $fd05d31532de2fc2$export$59536a0199721cab(fn);
}
function $fd05d31532de2fc2$var$setActiveBranch(suspense, branch) {
    suspense.activeBranch = branch;
    var vnode = suspense.vnode, parentComponent = suspense.parentComponent;
    var el = vnode.el = branch.el;
    if (parentComponent && parentComponent.subTree === vnode) {
        parentComponent.vnode.el = el;
        $fd05d31532de2fc2$var$updateHOCHostEl(parentComponent, el);
    }
}
function $fd05d31532de2fc2$var$isVNodeSuspensible(vnode) {
    var _a;
    return ((_a = vnode.props) == null ? void 0 : _a.suspensible) != null && vnode.props.suspensible !== false;
}
function $fd05d31532de2fc2$export$ede35fc0e5500309(effect, options) {
    return $fd05d31532de2fc2$var$doWatch(effect, null, options);
}
function $fd05d31532de2fc2$export$b7f27ea67102d543(effect, options) {
    return $fd05d31532de2fc2$var$doWatch(effect, null, {
        flush: "post"
    });
}
function $fd05d31532de2fc2$export$2035654f31b0e555(effect, options) {
    return $fd05d31532de2fc2$var$doWatch(effect, null, {
        flush: "sync"
    });
}
var $fd05d31532de2fc2$var$INITIAL_WATCHER_VALUE = {};
function $fd05d31532de2fc2$export$3db5d71bdb2d5499(source, cb, options) {
    return $fd05d31532de2fc2$var$doWatch(source, cb, options);
}
function $fd05d31532de2fc2$var$doWatch(source, cb) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $hLodm.EMPTY_OBJ), immediate = _ref.immediate, deep = _ref.deep, flush = _ref.flush, onTrack = _ref.onTrack, onTrigger = _ref.onTrigger;
    var _a;
    var warnInvalidSource = function(s) {
        $fd05d31532de2fc2$export$c106dd0671a0fc2d("Invalid watch source: ", s, "A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types.");
    };
    var instance = (0, $yQ0Ka.getCurrentScope)() === ((_a = $fd05d31532de2fc2$var$currentInstance) == null ? void 0 : _a.scope) ? $fd05d31532de2fc2$var$currentInstance : null;
    var getter;
    var forceTrigger = false;
    var isMultiSource = false;
    if ((0, $yQ0Ka.isRef)(source)) {
        getter = function() {
            return source.value;
        };
        forceTrigger = (0, $yQ0Ka.isShallow)(source);
    } else if ((0, $yQ0Ka.isReactive)(source)) {
        getter = function() {
            return source;
        };
        deep = true;
    } else if ((0, $hLodm.isArray)(source)) {
        isMultiSource = true;
        forceTrigger = source.some(function(s) {
            return (0, $yQ0Ka.isReactive)(s) || (0, $yQ0Ka.isShallow)(s);
        });
        getter = function() {
            return source.map(function(s) {
                if ((0, $yQ0Ka.isRef)(s)) return s.value;
                else if ((0, $yQ0Ka.isReactive)(s)) return $fd05d31532de2fc2$var$traverse(s);
                else if ((0, $hLodm.isFunction)(s)) return $fd05d31532de2fc2$export$b22fcaf88446e9bf(s, instance, 2);
            });
        };
    } else if ((0, $hLodm.isFunction)(source)) {
        if (cb) getter = function() {
            return $fd05d31532de2fc2$export$b22fcaf88446e9bf(source, instance, 2);
        };
        else getter = function() {
            if (instance && instance.isUnmounted) return;
            if (cleanup) cleanup();
            return $fd05d31532de2fc2$export$dae85862a8d94378(source, instance, 3, [
                onCleanup
            ]);
        };
    } else getter = (0, $hLodm.NOOP);
    if (cb && deep) {
        var baseGetter = getter;
        getter = function() {
            return $fd05d31532de2fc2$var$traverse(baseGetter());
        };
    }
    var cleanup;
    var onCleanup = function(fn) {
        cleanup = effect.onStop = function() {
            $fd05d31532de2fc2$export$b22fcaf88446e9bf(fn, instance, 4);
        };
    };
    var ssrCleanup;
    if ($fd05d31532de2fc2$var$isInSSRComponentSetup) {
        onCleanup = (0, $hLodm.NOOP);
        if (!cb) getter();
        else if (immediate) $fd05d31532de2fc2$export$dae85862a8d94378(cb, instance, 3, [
            getter(),
            isMultiSource ? [] : void 0,
            onCleanup
        ]);
        if (flush === "sync") {
            var ctx = $fd05d31532de2fc2$export$6b1c54dc4befcda();
            ssrCleanup = ctx.__watcherHandles || (ctx.__watcherHandles = []);
        } else return 0, $hLodm.NOOP;
    }
    var oldValue = isMultiSource ? new Array(source.length).fill($fd05d31532de2fc2$var$INITIAL_WATCHER_VALUE) : $fd05d31532de2fc2$var$INITIAL_WATCHER_VALUE;
    var job = function() {
        if (!effect.active) return;
        if (cb) {
            var newValue = effect.run();
            if (deep || forceTrigger || (isMultiSource ? newValue.some(function(v1, i) {
                return (0, $hLodm.hasChanged)(v1, oldValue[i]);
            }) : (0, $hLodm.hasChanged)(newValue, oldValue)) || false) {
                if (cleanup) cleanup();
                $fd05d31532de2fc2$export$dae85862a8d94378(cb, instance, 3, [
                    newValue,
                    // pass undefined as the old value when it's changed for the first time
                    oldValue === $fd05d31532de2fc2$var$INITIAL_WATCHER_VALUE ? void 0 : isMultiSource && oldValue[0] === $fd05d31532de2fc2$var$INITIAL_WATCHER_VALUE ? [] : oldValue,
                    onCleanup
                ]);
                oldValue = newValue;
            }
        } else effect.run();
    };
    job.allowRecurse = !!cb;
    var scheduler;
    if (flush === "sync") scheduler = job;
    else if (flush === "post") scheduler = function() {
        return $fd05d31532de2fc2$var$queuePostRenderEffect(job, instance && instance.suspense);
    };
    else {
        job.pre = true;
        if (instance) job.id = instance.uid;
        scheduler = function() {
            return $fd05d31532de2fc2$var$queueJob(job);
        };
    }
    var effect = new (0, $yQ0Ka.ReactiveEffect)(getter, scheduler);
    if (cb) {
        if (immediate) job();
        else oldValue = effect.run();
    } else if (flush === "post") $fd05d31532de2fc2$var$queuePostRenderEffect(effect.run.bind(effect), instance && instance.suspense);
    else effect.run();
    var unwatch = function() {
        effect.stop();
        if (instance && instance.scope) (0, $hLodm.remove)(instance.scope.effects, effect);
    };
    if (ssrCleanup) ssrCleanup.push(unwatch);
    return unwatch;
}
function $fd05d31532de2fc2$var$instanceWatch(source, value1, options) {
    var publicThis = this.proxy;
    var getter = (0, $hLodm.isString)(source) ? source.includes(".") ? $fd05d31532de2fc2$var$createPathGetter(publicThis, source) : function() {
        return publicThis[source];
    } : source.bind(publicThis, publicThis);
    var cb;
    if ((0, $hLodm.isFunction)(value1)) cb = value1;
    else {
        cb = value1.handler;
        options = value1;
    }
    var cur = $fd05d31532de2fc2$var$currentInstance;
    $fd05d31532de2fc2$var$setCurrentInstance(this);
    var res = $fd05d31532de2fc2$var$doWatch(getter, cb.bind(publicThis), options);
    if (cur) $fd05d31532de2fc2$var$setCurrentInstance(cur);
    else $fd05d31532de2fc2$var$unsetCurrentInstance();
    return res;
}
function $fd05d31532de2fc2$var$createPathGetter(ctx, path) {
    var segments = path.split(".");
    return function() {
        var cur = ctx;
        for(var i = 0; i < segments.length && cur; i++)cur = cur[segments[i]];
        return cur;
    };
}
function $fd05d31532de2fc2$var$traverse(value1, seen) {
    if (!(0, $hLodm.isObject)(value1) || value1["__v_skip"]) return value1;
    seen = seen || /* @__PURE__ */ new Set();
    if (seen.has(value1)) return value1;
    seen.add(value1);
    if ((0, $yQ0Ka.isRef)(value1)) $fd05d31532de2fc2$var$traverse(value1.value, seen);
    else if ((0, $hLodm.isArray)(value1)) for(var i = 0; i < value1.length; i++)$fd05d31532de2fc2$var$traverse(value1[i], seen);
    else if ((0, $hLodm.isSet)(value1) || (0, $hLodm.isMap)(value1)) value1.forEach(function(v1) {
        $fd05d31532de2fc2$var$traverse(v1, seen);
    });
    else if ((0, $hLodm.isPlainObject)(value1)) for(var key in value1)$fd05d31532de2fc2$var$traverse(value1[key], seen);
    return value1;
}
function $fd05d31532de2fc2$var$validateDirectiveName(name) {
    if ((0, $hLodm.isBuiltInDirective)(name)) $fd05d31532de2fc2$export$c106dd0671a0fc2d("Do not use built-in directive ids as custom directive id: " + name);
}
function $fd05d31532de2fc2$export$49729353e7c1e6c5(vnode, directives) {
    var internalInstance = $fd05d31532de2fc2$var$currentRenderingInstance;
    if (internalInstance === null) return vnode;
    var instance = $fd05d31532de2fc2$var$getExposeProxy(internalInstance) || internalInstance.proxy;
    var bindings = vnode.dirs || (vnode.dirs = []);
    for(var i = 0; i < directives.length; i++){
        var _directives_i = (0, $cv9Rk._)(directives[i], 4), dir = _directives_i[0], value1 = _directives_i[1], arg = _directives_i[2], tmp = _directives_i[3], modifiers = tmp === void 0 ? (0, $hLodm.EMPTY_OBJ) : tmp;
        if (dir) {
            if ((0, $hLodm.isFunction)(dir)) dir = {
                mounted: dir,
                updated: dir
            };
            if (dir.deep) $fd05d31532de2fc2$var$traverse(value1);
            bindings.push({
                dir: dir,
                instance: instance,
                value: value1,
                oldValue: void 0,
                arg: arg,
                modifiers: modifiers
            });
        }
    }
    return vnode;
}
function $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, prevVNode, instance, name) {
    var bindings = vnode.dirs;
    var oldBindings = prevVNode && prevVNode.dirs;
    for(var i = 0; i < bindings.length; i++){
        var binding = bindings[i];
        if (oldBindings) binding.oldValue = oldBindings[i].value;
        var hook = binding.dir[name];
        if (hook) {
            (0, $yQ0Ka.pauseTracking)();
            $fd05d31532de2fc2$export$dae85862a8d94378(hook, instance, 8, [
                vnode.el,
                binding,
                vnode,
                prevVNode
            ]);
            (0, $yQ0Ka.resetTracking)();
        }
    }
}
function $fd05d31532de2fc2$export$d2a0a1bc267c90f6() {
    var state = {
        isMounted: false,
        isLeaving: false,
        isUnmounting: false,
        leavingVNodes: /* @__PURE__ */ new Map()
    };
    $fd05d31532de2fc2$export$6d1641039221b5cb(function() {
        state.isMounted = true;
    });
    $fd05d31532de2fc2$export$40c420df62d2614(function() {
        state.isUnmounting = true;
    });
    return state;
}
var $fd05d31532de2fc2$var$TransitionHookValidator = [
    Function,
    Array
];
var $fd05d31532de2fc2$export$b876c99684f8cf3b = {
    mode: String,
    appear: Boolean,
    persisted: Boolean,
    // enter
    onBeforeEnter: $fd05d31532de2fc2$var$TransitionHookValidator,
    onEnter: $fd05d31532de2fc2$var$TransitionHookValidator,
    onAfterEnter: $fd05d31532de2fc2$var$TransitionHookValidator,
    onEnterCancelled: $fd05d31532de2fc2$var$TransitionHookValidator,
    // leave
    onBeforeLeave: $fd05d31532de2fc2$var$TransitionHookValidator,
    onLeave: $fd05d31532de2fc2$var$TransitionHookValidator,
    onAfterLeave: $fd05d31532de2fc2$var$TransitionHookValidator,
    onLeaveCancelled: $fd05d31532de2fc2$var$TransitionHookValidator,
    // appear
    onBeforeAppear: $fd05d31532de2fc2$var$TransitionHookValidator,
    onAppear: $fd05d31532de2fc2$var$TransitionHookValidator,
    onAfterAppear: $fd05d31532de2fc2$var$TransitionHookValidator,
    onAppearCancelled: $fd05d31532de2fc2$var$TransitionHookValidator
};
var $fd05d31532de2fc2$var$BaseTransitionImpl = {
    name: "BaseTransition",
    props: $fd05d31532de2fc2$export$b876c99684f8cf3b,
    setup: function(props, param) {
        var slots = param.slots;
        var instance = $fd05d31532de2fc2$export$f13e630aa3915748();
        var state = $fd05d31532de2fc2$export$d2a0a1bc267c90f6();
        var prevTransitionKey;
        return function() {
            var children = slots.default && $fd05d31532de2fc2$export$a67f9b1229c7c97a(slots.default(), true);
            if (!children || !children.length) return;
            var child = children[0];
            if (children.length > 1) {
                var hasFound = false;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var c = _step.value;
                        if (c.type !== $fd05d31532de2fc2$export$4d299b491347818a) {
                            child = c;
                            hasFound = true;
                            break;
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            var rawProps = (0, $yQ0Ka.toRaw)(props);
            var mode = rawProps.mode;
            if (state.isLeaving) return $fd05d31532de2fc2$var$emptyPlaceholder(child);
            var innerChild = $fd05d31532de2fc2$var$getKeepAliveChild(child);
            if (!innerChild) return $fd05d31532de2fc2$var$emptyPlaceholder(child);
            var enterHooks = $fd05d31532de2fc2$export$76ac1779589cd824(innerChild, rawProps, state, instance);
            $fd05d31532de2fc2$export$7770a22486565649(innerChild, enterHooks);
            var oldChild = instance.subTree;
            var oldInnerChild = oldChild && $fd05d31532de2fc2$var$getKeepAliveChild(oldChild);
            var transitionKeyChanged = false;
            var getTransitionKey = innerChild.type.getTransitionKey;
            if (getTransitionKey) {
                var key = getTransitionKey();
                if (prevTransitionKey === void 0) prevTransitionKey = key;
                else if (key !== prevTransitionKey) {
                    prevTransitionKey = key;
                    transitionKeyChanged = true;
                }
            }
            if (oldInnerChild && oldInnerChild.type !== $fd05d31532de2fc2$export$4d299b491347818a && (!$fd05d31532de2fc2$var$isSameVNodeType(innerChild, oldInnerChild) || transitionKeyChanged)) {
                var leavingHooks = $fd05d31532de2fc2$export$76ac1779589cd824(oldInnerChild, rawProps, state, instance);
                $fd05d31532de2fc2$export$7770a22486565649(oldInnerChild, leavingHooks);
                if (mode === "out-in") {
                    state.isLeaving = true;
                    leavingHooks.afterLeave = function() {
                        state.isLeaving = false;
                        if (instance.update.active !== false) instance.update();
                    };
                    return $fd05d31532de2fc2$var$emptyPlaceholder(child);
                } else if (mode === "in-out" && innerChild.type !== $fd05d31532de2fc2$export$4d299b491347818a) leavingHooks.delayLeave = function(el, earlyRemove, delayedLeave) {
                    var leavingVNodesCache = $fd05d31532de2fc2$var$getLeavingNodesForType(state, oldInnerChild);
                    leavingVNodesCache[String(oldInnerChild.key)] = oldInnerChild;
                    el._leaveCb = function() {
                        earlyRemove();
                        el._leaveCb = void 0;
                        delete enterHooks.delayedLeave;
                    };
                    enterHooks.delayedLeave = delayedLeave;
                };
            }
            return child;
        };
    }
};
var $fd05d31532de2fc2$export$abd95b5f5e8a8837 = $fd05d31532de2fc2$var$BaseTransitionImpl;
function $fd05d31532de2fc2$var$getLeavingNodesForType(state, vnode) {
    var leavingVNodes = state.leavingVNodes;
    var leavingVNodesCache = leavingVNodes.get(vnode.type);
    if (!leavingVNodesCache) {
        leavingVNodesCache = /* @__PURE__ */ Object.create(null);
        leavingVNodes.set(vnode.type, leavingVNodesCache);
    }
    return leavingVNodesCache;
}
function $fd05d31532de2fc2$export$76ac1779589cd824(vnode, props, state, instance) {
    var appear = props.appear, mode = props.mode, _props_persisted = props.persisted, persisted = _props_persisted === void 0 ? false : _props_persisted, onBeforeEnter = props.onBeforeEnter, onEnter = props.onEnter, onAfterEnter = props.onAfterEnter, onEnterCancelled = props.onEnterCancelled, onBeforeLeave = props.onBeforeLeave, onLeave = props.onLeave, onAfterLeave = props.onAfterLeave, onLeaveCancelled = props.onLeaveCancelled, onBeforeAppear = props.onBeforeAppear, onAppear = props.onAppear, onAfterAppear = props.onAfterAppear, onAppearCancelled = props.onAppearCancelled;
    var key = String(vnode.key);
    var leavingVNodesCache = $fd05d31532de2fc2$var$getLeavingNodesForType(state, vnode);
    var callHook = function(hook, args) {
        hook && $fd05d31532de2fc2$export$dae85862a8d94378(hook, instance, 9, args);
    };
    var callAsyncHook = function(hook, args) {
        var done = args[1];
        callHook(hook, args);
        if ((0, $hLodm.isArray)(hook)) {
            if (hook.every(function(hook2) {
                return hook2.length <= 1;
            })) done();
        } else if (hook.length <= 1) done();
    };
    var hooks = {
        mode: mode,
        persisted: persisted,
        beforeEnter: function(el) {
            var hook = onBeforeEnter;
            if (!state.isMounted) {
                if (appear) hook = onBeforeAppear || onBeforeEnter;
                else return;
            }
            if (el._leaveCb) el._leaveCb(true);
            var leavingVNode = leavingVNodesCache[key];
            if (leavingVNode && $fd05d31532de2fc2$var$isSameVNodeType(vnode, leavingVNode) && leavingVNode.el._leaveCb) leavingVNode.el._leaveCb();
            callHook(hook, [
                el
            ]);
        },
        enter: function(el) {
            var hook = onEnter;
            var afterHook = onAfterEnter;
            var cancelHook = onEnterCancelled;
            if (!state.isMounted) {
                if (appear) {
                    hook = onAppear || onEnter;
                    afterHook = onAfterAppear || onAfterEnter;
                    cancelHook = onAppearCancelled || onEnterCancelled;
                } else return;
            }
            var called = false;
            var done = el._enterCb = function(cancelled) {
                if (called) return;
                called = true;
                if (cancelled) callHook(cancelHook, [
                    el
                ]);
                else callHook(afterHook, [
                    el
                ]);
                if (hooks.delayedLeave) hooks.delayedLeave();
                el._enterCb = void 0;
            };
            if (hook) callAsyncHook(hook, [
                el,
                done
            ]);
            else done();
        },
        leave: function(el, remove) {
            var key2 = String(vnode.key);
            if (el._enterCb) el._enterCb(true);
            if (state.isUnmounting) return remove();
            callHook(onBeforeLeave, [
                el
            ]);
            var called = false;
            var done = el._leaveCb = function(cancelled) {
                if (called) return;
                called = true;
                remove();
                if (cancelled) callHook(onLeaveCancelled, [
                    el
                ]);
                else callHook(onAfterLeave, [
                    el
                ]);
                el._leaveCb = void 0;
                if (leavingVNodesCache[key2] === vnode) delete leavingVNodesCache[key2];
            };
            leavingVNodesCache[key2] = vnode;
            if (onLeave) callAsyncHook(onLeave, [
                el,
                done
            ]);
            else done();
        },
        clone: function(vnode2) {
            return $fd05d31532de2fc2$export$76ac1779589cd824(vnode2, props, state, instance);
        }
    };
    return hooks;
}
function $fd05d31532de2fc2$var$emptyPlaceholder(vnode) {
    if ($fd05d31532de2fc2$var$isKeepAlive(vnode)) {
        vnode = $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(vnode);
        vnode.children = null;
        return vnode;
    }
}
function $fd05d31532de2fc2$var$getKeepAliveChild(vnode) {
    return $fd05d31532de2fc2$var$isKeepAlive(vnode) ? vnode.children ? vnode.children[0] : void 0 : vnode;
}
function $fd05d31532de2fc2$export$7770a22486565649(vnode, hooks) {
    if (vnode.shapeFlag & 6 && vnode.component) $fd05d31532de2fc2$export$7770a22486565649(vnode.component.subTree, hooks);
    else if (vnode.shapeFlag & 128) {
        vnode.ssContent.transition = hooks.clone(vnode.ssContent);
        vnode.ssFallback.transition = hooks.clone(vnode.ssFallback);
    } else vnode.transition = hooks;
}
function $fd05d31532de2fc2$export$a67f9b1229c7c97a(children) {
    var keepComment = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, parentKey = arguments.length > 2 ? arguments[2] : void 0;
    var ret = [];
    var keyedFragmentCount = 0;
    for(var i = 0; i < children.length; i++){
        var child = children[i];
        var key = parentKey == null ? child.key : String(parentKey) + String(child.key != null ? child.key : i);
        if (child.type === $fd05d31532de2fc2$export$ffb0004e005737fa) {
            if (child.patchFlag & 128) keyedFragmentCount++;
            ret = ret.concat($fd05d31532de2fc2$export$a67f9b1229c7c97a(child.children, keepComment, key));
        } else if (keepComment || child.type !== $fd05d31532de2fc2$export$4d299b491347818a) ret.push(key != null ? $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(child, {
            key: key
        }) : child);
    }
    if (keyedFragmentCount > 1) for(var i1 = 0; i1 < ret.length; i1++)ret[i1].patchFlag = -2;
    return ret;
}
function $fd05d31532de2fc2$export$afa64b67e5a01c3b(options, extraOptions) {
    return (0, $hLodm.isFunction)(options) ? // #8326: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    /* @__PURE__ */ function() {
        return (0, $hLodm.extend)({
            name: options.name
        }, extraOptions, {
            setup: options
        });
    }() : options;
}
var $fd05d31532de2fc2$var$isAsyncWrapper = function(i) {
    return !!i.type.__asyncLoader;
};
function $fd05d31532de2fc2$export$d75d499b4c16cf21(source) {
    if ((0, $hLodm.isFunction)(source)) source = {
        loader: source
    };
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _source_delay = source.delay, delay = _source_delay === void 0 ? 200 : _source_delay, timeout = source.timeout, _source_suspensible = source.// undefined = never times out
    suspensible, suspensible = _source_suspensible === void 0 ? true : _source_suspensible, userOnError = source.onError;
    var pendingRequest = null;
    var resolvedComp;
    var retries = 0;
    var retry = function() {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function() {
        var thisRequest;
        return pendingRequest || (thisRequest = pendingRequest = loader().catch(function(err) {
            err = err instanceof Error ? err : new Error(String(err));
            if (userOnError) return new Promise(function(resolve, reject) {
                var userRetry = function() {
                    return resolve(retry());
                };
                var userFail = function() {
                    return reject(err);
                };
                userOnError(err, userRetry, userFail, retries + 1);
            });
            else throw err;
        }).then(function(comp) {
            if (thisRequest !== pendingRequest && pendingRequest) return pendingRequest;
            if (comp && (comp.__esModule || comp[Symbol.toStringTag] === "Module")) comp = comp.default;
            resolvedComp = comp;
            return comp;
        }));
    };
    return $fd05d31532de2fc2$export$afa64b67e5a01c3b({
        name: "AsyncComponentWrapper",
        __asyncLoader: load,
        get __asyncResolved () {
            return resolvedComp;
        },
        setup: function() {
            var instance = $fd05d31532de2fc2$var$currentInstance;
            if (resolvedComp) return function() {
                return $fd05d31532de2fc2$var$createInnerComp(resolvedComp, instance);
            };
            var onError = function(err) {
                pendingRequest = null;
                $fd05d31532de2fc2$export$d3da1ecaf1206c58(err, instance, 13, !errorComponent);
            };
            if (suspensible && instance.suspense || $fd05d31532de2fc2$var$isInSSRComponentSetup) return load().then(function(comp) {
                return function() {
                    return $fd05d31532de2fc2$var$createInnerComp(comp, instance);
                };
            }).catch(function(err) {
                onError(err);
                return function() {
                    return errorComponent ? $fd05d31532de2fc2$export$bf5c4cf060303d58(errorComponent, {
                        error: err
                    }) : null;
                };
            });
            var loaded = (0, $yQ0Ka.ref)(false);
            var error = (0, $yQ0Ka.ref)();
            var delayed = (0, $yQ0Ka.ref)(!!delay);
            if (delay) setTimeout(function() {
                delayed.value = false;
            }, delay);
            if (timeout != null) setTimeout(function() {
                if (!loaded.value && !error.value) {
                    var err = new Error("Async component timed out after ".concat(timeout, "ms."));
                    onError(err);
                    error.value = err;
                }
            }, timeout);
            load().then(function() {
                loaded.value = true;
                if (instance.parent && $fd05d31532de2fc2$var$isKeepAlive(instance.parent.vnode)) $fd05d31532de2fc2$var$queueJob(instance.parent.update);
            }).catch(function(err) {
                onError(err);
                error.value = err;
            });
            return function() {
                if (loaded.value && resolvedComp) return $fd05d31532de2fc2$var$createInnerComp(resolvedComp, instance);
                else if (error.value && errorComponent) return $fd05d31532de2fc2$export$bf5c4cf060303d58(errorComponent, {
                    error: error.value
                });
                else if (loadingComponent && !delayed.value) return $fd05d31532de2fc2$export$bf5c4cf060303d58(loadingComponent);
            };
        }
    });
}
function $fd05d31532de2fc2$var$createInnerComp(comp, parent) {
    var _parent_vnode = parent.vnode, ref2 = _parent_vnode.ref, props = _parent_vnode.props, children = _parent_vnode.children, ce = _parent_vnode.ce;
    var vnode = $fd05d31532de2fc2$export$bf5c4cf060303d58(comp, props, children);
    vnode.ref = ref2;
    vnode.ce = ce;
    delete parent.vnode.ce;
    return vnode;
}
var $fd05d31532de2fc2$var$isKeepAlive = function(vnode) {
    return vnode.type.__isKeepAlive;
};
var $fd05d31532de2fc2$var$KeepAliveImpl = {
    name: "KeepAlive",
    // Marker for special handling inside the renderer. We are not using a ===
    // check directly on KeepAlive in the renderer, because importing it directly
    // would prevent it from being tree-shaken.
    __isKeepAlive: true,
    props: {
        include: [
            String,
            RegExp,
            Array
        ],
        exclude: [
            String,
            RegExp,
            Array
        ],
        max: [
            String,
            Number
        ]
    },
    setup: function(props, param) {
        var slots = param.slots;
        var unmount = function unmount(vnode) {
            $fd05d31532de2fc2$var$resetShapeFlag(vnode);
            _unmount(vnode, instance, parentSuspense, true);
        };
        var pruneCache = function pruneCache(filter) {
            cache.forEach(function(vnode, key) {
                var name = $fd05d31532de2fc2$var$getComponentName(vnode.type);
                if (name && (!filter || !filter(name))) pruneCacheEntry(key);
            });
        };
        var pruneCacheEntry = function pruneCacheEntry(key) {
            var cached = cache.get(key);
            if (!current || !$fd05d31532de2fc2$var$isSameVNodeType(cached, current)) unmount(cached);
            else if (current) $fd05d31532de2fc2$var$resetShapeFlag(current);
            cache.delete(key);
            keys.delete(key);
        };
        var instance = $fd05d31532de2fc2$export$f13e630aa3915748();
        var sharedContext = instance.ctx;
        if (!sharedContext.renderer) return function() {
            var children = slots.default && slots.default();
            return children && children.length === 1 ? children[0] : children;
        };
        var cache = /* @__PURE__ */ new Map();
        var keys = /* @__PURE__ */ new Set();
        var current = null;
        if (__VUE_PROD_DEVTOOLS__) instance.__v_cache = cache;
        var parentSuspense = instance.suspense;
        var _sharedContext_renderer = sharedContext.renderer, patch = _sharedContext_renderer.p, move = _sharedContext_renderer.m, _unmount = _sharedContext_renderer.um, createElement = _sharedContext_renderer.o.createElement;
        var storageContainer = createElement("div");
        sharedContext.activate = function(vnode, container, anchor, isSVG, optimized) {
            var instance2 = vnode.component;
            move(vnode, container, anchor, 0, parentSuspense);
            patch(instance2.vnode, vnode, container, anchor, instance2, parentSuspense, isSVG, vnode.slotScopeIds, optimized);
            $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
                instance2.isDeactivated = false;
                if (instance2.a) (0, $hLodm.invokeArrayFns)(instance2.a);
                var vnodeHook = vnode.props && vnode.props.onVnodeMounted;
                if (vnodeHook) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsComponentAdded(instance2);
        };
        sharedContext.deactivate = function(vnode) {
            var instance2 = vnode.component;
            move(vnode, storageContainer, null, 1, parentSuspense);
            $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
                if (instance2.da) (0, $hLodm.invokeArrayFns)(instance2.da);
                var vnodeHook = vnode.props && vnode.props.onVnodeUnmounted;
                if (vnodeHook) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, instance2.parent, vnode);
                instance2.isDeactivated = true;
            }, parentSuspense);
            if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsComponentAdded(instance2);
        };
        $fd05d31532de2fc2$export$3db5d71bdb2d5499(function() {
            return [
                props.include,
                props.exclude
            ];
        }, function(param) {
            var _param = (0, $cv9Rk._)(param, 2), include = _param[0], exclude = _param[1];
            include && pruneCache(function(name) {
                return $fd05d31532de2fc2$var$matches(include, name);
            });
            exclude && pruneCache(function(name) {
                return !$fd05d31532de2fc2$var$matches(exclude, name);
            });
        }, // prune post-render after `current` has been updated
        {
            flush: "post",
            deep: true
        });
        var pendingCacheKey = null;
        var cacheSubtree = function() {
            if (pendingCacheKey != null) cache.set(pendingCacheKey, $fd05d31532de2fc2$var$getInnerChild(instance.subTree));
        };
        $fd05d31532de2fc2$export$6d1641039221b5cb(cacheSubtree);
        $fd05d31532de2fc2$export$5876c47052fb88b1(cacheSubtree);
        $fd05d31532de2fc2$export$40c420df62d2614(function() {
            cache.forEach(function(cached) {
                var subTree = instance.subTree, suspense = instance.suspense;
                var vnode = $fd05d31532de2fc2$var$getInnerChild(subTree);
                if (cached.type === vnode.type && cached.key === vnode.key) {
                    $fd05d31532de2fc2$var$resetShapeFlag(vnode);
                    var da = vnode.component.da;
                    da && $fd05d31532de2fc2$var$queuePostRenderEffect(da, suspense);
                    return;
                }
                unmount(cached);
            });
        });
        return function() {
            pendingCacheKey = null;
            if (!slots.default) return null;
            var children = slots.default();
            var rawVNode = children[0];
            if (children.length > 1) {
                current = null;
                return children;
            } else if (!$fd05d31532de2fc2$export$3868d13f8734ae81(rawVNode) || !(rawVNode.shapeFlag & 4) && !(rawVNode.shapeFlag & 128)) {
                current = null;
                return rawVNode;
            }
            var vnode = $fd05d31532de2fc2$var$getInnerChild(rawVNode);
            var comp = vnode.type;
            var name = $fd05d31532de2fc2$var$getComponentName($fd05d31532de2fc2$var$isAsyncWrapper(vnode) ? vnode.type.__asyncResolved || {} : comp);
            var include = props.include, exclude = props.exclude, max = props.max;
            if (include && (!name || !$fd05d31532de2fc2$var$matches(include, name)) || exclude && name && $fd05d31532de2fc2$var$matches(exclude, name)) {
                current = vnode;
                return rawVNode;
            }
            var key = vnode.key == null ? comp : vnode.key;
            var cachedVNode = cache.get(key);
            if (vnode.el) {
                vnode = $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(vnode);
                if (rawVNode.shapeFlag & 128) rawVNode.ssContent = vnode;
            }
            pendingCacheKey = key;
            if (cachedVNode) {
                vnode.el = cachedVNode.el;
                vnode.component = cachedVNode.component;
                if (vnode.transition) $fd05d31532de2fc2$export$7770a22486565649(vnode, vnode.transition);
                vnode.shapeFlag |= 512;
                keys.delete(key);
                keys.add(key);
            } else {
                keys.add(key);
                if (max && keys.size > parseInt(max, 10)) pruneCacheEntry(keys.values().next().value);
            }
            vnode.shapeFlag |= 256;
            current = vnode;
            return $fd05d31532de2fc2$var$isSuspense(rawVNode.type) ? rawVNode : vnode;
        };
    }
};
var $fd05d31532de2fc2$export$70eb8a58709972df = $fd05d31532de2fc2$var$KeepAliveImpl;
function $fd05d31532de2fc2$var$matches(pattern, name) {
    if ((0, $hLodm.isArray)(pattern)) return pattern.some(function(p) {
        return $fd05d31532de2fc2$var$matches(p, name);
    });
    else if ((0, $hLodm.isString)(pattern)) return pattern.split(",").includes(name);
    else if ((0, $hLodm.isRegExp)(pattern)) return pattern.test(name);
    return false;
}
function $fd05d31532de2fc2$export$ba52d824b95a2154(hook, target) {
    $fd05d31532de2fc2$var$registerKeepAliveHook(hook, "a", target);
}
function $fd05d31532de2fc2$export$bf1440eeaf5fa709(hook, target) {
    $fd05d31532de2fc2$var$registerKeepAliveHook(hook, "da", target);
}
function $fd05d31532de2fc2$var$registerKeepAliveHook(hook, type) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $fd05d31532de2fc2$var$currentInstance;
    var wrappedHook = hook.__wdc || (hook.__wdc = function() {
        var current = target;
        while(current){
            if (current.isDeactivated) return;
            current = current.parent;
        }
        return hook();
    });
    $fd05d31532de2fc2$var$injectHook(type, wrappedHook, target);
    if (target) {
        var current = target.parent;
        while(current && current.parent){
            if ($fd05d31532de2fc2$var$isKeepAlive(current.parent.vnode)) $fd05d31532de2fc2$var$injectToKeepAliveRoot(wrappedHook, type, target, current);
            current = current.parent;
        }
    }
}
function $fd05d31532de2fc2$var$injectToKeepAliveRoot(hook, type, target, keepAliveRoot) {
    var injected = $fd05d31532de2fc2$var$injectHook(type, hook, keepAliveRoot, true);
    $fd05d31532de2fc2$export$13348a43ccacfe58(function() {
        (0, $hLodm.remove)(keepAliveRoot[type], injected);
    }, target);
}
function $fd05d31532de2fc2$var$resetShapeFlag(vnode) {
    vnode.shapeFlag &= -257;
    vnode.shapeFlag &= -513;
}
function $fd05d31532de2fc2$var$getInnerChild(vnode) {
    return vnode.shapeFlag & 128 ? vnode.ssContent : vnode;
}
function $fd05d31532de2fc2$var$injectHook(type, hook) {
    var target = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $fd05d31532de2fc2$var$currentInstance, prepend = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    if (target) {
        var hooks = target[type] || (target[type] = []);
        var wrappedHook = hook.__weh || (hook.__weh = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            if (target.isUnmounted) return;
            (0, $yQ0Ka.pauseTracking)();
            $fd05d31532de2fc2$var$setCurrentInstance(target);
            var res = $fd05d31532de2fc2$export$dae85862a8d94378(hook, target, type, args);
            $fd05d31532de2fc2$var$unsetCurrentInstance();
            (0, $yQ0Ka.resetTracking)();
            return res;
        });
        if (prepend) hooks.unshift(wrappedHook);
        else hooks.push(wrappedHook);
        return wrappedHook;
    }
}
var $fd05d31532de2fc2$var$createHook = function(lifecycle) {
    return function(hook) {
        var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fd05d31532de2fc2$var$currentInstance;
        return(// post-create lifecycle registrations are noops during SSR (except for serverPrefetch)
        (!$fd05d31532de2fc2$var$isInSSRComponentSetup || lifecycle === "sp") && $fd05d31532de2fc2$var$injectHook(lifecycle, function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return hook.apply(void 0, (0, $c6Xmf._)(args));
        }, target));
    };
};
var $fd05d31532de2fc2$export$23b7aeb0d671f804 = $fd05d31532de2fc2$var$createHook("bm");
var $fd05d31532de2fc2$export$6d1641039221b5cb = $fd05d31532de2fc2$var$createHook("m");
var $fd05d31532de2fc2$export$ab91988a13872e4c = $fd05d31532de2fc2$var$createHook("bu");
var $fd05d31532de2fc2$export$5876c47052fb88b1 = $fd05d31532de2fc2$var$createHook("u");
var $fd05d31532de2fc2$export$40c420df62d2614 = $fd05d31532de2fc2$var$createHook("bum");
var $fd05d31532de2fc2$export$13348a43ccacfe58 = $fd05d31532de2fc2$var$createHook("um");
var $fd05d31532de2fc2$export$ebf0c601f267bceb = $fd05d31532de2fc2$var$createHook("sp");
var $fd05d31532de2fc2$export$898295a813d662eb = $fd05d31532de2fc2$var$createHook("rtg");
var $fd05d31532de2fc2$export$2b41f4235363e921 = $fd05d31532de2fc2$var$createHook("rtc");
function $fd05d31532de2fc2$export$6a3a15856e50ad19(hook) {
    var target = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $fd05d31532de2fc2$var$currentInstance;
    $fd05d31532de2fc2$var$injectHook("ec", hook, target);
}
var $fd05d31532de2fc2$var$COMPONENTS = "components";
var $fd05d31532de2fc2$var$DIRECTIVES = "directives";
function $fd05d31532de2fc2$export$681d65eec9d1d1e8(name, maybeSelfReference) {
    return $fd05d31532de2fc2$var$resolveAsset($fd05d31532de2fc2$var$COMPONENTS, name, true, maybeSelfReference) || name;
}
var $fd05d31532de2fc2$var$NULL_DYNAMIC_COMPONENT = Symbol.for("v-ndc");
function $fd05d31532de2fc2$export$b44c564a05ca975(component) {
    if ((0, $hLodm.isString)(component)) return $fd05d31532de2fc2$var$resolveAsset($fd05d31532de2fc2$var$COMPONENTS, component, false) || component;
    else return component || $fd05d31532de2fc2$var$NULL_DYNAMIC_COMPONENT;
}
function $fd05d31532de2fc2$export$a1989e995cd481be(name) {
    return $fd05d31532de2fc2$var$resolveAsset($fd05d31532de2fc2$var$DIRECTIVES, name);
}
function $fd05d31532de2fc2$var$resolveAsset(type, name) {
    var warnMissing = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, maybeSelfReference = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var instance = $fd05d31532de2fc2$var$currentRenderingInstance || $fd05d31532de2fc2$var$currentInstance;
    if (instance) {
        var Component = instance.type;
        if (type === $fd05d31532de2fc2$var$COMPONENTS) {
            var selfName = $fd05d31532de2fc2$var$getComponentName(Component, false);
            if (selfName && (selfName === name || selfName === (0, $hLodm.camelize)(name) || selfName === (0, $hLodm.capitalize)((0, $hLodm.camelize)(name)))) return Component;
        }
        var res = // local registration
        // check instance[type] first which is resolved for options API
        $fd05d31532de2fc2$var$resolve(instance[type] || Component[type], name) || // global registration
        $fd05d31532de2fc2$var$resolve(instance.appContext[type], name);
        if (!res && maybeSelfReference) return Component;
        return res;
    }
}
function $fd05d31532de2fc2$var$resolve(registry, name) {
    return registry && (registry[name] || registry[(0, $hLodm.camelize)(name)] || registry[(0, $hLodm.capitalize)((0, $hLodm.camelize)(name))]);
}
function $fd05d31532de2fc2$export$4bf387f59bfc6d67(source, renderItem, cache, index) {
    var ret;
    var cached = cache && cache[index];
    if ((0, $hLodm.isArray)(source) || (0, $hLodm.isString)(source)) {
        ret = new Array(source.length);
        for(var i = 0, l = source.length; i < l; i++)ret[i] = renderItem(source[i], i, void 0, cached && cached[i]);
    } else if (typeof source === "number") {
        ret = new Array(source);
        for(var i1 = 0; i1 < source; i1++)ret[i1] = renderItem(i1 + 1, i1, void 0, cached && cached[i1]);
    } else if ((0, $hLodm.isObject)(source)) {
        if (source[Symbol.iterator]) ret = Array.from(source, function(item, i) {
            return renderItem(item, i, void 0, cached && cached[i]);
        });
        else {
            var keys = Object.keys(source);
            ret = new Array(keys.length);
            for(var i2 = 0, l1 = keys.length; i2 < l1; i2++){
                var key = keys[i2];
                ret[i2] = renderItem(source[key], key, i2, cached && cached[i2]);
            }
        }
    } else ret = [];
    if (cache) cache[index] = ret;
    return ret;
}
function $fd05d31532de2fc2$export$85738f8fcd0a5430(slots, dynamicSlots) {
    var _loop = function(i) {
        var slot = dynamicSlots[i];
        if ((0, $hLodm.isArray)(slot)) for(var j = 0; j < slot.length; j++)slots[slot[j].name] = slot[j].fn;
        else if (slot) slots[slot.name] = slot.key ? function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _slot;
            var res = (_slot = slot).fn.apply(_slot, (0, $c6Xmf._)(args));
            if (res) res.key = slot.key;
            return res;
        } : slot.fn;
    };
    for(var i = 0; i < dynamicSlots.length; i++)_loop(i);
    return slots;
}
function $fd05d31532de2fc2$export$4abee4c34694ada1(slots, name) {
    var props = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, fallback = arguments.length > 3 ? arguments[3] : void 0, noSlotted = arguments.length > 4 ? arguments[4] : void 0;
    if ($fd05d31532de2fc2$var$currentRenderingInstance.isCE || $fd05d31532de2fc2$var$currentRenderingInstance.parent && $fd05d31532de2fc2$var$isAsyncWrapper($fd05d31532de2fc2$var$currentRenderingInstance.parent) && $fd05d31532de2fc2$var$currentRenderingInstance.parent.isCE) {
        if (name !== "default") props.name = name;
        return $fd05d31532de2fc2$export$bf5c4cf060303d58("slot", props, fallback && fallback());
    }
    var slot = slots[name];
    if (slot && slot._c) slot._d = false;
    $fd05d31532de2fc2$export$e7eaa45e502fe5cc();
    var validSlotContent = slot && $fd05d31532de2fc2$var$ensureValidVNode(slot(props));
    var rendered = $fd05d31532de2fc2$export$9f2dfe8048dfb22b($fd05d31532de2fc2$export$ffb0004e005737fa, {
        key: props.key || // slot content array of a dynamic conditional slot may have a branch
        // key attached in the `createSlots` helper, respect that
        validSlotContent && validSlotContent.key || "_".concat(name)
    }, validSlotContent || (fallback ? fallback() : []), validSlotContent && slots._ === 1 ? 64 : -2);
    if (!noSlotted && rendered.scopeId) rendered.slotScopeIds = [
        rendered.scopeId + "-s"
    ];
    if (slot && slot._c) slot._d = true;
    return rendered;
}
function $fd05d31532de2fc2$var$ensureValidVNode(vnodes) {
    return vnodes.some(function(child) {
        if (!$fd05d31532de2fc2$export$3868d13f8734ae81(child)) return true;
        if (child.type === $fd05d31532de2fc2$export$4d299b491347818a) return false;
        if (child.type === $fd05d31532de2fc2$export$ffb0004e005737fa && !$fd05d31532de2fc2$var$ensureValidVNode(child.children)) return false;
        return true;
    }) ? vnodes : null;
}
function $fd05d31532de2fc2$export$2fb94ff667a6a1a(obj, preserveCaseIfNecessary) {
    var ret = {};
    for(var key in obj)ret[preserveCaseIfNecessary && /[A-Z]/.test(key) ? "on:".concat(key) : (0, $hLodm.toHandlerKey)(key)] = obj[key];
    return ret;
}
var $fd05d31532de2fc2$var$getPublicInstance = function(i) {
    if (!i) return null;
    if ($fd05d31532de2fc2$var$isStatefulComponent(i)) return $fd05d31532de2fc2$var$getExposeProxy(i) || i.proxy;
    return $fd05d31532de2fc2$var$getPublicInstance(i.parent);
};
var $fd05d31532de2fc2$var$publicPropertiesMap = // Move PURE marker to new line to workaround compiler discarding it
// due to type annotation
/* @__PURE__ */ (0, $hLodm.extend)(/* @__PURE__ */ Object.create(null), {
    $: function(i) {
        return i;
    },
    $el: function(i) {
        return i.vnode.el;
    },
    $data: function(i) {
        return i.data;
    },
    $props: function(i) {
        return 0, i.props;
    },
    $attrs: function(i) {
        return 0, i.attrs;
    },
    $slots: function(i) {
        return 0, i.slots;
    },
    $refs: function(i) {
        return 0, i.refs;
    },
    $parent: function(i) {
        return $fd05d31532de2fc2$var$getPublicInstance(i.parent);
    },
    $root: function(i) {
        return $fd05d31532de2fc2$var$getPublicInstance(i.root);
    },
    $emit: function(i) {
        return i.emit;
    },
    $options: function(i) {
        return __VUE_OPTIONS_API__ ? $fd05d31532de2fc2$var$resolveMergedOptions(i) : i.type;
    },
    $forceUpdate: function(i) {
        return i.f || (i.f = function() {
            return $fd05d31532de2fc2$var$queueJob(i.update);
        });
    },
    $nextTick: function(i) {
        return i.n || (i.n = $fd05d31532de2fc2$export$bdd553fddd433dcb.bind(i.proxy));
    },
    $watch: function(i) {
        return __VUE_OPTIONS_API__ ? $fd05d31532de2fc2$var$instanceWatch.bind(i) : (0, $hLodm.NOOP);
    }
});
var $fd05d31532de2fc2$var$isReservedPrefix = function(key) {
    return key === "_" || key === "$";
};
var $fd05d31532de2fc2$var$hasSetupBinding = function(state, key) {
    return state !== (0, $hLodm.EMPTY_OBJ) && !state.__isScriptSetup && (0, $hLodm.hasOwn)(state, key);
};
var $fd05d31532de2fc2$var$_obj1;
var $fd05d31532de2fc2$var$PublicInstanceProxyHandlers = ($fd05d31532de2fc2$var$_obj1 = {
    get: function(param, key) {
        var instance = param._;
        var ctx = instance.ctx, setupState = instance.setupState, data = instance.data, props = instance.props, accessCache = instance.accessCache, type = instance.type, appContext = instance.appContext;
        var normalizedProps;
        if (key[0] !== "$") {
            var n = accessCache[key];
            if (n !== void 0) switch(n){
                case 1 /* SETUP */ :
                    return setupState[key];
                case 2 /* DATA */ :
                    return data[key];
                case 4 /* CONTEXT */ :
                    return ctx[key];
                case 3 /* PROPS */ :
                    return props[key];
            }
            else if ($fd05d31532de2fc2$var$hasSetupBinding(setupState, key)) {
                accessCache[key] = 1 /* SETUP */ ;
                return setupState[key];
            } else if (data !== (0, $hLodm.EMPTY_OBJ) && (0, $hLodm.hasOwn)(data, key)) {
                accessCache[key] = 2 /* DATA */ ;
                return data[key];
            } else if (// only cache other properties when instance has declared (thus stable)
            // props
            (normalizedProps = instance.propsOptions[0]) && (0, $hLodm.hasOwn)(normalizedProps, key)) {
                accessCache[key] = 3 /* PROPS */ ;
                return props[key];
            } else if (ctx !== (0, $hLodm.EMPTY_OBJ) && (0, $hLodm.hasOwn)(ctx, key)) {
                accessCache[key] = 4 /* CONTEXT */ ;
                return ctx[key];
            } else if (!__VUE_OPTIONS_API__ || $fd05d31532de2fc2$var$shouldCacheAccess) accessCache[key] = 0 /* OTHER */ ;
        }
        var publicGetter = $fd05d31532de2fc2$var$publicPropertiesMap[key];
        var cssModule, globalProperties;
        if (publicGetter) {
            if (key === "$attrs") (0, $yQ0Ka.track)(instance, "get", key);
            return publicGetter(instance);
        } else if (// css module (injected by vue-loader)
        (cssModule = type.__cssModules) && (cssModule = cssModule[key])) return cssModule;
        else if (ctx !== (0, $hLodm.EMPTY_OBJ) && (0, $hLodm.hasOwn)(ctx, key)) {
            accessCache[key] = 4 /* CONTEXT */ ;
            return ctx[key];
        } else if (// global properties
        globalProperties = appContext.config.globalProperties, (0, $hLodm.hasOwn)(globalProperties, key)) return globalProperties[key];
    }
}, (0, $3sHb8._)($fd05d31532de2fc2$var$_obj1, "set", function(param, key, value1) {
    var instance = param["_"];
    var data = instance.data, setupState = instance.setupState, ctx = instance.ctx;
    if ($fd05d31532de2fc2$var$hasSetupBinding(setupState, key)) {
        setupState[key] = value1;
        return true;
    } else {
        if (data !== (0, $hLodm.EMPTY_OBJ) && (0, $hLodm.hasOwn)(data, key)) {
            data[key] = value1;
            return true;
        } else if ((0, $hLodm.hasOwn)(instance.props, key)) return false;
    }
    if (key[0] === "$" && key.slice(1) in instance) return false;
    else ctx[key] = value1;
    return true;
}), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj1, "has", function(param, key) {
    var _param__ = param["_"], data = _param__.data, setupState = _param__.setupState, accessCache = _param__.accessCache, ctx = _param__.ctx, appContext = _param__.appContext, propsOptions = _param__.propsOptions;
    var normalizedProps;
    return !!accessCache[key] || data !== (0, $hLodm.EMPTY_OBJ) && (0, $hLodm.hasOwn)(data, key) || $fd05d31532de2fc2$var$hasSetupBinding(setupState, key) || (normalizedProps = propsOptions[0]) && (0, $hLodm.hasOwn)(normalizedProps, key) || (0, $hLodm.hasOwn)(ctx, key) || (0, $hLodm.hasOwn)($fd05d31532de2fc2$var$publicPropertiesMap, key) || (0, $hLodm.hasOwn)(appContext.config.globalProperties, key);
}), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj1, "defineProperty", function(target, key, descriptor) {
    if (descriptor.get != null) target._.accessCache[key] = 0;
    else if ((0, $hLodm.hasOwn)(descriptor, "value")) this.set(target, key, descriptor.value, null);
    return Reflect.defineProperty(target, key, descriptor);
}), $fd05d31532de2fc2$var$_obj1);
var $fd05d31532de2fc2$var$target;
var $fd05d31532de2fc2$var$RuntimeCompiledPublicInstanceProxyHandlers = /* @__PURE__ */ (0, $hLodm.extend)({}, $fd05d31532de2fc2$var$PublicInstanceProxyHandlers, {
    get: function(target, key) {
        if (key === Symbol.unscopables) return;
        return $fd05d31532de2fc2$var$PublicInstanceProxyHandlers.get(target, key, target);
    },
    has: function(_, key) {
        var has = key[0] !== "_" && !(0, $hLodm.isGloballyWhitelisted)(key);
        return has;
    }
});
function $fd05d31532de2fc2$var$createDevRenderContext(instance) {
    var target = {};
    Object.defineProperty(target, "_", {
        configurable: true,
        enumerable: false,
        get: function() {
            return instance;
        }
    });
    Object.keys($fd05d31532de2fc2$var$publicPropertiesMap).forEach(function(key) {
        Object.defineProperty(target, key, {
            configurable: true,
            enumerable: false,
            get: function() {
                return $fd05d31532de2fc2$var$publicPropertiesMap[key](instance);
            },
            // intercepted by the proxy so no need for implementation,
            // but needed to prevent set errors
            set: (0, $hLodm.NOOP)
        });
    });
    return target;
}
function $fd05d31532de2fc2$var$exposePropsOnRenderContext(instance) {
    var ctx = instance.ctx, _instance_propsOptions = (0, $cv9Rk._)(instance.propsOptions, 1), propsOptions = _instance_propsOptions[0];
    if (propsOptions) Object.keys(propsOptions).forEach(function(key) {
        Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return instance.props[key];
            },
            set: (0, $hLodm.NOOP)
        });
    });
}
function $fd05d31532de2fc2$var$exposeSetupStateOnRenderContext(instance) {
    var ctx = instance.ctx, setupState = instance.setupState;
    Object.keys((0, $yQ0Ka.toRaw)(setupState)).forEach(function(key) {
        if (!setupState.__isScriptSetup) {
            if ($fd05d31532de2fc2$var$isReservedPrefix(key[0])) {
                $fd05d31532de2fc2$export$c106dd0671a0fc2d("setup() return property ".concat(JSON.stringify(key), ' should not start with "$" or "_" which are reserved prefixes for Vue internals.'));
                return;
            }
            Object.defineProperty(ctx, key, {
                enumerable: true,
                configurable: true,
                get: function() {
                    return setupState[key];
                },
                set: (0, $hLodm.NOOP)
            });
        }
    });
}
var $fd05d31532de2fc2$var$warnRuntimeUsage = function(method) {
    return $fd05d31532de2fc2$export$c106dd0671a0fc2d("".concat(method, "() is a compiler-hint helper that is only usable inside <script setup> of a single file component. Its arguments should be compiled away and passing it at runtime has no effect."));
};
function $fd05d31532de2fc2$export$80b33eababae110e() {
    return null;
}
function $fd05d31532de2fc2$export$51ecece22fc17ddc() {
    return null;
}
function $fd05d31532de2fc2$export$da25b65ca24b518a(exposed) {}
function $fd05d31532de2fc2$export$77e79129327f3d0d(options) {}
function $fd05d31532de2fc2$export$1b3acd4bb805b712() {
    return null;
}
function $fd05d31532de2fc2$export$acd55aa037e791bb() {}
function $fd05d31532de2fc2$export$4df9c0969a9e0160(props, defaults) {
    return null;
}
function $fd05d31532de2fc2$export$9203a8e84125433c() {
    return $fd05d31532de2fc2$var$getContext().slots;
}
function $fd05d31532de2fc2$export$75e29435042cd2ea() {
    return $fd05d31532de2fc2$var$getContext().attrs;
}
function $fd05d31532de2fc2$export$fb78bd113157f1a1(props, name, options) {
    var i = $fd05d31532de2fc2$export$f13e630aa3915748();
    if (options && options.local) {
        var proxy = (0, $yQ0Ka.ref)(props[name]);
        $fd05d31532de2fc2$export$3db5d71bdb2d5499(function() {
            return props[name];
        }, function(v1) {
            return proxy.value = v1;
        });
        $fd05d31532de2fc2$export$3db5d71bdb2d5499(proxy, function(value1) {
            if (value1 !== props[name]) i.emit("update:".concat(name), value1);
        });
        return proxy;
    } else return {
        __v_isRef: true,
        get value () {
            return props[name];
        },
        set value (value){
            i.emit("update:".concat(name), value);
        }
    };
}
function $fd05d31532de2fc2$var$getContext() {
    var i = $fd05d31532de2fc2$export$f13e630aa3915748();
    return i.setupContext || (i.setupContext = $fd05d31532de2fc2$var$createSetupContext(i));
}
function $fd05d31532de2fc2$var$normalizePropsOrEmits(props) {
    return (0, $hLodm.isArray)(props) ? props.reduce(function(normalized, p) {
        return normalized[p] = null, normalized;
    }, {}) : props;
}
function $fd05d31532de2fc2$export$ec60f47d4a8a2e7f(raw, defaults) {
    var props = $fd05d31532de2fc2$var$normalizePropsOrEmits(raw);
    for(var key in defaults){
        if (key.startsWith("__skip")) continue;
        var opt = props[key];
        if (opt) {
            if ((0, $hLodm.isArray)(opt) || (0, $hLodm.isFunction)(opt)) opt = props[key] = {
                type: opt,
                default: defaults[key]
            };
            else opt.default = defaults[key];
        } else if (opt === null) opt = props[key] = {
            default: defaults[key]
        };
        if (opt && defaults["__skip_".concat(key)]) opt.skipFactory = true;
    }
    return props;
}
function $fd05d31532de2fc2$export$ad4f724f587e6828(a, b) {
    if (!a || !b) return a || b;
    if ((0, $hLodm.isArray)(a) && (0, $hLodm.isArray)(b)) return a.concat(b);
    return (0, $hLodm.extend)({}, $fd05d31532de2fc2$var$normalizePropsOrEmits(a), $fd05d31532de2fc2$var$normalizePropsOrEmits(b));
}
function $fd05d31532de2fc2$export$7c343e855c563faa(props, excludedKeys) {
    var _loop = function(key) {
        if (!excludedKeys.includes(key)) Object.defineProperty(ret, key, {
            enumerable: true,
            get: function() {
                return props[key];
            }
        });
    };
    var ret = {};
    for(var key in props)_loop(key);
    return ret;
}
function $fd05d31532de2fc2$export$d6d6f7369f1fb104(getAwaitable) {
    var ctx = $fd05d31532de2fc2$export$f13e630aa3915748();
    var awaitable = getAwaitable();
    $fd05d31532de2fc2$var$unsetCurrentInstance();
    if ((0, $hLodm.isPromise)(awaitable)) awaitable = awaitable.catch(function(e) {
        $fd05d31532de2fc2$var$setCurrentInstance(ctx);
        throw e;
    });
    return [
        awaitable,
        function() {
            return $fd05d31532de2fc2$var$setCurrentInstance(ctx);
        }
    ];
}
function $fd05d31532de2fc2$var$createDuplicateChecker() {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(type, key) {
        if (cache[key]) $fd05d31532de2fc2$export$c106dd0671a0fc2d("".concat(type, ' property "').concat(key, '" is already defined in ').concat(cache[key], "."));
        else cache[key] = type;
    };
}
var $fd05d31532de2fc2$var$shouldCacheAccess = true;
function $fd05d31532de2fc2$var$applyOptions(instance) {
    var _loop = function(key1) {
        var opt = computedOptions[key1];
        var get = (0, $hLodm.isFunction)(opt) ? opt.bind(publicThis, publicThis) : (0, $hLodm.isFunction)(opt.get) ? opt.get.bind(publicThis, publicThis) : (0, $hLodm.NOOP);
        var set = !(0, $hLodm.isFunction)(opt) && (0, $hLodm.isFunction)(opt.set) ? opt.set.bind(publicThis) : (0, $hLodm.NOOP);
        var c = $fd05d31532de2fc2$export$2983e091f1a1e8e2({
            get: get,
            set: set
        });
        Object.defineProperty(ctx, key1, {
            enumerable: true,
            configurable: true,
            get: function() {
                return c.value;
            },
            set: function(v1) {
                return c.value = v1;
            }
        });
    };
    var registerLifecycleHook = function registerLifecycleHook(register, hook) {
        if ((0, $hLodm.isArray)(hook)) hook.forEach(function(_hook) {
            return register(_hook.bind(publicThis));
        });
        else if (hook) register(hook.bind(publicThis));
    };
    var options = $fd05d31532de2fc2$var$resolveMergedOptions(instance);
    var publicThis = instance.proxy;
    var ctx = instance.ctx;
    $fd05d31532de2fc2$var$shouldCacheAccess = false;
    if (options.beforeCreate) $fd05d31532de2fc2$var$callHook(options.beforeCreate, instance, "bc");
    var // state
    dataOptions = options.data, computedOptions = options.computed, methods = options.methods, watchOptions = options.watch, provideOptions = options.provide, injectOptions = options.inject, // lifecycle
    created = options.created, beforeMount = options.beforeMount, mounted = options.mounted, beforeUpdate = options.beforeUpdate, updated = options.updated, activated = options.activated, deactivated = options.deactivated, beforeDestroy = options.beforeDestroy, beforeUnmount = options.beforeUnmount, destroyed = options.destroyed, unmounted = options.unmounted, render = options.render, renderTracked = options.renderTracked, renderTriggered = options.renderTriggered, errorCaptured = options.errorCaptured, serverPrefetch = options.serverPrefetch, // public API
    expose = options.expose, inheritAttrs = options.inheritAttrs, // assets
    components = options.components, directives = options.directives, filters = options.filters;
    var checkDuplicateProperties = null;
    if (injectOptions) $fd05d31532de2fc2$var$resolveInjections(injectOptions, ctx, checkDuplicateProperties);
    if (methods) for(var key in methods){
        var methodHandler = methods[key];
        if ((0, $hLodm.isFunction)(methodHandler)) ctx[key] = methodHandler.bind(publicThis);
    }
    if (dataOptions) {
        var data = dataOptions.call(publicThis, publicThis);
        if (!(0, $hLodm.isObject)(data)) ;
        else instance.data = (0, $yQ0Ka.reactive)(data);
    }
    $fd05d31532de2fc2$var$shouldCacheAccess = true;
    if (computedOptions) for(var key1 in computedOptions)_loop(key1);
    if (watchOptions) for(var key2 in watchOptions)$fd05d31532de2fc2$var$createWatcher(watchOptions[key2], ctx, publicThis, key2);
    if (provideOptions) {
        var provides = (0, $hLodm.isFunction)(provideOptions) ? provideOptions.call(publicThis) : provideOptions;
        Reflect.ownKeys(provides).forEach(function(key) {
            $fd05d31532de2fc2$export$abe1e183e22e10ad(key, provides[key]);
        });
    }
    if (created) $fd05d31532de2fc2$var$callHook(created, instance, "c");
    registerLifecycleHook($fd05d31532de2fc2$export$23b7aeb0d671f804, beforeMount);
    registerLifecycleHook($fd05d31532de2fc2$export$6d1641039221b5cb, mounted);
    registerLifecycleHook($fd05d31532de2fc2$export$ab91988a13872e4c, beforeUpdate);
    registerLifecycleHook($fd05d31532de2fc2$export$5876c47052fb88b1, updated);
    registerLifecycleHook($fd05d31532de2fc2$export$ba52d824b95a2154, activated);
    registerLifecycleHook($fd05d31532de2fc2$export$bf1440eeaf5fa709, deactivated);
    registerLifecycleHook($fd05d31532de2fc2$export$6a3a15856e50ad19, errorCaptured);
    registerLifecycleHook($fd05d31532de2fc2$export$2b41f4235363e921, renderTracked);
    registerLifecycleHook($fd05d31532de2fc2$export$898295a813d662eb, renderTriggered);
    registerLifecycleHook($fd05d31532de2fc2$export$40c420df62d2614, beforeUnmount);
    registerLifecycleHook($fd05d31532de2fc2$export$13348a43ccacfe58, unmounted);
    registerLifecycleHook($fd05d31532de2fc2$export$ebf0c601f267bceb, serverPrefetch);
    if ((0, $hLodm.isArray)(expose)) {
        if (expose.length) {
            var exposed = instance.exposed || (instance.exposed = {});
            expose.forEach(function(key) {
                Object.defineProperty(exposed, key, {
                    get: function() {
                        return publicThis[key];
                    },
                    set: function(val) {
                        return publicThis[key] = val;
                    }
                });
            });
        } else if (!instance.exposed) instance.exposed = {};
    }
    if (render && instance.render === (0, $hLodm.NOOP)) instance.render = render;
    if (inheritAttrs != null) instance.inheritAttrs = inheritAttrs;
    if (components) instance.components = components;
    if (directives) instance.directives = directives;
}
function $fd05d31532de2fc2$var$resolveInjections(injectOptions, ctx) {
    var _loop = function(key) {
        var opt = injectOptions[key];
        var injected = void 0;
        if ((0, $hLodm.isObject)(opt)) {
            if ("default" in opt) injected = $fd05d31532de2fc2$export$a976684a0efeb93f(opt.from || key, opt.default, true);
            else injected = $fd05d31532de2fc2$export$a976684a0efeb93f(opt.from || key);
        } else injected = $fd05d31532de2fc2$export$a976684a0efeb93f(opt);
        if ((0, $yQ0Ka.isRef)(injected)) Object.defineProperty(ctx, key, {
            enumerable: true,
            configurable: true,
            get: function() {
                return injected.value;
            },
            set: function(v1) {
                return injected.value = v1;
            }
        });
        else ctx[key] = injected;
    };
    var checkDuplicateProperties = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : (0, $hLodm.NOOP);
    if ((0, $hLodm.isArray)(injectOptions)) injectOptions = $fd05d31532de2fc2$var$normalizeInject(injectOptions);
    for(var key in injectOptions)_loop(key);
}
function $fd05d31532de2fc2$var$callHook(hook, instance, type) {
    $fd05d31532de2fc2$export$dae85862a8d94378((0, $hLodm.isArray)(hook) ? hook.map(function(h) {
        return h.bind(instance.proxy);
    }) : hook.bind(instance.proxy), instance, type);
}
function $fd05d31532de2fc2$var$createWatcher(raw, ctx, publicThis, key) {
    var getter = key.includes(".") ? $fd05d31532de2fc2$var$createPathGetter(publicThis, key) : function() {
        return publicThis[key];
    };
    if ((0, $hLodm.isString)(raw)) {
        var handler = ctx[raw];
        if ((0, $hLodm.isFunction)(handler)) $fd05d31532de2fc2$export$3db5d71bdb2d5499(getter, handler);
    } else if ((0, $hLodm.isFunction)(raw)) $fd05d31532de2fc2$export$3db5d71bdb2d5499(getter, raw.bind(publicThis));
    else if ((0, $hLodm.isObject)(raw)) {
        if ((0, $hLodm.isArray)(raw)) raw.forEach(function(r) {
            return $fd05d31532de2fc2$var$createWatcher(r, ctx, publicThis, key);
        });
        else {
            var handler1 = (0, $hLodm.isFunction)(raw.handler) ? raw.handler.bind(publicThis) : ctx[raw.handler];
            if ((0, $hLodm.isFunction)(handler1)) $fd05d31532de2fc2$export$3db5d71bdb2d5499(getter, handler1, raw);
        }
    } else ;
}
function $fd05d31532de2fc2$var$resolveMergedOptions(instance) {
    var base = instance.type;
    var mixins = base.mixins, extendsOptions = base.extends;
    var _instance_appContext = instance.appContext, globalMixins = _instance_appContext.mixins, cache = _instance_appContext.optionsCache, optionMergeStrategies = _instance_appContext.config.optionMergeStrategies;
    var cached = cache.get(base);
    var resolved;
    if (cached) resolved = cached;
    else if (!globalMixins.length && !mixins && !extendsOptions) resolved = base;
    else {
        resolved = {};
        if (globalMixins.length) globalMixins.forEach(function(m) {
            return $fd05d31532de2fc2$var$mergeOptions(resolved, m, optionMergeStrategies, true);
        });
        $fd05d31532de2fc2$var$mergeOptions(resolved, base, optionMergeStrategies);
    }
    if ((0, $hLodm.isObject)(base)) cache.set(base, resolved);
    return resolved;
}
function $fd05d31532de2fc2$var$mergeOptions(to, from, strats) {
    var asMixin = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var mixins = from.mixins, extendsOptions = from.extends;
    if (extendsOptions) $fd05d31532de2fc2$var$mergeOptions(to, extendsOptions, strats, true);
    if (mixins) mixins.forEach(function(m) {
        return $fd05d31532de2fc2$var$mergeOptions(to, m, strats, true);
    });
    for(var key in from){
        if (asMixin && key === "expose") ;
        else {
            var strat = $fd05d31532de2fc2$var$internalOptionMergeStrats[key] || strats && strats[key];
            to[key] = strat ? strat(to[key], from[key]) : from[key];
        }
    }
    return to;
}
var $fd05d31532de2fc2$var$internalOptionMergeStrats = {
    data: $fd05d31532de2fc2$var$mergeDataFn,
    props: $fd05d31532de2fc2$var$mergeEmitsOrPropsOptions,
    emits: $fd05d31532de2fc2$var$mergeEmitsOrPropsOptions,
    // objects
    methods: $fd05d31532de2fc2$var$mergeObjectOptions,
    computed: $fd05d31532de2fc2$var$mergeObjectOptions,
    // lifecycle
    beforeCreate: $fd05d31532de2fc2$var$mergeAsArray,
    created: $fd05d31532de2fc2$var$mergeAsArray,
    beforeMount: $fd05d31532de2fc2$var$mergeAsArray,
    mounted: $fd05d31532de2fc2$var$mergeAsArray,
    beforeUpdate: $fd05d31532de2fc2$var$mergeAsArray,
    updated: $fd05d31532de2fc2$var$mergeAsArray,
    beforeDestroy: $fd05d31532de2fc2$var$mergeAsArray,
    beforeUnmount: $fd05d31532de2fc2$var$mergeAsArray,
    destroyed: $fd05d31532de2fc2$var$mergeAsArray,
    unmounted: $fd05d31532de2fc2$var$mergeAsArray,
    activated: $fd05d31532de2fc2$var$mergeAsArray,
    deactivated: $fd05d31532de2fc2$var$mergeAsArray,
    errorCaptured: $fd05d31532de2fc2$var$mergeAsArray,
    serverPrefetch: $fd05d31532de2fc2$var$mergeAsArray,
    // assets
    components: $fd05d31532de2fc2$var$mergeObjectOptions,
    directives: $fd05d31532de2fc2$var$mergeObjectOptions,
    // watch
    watch: $fd05d31532de2fc2$var$mergeWatchOptions,
    // provide / inject
    provide: $fd05d31532de2fc2$var$mergeDataFn,
    inject: $fd05d31532de2fc2$var$mergeInject
};
function $fd05d31532de2fc2$var$mergeDataFn(to, from) {
    if (!from) return to;
    if (!to) return from;
    return function mergedDataFn() {
        return (0, $hLodm.extend)((0, $hLodm.isFunction)(to) ? to.call(this, this) : to, (0, $hLodm.isFunction)(from) ? from.call(this, this) : from);
    };
}
function $fd05d31532de2fc2$var$mergeInject(to, from) {
    return $fd05d31532de2fc2$var$mergeObjectOptions($fd05d31532de2fc2$var$normalizeInject(to), $fd05d31532de2fc2$var$normalizeInject(from));
}
function $fd05d31532de2fc2$var$normalizeInject(raw) {
    if ((0, $hLodm.isArray)(raw)) {
        var res = {};
        for(var i = 0; i < raw.length; i++)res[raw[i]] = raw[i];
        return res;
    }
    return raw;
}
function $fd05d31532de2fc2$var$mergeAsArray(to, from) {
    return to ? (0, $c6Xmf._)(new Set([].concat(to, from))) : from;
}
function $fd05d31532de2fc2$var$mergeObjectOptions(to, from) {
    return to ? (0, $hLodm.extend)(/* @__PURE__ */ Object.create(null), to, from) : from;
}
function $fd05d31532de2fc2$var$mergeEmitsOrPropsOptions(to, from) {
    if (to) {
        if ((0, $hLodm.isArray)(to) && (0, $hLodm.isArray)(from)) return (0, $c6Xmf._)(/* @__PURE__ */ new Set((0, $c6Xmf._)(to).concat((0, $c6Xmf._)(from))));
        return (0, $hLodm.extend)(/* @__PURE__ */ Object.create(null), $fd05d31532de2fc2$var$normalizePropsOrEmits(to), $fd05d31532de2fc2$var$normalizePropsOrEmits(from != null ? from : {}));
    } else return from;
}
function $fd05d31532de2fc2$var$mergeWatchOptions(to, from) {
    if (!to) return from;
    if (!from) return to;
    var merged = (0, $hLodm.extend)(/* @__PURE__ */ Object.create(null), to);
    for(var key in from)merged[key] = $fd05d31532de2fc2$var$mergeAsArray(to[key], from[key]);
    return merged;
}
function $fd05d31532de2fc2$var$createAppContext() {
    return {
        app: null,
        config: {
            isNativeTag: (0, $hLodm.NO),
            performance: false,
            globalProperties: {},
            optionMergeStrategies: {},
            errorHandler: void 0,
            warnHandler: void 0,
            compilerOptions: {}
        },
        mixins: [],
        components: {},
        directives: {},
        provides: /* @__PURE__ */ Object.create(null),
        optionsCache: /* @__PURE__ */ new WeakMap(),
        propsCache: /* @__PURE__ */ new WeakMap(),
        emitsCache: /* @__PURE__ */ new WeakMap()
    };
}
var $fd05d31532de2fc2$var$uid$1 = 0;
function $fd05d31532de2fc2$var$createAppAPI(render, hydrate) {
    return function createApp(rootComponent) {
        var rootProps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
        if (!(0, $hLodm.isFunction)(rootComponent)) rootComponent = (0, $hLodm.extend)({}, rootComponent);
        if (rootProps != null && !(0, $hLodm.isObject)(rootProps)) rootProps = null;
        var context = $fd05d31532de2fc2$var$createAppContext();
        var installedPlugins = /* @__PURE__ */ new Set();
        var isMounted = false;
        var app = context.app = {
            _uid: $fd05d31532de2fc2$var$uid$1++,
            _component: rootComponent,
            _props: rootProps,
            _container: null,
            _context: context,
            _instance: null,
            version: $fd05d31532de2fc2$export$83d89fbfd8236492,
            get config () {
                return context.config;
            },
            set config (v){},
            use: function(plugin) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                if (installedPlugins.has(plugin)) ;
                else if (plugin && (0, $hLodm.isFunction)(plugin.install)) {
                    var _plugin;
                    installedPlugins.add(plugin);
                    (_plugin = plugin).install.apply(_plugin, [
                        app
                    ].concat((0, $c6Xmf._)(options)));
                } else if ((0, $hLodm.isFunction)(plugin)) {
                    installedPlugins.add(plugin);
                    plugin.apply(void 0, [
                        app
                    ].concat((0, $c6Xmf._)(options)));
                }
                return app;
            },
            mixin: function(mixin) {
                if (__VUE_OPTIONS_API__) {
                    if (!context.mixins.includes(mixin)) context.mixins.push(mixin);
                }
                return app;
            },
            component: function(name, component) {
                if (!component) return context.components[name];
                context.components[name] = component;
                return app;
            },
            directive: function(name, directive) {
                if (!directive) return context.directives[name];
                context.directives[name] = directive;
                return app;
            },
            mount: function(rootContainer, isHydrate, isSVG) {
                if (!isMounted) {
                    var vnode = $fd05d31532de2fc2$export$bf5c4cf060303d58(rootComponent, rootProps);
                    vnode.appContext = context;
                    if (isHydrate && hydrate) hydrate(vnode, rootContainer);
                    else render(vnode, rootContainer, isSVG);
                    isMounted = true;
                    app._container = rootContainer;
                    rootContainer.__vue_app__ = app;
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = vnode.component;
                        $fd05d31532de2fc2$var$devtoolsInitApp(app, $fd05d31532de2fc2$export$83d89fbfd8236492);
                    }
                    return $fd05d31532de2fc2$var$getExposeProxy(vnode.component) || vnode.component.proxy;
                }
            },
            unmount: function() {
                if (isMounted) {
                    render(null, app._container);
                    if (__VUE_PROD_DEVTOOLS__) {
                        app._instance = null;
                        $fd05d31532de2fc2$var$devtoolsUnmountApp(app);
                    }
                    delete app._container.__vue_app__;
                }
            },
            provide: function(key, value1) {
                context.provides[key] = value1;
                return app;
            },
            runWithContext: function(fn) {
                $fd05d31532de2fc2$var$currentApp = app;
                try {
                    return fn();
                } finally{
                    $fd05d31532de2fc2$var$currentApp = null;
                }
            }
        };
        return app;
    };
}
var $fd05d31532de2fc2$var$currentApp = null;
function $fd05d31532de2fc2$export$abe1e183e22e10ad(key, value1) {
    if (!$fd05d31532de2fc2$var$currentInstance) ;
    else {
        var provides = $fd05d31532de2fc2$var$currentInstance.provides;
        var parentProvides = $fd05d31532de2fc2$var$currentInstance.parent && $fd05d31532de2fc2$var$currentInstance.parent.provides;
        if (parentProvides === provides) provides = $fd05d31532de2fc2$var$currentInstance.provides = Object.create(parentProvides);
        provides[key] = value1;
    }
}
function $fd05d31532de2fc2$export$a976684a0efeb93f(key, defaultValue) {
    var treatDefaultAsFactory = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var instance = $fd05d31532de2fc2$var$currentInstance || $fd05d31532de2fc2$var$currentRenderingInstance;
    if (instance || $fd05d31532de2fc2$var$currentApp) {
        var provides = instance ? instance.parent == null ? instance.vnode.appContext && instance.vnode.appContext.provides : instance.parent.provides : $fd05d31532de2fc2$var$currentApp._context.provides;
        if (provides && key in provides) return provides[key];
        else if (arguments.length > 1) return treatDefaultAsFactory && (0, $hLodm.isFunction)(defaultValue) ? defaultValue.call(instance && instance.proxy) : defaultValue;
    }
}
function $fd05d31532de2fc2$export$caf6761f24fc571a() {
    return !!($fd05d31532de2fc2$var$currentInstance || $fd05d31532de2fc2$var$currentRenderingInstance || $fd05d31532de2fc2$var$currentApp);
}
function $fd05d31532de2fc2$var$initProps(instance, rawProps, isStateful) {
    var isSSR = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var props = {};
    var attrs = {};
    (0, $hLodm.def)(attrs, $fd05d31532de2fc2$var$InternalObjectKey, 1);
    instance.propsDefaults = /* @__PURE__ */ Object.create(null);
    $fd05d31532de2fc2$var$setFullProps(instance, rawProps, props, attrs);
    for(var key in instance.propsOptions[0])if (!(key in props)) props[key] = void 0;
    if (isStateful) instance.props = isSSR ? props : (0, $yQ0Ka.shallowReactive)(props);
    else if (!instance.type.props) instance.props = attrs;
    else instance.props = props;
    instance.attrs = attrs;
}
function $fd05d31532de2fc2$var$isInHmrContext(instance) {
    while(instance){
        if (instance.type.__hmrId) return true;
        instance = instance.parent;
    }
}
function $fd05d31532de2fc2$var$updateProps(instance, rawProps, rawPrevProps, optimized) {
    var props = instance.props, attrs = instance.attrs, patchFlag = instance.vnode.patchFlag;
    var rawCurrentProps = (0, $yQ0Ka.toRaw)(props);
    var _instance_propsOptions = (0, $cv9Rk._)(instance.propsOptions, 1), options = _instance_propsOptions[0];
    var hasAttrsChanged = false;
    if (// always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (optimized || patchFlag > 0) && !(patchFlag & 16)) {
        if (patchFlag & 8) {
            var propsToUpdate = instance.vnode.dynamicProps;
            for(var i = 0; i < propsToUpdate.length; i++){
                var key = propsToUpdate[i];
                if ($fd05d31532de2fc2$var$isEmitListener(instance.emitsOptions, key)) continue;
                var value1 = rawProps[key];
                if (options) {
                    if ((0, $hLodm.hasOwn)(attrs, key)) {
                        if (value1 !== attrs[key]) {
                            attrs[key] = value1;
                            hasAttrsChanged = true;
                        }
                    } else {
                        var camelizedKey = (0, $hLodm.camelize)(key);
                        props[camelizedKey] = $fd05d31532de2fc2$var$resolvePropValue(options, rawCurrentProps, camelizedKey, value1, instance, false);
                    }
                } else if (value1 !== attrs[key]) {
                    attrs[key] = value1;
                    hasAttrsChanged = true;
                }
            }
        }
    } else {
        if ($fd05d31532de2fc2$var$setFullProps(instance, rawProps, props, attrs)) hasAttrsChanged = true;
        var kebabKey;
        for(var key1 in rawCurrentProps)if (!rawProps || // for camelCase
        !(0, $hLodm.hasOwn)(rawProps, key1) && // it's possible the original props was passed in as kebab-case
        // and converted to camelCase (#955)
        ((kebabKey = (0, $hLodm.hyphenate)(key1)) === key1 || !(0, $hLodm.hasOwn)(rawProps, kebabKey))) {
            if (options) {
                if (rawPrevProps && // for camelCase
                (rawPrevProps[key1] !== void 0 || // for kebab-case
                rawPrevProps[kebabKey] !== void 0)) props[key1] = $fd05d31532de2fc2$var$resolvePropValue(options, rawCurrentProps, key1, void 0, instance, true);
            } else delete props[key1];
        }
        if (attrs !== rawCurrentProps) {
            for(var key2 in attrs)if (!rawProps || !(0, $hLodm.hasOwn)(rawProps, key2) && true) {
                delete attrs[key2];
                hasAttrsChanged = true;
            }
        }
    }
    if (hasAttrsChanged) (0, $yQ0Ka.trigger)(instance, "set", "$attrs");
}
function $fd05d31532de2fc2$var$setFullProps(instance, rawProps, props, attrs) {
    var _instance_propsOptions = (0, $cv9Rk._)(instance.propsOptions, 2), options = _instance_propsOptions[0], needCastKeys = _instance_propsOptions[1];
    var hasAttrsChanged = false;
    var rawCastValues;
    if (rawProps) for(var key in rawProps){
        if ((0, $hLodm.isReservedProp)(key)) continue;
        var value1 = rawProps[key];
        var camelKey = void 0;
        if (options && (0, $hLodm.hasOwn)(options, camelKey = (0, $hLodm.camelize)(key))) {
            if (!needCastKeys || !needCastKeys.includes(camelKey)) props[camelKey] = value1;
            else (rawCastValues || (rawCastValues = {}))[camelKey] = value1;
        } else if (!$fd05d31532de2fc2$var$isEmitListener(instance.emitsOptions, key)) {
            if (!(key in attrs) || value1 !== attrs[key]) {
                attrs[key] = value1;
                hasAttrsChanged = true;
            }
        }
    }
    if (needCastKeys) {
        var rawCurrentProps = (0, $yQ0Ka.toRaw)(props);
        var castValues = rawCastValues || (0, $hLodm.EMPTY_OBJ);
        for(var i = 0; i < needCastKeys.length; i++){
            var key1 = needCastKeys[i];
            props[key1] = $fd05d31532de2fc2$var$resolvePropValue(options, rawCurrentProps, key1, castValues[key1], instance, !(0, $hLodm.hasOwn)(castValues, key1));
        }
    }
    return hasAttrsChanged;
}
function $fd05d31532de2fc2$var$resolvePropValue(options, props, key, value1, instance, isAbsent) {
    var opt = options[key];
    if (opt != null) {
        var hasDefault = (0, $hLodm.hasOwn)(opt, "default");
        if (hasDefault && value1 === void 0) {
            var defaultValue = opt.default;
            if (opt.type !== Function && !opt.skipFactory && (0, $hLodm.isFunction)(defaultValue)) {
                var propsDefaults = instance.propsDefaults;
                if (key in propsDefaults) value1 = propsDefaults[key];
                else {
                    $fd05d31532de2fc2$var$setCurrentInstance(instance);
                    value1 = propsDefaults[key] = defaultValue.call(null, props);
                    $fd05d31532de2fc2$var$unsetCurrentInstance();
                }
            } else value1 = defaultValue;
        }
        if (opt[0 /* shouldCast */ ]) {
            if (isAbsent && !hasDefault) value1 = false;
            else if (opt[1 /* shouldCastTrue */ ] && (value1 === "" || value1 === (0, $hLodm.hyphenate)(key))) value1 = true;
        }
    }
    return value1;
}
function $fd05d31532de2fc2$var$normalizePropsOptions(comp, appContext) {
    var asMixin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var cache = appContext.propsCache;
    var cached = cache.get(comp);
    if (cached) return cached;
    var raw = comp.props;
    var normalized = {};
    var needCastKeys = [];
    var hasExtends = false;
    if (__VUE_OPTIONS_API__ && !(0, $hLodm.isFunction)(comp)) {
        var extendProps = function(raw2) {
            var _needCastKeys;
            hasExtends = true;
            var _normalizePropsOptions = (0, $cv9Rk._)($fd05d31532de2fc2$var$normalizePropsOptions(raw2, appContext, true), 2), props = _normalizePropsOptions[0], keys = _normalizePropsOptions[1];
            (0, $hLodm.extend)(normalized, props);
            if (keys) (_needCastKeys = needCastKeys).push.apply(_needCastKeys, (0, $c6Xmf._)(keys));
        };
        if (!asMixin && appContext.mixins.length) appContext.mixins.forEach(extendProps);
        if (comp.extends) extendProps(comp.extends);
        if (comp.mixins) comp.mixins.forEach(extendProps);
    }
    if (!raw && !hasExtends) {
        if ((0, $hLodm.isObject)(comp)) cache.set(comp, (0, $hLodm.EMPTY_ARR));
        return 0, $hLodm.EMPTY_ARR;
    }
    if ((0, $hLodm.isArray)(raw)) for(var i = 0; i < raw.length; i++){
        var normalizedKey = (0, $hLodm.camelize)(raw[i]);
        if ($fd05d31532de2fc2$var$validatePropName(normalizedKey)) normalized[normalizedKey] = (0, $hLodm.EMPTY_OBJ);
    }
    else if (raw) for(var key in raw){
        var normalizedKey1 = (0, $hLodm.camelize)(key);
        if ($fd05d31532de2fc2$var$validatePropName(normalizedKey1)) {
            var opt = raw[key];
            var prop = normalized[normalizedKey1] = (0, $hLodm.isArray)(opt) || (0, $hLodm.isFunction)(opt) ? {
                type: opt
            } : (0, $hLodm.extend)({}, opt);
            if (prop) {
                var booleanIndex = $fd05d31532de2fc2$var$getTypeIndex(Boolean, prop.type);
                var stringIndex = $fd05d31532de2fc2$var$getTypeIndex(String, prop.type);
                prop[0 /* shouldCast */ ] = booleanIndex > -1;
                prop[1 /* shouldCastTrue */ ] = stringIndex < 0 || booleanIndex < stringIndex;
                if (booleanIndex > -1 || (0, $hLodm.hasOwn)(prop, "default")) needCastKeys.push(normalizedKey1);
            }
        }
    }
    var res = [
        normalized,
        needCastKeys
    ];
    if ((0, $hLodm.isObject)(comp)) cache.set(comp, res);
    return res;
}
function $fd05d31532de2fc2$var$validatePropName(key) {
    if (key[0] !== "$") return true;
    return false;
}
function $fd05d31532de2fc2$var$getType(ctor) {
    var match = ctor && ctor.toString().match(/^\s*(function|class) (\w+)/);
    return match ? match[2] : ctor === null ? "null" : "";
}
function $fd05d31532de2fc2$var$isSameType(a, b) {
    return $fd05d31532de2fc2$var$getType(a) === $fd05d31532de2fc2$var$getType(b);
}
function $fd05d31532de2fc2$var$getTypeIndex(type, expectedTypes) {
    if ((0, $hLodm.isArray)(expectedTypes)) return expectedTypes.findIndex(function(t) {
        return $fd05d31532de2fc2$var$isSameType(t, type);
    });
    else if ((0, $hLodm.isFunction)(expectedTypes)) return $fd05d31532de2fc2$var$isSameType(expectedTypes, type) ? 0 : -1;
    return -1;
}
function $fd05d31532de2fc2$var$validateProps(rawProps, props, instance) {
    var resolvedValues = (0, $yQ0Ka.toRaw)(props);
    var options = instance.propsOptions[0];
    for(var key in options){
        var opt = options[key];
        if (opt == null) continue;
        $fd05d31532de2fc2$var$validateProp(key, resolvedValues[key], opt, !(0, $hLodm.hasOwn)(rawProps, key) && !(0, $hLodm.hasOwn)(rawProps, (0, $hLodm.hyphenate)(key)));
    }
}
function $fd05d31532de2fc2$var$validateProp(name, value1, prop, isAbsent) {
    var type = prop.type, required = prop.required, validator = prop.validator, skipCheck = prop.skipCheck;
    if (required && isAbsent) {
        $fd05d31532de2fc2$export$c106dd0671a0fc2d('Missing required prop: "' + name + '"');
        return;
    }
    if (value1 == null && !required) return;
    if (type != null && type !== true && !skipCheck) {
        var isValid = false;
        var types = (0, $hLodm.isArray)(type) ? type : [
            type
        ];
        var expectedTypes = [];
        for(var i = 0; i < types.length && !isValid; i++){
            var _assertType = $fd05d31532de2fc2$var$assertType(value1, types[i]), valid = _assertType.valid, expectedType = _assertType.expectedType;
            expectedTypes.push(expectedType || "");
            isValid = valid;
        }
        if (!isValid) {
            $fd05d31532de2fc2$export$c106dd0671a0fc2d($fd05d31532de2fc2$var$getInvalidTypeMessage(name, value1, expectedTypes));
            return;
        }
    }
    if (validator && !validator(value1)) $fd05d31532de2fc2$export$c106dd0671a0fc2d('Invalid prop: custom validator check failed for prop "' + name + '".');
}
var $fd05d31532de2fc2$var$isSimpleType = /* @__PURE__ */ (0, $hLodm.makeMap)("String,Number,Boolean,Function,Symbol,BigInt");
function $fd05d31532de2fc2$var$assertType(value1, type) {
    var valid;
    var expectedType = $fd05d31532de2fc2$var$getType(type);
    if ($fd05d31532de2fc2$var$isSimpleType(expectedType)) {
        var t = typeof value1 === "undefined" ? "undefined" : (0, $l0HdX._)(value1);
        valid = t === expectedType.toLowerCase();
        if (!valid && t === "object") valid = value1 instanceof type;
    } else if (expectedType === "Object") valid = (0, $hLodm.isObject)(value1);
    else if (expectedType === "Array") valid = (0, $hLodm.isArray)(value1);
    else if (expectedType === "null") valid = value1 === null;
    else valid = value1 instanceof type;
    return {
        valid: valid,
        expectedType: expectedType
    };
}
function $fd05d31532de2fc2$var$getInvalidTypeMessage(name, value1, expectedTypes) {
    var message = 'Invalid prop: type check failed for prop "'.concat(name, '". Expected ').concat(expectedTypes.map((0, $hLodm.capitalize)).join(" | "));
    var expectedType = expectedTypes[0];
    var receivedType = (0, $hLodm.toRawType)(value1);
    var expectedValue = $fd05d31532de2fc2$var$styleValue(value1, expectedType);
    var receivedValue = $fd05d31532de2fc2$var$styleValue(value1, receivedType);
    if (expectedTypes.length === 1 && $fd05d31532de2fc2$var$isExplicable(expectedType) && !$fd05d31532de2fc2$var$isBoolean(expectedType, receivedType)) message += " with value ".concat(expectedValue);
    message += ", got ".concat(receivedType, " ");
    if ($fd05d31532de2fc2$var$isExplicable(receivedType)) message += "with value ".concat(receivedValue, ".");
    return message;
}
function $fd05d31532de2fc2$var$styleValue(value1, type) {
    if (type === "String") return '"'.concat(value1, '"');
    else if (type === "Number") return "".concat(Number(value1));
    else return "".concat(value1);
}
function $fd05d31532de2fc2$var$isExplicable(type) {
    var explicitTypes = [
        "string",
        "number",
        "boolean"
    ];
    return explicitTypes.some(function(elem) {
        return type.toLowerCase() === elem;
    });
}
function $fd05d31532de2fc2$var$isBoolean() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return args.some(function(elem) {
        return elem.toLowerCase() === "boolean";
    });
}
var $fd05d31532de2fc2$var$isInternalKey = function(key) {
    return key[0] === "_" || key === "$stable";
};
var $fd05d31532de2fc2$var$normalizeSlotValue = function(value1) {
    return (0, $hLodm.isArray)(value1) ? value1.map($fd05d31532de2fc2$var$normalizeVNode) : [
        $fd05d31532de2fc2$var$normalizeVNode(value1)
    ];
};
var $fd05d31532de2fc2$var$normalizeSlot = function(key, rawSlot, ctx) {
    if (rawSlot._n) return rawSlot;
    var normalized = $fd05d31532de2fc2$export$694b237e827a3d23(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return $fd05d31532de2fc2$var$normalizeSlotValue(rawSlot.apply(void 0, (0, $c6Xmf._)(args)));
    }, ctx);
    normalized._c = false;
    return normalized;
};
var $fd05d31532de2fc2$var$normalizeObjectSlots = function(rawSlots, slots, instance) {
    var _loop = function(key) {
        if ($fd05d31532de2fc2$var$isInternalKey(key)) return "continue";
        var value1 = rawSlots[key];
        if ((0, $hLodm.isFunction)(value1)) slots[key] = $fd05d31532de2fc2$var$normalizeSlot(key, value1, ctx);
        else if (value1 != null) {
            var normalized = $fd05d31532de2fc2$var$normalizeSlotValue(value1);
            slots[key] = function() {
                return normalized;
            };
        }
    };
    var ctx = rawSlots._ctx;
    for(var key in rawSlots)_loop(key);
};
var $fd05d31532de2fc2$var$normalizeVNodeSlots = function(instance, children) {
    var normalized = $fd05d31532de2fc2$var$normalizeSlotValue(children);
    instance.slots.default = function() {
        return normalized;
    };
};
var $fd05d31532de2fc2$var$initSlots = function(instance, children) {
    if (instance.vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            instance.slots = (0, $yQ0Ka.toRaw)(children);
            (0, $hLodm.def)(children, "_", type);
        } else $fd05d31532de2fc2$var$normalizeObjectSlots(children, instance.slots = {});
    } else {
        instance.slots = {};
        if (children) $fd05d31532de2fc2$var$normalizeVNodeSlots(instance, children);
    }
    (0, $hLodm.def)(instance.slots, $fd05d31532de2fc2$var$InternalObjectKey, 1);
};
var $fd05d31532de2fc2$var$updateSlots = function(instance, children, optimized) {
    var vnode = instance.vnode, slots = instance.slots;
    var needDeletionCheck = true;
    var deletionComparisonTarget = (0, $hLodm.EMPTY_OBJ);
    if (vnode.shapeFlag & 32) {
        var type = children._;
        if (type) {
            if (optimized && type === 1) needDeletionCheck = false;
            else {
                (0, $hLodm.extend)(slots, children);
                if (!optimized && type === 1) delete slots._;
            }
        } else {
            needDeletionCheck = !children.$stable;
            $fd05d31532de2fc2$var$normalizeObjectSlots(children, slots);
        }
        deletionComparisonTarget = children;
    } else if (children) {
        $fd05d31532de2fc2$var$normalizeVNodeSlots(instance, children);
        deletionComparisonTarget = {
            default: 1
        };
    }
    if (needDeletionCheck) {
        for(var key in slots)if (!$fd05d31532de2fc2$var$isInternalKey(key) && !(key in deletionComparisonTarget)) delete slots[key];
    }
};
function $fd05d31532de2fc2$var$setRef(rawRef, oldRawRef, parentSuspense, vnode) {
    var isUnmount = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    if ((0, $hLodm.isArray)(rawRef)) {
        rawRef.forEach(function(r, i) {
            return $fd05d31532de2fc2$var$setRef(r, oldRawRef && ((0, $hLodm.isArray)(oldRawRef) ? oldRawRef[i] : oldRawRef), parentSuspense, vnode, isUnmount);
        });
        return;
    }
    if ($fd05d31532de2fc2$var$isAsyncWrapper(vnode) && !isUnmount) return;
    var refValue = vnode.shapeFlag & 4 ? $fd05d31532de2fc2$var$getExposeProxy(vnode.component) || vnode.component.proxy : vnode.el;
    var value1 = isUnmount ? null : refValue;
    var owner = rawRef.i, ref = rawRef.r;
    var oldRef = oldRawRef && oldRawRef.r;
    var refs = owner.refs === (0, $hLodm.EMPTY_OBJ) ? owner.refs = {} : owner.refs;
    var setupState = owner.setupState;
    if (oldRef != null && oldRef !== ref) {
        if ((0, $hLodm.isString)(oldRef)) {
            refs[oldRef] = null;
            if ((0, $hLodm.hasOwn)(setupState, oldRef)) setupState[oldRef] = null;
        } else if ((0, $yQ0Ka.isRef)(oldRef)) oldRef.value = null;
    }
    if ((0, $hLodm.isFunction)(ref)) $fd05d31532de2fc2$export$b22fcaf88446e9bf(ref, owner, 12, [
        value1,
        refs
    ]);
    else {
        var _isString = (0, $hLodm.isString)(ref);
        var _isRef = (0, $yQ0Ka.isRef)(ref);
        if (_isString || _isRef) {
            var doSet = function() {
                if (rawRef.f) {
                    var existing = _isString ? (0, $hLodm.hasOwn)(setupState, ref) ? setupState[ref] : refs[ref] : ref.value;
                    if (isUnmount) (0, $hLodm.isArray)(existing) && (0, $hLodm.remove)(existing, refValue);
                    else {
                        if (!(0, $hLodm.isArray)(existing)) {
                            if (_isString) {
                                refs[ref] = [
                                    refValue
                                ];
                                if ((0, $hLodm.hasOwn)(setupState, ref)) setupState[ref] = refs[ref];
                            } else {
                                ref.value = [
                                    refValue
                                ];
                                if (rawRef.k) refs[rawRef.k] = ref.value;
                            }
                        } else if (!existing.includes(refValue)) existing.push(refValue);
                    }
                } else if (_isString) {
                    refs[ref] = value1;
                    if ((0, $hLodm.hasOwn)(setupState, ref)) setupState[ref] = value1;
                } else if (_isRef) {
                    ref.value = value1;
                    if (rawRef.k) refs[rawRef.k] = value1;
                }
            };
            if (value1) {
                doSet.id = -1;
                $fd05d31532de2fc2$var$queuePostRenderEffect(doSet, parentSuspense);
            } else doSet();
        }
    }
}
var $fd05d31532de2fc2$var$hasMismatch = false;
var $fd05d31532de2fc2$var$isSVGContainer = function(container) {
    return /svg/.test(container.namespaceURI) && container.tagName !== "foreignObject";
};
var $fd05d31532de2fc2$var$isComment = function(node) {
    return node.nodeType === 8 /* COMMENT */ ;
};
function $fd05d31532de2fc2$var$createHydrationFunctions(rendererInternals) {
    var mountComponent = rendererInternals.mt, patch = rendererInternals.p, _rendererInternals_o = rendererInternals.o, patchProp = _rendererInternals_o.patchProp, createText = _rendererInternals_o.createText, nextSibling = _rendererInternals_o.nextSibling, parentNode = _rendererInternals_o.parentNode, remove = _rendererInternals_o.remove, insert = _rendererInternals_o.insert, createComment = _rendererInternals_o.createComment;
    var hydrate = function(vnode, container) {
        if (!container.hasChildNodes()) {
            patch(null, vnode, container);
            $fd05d31532de2fc2$var$flushPostFlushCbs();
            container._vnode = vnode;
            return;
        }
        $fd05d31532de2fc2$var$hasMismatch = false;
        hydrateNode(container.firstChild, vnode, null, null, null);
        $fd05d31532de2fc2$var$flushPostFlushCbs();
        container._vnode = vnode;
        if ($fd05d31532de2fc2$var$hasMismatch && true) console.error("Hydration completed but contains mismatches.");
    };
    var hydrateNode = function(node, vnode, parentComponent, parentSuspense, slotScopeIds) {
        var optimized = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
        var isFragmentStart = $fd05d31532de2fc2$var$isComment(node) && node.data === "[";
        var onMismatch = function() {
            return handleMismatch(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragmentStart);
        };
        var type = vnode.type, ref = vnode.ref, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag;
        var domType = node.nodeType;
        vnode.el = node;
        if (patchFlag === -2) {
            optimized = false;
            vnode.dynamicChildren = null;
        }
        var nextNode = null;
        switch(type){
            case $fd05d31532de2fc2$export$5f1af8db9871e1d6:
                if (domType !== 3 /* TEXT */ ) {
                    if (vnode.children === "") {
                        insert(vnode.el = createText(""), parentNode(node), node);
                        nextNode = node;
                    } else nextNode = onMismatch();
                } else {
                    if (node.data !== vnode.children) {
                        $fd05d31532de2fc2$var$hasMismatch = true;
                        node.data = vnode.children;
                    }
                    nextNode = nextSibling(node);
                }
                break;
            case $fd05d31532de2fc2$export$4d299b491347818a:
                if (domType !== 8 /* COMMENT */  || isFragmentStart) nextNode = onMismatch();
                else nextNode = nextSibling(node);
                break;
            case $fd05d31532de2fc2$export$c1b9a1d3af45b7b6:
                if (isFragmentStart) {
                    node = nextSibling(node);
                    domType = node.nodeType;
                }
                if (domType === 1 /* ELEMENT */  || domType === 3 /* TEXT */ ) {
                    nextNode = node;
                    var needToAdoptContent = !vnode.children.length;
                    for(var i = 0; i < vnode.staticCount; i++){
                        if (needToAdoptContent) vnode.children += nextNode.nodeType === 1 /* ELEMENT */  ? nextNode.outerHTML : nextNode.data;
                        if (i === vnode.staticCount - 1) vnode.anchor = nextNode;
                        nextNode = nextSibling(nextNode);
                    }
                    return isFragmentStart ? nextSibling(nextNode) : nextNode;
                } else onMismatch();
                break;
            case $fd05d31532de2fc2$export$ffb0004e005737fa:
                if (!isFragmentStart) nextNode = onMismatch();
                else nextNode = hydrateFragment(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) {
                    if (domType !== 1 /* ELEMENT */  || vnode.type.toLowerCase() !== node.tagName.toLowerCase()) nextNode = onMismatch();
                    else nextNode = hydrateElement(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
                } else if (shapeFlag & 6) {
                    vnode.slotScopeIds = slotScopeIds;
                    var container = parentNode(node);
                    mountComponent(vnode, container, null, parentComponent, parentSuspense, $fd05d31532de2fc2$var$isSVGContainer(container), optimized);
                    nextNode = isFragmentStart ? locateClosingAsyncAnchor(node) : nextSibling(node);
                    if (nextNode && $fd05d31532de2fc2$var$isComment(nextNode) && nextNode.data === "teleport end") nextNode = nextSibling(nextNode);
                    if ($fd05d31532de2fc2$var$isAsyncWrapper(vnode)) {
                        var subTree;
                        if (isFragmentStart) {
                            subTree = $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$ffb0004e005737fa);
                            subTree.anchor = nextNode ? nextNode.previousSibling : container.lastChild;
                        } else subTree = node.nodeType === 3 ? $fd05d31532de2fc2$export$22f9b5ffd89dac9("") : $fd05d31532de2fc2$export$bf5c4cf060303d58("div");
                        subTree.el = node;
                        vnode.component.subTree = subTree;
                    }
                } else if (shapeFlag & 64) {
                    if (domType !== 8 /* COMMENT */ ) nextNode = onMismatch();
                    else nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, rendererInternals, hydrateChildren);
                } else if (shapeFlag & 128) nextNode = vnode.type.hydrate(node, vnode, parentComponent, parentSuspense, $fd05d31532de2fc2$var$isSVGContainer(parentNode(node)), slotScopeIds, optimized, rendererInternals, hydrateNode);
        }
        if (ref != null) $fd05d31532de2fc2$var$setRef(ref, null, parentSuspense, vnode);
        return nextNode;
    };
    var hydrateElement = function(el, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!vnode.dynamicChildren;
        var type = vnode.type, props = vnode.props, patchFlag = vnode.patchFlag, shapeFlag = vnode.shapeFlag, dirs = vnode.dirs;
        var forcePatchValue = type === "input" && dirs || type === "option";
        if (forcePatchValue || patchFlag !== -1) {
            if (dirs) $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
            if (props) {
                if (forcePatchValue || !optimized || patchFlag & 48) {
                    for(var key in props)if (forcePatchValue && key.endsWith("value") || (0, $hLodm.isOn)(key) && !(0, $hLodm.isReservedProp)(key)) patchProp(el, key, null, props[key], false, void 0, parentComponent);
                } else if (props.onClick) patchProp(el, "onClick", null, props.onClick, false, void 0, parentComponent);
            }
            var vnodeHooks;
            if (vnodeHooks = props && props.onVnodeBeforeMount) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
            if (dirs) $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
            if ((vnodeHooks = props && props.onVnodeMounted) || dirs) $fd05d31532de2fc2$var$queueEffectWithSuspense(function() {
                vnodeHooks && $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHooks, parentComponent, vnode);
                dirs && $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
            }, parentSuspense);
            if (shapeFlag & 16 && // skip if element has innerHTML / textContent
            !(props && (props.innerHTML || props.textContent))) {
                var next = hydrateChildren(el.firstChild, vnode, el, parentComponent, parentSuspense, slotScopeIds, optimized);
                var hasWarned = false;
                while(next){
                    $fd05d31532de2fc2$var$hasMismatch = true;
                    var cur = next;
                    next = next.nextSibling;
                    remove(cur);
                }
            } else if (shapeFlag & 8) {
                if (el.textContent !== vnode.children) {
                    $fd05d31532de2fc2$var$hasMismatch = true;
                    el.textContent = vnode.children;
                }
            }
        }
        return el.nextSibling;
    };
    var hydrateChildren = function(node, parentVNode, container, parentComponent, parentSuspense, slotScopeIds, optimized) {
        optimized = optimized || !!parentVNode.dynamicChildren;
        var children = parentVNode.children;
        var l = children.length;
        var hasWarned = false;
        for(var i = 0; i < l; i++){
            var vnode = optimized ? children[i] : children[i] = $fd05d31532de2fc2$var$normalizeVNode(children[i]);
            if (node) node = hydrateNode(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized);
            else if (vnode.type === $fd05d31532de2fc2$export$5f1af8db9871e1d6 && !vnode.children) continue;
            else {
                $fd05d31532de2fc2$var$hasMismatch = true;
                patch(null, vnode, container, null, parentComponent, parentSuspense, $fd05d31532de2fc2$var$isSVGContainer(container), slotScopeIds);
            }
        }
        return node;
    };
    var hydrateFragment = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized) {
        var fragmentSlotScopeIds = vnode.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        var container = parentNode(node);
        var next = hydrateChildren(nextSibling(node), vnode, container, parentComponent, parentSuspense, slotScopeIds, optimized);
        if (next && $fd05d31532de2fc2$var$isComment(next) && next.data === "]") return nextSibling(vnode.anchor = next);
        else {
            $fd05d31532de2fc2$var$hasMismatch = true;
            insert(vnode.anchor = createComment("]"), container, next);
            return next;
        }
    };
    var handleMismatch = function(node, vnode, parentComponent, parentSuspense, slotScopeIds, isFragment) {
        $fd05d31532de2fc2$var$hasMismatch = true;
        vnode.el = null;
        if (isFragment) {
            var end = locateClosingAsyncAnchor(node);
            while(true){
                var next2 = nextSibling(node);
                if (next2 && next2 !== end) remove(next2);
                else break;
            }
        }
        var next = nextSibling(node);
        var container = parentNode(node);
        remove(node);
        patch(null, vnode, container, next, parentComponent, parentSuspense, $fd05d31532de2fc2$var$isSVGContainer(container), slotScopeIds);
        return next;
    };
    var locateClosingAsyncAnchor = function(node) {
        var match = 0;
        while(node){
            node = nextSibling(node);
            if (node && $fd05d31532de2fc2$var$isComment(node)) {
                if (node.data === "[") match++;
                if (node.data === "]") {
                    if (match === 0) return nextSibling(node);
                    else match--;
                }
            }
        }
        return node;
    };
    return [
        hydrate,
        hydrateNode
    ];
}
var $fd05d31532de2fc2$var$supported;
var $fd05d31532de2fc2$var$perf;
function $fd05d31532de2fc2$var$startMeasure(instance, type) {
    if (instance.appContext.config.performance && $fd05d31532de2fc2$var$isSupported()) $fd05d31532de2fc2$var$perf.mark("vue-".concat(type, "-").concat(instance.uid));
    if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsPerfStart(instance, type, $fd05d31532de2fc2$var$isSupported() ? $fd05d31532de2fc2$var$perf.now() : Date.now());
}
function $fd05d31532de2fc2$var$endMeasure(instance, type) {
    if (instance.appContext.config.performance && $fd05d31532de2fc2$var$isSupported()) {
        var startTag = "vue-".concat(type, "-").concat(instance.uid);
        var endTag = startTag + ":end";
        $fd05d31532de2fc2$var$perf.mark(endTag);
        $fd05d31532de2fc2$var$perf.measure("<".concat($fd05d31532de2fc2$var$formatComponentName(instance, instance.type), "> ").concat(type), startTag, endTag);
        $fd05d31532de2fc2$var$perf.clearMarks(startTag);
        $fd05d31532de2fc2$var$perf.clearMarks(endTag);
    }
    if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsPerfEnd(instance, type, $fd05d31532de2fc2$var$isSupported() ? $fd05d31532de2fc2$var$perf.now() : Date.now());
}
function $fd05d31532de2fc2$var$isSupported() {
    if ($fd05d31532de2fc2$var$supported !== void 0) return $fd05d31532de2fc2$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $fd05d31532de2fc2$var$supported = true;
        $fd05d31532de2fc2$var$perf = window.performance;
    } else $fd05d31532de2fc2$var$supported = false;
    return $fd05d31532de2fc2$var$supported;
}
function $fd05d31532de2fc2$var$initFeatureFlags() {
    var needWarn = [];
    if (typeof __VUE_OPTIONS_API__ !== "boolean") (0, $hLodm.getGlobalThis)().__VUE_OPTIONS_API__ = true;
    if (typeof __VUE_PROD_DEVTOOLS__ !== "boolean") (0, $hLodm.getGlobalThis)().__VUE_PROD_DEVTOOLS__ = false;
}
var $fd05d31532de2fc2$var$queuePostRenderEffect = $fd05d31532de2fc2$var$queueEffectWithSuspense;
function $fd05d31532de2fc2$export$53ae2f996c64e9a(options) {
    return $fd05d31532de2fc2$var$baseCreateRenderer(options);
}
function $fd05d31532de2fc2$export$200524cf0d997ff0(options) {
    return $fd05d31532de2fc2$var$baseCreateRenderer(options, $fd05d31532de2fc2$var$createHydrationFunctions);
}
function $fd05d31532de2fc2$var$baseCreateRenderer(options, createHydrationFns) {
    $fd05d31532de2fc2$var$initFeatureFlags();
    var target = (0, $hLodm.getGlobalThis)();
    target.__VUE__ = true;
    if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$export$b0c258b32c26c785(target.__VUE_DEVTOOLS_GLOBAL_HOOK__, target);
    var hostInsert = options.insert, hostRemove = options.remove, hostPatchProp = options.patchProp, hostCreateElement = options.createElement, hostCreateText = options.createText, hostCreateComment = options.createComment, hostSetText = options.setText, hostSetElementText = options.setElementText, hostParentNode = options.parentNode, hostNextSibling = options.nextSibling, tmp = options.setScopeId, hostSetScopeId = tmp === void 0 ? (0, $hLodm.NOOP) : tmp, hostInsertStaticContent = options.insertStaticContent;
    var patch = function(n1, n2, container) {
        var anchor = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null, parentComponent = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, parentSuspense = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : null, isSVG = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, slotScopeIds = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : null, optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !!n2.dynamicChildren;
        if (n1 === n2) return;
        if (n1 && !$fd05d31532de2fc2$var$isSameVNodeType(n1, n2)) {
            anchor = getNextHostNode(n1);
            unmount(n1, parentComponent, parentSuspense, true);
            n1 = null;
        }
        if (n2.patchFlag === -2) {
            optimized = false;
            n2.dynamicChildren = null;
        }
        var type = n2.type, ref = n2.ref, shapeFlag = n2.shapeFlag;
        switch(type){
            case $fd05d31532de2fc2$export$5f1af8db9871e1d6:
                processText(n1, n2, container, anchor);
                break;
            case $fd05d31532de2fc2$export$4d299b491347818a:
                processCommentNode(n1, n2, container, anchor);
                break;
            case $fd05d31532de2fc2$export$c1b9a1d3af45b7b6:
                if (n1 == null) mountStaticNode(n2, container, anchor, isSVG);
                break;
            case $fd05d31532de2fc2$export$ffb0004e005737fa:
                processFragment(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                break;
            default:
                if (shapeFlag & 1) processElement(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 6) processComponent(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (shapeFlag & 64) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
                else if (shapeFlag & 128) type.process(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals);
        }
        if (ref != null && parentComponent) $fd05d31532de2fc2$var$setRef(ref, n1 && n1.ref, parentSuspense, n2 || n1, !n2);
    };
    var processText = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateText(n2.children), container, anchor);
        else {
            var el = n2.el = n1.el;
            if (n2.children !== n1.children) hostSetText(el, n2.children);
        }
    };
    var processCommentNode = function(n1, n2, container, anchor) {
        if (n1 == null) hostInsert(n2.el = hostCreateComment(n2.children || ""), container, anchor);
        else n2.el = n1.el;
    };
    var mountStaticNode = function(n2, container, anchor, isSVG) {
        var ref;
        ref = (0, $cv9Rk._)(hostInsertStaticContent(n2.children, container, anchor, isSVG, n2.el, n2.anchor), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
    };
    var patchStaticNode = function(n1, n2, container, isSVG) {
        if (n2.children !== n1.children) {
            var anchor = hostNextSibling(n1.anchor);
            removeStaticNode(n1);
            var ref;
            ref = (0, $cv9Rk._)(hostInsertStaticContent(n2.children, container, anchor, isSVG), 2), n2.el = ref[0], n2.anchor = ref[1], ref;
        } else {
            n2.el = n1.el;
            n2.anchor = n1.anchor;
        }
    };
    var moveStaticNode = function(param, container, nextSibling) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostInsert(el, container, nextSibling);
            el = next;
        }
        hostInsert(anchor, container, nextSibling);
    };
    var removeStaticNode = function(param) {
        var el = param.el, anchor = param.anchor;
        var next;
        while(el && el !== anchor){
            next = hostNextSibling(el);
            hostRemove(el);
            el = next;
        }
        hostRemove(anchor);
    };
    var processElement = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        isSVG = isSVG || n2.type === "svg";
        if (n1 == null) mountElement(n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        else patchElement(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    var mountElement = function(vnode, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var el;
        var vnodeHook;
        var type = vnode.type, props = vnode.props, shapeFlag = vnode.shapeFlag, transition = vnode.transition, dirs = vnode.dirs;
        el = vnode.el = hostCreateElement(vnode.type, isSVG, props && props.is, props);
        if (shapeFlag & 8) hostSetElementText(el, vnode.children);
        else if (shapeFlag & 16) mountChildren(vnode.children, el, null, parentComponent, parentSuspense, isSVG && type !== "foreignObject", slotScopeIds, optimized);
        if (dirs) $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "created");
        setScopeId(el, vnode, vnode.scopeId, slotScopeIds, parentComponent);
        if (props) {
            for(var key in props)if (key !== "value" && !(0, $hLodm.isReservedProp)(key)) hostPatchProp(el, key, null, props[key], isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            if ("value" in props) hostPatchProp(el, "value", null, props.value);
            if (vnodeHook = props.onVnodeBeforeMount) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        }
        if (__VUE_PROD_DEVTOOLS__) {
            Object.defineProperty(el, "__vnode", {
                value: vnode,
                enumerable: false
            });
            Object.defineProperty(el, "__vueParentComponent", {
                value: parentComponent,
                enumerable: false
            });
        }
        if (dirs) $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeMount");
        var needCallTransitionHooks = (!parentSuspense || parentSuspense && !parentSuspense.pendingBranch) && transition && !transition.persisted;
        if (needCallTransitionHooks) transition.beforeEnter(el);
        hostInsert(el, container, anchor);
        if ((vnodeHook = props && props.onVnodeMounted) || needCallTransitionHooks || dirs) $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
            vnodeHook && $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            needCallTransitionHooks && transition.enter(el);
            dirs && $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "mounted");
        }, parentSuspense);
    };
    var setScopeId = function(el, vnode, scopeId, slotScopeIds, parentComponent) {
        if (scopeId) hostSetScopeId(el, scopeId);
        if (slotScopeIds) for(var i = 0; i < slotScopeIds.length; i++)hostSetScopeId(el, slotScopeIds[i]);
        if (parentComponent) {
            var subTree = parentComponent.subTree;
            if (vnode === subTree) {
                var parentVNode = parentComponent.vnode;
                setScopeId(el, parentVNode, parentVNode.scopeId, parentVNode.slotScopeIds, parentComponent.parent);
            }
        }
    };
    var mountChildren = function(children, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var start = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : 0;
        for(var i = start; i < children.length; i++){
            var child = children[i] = optimized ? $fd05d31532de2fc2$var$cloneIfMounted(children[i]) : $fd05d31532de2fc2$var$normalizeVNode(children[i]);
            patch(null, child, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    var patchElement = function(n1, n2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var el = n2.el = n1.el;
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, dirs = n2.dirs;
        patchFlag |= n1.patchFlag & 16;
        var oldProps = n1.props || (0, $hLodm.EMPTY_OBJ);
        var newProps = n2.props || (0, $hLodm.EMPTY_OBJ);
        var vnodeHook;
        parentComponent && $fd05d31532de2fc2$var$toggleRecurse(parentComponent, false);
        if (vnodeHook = newProps.onVnodeBeforeUpdate) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
        if (dirs) $fd05d31532de2fc2$var$invokeDirectiveHook(n2, n1, parentComponent, "beforeUpdate");
        parentComponent && $fd05d31532de2fc2$var$toggleRecurse(parentComponent, true);
        var areChildrenSVG = isSVG && n2.type !== "foreignObject";
        if (dynamicChildren) patchBlockChildren(n1.dynamicChildren, dynamicChildren, el, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds);
        else if (!optimized) patchChildren(n1, n2, el, null, parentComponent, parentSuspense, areChildrenSVG, slotScopeIds, false);
        if (patchFlag > 0) {
            if (patchFlag & 16) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
            else {
                if (patchFlag & 2) {
                    if (oldProps.class !== newProps.class) hostPatchProp(el, "class", null, newProps.class, isSVG);
                }
                if (patchFlag & 4) hostPatchProp(el, "style", oldProps.style, newProps.style, isSVG);
                if (patchFlag & 8) {
                    var propsToUpdate = n2.dynamicProps;
                    for(var i = 0; i < propsToUpdate.length; i++){
                        var key = propsToUpdate[i];
                        var prev = oldProps[key];
                        var next = newProps[key];
                        if (next !== prev || key === "value") hostPatchProp(el, key, prev, next, isSVG, n1.children, parentComponent, parentSuspense, unmountChildren);
                    }
                }
            }
            if (patchFlag & 1) {
                if (n1.children !== n2.children) hostSetElementText(el, n2.children);
            }
        } else if (!optimized && dynamicChildren == null) patchProps(el, n2, oldProps, newProps, parentComponent, parentSuspense, isSVG);
        if ((vnodeHook = newProps.onVnodeUpdated) || dirs) $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
            vnodeHook && $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parentComponent, n2, n1);
            dirs && $fd05d31532de2fc2$var$invokeDirectiveHook(n2, n1, parentComponent, "updated");
        }, parentSuspense);
    };
    var patchBlockChildren = function(oldChildren, newChildren, fallbackContainer, parentComponent, parentSuspense, isSVG, slotScopeIds) {
        for(var i = 0; i < newChildren.length; i++){
            var oldVNode = oldChildren[i];
            var newVNode = newChildren[i];
            var container = // oldVNode may be an errored async setup() component inside Suspense
            // which will not have a mounted element
            oldVNode.el && // - In the case of a Fragment, we need to provide the actual parent
            // of the Fragment itself so it can move its children.
            (oldVNode.type === $fd05d31532de2fc2$export$ffb0004e005737fa || // - In the case of different nodes, there is going to be a replacement
            // which also requires the correct parent container
            !$fd05d31532de2fc2$var$isSameVNodeType(oldVNode, newVNode) || // - In the case of a component, it could contain anything.
            oldVNode.shapeFlag & 70) ? hostParentNode(oldVNode.el) : // In other cases, the parent container is not actually used so we
            // just pass the block element here to avoid a DOM parentNode call.
            fallbackContainer;
            patch(oldVNode, newVNode, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, true);
        }
    };
    var patchProps = function(el, vnode, oldProps, newProps, parentComponent, parentSuspense, isSVG) {
        if (oldProps !== newProps) {
            if (oldProps !== (0, $hLodm.EMPTY_OBJ)) {
                for(var key in oldProps)if (!(0, $hLodm.isReservedProp)(key) && !(key in newProps)) hostPatchProp(el, key, oldProps[key], null, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            for(var key1 in newProps){
                if ((0, $hLodm.isReservedProp)(key1)) continue;
                var next = newProps[key1];
                var prev = oldProps[key1];
                if (next !== prev && key1 !== "value") hostPatchProp(el, key1, prev, next, isSVG, vnode.children, parentComponent, parentSuspense, unmountChildren);
            }
            if ("value" in newProps) hostPatchProp(el, "value", oldProps.value, newProps.value);
        }
    };
    var processFragment = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var fragmentStartAnchor = n2.el = n1 ? n1.el : hostCreateText("");
        var fragmentEndAnchor = n2.anchor = n1 ? n1.anchor : hostCreateText("");
        var patchFlag = n2.patchFlag, dynamicChildren = n2.dynamicChildren, fragmentSlotScopeIds = n2.slotScopeIds;
        if (fragmentSlotScopeIds) slotScopeIds = slotScopeIds ? slotScopeIds.concat(fragmentSlotScopeIds) : fragmentSlotScopeIds;
        if (n1 == null) {
            hostInsert(fragmentStartAnchor, container, anchor);
            hostInsert(fragmentEndAnchor, container, anchor);
            mountChildren(n2.children, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        } else if (patchFlag > 0 && patchFlag & 64 && dynamicChildren && // #2715 the previous fragment could've been a BAILed one as a result
        // of renderSlot() with no valid children
        n1.dynamicChildren) {
            patchBlockChildren(n1.dynamicChildren, dynamicChildren, container, parentComponent, parentSuspense, isSVG, slotScopeIds);
            if (// #2080 if the stable fragment has a key, it's a <template v-for> that may
            //  get moved around. Make sure all root level vnodes inherit el.
            // #2134 or if it's a component root, it may also get moved around
            // as the component is being moved.
            n2.key != null || parentComponent && n2 === parentComponent.subTree) $fd05d31532de2fc2$var$traverseStaticChildren(n1, n2, true);
        } else patchChildren(n1, n2, container, fragmentEndAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
    };
    var processComponent = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        n2.slotScopeIds = slotScopeIds;
        if (n1 == null) {
            if (n2.shapeFlag & 512) parentComponent.ctx.activate(n2, container, anchor, isSVG, optimized);
            else mountComponent(n2, container, anchor, parentComponent, parentSuspense, isSVG, optimized);
        } else updateComponent(n1, n2, optimized);
    };
    var mountComponent = function(initialVNode, container, anchor, parentComponent, parentSuspense, isSVG, optimized) {
        var instance = initialVNode.component = $fd05d31532de2fc2$var$createComponentInstance(initialVNode, parentComponent, parentSuspense);
        if ($fd05d31532de2fc2$var$isKeepAlive(initialVNode)) instance.ctx.renderer = internals;
        $fd05d31532de2fc2$var$setupComponent(instance);
        if (instance.asyncDep) {
            parentSuspense && parentSuspense.registerDep(instance, setupRenderEffect);
            if (!initialVNode.el) {
                var placeholder = instance.subTree = $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$4d299b491347818a);
                processCommentNode(null, placeholder, container, anchor);
            }
            return;
        }
        setupRenderEffect(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized);
    };
    var updateComponent = function(n1, n2, optimized) {
        var instance = n2.component = n1.component;
        if ($fd05d31532de2fc2$var$shouldUpdateComponent(n1, n2, optimized)) {
            if (instance.asyncDep && !instance.asyncResolved) {
                updateComponentPreRender(instance, n2, optimized);
                return;
            } else {
                instance.next = n2;
                $fd05d31532de2fc2$var$invalidateJob(instance.update);
                instance.update();
            }
        } else {
            n2.el = n1.el;
            instance.vnode = n2;
        }
    };
    var setupRenderEffect = function(instance, initialVNode, container, anchor, parentSuspense, isSVG, optimized) {
        var componentUpdateFn = function() {
            if (!instance.isMounted) {
                var vnodeHook;
                var el = initialVNode.el, props = initialVNode.props;
                var bm = instance.bm, m = instance.m, parent = instance.parent;
                var isAsyncWrapperVNode = $fd05d31532de2fc2$var$isAsyncWrapper(initialVNode);
                $fd05d31532de2fc2$var$toggleRecurse(instance, false);
                if (bm) (0, $hLodm.invokeArrayFns)(bm);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeBeforeMount)) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parent, initialVNode);
                $fd05d31532de2fc2$var$toggleRecurse(instance, true);
                if (el && hydrateNode) {
                    var hydrateSubTree = function() {
                        instance.subTree = $fd05d31532de2fc2$var$renderComponentRoot(instance);
                        hydrateNode(el, instance.subTree, instance, parentSuspense, null);
                    };
                    if (isAsyncWrapperVNode) initialVNode.type.__asyncLoader().then(// note: we are moving the render call into an async callback,
                    // which means it won't track dependencies - but it's ok because
                    // a server-rendered async wrapper is already in resolved state
                    // and it will never need to change.
                    function() {
                        return !instance.isUnmounted && hydrateSubTree();
                    });
                    else hydrateSubTree();
                } else {
                    var subTree = instance.subTree = $fd05d31532de2fc2$var$renderComponentRoot(instance);
                    patch(null, subTree, container, anchor, instance, parentSuspense, isSVG);
                    initialVNode.el = subTree.el;
                }
                if (m) $fd05d31532de2fc2$var$queuePostRenderEffect(m, parentSuspense);
                if (!isAsyncWrapperVNode && (vnodeHook = props && props.onVnodeMounted)) {
                    var scopedInitialVNode = initialVNode;
                    $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
                        return $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parent, scopedInitialVNode);
                    }, parentSuspense);
                }
                if (initialVNode.shapeFlag & 256 || parent && $fd05d31532de2fc2$var$isAsyncWrapper(parent.vnode) && parent.vnode.shapeFlag & 256) instance.a && $fd05d31532de2fc2$var$queuePostRenderEffect(instance.a, parentSuspense);
                instance.isMounted = true;
                if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsComponentAdded(instance);
                initialVNode = container = anchor = null;
            } else {
                var next = instance.next, bu = instance.bu, u = instance.u, parent1 = instance.parent, vnode = instance.vnode;
                var originNext = next;
                var vnodeHook1;
                $fd05d31532de2fc2$var$toggleRecurse(instance, false);
                if (next) {
                    next.el = vnode.el;
                    updateComponentPreRender(instance, next, optimized);
                } else next = vnode;
                if (bu) (0, $hLodm.invokeArrayFns)(bu);
                if (vnodeHook1 = next.props && next.props.onVnodeBeforeUpdate) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                $fd05d31532de2fc2$var$toggleRecurse(instance, true);
                var nextTree = $fd05d31532de2fc2$var$renderComponentRoot(instance);
                var prevTree = instance.subTree;
                instance.subTree = nextTree;
                patch(prevTree, nextTree, // parent may have changed if it's in a teleport
                hostParentNode(prevTree.el), // anchor may have changed if it's in a fragment
                getNextHostNode(prevTree), instance, parentSuspense, isSVG);
                next.el = nextTree.el;
                if (originNext === null) $fd05d31532de2fc2$var$updateHOCHostEl(instance, nextTree.el);
                if (u) $fd05d31532de2fc2$var$queuePostRenderEffect(u, parentSuspense);
                if (vnodeHook1 = next.props && next.props.onVnodeUpdated) $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
                    return $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook1, parent1, next, vnode);
                }, parentSuspense);
                if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsComponentUpdated(instance);
            }
        };
        var effect = instance.effect = new (0, $yQ0Ka.ReactiveEffect)(componentUpdateFn, function() {
            return $fd05d31532de2fc2$var$queueJob(update);
        }, instance.scope);
        var update = instance.update = function() {
            return effect.run();
        };
        update.id = instance.uid;
        $fd05d31532de2fc2$var$toggleRecurse(instance, true);
        var e, e1;
        update();
    };
    var updateComponentPreRender = function(instance, nextVNode, optimized) {
        nextVNode.component = instance;
        var prevProps = instance.vnode.props;
        instance.vnode = nextVNode;
        instance.next = null;
        $fd05d31532de2fc2$var$updateProps(instance, nextVNode.props, prevProps, optimized);
        $fd05d31532de2fc2$var$updateSlots(instance, nextVNode.children, optimized);
        (0, $yQ0Ka.pauseTracking)();
        $fd05d31532de2fc2$var$flushPreFlushCbs();
        (0, $yQ0Ka.resetTracking)();
    };
    var patchChildren = function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds) {
        var optimized = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : false;
        var c1 = n1 && n1.children;
        var prevShapeFlag = n1 ? n1.shapeFlag : 0;
        var c2 = n2.children;
        var patchFlag = n2.patchFlag, shapeFlag = n2.shapeFlag;
        if (patchFlag > 0) {
            if (patchFlag & 128) {
                patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            } else if (patchFlag & 256) {
                patchUnkeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                return;
            }
        }
        if (shapeFlag & 8) {
            if (prevShapeFlag & 16) unmountChildren(c1, parentComponent, parentSuspense);
            if (c2 !== c1) hostSetElementText(container, c2);
        } else if (prevShapeFlag & 16) {
            if (shapeFlag & 16) patchKeyedChildren(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else unmountChildren(c1, parentComponent, parentSuspense, true);
        } else {
            if (prevShapeFlag & 8) hostSetElementText(container, "");
            if (shapeFlag & 16) mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
    };
    var patchUnkeyedChildren = function(c1, c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        c1 = c1 || (0, $hLodm.EMPTY_ARR);
        c2 = c2 || (0, $hLodm.EMPTY_ARR);
        var oldLength = c1.length;
        var newLength = c2.length;
        var commonLength = Math.min(oldLength, newLength);
        var i;
        for(i = 0; i < commonLength; i++){
            var nextChild = c2[i] = optimized ? $fd05d31532de2fc2$var$cloneIfMounted(c2[i]) : $fd05d31532de2fc2$var$normalizeVNode(c2[i]);
            patch(c1[i], nextChild, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
        }
        if (oldLength > newLength) unmountChildren(c1, parentComponent, parentSuspense, true, false, commonLength);
        else mountChildren(c2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, commonLength);
    };
    var patchKeyedChildren = function(c1, c2, container, parentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized) {
        var i = 0;
        var l2 = c2.length;
        var e1 = c1.length - 1;
        var e2 = l2 - 1;
        while(i <= e1 && i <= e2){
            var n1 = c1[i];
            var n2 = c2[i] = optimized ? $fd05d31532de2fc2$var$cloneIfMounted(c2[i]) : $fd05d31532de2fc2$var$normalizeVNode(c2[i]);
            if ($fd05d31532de2fc2$var$isSameVNodeType(n1, n2)) patch(n1, n2, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            i++;
        }
        while(i <= e1 && i <= e2){
            var n11 = c1[e1];
            var n21 = c2[e2] = optimized ? $fd05d31532de2fc2$var$cloneIfMounted(c2[e2]) : $fd05d31532de2fc2$var$normalizeVNode(c2[e2]);
            if ($fd05d31532de2fc2$var$isSameVNodeType(n11, n21)) patch(n11, n21, container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            else break;
            e1--;
            e2--;
        }
        if (i > e1) {
            if (i <= e2) {
                var nextPos = e2 + 1;
                var anchor = nextPos < l2 ? c2[nextPos].el : parentAnchor;
                while(i <= e2){
                    patch(null, c2[i] = optimized ? $fd05d31532de2fc2$var$cloneIfMounted(c2[i]) : $fd05d31532de2fc2$var$normalizeVNode(c2[i]), container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    i++;
                }
            }
        } else if (i > e2) while(i <= e1){
            unmount(c1[i], parentComponent, parentSuspense, true);
            i++;
        }
        else {
            var s1 = i;
            var s2 = i;
            var keyToNewIndexMap = /* @__PURE__ */ new Map();
            for(i = s2; i <= e2; i++){
                var nextChild = c2[i] = optimized ? $fd05d31532de2fc2$var$cloneIfMounted(c2[i]) : $fd05d31532de2fc2$var$normalizeVNode(c2[i]);
                if (nextChild.key != null) keyToNewIndexMap.set(nextChild.key, i);
            }
            var j;
            var patched = 0;
            var toBePatched = e2 - s2 + 1;
            var moved = false;
            var maxNewIndexSoFar = 0;
            var newIndexToOldIndexMap = new Array(toBePatched);
            for(i = 0; i < toBePatched; i++)newIndexToOldIndexMap[i] = 0;
            for(i = s1; i <= e1; i++){
                var prevChild = c1[i];
                if (patched >= toBePatched) {
                    unmount(prevChild, parentComponent, parentSuspense, true);
                    continue;
                }
                var newIndex = void 0;
                if (prevChild.key != null) newIndex = keyToNewIndexMap.get(prevChild.key);
                else {
                    for(j = s2; j <= e2; j++)if (newIndexToOldIndexMap[j - s2] === 0 && $fd05d31532de2fc2$var$isSameVNodeType(prevChild, c2[j])) {
                        newIndex = j;
                        break;
                    }
                }
                if (newIndex === void 0) unmount(prevChild, parentComponent, parentSuspense, true);
                else {
                    newIndexToOldIndexMap[newIndex - s2] = i + 1;
                    if (newIndex >= maxNewIndexSoFar) maxNewIndexSoFar = newIndex;
                    else moved = true;
                    patch(prevChild, c2[newIndex], container, null, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                    patched++;
                }
            }
            var increasingNewIndexSequence = moved ? $fd05d31532de2fc2$var$getSequence(newIndexToOldIndexMap) : (0, $hLodm.EMPTY_ARR);
            j = increasingNewIndexSequence.length - 1;
            for(i = toBePatched - 1; i >= 0; i--){
                var nextIndex = s2 + i;
                var nextChild1 = c2[nextIndex];
                var anchor1 = nextIndex + 1 < l2 ? c2[nextIndex + 1].el : parentAnchor;
                if (newIndexToOldIndexMap[i] === 0) patch(null, nextChild1, container, anchor1, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
                else if (moved) {
                    if (j < 0 || i !== increasingNewIndexSequence[j]) move(nextChild1, container, anchor1, 2);
                    else j--;
                }
            }
        }
    };
    var move = function(vnode, container, anchor, moveType) {
        var parentSuspense = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
        var el = vnode.el, type = vnode.type, transition = vnode.transition, children = vnode.children, shapeFlag = vnode.shapeFlag;
        if (shapeFlag & 6) {
            move(vnode.component.subTree, container, anchor, moveType);
            return;
        }
        if (shapeFlag & 128) {
            vnode.suspense.move(container, anchor, moveType);
            return;
        }
        if (shapeFlag & 64) {
            type.move(vnode, container, anchor, internals);
            return;
        }
        if (type === $fd05d31532de2fc2$export$ffb0004e005737fa) {
            hostInsert(el, container, anchor);
            for(var i = 0; i < children.length; i++)move(children[i], container, anchor, moveType);
            hostInsert(vnode.anchor, container, anchor);
            return;
        }
        if (type === $fd05d31532de2fc2$export$c1b9a1d3af45b7b6) {
            moveStaticNode(vnode, container, anchor);
            return;
        }
        var needTransition = moveType !== 2 && shapeFlag & 1 && transition;
        if (needTransition) {
            if (moveType === 0) {
                transition.beforeEnter(el);
                hostInsert(el, container, anchor);
                $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
                    return transition.enter(el);
                }, parentSuspense);
            } else {
                var leave = transition.leave, delayLeave = transition.delayLeave, afterLeave = transition.afterLeave;
                var remove2 = function() {
                    return hostInsert(el, container, anchor);
                };
                var performLeave = function() {
                    leave(el, function() {
                        remove2();
                        afterLeave && afterLeave();
                    });
                };
                if (delayLeave) delayLeave(el, remove2, performLeave);
                else performLeave();
            }
        } else hostInsert(el, container, anchor);
    };
    var unmount = function(vnode, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
        var type = vnode.type, props = vnode.props, ref = vnode.ref, children = vnode.children, dynamicChildren = vnode.dynamicChildren, shapeFlag = vnode.shapeFlag, patchFlag = vnode.patchFlag, dirs = vnode.dirs;
        if (ref != null) $fd05d31532de2fc2$var$setRef(ref, null, parentSuspense, vnode, true);
        if (shapeFlag & 256) {
            parentComponent.ctx.deactivate(vnode);
            return;
        }
        var shouldInvokeDirs = shapeFlag & 1 && dirs;
        var shouldInvokeVnodeHook = !$fd05d31532de2fc2$var$isAsyncWrapper(vnode);
        var vnodeHook;
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeBeforeUnmount)) $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
        if (shapeFlag & 6) unmountComponent(vnode.component, parentSuspense, doRemove);
        else {
            if (shapeFlag & 128) {
                vnode.suspense.unmount(parentSuspense, doRemove);
                return;
            }
            if (shouldInvokeDirs) $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "beforeUnmount");
            if (shapeFlag & 64) vnode.type.remove(vnode, parentComponent, parentSuspense, optimized, internals, doRemove);
            else if (dynamicChildren && // #1153: fast path should not be taken for non-stable (v-for) fragments
            (type !== $fd05d31532de2fc2$export$ffb0004e005737fa || patchFlag > 0 && patchFlag & 64)) unmountChildren(dynamicChildren, parentComponent, parentSuspense, false, true);
            else if (type === $fd05d31532de2fc2$export$ffb0004e005737fa && patchFlag & 384 || !optimized && shapeFlag & 16) unmountChildren(children, parentComponent, parentSuspense);
            if (doRemove) remove(vnode);
        }
        if (shouldInvokeVnodeHook && (vnodeHook = props && props.onVnodeUnmounted) || shouldInvokeDirs) $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
            vnodeHook && $fd05d31532de2fc2$var$invokeVNodeHook(vnodeHook, parentComponent, vnode);
            shouldInvokeDirs && $fd05d31532de2fc2$var$invokeDirectiveHook(vnode, null, parentComponent, "unmounted");
        }, parentSuspense);
    };
    var remove = function(vnode) {
        var type = vnode.type, el = vnode.el, anchor = vnode.anchor, transition = vnode.transition;
        if (type === $fd05d31532de2fc2$export$ffb0004e005737fa) {
            var child;
            removeFragment(el, anchor);
            return;
        }
        if (type === $fd05d31532de2fc2$export$c1b9a1d3af45b7b6) {
            removeStaticNode(vnode);
            return;
        }
        var performRemove = function() {
            hostRemove(el);
            if (transition && !transition.persisted && transition.afterLeave) transition.afterLeave();
        };
        if (vnode.shapeFlag & 1 && transition && !transition.persisted) {
            var leave = transition.leave, delayLeave = transition.delayLeave;
            var performLeave = function() {
                return leave(el, performRemove);
            };
            if (delayLeave) delayLeave(vnode.el, performRemove, performLeave);
            else performLeave();
        } else performRemove();
    };
    var removeFragment = function(cur, end) {
        var next;
        while(cur !== end){
            next = hostNextSibling(cur);
            hostRemove(cur);
            cur = next;
        }
        hostRemove(end);
    };
    var unmountComponent = function(instance, parentSuspense, doRemove) {
        var bum = instance.bum, scope = instance.scope, update = instance.update, subTree = instance.subTree, um = instance.um;
        if (bum) (0, $hLodm.invokeArrayFns)(bum);
        scope.stop();
        if (update) {
            update.active = false;
            unmount(subTree, instance, parentSuspense, doRemove);
        }
        if (um) $fd05d31532de2fc2$var$queuePostRenderEffect(um, parentSuspense);
        $fd05d31532de2fc2$var$queuePostRenderEffect(function() {
            instance.isUnmounted = true;
        }, parentSuspense);
        if (parentSuspense && parentSuspense.pendingBranch && !parentSuspense.isUnmounted && instance.asyncDep && !instance.asyncResolved && instance.suspenseId === parentSuspense.pendingId) {
            parentSuspense.deps--;
            if (parentSuspense.deps === 0) parentSuspense.resolve();
        }
        if (__VUE_PROD_DEVTOOLS__) $fd05d31532de2fc2$var$devtoolsComponentRemoved(instance);
    };
    var unmountChildren = function(children, parentComponent, parentSuspense) {
        var doRemove = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, optimized = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, start = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 0;
        for(var i = start; i < children.length; i++)unmount(children[i], parentComponent, parentSuspense, doRemove, optimized);
    };
    var getNextHostNode = function(vnode) {
        if (vnode.shapeFlag & 6) return getNextHostNode(vnode.component.subTree);
        if (vnode.shapeFlag & 128) return vnode.suspense.next();
        return hostNextSibling(vnode.anchor || vnode.el);
    };
    var render = function(vnode, container, isSVG) {
        if (vnode == null) {
            if (container._vnode) unmount(container._vnode, null, null, true);
        } else patch(container._vnode || null, vnode, container, null, null, null, isSVG);
        $fd05d31532de2fc2$var$flushPreFlushCbs();
        $fd05d31532de2fc2$var$flushPostFlushCbs();
        container._vnode = vnode;
    };
    var internals = {
        p: patch,
        um: unmount,
        m: move,
        r: remove,
        mt: mountComponent,
        mc: mountChildren,
        pc: patchChildren,
        pbc: patchBlockChildren,
        n: getNextHostNode,
        o: options
    };
    var hydrate;
    var hydrateNode;
    var ref;
    if (createHydrationFns) ref = (0, $cv9Rk._)(createHydrationFns(internals), 2), hydrate = ref[0], hydrateNode = ref[1], ref;
    return {
        render: render,
        hydrate: hydrate,
        createApp: $fd05d31532de2fc2$var$createAppAPI(render, hydrate)
    };
}
function $fd05d31532de2fc2$var$toggleRecurse(param, allowed) {
    var effect = param.effect, update = param.update;
    effect.allowRecurse = update.allowRecurse = allowed;
}
function $fd05d31532de2fc2$var$traverseStaticChildren(n1, n2) {
    var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var ch1 = n1.children;
    var ch2 = n2.children;
    if ((0, $hLodm.isArray)(ch1) && (0, $hLodm.isArray)(ch2)) for(var i = 0; i < ch1.length; i++){
        var c1 = ch1[i];
        var c2 = ch2[i];
        if (c2.shapeFlag & 1 && !c2.dynamicChildren) {
            if (c2.patchFlag <= 0 || c2.patchFlag === 32) {
                c2 = ch2[i] = $fd05d31532de2fc2$var$cloneIfMounted(ch2[i]);
                c2.el = c1.el;
            }
            if (!shallow) $fd05d31532de2fc2$var$traverseStaticChildren(c1, c2);
        }
        if (c2.type === $fd05d31532de2fc2$export$5f1af8db9871e1d6) c2.el = c1.el;
    }
}
function $fd05d31532de2fc2$var$getSequence(arr) {
    var p = arr.slice();
    var result = [
        0
    ];
    var i, j, u, v1, c;
    var len = arr.length;
    for(i = 0; i < len; i++){
        var arrI = arr[i];
        if (arrI !== 0) {
            j = result[result.length - 1];
            if (arr[j] < arrI) {
                p[i] = j;
                result.push(i);
                continue;
            }
            u = 0;
            v1 = result.length - 1;
            while(u < v1){
                c = u + v1 >> 1;
                if (arr[result[c]] < arrI) u = c + 1;
                else v1 = c;
            }
            if (arrI < arr[result[u]]) {
                if (u > 0) p[i] = result[u - 1];
                result[u] = i;
            }
        }
    }
    u = result.length;
    v1 = result[u - 1];
    while(u-- > 0){
        result[u] = v1;
        v1 = p[v1];
    }
    return result;
}
var $fd05d31532de2fc2$var$isTeleport = function(type) {
    return type.__isTeleport;
};
var $fd05d31532de2fc2$var$isTeleportDisabled = function(props) {
    return props && (props.disabled || props.disabled === "");
};
var $fd05d31532de2fc2$var$isTargetSVG = function(target) {
    return typeof SVGElement !== "undefined" && target instanceof SVGElement;
};
var $fd05d31532de2fc2$var$resolveTarget = function(props, select) {
    var targetSelector = props && props.to;
    if ((0, $hLodm.isString)(targetSelector)) {
        if (!select) return null;
        else {
            var target = select(targetSelector);
            target;
            return target;
        }
    } else return targetSelector;
};
var $fd05d31532de2fc2$var$_obj2;
var $fd05d31532de2fc2$var$TeleportImpl = ($fd05d31532de2fc2$var$_obj2 = {
    __isTeleport: true,
    process: function(n1, n2, container, anchor, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized, internals) {
        var mountChildren = internals.mc, patchChildren = internals.pc, patchBlockChildren = internals.pbc, _internals_o = internals.o, insert = _internals_o.insert, querySelector = _internals_o.querySelector, createText = _internals_o.createText, createComment = _internals_o.createComment;
        var disabled = $fd05d31532de2fc2$var$isTeleportDisabled(n2.props);
        var shapeFlag = n2.shapeFlag, children = n2.children, dynamicChildren = n2.dynamicChildren;
        if (n1 == null) {
            var placeholder = n2.el = createText("");
            var mainAnchor = n2.anchor = createText("");
            insert(placeholder, container, anchor);
            insert(mainAnchor, container, anchor);
            var target = n2.target = $fd05d31532de2fc2$var$resolveTarget(n2.props, querySelector);
            var targetAnchor = n2.targetAnchor = createText("");
            if (target) {
                insert(targetAnchor, target);
                isSVG = isSVG || $fd05d31532de2fc2$var$isTargetSVG(target);
            }
            var mount = function(container2, anchor2) {
                if (shapeFlag & 16) mountChildren(children, container2, anchor2, parentComponent, parentSuspense, isSVG, slotScopeIds, optimized);
            };
            if (disabled) mount(container, mainAnchor);
            else if (target) mount(target, targetAnchor);
        } else {
            n2.el = n1.el;
            var mainAnchor1 = n2.anchor = n1.anchor;
            var target1 = n2.target = n1.target;
            var targetAnchor1 = n2.targetAnchor = n1.targetAnchor;
            var wasDisabled = $fd05d31532de2fc2$var$isTeleportDisabled(n1.props);
            var currentContainer = wasDisabled ? container : target1;
            var currentAnchor = wasDisabled ? mainAnchor1 : targetAnchor1;
            isSVG = isSVG || $fd05d31532de2fc2$var$isTargetSVG(target1);
            if (dynamicChildren) {
                patchBlockChildren(n1.dynamicChildren, dynamicChildren, currentContainer, parentComponent, parentSuspense, isSVG, slotScopeIds);
                $fd05d31532de2fc2$var$traverseStaticChildren(n1, n2, true);
            } else if (!optimized) patchChildren(n1, n2, currentContainer, currentAnchor, parentComponent, parentSuspense, isSVG, slotScopeIds, false);
            if (disabled) {
                if (!wasDisabled) $fd05d31532de2fc2$var$moveTeleport(n2, container, mainAnchor1, internals, 1);
            } else {
                if ((n2.props && n2.props.to) !== (n1.props && n1.props.to)) {
                    var nextTarget = n2.target = $fd05d31532de2fc2$var$resolveTarget(n2.props, querySelector);
                    if (nextTarget) $fd05d31532de2fc2$var$moveTeleport(n2, nextTarget, null, internals, 0);
                } else if (wasDisabled) $fd05d31532de2fc2$var$moveTeleport(n2, target1, targetAnchor1, internals, 1);
            }
        }
        $fd05d31532de2fc2$var$updateCssVars(n2);
    }
}, (0, $3sHb8._)($fd05d31532de2fc2$var$_obj2, "remove", function(vnode, parentComponent, parentSuspense, optimized, param, doRemove) {
    var unmount = param.um, _param_o = param["o"], hostRemove = _param_o["remove"];
    var shapeFlag = vnode.shapeFlag, children = vnode.children, anchor = vnode.anchor, targetAnchor = vnode.targetAnchor, target = vnode.target, props = vnode.props;
    if (target) hostRemove(targetAnchor);
    if (doRemove || !$fd05d31532de2fc2$var$isTeleportDisabled(props)) {
        hostRemove(anchor);
        if (shapeFlag & 16) for(var i = 0; i < children.length; i++){
            var child = children[i];
            unmount(child, parentComponent, parentSuspense, true, !!child.dynamicChildren);
        }
    }
}), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj2, "move", $fd05d31532de2fc2$var$moveTeleport), (0, $3sHb8._)($fd05d31532de2fc2$var$_obj2, "hydrate", $fd05d31532de2fc2$var$hydrateTeleport), $fd05d31532de2fc2$var$_obj2);
function $fd05d31532de2fc2$var$moveTeleport(vnode, container, parentAnchor, param) {
    var insert = param.o.insert, move = param.m, moveType = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 2;
    if (moveType === 0) insert(vnode.targetAnchor, container, parentAnchor);
    var el = vnode.el, anchor = vnode.anchor, shapeFlag = vnode.shapeFlag, children = vnode.children, props = vnode.props;
    var isReorder = moveType === 2;
    if (isReorder) insert(el, container, parentAnchor);
    if (!isReorder || $fd05d31532de2fc2$var$isTeleportDisabled(props)) {
        if (shapeFlag & 16) for(var i = 0; i < children.length; i++)move(children[i], container, parentAnchor, 2);
    }
    if (isReorder) insert(anchor, container, parentAnchor);
}
function $fd05d31532de2fc2$var$hydrateTeleport(node, vnode, parentComponent, parentSuspense, slotScopeIds, optimized, param, hydrateChildren) {
    var _param_o = param.o, nextSibling = _param_o.nextSibling, parentNode = _param_o.parentNode, querySelector = _param_o.querySelector;
    var target = vnode.target = $fd05d31532de2fc2$var$resolveTarget(vnode.props, querySelector);
    if (target) {
        var targetNode = target._lpa || target.firstChild;
        if (vnode.shapeFlag & 16) {
            if ($fd05d31532de2fc2$var$isTeleportDisabled(vnode.props)) {
                vnode.anchor = hydrateChildren(nextSibling(node), vnode, parentNode(node), parentComponent, parentSuspense, slotScopeIds, optimized);
                vnode.targetAnchor = targetNode;
            } else {
                vnode.anchor = nextSibling(node);
                var targetAnchor = targetNode;
                while(targetAnchor){
                    targetAnchor = nextSibling(targetAnchor);
                    if (targetAnchor && targetAnchor.nodeType === 8 && targetAnchor.data === "teleport anchor") {
                        vnode.targetAnchor = targetAnchor;
                        target._lpa = vnode.targetAnchor && nextSibling(vnode.targetAnchor);
                        break;
                    }
                }
                hydrateChildren(targetNode, vnode, target, parentComponent, parentSuspense, slotScopeIds, optimized);
            }
        }
        $fd05d31532de2fc2$var$updateCssVars(vnode);
    }
    return vnode.anchor && nextSibling(vnode.anchor);
}
var $fd05d31532de2fc2$export$76d55a0304a371f4 = $fd05d31532de2fc2$var$TeleportImpl;
function $fd05d31532de2fc2$var$updateCssVars(vnode) {
    var ctx = vnode.ctx;
    if (ctx && ctx.ut) {
        var node = vnode.children[0].el;
        while(node !== vnode.targetAnchor){
            if (node.nodeType === 1) node.setAttribute("data-v-owner", ctx.uid);
            node = node.nextSibling;
        }
        ctx.ut();
    }
}
var $fd05d31532de2fc2$export$ffb0004e005737fa = Symbol.for("v-fgt");
var $fd05d31532de2fc2$export$5f1af8db9871e1d6 = Symbol.for("v-txt");
var $fd05d31532de2fc2$export$4d299b491347818a = Symbol.for("v-cmt");
var $fd05d31532de2fc2$export$c1b9a1d3af45b7b6 = Symbol.for("v-stc");
var $fd05d31532de2fc2$var$blockStack = [];
var $fd05d31532de2fc2$var$currentBlock = null;
function $fd05d31532de2fc2$export$e7eaa45e502fe5cc() {
    var disableTracking = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    $fd05d31532de2fc2$var$blockStack.push($fd05d31532de2fc2$var$currentBlock = disableTracking ? null : []);
}
function $fd05d31532de2fc2$var$closeBlock() {
    $fd05d31532de2fc2$var$blockStack.pop();
    $fd05d31532de2fc2$var$currentBlock = $fd05d31532de2fc2$var$blockStack[$fd05d31532de2fc2$var$blockStack.length - 1] || null;
}
var $fd05d31532de2fc2$var$isBlockTreeEnabled = 1;
function $fd05d31532de2fc2$export$c20bee82f26f1e27(value1) {
    $fd05d31532de2fc2$var$isBlockTreeEnabled += value1;
}
function $fd05d31532de2fc2$var$setupBlock(vnode) {
    vnode.dynamicChildren = $fd05d31532de2fc2$var$isBlockTreeEnabled > 0 ? $fd05d31532de2fc2$var$currentBlock || (0, $hLodm.EMPTY_ARR) : null;
    $fd05d31532de2fc2$var$closeBlock();
    if ($fd05d31532de2fc2$var$isBlockTreeEnabled > 0 && $fd05d31532de2fc2$var$currentBlock) $fd05d31532de2fc2$var$currentBlock.push(vnode);
    return vnode;
}
function $fd05d31532de2fc2$export$167055419fc69ec1(type, props, children, patchFlag, dynamicProps, shapeFlag) {
    return $fd05d31532de2fc2$var$setupBlock($fd05d31532de2fc2$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, true));
}
function $fd05d31532de2fc2$export$9f2dfe8048dfb22b(type, props, children, patchFlag, dynamicProps) {
    return $fd05d31532de2fc2$var$setupBlock($fd05d31532de2fc2$export$bf5c4cf060303d58(type, props, children, patchFlag, dynamicProps, true));
}
function $fd05d31532de2fc2$export$3868d13f8734ae81(value1) {
    return value1 ? value1.__v_isVNode === true : false;
}
function $fd05d31532de2fc2$var$isSameVNodeType(n1, n2) {
    return n1.type === n2.type && n1.key === n2.key;
}
var $fd05d31532de2fc2$var$vnodeArgsTransformer;
function $fd05d31532de2fc2$export$83beccd3afeeb809(transformer) {
    $fd05d31532de2fc2$var$vnodeArgsTransformer = transformer;
}
var $fd05d31532de2fc2$var$createVNodeWithArgsTransform = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    return $fd05d31532de2fc2$var$_createVNode.apply(void 0, (0, $c6Xmf._)($fd05d31532de2fc2$var$vnodeArgsTransformer ? $fd05d31532de2fc2$var$vnodeArgsTransformer(args, $fd05d31532de2fc2$var$currentRenderingInstance) : args));
};
var $fd05d31532de2fc2$var$InternalObjectKey = "__vInternal";
var $fd05d31532de2fc2$var$normalizeKey = function(param) {
    var key = param.key;
    return key != null ? key : null;
};
var $fd05d31532de2fc2$var$normalizeRef = function(param) {
    var ref = param.ref, ref_key = param.ref_key, ref_for = param.ref_for;
    if (typeof ref === "number") ref = "" + ref;
    return ref != null ? (0, $hLodm.isString)(ref) || (0, $yQ0Ka.isRef)(ref) || (0, $hLodm.isFunction)(ref) ? {
        i: $fd05d31532de2fc2$var$currentRenderingInstance,
        r: ref,
        k: ref_key,
        f: !!ref_for
    } : ref : null;
};
function $fd05d31532de2fc2$export$42098e0eaa15c48e(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, shapeFlag = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : type === $fd05d31532de2fc2$export$ffb0004e005737fa ? 0 : 1, isBlockNode = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : false, needFullChildrenNormalization = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : false;
    var vnode = {
        __v_isVNode: true,
        __v_skip: true,
        type: type,
        props: props,
        key: props && $fd05d31532de2fc2$var$normalizeKey(props),
        ref: props && $fd05d31532de2fc2$var$normalizeRef(props),
        scopeId: $fd05d31532de2fc2$var$currentScopeId,
        slotScopeIds: null,
        children: children,
        component: null,
        suspense: null,
        ssContent: null,
        ssFallback: null,
        dirs: null,
        transition: null,
        el: null,
        anchor: null,
        target: null,
        targetAnchor: null,
        staticCount: 0,
        shapeFlag: shapeFlag,
        patchFlag: patchFlag,
        dynamicProps: dynamicProps,
        dynamicChildren: null,
        appContext: null,
        ctx: $fd05d31532de2fc2$var$currentRenderingInstance
    };
    if (needFullChildrenNormalization) {
        $fd05d31532de2fc2$var$normalizeChildren(vnode, children);
        if (shapeFlag & 128) type.normalize(vnode);
    } else if (children) vnode.shapeFlag |= (0, $hLodm.isString)(children) ? 8 : 16;
    if ($fd05d31532de2fc2$var$isBlockTreeEnabled > 0 && // avoid a block node from tracking itself
    !isBlockNode && // has current parent block
    $fd05d31532de2fc2$var$currentBlock && // presence of a patch flag indicates this node needs patching on updates.
    // component nodes also should always be patched, because even if the
    // component doesn't need to update, it needs to persist the instance on to
    // the next vnode so that it can be properly unmounted later.
    (vnode.patchFlag > 0 || shapeFlag & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
    // vnode should not be considered dynamic due to handler caching.
    vnode.patchFlag !== 32) $fd05d31532de2fc2$var$currentBlock.push(vnode);
    return vnode;
}
var $fd05d31532de2fc2$export$bf5c4cf060303d58 = $fd05d31532de2fc2$var$_createVNode;
function $fd05d31532de2fc2$var$_createVNode(type) {
    var props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, children = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, patchFlag = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0, dynamicProps = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null, isBlockNode = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    if (!type || type === $fd05d31532de2fc2$var$NULL_DYNAMIC_COMPONENT) type = $fd05d31532de2fc2$export$4d299b491347818a;
    if ($fd05d31532de2fc2$export$3868d13f8734ae81(type)) {
        var cloned = $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(type, props, true);
        if (children) $fd05d31532de2fc2$var$normalizeChildren(cloned, children);
        if ($fd05d31532de2fc2$var$isBlockTreeEnabled > 0 && !isBlockNode && $fd05d31532de2fc2$var$currentBlock) {
            if (cloned.shapeFlag & 6) $fd05d31532de2fc2$var$currentBlock[$fd05d31532de2fc2$var$currentBlock.indexOf(type)] = cloned;
            else $fd05d31532de2fc2$var$currentBlock.push(cloned);
        }
        cloned.patchFlag |= -2;
        return cloned;
    }
    if ($fd05d31532de2fc2$var$isClassComponent(type)) type = type.__vccOpts;
    if (props) {
        props = $fd05d31532de2fc2$export$1f1be0e0e384d7d2(props);
        var klass = props.class, style = props.style;
        if (klass && !(0, $hLodm.isString)(klass)) props.class = (0, $hLodm.normalizeClass)(klass);
        if ((0, $hLodm.isObject)(style)) {
            if ((0, $yQ0Ka.isProxy)(style) && !(0, $hLodm.isArray)(style)) style = (0, $hLodm.extend)({}, style);
            props.style = (0, $hLodm.normalizeStyle)(style);
        }
    }
    var shapeFlag = (0, $hLodm.isString)(type) ? 1 : $fd05d31532de2fc2$var$isSuspense(type) ? 128 : $fd05d31532de2fc2$var$isTeleport(type) ? 64 : (0, $hLodm.isObject)(type) ? 4 : (0, $hLodm.isFunction)(type) ? 2 : 0;
    return $fd05d31532de2fc2$export$42098e0eaa15c48e(type, props, children, patchFlag, dynamicProps, shapeFlag, isBlockNode, true);
}
function $fd05d31532de2fc2$export$1f1be0e0e384d7d2(props) {
    if (!props) return null;
    return (0, $yQ0Ka.isProxy)(props) || $fd05d31532de2fc2$var$InternalObjectKey in props ? (0, $hLodm.extend)({}, props) : props;
}
function $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(vnode, extraProps) {
    var mergeRef = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var props = vnode.props, ref = vnode.ref, patchFlag = vnode.patchFlag, children = vnode.children;
    var mergedProps = extraProps ? $fd05d31532de2fc2$export$9d1611c77c2fe928(props || {}, extraProps) : props;
    var cloned = {
        __v_isVNode: true,
        __v_skip: true,
        type: vnode.type,
        props: mergedProps,
        key: mergedProps && $fd05d31532de2fc2$var$normalizeKey(mergedProps),
        ref: extraProps && extraProps.ref ? // #2078 in the case of <component :is="vnode" ref="extra"/>
        // if the vnode itself already has a ref, cloneVNode will need to merge
        // the refs so the single vnode can be set on multiple refs
        mergeRef && ref ? (0, $hLodm.isArray)(ref) ? ref.concat($fd05d31532de2fc2$var$normalizeRef(extraProps)) : [
            ref,
            $fd05d31532de2fc2$var$normalizeRef(extraProps)
        ] : $fd05d31532de2fc2$var$normalizeRef(extraProps) : ref,
        scopeId: vnode.scopeId,
        slotScopeIds: vnode.slotScopeIds,
        children: children,
        target: vnode.target,
        targetAnchor: vnode.targetAnchor,
        staticCount: vnode.staticCount,
        shapeFlag: vnode.shapeFlag,
        // if the vnode is cloned with extra props, we can no longer assume its
        // existing patch flag to be reliable and need to add the FULL_PROPS flag.
        // note: preserve flag for fragments since they use the flag for children
        // fast paths only.
        patchFlag: extraProps && vnode.type !== $fd05d31532de2fc2$export$ffb0004e005737fa ? patchFlag === -1 ? 16 : patchFlag | 16 : patchFlag,
        dynamicProps: vnode.dynamicProps,
        dynamicChildren: vnode.dynamicChildren,
        appContext: vnode.appContext,
        dirs: vnode.dirs,
        transition: vnode.transition,
        // These should technically only be non-null on mounted VNodes. However,
        // they *should* be copied for kept-alive vnodes. So we just always copy
        // them since them being non-null during a mount doesn't affect the logic as
        // they will simply be overwritten.
        component: vnode.component,
        suspense: vnode.suspense,
        ssContent: vnode.ssContent && $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(vnode.ssContent),
        ssFallback: vnode.ssFallback && $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(vnode.ssFallback),
        el: vnode.el,
        anchor: vnode.anchor,
        ctx: vnode.ctx,
        ce: vnode.ce
    };
    return cloned;
}
function $fd05d31532de2fc2$var$deepCloneVNode(vnode) {
    var cloned = $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(vnode);
    if ((0, $hLodm.isArray)(vnode.children)) cloned.children = vnode.children.map($fd05d31532de2fc2$var$deepCloneVNode);
    return cloned;
}
function $fd05d31532de2fc2$export$22f9b5ffd89dac9() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : " ", flag = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$5f1af8db9871e1d6, null, text, flag);
}
function $fd05d31532de2fc2$export$33a9f6dd2840e6bb(content, numberOfNodes) {
    var vnode = $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$c1b9a1d3af45b7b6, null, content);
    vnode.staticCount = numberOfNodes;
    return vnode;
}
function $fd05d31532de2fc2$export$49553837c7236d3c() {
    var text = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", asBlock = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return asBlock ? ($fd05d31532de2fc2$export$e7eaa45e502fe5cc(), $fd05d31532de2fc2$export$9f2dfe8048dfb22b($fd05d31532de2fc2$export$4d299b491347818a, null, text)) : $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$4d299b491347818a, null, text);
}
function $fd05d31532de2fc2$var$normalizeVNode(child) {
    if (child == null || typeof child === "boolean") return $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$4d299b491347818a);
    else if ((0, $hLodm.isArray)(child)) return $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$ffb0004e005737fa, null, // #3666, avoid reference pollution when reusing vnode
    child.slice());
    else if (typeof child === "object") return $fd05d31532de2fc2$var$cloneIfMounted(child);
    else return $fd05d31532de2fc2$export$bf5c4cf060303d58($fd05d31532de2fc2$export$5f1af8db9871e1d6, null, String(child));
}
function $fd05d31532de2fc2$var$cloneIfMounted(child) {
    return child.el === null && child.patchFlag !== -1 || child.memo ? child : $fd05d31532de2fc2$export$ee4f9e12c0a92a1a(child);
}
function $fd05d31532de2fc2$var$normalizeChildren(vnode, children) {
    var type = 0;
    var shapeFlag = vnode.shapeFlag;
    if (children == null) children = null;
    else if ((0, $hLodm.isArray)(children)) type = 16;
    else if (typeof children === "object") {
        if (shapeFlag & 65) {
            var slot = children.default;
            if (slot) {
                slot._c && (slot._d = false);
                $fd05d31532de2fc2$var$normalizeChildren(vnode, slot());
                slot._c && (slot._d = true);
            }
            return;
        } else {
            type = 32;
            var slotFlag = children._;
            if (!slotFlag && !($fd05d31532de2fc2$var$InternalObjectKey in children)) children._ctx = $fd05d31532de2fc2$var$currentRenderingInstance;
            else if (slotFlag === 3 && $fd05d31532de2fc2$var$currentRenderingInstance) {
                if ($fd05d31532de2fc2$var$currentRenderingInstance.slots._ === 1) children._ = 1;
                else {
                    children._ = 2;
                    vnode.patchFlag |= 1024;
                }
            }
        }
    } else if ((0, $hLodm.isFunction)(children)) {
        children = {
            default: children,
            _ctx: $fd05d31532de2fc2$var$currentRenderingInstance
        };
        type = 32;
    } else {
        children = String(children);
        if (shapeFlag & 64) {
            type = 16;
            children = [
                $fd05d31532de2fc2$export$22f9b5ffd89dac9(children)
            ];
        } else type = 8;
    }
    vnode.children = children;
    vnode.shapeFlag |= type;
}
function $fd05d31532de2fc2$export$9d1611c77c2fe928() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var ret = {};
    for(var i = 0; i < args.length; i++){
        var toMerge = args[i];
        for(var key in toMerge){
            if (key === "class") {
                if (ret.class !== toMerge.class) ret.class = (0, $hLodm.normalizeClass)([
                    ret.class,
                    toMerge.class
                ]);
            } else if (key === "style") ret.style = (0, $hLodm.normalizeStyle)([
                ret.style,
                toMerge.style
            ]);
            else if ((0, $hLodm.isOn)(key)) {
                var existing = ret[key];
                var incoming = toMerge[key];
                if (incoming && existing !== incoming && !((0, $hLodm.isArray)(existing) && existing.includes(incoming))) ret[key] = existing ? [].concat(existing, incoming) : incoming;
            } else if (key !== "") ret[key] = toMerge[key];
        }
    }
    return ret;
}
function $fd05d31532de2fc2$var$invokeVNodeHook(hook, instance, vnode) {
    var prevVNode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
    $fd05d31532de2fc2$export$dae85862a8d94378(hook, instance, 7, [
        vnode,
        prevVNode
    ]);
}
var $fd05d31532de2fc2$var$emptyAppContext = $fd05d31532de2fc2$var$createAppContext();
var $fd05d31532de2fc2$var$uid = 0;
function $fd05d31532de2fc2$var$createComponentInstance(vnode, parent, suspense) {
    var type = vnode.type;
    var appContext = (parent ? parent.appContext : vnode.appContext) || $fd05d31532de2fc2$var$emptyAppContext;
    var instance = {
        uid: $fd05d31532de2fc2$var$uid++,
        vnode: vnode,
        type: type,
        parent: parent,
        appContext: appContext,
        root: null,
        // to be immediately set
        next: null,
        subTree: null,
        // will be set synchronously right after creation
        effect: null,
        update: null,
        // will be set synchronously right after creation
        scope: new (0, $yQ0Ka.EffectScope)(true),
        render: null,
        proxy: null,
        exposed: null,
        exposeProxy: null,
        withProxy: null,
        provides: parent ? parent.provides : Object.create(appContext.provides),
        accessCache: null,
        renderCache: [],
        // local resolved assets
        components: null,
        directives: null,
        // resolved props and emits options
        propsOptions: $fd05d31532de2fc2$var$normalizePropsOptions(type, appContext),
        emitsOptions: $fd05d31532de2fc2$var$normalizeEmitsOptions(type, appContext),
        // emit
        emit: null,
        // to be set immediately
        emitted: null,
        // props default value
        propsDefaults: (0, $hLodm.EMPTY_OBJ),
        // inheritAttrs
        inheritAttrs: type.inheritAttrs,
        // state
        ctx: (0, $hLodm.EMPTY_OBJ),
        data: (0, $hLodm.EMPTY_OBJ),
        props: (0, $hLodm.EMPTY_OBJ),
        attrs: (0, $hLodm.EMPTY_OBJ),
        slots: (0, $hLodm.EMPTY_OBJ),
        refs: (0, $hLodm.EMPTY_OBJ),
        setupState: (0, $hLodm.EMPTY_OBJ),
        setupContext: null,
        attrsProxy: null,
        slotsProxy: null,
        // suspense related
        suspense: suspense,
        suspenseId: suspense ? suspense.pendingId : 0,
        asyncDep: null,
        asyncResolved: false,
        // lifecycle hooks
        // not using enums here because it results in computed properties
        isMounted: false,
        isUnmounted: false,
        isDeactivated: false,
        bc: null,
        c: null,
        bm: null,
        m: null,
        bu: null,
        u: null,
        um: null,
        bum: null,
        da: null,
        a: null,
        rtg: null,
        rtc: null,
        ec: null,
        sp: null
    };
    instance.ctx = {
        _: instance
    };
    instance.root = parent ? parent.root : instance;
    instance.emit = $fd05d31532de2fc2$var$emit.bind(null, instance);
    if (vnode.ce) vnode.ce(instance);
    return instance;
}
var $fd05d31532de2fc2$var$currentInstance = null;
var $fd05d31532de2fc2$export$f13e630aa3915748 = function() {
    return $fd05d31532de2fc2$var$currentInstance || $fd05d31532de2fc2$var$currentRenderingInstance;
};
var $fd05d31532de2fc2$var$internalSetCurrentInstance;
var $fd05d31532de2fc2$var$globalCurrentInstanceSetters;
var $fd05d31532de2fc2$var$settersKey = "__VUE_INSTANCE_SETTERS__";
if (!($fd05d31532de2fc2$var$globalCurrentInstanceSetters = (0, $hLodm.getGlobalThis)()[$fd05d31532de2fc2$var$settersKey])) $fd05d31532de2fc2$var$globalCurrentInstanceSetters = (0, $hLodm.getGlobalThis)()[$fd05d31532de2fc2$var$settersKey] = [];
$fd05d31532de2fc2$var$globalCurrentInstanceSetters.push(function(i) {
    return $fd05d31532de2fc2$var$currentInstance = i;
});
$fd05d31532de2fc2$var$internalSetCurrentInstance = function(instance) {
    if ($fd05d31532de2fc2$var$globalCurrentInstanceSetters.length > 1) $fd05d31532de2fc2$var$globalCurrentInstanceSetters.forEach(function(s) {
        return s(instance);
    });
    else $fd05d31532de2fc2$var$globalCurrentInstanceSetters[0](instance);
};
var $fd05d31532de2fc2$var$setCurrentInstance = function(instance) {
    $fd05d31532de2fc2$var$internalSetCurrentInstance(instance);
    instance.scope.on();
};
var $fd05d31532de2fc2$var$unsetCurrentInstance = function() {
    $fd05d31532de2fc2$var$currentInstance && $fd05d31532de2fc2$var$currentInstance.scope.off();
    $fd05d31532de2fc2$var$internalSetCurrentInstance(null);
};
var $fd05d31532de2fc2$var$isBuiltInTag = /* @__PURE__ */ (0, $hLodm.makeMap)("slot,component");
function $fd05d31532de2fc2$var$validateComponentName(name, config) {
    var appIsNativeTag = config.isNativeTag || (0, $hLodm.NO);
    if ($fd05d31532de2fc2$var$isBuiltInTag(name) || appIsNativeTag(name)) $fd05d31532de2fc2$export$c106dd0671a0fc2d("Do not use built-in or reserved HTML elements as component id: " + name);
}
function $fd05d31532de2fc2$var$isStatefulComponent(instance) {
    return instance.vnode.shapeFlag & 4;
}
var $fd05d31532de2fc2$var$isInSSRComponentSetup = false;
function $fd05d31532de2fc2$var$setupComponent(instance) {
    var isSSR = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    $fd05d31532de2fc2$var$isInSSRComponentSetup = isSSR;
    var _instance_vnode = instance.vnode, props = _instance_vnode.props, children = _instance_vnode.children;
    var isStateful = $fd05d31532de2fc2$var$isStatefulComponent(instance);
    $fd05d31532de2fc2$var$initProps(instance, props, isStateful, isSSR);
    $fd05d31532de2fc2$var$initSlots(instance, children);
    var setupResult = isStateful ? $fd05d31532de2fc2$var$setupStatefulComponent(instance, isSSR) : void 0;
    $fd05d31532de2fc2$var$isInSSRComponentSetup = false;
    return setupResult;
}
function $fd05d31532de2fc2$var$setupStatefulComponent(instance, isSSR) {
    var _a;
    var Component = instance.type;
    instance.accessCache = /* @__PURE__ */ Object.create(null);
    instance.proxy = (0, $yQ0Ka.markRaw)(new Proxy(instance.ctx, $fd05d31532de2fc2$var$PublicInstanceProxyHandlers));
    var setup = Component.setup;
    if (setup) {
        var setupContext = instance.setupContext = setup.length > 1 ? $fd05d31532de2fc2$var$createSetupContext(instance) : null;
        $fd05d31532de2fc2$var$setCurrentInstance(instance);
        (0, $yQ0Ka.pauseTracking)();
        var setupResult = $fd05d31532de2fc2$export$b22fcaf88446e9bf(setup, instance, 0, [
            (0, instance.props),
            setupContext
        ]);
        (0, $yQ0Ka.resetTracking)();
        $fd05d31532de2fc2$var$unsetCurrentInstance();
        if ((0, $hLodm.isPromise)(setupResult)) {
            setupResult.then($fd05d31532de2fc2$var$unsetCurrentInstance, $fd05d31532de2fc2$var$unsetCurrentInstance);
            if (isSSR) return setupResult.then(function(resolvedResult) {
                $fd05d31532de2fc2$var$handleSetupResult(instance, resolvedResult, isSSR);
            }).catch(function(e) {
                $fd05d31532de2fc2$export$d3da1ecaf1206c58(e, instance, 0);
            });
            else instance.asyncDep = setupResult;
        } else $fd05d31532de2fc2$var$handleSetupResult(instance, setupResult, isSSR);
    } else $fd05d31532de2fc2$var$finishComponentSetup(instance, isSSR);
}
function $fd05d31532de2fc2$var$handleSetupResult(instance, setupResult, isSSR) {
    if ((0, $hLodm.isFunction)(setupResult)) {
        if (instance.type.__ssrInlineRender) instance.ssrRender = setupResult;
        else instance.render = setupResult;
    } else if ((0, $hLodm.isObject)(setupResult)) {
        if (__VUE_PROD_DEVTOOLS__) instance.devtoolsRawSetupState = setupResult;
        instance.setupState = (0, $yQ0Ka.proxyRefs)(setupResult);
    }
    $fd05d31532de2fc2$var$finishComponentSetup(instance, isSSR);
}
var $fd05d31532de2fc2$var$compile;
var $fd05d31532de2fc2$var$installWithProxy;
function $fd05d31532de2fc2$export$667bb5a67822b941(_compile) {
    $fd05d31532de2fc2$var$compile = _compile;
    $fd05d31532de2fc2$var$installWithProxy = function(i) {
        if (i.render._rc) i.withProxy = new Proxy(i.ctx, $fd05d31532de2fc2$var$RuntimeCompiledPublicInstanceProxyHandlers);
    };
}
var $fd05d31532de2fc2$export$c93a9c496c5211fa = function() {
    return !$fd05d31532de2fc2$var$compile;
};
function $fd05d31532de2fc2$var$finishComponentSetup(instance, isSSR, skipOptions) {
    var Component = instance.type;
    if (!instance.render) {
        if (!isSSR && $fd05d31532de2fc2$var$compile && !Component.render) {
            var template = Component.template || $fd05d31532de2fc2$var$resolveMergedOptions(instance).template;
            if (template) {
                var _instance_appContext_config = instance.appContext.config, isCustomElement = _instance_appContext_config.isCustomElement, compilerOptions = _instance_appContext_config.compilerOptions;
                var delimiters = Component.delimiters, componentCompilerOptions = Component.compilerOptions;
                var finalCompilerOptions = (0, $hLodm.extend)((0, $hLodm.extend)({
                    isCustomElement: isCustomElement,
                    delimiters: delimiters
                }, compilerOptions), componentCompilerOptions);
                Component.render = $fd05d31532de2fc2$var$compile(template, finalCompilerOptions);
            }
        }
        instance.render = Component.render || (0, $hLodm.NOOP);
        if ($fd05d31532de2fc2$var$installWithProxy) $fd05d31532de2fc2$var$installWithProxy(instance);
    }
    if (__VUE_OPTIONS_API__ && true) {
        $fd05d31532de2fc2$var$setCurrentInstance(instance);
        (0, $yQ0Ka.pauseTracking)();
        $fd05d31532de2fc2$var$applyOptions(instance);
        (0, $yQ0Ka.resetTracking)();
        $fd05d31532de2fc2$var$unsetCurrentInstance();
    }
}
function $fd05d31532de2fc2$var$getAttrsProxy(instance) {
    return instance.attrsProxy || (instance.attrsProxy = new Proxy(instance.attrs, {
        get: function(target, key) {
            (0, $yQ0Ka.track)(instance, "get", "$attrs");
            return target[key];
        }
    }));
}
function $fd05d31532de2fc2$var$getSlotsProxy(instance) {
    return instance.slotsProxy || (instance.slotsProxy = new Proxy(instance.slots, {
        get: function(target, key) {
            (0, $yQ0Ka.track)(instance, "get", "$slots");
            return target[key];
        }
    }));
}
function $fd05d31532de2fc2$var$createSetupContext(instance) {
    var expose = function(exposed) {
        instance.exposed = exposed || {};
    };
    var event, args;
    return {
        get attrs () {
            return $fd05d31532de2fc2$var$getAttrsProxy(instance);
        },
        slots: instance.slots,
        emit: instance.emit,
        expose: expose
    };
}
function $fd05d31532de2fc2$var$getExposeProxy(instance) {
    if (instance.exposed) return instance.exposeProxy || (instance.exposeProxy = new Proxy((0, $yQ0Ka.proxyRefs)((0, $yQ0Ka.markRaw)(instance.exposed)), {
        get: function(target, key) {
            if (key in target) return target[key];
            else if (key in $fd05d31532de2fc2$var$publicPropertiesMap) return $fd05d31532de2fc2$var$publicPropertiesMap[key](instance);
        },
        has: function(target, key) {
            return key in target || key in $fd05d31532de2fc2$var$publicPropertiesMap;
        }
    }));
}
var $fd05d31532de2fc2$var$classifyRE = /(?:^|[-_])(\w)/g;
var $fd05d31532de2fc2$var$classify = function(str) {
    return str.replace($fd05d31532de2fc2$var$classifyRE, function(c) {
        return c.toUpperCase();
    }).replace(/[-_]/g, "");
};
function $fd05d31532de2fc2$var$getComponentName(Component) {
    var includeInferred = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    return (0, $hLodm.isFunction)(Component) ? Component.displayName || Component.name : Component.name || includeInferred && Component.__name;
}
function $fd05d31532de2fc2$var$formatComponentName(instance, Component) {
    var isRoot = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var name = $fd05d31532de2fc2$var$getComponentName(Component);
    if (!name && Component.__file) {
        var match = Component.__file.match(/([^/\\]+)\.\w+$/);
        if (match) name = match[1];
    }
    if (!name && instance && instance.parent) {
        var inferFromRegistry = function(registry) {
            for(var key in registry){
                if (registry[key] === Component) return key;
            }
        };
        name = inferFromRegistry(instance.components || instance.parent.type.components) || inferFromRegistry(instance.appContext.components);
    }
    return name ? $fd05d31532de2fc2$var$classify(name) : isRoot ? "App" : "Anonymous";
}
function $fd05d31532de2fc2$var$isClassComponent(value1) {
    return (0, $hLodm.isFunction)(value1) && "__vccOpts" in value1;
}
var $fd05d31532de2fc2$export$2983e091f1a1e8e2 = function(getterOrOptions, debugOptions) {
    return (0, $yQ0Ka.computed)(getterOrOptions, debugOptions, $fd05d31532de2fc2$var$isInSSRComponentSetup);
};
function $fd05d31532de2fc2$export$dda1d9f60106f0e9(type, propsOrChildren, children) {
    var l = arguments.length;
    if (l === 2) {
        if ((0, $hLodm.isObject)(propsOrChildren) && !(0, $hLodm.isArray)(propsOrChildren)) {
            if ($fd05d31532de2fc2$export$3868d13f8734ae81(propsOrChildren)) return $fd05d31532de2fc2$export$bf5c4cf060303d58(type, null, [
                propsOrChildren
            ]);
            return $fd05d31532de2fc2$export$bf5c4cf060303d58(type, propsOrChildren);
        } else return $fd05d31532de2fc2$export$bf5c4cf060303d58(type, null, propsOrChildren);
    } else {
        if (l > 3) children = Array.prototype.slice.call(arguments, 2);
        else if (l === 3 && $fd05d31532de2fc2$export$3868d13f8734ae81(children)) children = [
            children
        ];
        return $fd05d31532de2fc2$export$bf5c4cf060303d58(type, propsOrChildren, children);
    }
}
var $fd05d31532de2fc2$export$f2549a27e18acf2d = Symbol.for("v-scx");
var $fd05d31532de2fc2$export$6b1c54dc4befcda = function() {
    {
        var ctx = $fd05d31532de2fc2$export$a976684a0efeb93f($fd05d31532de2fc2$export$f2549a27e18acf2d);
        ctx;
        return ctx;
    }
};
function $fd05d31532de2fc2$var$isShallow(value1) {
    return !!(value1 && value1["__v_isShallow"]);
}
function $fd05d31532de2fc2$export$aed4979be6a60047() {
    var formatInstance = function formatInstance(instance) {
        var blocks = [];
        if (instance.type.props && instance.props) blocks.push(createInstanceBlock("props", (0, $yQ0Ka.toRaw)(instance.props)));
        if (instance.setupState !== (0, $hLodm.EMPTY_OBJ)) blocks.push(createInstanceBlock("setup", instance.setupState));
        if (instance.data !== (0, $hLodm.EMPTY_OBJ)) blocks.push(createInstanceBlock("data", (0, $yQ0Ka.toRaw)(instance.data)));
        var computed = extractKeys(instance, "computed");
        if (computed) blocks.push(createInstanceBlock("computed", computed));
        var injected = extractKeys(instance, "inject");
        if (injected) blocks.push(createInstanceBlock("injected", injected));
        blocks.push([
            "div",
            {},
            [
                "span",
                {
                    style: keywordStyle.style + ";opacity:0.66"
                },
                "$ (internal): "
            ],
            [
                "object",
                {
                    object: instance
                }
            ]
        ]);
        return blocks;
    };
    var createInstanceBlock = function createInstanceBlock(type, target) {
        target = (0, $hLodm.extend)({}, target);
        if (!Object.keys(target).length) return [
            "span",
            {}
        ];
        return [
            "div",
            {
                style: "line-height:1.25em;margin-bottom:0.6em"
            },
            [
                "div",
                {
                    style: "color:#476582"
                },
                type
            ],
            [
                "div",
                {
                    style: "padding-left:1.25em"
                }
            ].concat((0, $c6Xmf._)(Object.keys(target).map(function(key) {
                return [
                    "div",
                    {},
                    [
                        "span",
                        keywordStyle,
                        key + ": "
                    ],
                    formatValue(target[key], false)
                ];
            })))
        ];
    };
    var formatValue = function formatValue(v1) {
        var asRaw = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        if (typeof v1 === "number") return [
            "span",
            numberStyle,
            v1
        ];
        else if (typeof v1 === "string") return [
            "span",
            stringStyle,
            JSON.stringify(v1)
        ];
        else if (typeof v1 === "boolean") return [
            "span",
            keywordStyle,
            v1
        ];
        else if ((0, $hLodm.isObject)(v1)) return [
            "object",
            {
                object: asRaw ? (0, $yQ0Ka.toRaw)(v1) : v1
            }
        ];
        else return [
            "span",
            stringStyle,
            String(v1)
        ];
    };
    var extractKeys = function extractKeys(instance, type) {
        var Comp = instance.type;
        if ((0, $hLodm.isFunction)(Comp)) return;
        var extracted = {};
        for(var key in instance.ctx)if (isKeyOfType(Comp, key, type)) extracted[key] = instance.ctx[key];
        return extracted;
    };
    var genRefFlag = function genRefFlag(v1) {
        if ($fd05d31532de2fc2$var$isShallow(v1)) return "ShallowRef";
        if (v1.effect) return "ComputedRef";
        return "Ref";
    };
    return;
    function isKeyOfType(Comp, key, type) {
        var opts = Comp[type];
        if ((0, $hLodm.isArray)(opts) && opts.includes(key) || (0, $hLodm.isObject)(opts) && key in opts) return true;
        if (Comp.extends && isKeyOfType(Comp.extends, key, type)) return true;
        if (Comp.mixins && Comp.mixins.some(function(m) {
            return isKeyOfType(m, key, type);
        })) return true;
    }
}
function $fd05d31532de2fc2$export$2a6d714a4d738ae(memo, render, cache, index) {
    var cached = cache[index];
    if (cached && $fd05d31532de2fc2$export$bf525184d622787c(cached, memo)) return cached;
    var ret = render();
    ret.memo = memo.slice();
    return cache[index] = ret;
}
function $fd05d31532de2fc2$export$bf525184d622787c(cached, memo) {
    var prev = cached.memo;
    if (prev.length != memo.length) return false;
    for(var i = 0; i < prev.length; i++){
        if ((0, $hLodm.hasChanged)(prev[i], memo[i])) return false;
    }
    if ($fd05d31532de2fc2$var$isBlockTreeEnabled > 0 && $fd05d31532de2fc2$var$currentBlock) $fd05d31532de2fc2$var$currentBlock.push(cached);
    return true;
}
var $fd05d31532de2fc2$export$83d89fbfd8236492 = "3.3.4";
var $fd05d31532de2fc2$var$_ssrUtils = {
    createComponentInstance: $fd05d31532de2fc2$var$createComponentInstance,
    setupComponent: $fd05d31532de2fc2$var$setupComponent,
    renderComponentRoot: $fd05d31532de2fc2$var$renderComponentRoot,
    setCurrentRenderingInstance: $fd05d31532de2fc2$var$setCurrentRenderingInstance,
    isVNode: $fd05d31532de2fc2$export$3868d13f8734ae81,
    normalizeVNode: $fd05d31532de2fc2$var$normalizeVNode
};
var $fd05d31532de2fc2$export$a9679033567b336d = $fd05d31532de2fc2$var$_ssrUtils;
var $fd05d31532de2fc2$export$83cf26e06ea620e1 = null;
var $fd05d31532de2fc2$export$dc678eddf276286e = null;

});
parcelRequire.register("cv9Rk", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $91a007218046315e$export$fdf2a89c76341bbf; });

var $hrk7H = parcelRequire("hrk7H");

var $fBJYg = parcelRequire("fBJYg");

var $e8oCh = parcelRequire("e8oCh");

var $1hjNY = parcelRequire("1hjNY");
function $91a007218046315e$export$fdf2a89c76341bbf(arr, i) {
    return (0, $hrk7H._array_with_holes)(arr) || (0, $fBJYg._iterable_to_array_limit)(arr, i) || (0, $1hjNY._unsupported_iterable_to_array)(arr, i) || (0, $e8oCh._non_iterable_rest)();
}

});
parcelRequire.register("hrk7H", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $cb24915816a1cfc9$export$e6256bf45c68d561; });
function $cb24915816a1cfc9$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("fBJYg", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $b5cdf895c6f08ea2$export$2fd15edff6687200; });
function $b5cdf895c6f08ea2$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("e8oCh", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $a4a4e8541bb818da$export$60dbc22abd7da546; });
function $a4a4e8541bb818da$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("yQ0Ka", function(module, exports) {

$parcel$export(module.exports, "EffectScope", function () { return $068b8563ee89b659$export$1168ed9dbc71ddbd; });
$parcel$export(module.exports, "effectScope", function () { return $068b8563ee89b659$export$7056603ea81600be; });
$parcel$export(module.exports, "getCurrentScope", function () { return $068b8563ee89b659$export$c7be4b0125a10cba; });
$parcel$export(module.exports, "ReactiveEffect", function () { return $068b8563ee89b659$export$28352bb4dd362521; });
$parcel$export(module.exports, "pauseTracking", function () { return $068b8563ee89b659$export$938a971395fef855; });
$parcel$export(module.exports, "resetTracking", function () { return $068b8563ee89b659$export$c39176b1babaa8b8; });
$parcel$export(module.exports, "track", function () { return $068b8563ee89b659$export$6b2a7d5132615086; });
$parcel$export(module.exports, "trigger", function () { return $068b8563ee89b659$export$e614dc9140f7ae71; });
$parcel$export(module.exports, "toRaw", function () { return $068b8563ee89b659$export$ab18938b9fc5f28e; });
$parcel$export(module.exports, "isRef", function () { return $068b8563ee89b659$export$4f9f5282de18fc69; });
$parcel$export(module.exports, "reactive", function () { return $068b8563ee89b659$export$90a44edba14e47be; });
$parcel$export(module.exports, "isShallow", function () { return $068b8563ee89b659$export$7f3fe6025abfa26e; });
$parcel$export(module.exports, "shallowReactive", function () { return $068b8563ee89b659$export$8d81cefd22d22260; });
$parcel$export(module.exports, "isReactive", function () { return $068b8563ee89b659$export$352205f445242f02; });
$parcel$export(module.exports, "isProxy", function () { return $068b8563ee89b659$export$5f3ca29d057519b3; });
$parcel$export(module.exports, "markRaw", function () { return $068b8563ee89b659$export$995ab8b13ad7a9d0; });
$parcel$export(module.exports, "ref", function () { return $068b8563ee89b659$export$eff4d24c3ff7876e; });
$parcel$export(module.exports, "shallowRef", function () { return $068b8563ee89b659$export$9b7bc5fe3b17c8b3; });
$parcel$export(module.exports, "proxyRefs", function () { return $068b8563ee89b659$export$f353fd1b97db3fa0; });
$parcel$export(module.exports, "computed", function () { return $068b8563ee89b659$export$2983e091f1a1e8e2; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $hLodm = parcelRequire("hLodm");
function $068b8563ee89b659$var$warn(msg) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var _console;
    (_console = console).warn.apply(_console, [
        "[Vue warn] ".concat(msg)
    ].concat((0, $c6Xmf._)(args)));
}
var $068b8563ee89b659$var$activeEffectScope;
var $068b8563ee89b659$export$1168ed9dbc71ddbd = /*#__PURE__*/ function() {
    "use strict";
    function EffectScope() {
        var detached = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        (0, $4GJKx._)(this, EffectScope);
        this.detached = detached;
        /**
     * @internal
     */ this._active = true;
        /**
     * @internal
     */ this.effects = [];
        /**
     * @internal
     */ this.cleanups = [];
        this.parent = $068b8563ee89b659$var$activeEffectScope;
        if (!detached && $068b8563ee89b659$var$activeEffectScope) this.index = ($068b8563ee89b659$var$activeEffectScope.scopes || ($068b8563ee89b659$var$activeEffectScope.scopes = [])).push(this) - 1;
    }
    (0, $1wc17._)(EffectScope, [
        {
            key: "active",
            get: function get() {
                return this._active;
            }
        },
        {
            key: "run",
            value: function run(fn) {
                if (this._active) {
                    var currentEffectScope = $068b8563ee89b659$var$activeEffectScope;
                    try {
                        $068b8563ee89b659$var$activeEffectScope = this;
                        return fn();
                    } finally{
                        $068b8563ee89b659$var$activeEffectScope = currentEffectScope;
                    }
                }
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "on",
            value: function on() {
                $068b8563ee89b659$var$activeEffectScope = this;
            }
        },
        {
            /**
   * This should only be called on non-detached scopes
   * @internal
   */ key: "off",
            value: function off() {
                $068b8563ee89b659$var$activeEffectScope = this.parent;
            }
        },
        {
            key: "stop",
            value: function stop(fromParent) {
                if (this._active) {
                    var i, l;
                    for(i = 0, l = this.effects.length; i < l; i++)this.effects[i].stop();
                    for(i = 0, l = this.cleanups.length; i < l; i++)this.cleanups[i]();
                    if (this.scopes) for(i = 0, l = this.scopes.length; i < l; i++)this.scopes[i].stop(true);
                    if (!this.detached && this.parent && !fromParent) {
                        var last = this.parent.scopes.pop();
                        if (last && last !== this) {
                            this.parent.scopes[this.index] = last;
                            last.index = this.index;
                        }
                    }
                    this.parent = void 0;
                    this._active = false;
                }
            }
        }
    ]);
    return EffectScope;
}();
function $068b8563ee89b659$export$7056603ea81600be(detached) {
    return new $068b8563ee89b659$export$1168ed9dbc71ddbd(detached);
}
function $068b8563ee89b659$var$recordEffectScope(effect) {
    var scope = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $068b8563ee89b659$var$activeEffectScope;
    if (scope && scope.active) scope.effects.push(effect);
}
function $068b8563ee89b659$export$c7be4b0125a10cba() {
    return $068b8563ee89b659$var$activeEffectScope;
}
function $068b8563ee89b659$export$a780418acd4762da(fn) {
    if ($068b8563ee89b659$var$activeEffectScope) $068b8563ee89b659$var$activeEffectScope.cleanups.push(fn);
}
var $068b8563ee89b659$var$createDep = function(effects) {
    var dep = new Set(effects);
    dep.w = 0;
    dep.n = 0;
    return dep;
};
var $068b8563ee89b659$var$wasTracked = function(dep) {
    return (dep.w & $068b8563ee89b659$var$trackOpBit) > 0;
};
var $068b8563ee89b659$var$newTracked = function(dep) {
    return (dep.n & $068b8563ee89b659$var$trackOpBit) > 0;
};
var $068b8563ee89b659$var$initDepMarkers = function(param) {
    var deps = param.deps;
    if (deps.length) for(var i = 0; i < deps.length; i++)deps[i].w |= $068b8563ee89b659$var$trackOpBit;
};
var $068b8563ee89b659$var$finalizeDepMarkers = function(effect) {
    var deps = effect.deps;
    if (deps.length) {
        var ptr = 0;
        for(var i = 0; i < deps.length; i++){
            var dep = deps[i];
            if ($068b8563ee89b659$var$wasTracked(dep) && !$068b8563ee89b659$var$newTracked(dep)) dep.delete(effect);
            else deps[ptr++] = dep;
            dep.w &= ~$068b8563ee89b659$var$trackOpBit;
            dep.n &= ~$068b8563ee89b659$var$trackOpBit;
        }
        deps.length = ptr;
    }
};
var $068b8563ee89b659$var$targetMap = /* @__PURE__ */ new WeakMap();
var $068b8563ee89b659$var$effectTrackDepth = 0;
var $068b8563ee89b659$var$trackOpBit = 1;
var $068b8563ee89b659$var$maxMarkerBits = 30;
var $068b8563ee89b659$var$activeEffect;
var $068b8563ee89b659$export$3c41b1a4e06acc14 = Symbol("");
var $068b8563ee89b659$var$MAP_KEY_ITERATE_KEY = Symbol("");
var $068b8563ee89b659$export$28352bb4dd362521 = /*#__PURE__*/ function() {
    "use strict";
    function ReactiveEffect(fn) {
        var scheduler = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, scope = arguments.length > 2 ? arguments[2] : void 0;
        (0, $4GJKx._)(this, ReactiveEffect);
        this.fn = fn;
        this.scheduler = scheduler;
        this.active = true;
        this.deps = [];
        this.parent = void 0;
        $068b8563ee89b659$var$recordEffectScope(this, scope);
    }
    (0, $1wc17._)(ReactiveEffect, [
        {
            key: "run",
            value: function run() {
                if (!this.active) return this.fn();
                var parent = $068b8563ee89b659$var$activeEffect;
                var lastShouldTrack = $068b8563ee89b659$var$shouldTrack;
                while(parent){
                    if (parent === this) return;
                    parent = parent.parent;
                }
                try {
                    this.parent = $068b8563ee89b659$var$activeEffect;
                    $068b8563ee89b659$var$activeEffect = this;
                    $068b8563ee89b659$var$shouldTrack = true;
                    $068b8563ee89b659$var$trackOpBit = 1 << ++$068b8563ee89b659$var$effectTrackDepth;
                    if ($068b8563ee89b659$var$effectTrackDepth <= $068b8563ee89b659$var$maxMarkerBits) $068b8563ee89b659$var$initDepMarkers(this);
                    else $068b8563ee89b659$var$cleanupEffect(this);
                    return this.fn();
                } finally{
                    if ($068b8563ee89b659$var$effectTrackDepth <= $068b8563ee89b659$var$maxMarkerBits) $068b8563ee89b659$var$finalizeDepMarkers(this);
                    $068b8563ee89b659$var$trackOpBit = 1 << --$068b8563ee89b659$var$effectTrackDepth;
                    $068b8563ee89b659$var$activeEffect = this.parent;
                    $068b8563ee89b659$var$shouldTrack = lastShouldTrack;
                    this.parent = void 0;
                    if (this.deferStop) this.stop();
                }
            }
        },
        {
            key: "stop",
            value: function stop() {
                if ($068b8563ee89b659$var$activeEffect === this) this.deferStop = true;
                else if (this.active) {
                    $068b8563ee89b659$var$cleanupEffect(this);
                    if (this.onStop) this.onStop();
                    this.active = false;
                }
            }
        }
    ]);
    return ReactiveEffect;
}();
function $068b8563ee89b659$var$cleanupEffect(effect2) {
    var deps = effect2.deps;
    if (deps.length) {
        for(var i = 0; i < deps.length; i++)deps[i].delete(effect2);
        deps.length = 0;
    }
}
function $068b8563ee89b659$export$dc573d8a6576cdb3(fn, options) {
    if (fn.effect) fn = fn.effect.fn;
    var _effect = new $068b8563ee89b659$export$28352bb4dd362521(fn);
    if (options) {
        (0, $hLodm.extend)(_effect, options);
        if (options.scope) $068b8563ee89b659$var$recordEffectScope(_effect, options.scope);
    }
    if (!options || !options.lazy) _effect.run();
    var runner = _effect.run.bind(_effect);
    runner.effect = _effect;
    return runner;
}
function $068b8563ee89b659$export$fa6813432f753b0d(runner) {
    runner.effect.stop();
}
var $068b8563ee89b659$var$shouldTrack = true;
var $068b8563ee89b659$var$trackStack = [];
function $068b8563ee89b659$export$938a971395fef855() {
    $068b8563ee89b659$var$trackStack.push($068b8563ee89b659$var$shouldTrack);
    $068b8563ee89b659$var$shouldTrack = false;
}
function $068b8563ee89b659$export$1f8ffc6fd33b1d16() {
    $068b8563ee89b659$var$trackStack.push($068b8563ee89b659$var$shouldTrack);
    $068b8563ee89b659$var$shouldTrack = true;
}
function $068b8563ee89b659$export$c39176b1babaa8b8() {
    var last = $068b8563ee89b659$var$trackStack.pop();
    $068b8563ee89b659$var$shouldTrack = last === void 0 ? true : last;
}
function $068b8563ee89b659$export$6b2a7d5132615086(target, type, key) {
    if ($068b8563ee89b659$var$shouldTrack && $068b8563ee89b659$var$activeEffect) {
        var depsMap = $068b8563ee89b659$var$targetMap.get(target);
        if (!depsMap) $068b8563ee89b659$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
        var dep = depsMap.get(key);
        if (!dep) depsMap.set(key, dep = $068b8563ee89b659$var$createDep());
        var eventInfo = void 0;
        $068b8563ee89b659$var$trackEffects(dep, eventInfo);
    }
}
function $068b8563ee89b659$var$trackEffects(dep, debuggerEventExtraInfo) {
    var shouldTrack2 = false;
    if ($068b8563ee89b659$var$effectTrackDepth <= $068b8563ee89b659$var$maxMarkerBits) {
        if (!$068b8563ee89b659$var$newTracked(dep)) {
            dep.n |= $068b8563ee89b659$var$trackOpBit;
            shouldTrack2 = !$068b8563ee89b659$var$wasTracked(dep);
        }
    } else shouldTrack2 = !dep.has($068b8563ee89b659$var$activeEffect);
    if (shouldTrack2) {
        dep.add($068b8563ee89b659$var$activeEffect);
        $068b8563ee89b659$var$activeEffect.deps.push(dep);
    }
}
function $068b8563ee89b659$export$e614dc9140f7ae71(target, type, key, newValue, oldValue, oldTarget) {
    var depsMap = $068b8563ee89b659$var$targetMap.get(target);
    if (!depsMap) return;
    var deps = [];
    if (type === "clear") deps = (0, $c6Xmf._)(depsMap.values());
    else if (key === "length" && (0, $hLodm.isArray)(target)) {
        var newLength = Number(newValue);
        depsMap.forEach(function(dep, key2) {
            if (key2 === "length" || key2 >= newLength) deps.push(dep);
        });
    } else {
        if (key !== void 0) deps.push(depsMap.get(key));
        switch(type){
            case "add":
                if (!(0, $hLodm.isArray)(target)) {
                    deps.push(depsMap.get($068b8563ee89b659$export$3c41b1a4e06acc14));
                    if ((0, $hLodm.isMap)(target)) deps.push(depsMap.get($068b8563ee89b659$var$MAP_KEY_ITERATE_KEY));
                } else if ((0, $hLodm.isIntegerKey)(key)) deps.push(depsMap.get("length"));
                break;
            case "delete":
                if (!(0, $hLodm.isArray)(target)) {
                    deps.push(depsMap.get($068b8563ee89b659$export$3c41b1a4e06acc14));
                    if ((0, $hLodm.isMap)(target)) deps.push(depsMap.get($068b8563ee89b659$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ((0, $hLodm.isMap)(target)) deps.push(depsMap.get($068b8563ee89b659$export$3c41b1a4e06acc14));
                break;
        }
    }
    var eventInfo = void 0;
    if (deps.length === 1) {
        if (deps[0]) $068b8563ee89b659$var$triggerEffects(deps[0]);
    } else {
        var _effects;
        var effects = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = deps[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var dep = _step.value;
                if (dep) (_effects = effects).push.apply(_effects, (0, $c6Xmf._)(dep));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        $068b8563ee89b659$var$triggerEffects($068b8563ee89b659$var$createDep(effects));
    }
}
function $068b8563ee89b659$var$triggerEffects(dep, debuggerEventExtraInfo) {
    var effects = (0, $hLodm.isArray)(dep) ? dep : (0, $c6Xmf._)(dep);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = effects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var effect2 = _step.value;
            if (effect2.computed) $068b8563ee89b659$var$triggerEffect(effect2, debuggerEventExtraInfo);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = effects[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var effect21 = _step1.value;
            if (!effect21.computed) $068b8563ee89b659$var$triggerEffect(effect21, debuggerEventExtraInfo);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
}
function $068b8563ee89b659$var$triggerEffect(effect2, debuggerEventExtraInfo) {
    if (effect2 !== $068b8563ee89b659$var$activeEffect || effect2.allowRecurse) {
        if (effect2.scheduler) effect2.scheduler();
        else effect2.run();
    }
}
function $068b8563ee89b659$var$getDepFromReactive(object, key) {
    var _a;
    return (_a = $068b8563ee89b659$var$targetMap.get(object)) == null ? void 0 : _a.get(key);
}
var $068b8563ee89b659$var$isNonTrackableKeys = /* @__PURE__ */ (0, $hLodm.makeMap)("__proto__,__v_isRef,__isVue");
var $068b8563ee89b659$var$builtInSymbols = new Set(/* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter(function(key) {
    return key !== "arguments" && key !== "caller";
}).map(function(key) {
    return Symbol[key];
}).filter((0, $hLodm.isSymbol)));
var $068b8563ee89b659$var$get$1 = /* @__PURE__ */ $068b8563ee89b659$var$createGetter();
var $068b8563ee89b659$var$shallowGet = /* @__PURE__ */ $068b8563ee89b659$var$createGetter(false, true);
var $068b8563ee89b659$var$readonlyGet = /* @__PURE__ */ $068b8563ee89b659$var$createGetter(true);
var $068b8563ee89b659$var$shallowReadonlyGet = /* @__PURE__ */ $068b8563ee89b659$var$createGetter(true, true);
var $068b8563ee89b659$var$arrayInstrumentations = /* @__PURE__ */ $068b8563ee89b659$var$createArrayInstrumentations();
function $068b8563ee89b659$var$createArrayInstrumentations() {
    var instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _arr, _arr1;
            var arr = $068b8563ee89b659$export$ab18938b9fc5f28e(this);
            for(var i = 0, l = this.length; i < l; i++)$068b8563ee89b659$export$6b2a7d5132615086(arr, "get", i + "");
            var res = (_arr = arr)[key].apply(_arr, (0, $c6Xmf._)(args));
            if (res === -1 || res === false) return (_arr1 = arr)[key].apply(_arr1, (0, $c6Xmf._)(args.map($068b8563ee89b659$export$ab18938b9fc5f28e)));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach(function(key) {
        instrumentations[key] = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            $068b8563ee89b659$export$938a971395fef855();
            var res = $068b8563ee89b659$export$ab18938b9fc5f28e(this)[key].apply(this, args);
            $068b8563ee89b659$export$c39176b1babaa8b8();
            return res;
        };
    });
    return instrumentations;
}
function $068b8563ee89b659$var$hasOwnProperty(key) {
    var obj = $068b8563ee89b659$export$ab18938b9fc5f28e(this);
    $068b8563ee89b659$export$6b2a7d5132615086(obj, "has", key);
    return obj.hasOwnProperty(key);
}
function $068b8563ee89b659$var$createGetter() {
    var isReadonly2 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shallow = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return function get2(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly2;
        else if (key === "__v_isReadonly") return isReadonly2;
        else if (key === "__v_isShallow") return shallow;
        else if (key === "__v_raw" && receiver === (isReadonly2 ? shallow ? $068b8563ee89b659$var$shallowReadonlyMap : $068b8563ee89b659$var$readonlyMap : shallow ? $068b8563ee89b659$var$shallowReactiveMap : $068b8563ee89b659$var$reactiveMap).get(target)) return target;
        var targetIsArray = (0, $hLodm.isArray)(target);
        if (!isReadonly2) {
            if (targetIsArray && (0, $hLodm.hasOwn)($068b8563ee89b659$var$arrayInstrumentations, key)) return Reflect.get($068b8563ee89b659$var$arrayInstrumentations, key, receiver);
            if (key === "hasOwnProperty") return $068b8563ee89b659$var$hasOwnProperty;
        }
        var res = Reflect.get(target, key, receiver);
        if ((0, $hLodm.isSymbol)(key) ? $068b8563ee89b659$var$builtInSymbols.has(key) : $068b8563ee89b659$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly2) $068b8563ee89b659$export$6b2a7d5132615086(target, "get", key);
        if (shallow) return res;
        if ($068b8563ee89b659$export$4f9f5282de18fc69(res)) return targetIsArray && (0, $hLodm.isIntegerKey)(key) ? res : res.value;
        if ((0, $hLodm.isObject)(res)) return isReadonly2 ? $068b8563ee89b659$export$6ec456bd5b7b3c51(res) : $068b8563ee89b659$export$90a44edba14e47be(res);
        return res;
    };
}
var $068b8563ee89b659$var$set$1 = /* @__PURE__ */ $068b8563ee89b659$var$createSetter();
var $068b8563ee89b659$var$shallowSet = /* @__PURE__ */ $068b8563ee89b659$var$createSetter(true);
function $068b8563ee89b659$var$createSetter() {
    var shallow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    return function set2(target, key, value, receiver) {
        var oldValue = target[key];
        if ($068b8563ee89b659$export$92d09b48637741e7(oldValue) && $068b8563ee89b659$export$4f9f5282de18fc69(oldValue) && !$068b8563ee89b659$export$4f9f5282de18fc69(value)) return false;
        if (!shallow) {
            if (!$068b8563ee89b659$export$7f3fe6025abfa26e(value) && !$068b8563ee89b659$export$92d09b48637741e7(value)) {
                oldValue = $068b8563ee89b659$export$ab18938b9fc5f28e(oldValue);
                value = $068b8563ee89b659$export$ab18938b9fc5f28e(value);
            }
            if (!(0, $hLodm.isArray)(target) && $068b8563ee89b659$export$4f9f5282de18fc69(oldValue) && !$068b8563ee89b659$export$4f9f5282de18fc69(value)) {
                oldValue.value = value;
                return true;
            }
        }
        var hadKey = (0, $hLodm.isArray)(target) && (0, $hLodm.isIntegerKey)(key) ? Number(key) < target.length : (0, $hLodm.hasOwn)(target, key);
        var result = Reflect.set(target, key, value, receiver);
        if (target === $068b8563ee89b659$export$ab18938b9fc5f28e(receiver)) {
            if (!hadKey) $068b8563ee89b659$export$e614dc9140f7ae71(target, "add", key, value);
            else if ((0, $hLodm.hasChanged)(value, oldValue)) $068b8563ee89b659$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $068b8563ee89b659$var$deleteProperty(target, key) {
    var hadKey = (0, $hLodm.hasOwn)(target, key);
    var oldValue = target[key];
    var result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $068b8563ee89b659$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $068b8563ee89b659$var$has$1(target, key) {
    var result = Reflect.has(target, key);
    if (!(0, $hLodm.isSymbol)(key) || !$068b8563ee89b659$var$builtInSymbols.has(key)) $068b8563ee89b659$export$6b2a7d5132615086(target, "has", key);
    return result;
}
function $068b8563ee89b659$var$ownKeys(target) {
    $068b8563ee89b659$export$6b2a7d5132615086(target, "iterate", (0, $hLodm.isArray)(target) ? "length" : $068b8563ee89b659$export$3c41b1a4e06acc14);
    return Reflect.ownKeys(target);
}
var $068b8563ee89b659$var$mutableHandlers = {
    get: $068b8563ee89b659$var$get$1,
    set: $068b8563ee89b659$var$set$1,
    deleteProperty: $068b8563ee89b659$var$deleteProperty,
    has: $068b8563ee89b659$var$has$1,
    ownKeys: $068b8563ee89b659$var$ownKeys
};
var $068b8563ee89b659$var$readonlyHandlers = {
    get: $068b8563ee89b659$var$readonlyGet,
    set: function(target, key) {
        return true;
    },
    deleteProperty: function(target, key) {
        return true;
    }
};
var $068b8563ee89b659$var$shallowReactiveHandlers = /* @__PURE__ */ (0, $hLodm.extend)({}, $068b8563ee89b659$var$mutableHandlers, {
    get: $068b8563ee89b659$var$shallowGet,
    set: $068b8563ee89b659$var$shallowSet
});
var $068b8563ee89b659$var$shallowReadonlyHandlers = /* @__PURE__ */ (0, $hLodm.extend)({}, $068b8563ee89b659$var$readonlyHandlers, {
    get: $068b8563ee89b659$var$shallowReadonlyGet
});
var $068b8563ee89b659$var$toShallow = function(value) {
    return value;
};
var $068b8563ee89b659$var$getProto = function(v) {
    return Reflect.getPrototypeOf(v);
};
function $068b8563ee89b659$var$get(target, key) {
    var isReadonly = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isShallow = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    target = target["__v_raw"];
    var rawTarget = $068b8563ee89b659$export$ab18938b9fc5f28e(target);
    var rawKey = $068b8563ee89b659$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $068b8563ee89b659$export$6b2a7d5132615086(rawTarget, "get", key);
        $068b8563ee89b659$export$6b2a7d5132615086(rawTarget, "get", rawKey);
    }
    var _getProto = $068b8563ee89b659$var$getProto(rawTarget), has2 = _getProto.has;
    var wrap = isShallow ? $068b8563ee89b659$var$toShallow : isReadonly ? $068b8563ee89b659$var$toReadonly : $068b8563ee89b659$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $068b8563ee89b659$var$has(key) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var target = this["__v_raw"];
    var rawTarget = $068b8563ee89b659$export$ab18938b9fc5f28e(target);
    var rawKey = $068b8563ee89b659$export$ab18938b9fc5f28e(key);
    if (!isReadonly) {
        if (key !== rawKey) $068b8563ee89b659$export$6b2a7d5132615086(rawTarget, "has", key);
        $068b8563ee89b659$export$6b2a7d5132615086(rawTarget, "has", rawKey);
    }
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $068b8563ee89b659$var$size(target) {
    var isReadonly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    target = target["__v_raw"];
    !isReadonly && $068b8563ee89b659$export$6b2a7d5132615086($068b8563ee89b659$export$ab18938b9fc5f28e(target), "iterate", $068b8563ee89b659$export$3c41b1a4e06acc14);
    return Reflect.get(target, "size", target);
}
function $068b8563ee89b659$var$add(value) {
    value = $068b8563ee89b659$export$ab18938b9fc5f28e(value);
    var target = $068b8563ee89b659$export$ab18938b9fc5f28e(this);
    var proto = $068b8563ee89b659$var$getProto(target);
    var hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $068b8563ee89b659$export$e614dc9140f7ae71(target, "add", value, value);
    }
    return this;
}
function $068b8563ee89b659$var$set(key, value) {
    value = $068b8563ee89b659$export$ab18938b9fc5f28e(value);
    var target = $068b8563ee89b659$export$ab18938b9fc5f28e(this);
    var _getProto = $068b8563ee89b659$var$getProto(target), has2 = _getProto.has, get2 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $068b8563ee89b659$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    var oldValue = get2.call(target, key);
    target.set(key, value);
    if (!hadKey) $068b8563ee89b659$export$e614dc9140f7ae71(target, "add", key, value);
    else if ((0, $hLodm.hasChanged)(value, oldValue)) $068b8563ee89b659$export$e614dc9140f7ae71(target, "set", key, value, oldValue);
    return this;
}
function $068b8563ee89b659$var$deleteEntry(key) {
    var target = $068b8563ee89b659$export$ab18938b9fc5f28e(this);
    var _getProto = $068b8563ee89b659$var$getProto(target), has2 = _getProto.has, get2 = _getProto.get;
    var hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $068b8563ee89b659$export$ab18938b9fc5f28e(key);
        hadKey = has2.call(target, key);
    }
    var oldValue = get2 ? get2.call(target, key) : void 0;
    var result = target.delete(key);
    if (hadKey) $068b8563ee89b659$export$e614dc9140f7ae71(target, "delete", key, void 0, oldValue);
    return result;
}
function $068b8563ee89b659$var$clear() {
    var target = $068b8563ee89b659$export$ab18938b9fc5f28e(this);
    var hadItems = target.size !== 0;
    var oldTarget = void 0;
    var result = target.clear();
    if (hadItems) $068b8563ee89b659$export$e614dc9140f7ae71(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $068b8563ee89b659$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        var observed = this;
        var target = observed["__v_raw"];
        var rawTarget = $068b8563ee89b659$export$ab18938b9fc5f28e(target);
        var wrap = isShallow ? $068b8563ee89b659$var$toShallow : isReadonly ? $068b8563ee89b659$var$toReadonly : $068b8563ee89b659$var$toReactive;
        !isReadonly && $068b8563ee89b659$export$6b2a7d5132615086(rawTarget, "iterate", $068b8563ee89b659$export$3c41b1a4e06acc14);
        return target.forEach(function(value, key) {
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $068b8563ee89b659$var$createIterableMethod(method, isReadonly, isShallow) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _target;
        var target = this["__v_raw"];
        var rawTarget = $068b8563ee89b659$export$ab18938b9fc5f28e(target);
        var targetIsMap = (0, $hLodm.isMap)(rawTarget);
        var isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        var isKeyOnly = method === "keys" && targetIsMap;
        var innerIterator = (_target = target)[method].apply(_target, (0, $c6Xmf._)(args));
        var wrap = isShallow ? $068b8563ee89b659$var$toShallow : isReadonly ? $068b8563ee89b659$var$toReadonly : $068b8563ee89b659$var$toReactive;
        !isReadonly && $068b8563ee89b659$export$6b2a7d5132615086(rawTarget, "iterate", isKeyOnly ? $068b8563ee89b659$var$MAP_KEY_ITERATE_KEY : $068b8563ee89b659$export$3c41b1a4e06acc14);
        return(// iterable protocol
        (0, $3sHb8._)({
            // iterator protocol
            next: function() {
                var _innerIterator_next = innerIterator.next(), value = _innerIterator_next.value, done = _innerIterator_next.done;
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            }
        }, Symbol.iterator, function() {
            return this;
        }));
    };
}
function $068b8563ee89b659$var$createReadonlyMethod(type) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return type === "delete" ? false : this;
    };
}
function $068b8563ee89b659$var$createInstrumentations() {
    var mutableInstrumentations2 = {
        get: function(key) {
            return $068b8563ee89b659$var$get(this, key);
        },
        get size () {
            return $068b8563ee89b659$var$size(this);
        },
        has: $068b8563ee89b659$var$has,
        add: $068b8563ee89b659$var$add,
        set: $068b8563ee89b659$var$set,
        delete: $068b8563ee89b659$var$deleteEntry,
        clear: $068b8563ee89b659$var$clear,
        forEach: $068b8563ee89b659$var$createForEach(false, false)
    };
    var shallowInstrumentations2 = {
        get: function(key) {
            return $068b8563ee89b659$var$get(this, key, false, true);
        },
        get size () {
            return $068b8563ee89b659$var$size(this);
        },
        has: $068b8563ee89b659$var$has,
        add: $068b8563ee89b659$var$add,
        set: $068b8563ee89b659$var$set,
        delete: $068b8563ee89b659$var$deleteEntry,
        clear: $068b8563ee89b659$var$clear,
        forEach: $068b8563ee89b659$var$createForEach(false, true)
    };
    var readonlyInstrumentations2 = {
        get: function(key) {
            return $068b8563ee89b659$var$get(this, key, true);
        },
        get size () {
            return $068b8563ee89b659$var$size(this, true);
        },
        has: function(key) {
            return $068b8563ee89b659$var$has.call(this, key, true);
        },
        add: $068b8563ee89b659$var$createReadonlyMethod("add"),
        set: $068b8563ee89b659$var$createReadonlyMethod("set"),
        delete: $068b8563ee89b659$var$createReadonlyMethod("delete"),
        clear: $068b8563ee89b659$var$createReadonlyMethod("clear"),
        forEach: $068b8563ee89b659$var$createForEach(true, false)
    };
    var shallowReadonlyInstrumentations2 = {
        get: function(key) {
            return $068b8563ee89b659$var$get(this, key, true, true);
        },
        get size () {
            return $068b8563ee89b659$var$size(this, true);
        },
        has: function(key) {
            return $068b8563ee89b659$var$has.call(this, key, true);
        },
        add: $068b8563ee89b659$var$createReadonlyMethod("add"),
        set: $068b8563ee89b659$var$createReadonlyMethod("set"),
        delete: $068b8563ee89b659$var$createReadonlyMethod("delete"),
        clear: $068b8563ee89b659$var$createReadonlyMethod("clear"),
        forEach: $068b8563ee89b659$var$createForEach(true, true)
    };
    var iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach(function(method) {
        mutableInstrumentations2[method] = $068b8563ee89b659$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $068b8563ee89b659$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $068b8563ee89b659$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $068b8563ee89b659$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var /* @__PURE__ */ $068b8563ee89b659$var$_createInstrumentations = (0, $cv9Rk._)($068b8563ee89b659$var$createInstrumentations(), 4), $068b8563ee89b659$var$mutableInstrumentations = $068b8563ee89b659$var$_createInstrumentations[0], $068b8563ee89b659$var$readonlyInstrumentations = $068b8563ee89b659$var$_createInstrumentations[1], $068b8563ee89b659$var$shallowInstrumentations = $068b8563ee89b659$var$_createInstrumentations[2], $068b8563ee89b659$var$shallowReadonlyInstrumentations = $068b8563ee89b659$var$_createInstrumentations[3];
function $068b8563ee89b659$var$createInstrumentationGetter(isReadonly, shallow) {
    var instrumentations = shallow ? isReadonly ? $068b8563ee89b659$var$shallowReadonlyInstrumentations : $068b8563ee89b659$var$shallowInstrumentations : isReadonly ? $068b8563ee89b659$var$readonlyInstrumentations : $068b8563ee89b659$var$mutableInstrumentations;
    return function(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get((0, $hLodm.hasOwn)(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $068b8563ee89b659$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $068b8563ee89b659$var$createInstrumentationGetter(false, false)
};
var $068b8563ee89b659$var$shallowCollectionHandlers = {
    get: /* @__PURE__ */ $068b8563ee89b659$var$createInstrumentationGetter(false, true)
};
var $068b8563ee89b659$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $068b8563ee89b659$var$createInstrumentationGetter(true, false)
};
var $068b8563ee89b659$var$shallowReadonlyCollectionHandlers = {
    get: /* @__PURE__ */ $068b8563ee89b659$var$createInstrumentationGetter(true, true)
};
function $068b8563ee89b659$var$checkIdentityKeys(target, has2, key) {
    var rawKey = $068b8563ee89b659$export$ab18938b9fc5f28e(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        var type = (0, $hLodm.toRawType)(target);
        console.warn("Reactive ".concat(type, " contains both the raw and reactive versions of the same object").concat(type === "Map" ? " as keys" : "", ", which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible."));
    }
}
var $068b8563ee89b659$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $068b8563ee89b659$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $068b8563ee89b659$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $068b8563ee89b659$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $068b8563ee89b659$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1 /* COMMON */ ;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2 /* COLLECTION */ ;
        default:
            return 0 /* INVALID */ ;
    }
}
function $068b8563ee89b659$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 /* INVALID */  : $068b8563ee89b659$var$targetTypeMap((0, $hLodm.toRawType)(value));
}
function $068b8563ee89b659$export$90a44edba14e47be(target) {
    if ($068b8563ee89b659$export$92d09b48637741e7(target)) return target;
    return $068b8563ee89b659$var$createReactiveObject(target, false, $068b8563ee89b659$var$mutableHandlers, $068b8563ee89b659$var$mutableCollectionHandlers, $068b8563ee89b659$var$reactiveMap);
}
function $068b8563ee89b659$export$8d81cefd22d22260(target) {
    return $068b8563ee89b659$var$createReactiveObject(target, false, $068b8563ee89b659$var$shallowReactiveHandlers, $068b8563ee89b659$var$shallowCollectionHandlers, $068b8563ee89b659$var$shallowReactiveMap);
}
function $068b8563ee89b659$export$6ec456bd5b7b3c51(target) {
    return $068b8563ee89b659$var$createReactiveObject(target, true, $068b8563ee89b659$var$readonlyHandlers, $068b8563ee89b659$var$readonlyCollectionHandlers, $068b8563ee89b659$var$readonlyMap);
}
function $068b8563ee89b659$export$7c4b5f2b50f09f6b(target) {
    return $068b8563ee89b659$var$createReactiveObject(target, true, $068b8563ee89b659$var$shallowReadonlyHandlers, $068b8563ee89b659$var$shallowReadonlyCollectionHandlers, $068b8563ee89b659$var$shallowReadonlyMap);
}
function $068b8563ee89b659$var$createReactiveObject(target, isReadonly2, baseHandlers, collectionHandlers, proxyMap) {
    if (!(0, $hLodm.isObject)(target)) return target;
    if (target["__v_raw"] && !(isReadonly2 && target["__v_isReactive"])) return target;
    var existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    var targetType = $068b8563ee89b659$var$getTargetType(target);
    if (targetType === 0 /* INVALID */ ) return target;
    var proxy = new Proxy(target, targetType === 2 /* COLLECTION */  ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $068b8563ee89b659$export$352205f445242f02(value) {
    if ($068b8563ee89b659$export$92d09b48637741e7(value)) return $068b8563ee89b659$export$352205f445242f02(value["__v_raw"]);
    return !!(value && value["__v_isReactive"]);
}
function $068b8563ee89b659$export$92d09b48637741e7(value) {
    return !!(value && value["__v_isReadonly"]);
}
function $068b8563ee89b659$export$7f3fe6025abfa26e(value) {
    return !!(value && value["__v_isShallow"]);
}
function $068b8563ee89b659$export$5f3ca29d057519b3(value) {
    return $068b8563ee89b659$export$352205f445242f02(value) || $068b8563ee89b659$export$92d09b48637741e7(value);
}
function $068b8563ee89b659$export$ab18938b9fc5f28e(observed) {
    var raw = observed && observed["__v_raw"];
    return raw ? $068b8563ee89b659$export$ab18938b9fc5f28e(raw) : observed;
}
function $068b8563ee89b659$export$995ab8b13ad7a9d0(value) {
    (0, $hLodm.def)(value, "__v_skip", true);
    return value;
}
var $068b8563ee89b659$var$toReactive = function(value) {
    return (0, $hLodm.isObject)(value) ? $068b8563ee89b659$export$90a44edba14e47be(value) : value;
};
var $068b8563ee89b659$var$toReadonly = function(value) {
    return (0, $hLodm.isObject)(value) ? $068b8563ee89b659$export$6ec456bd5b7b3c51(value) : value;
};
function $068b8563ee89b659$var$trackRefValue(ref2) {
    if ($068b8563ee89b659$var$shouldTrack && $068b8563ee89b659$var$activeEffect) {
        ref2 = $068b8563ee89b659$export$ab18938b9fc5f28e(ref2);
        $068b8563ee89b659$var$trackEffects(ref2.dep || (ref2.dep = $068b8563ee89b659$var$createDep()));
    }
}
function $068b8563ee89b659$var$triggerRefValue(ref2, newVal) {
    ref2 = $068b8563ee89b659$export$ab18938b9fc5f28e(ref2);
    var dep = ref2.dep;
    if (dep) $068b8563ee89b659$var$triggerEffects(dep);
}
function $068b8563ee89b659$export$4f9f5282de18fc69(r) {
    return !!(r && r.__v_isRef === true);
}
function $068b8563ee89b659$export$eff4d24c3ff7876e(value) {
    return $068b8563ee89b659$var$createRef(value, false);
}
function $068b8563ee89b659$export$9b7bc5fe3b17c8b3(value) {
    return $068b8563ee89b659$var$createRef(value, true);
}
function $068b8563ee89b659$var$createRef(rawValue, shallow) {
    if ($068b8563ee89b659$export$4f9f5282de18fc69(rawValue)) return rawValue;
    return new $068b8563ee89b659$var$RefImpl(rawValue, shallow);
}
var $068b8563ee89b659$var$RefImpl = /*#__PURE__*/ function() {
    "use strict";
    function RefImpl(value, __v_isShallow) {
        (0, $4GJKx._)(this, RefImpl);
        this.__v_isShallow = __v_isShallow;
        this.dep = void 0;
        this.__v_isRef = true;
        this._rawValue = __v_isShallow ? value : $068b8563ee89b659$export$ab18938b9fc5f28e(value);
        this._value = __v_isShallow ? value : $068b8563ee89b659$var$toReactive(value);
    }
    (0, $1wc17._)(RefImpl, [
        {
            key: "value",
            get: function get() {
                $068b8563ee89b659$var$trackRefValue(this);
                return this._value;
            },
            set: function set(newVal) {
                var useDirectValue = this.__v_isShallow || $068b8563ee89b659$export$7f3fe6025abfa26e(newVal) || $068b8563ee89b659$export$92d09b48637741e7(newVal);
                newVal = useDirectValue ? newVal : $068b8563ee89b659$export$ab18938b9fc5f28e(newVal);
                if ((0, $hLodm.hasChanged)(newVal, this._rawValue)) {
                    this._rawValue = newVal;
                    this._value = useDirectValue ? newVal : $068b8563ee89b659$var$toReactive(newVal);
                    $068b8563ee89b659$var$triggerRefValue(this, newVal);
                }
            }
        }
    ]);
    return RefImpl;
}();
function $068b8563ee89b659$export$f402f86588575ccc(ref2) {
    $068b8563ee89b659$var$triggerRefValue(ref2, void 0);
}
function $068b8563ee89b659$export$a239a76781616204(ref2) {
    return $068b8563ee89b659$export$4f9f5282de18fc69(ref2) ? ref2.value : ref2;
}
function $068b8563ee89b659$export$30bdcc2218aa9458(source) {
    return (0, $hLodm.isFunction)(source) ? source() : $068b8563ee89b659$export$a239a76781616204(source);
}
var $068b8563ee89b659$var$shallowUnwrapHandlers = {
    get: function(target, key, receiver) {
        return $068b8563ee89b659$export$a239a76781616204(Reflect.get(target, key, receiver));
    },
    set: function(target, key, value, receiver) {
        var oldValue = target[key];
        if ($068b8563ee89b659$export$4f9f5282de18fc69(oldValue) && !$068b8563ee89b659$export$4f9f5282de18fc69(value)) {
            oldValue.value = value;
            return true;
        } else return Reflect.set(target, key, value, receiver);
    }
};
function $068b8563ee89b659$export$f353fd1b97db3fa0(objectWithRefs) {
    return $068b8563ee89b659$export$352205f445242f02(objectWithRefs) ? objectWithRefs : new Proxy(objectWithRefs, $068b8563ee89b659$var$shallowUnwrapHandlers);
}
var $068b8563ee89b659$var$CustomRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function CustomRefImpl(factory) {
        var _this = this;
        (0, $4GJKx._)(this, CustomRefImpl);
        this.dep = void 0;
        this.__v_isRef = true;
        var _factory = factory(function() {
            return $068b8563ee89b659$var$trackRefValue(_this);
        }, function() {
            return $068b8563ee89b659$var$triggerRefValue(_this);
        }), get = _factory.get, set = _factory.set;
        this._get = get;
        this._set = set;
    }
    (0, $1wc17._)(CustomRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._get();
            },
            set: function set(newVal) {
                this._set(newVal);
            }
        }
    ]);
    return CustomRefImpl;
}();
function $068b8563ee89b659$export$a20c2dd6199824cb(factory) {
    return new $068b8563ee89b659$var$CustomRefImpl(factory);
}
function $068b8563ee89b659$export$2e9533675e5e70e0(object) {
    var ret = (0, $hLodm.isArray)(object) ? new Array(object.length) : {};
    for(var key in object)ret[key] = $068b8563ee89b659$var$propertyToRef(object, key);
    return ret;
}
var $068b8563ee89b659$var$ObjectRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ObjectRefImpl(_object, _key, _defaultValue) {
        (0, $4GJKx._)(this, ObjectRefImpl);
        this._object = _object;
        this._key = _key;
        this._defaultValue = _defaultValue;
        this.__v_isRef = true;
    }
    (0, $1wc17._)(ObjectRefImpl, [
        {
            key: "value",
            get: function get() {
                var val = this._object[this._key];
                return val === void 0 ? this._defaultValue : val;
            },
            set: function set(newVal) {
                this._object[this._key] = newVal;
            }
        },
        {
            key: "dep",
            get: function get() {
                return $068b8563ee89b659$var$getDepFromReactive($068b8563ee89b659$export$ab18938b9fc5f28e(this._object), this._key);
            }
        }
    ]);
    return ObjectRefImpl;
}();
var $068b8563ee89b659$var$GetterRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function GetterRefImpl(_getter) {
        (0, $4GJKx._)(this, GetterRefImpl);
        this._getter = _getter;
        this.__v_isRef = true;
        this.__v_isReadonly = true;
    }
    (0, $1wc17._)(GetterRefImpl, [
        {
            key: "value",
            get: function get() {
                return this._getter();
            }
        }
    ]);
    return GetterRefImpl;
}();
function $068b8563ee89b659$export$1f60508e4f47b4b7(source, key, defaultValue) {
    if ($068b8563ee89b659$export$4f9f5282de18fc69(source)) return source;
    else if ((0, $hLodm.isFunction)(source)) return new $068b8563ee89b659$var$GetterRefImpl(source);
    else if ((0, $hLodm.isObject)(source) && arguments.length > 1) return $068b8563ee89b659$var$propertyToRef(source, key, defaultValue);
    else return $068b8563ee89b659$export$eff4d24c3ff7876e(source);
}
function $068b8563ee89b659$var$propertyToRef(source, key, defaultValue) {
    var val = source[key];
    return $068b8563ee89b659$export$4f9f5282de18fc69(val) ? val : new $068b8563ee89b659$var$ObjectRefImpl(source, key, defaultValue);
}
var $068b8563ee89b659$var$ComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function ComputedRefImpl(getter, _setter, isReadonly, isSSR) {
        var _this = this;
        (0, $4GJKx._)(this, ComputedRefImpl);
        this._setter = _setter;
        this.dep = void 0;
        this.__v_isRef = true;
        this["__v_isReadonly"] = false;
        this._dirty = true;
        this.effect = new $068b8563ee89b659$export$28352bb4dd362521(getter, function() {
            if (!_this._dirty) {
                _this._dirty = true;
                $068b8563ee89b659$var$triggerRefValue(_this);
            }
        });
        this.effect.computed = this;
        this.effect.active = this._cacheable = !isSSR;
        this["__v_isReadonly"] = isReadonly;
    }
    (0, $1wc17._)(ComputedRefImpl, [
        {
            key: "value",
            get: function get() {
                var self = $068b8563ee89b659$export$ab18938b9fc5f28e(this);
                $068b8563ee89b659$var$trackRefValue(self);
                if (self._dirty || !self._cacheable) {
                    self._dirty = false;
                    self._value = self.effect.run();
                }
                return self._value;
            },
            set: function set(newValue) {
                this._setter(newValue);
            }
        }
    ]);
    return ComputedRefImpl;
}();
function $068b8563ee89b659$export$2983e091f1a1e8e2(getterOrOptions, debugOptions) {
    var isSSR = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var getter;
    var setter;
    var onlyGetter = (0, $hLodm.isFunction)(getterOrOptions);
    if (onlyGetter) {
        getter = getterOrOptions;
        setter = (0, $hLodm.NOOP);
    } else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var cRef = new $068b8563ee89b659$var$ComputedRefImpl(getter, setter, onlyGetter || !setter, isSSR);
    return cRef;
}
var $068b8563ee89b659$var$tick = /* @__PURE__ */ Promise.resolve();
var $068b8563ee89b659$var$queue = [];
var $068b8563ee89b659$var$queued = false;
var $068b8563ee89b659$var$scheduler = function(fn) {
    $068b8563ee89b659$var$queue.push(fn);
    if (!$068b8563ee89b659$var$queued) {
        $068b8563ee89b659$var$queued = true;
        $068b8563ee89b659$var$tick.then($068b8563ee89b659$var$flush);
    }
};
var $068b8563ee89b659$var$flush = function() {
    for(var i = 0; i < $068b8563ee89b659$var$queue.length; i++)$068b8563ee89b659$var$queue[i]();
    $068b8563ee89b659$var$queue.length = 0;
    $068b8563ee89b659$var$queued = false;
};
var $068b8563ee89b659$var$DeferredComputedRefImpl = /*#__PURE__*/ function() {
    "use strict";
    function DeferredComputedRefImpl(getter) {
        var _this = this;
        (0, $4GJKx._)(this, DeferredComputedRefImpl);
        this.dep = void 0;
        this._dirty = true;
        this.__v_isRef = true;
        this["__v_isReadonly"] = true;
        var compareTarget;
        var hasCompareTarget = false;
        var scheduled = false;
        this.effect = new $068b8563ee89b659$export$28352bb4dd362521(getter, function(computedTrigger) {
            if (_this.dep) {
                if (computedTrigger) {
                    compareTarget = _this._value;
                    hasCompareTarget = true;
                } else if (!scheduled) {
                    var valueToCompare = hasCompareTarget ? compareTarget : _this._value;
                    scheduled = true;
                    hasCompareTarget = false;
                    $068b8563ee89b659$var$scheduler(function() {
                        if (_this.effect.active && _this._get() !== valueToCompare) $068b8563ee89b659$var$triggerRefValue(_this);
                        scheduled = false;
                    });
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _this.dep[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var e = _step.value;
                        if (e.computed instanceof DeferredComputedRefImpl) e.scheduler(true);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            _this._dirty = true;
        });
        this.effect.computed = this;
    }
    (0, $1wc17._)(DeferredComputedRefImpl, [
        {
            key: "_get",
            value: function _get() {
                if (this._dirty) {
                    this._dirty = false;
                    return this._value = this.effect.run();
                }
                return this._value;
            }
        },
        {
            key: "value",
            get: function get() {
                $068b8563ee89b659$var$trackRefValue(this);
                return $068b8563ee89b659$export$ab18938b9fc5f28e(this)._get();
            }
        }
    ]);
    return DeferredComputedRefImpl;
}();
function $068b8563ee89b659$export$483264c4ec4c46ce(getter) {
    return new $068b8563ee89b659$var$DeferredComputedRefImpl(getter);
}

});
parcelRequire.register("4GJKx", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $369e92947825c2b5$export$2996f80ef42b8419; });
function $369e92947825c2b5$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("1wc17", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $11b219ef186b1c94$export$d60067ff2358eee8; });
function $11b219ef186b1c94$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $11b219ef186b1c94$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $11b219ef186b1c94$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $11b219ef186b1c94$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("hLodm", function(module, exports) {

$parcel$export(module.exports, "makeMap", function () { return $cee99bf667b6fd39$export$b41394a5437791c8; });
$parcel$export(module.exports, "EMPTY_OBJ", function () { return $cee99bf667b6fd39$export$cf583d23ab39677c; });
$parcel$export(module.exports, "EMPTY_ARR", function () { return $cee99bf667b6fd39$export$6bd8558f433f1cc1; });
$parcel$export(module.exports, "NOOP", function () { return $cee99bf667b6fd39$export$5702a91a6f42969f; });
$parcel$export(module.exports, "NO", function () { return $cee99bf667b6fd39$export$c01351c0af048e39; });
$parcel$export(module.exports, "isOn", function () { return $cee99bf667b6fd39$export$1a2d97de39ecbb75; });
$parcel$export(module.exports, "isModelListener", function () { return $cee99bf667b6fd39$export$793aa5469768d691; });
$parcel$export(module.exports, "extend", function () { return $cee99bf667b6fd39$export$8b58be045bf06082; });
$parcel$export(module.exports, "remove", function () { return $cee99bf667b6fd39$export$cd7f480d6b8286c3; });
$parcel$export(module.exports, "hasOwn", function () { return $cee99bf667b6fd39$export$b5a638e9b3fff9f3; });
$parcel$export(module.exports, "isArray", function () { return $cee99bf667b6fd39$export$43bee75e5e14138e; });
$parcel$export(module.exports, "isMap", function () { return $cee99bf667b6fd39$export$5c90113a285f2241; });
$parcel$export(module.exports, "isSet", function () { return $cee99bf667b6fd39$export$6750766a7c7ec627; });
$parcel$export(module.exports, "isRegExp", function () { return $cee99bf667b6fd39$export$49841c62b9eff15; });
$parcel$export(module.exports, "isFunction", function () { return $cee99bf667b6fd39$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "isString", function () { return $cee99bf667b6fd39$export$844ec244b1367d54; });
$parcel$export(module.exports, "isSymbol", function () { return $cee99bf667b6fd39$export$a244864fd9645c7f; });
$parcel$export(module.exports, "isObject", function () { return $cee99bf667b6fd39$export$a6cdc56e425d0d0a; });
$parcel$export(module.exports, "isPromise", function () { return $cee99bf667b6fd39$export$4369c812aac99591; });
$parcel$export(module.exports, "toRawType", function () { return $cee99bf667b6fd39$export$5ad0a3c360b8fbb5; });
$parcel$export(module.exports, "isPlainObject", function () { return $cee99bf667b6fd39$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isIntegerKey", function () { return $cee99bf667b6fd39$export$e2a2b93446ec9fe; });
$parcel$export(module.exports, "isReservedProp", function () { return $cee99bf667b6fd39$export$bf7d3c0236f0aa85; });
$parcel$export(module.exports, "isBuiltInDirective", function () { return $cee99bf667b6fd39$export$a9c1fdb3030c2a6b; });
$parcel$export(module.exports, "camelize", function () { return $cee99bf667b6fd39$export$161d051f5dd25de7; });
$parcel$export(module.exports, "hyphenate", function () { return $cee99bf667b6fd39$export$6e6a0a3676c4b8bb; });
$parcel$export(module.exports, "capitalize", function () { return $cee99bf667b6fd39$export$9a00dee1beb8f576; });
$parcel$export(module.exports, "toHandlerKey", function () { return $cee99bf667b6fd39$export$8c022799eeaaefcd; });
$parcel$export(module.exports, "hasChanged", function () { return $cee99bf667b6fd39$export$f619eb8b89076d23; });
$parcel$export(module.exports, "invokeArrayFns", function () { return $cee99bf667b6fd39$export$39951422d618a9d3; });
$parcel$export(module.exports, "def", function () { return $cee99bf667b6fd39$export$8afb76124cf08683; });
$parcel$export(module.exports, "looseToNumber", function () { return $cee99bf667b6fd39$export$d3be7195bcc2f31b; });
$parcel$export(module.exports, "toNumber", function () { return $cee99bf667b6fd39$export$a0a81dc3380ce7d3; });
$parcel$export(module.exports, "getGlobalThis", function () { return $cee99bf667b6fd39$export$ff5f2eeb11fc7e14; });
$parcel$export(module.exports, "isGloballyWhitelisted", function () { return $cee99bf667b6fd39$export$d6571a1911e4f27e; });
$parcel$export(module.exports, "normalizeStyle", function () { return $cee99bf667b6fd39$export$8756898546458274; });
$parcel$export(module.exports, "normalizeClass", function () { return $cee99bf667b6fd39$export$4f7022d2d68e2c5a; });
$parcel$export(module.exports, "isHTMLTag", function () { return $cee99bf667b6fd39$export$1ccf854a0984f890; });
$parcel$export(module.exports, "isSVGTag", function () { return $cee99bf667b6fd39$export$6328ce7565ea1049; });
$parcel$export(module.exports, "isSpecialBooleanAttr", function () { return $cee99bf667b6fd39$export$d186f5eb2e810715; });
$parcel$export(module.exports, "includeBooleanAttr", function () { return $cee99bf667b6fd39$export$e3f3cdb1390d56ce; });
$parcel$export(module.exports, "looseEqual", function () { return $cee99bf667b6fd39$export$ae8015769846262c; });
$parcel$export(module.exports, "looseIndexOf", function () { return $cee99bf667b6fd39$export$42912a80cedb8bd4; });
$parcel$export(module.exports, "toDisplayString", function () { return $cee99bf667b6fd39$export$b5b1545233b45293; });

var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");
function $cee99bf667b6fd39$export$b41394a5437791c8(str, expectsLowerCase) {
    var map = /* @__PURE__ */ Object.create(null);
    var list = str.split(",");
    for(var i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? function(val) {
        return !!map[val.toLowerCase()];
    } : function(val) {
        return !!map[val];
    };
}
var $cee99bf667b6fd39$export$cf583d23ab39677c = {};
var $cee99bf667b6fd39$export$6bd8558f433f1cc1 = [];
var $cee99bf667b6fd39$export$5702a91a6f42969f = function() {};
var $cee99bf667b6fd39$export$c01351c0af048e39 = function() {
    return false;
};
var $cee99bf667b6fd39$var$onRE = /^on[^a-z]/;
var $cee99bf667b6fd39$export$1a2d97de39ecbb75 = function(key) {
    return $cee99bf667b6fd39$var$onRE.test(key);
};
var $cee99bf667b6fd39$export$793aa5469768d691 = function(key) {
    return key.startsWith("onUpdate:");
};
var $cee99bf667b6fd39$export$8b58be045bf06082 = Object.assign;
var $cee99bf667b6fd39$export$cd7f480d6b8286c3 = function(arr, el) {
    var i = arr.indexOf(el);
    if (i > -1) arr.splice(i, 1);
};
var $cee99bf667b6fd39$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $cee99bf667b6fd39$export$b5a638e9b3fff9f3 = function(val, key) {
    return $cee99bf667b6fd39$var$hasOwnProperty.call(val, key);
};
var $cee99bf667b6fd39$export$43bee75e5e14138e = Array.isArray;
var $cee99bf667b6fd39$export$5c90113a285f2241 = function(val) {
    return $cee99bf667b6fd39$export$1dccc787cc36538b(val) === "[object Map]";
};
var $cee99bf667b6fd39$export$6750766a7c7ec627 = function(val) {
    return $cee99bf667b6fd39$export$1dccc787cc36538b(val) === "[object Set]";
};
var $cee99bf667b6fd39$export$871608497c498473 = function(val) {
    return $cee99bf667b6fd39$export$1dccc787cc36538b(val) === "[object Date]";
};
var $cee99bf667b6fd39$export$49841c62b9eff15 = function(val) {
    return $cee99bf667b6fd39$export$1dccc787cc36538b(val) === "[object RegExp]";
};
var $cee99bf667b6fd39$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $cee99bf667b6fd39$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $cee99bf667b6fd39$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val)) === "symbol";
};
var $cee99bf667b6fd39$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && typeof val === "object";
};
var $cee99bf667b6fd39$export$4369c812aac99591 = function(val) {
    return $cee99bf667b6fd39$export$a6cdc56e425d0d0a(val) && $cee99bf667b6fd39$export$f6e2535fb5126e54(val.then) && $cee99bf667b6fd39$export$f6e2535fb5126e54(val.catch);
};
var $cee99bf667b6fd39$export$830c053460e5ddf6 = Object.prototype.toString;
var $cee99bf667b6fd39$export$1dccc787cc36538b = function(value) {
    return $cee99bf667b6fd39$export$830c053460e5ddf6.call(value);
};
var $cee99bf667b6fd39$export$5ad0a3c360b8fbb5 = function(value) {
    return $cee99bf667b6fd39$export$1dccc787cc36538b(value).slice(8, -1);
};
var $cee99bf667b6fd39$export$53b83ca8eaab0383 = function(val) {
    return $cee99bf667b6fd39$export$1dccc787cc36538b(val) === "[object Object]";
};
var $cee99bf667b6fd39$export$e2a2b93446ec9fe = function(key) {
    return $cee99bf667b6fd39$export$844ec244b1367d54(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
};
var $cee99bf667b6fd39$export$bf7d3c0236f0aa85 = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8(// the leading comma is intentional so empty string "" is also included
",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted");
var $cee99bf667b6fd39$export$a9c1fdb3030c2a6b = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8("bind,cloak,else-if,else,for,html,if,model,on,once,pre,show,slot,text,memo");
var $cee99bf667b6fd39$var$cacheStringFunction = function(fn) {
    var cache = /* @__PURE__ */ Object.create(null);
    return function(str) {
        var hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $cee99bf667b6fd39$var$camelizeRE = /-(\w)/g;
var $cee99bf667b6fd39$export$161d051f5dd25de7 = $cee99bf667b6fd39$var$cacheStringFunction(function(str) {
    return str.replace($cee99bf667b6fd39$var$camelizeRE, function(_, c) {
        return c ? c.toUpperCase() : "";
    });
});
var $cee99bf667b6fd39$var$hyphenateRE = /\B([A-Z])/g;
var $cee99bf667b6fd39$export$6e6a0a3676c4b8bb = $cee99bf667b6fd39$var$cacheStringFunction(function(str) {
    return str.replace($cee99bf667b6fd39$var$hyphenateRE, "-$1").toLowerCase();
});
var $cee99bf667b6fd39$export$9a00dee1beb8f576 = $cee99bf667b6fd39$var$cacheStringFunction(function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
});
var $cee99bf667b6fd39$export$8c022799eeaaefcd = $cee99bf667b6fd39$var$cacheStringFunction(function(str) {
    return str ? "on".concat($cee99bf667b6fd39$export$9a00dee1beb8f576(str)) : "";
});
var $cee99bf667b6fd39$export$f619eb8b89076d23 = function(value, oldValue) {
    return !Object.is(value, oldValue);
};
var $cee99bf667b6fd39$export$39951422d618a9d3 = function(fns, arg) {
    for(var i = 0; i < fns.length; i++)fns[i](arg);
};
var $cee99bf667b6fd39$export$8afb76124cf08683 = function(obj, key, value) {
    Object.defineProperty(obj, key, {
        configurable: true,
        enumerable: false,
        value: value
    });
};
var $cee99bf667b6fd39$export$d3be7195bcc2f31b = function(val) {
    var n = parseFloat(val);
    return isNaN(n) ? val : n;
};
var $cee99bf667b6fd39$export$a0a81dc3380ce7d3 = function(val) {
    var n = $cee99bf667b6fd39$export$844ec244b1367d54(val) ? Number(val) : NaN;
    return isNaN(n) ? val : n;
};
var $cee99bf667b6fd39$var$_globalThis;
var $cee99bf667b6fd39$export$ff5f2eeb11fc7e14 = function() {
    return $cee99bf667b6fd39$var$_globalThis || ($cee99bf667b6fd39$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
var $cee99bf667b6fd39$var$identRE = /^[_$a-zA-Z\xA0-\uFFFF][_$a-zA-Z0-9\xA0-\uFFFF]*$/;
function $cee99bf667b6fd39$export$53d5e12f9a1d3cde(name) {
    return $cee99bf667b6fd39$var$identRE.test(name) ? "__props.".concat(name) : "__props[".concat(JSON.stringify(name), "]");
}
var $cee99bf667b6fd39$var$_obj;
var $cee99bf667b6fd39$export$def7dc2c2e95a08a = ($cee99bf667b6fd39$var$_obj = {}, (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 1, "TEXT"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 2, "CLASS"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 4, "STYLE"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 8, "PROPS"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 16, "FULL_PROPS"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 32, "HYDRATE_EVENTS"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 64, "STABLE_FRAGMENT"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 128, "KEYED_FRAGMENT"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 256, "UNKEYED_FRAGMENT"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 512, "NEED_PATCH"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 1024, "DYNAMIC_SLOTS"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, 2048, "DEV_ROOT_FRAGMENT"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, -1, "HOISTED"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj, -2, "BAIL"), $cee99bf667b6fd39$var$_obj);
var $cee99bf667b6fd39$var$_obj1;
var $cee99bf667b6fd39$export$624972196ed3745f = ($cee99bf667b6fd39$var$_obj1 = {}, (0, $3sHb8._)($cee99bf667b6fd39$var$_obj1, 1, "STABLE"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj1, 2, "DYNAMIC"), (0, $3sHb8._)($cee99bf667b6fd39$var$_obj1, 3, "FORWARDED"), $cee99bf667b6fd39$var$_obj1);
var $cee99bf667b6fd39$var$GLOBALS_WHITE_LISTED = "Infinity,undefined,NaN,isFinite,isNaN,parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,BigInt,console";
var $cee99bf667b6fd39$export$d6571a1911e4f27e = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8($cee99bf667b6fd39$var$GLOBALS_WHITE_LISTED);
var $cee99bf667b6fd39$var$range = 2;
function $cee99bf667b6fd39$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    var lines = source.split(/(\r?\n)/);
    var newlineSequences = lines.filter(function(_, idx) {
        return idx % 2 === 1;
    });
    lines = lines.filter(function(_, idx) {
        return idx % 2 === 0;
    });
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + (newlineSequences[i] && newlineSequences[i].length || 0);
        if (count >= start) {
            for(var j = i - $cee99bf667b6fd39$var$range; j <= i + $cee99bf667b6fd39$var$range || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(Math.max(3 - String(line).length, 0)), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                var newLineSeqLength = newlineSequences[j] && newlineSequences[j].length || 0;
                if (j === i) {
                    var pad = start - (count - (lineLength + newLineSeqLength));
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + newLineSeqLength;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
function $cee99bf667b6fd39$export$8756898546458274(value) {
    if ($cee99bf667b6fd39$export$43bee75e5e14138e(value)) {
        var res = {};
        for(var i = 0; i < value.length; i++){
            var item = value[i];
            var normalized = $cee99bf667b6fd39$export$844ec244b1367d54(item) ? $cee99bf667b6fd39$export$76a205ce979d066a(item) : $cee99bf667b6fd39$export$8756898546458274(item);
            if (normalized) for(var key in normalized)res[key] = normalized[key];
        }
        return res;
    } else if ($cee99bf667b6fd39$export$844ec244b1367d54(value)) return value;
    else if ($cee99bf667b6fd39$export$a6cdc56e425d0d0a(value)) return value;
}
var $cee99bf667b6fd39$var$listDelimiterRE = /;(?![^(]*\))/g;
var $cee99bf667b6fd39$var$propertyDelimiterRE = /:([^]+)/;
var $cee99bf667b6fd39$var$styleCommentRE = /\/\*[^]*?\*\//g;
function $cee99bf667b6fd39$export$76a205ce979d066a(cssText) {
    var ret = {};
    cssText.replace($cee99bf667b6fd39$var$styleCommentRE, "").split($cee99bf667b6fd39$var$listDelimiterRE).forEach(function(item) {
        if (item) {
            var tmp = item.split($cee99bf667b6fd39$var$propertyDelimiterRE);
            tmp.length > 1 && (ret[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return ret;
}
function $cee99bf667b6fd39$export$9466a5a0ee6f1479(styles) {
    var ret = "";
    if (!styles || $cee99bf667b6fd39$export$844ec244b1367d54(styles)) return ret;
    for(var key in styles){
        var value = styles[key];
        var normalizedKey = key.startsWith("--") ? key : $cee99bf667b6fd39$export$6e6a0a3676c4b8bb(key);
        if ($cee99bf667b6fd39$export$844ec244b1367d54(value) || typeof value === "number") ret += "".concat(normalizedKey, ":").concat(value, ";");
    }
    return ret;
}
function $cee99bf667b6fd39$export$4f7022d2d68e2c5a(value) {
    var res = "";
    if ($cee99bf667b6fd39$export$844ec244b1367d54(value)) res = value;
    else if ($cee99bf667b6fd39$export$43bee75e5e14138e(value)) for(var i = 0; i < value.length; i++){
        var normalized = $cee99bf667b6fd39$export$4f7022d2d68e2c5a(value[i]);
        if (normalized) res += normalized + " ";
    }
    else if ($cee99bf667b6fd39$export$a6cdc56e425d0d0a(value)) {
        for(var name in value)if (value[name]) res += name + " ";
    }
    return res.trim();
}
function $cee99bf667b6fd39$export$601abcd8103db5e4(props) {
    if (!props) return null;
    var klass = props.class, style = props.style;
    if (klass && !$cee99bf667b6fd39$export$844ec244b1367d54(klass)) props.class = $cee99bf667b6fd39$export$4f7022d2d68e2c5a(klass);
    if (style) props.style = $cee99bf667b6fd39$export$8756898546458274(style);
    return props;
}
var $cee99bf667b6fd39$var$HTML_TAGS = "html,body,base,head,link,meta,style,title,address,article,aside,footer,header,hgroup,h1,h2,h3,h4,h5,h6,nav,section,div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,ruby,s,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,embed,object,param,source,canvas,script,noscript,del,ins,caption,col,colgroup,table,thead,tbody,td,th,tr,button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,output,progress,select,textarea,details,dialog,menu,summary,template,blockquote,iframe,tfoot";
var $cee99bf667b6fd39$var$SVG_TAGS = "svg,animate,animateMotion,animateTransform,circle,clipPath,color-profile,defs,desc,discard,ellipse,feBlend,feColorMatrix,feComponentTransfer,feComposite,feConvolveMatrix,feDiffuseLighting,feDisplacementMap,feDistantLight,feDropShadow,feFlood,feFuncA,feFuncB,feFuncG,feFuncR,feGaussianBlur,feImage,feMerge,feMergeNode,feMorphology,feOffset,fePointLight,feSpecularLighting,feSpotLight,feTile,feTurbulence,filter,foreignObject,g,hatch,hatchpath,image,line,linearGradient,marker,mask,mesh,meshgradient,meshpatch,meshrow,metadata,mpath,path,pattern,polygon,polyline,radialGradient,rect,set,solidcolor,stop,switch,symbol,text,textPath,title,tspan,unknown,use,view";
var $cee99bf667b6fd39$var$VOID_TAGS = "area,base,br,col,embed,hr,img,input,link,meta,param,source,track,wbr";
var $cee99bf667b6fd39$export$1ccf854a0984f890 = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8($cee99bf667b6fd39$var$HTML_TAGS);
var $cee99bf667b6fd39$export$6328ce7565ea1049 = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8($cee99bf667b6fd39$var$SVG_TAGS);
var $cee99bf667b6fd39$export$e5f2d3d97d9367a4 = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8($cee99bf667b6fd39$var$VOID_TAGS);
var $cee99bf667b6fd39$var$specialBooleanAttrs = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly";
var $cee99bf667b6fd39$export$d186f5eb2e810715 = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8($cee99bf667b6fd39$var$specialBooleanAttrs);
var $cee99bf667b6fd39$export$f763ba3b84e9cd8c = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8($cee99bf667b6fd39$var$specialBooleanAttrs + ",async,autofocus,autoplay,controls,default,defer,disabled,hidden,inert,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected");
function $cee99bf667b6fd39$export$e3f3cdb1390d56ce(value) {
    return !!value || value === "";
}
var $cee99bf667b6fd39$var$unsafeAttrCharRE = /[>/="'\u0009\u000a\u000c\u0020]/;
var $cee99bf667b6fd39$var$attrValidationCache = {};
function $cee99bf667b6fd39$export$d55ef77660f30d12(name) {
    if ($cee99bf667b6fd39$var$attrValidationCache.hasOwnProperty(name)) return $cee99bf667b6fd39$var$attrValidationCache[name];
    var isUnsafe = $cee99bf667b6fd39$var$unsafeAttrCharRE.test(name);
    if (isUnsafe) console.error("unsafe attribute name: ".concat(name));
    return $cee99bf667b6fd39$var$attrValidationCache[name] = !isUnsafe;
}
var $cee99bf667b6fd39$export$b66fd0cae8dec3c8 = {
    acceptCharset: "accept-charset",
    className: "class",
    htmlFor: "for",
    httpEquiv: "http-equiv"
};
var $cee99bf667b6fd39$export$f7e7a1cc7da8d5e9 = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8("accept,accept-charset,accesskey,action,align,allow,alt,async,autocapitalize,autocomplete,autofocus,autoplay,background,bgcolor,border,buffered,capture,challenge,charset,checked,cite,class,code,codebase,color,cols,colspan,content,contenteditable,contextmenu,controls,coords,crossorigin,csp,data,datetime,decoding,default,defer,dir,dirname,disabled,download,draggable,dropzone,enctype,enterkeyhint,for,form,formaction,formenctype,formmethod,formnovalidate,formtarget,headers,height,hidden,high,href,hreflang,http-equiv,icon,id,importance,inert,integrity,ismap,itemprop,keytype,kind,label,lang,language,loading,list,loop,low,manifest,max,maxlength,minlength,media,min,multiple,muted,name,novalidate,open,optimum,pattern,ping,placeholder,poster,preload,radiogroup,readonly,referrerpolicy,rel,required,reversed,rows,rowspan,sandbox,scope,scoped,selected,shape,size,sizes,slot,span,spellcheck,src,srcdoc,srclang,srcset,start,step,style,summary,tabindex,target,title,translate,type,usemap,value,width,wrap");
var $cee99bf667b6fd39$export$80da416f43933831 = /* @__PURE__ */ $cee99bf667b6fd39$export$b41394a5437791c8("xmlns,accent-height,accumulate,additive,alignment-baseline,alphabetic,amplitude,arabic-form,ascent,attributeName,attributeType,azimuth,baseFrequency,baseline-shift,baseProfile,bbox,begin,bias,by,calcMode,cap-height,class,clip,clipPathUnits,clip-path,clip-rule,color,color-interpolation,color-interpolation-filters,color-profile,color-rendering,contentScriptType,contentStyleType,crossorigin,cursor,cx,cy,d,decelerate,descent,diffuseConstant,direction,display,divisor,dominant-baseline,dur,dx,dy,edgeMode,elevation,enable-background,end,exponent,fill,fill-opacity,fill-rule,filter,filterRes,filterUnits,flood-color,flood-opacity,font-family,font-size,font-size-adjust,font-stretch,font-style,font-variant,font-weight,format,from,fr,fx,fy,g1,g2,glyph-name,glyph-orientation-horizontal,glyph-orientation-vertical,glyphRef,gradientTransform,gradientUnits,hanging,height,href,hreflang,horiz-adv-x,horiz-origin-x,id,ideographic,image-rendering,in,in2,intercept,k,k1,k2,k3,k4,kernelMatrix,kernelUnitLength,kerning,keyPoints,keySplines,keyTimes,lang,lengthAdjust,letter-spacing,lighting-color,limitingConeAngle,local,marker-end,marker-mid,marker-start,markerHeight,markerUnits,markerWidth,mask,maskContentUnits,maskUnits,mathematical,max,media,method,min,mode,name,numOctaves,offset,opacity,operator,order,orient,orientation,origin,overflow,overline-position,overline-thickness,panose-1,paint-order,path,pathLength,patternContentUnits,patternTransform,patternUnits,ping,pointer-events,points,pointsAtX,pointsAtY,pointsAtZ,preserveAlpha,preserveAspectRatio,primitiveUnits,r,radius,referrerPolicy,refX,refY,rel,rendering-intent,repeatCount,repeatDur,requiredExtensions,requiredFeatures,restart,result,rotate,rx,ry,scale,seed,shape-rendering,slope,spacing,specularConstant,specularExponent,speed,spreadMethod,startOffset,stdDeviation,stemh,stemv,stitchTiles,stop-color,stop-opacity,strikethrough-position,strikethrough-thickness,string,stroke,stroke-dasharray,stroke-dashoffset,stroke-linecap,stroke-linejoin,stroke-miterlimit,stroke-opacity,stroke-width,style,surfaceScale,systemLanguage,tabindex,tableValues,target,targetX,targetY,text-anchor,text-decoration,text-rendering,textLength,to,transform,transform-origin,type,u1,u2,underline-position,underline-thickness,unicode,unicode-bidi,unicode-range,units-per-em,v-alphabetic,v-hanging,v-ideographic,v-mathematical,values,vector-effect,version,vert-adv-y,vert-origin-x,vert-origin-y,viewBox,viewTarget,visibility,width,widths,word-spacing,writing-mode,x,x-height,x1,x2,xChannelSelector,xlink:actuate,xlink:arcrole,xlink:href,xlink:role,xlink:show,xlink:title,xlink:type,xml:base,xml:lang,xml:space,y,y1,y2,yChannelSelector,z,zoomAndPan");
var $cee99bf667b6fd39$var$escapeRE = /["'&<>]/;
function $cee99bf667b6fd39$export$4cf11838cdc2a8a8(string) {
    var str = "" + string;
    var match = $cee99bf667b6fd39$var$escapeRE.exec(str);
    if (!match) return str;
    var html = "";
    var escaped;
    var index;
    var lastIndex = 0;
    for(index = match.index; index < str.length; index++){
        switch(str.charCodeAt(index)){
            case 34:
                escaped = "&quot;";
                break;
            case 38:
                escaped = "&amp;";
                break;
            case 39:
                escaped = "&#39;";
                break;
            case 60:
                escaped = "&lt;";
                break;
            case 62:
                escaped = "&gt;";
                break;
            default:
                continue;
        }
        if (lastIndex !== index) html += str.slice(lastIndex, index);
        lastIndex = index + 1;
        html += escaped;
    }
    return lastIndex !== index ? html + str.slice(lastIndex, index) : html;
}
var $cee99bf667b6fd39$var$commentStripRE = /^-?>|<!--|-->|--!>|<!-$/g;
function $cee99bf667b6fd39$export$7b105034a53bde5f(src) {
    return src.replace($cee99bf667b6fd39$var$commentStripRE, "");
}
function $cee99bf667b6fd39$var$looseCompareArrays(a, b) {
    if (a.length !== b.length) return false;
    var equal = true;
    for(var i = 0; equal && i < a.length; i++)equal = $cee99bf667b6fd39$export$ae8015769846262c(a[i], b[i]);
    return equal;
}
function $cee99bf667b6fd39$export$ae8015769846262c(a, b) {
    if (a === b) return true;
    var aValidType = $cee99bf667b6fd39$export$871608497c498473(a);
    var bValidType = $cee99bf667b6fd39$export$871608497c498473(b);
    if (aValidType || bValidType) return aValidType && bValidType ? a.getTime() === b.getTime() : false;
    aValidType = $cee99bf667b6fd39$export$a244864fd9645c7f(a);
    bValidType = $cee99bf667b6fd39$export$a244864fd9645c7f(b);
    if (aValidType || bValidType) return a === b;
    aValidType = $cee99bf667b6fd39$export$43bee75e5e14138e(a);
    bValidType = $cee99bf667b6fd39$export$43bee75e5e14138e(b);
    if (aValidType || bValidType) return aValidType && bValidType ? $cee99bf667b6fd39$var$looseCompareArrays(a, b) : false;
    aValidType = $cee99bf667b6fd39$export$a6cdc56e425d0d0a(a);
    bValidType = $cee99bf667b6fd39$export$a6cdc56e425d0d0a(b);
    if (aValidType || bValidType) {
        if (!aValidType || !bValidType) return false;
        var aKeysCount = Object.keys(a).length;
        var bKeysCount = Object.keys(b).length;
        if (aKeysCount !== bKeysCount) return false;
        for(var key in a){
            var aHasKey = a.hasOwnProperty(key);
            var bHasKey = b.hasOwnProperty(key);
            if (aHasKey && !bHasKey || !aHasKey && bHasKey || !$cee99bf667b6fd39$export$ae8015769846262c(a[key], b[key])) return false;
        }
    }
    return String(a) === String(b);
}
function $cee99bf667b6fd39$export$42912a80cedb8bd4(arr, val) {
    return arr.findIndex(function(item) {
        return $cee99bf667b6fd39$export$ae8015769846262c(item, val);
    });
}
var $cee99bf667b6fd39$export$b5b1545233b45293 = function(val) {
    return $cee99bf667b6fd39$export$844ec244b1367d54(val) ? val : val == null ? "" : $cee99bf667b6fd39$export$43bee75e5e14138e(val) || $cee99bf667b6fd39$export$a6cdc56e425d0d0a(val) && (val.toString === $cee99bf667b6fd39$export$830c053460e5ddf6 || !$cee99bf667b6fd39$export$f6e2535fb5126e54(val.toString)) ? JSON.stringify(val, $cee99bf667b6fd39$var$replacer, 2) : String(val);
};
var $cee99bf667b6fd39$var$replacer = function(_key, val) {
    if (val && val.__v_isRef) return $cee99bf667b6fd39$var$replacer(_key, val.value);
    else if ($cee99bf667b6fd39$export$5c90113a285f2241(val)) return (0, $3sHb8._)({}, "Map(".concat(val.size, ")"), (0, $c6Xmf._)(val.entries()).reduce(function(entries, param) {
        var _param = (0, $cv9Rk._)(param, 2), key = _param[0], val2 = _param[1];
        entries["".concat(key, " =>")] = val2;
        return entries;
    }, {}));
    else if ($cee99bf667b6fd39$export$6750766a7c7ec627(val)) return (0, $3sHb8._)({}, "Set(".concat(val.size, ")"), (0, $c6Xmf._)(val.values()));
    else if ($cee99bf667b6fd39$export$a6cdc56e425d0d0a(val) && !$cee99bf667b6fd39$export$43bee75e5e14138e(val) && !$cee99bf667b6fd39$export$53b83ca8eaab0383(val)) return String(val);
    return val;
};

});



parcelRequire.register("i0Zoc", function(module, exports) {
$parcel$export(module.exports, "BaseTransition", function () { return (parcelRequire("lIPIy")).BaseTransition; });
$parcel$export(module.exports, "BaseTransitionPropsValidators", function () { return (parcelRequire("lIPIy")).BaseTransitionPropsValidators; });
$parcel$export(module.exports, "callWithAsyncErrorHandling", function () { return (parcelRequire("lIPIy")).callWithAsyncErrorHandling; });
$parcel$export(module.exports, "camelize", function () { return (parcelRequire("hLodm")).camelize; });
$parcel$export(module.exports, "computed", function () { return (parcelRequire("lIPIy")).computed; });
$parcel$export(module.exports, "createCommentVNode", function () { return (parcelRequire("lIPIy")).createCommentVNode; });
$parcel$export(module.exports, "createElementBlock", function () { return (parcelRequire("lIPIy")).createElementBlock; });
$parcel$export(module.exports, "createElementVNode", function () { return (parcelRequire("lIPIy")).createElementVNode; });
$parcel$export(module.exports, "createHydrationRenderer", function () { return (parcelRequire("lIPIy")).createHydrationRenderer; });
$parcel$export(module.exports, "createRenderer", function () { return (parcelRequire("lIPIy")).createRenderer; });
$parcel$export(module.exports, "createStaticVNode", function () { return (parcelRequire("lIPIy")).createStaticVNode; });
$parcel$export(module.exports, "createTextVNode", function () { return (parcelRequire("lIPIy")).createTextVNode; });
$parcel$export(module.exports, "createVNode", function () { return (parcelRequire("lIPIy")).createVNode; });
$parcel$export(module.exports, "defineComponent", function () { return (parcelRequire("lIPIy")).defineComponent; });
$parcel$export(module.exports, "Fragment", function () { return (parcelRequire("lIPIy")).Fragment; });
$parcel$export(module.exports, "getCurrentInstance", function () { return (parcelRequire("lIPIy")).getCurrentInstance; });
$parcel$export(module.exports, "getTransitionRawChildren", function () { return (parcelRequire("lIPIy")).getTransitionRawChildren; });
$parcel$export(module.exports, "h", function () { return (parcelRequire("lIPIy")).h; });
$parcel$export(module.exports, "initCustomFormatter", function () { return (parcelRequire("lIPIy")).initCustomFormatter; });
$parcel$export(module.exports, "inject", function () { return (parcelRequire("lIPIy")).inject; });
$parcel$export(module.exports, "isRef", function () { return (parcelRequire("yQ0Ka")).isRef; });
$parcel$export(module.exports, "isRuntimeOnly", function () { return (parcelRequire("lIPIy")).isRuntimeOnly; });
$parcel$export(module.exports, "nextTick", function () { return (parcelRequire("lIPIy")).nextTick; });
$parcel$export(module.exports, "normalizeClass", function () { return (parcelRequire("hLodm")).normalizeClass; });
$parcel$export(module.exports, "onBeforeMount", function () { return (parcelRequire("lIPIy")).onBeforeMount; });
$parcel$export(module.exports, "onMounted", function () { return (parcelRequire("lIPIy")).onMounted; });
$parcel$export(module.exports, "onUnmounted", function () { return (parcelRequire("lIPIy")).onUnmounted; });
$parcel$export(module.exports, "onUpdated", function () { return (parcelRequire("lIPIy")).onUpdated; });
$parcel$export(module.exports, "openBlock", function () { return (parcelRequire("lIPIy")).openBlock; });
$parcel$export(module.exports, "popScopeId", function () { return (parcelRequire("lIPIy")).popScopeId; });
$parcel$export(module.exports, "pushScopeId", function () { return (parcelRequire("lIPIy")).pushScopeId; });
$parcel$export(module.exports, "ref", function () { return (parcelRequire("yQ0Ka")).ref; });
$parcel$export(module.exports, "renderList", function () { return (parcelRequire("lIPIy")).renderList; });
$parcel$export(module.exports, "resolveComponent", function () { return (parcelRequire("lIPIy")).resolveComponent; });
$parcel$export(module.exports, "resolveTransitionHooks", function () { return (parcelRequire("lIPIy")).resolveTransitionHooks; });
$parcel$export(module.exports, "setTransitionHooks", function () { return (parcelRequire("lIPIy")).setTransitionHooks; });
$parcel$export(module.exports, "Static", function () { return (parcelRequire("lIPIy")).Static; });
$parcel$export(module.exports, "Text", function () { return (parcelRequire("lIPIy")).Text; });
$parcel$export(module.exports, "toRaw", function () { return (parcelRequire("yQ0Ka")).toRaw; });
$parcel$export(module.exports, "useTransitionState", function () { return (parcelRequire("lIPIy")).useTransitionState; });
$parcel$export(module.exports, "warn", function () { return (parcelRequire("lIPIy")).warn; });
$parcel$export(module.exports, "watch", function () { return (parcelRequire("lIPIy")).watch; });
$parcel$export(module.exports, "watchPostEffect", function () { return (parcelRequire("lIPIy")).watchPostEffect; });
$parcel$export(module.exports, "withCtx", function () { return (parcelRequire("lIPIy")).withCtx; });
$parcel$export(module.exports, "withDirectives", function () { return (parcelRequire("lIPIy")).withDirectives; });
$parcel$export(module.exports, "effectScope", function () { return (parcelRequire("yQ0Ka")).effectScope; });
$parcel$export(module.exports, "shallowRef", function () { return (parcelRequire("yQ0Ka")).shallowRef; });
$parcel$export(module.exports, "toDisplayString", function () { return (parcelRequire("hLodm")).toDisplayString; });

$parcel$export(module.exports, "vModelText", function () { return $d1d7d8b3f9a18d56$export$f1f88689f5728478; });
$parcel$export(module.exports, "vModelSelect", function () { return $d1d7d8b3f9a18d56$export$87d227567b51ca39; });
$parcel$export(module.exports, "withKeys", function () { return $d1d7d8b3f9a18d56$export$f691a8759658f782; });
$parcel$export(module.exports, "vShow", function () { return $d1d7d8b3f9a18d56$export$5cb4fcdc6937d7e1; });
$parcel$export(module.exports, "createApp", function () { return $d1d7d8b3f9a18d56$export$4e373c34abfa8c68; });

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $3sHb8 = parcelRequire("3sHb8");

var $dcsZi = parcelRequire("dcsZi");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

var $l0HdX = parcelRequire("l0HdX");

var $ohfOJ = parcelRequire("ohfOJ");
parcelRequire("lIPIy");
var $hLodm = parcelRequire("hLodm");
var $lIPIy = parcelRequire("lIPIy");
var $yQ0Ka = parcelRequire("yQ0Ka");parcelRequire("yQ0Ka");parcelRequire("hLodm");

var $hLodm = parcelRequire("hLodm");
var $d1d7d8b3f9a18d56$var$svgNS = "http://www.w3.org/2000/svg";
var $d1d7d8b3f9a18d56$var$doc = typeof document !== "undefined" ? document : null;
var $d1d7d8b3f9a18d56$var$templateContainer = $d1d7d8b3f9a18d56$var$doc && /* @__PURE__ */ $d1d7d8b3f9a18d56$var$doc.createElement("template");
var $d1d7d8b3f9a18d56$var$nodeOps = {
    insert: function(child, parent, anchor) {
        parent.insertBefore(child, anchor || null);
    },
    remove: function(child) {
        var parent = child.parentNode;
        if (parent) parent.removeChild(child);
    },
    createElement: function(tag, isSVG, is, props) {
        var el = isSVG ? $d1d7d8b3f9a18d56$var$doc.createElementNS($d1d7d8b3f9a18d56$var$svgNS, tag) : $d1d7d8b3f9a18d56$var$doc.createElement(tag, is ? {
            is: is
        } : void 0);
        if (tag === "select" && props && props.multiple != null) el.setAttribute("multiple", props.multiple);
        return el;
    },
    createText: function(text) {
        return $d1d7d8b3f9a18d56$var$doc.createTextNode(text);
    },
    createComment: function(text) {
        return $d1d7d8b3f9a18d56$var$doc.createComment(text);
    },
    setText: function(node, text) {
        node.nodeValue = text;
    },
    setElementText: function(el, text) {
        el.textContent = text;
    },
    parentNode: function(node) {
        return node.parentNode;
    },
    nextSibling: function(node) {
        return node.nextSibling;
    },
    querySelector: function(selector) {
        return $d1d7d8b3f9a18d56$var$doc.querySelector(selector);
    },
    setScopeId: function(el, id) {
        el.setAttribute(id, "");
    },
    // __UNSAFE__
    // Reason: innerHTML.
    // Static content here can only come from compiled templates.
    // As long as the user only uses trusted templates, this is safe.
    insertStaticContent: function(content, parent, anchor, isSVG, start, end) {
        var before = anchor ? anchor.previousSibling : parent.lastChild;
        if (start && (start === end || start.nextSibling)) while(true){
            parent.insertBefore(start.cloneNode(true), anchor);
            if (start === end || !(start = start.nextSibling)) break;
        }
        else {
            $d1d7d8b3f9a18d56$var$templateContainer.innerHTML = isSVG ? "<svg>".concat(content, "</svg>") : content;
            var template = $d1d7d8b3f9a18d56$var$templateContainer.content;
            if (isSVG) {
                var wrapper = template.firstChild;
                while(wrapper.firstChild)template.appendChild(wrapper.firstChild);
                template.removeChild(wrapper);
            }
            parent.insertBefore(template, anchor);
        }
        return [
            // first
            before ? before.nextSibling : parent.firstChild,
            // last
            anchor ? anchor.previousSibling : parent.lastChild
        ];
    }
};
function $d1d7d8b3f9a18d56$var$patchClass(el, value, isSVG) {
    var transitionClasses = el._vtc;
    if (transitionClasses) value = (value ? [
        value
    ].concat((0, $c6Xmf._)(transitionClasses)) : (0, $c6Xmf._)(transitionClasses)).join(" ");
    if (value == null) el.removeAttribute("class");
    else if (isSVG) el.setAttribute("class", value);
    else el.className = value;
}
function $d1d7d8b3f9a18d56$var$patchStyle(el, prev, next) {
    var style = el.style;
    var isCssString = (0, $hLodm.isString)(next);
    if (next && !isCssString) {
        if (prev && !(0, $hLodm.isString)(prev)) {
            for(var key in prev)if (next[key] == null) $d1d7d8b3f9a18d56$var$setStyle(style, key, "");
        }
        for(var key1 in next)$d1d7d8b3f9a18d56$var$setStyle(style, key1, next[key1]);
    } else {
        var currentDisplay = style.display;
        if (isCssString) {
            if (prev !== next) style.cssText = next;
        } else if (prev) el.removeAttribute("style");
        if ("_vod" in el) style.display = currentDisplay;
    }
}
var $d1d7d8b3f9a18d56$var$semicolonRE = /[^\\];\s*$/;
var $d1d7d8b3f9a18d56$var$importantRE = /\s*!important$/;
function $d1d7d8b3f9a18d56$var$setStyle(style, name, val) {
    if ((0, $hLodm.isArray)(val)) val.forEach(function(v) {
        return $d1d7d8b3f9a18d56$var$setStyle(style, name, v);
    });
    else {
        if (val == null) val = "";
        if (name.startsWith("--")) style.setProperty(name, val);
        else {
            var prefixed = $d1d7d8b3f9a18d56$var$autoPrefix(style, name);
            if ($d1d7d8b3f9a18d56$var$importantRE.test(val)) style.setProperty((0, $hLodm.hyphenate)(prefixed), val.replace($d1d7d8b3f9a18d56$var$importantRE, ""), "important");
            else style[prefixed] = val;
        }
    }
}
var $d1d7d8b3f9a18d56$var$prefixes = [
    "Webkit",
    "Moz",
    "ms"
];
var $d1d7d8b3f9a18d56$var$prefixCache = {};
function $d1d7d8b3f9a18d56$var$autoPrefix(style, rawName) {
    var cached = $d1d7d8b3f9a18d56$var$prefixCache[rawName];
    if (cached) return cached;
    var name = (0, $hLodm.camelize)(rawName);
    if (name !== "filter" && name in style) return $d1d7d8b3f9a18d56$var$prefixCache[rawName] = name;
    name = (0, $hLodm.capitalize)(name);
    for(var i = 0; i < $d1d7d8b3f9a18d56$var$prefixes.length; i++){
        var prefixed = $d1d7d8b3f9a18d56$var$prefixes[i] + name;
        if (prefixed in style) return $d1d7d8b3f9a18d56$var$prefixCache[rawName] = prefixed;
    }
    return rawName;
}
var $d1d7d8b3f9a18d56$var$xlinkNS = "http://www.w3.org/1999/xlink";
function $d1d7d8b3f9a18d56$var$patchAttr(el, key, value, isSVG, instance) {
    if (isSVG && key.startsWith("xlink:")) {
        if (value == null) el.removeAttributeNS($d1d7d8b3f9a18d56$var$xlinkNS, key.slice(6, key.length));
        else el.setAttributeNS($d1d7d8b3f9a18d56$var$xlinkNS, key, value);
    } else {
        var isBoolean = (0, $hLodm.isSpecialBooleanAttr)(key);
        if (value == null || isBoolean && !(0, $hLodm.includeBooleanAttr)(value)) el.removeAttribute(key);
        else el.setAttribute(key, isBoolean ? "" : value);
    }
}
function $d1d7d8b3f9a18d56$var$patchDOMProp(el, key, value, prevChildren, parentComponent, parentSuspense, unmountChildren) {
    if (key === "innerHTML" || key === "textContent") {
        if (prevChildren) unmountChildren(prevChildren, parentComponent, parentSuspense);
        el[key] = value == null ? "" : value;
        return;
    }
    var tag = el.tagName;
    if (key === "value" && tag !== "PROGRESS" && // custom elements may use _value internally
    !tag.includes("-")) {
        el._value = value;
        var oldValue = tag === "OPTION" ? el.getAttribute("value") : el.value;
        var newValue = value == null ? "" : value;
        if (oldValue !== newValue) el.value = newValue;
        if (value == null) el.removeAttribute(key);
        return;
    }
    var needRemove = false;
    if (value === "" || value == null) {
        var type = (0, $l0HdX._)(el[key]);
        if (type === "boolean") value = (0, $hLodm.includeBooleanAttr)(value);
        else if (value == null && type === "string") {
            value = "";
            needRemove = true;
        } else if (type === "number") {
            value = 0;
            needRemove = true;
        }
    }
    try {
        el[key] = value;
    } catch (e) {}
    needRemove && el.removeAttribute(key);
}
function $d1d7d8b3f9a18d56$var$addEventListener(el, event, handler, options) {
    el.addEventListener(event, handler, options);
}
function $d1d7d8b3f9a18d56$var$removeEventListener(el, event, handler, options) {
    el.removeEventListener(event, handler, options);
}
function $d1d7d8b3f9a18d56$var$patchEvent(el, rawName, prevValue, nextValue) {
    var instance = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : null;
    var invokers = el._vei || (el._vei = {});
    var existingInvoker = invokers[rawName];
    if (nextValue && existingInvoker) existingInvoker.value = nextValue;
    else {
        var _parseName = (0, $cv9Rk._)($d1d7d8b3f9a18d56$var$parseName(rawName), 2), name = _parseName[0], options = _parseName[1];
        if (nextValue) {
            var invoker = invokers[rawName] = $d1d7d8b3f9a18d56$var$createInvoker(nextValue, instance);
            $d1d7d8b3f9a18d56$var$addEventListener(el, name, invoker, options);
        } else if (existingInvoker) {
            $d1d7d8b3f9a18d56$var$removeEventListener(el, name, existingInvoker, options);
            invokers[rawName] = void 0;
        }
    }
}
var $d1d7d8b3f9a18d56$var$optionsModifierRE = /(?:Once|Passive|Capture)$/;
function $d1d7d8b3f9a18d56$var$parseName(name) {
    var options;
    if ($d1d7d8b3f9a18d56$var$optionsModifierRE.test(name)) {
        options = {};
        var m;
        while(m = name.match($d1d7d8b3f9a18d56$var$optionsModifierRE)){
            name = name.slice(0, name.length - m[0].length);
            options[m[0].toLowerCase()] = true;
        }
    }
    var event = name[2] === ":" ? name.slice(3) : (0, $hLodm.hyphenate)(name.slice(2));
    return [
        event,
        options
    ];
}
var $d1d7d8b3f9a18d56$var$cachedNow = 0;
var $d1d7d8b3f9a18d56$var$p = /* @__PURE__ */ Promise.resolve();
var $d1d7d8b3f9a18d56$var$getNow = function() {
    return $d1d7d8b3f9a18d56$var$cachedNow || ($d1d7d8b3f9a18d56$var$p.then(function() {
        return $d1d7d8b3f9a18d56$var$cachedNow = 0;
    }), $d1d7d8b3f9a18d56$var$cachedNow = Date.now());
};
function $d1d7d8b3f9a18d56$var$createInvoker(initialValue, instance) {
    var invoker = function(e) {
        if (!e._vts) e._vts = Date.now();
        else if (e._vts <= invoker.attached) return;
        (0, $lIPIy.callWithAsyncErrorHandling)($d1d7d8b3f9a18d56$var$patchStopImmediatePropagation(e, invoker.value), instance, 5, [
            e
        ]);
    };
    invoker.value = initialValue;
    invoker.attached = $d1d7d8b3f9a18d56$var$getNow();
    return invoker;
}
function $d1d7d8b3f9a18d56$var$patchStopImmediatePropagation(e, value) {
    if ((0, $hLodm.isArray)(value)) {
        var originalStop = e.stopImmediatePropagation;
        e.stopImmediatePropagation = function() {
            originalStop.call(e);
            e._stopped = true;
        };
        return value.map(function(fn) {
            return function(e2) {
                return !e2._stopped && fn && fn(e2);
            };
        });
    } else return value;
}
var $d1d7d8b3f9a18d56$var$nativeOnRE = /^on[a-z]/;
var $d1d7d8b3f9a18d56$var$patchProp = function(el, key, prevValue, nextValue) {
    var isSVG = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false, prevChildren = arguments.length > 5 ? arguments[5] : void 0, parentComponent = arguments.length > 6 ? arguments[6] : void 0, parentSuspense = arguments.length > 7 ? arguments[7] : void 0, unmountChildren = arguments.length > 8 ? arguments[8] : void 0;
    if (key === "class") $d1d7d8b3f9a18d56$var$patchClass(el, nextValue, isSVG);
    else if (key === "style") $d1d7d8b3f9a18d56$var$patchStyle(el, prevValue, nextValue);
    else if ((0, $hLodm.isOn)(key)) {
        if (!(0, $hLodm.isModelListener)(key)) $d1d7d8b3f9a18d56$var$patchEvent(el, key, prevValue, nextValue, parentComponent);
    } else if (key[0] === "." ? (key = key.slice(1), true) : key[0] === "^" ? (key = key.slice(1), false) : $d1d7d8b3f9a18d56$var$shouldSetAsProp(el, key, nextValue, isSVG)) $d1d7d8b3f9a18d56$var$patchDOMProp(el, key, nextValue, prevChildren, parentComponent, parentSuspense, unmountChildren);
    else {
        if (key === "true-value") el._trueValue = nextValue;
        else if (key === "false-value") el._falseValue = nextValue;
        $d1d7d8b3f9a18d56$var$patchAttr(el, key, nextValue, isSVG);
    }
};
function $d1d7d8b3f9a18d56$var$shouldSetAsProp(el, key, value, isSVG) {
    if (isSVG) {
        if (key === "innerHTML" || key === "textContent") return true;
        if (key in el && $d1d7d8b3f9a18d56$var$nativeOnRE.test(key) && (0, $hLodm.isFunction)(value)) return true;
        return false;
    }
    if (key === "spellcheck" || key === "draggable" || key === "translate") return false;
    if (key === "form") return false;
    if (key === "list" && el.tagName === "INPUT") return false;
    if (key === "type" && el.tagName === "TEXTAREA") return false;
    if ($d1d7d8b3f9a18d56$var$nativeOnRE.test(key) && (0, $hLodm.isString)(value)) return false;
    return key in el;
}
function $d1d7d8b3f9a18d56$export$a00e2346eabbdbef(options, hydrate2) {
    var Comp = (0, $lIPIy.defineComponent)(options);
    var VueCustomElement = /*#__PURE__*/ function(VueElement) {
        "use strict";
        (0, $dcsZi._)(VueCustomElement, VueElement);
        var _super = (0, $ohfOJ._)(VueCustomElement);
        function VueCustomElement(initialProps) {
            (0, $4GJKx._)(this, VueCustomElement);
            return _super.call(this, Comp, initialProps, hydrate2);
        }
        return VueCustomElement;
    }($d1d7d8b3f9a18d56$export$b337c1a55163dbe3);
    VueCustomElement.def = Comp;
    return VueCustomElement;
}
var $d1d7d8b3f9a18d56$export$6debb2e68f212638 = function(options) {
    return $d1d7d8b3f9a18d56$export$a00e2346eabbdbef(options, $d1d7d8b3f9a18d56$export$fa8d919ba61d84db);
};
var $d1d7d8b3f9a18d56$var$BaseClass = typeof HTMLElement !== "undefined" ? HTMLElement : function _class() {
    "use strict";
    (0, $4GJKx._)(this, _class);
};
var $d1d7d8b3f9a18d56$export$b337c1a55163dbe3 = /*#__PURE__*/ function(BaseClass) {
    "use strict";
    (0, $dcsZi._)(VueElement, BaseClass);
    var _super = (0, $ohfOJ._)(VueElement);
    function VueElement(_def) {
        var _props = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, hydrate2 = arguments.length > 2 ? arguments[2] : void 0;
        (0, $4GJKx._)(this, VueElement);
        var _this;
        _this = _super.call(this);
        _this._def = _def;
        _this._props = _props;
        /**
     * @internal
     */ _this._instance = null;
        _this._connected = false;
        _this._resolved = false;
        _this._numberProps = null;
        if (_this.shadowRoot && hydrate2) hydrate2(_this._createVNode(), _this.shadowRoot);
        else {
            _this.attachShadow({
                mode: "open"
            });
            if (!_this._def.__asyncLoader) _this._resolveProps(_this._def);
        }
        return _this;
    }
    (0, $1wc17._)(VueElement, [
        {
            key: "connectedCallback",
            value: function connectedCallback() {
                this._connected = true;
                if (!this._instance) {
                    if (this._resolved) this._update();
                    else this._resolveDef();
                }
            }
        },
        {
            key: "disconnectedCallback",
            value: function disconnectedCallback() {
                var _this = this;
                this._connected = false;
                (0, $lIPIy.nextTick)(function() {
                    if (!_this._connected) {
                        $d1d7d8b3f9a18d56$export$b3890eb0ae9dca99(null, _this.shadowRoot);
                        _this._instance = null;
                    }
                });
            }
        },
        {
            /**
   * resolve inner component definition (handle possible async component)
   */ key: "_resolveDef",
            value: function _resolveDef() {
                var _this = this;
                this._resolved = true;
                for(var i = 0; i < this.attributes.length; i++)this._setAttr(this.attributes[i].name);
                new MutationObserver(function(mutations) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = mutations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var m = _step.value;
                            _this._setAttr(m.attributeName);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }).observe(this, {
                    attributes: true
                });
                var resolve = function(def) {
                    var isAsync = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                    var props = def.props, styles = def.styles;
                    var numberProps;
                    if (props && !(0, $hLodm.isArray)(props)) for(var key in props){
                        var opt = props[key];
                        if (opt === Number || opt && opt.type === Number) {
                            if (key in _this._props) _this._props[key] = (0, $hLodm.toNumber)(_this._props[key]);
                            (numberProps || (numberProps = /* @__PURE__ */ Object.create(null)))[(0, $hLodm.camelize)(key)] = true;
                        }
                    }
                    _this._numberProps = numberProps;
                    if (isAsync) _this._resolveProps(def);
                    _this._applyStyles(styles);
                    _this._update();
                };
                var asyncDef = this._def.__asyncLoader;
                if (asyncDef) asyncDef().then(function(def) {
                    return resolve(def, true);
                });
                else resolve(this._def);
            }
        },
        {
            key: "_resolveProps",
            value: function _resolveProps(def) {
                var props = def.props;
                var declaredPropKeys = (0, $hLodm.isArray)(props) ? props : Object.keys(props || {});
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var key = _step.value;
                        if (key[0] !== "_" && declaredPropKeys.includes(key)) this._setProp(key, this[key], true, false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    var _this = this, _loop = function() {
                        var key = _step1.value;
                        Object.defineProperty(_this, key, {
                            get: function() {
                                return this._getProp(key);
                            },
                            set: function(val) {
                                this._setProp(key, val);
                            }
                        });
                    };
                    for(var _iterator1 = declaredPropKeys.map((0, $hLodm.camelize))[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_setAttr",
            value: function _setAttr(key) {
                var value = this.getAttribute(key);
                var camelKey = (0, $hLodm.camelize)(key);
                if (this._numberProps && this._numberProps[camelKey]) value = (0, $hLodm.toNumber)(value);
                this._setProp(camelKey, value, false);
            }
        },
        {
            /**
   * @internal
   */ key: "_getProp",
            value: function _getProp(key) {
                return this._props[key];
            }
        },
        {
            /**
   * @internal
   */ key: "_setProp",
            value: function _setProp(key, val) {
                var shouldReflect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, shouldUpdate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true;
                if (val !== this._props[key]) {
                    this._props[key] = val;
                    if (shouldUpdate && this._instance) this._update();
                    if (shouldReflect) {
                        if (val === true) this.setAttribute((0, $hLodm.hyphenate)(key), "");
                        else if (typeof val === "string" || typeof val === "number") this.setAttribute((0, $hLodm.hyphenate)(key), val + "");
                        else if (!val) this.removeAttribute((0, $hLodm.hyphenate)(key));
                    }
                }
            }
        },
        {
            key: "_update",
            value: function _update() {
                $d1d7d8b3f9a18d56$export$b3890eb0ae9dca99(this._createVNode(), this.shadowRoot);
            }
        },
        {
            key: "_createVNode",
            value: function _createVNode() {
                var _this = this;
                var vnode = (0, $lIPIy.createVNode)(this._def, (0, $hLodm.extend)({}, this._props));
                if (!this._instance) vnode.ce = function(instance) {
                    _this._instance = instance;
                    instance.isCE = true;
                    var newStyles, s;
                    var dispatch = function(event, args) {
                        _this.dispatchEvent(new CustomEvent(event, {
                            detail: args
                        }));
                    };
                    instance.emit = function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            args[_key - 1] = arguments[_key];
                        }
                        dispatch(event, args);
                        if ((0, $hLodm.hyphenate)(event) !== event) dispatch((0, $hLodm.hyphenate)(event), args);
                    };
                    var parent = _this;
                    while(parent = parent && (parent.parentNode || parent.host))if (parent instanceof VueElement) {
                        instance.parent = parent._instance;
                        instance.provides = parent._instance.provides;
                        break;
                    }
                };
                return vnode;
            }
        },
        {
            key: "_applyStyles",
            value: function _applyStyles(styles) {
                var _this = this;
                if (styles) styles.forEach(function(css) {
                    var s = document.createElement("style");
                    s.textContent = css;
                    _this.shadowRoot.appendChild(s);
                });
            }
        }
    ]);
    return VueElement;
}($d1d7d8b3f9a18d56$var$BaseClass);
function $d1d7d8b3f9a18d56$export$9300d5b90d56e3d1() {
    var name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "$style";
    {
        var instance = (0, $lIPIy.getCurrentInstance)();
        if (!instance) return 0, $hLodm.EMPTY_OBJ;
        var modules = instance.type.__cssModules;
        if (!modules) return 0, $hLodm.EMPTY_OBJ;
        var mod = modules[name];
        if (!mod) return 0, $hLodm.EMPTY_OBJ;
        return mod;
    }
}
function $d1d7d8b3f9a18d56$export$ef28b76f07940108(getter) {
    var instance = (0, $lIPIy.getCurrentInstance)();
    if (!instance) return;
    var updateTeleports = instance.ut = function() {
        var vars = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : getter(instance.proxy);
        Array.from(document.querySelectorAll('[data-v-owner="'.concat(instance.uid, '"]'))).forEach(function(node) {
            return $d1d7d8b3f9a18d56$var$setVarsOnNode(node, vars);
        });
    };
    var setVars = function() {
        var vars = getter(instance.proxy);
        $d1d7d8b3f9a18d56$var$setVarsOnVNode(instance.subTree, vars);
        updateTeleports(vars);
    };
    (0, $lIPIy.watchPostEffect)(setVars);
    (0, $lIPIy.onMounted)(function() {
        var ob = new MutationObserver(setVars);
        ob.observe(instance.subTree.el.parentNode, {
            childList: true
        });
        (0, $lIPIy.onUnmounted)(function() {
            return ob.disconnect();
        });
    });
}
function $d1d7d8b3f9a18d56$var$setVarsOnVNode(vnode, vars) {
    if (vnode.shapeFlag & 128) {
        var suspense = vnode.suspense;
        vnode = suspense.activeBranch;
        if (suspense.pendingBranch && !suspense.isHydrating) suspense.effects.push(function() {
            $d1d7d8b3f9a18d56$var$setVarsOnVNode(suspense.activeBranch, vars);
        });
    }
    while(vnode.component)vnode = vnode.component.subTree;
    if (vnode.shapeFlag & 1 && vnode.el) $d1d7d8b3f9a18d56$var$setVarsOnNode(vnode.el, vars);
    else if (vnode.type === (0, $lIPIy.Fragment)) vnode.children.forEach(function(c) {
        return $d1d7d8b3f9a18d56$var$setVarsOnVNode(c, vars);
    });
    else if (vnode.type === (0, $lIPIy.Static)) {
        var el = vnode.el, anchor = vnode.anchor;
        while(el){
            $d1d7d8b3f9a18d56$var$setVarsOnNode(el, vars);
            if (el === anchor) break;
            el = el.nextSibling;
        }
    }
}
function $d1d7d8b3f9a18d56$var$setVarsOnNode(el, vars) {
    if (el.nodeType === 1) {
        var style = el.style;
        for(var key in vars)style.setProperty("--".concat(key), vars[key]);
    }
}
var $d1d7d8b3f9a18d56$var$TRANSITION = "transition";
var $d1d7d8b3f9a18d56$var$ANIMATION = "animation";
var $d1d7d8b3f9a18d56$export$be58926105124dd4 = function(props, param) {
    var slots = param.slots;
    return (0, $lIPIy.h)((0, $lIPIy.BaseTransition), $d1d7d8b3f9a18d56$var$resolveTransitionProps(props), slots);
};
$d1d7d8b3f9a18d56$export$be58926105124dd4.displayName = "Transition";
var $d1d7d8b3f9a18d56$var$DOMTransitionPropsValidators = {
    name: String,
    type: String,
    css: {
        type: Boolean,
        default: true
    },
    duration: [
        String,
        Number,
        Object
    ],
    enterFromClass: String,
    enterActiveClass: String,
    enterToClass: String,
    appearFromClass: String,
    appearActiveClass: String,
    appearToClass: String,
    leaveFromClass: String,
    leaveActiveClass: String,
    leaveToClass: String
};
var $d1d7d8b3f9a18d56$var$TransitionPropsValidators = $d1d7d8b3f9a18d56$export$be58926105124dd4.props = /* @__PURE__ */ (0, $hLodm.extend)({}, (0, $lIPIy.BaseTransitionPropsValidators), $d1d7d8b3f9a18d56$var$DOMTransitionPropsValidators);
var $d1d7d8b3f9a18d56$var$callHook = function(hook) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    if ((0, $hLodm.isArray)(hook)) hook.forEach(function(h2) {
        return h2.apply(void 0, (0, $c6Xmf._)(args));
    });
    else if (hook) hook.apply(void 0, (0, $c6Xmf._)(args));
};
var $d1d7d8b3f9a18d56$var$hasExplicitCallback = function(hook) {
    return hook ? (0, $hLodm.isArray)(hook) ? hook.some(function(h2) {
        return h2.length > 1;
    }) : hook.length > 1 : false;
};
function $d1d7d8b3f9a18d56$var$resolveTransitionProps(rawProps) {
    var baseProps = {};
    for(var key in rawProps)if (!(key in $d1d7d8b3f9a18d56$var$DOMTransitionPropsValidators)) baseProps[key] = rawProps[key];
    if (rawProps.css === false) return baseProps;
    var _rawProps_name = rawProps.name, name = _rawProps_name === void 0 ? "v" : _rawProps_name, type = rawProps.type, duration = rawProps.duration, _rawProps_enterFromClass = rawProps.enterFromClass, enterFromClass = _rawProps_enterFromClass === void 0 ? "".concat(name, "-enter-from") : _rawProps_enterFromClass, _rawProps_enterActiveClass = rawProps.enterActiveClass, enterActiveClass = _rawProps_enterActiveClass === void 0 ? "".concat(name, "-enter-active") : _rawProps_enterActiveClass, _rawProps_enterToClass = rawProps.enterToClass, enterToClass = _rawProps_enterToClass === void 0 ? "".concat(name, "-enter-to") : _rawProps_enterToClass, _rawProps_appearFromClass = rawProps.appearFromClass, appearFromClass = _rawProps_appearFromClass === void 0 ? enterFromClass : _rawProps_appearFromClass, _rawProps_appearActiveClass = rawProps.appearActiveClass, appearActiveClass = _rawProps_appearActiveClass === void 0 ? enterActiveClass : _rawProps_appearActiveClass, _rawProps_appearToClass = rawProps.appearToClass, appearToClass = _rawProps_appearToClass === void 0 ? enterToClass : _rawProps_appearToClass, _rawProps_leaveFromClass = rawProps.leaveFromClass, leaveFromClass = _rawProps_leaveFromClass === void 0 ? "".concat(name, "-leave-from") : _rawProps_leaveFromClass, _rawProps_leaveActiveClass = rawProps.leaveActiveClass, leaveActiveClass = _rawProps_leaveActiveClass === void 0 ? "".concat(name, "-leave-active") : _rawProps_leaveActiveClass, _rawProps_leaveToClass = rawProps.leaveToClass, leaveToClass = _rawProps_leaveToClass === void 0 ? "".concat(name, "-leave-to") : _rawProps_leaveToClass;
    var durations = $d1d7d8b3f9a18d56$var$normalizeDuration(duration);
    var enterDuration = durations && durations[0];
    var leaveDuration = durations && durations[1];
    var onBeforeEnter = baseProps.onBeforeEnter, onEnter = baseProps.onEnter, onEnterCancelled = baseProps.onEnterCancelled, onLeave = baseProps.onLeave, onLeaveCancelled = baseProps.onLeaveCancelled, _baseProps_onBeforeAppear = baseProps.onBeforeAppear, onBeforeAppear = _baseProps_onBeforeAppear === void 0 ? onBeforeEnter : _baseProps_onBeforeAppear, _baseProps_onAppear = baseProps.onAppear, onAppear = _baseProps_onAppear === void 0 ? onEnter : _baseProps_onAppear, _baseProps_onAppearCancelled = baseProps.onAppearCancelled, onAppearCancelled = _baseProps_onAppearCancelled === void 0 ? onEnterCancelled : _baseProps_onAppearCancelled;
    var finishEnter = function(el, isAppear, done) {
        $d1d7d8b3f9a18d56$var$removeTransitionClass(el, isAppear ? appearToClass : enterToClass);
        $d1d7d8b3f9a18d56$var$removeTransitionClass(el, isAppear ? appearActiveClass : enterActiveClass);
        done && done();
    };
    var finishLeave = function(el, done) {
        el._isLeaving = false;
        $d1d7d8b3f9a18d56$var$removeTransitionClass(el, leaveFromClass);
        $d1d7d8b3f9a18d56$var$removeTransitionClass(el, leaveToClass);
        $d1d7d8b3f9a18d56$var$removeTransitionClass(el, leaveActiveClass);
        done && done();
    };
    var makeEnterHook = function(isAppear) {
        return function(el, done) {
            var hook = isAppear ? onAppear : onEnter;
            var resolve = function() {
                return finishEnter(el, isAppear, done);
            };
            $d1d7d8b3f9a18d56$var$callHook(hook, [
                el,
                resolve
            ]);
            $d1d7d8b3f9a18d56$var$nextFrame(function() {
                $d1d7d8b3f9a18d56$var$removeTransitionClass(el, isAppear ? appearFromClass : enterFromClass);
                $d1d7d8b3f9a18d56$var$addTransitionClass(el, isAppear ? appearToClass : enterToClass);
                if (!$d1d7d8b3f9a18d56$var$hasExplicitCallback(hook)) $d1d7d8b3f9a18d56$var$whenTransitionEnds(el, type, enterDuration, resolve);
            });
        };
    };
    return (0, $hLodm.extend)(baseProps, {
        onBeforeEnter: function(el) {
            $d1d7d8b3f9a18d56$var$callHook(onBeforeEnter, [
                el
            ]);
            $d1d7d8b3f9a18d56$var$addTransitionClass(el, enterFromClass);
            $d1d7d8b3f9a18d56$var$addTransitionClass(el, enterActiveClass);
        },
        onBeforeAppear: function(el) {
            $d1d7d8b3f9a18d56$var$callHook(onBeforeAppear, [
                el
            ]);
            $d1d7d8b3f9a18d56$var$addTransitionClass(el, appearFromClass);
            $d1d7d8b3f9a18d56$var$addTransitionClass(el, appearActiveClass);
        },
        onEnter: makeEnterHook(false),
        onAppear: makeEnterHook(true),
        onLeave: function(el, done) {
            el._isLeaving = true;
            var resolve = function() {
                return finishLeave(el, done);
            };
            $d1d7d8b3f9a18d56$var$addTransitionClass(el, leaveFromClass);
            $d1d7d8b3f9a18d56$var$forceReflow();
            $d1d7d8b3f9a18d56$var$addTransitionClass(el, leaveActiveClass);
            $d1d7d8b3f9a18d56$var$nextFrame(function() {
                if (!el._isLeaving) return;
                $d1d7d8b3f9a18d56$var$removeTransitionClass(el, leaveFromClass);
                $d1d7d8b3f9a18d56$var$addTransitionClass(el, leaveToClass);
                if (!$d1d7d8b3f9a18d56$var$hasExplicitCallback(onLeave)) $d1d7d8b3f9a18d56$var$whenTransitionEnds(el, type, leaveDuration, resolve);
            });
            $d1d7d8b3f9a18d56$var$callHook(onLeave, [
                el,
                resolve
            ]);
        },
        onEnterCancelled: function(el) {
            finishEnter(el, false);
            $d1d7d8b3f9a18d56$var$callHook(onEnterCancelled, [
                el
            ]);
        },
        onAppearCancelled: function(el) {
            finishEnter(el, true);
            $d1d7d8b3f9a18d56$var$callHook(onAppearCancelled, [
                el
            ]);
        },
        onLeaveCancelled: function(el) {
            finishLeave(el);
            $d1d7d8b3f9a18d56$var$callHook(onLeaveCancelled, [
                el
            ]);
        }
    });
}
function $d1d7d8b3f9a18d56$var$normalizeDuration(duration) {
    if (duration == null) return null;
    else if ((0, $hLodm.isObject)(duration)) return [
        $d1d7d8b3f9a18d56$var$NumberOf(duration.enter),
        $d1d7d8b3f9a18d56$var$NumberOf(duration.leave)
    ];
    else {
        var n = $d1d7d8b3f9a18d56$var$NumberOf(duration);
        return [
            n,
            n
        ];
    }
}
function $d1d7d8b3f9a18d56$var$NumberOf(val) {
    var res = (0, $hLodm.toNumber)(val);
    return res;
}
function $d1d7d8b3f9a18d56$var$addTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.add(c);
    });
    (el._vtc || (el._vtc = /* @__PURE__ */ new Set())).add(cls);
}
function $d1d7d8b3f9a18d56$var$removeTransitionClass(el, cls) {
    cls.split(/\s+/).forEach(function(c) {
        return c && el.classList.remove(c);
    });
    var _vtc = el._vtc;
    if (_vtc) {
        _vtc.delete(cls);
        if (!_vtc.size) el._vtc = void 0;
    }
}
function $d1d7d8b3f9a18d56$var$nextFrame(cb) {
    requestAnimationFrame(function() {
        requestAnimationFrame(cb);
    });
}
var $d1d7d8b3f9a18d56$var$endId = 0;
function $d1d7d8b3f9a18d56$var$whenTransitionEnds(el, expectedType, explicitTimeout, resolve) {
    var id = el._endId = ++$d1d7d8b3f9a18d56$var$endId;
    var resolveIfNotStale = function() {
        if (id === el._endId) resolve();
    };
    if (explicitTimeout) return setTimeout(resolveIfNotStale, explicitTimeout);
    var _getTransitionInfo = $d1d7d8b3f9a18d56$var$getTransitionInfo(el, expectedType), type = _getTransitionInfo.type, timeout = _getTransitionInfo.timeout, propCount = _getTransitionInfo.propCount;
    if (!type) return resolve();
    var endEvent = type + "end";
    var ended = 0;
    var end = function() {
        el.removeEventListener(endEvent, onEnd);
        resolveIfNotStale();
    };
    var onEnd = function(e) {
        if (e.target === el && ++ended >= propCount) end();
    };
    setTimeout(function() {
        if (ended < propCount) end();
    }, timeout + 1);
    el.addEventListener(endEvent, onEnd);
}
function $d1d7d8b3f9a18d56$var$getTransitionInfo(el, expectedType) {
    var styles = window.getComputedStyle(el);
    var getStyleProperties = function(key) {
        return (styles[key] || "").split(", ");
    };
    var transitionDelays = getStyleProperties("".concat($d1d7d8b3f9a18d56$var$TRANSITION, "Delay"));
    var transitionDurations = getStyleProperties("".concat($d1d7d8b3f9a18d56$var$TRANSITION, "Duration"));
    var transitionTimeout = $d1d7d8b3f9a18d56$var$getTimeout(transitionDelays, transitionDurations);
    var animationDelays = getStyleProperties("".concat($d1d7d8b3f9a18d56$var$ANIMATION, "Delay"));
    var animationDurations = getStyleProperties("".concat($d1d7d8b3f9a18d56$var$ANIMATION, "Duration"));
    var animationTimeout = $d1d7d8b3f9a18d56$var$getTimeout(animationDelays, animationDurations);
    var type = null;
    var timeout = 0;
    var propCount = 0;
    if (expectedType === $d1d7d8b3f9a18d56$var$TRANSITION) {
        if (transitionTimeout > 0) {
            type = $d1d7d8b3f9a18d56$var$TRANSITION;
            timeout = transitionTimeout;
            propCount = transitionDurations.length;
        }
    } else if (expectedType === $d1d7d8b3f9a18d56$var$ANIMATION) {
        if (animationTimeout > 0) {
            type = $d1d7d8b3f9a18d56$var$ANIMATION;
            timeout = animationTimeout;
            propCount = animationDurations.length;
        }
    } else {
        timeout = Math.max(transitionTimeout, animationTimeout);
        type = timeout > 0 ? transitionTimeout > animationTimeout ? $d1d7d8b3f9a18d56$var$TRANSITION : $d1d7d8b3f9a18d56$var$ANIMATION : null;
        propCount = type ? type === $d1d7d8b3f9a18d56$var$TRANSITION ? transitionDurations.length : animationDurations.length : 0;
    }
    var hasTransform = type === $d1d7d8b3f9a18d56$var$TRANSITION && /\b(transform|all)(,|$)/.test(getStyleProperties("".concat($d1d7d8b3f9a18d56$var$TRANSITION, "Property")).toString());
    return {
        type: type,
        timeout: timeout,
        propCount: propCount,
        hasTransform: hasTransform
    };
}
function $d1d7d8b3f9a18d56$var$getTimeout(delays, durations) {
    var _Math;
    while(delays.length < durations.length)delays = delays.concat(delays);
    return (_Math = Math).max.apply(_Math, (0, $c6Xmf._)(durations.map(function(d, i) {
        return $d1d7d8b3f9a18d56$var$toMs(d) + $d1d7d8b3f9a18d56$var$toMs(delays[i]);
    })));
}
function $d1d7d8b3f9a18d56$var$toMs(s) {
    return Number(s.slice(0, -1).replace(",", ".")) * 1e3;
}
function $d1d7d8b3f9a18d56$var$forceReflow() {
    return document.body.offsetHeight;
}
var $d1d7d8b3f9a18d56$var$positionMap = /* @__PURE__ */ new WeakMap();
var $d1d7d8b3f9a18d56$var$newPositionMap = /* @__PURE__ */ new WeakMap();
var $d1d7d8b3f9a18d56$var$TransitionGroupImpl = {
    name: "TransitionGroup",
    props: /* @__PURE__ */ (0, $hLodm.extend)({}, $d1d7d8b3f9a18d56$var$TransitionPropsValidators, {
        tag: String,
        moveClass: String
    }),
    setup: function(props, param) {
        var slots = param.slots;
        var instance = (0, $lIPIy.getCurrentInstance)();
        var state = (0, $lIPIy.useTransitionState)();
        var prevChildren;
        var children;
        (0, $lIPIy.onUpdated)(function() {
            if (!prevChildren.length) return;
            var moveClass = props.moveClass || "".concat(props.name || "v", "-move");
            if (!$d1d7d8b3f9a18d56$var$hasCSSTransform(prevChildren[0].el, instance.vnode.el, moveClass)) return;
            prevChildren.forEach($d1d7d8b3f9a18d56$var$callPendingCbs);
            prevChildren.forEach($d1d7d8b3f9a18d56$var$recordPosition);
            var movedChildren = prevChildren.filter($d1d7d8b3f9a18d56$var$applyTranslation);
            $d1d7d8b3f9a18d56$var$forceReflow();
            movedChildren.forEach(function(c) {
                var el = c.el;
                var style = el.style;
                $d1d7d8b3f9a18d56$var$addTransitionClass(el, moveClass);
                style.transform = style.webkitTransform = style.transitionDuration = "";
                var cb = el._moveCb = function(e) {
                    if (e && e.target !== el) return;
                    if (!e || /transform$/.test(e.propertyName)) {
                        el.removeEventListener("transitionend", cb);
                        el._moveCb = null;
                        $d1d7d8b3f9a18d56$var$removeTransitionClass(el, moveClass);
                    }
                };
                el.addEventListener("transitionend", cb);
            });
        });
        return function() {
            var rawProps = (0, $yQ0Ka.toRaw)(props);
            var cssTransitionProps = $d1d7d8b3f9a18d56$var$resolveTransitionProps(rawProps);
            var tag = rawProps.tag || (0, $lIPIy.Fragment);
            prevChildren = children;
            children = slots.default ? (0, $lIPIy.getTransitionRawChildren)(slots.default()) : [];
            for(var i = 0; i < children.length; i++){
                var child = children[i];
                if (child.key != null) (0, $lIPIy.setTransitionHooks)(child, (0, $lIPIy.resolveTransitionHooks)(child, cssTransitionProps, state, instance));
            }
            if (prevChildren) for(var i1 = 0; i1 < prevChildren.length; i1++){
                var child1 = prevChildren[i1];
                (0, $lIPIy.setTransitionHooks)(child1, (0, $lIPIy.resolveTransitionHooks)(child1, cssTransitionProps, state, instance));
                $d1d7d8b3f9a18d56$var$positionMap.set(child1, child1.el.getBoundingClientRect());
            }
            return (0, $lIPIy.createVNode)(tag, null, children);
        };
    }
};
var $d1d7d8b3f9a18d56$var$removeMode = function(props) {
    return delete props.mode;
};
/* @__PURE__ */ $d1d7d8b3f9a18d56$var$removeMode($d1d7d8b3f9a18d56$var$TransitionGroupImpl.props);
var $d1d7d8b3f9a18d56$export$19ffa8f511f7bc2e = $d1d7d8b3f9a18d56$var$TransitionGroupImpl;
function $d1d7d8b3f9a18d56$var$callPendingCbs(c) {
    var el = c.el;
    if (el._moveCb) el._moveCb();
    if (el._enterCb) el._enterCb();
}
function $d1d7d8b3f9a18d56$var$recordPosition(c) {
    $d1d7d8b3f9a18d56$var$newPositionMap.set(c, c.el.getBoundingClientRect());
}
function $d1d7d8b3f9a18d56$var$applyTranslation(c) {
    var oldPos = $d1d7d8b3f9a18d56$var$positionMap.get(c);
    var newPos = $d1d7d8b3f9a18d56$var$newPositionMap.get(c);
    var dx = oldPos.left - newPos.left;
    var dy = oldPos.top - newPos.top;
    if (dx || dy) {
        var s = c.el.style;
        s.transform = s.webkitTransform = "translate(".concat(dx, "px,").concat(dy, "px)");
        s.transitionDuration = "0s";
        return c;
    }
}
function $d1d7d8b3f9a18d56$var$hasCSSTransform(el, root, moveClass) {
    var clone = el.cloneNode();
    if (el._vtc) el._vtc.forEach(function(cls) {
        cls.split(/\s+/).forEach(function(c) {
            return c && clone.classList.remove(c);
        });
    });
    moveClass.split(/\s+/).forEach(function(c) {
        return c && clone.classList.add(c);
    });
    clone.style.display = "none";
    var container = root.nodeType === 1 ? root : root.parentNode;
    container.appendChild(clone);
    var hasTransform = $d1d7d8b3f9a18d56$var$getTransitionInfo(clone).hasTransform;
    container.removeChild(clone);
    return hasTransform;
}
var $d1d7d8b3f9a18d56$var$getModelAssigner = function(vnode) {
    var fn = vnode.props["onUpdate:modelValue"] || false;
    return (0, $hLodm.isArray)(fn) ? function(value) {
        return (0, $hLodm.invokeArrayFns)(fn, value);
    } : fn;
};
function $d1d7d8b3f9a18d56$var$onCompositionStart(e) {
    e.target.composing = true;
}
function $d1d7d8b3f9a18d56$var$onCompositionEnd(e) {
    var target = e.target;
    if (target.composing) {
        target.composing = false;
        target.dispatchEvent(new Event("input"));
    }
}
var $d1d7d8b3f9a18d56$export$f1f88689f5728478 = (0, $3sHb8._)({
    created: function(el, param, vnode) {
        var _param_modifiers = param.modifiers, lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
        el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
        var castToNumber = number || vnode.props && vnode.props.type === "number";
        $d1d7d8b3f9a18d56$var$addEventListener(el, lazy ? "change" : "input", function(e) {
            if (e.target.composing) return;
            var domValue = el.value;
            if (trim) domValue = domValue.trim();
            if (castToNumber) domValue = (0, $hLodm.looseToNumber)(domValue);
            el._assign(domValue);
        });
        if (trim) $d1d7d8b3f9a18d56$var$addEventListener(el, "change", function() {
            el.value = el.value.trim();
        });
        if (!lazy) {
            $d1d7d8b3f9a18d56$var$addEventListener(el, "compositionstart", $d1d7d8b3f9a18d56$var$onCompositionStart);
            $d1d7d8b3f9a18d56$var$addEventListener(el, "compositionend", $d1d7d8b3f9a18d56$var$onCompositionEnd);
            $d1d7d8b3f9a18d56$var$addEventListener(el, "change", $d1d7d8b3f9a18d56$var$onCompositionEnd);
        }
    },
    // set value on mounted so it's after min/max for type="range"
    mounted: function(el, param) {
        var value = param.value;
        el.value = value == null ? "" : value;
    }
}, "beforeUpdate", function(el, param, vnode) {
    var value = param.value, _param_modifiers = param["modifiers"], lazy = _param_modifiers.lazy, trim = _param_modifiers.trim, number = _param_modifiers.number;
    el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
    if (el.composing) return;
    if (document.activeElement === el && el.type !== "range") {
        if (lazy) return;
        if (trim && el.value.trim() === value) return;
        if ((number || el.type === "number") && (0, $hLodm.looseToNumber)(el.value) === value) return;
    }
    var newValue = value == null ? "" : value;
    if (el.value !== newValue) el.value = newValue;
});
var $d1d7d8b3f9a18d56$export$8847c2e532b35714 = {
    // #4096 array checkboxes need to be deep traversed
    deep: true,
    created: function(el, _, vnode) {
        el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
        $d1d7d8b3f9a18d56$var$addEventListener(el, "change", function() {
            var modelValue = el._modelValue;
            var elementValue = $d1d7d8b3f9a18d56$var$getValue(el);
            var checked = el.checked;
            var assign = el._assign;
            if ((0, $hLodm.isArray)(modelValue)) {
                var index = (0, $hLodm.looseIndexOf)(modelValue, elementValue);
                var found = index !== -1;
                if (checked && !found) assign(modelValue.concat(elementValue));
                else if (!checked && found) {
                    var filtered = (0, $c6Xmf._)(modelValue);
                    filtered.splice(index, 1);
                    assign(filtered);
                }
            } else if ((0, $hLodm.isSet)(modelValue)) {
                var cloned = new Set(modelValue);
                if (checked) cloned.add(elementValue);
                else cloned.delete(elementValue);
                assign(cloned);
            } else assign($d1d7d8b3f9a18d56$var$getCheckboxValue(el, checked));
        });
    },
    // set initial checked on mount to wait for true-value/false-value
    mounted: $d1d7d8b3f9a18d56$var$setChecked,
    beforeUpdate: function(el, binding, vnode) {
        el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
        $d1d7d8b3f9a18d56$var$setChecked(el, binding, vnode);
    }
};
function $d1d7d8b3f9a18d56$var$setChecked(el, param, vnode) {
    var value = param.value, oldValue = param.oldValue;
    el._modelValue = value;
    if ((0, $hLodm.isArray)(value)) el.checked = (0, $hLodm.looseIndexOf)(value, vnode.props.value) > -1;
    else if ((0, $hLodm.isSet)(value)) el.checked = value.has(vnode.props.value);
    else if (value !== oldValue) el.checked = (0, $hLodm.looseEqual)(value, $d1d7d8b3f9a18d56$var$getCheckboxValue(el, true));
}
var $d1d7d8b3f9a18d56$export$b4356c59b38b7aa9 = {
    created: function(el, param, vnode) {
        var value = param.value;
        el.checked = (0, $hLodm.looseEqual)(value, vnode.props.value);
        el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
        $d1d7d8b3f9a18d56$var$addEventListener(el, "change", function() {
            el._assign($d1d7d8b3f9a18d56$var$getValue(el));
        });
    },
    beforeUpdate: function(el, param, vnode) {
        var value = param.value, oldValue = param.oldValue;
        el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
        if (value !== oldValue) el.checked = (0, $hLodm.looseEqual)(value, vnode.props.value);
    }
};
var $d1d7d8b3f9a18d56$export$87d227567b51ca39 = {
    // <select multiple> value need to be deep traversed
    deep: true,
    created: function(el, param, vnode) {
        var value = param.value, number = param.modifiers.number;
        var isSetModel = (0, $hLodm.isSet)(value);
        $d1d7d8b3f9a18d56$var$addEventListener(el, "change", function() {
            var selectedVal = Array.prototype.filter.call(el.options, function(o) {
                return o.selected;
            }).map(function(o) {
                return number ? (0, $hLodm.looseToNumber)($d1d7d8b3f9a18d56$var$getValue(o)) : $d1d7d8b3f9a18d56$var$getValue(o);
            });
            el._assign(el.multiple ? isSetModel ? new Set(selectedVal) : selectedVal : selectedVal[0]);
        });
        el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
    },
    // set value in mounted & updated because <select> relies on its children
    // <option>s.
    mounted: function(el, param) {
        var value = param.value;
        $d1d7d8b3f9a18d56$var$setSelected(el, value);
    },
    beforeUpdate: function(el, _binding, vnode) {
        el._assign = $d1d7d8b3f9a18d56$var$getModelAssigner(vnode);
    },
    updated: function(el, param) {
        var value = param.value;
        $d1d7d8b3f9a18d56$var$setSelected(el, value);
    }
};
function $d1d7d8b3f9a18d56$var$setSelected(el, value) {
    var isMultiple = el.multiple;
    if (isMultiple && !(0, $hLodm.isArray)(value) && !(0, $hLodm.isSet)(value)) return;
    for(var i = 0, l = el.options.length; i < l; i++){
        var option = el.options[i];
        var optionValue = $d1d7d8b3f9a18d56$var$getValue(option);
        if (isMultiple) {
            if ((0, $hLodm.isArray)(value)) option.selected = (0, $hLodm.looseIndexOf)(value, optionValue) > -1;
            else option.selected = value.has(optionValue);
        } else if ((0, $hLodm.looseEqual)($d1d7d8b3f9a18d56$var$getValue(option), value)) {
            if (el.selectedIndex !== i) el.selectedIndex = i;
            return;
        }
    }
    if (!isMultiple && el.selectedIndex !== -1) el.selectedIndex = -1;
}
function $d1d7d8b3f9a18d56$var$getValue(el) {
    return "_value" in el ? el._value : el.value;
}
function $d1d7d8b3f9a18d56$var$getCheckboxValue(el, checked) {
    var key = checked ? "_trueValue" : "_falseValue";
    return key in el ? el[key] : checked;
}
var $d1d7d8b3f9a18d56$export$5ad5c0e01ff62c5 = {
    created: function(el, binding, vnode) {
        $d1d7d8b3f9a18d56$var$callModelHook(el, binding, vnode, null, "created");
    },
    mounted: function(el, binding, vnode) {
        $d1d7d8b3f9a18d56$var$callModelHook(el, binding, vnode, null, "mounted");
    },
    beforeUpdate: function(el, binding, vnode, prevVNode) {
        $d1d7d8b3f9a18d56$var$callModelHook(el, binding, vnode, prevVNode, "beforeUpdate");
    },
    updated: function(el, binding, vnode, prevVNode) {
        $d1d7d8b3f9a18d56$var$callModelHook(el, binding, vnode, prevVNode, "updated");
    }
};
function $d1d7d8b3f9a18d56$var$resolveDynamicModel(tagName, type) {
    switch(tagName){
        case "SELECT":
            return $d1d7d8b3f9a18d56$export$87d227567b51ca39;
        case "TEXTAREA":
            return $d1d7d8b3f9a18d56$export$f1f88689f5728478;
        default:
            switch(type){
                case "checkbox":
                    return $d1d7d8b3f9a18d56$export$8847c2e532b35714;
                case "radio":
                    return $d1d7d8b3f9a18d56$export$b4356c59b38b7aa9;
                default:
                    return $d1d7d8b3f9a18d56$export$f1f88689f5728478;
            }
    }
}
function $d1d7d8b3f9a18d56$var$callModelHook(el, binding, vnode, prevVNode, hook) {
    var modelToUse = $d1d7d8b3f9a18d56$var$resolveDynamicModel(el.tagName, vnode.props && vnode.props.type);
    var fn = modelToUse[hook];
    fn && fn(el, binding, vnode, prevVNode);
}
function $d1d7d8b3f9a18d56$var$initVModelForSSR() {
    $d1d7d8b3f9a18d56$export$f1f88689f5728478.getSSRProps = function(param) {
        var value = param.value;
        return {
            value: value
        };
    };
    $d1d7d8b3f9a18d56$export$b4356c59b38b7aa9.getSSRProps = function(param, vnode) {
        var value = param.value;
        if (vnode.props && (0, $hLodm.looseEqual)(vnode.props.value, value)) return {
            checked: true
        };
    };
    $d1d7d8b3f9a18d56$export$8847c2e532b35714.getSSRProps = function(param, vnode) {
        var value = param.value;
        if ((0, $hLodm.isArray)(value)) {
            if (vnode.props && (0, $hLodm.looseIndexOf)(value, vnode.props.value) > -1) return {
                checked: true
            };
        } else if ((0, $hLodm.isSet)(value)) {
            if (vnode.props && value.has(vnode.props.value)) return {
                checked: true
            };
        } else if (value) return {
            checked: true
        };
    };
    $d1d7d8b3f9a18d56$export$5ad5c0e01ff62c5.getSSRProps = function(binding, vnode) {
        if (typeof vnode.type !== "string") return;
        var modelToUse = $d1d7d8b3f9a18d56$var$resolveDynamicModel(// resolveDynamicModel expects an uppercase tag name, but vnode.type is lowercase
        vnode.type.toUpperCase(), vnode.props && vnode.props.type);
        if (modelToUse.getSSRProps) return modelToUse.getSSRProps(binding, vnode);
    };
}
var $d1d7d8b3f9a18d56$var$systemModifiers = [
    "ctrl",
    "shift",
    "alt",
    "meta"
];
var $d1d7d8b3f9a18d56$var$modifierGuards = {
    stop: function(e) {
        return e.stopPropagation();
    },
    prevent: function(e) {
        return e.preventDefault();
    },
    self: function(e) {
        return e.target !== e.currentTarget;
    },
    ctrl: function(e) {
        return !e.ctrlKey;
    },
    shift: function(e) {
        return !e.shiftKey;
    },
    alt: function(e) {
        return !e.altKey;
    },
    meta: function(e) {
        return !e.metaKey;
    },
    left: function(e) {
        return "button" in e && e.button !== 0;
    },
    middle: function(e) {
        return "button" in e && e.button !== 1;
    },
    right: function(e) {
        return "button" in e && e.button !== 2;
    },
    exact: function(e, modifiers) {
        return $d1d7d8b3f9a18d56$var$systemModifiers.some(function(m) {
            return e["".concat(m, "Key")] && !modifiers.includes(m);
        });
    }
};
var $d1d7d8b3f9a18d56$export$26bd3b8e29e6f273 = function(fn, modifiers) {
    return function(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        for(var i = 0; i < modifiers.length; i++){
            var guard = $d1d7d8b3f9a18d56$var$modifierGuards[modifiers[i]];
            if (guard && guard(event, modifiers)) return;
        }
        return fn.apply(void 0, [
            event
        ].concat((0, $c6Xmf._)(args)));
    };
};
var $d1d7d8b3f9a18d56$var$keyNames = {
    esc: "escape",
    space: " ",
    up: "arrow-up",
    left: "arrow-left",
    right: "arrow-right",
    down: "arrow-down",
    delete: "backspace"
};
var $d1d7d8b3f9a18d56$export$f691a8759658f782 = function(fn, modifiers) {
    return function(event) {
        if (!("key" in event)) return;
        var eventKey = (0, $hLodm.hyphenate)(event.key);
        if (modifiers.some(function(k) {
            return k === eventKey || $d1d7d8b3f9a18d56$var$keyNames[k] === eventKey;
        })) return fn(event);
    };
};
var $d1d7d8b3f9a18d56$export$5cb4fcdc6937d7e1 = {
    beforeMount: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        el._vod = el.style.display === "none" ? "" : el.style.display;
        if (transition && value) transition.beforeEnter(el);
        else $d1d7d8b3f9a18d56$var$setDisplay(el, value);
    },
    mounted: function(el, param, param1) {
        var value = param.value, transition = param1.transition;
        if (transition && value) transition.enter(el);
    },
    updated: function(el, param, param1) {
        var value = param.value, oldValue = param.oldValue, transition = param1.transition;
        if (!value === !oldValue) return;
        if (transition) {
            if (value) {
                transition.beforeEnter(el);
                $d1d7d8b3f9a18d56$var$setDisplay(el, true);
                transition.enter(el);
            } else transition.leave(el, function() {
                $d1d7d8b3f9a18d56$var$setDisplay(el, false);
            });
        } else $d1d7d8b3f9a18d56$var$setDisplay(el, value);
    },
    beforeUnmount: function(el, param) {
        var value = param.value;
        $d1d7d8b3f9a18d56$var$setDisplay(el, value);
    }
};
function $d1d7d8b3f9a18d56$var$setDisplay(el, value) {
    el.style.display = value ? el._vod : "none";
}
function $d1d7d8b3f9a18d56$var$initVShowForSSR() {
    $d1d7d8b3f9a18d56$export$5cb4fcdc6937d7e1.getSSRProps = function(param) {
        var value = param.value;
        if (!value) return {
            style: {
                display: "none"
            }
        };
    };
}
var $d1d7d8b3f9a18d56$var$rendererOptions = /* @__PURE__ */ (0, $hLodm.extend)({
    patchProp: $d1d7d8b3f9a18d56$var$patchProp
}, $d1d7d8b3f9a18d56$var$nodeOps);
var $d1d7d8b3f9a18d56$var$renderer;
var $d1d7d8b3f9a18d56$var$enabledHydration = false;
function $d1d7d8b3f9a18d56$var$ensureRenderer() {
    return $d1d7d8b3f9a18d56$var$renderer || ($d1d7d8b3f9a18d56$var$renderer = (0, $lIPIy.createRenderer)($d1d7d8b3f9a18d56$var$rendererOptions));
}
function $d1d7d8b3f9a18d56$var$ensureHydrationRenderer() {
    $d1d7d8b3f9a18d56$var$renderer = $d1d7d8b3f9a18d56$var$enabledHydration ? $d1d7d8b3f9a18d56$var$renderer : (0, $lIPIy.createHydrationRenderer)($d1d7d8b3f9a18d56$var$rendererOptions);
    $d1d7d8b3f9a18d56$var$enabledHydration = true;
    return $d1d7d8b3f9a18d56$var$renderer;
}
var $d1d7d8b3f9a18d56$export$b3890eb0ae9dca99 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    (_ensureRenderer = $d1d7d8b3f9a18d56$var$ensureRenderer()).render.apply(_ensureRenderer, (0, $c6Xmf._)(args));
};
var $d1d7d8b3f9a18d56$export$fa8d919ba61d84db = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    (_ensureHydrationRenderer = $d1d7d8b3f9a18d56$var$ensureHydrationRenderer()).hydrate.apply(_ensureHydrationRenderer, (0, $c6Xmf._)(args));
};
var $d1d7d8b3f9a18d56$export$4e373c34abfa8c68 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureRenderer;
    var app = (_ensureRenderer = $d1d7d8b3f9a18d56$var$ensureRenderer()).createApp.apply(_ensureRenderer, (0, $c6Xmf._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $d1d7d8b3f9a18d56$var$normalizeContainer(containerOrSelector);
        if (!container) return;
        var component = app._component;
        if (!(0, $hLodm.isFunction)(component) && !component.render && !component.template) component.template = container.innerHTML;
        container.innerHTML = "";
        var proxy = mount(container, false, container instanceof SVGElement);
        if (container instanceof Element) {
            container.removeAttribute("v-cloak");
            container.setAttribute("data-v-app", "");
        }
        return proxy;
    };
    return app;
};
var $d1d7d8b3f9a18d56$export$35800275c0037383 = function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _ensureHydrationRenderer;
    var app = (_ensureHydrationRenderer = $d1d7d8b3f9a18d56$var$ensureHydrationRenderer()).createApp.apply(_ensureHydrationRenderer, (0, $c6Xmf._)(args));
    var mount = app.mount;
    app.mount = function(containerOrSelector) {
        var container = $d1d7d8b3f9a18d56$var$normalizeContainer(containerOrSelector);
        if (container) return mount(container, true, container instanceof SVGElement);
    };
    return app;
};
function $d1d7d8b3f9a18d56$var$injectNativeTagCheck(app) {
    Object.defineProperty(app.config, "isNativeTag", {
        value: function(tag) {
            return (0, $hLodm.isHTMLTag)(tag) || (0, $hLodm.isSVGTag)(tag);
        },
        writable: false
    });
}
function $d1d7d8b3f9a18d56$var$injectCompilerOptionsCheck(app) {
    if ((0, $lIPIy.isRuntimeOnly)()) {
        var isCustomElement = app.config.isCustomElement;
        Object.defineProperty(app.config, "isCustomElement", {
            get: function() {
                return isCustomElement;
            },
            set: function() {
                (0, $lIPIy.warn)("The `isCustomElement` config option is deprecated. Use `compilerOptions.isCustomElement` instead.");
            }
        });
        var compilerOptions = app.config.compilerOptions;
        var msg = 'The `compilerOptions` config option is only respected when using a build of Vue.js that includes the runtime compiler (aka "full build"). Since you are using the runtime-only build, `compilerOptions` must be passed to `@vue/compiler-dom` in the build setup instead.\n- For vue-loader: pass it via vue-loader\'s `compilerOptions` loader option.\n- For vue-cli: see https://cli.vuejs.org/guide/webpack.html#modifying-options-of-a-loader\n- For vite: pass it via @vitejs/plugin-vue options. See https://github.com/vitejs/vite-plugin-vue/tree/main/packages/plugin-vue#example-for-passing-options-to-vuecompiler-sfc';
        Object.defineProperty(app.config, "compilerOptions", {
            get: function() {
                (0, $lIPIy.warn)(msg);
                return compilerOptions;
            },
            set: function() {
                (0, $lIPIy.warn)(msg);
            }
        });
    }
}
function $d1d7d8b3f9a18d56$var$normalizeContainer(container) {
    if ((0, $hLodm.isString)(container)) {
        var res = document.querySelector(container);
        return res;
    }
    return container;
}
var $d1d7d8b3f9a18d56$var$ssrDirectiveInitialized = false;
var $d1d7d8b3f9a18d56$export$800b28255aa678d9 = function() {
    if (!$d1d7d8b3f9a18d56$var$ssrDirectiveInitialized) {
        $d1d7d8b3f9a18d56$var$ssrDirectiveInitialized = true;
        $d1d7d8b3f9a18d56$var$initVModelForSSR();
        $d1d7d8b3f9a18d56$var$initVShowForSSR();
    }
};

});
parcelRequire.register("dcsZi", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $99c2e1b2c4a01e52$export$7e4530ad35d3bb8; });

var $koVwh = parcelRequire("koVwh");
function $99c2e1b2c4a01e52$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $koVwh._set_prototype_of)(subClass, superClass);
}

});
parcelRequire.register("koVwh", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $eda2aabf2c4b7bd6$export$c2c98ac76e997b63; });
function $eda2aabf2c4b7bd6$export$c2c98ac76e997b63(o, p) {
    $eda2aabf2c4b7bd6$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $eda2aabf2c4b7bd6$export$c2c98ac76e997b63(o, p);
}

});


parcelRequire.register("ohfOJ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $048fa05071cfee44$export$8dd05c13f5255580; });

var $b8Rim = parcelRequire("b8Rim");

var $9yjJS = parcelRequire("9yjJS");

var $3U0IP = parcelRequire("3U0IP");
function $048fa05071cfee44$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $9yjJS._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $b8Rim._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $b8Rim._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $3U0IP._possible_constructor_return)(this, result);
    };
}

});
parcelRequire.register("b8Rim", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $81c9c858187986cb$export$f09211a7d3c496a1; });
function $81c9c858187986cb$export$f09211a7d3c496a1(o) {
    $81c9c858187986cb$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $81c9c858187986cb$export$f09211a7d3c496a1(o);
}

});

parcelRequire.register("9yjJS", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $6f4699ca644cfb51$export$685354647fba1516; });
function $6f4699ca644cfb51$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRequire.register("3U0IP", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $2d772972bd4fe337$export$ef97c660ca164e52; });

var $d3H5E = parcelRequire("d3H5E");

var $l0HdX = parcelRequire("l0HdX");
function $2d772972bd4fe337$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $l0HdX._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $d3H5E._assert_this_initialized)(self);
}

});
parcelRequire.register("d3H5E", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $981cfaf5c821609e$export$f3b8ed2e4a5d10b8; });
function $981cfaf5c821609e$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});






parcelRequire.register("7rELn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $56baacbff8b6a882$export$2e2bcd8739ae039; });
var $56baacbff8b6a882$var$NOOP = function() {};
var $56baacbff8b6a882$export$2e2bcd8739ae039 = function(script) {};

});

parcelRequire.register("d0ZGJ", function(module, exports) {
/**
 * Code refactored from Mozilla Developer Network:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
 */ "use strict";
function $979b207221e9d1fa$var$assign(target, firstSource) {
    if (target === undefined || target === null) throw new TypeError("Cannot convert first argument to object");
    var to = Object(target);
    for(var i = 1; i < arguments.length; i++){
        var nextSource = arguments[i];
        if (nextSource === undefined || nextSource === null) continue;
        var keysArray = Object.keys(Object(nextSource));
        for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++){
            var nextKey = keysArray[nextIndex];
            var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
            if (desc !== undefined && desc.enumerable) to[nextKey] = nextSource[nextKey];
        }
    }
    return to;
}
function $979b207221e9d1fa$var$polyfill() {
    if (!Object.assign) Object.defineProperty(Object, "assign", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: $979b207221e9d1fa$var$assign
    });
}
module.exports = {
    assign: $979b207221e9d1fa$var$assign,
    polyfill: $979b207221e9d1fa$var$polyfill
};

});

parcelRequire.register("hpBw0", function(module, exports) {
"use strict";
var $cad1df2f88e73fea$var$__spreadArrays = module.exports && module.exports.__spreadArrays || function() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $71mIx = parcelRequire("71mIx");
var $cad1df2f88e73fea$var$VueLogger = /** @class */ function() {
    var VueLogger = function VueLogger() {
        this.errorMessage = "Provided options for vuejs-logger are not valid.";
        this.logLevels = Object.keys($71mIx.LogLevels).map(function(l) {
            return l.toLowerCase();
        });
    };
    VueLogger.prototype.install = function(Vue, options) {
        options = Object.assign(this.getDefaultOptions(), options);
        if (this.isValidOptions(options, this.logLevels)) {
            Vue.$log = this.initLoggerInstance(options, this.logLevels);
            Vue.provide("vuejs3-logger", Vue.$log);
            Vue.config.globalProperties.$log = Vue.$log;
        } else throw new Error(this.errorMessage);
    };
    VueLogger.prototype.isValidOptions = function(options, logLevels) {
        if (!(options.logLevel && typeof options.logLevel === "string" && logLevels.indexOf(options.logLevel) > -1)) return false;
        if (options.stringifyArguments && typeof options.stringifyArguments !== "boolean") return false;
        if (options.showLogLevel && typeof options.showLogLevel !== "boolean") return false;
        if (options.showConsoleColors && typeof options.showConsoleColors !== "boolean") return false;
        if (options.separator && (typeof options.separator !== "string" || typeof options.separator === "string" && options.separator.length > 3)) return false;
        if (typeof options.isEnabled !== "boolean") return false;
        return !(options.showMethodName && typeof options.showMethodName !== "boolean");
    };
    VueLogger.prototype.getMethodName = function() {
        var error = {};
        try {
            throw new Error("");
        } catch (e) {
            error = e;
        }
        // IE9 does not have .stack property
        if (error.stack === undefined) return "";
        var stackTrace = error.stack.split("\n")[3];
        if (/ /.test(stackTrace)) stackTrace = stackTrace.trim().split(" ")[1];
        if (stackTrace && stackTrace.indexOf(".") > -1) stackTrace = stackTrace.split(".")[1];
        return stackTrace;
    };
    VueLogger.prototype.initLoggerInstance = function(options, logLevels) {
        var _this = this;
        var logger = {};
        logLevels.forEach(function(logLevel) {
            if (logLevels.indexOf(logLevel) >= logLevels.indexOf(options.logLevel) && options.isEnabled) logger[logLevel] = function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var methodName = _this.getMethodName();
                var methodNamePrefix = options.showMethodName ? methodName + (" " + options.separator + " ") : "";
                var logLevelPrefix = options.showLogLevel ? logLevel + (" " + options.separator + " ") : "";
                var formattedArguments = options.stringifyArguments ? args.map(function(a) {
                    return JSON.stringify(a);
                }) : args;
                var logMessage = logLevelPrefix + " " + methodNamePrefix;
                _this.printLogMessage(logLevel, logMessage, options.showConsoleColors, formattedArguments);
                return logMessage + " " + formattedArguments.toString();
            };
            else logger[logLevel] = function() {
                return undefined;
            };
        });
        return logger;
    };
    VueLogger.prototype.printLogMessage = function(logLevel, logMessage, showConsoleColors, formattedArguments) {
        if (showConsoleColors && (logLevel === "warn" || logLevel === "error" || logLevel === "fatal")) console[logLevel === "fatal" ? "error" : logLevel].apply(console, $cad1df2f88e73fea$var$__spreadArrays([
            logMessage
        ], formattedArguments));
        else console.log.apply(console, $cad1df2f88e73fea$var$__spreadArrays([
            logMessage
        ], formattedArguments));
    };
    VueLogger.prototype.getDefaultOptions = function() {
        return {
            isEnabled: true,
            logLevel: $71mIx.LogLevels.DEBUG,
            separator: "|",
            showConsoleColors: false,
            showLogLevel: false,
            showMethodName: false,
            stringifyArguments: false
        };
    };
    return VueLogger;
}();
module.exports.default = new $cad1df2f88e73fea$var$VueLogger();

});
parcelRequire.register("71mIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $51ca3f9cea862719$var$LogLevels;
(function(LogLevels) {
    LogLevels["DEBUG"] = "debug";
    LogLevels["INFO"] = "info";
    LogLevels["WARN"] = "warn";
    LogLevels["ERROR"] = "error";
    LogLevels["FATAL"] = "fatal";
})($51ca3f9cea862719$var$LogLevels = module.exports.LogLevels || (module.exports.LogLevels = {}));

});


var $c8ac7f42204e79b8$exports = {};

(parcelRequire("bRvn3")).register(JSON.parse('{"12710":"rodents.00b52ba0.jpg","cVWVU":"index.2baac22b.js","ja4MD":"logo-sts-de.2eb117a4.png","5SBlC":"logo-sts-fr.11e6df30.png","6VrDU":"logo-sts-it.029a94ca.png","8RU2F":"logo-blv-de-1000.0e608301.png","5IKFz":"logo-blv-de-vertical-600.a51ca3c1.png","lJI6R":"logo-blv-fr-1000.1c13b92e.png","7UjrZ":"logo-blv-fr-vertical-600.70599400.png","cnqJK":"logo-blv-it-1000.813ce936.png","352jE":"logo-blv-it-vertical-600.ea045941.png","cX2Bz":"icon-68.9442a8ac.png","5KKNR":"icon-warning-black.b84314e1.svg","e3ttH":"icon-warning-white.e402ffbb.svg","hWl48":"length-lizards.5ff4f6c7.png","5oQro":"length-snakes.f15853b7.png","dezXr":"length-turtles.6c95159f.png","kbWRv":"equidae-withers.b4254aa6.png","dWO64":"rodents-320w.394ea02d.jpg","axomw":"rodents-480w.9e3d7fd3.jpg","aqakd":"rodents-640w.b048d6b0.jpg","bx9Gx":"leopardgecko.eb9adbac.jpg","8uMmT":"leopardgecko-320w.1d02fa01.jpg","blAG8":"leopardgecko-480w.01809450.jpg","cH7hC":"leopardgecko-640w.91f5e32e.jpg","XIcAI":"nymphensittich.7513b704.jpg","ax7c0":"nymphensittich-320w.b5c23b1e.jpg","9rvAe":"nymphensittich-480w.6d571e65.jpg","oMKRy":"nymphensittich-640w.2d3c7299.jpg","76WFY":"multiple-birds.937ef0ae.jpg","jPi7p":"multiple-birds-320w.1e0a42aa.jpg","9nrhP":"multiple-birds-480w.eb3aff46.jpg","cZFzF":"multiple-birds-640w.bc002df3.jpg","k0xjp":"pferd.ad6b3e9b.jpg","9ugT7":"pferd-320w.bbe3ea32.jpg","lhg4Z":"pferd-480w.5c24803f.jpg","dt3FV":"pferd-640w.3474c2ea.jpg","apW5B":"degu.abddd12b.jpg","hLb2L":"degu-320w.e786b2e7.jpg","6qTcm":"degu-480w.a79d1d3a.jpg","fZAb4":"degu-640w.28c0e0cf.jpg","aasyh":"farbmaus.18f84535.jpg","dT2RT":"farbmaus-320w.2c8b08fc.jpg","lV953":"farbmaus-480w.1dcccd1a.jpg","k8bnH":"farbmaus-640w.9ab11272.jpg","fgyfY":"goldhamster.ab24e35c.jpg","bxRkK":"goldhamster-320w.677e8667.jpg","lNl61":"goldhamster-480w.3672f286.jpg","dPgsb":"goldhamster-640w.f98c96af.jpg","6YQ26":"kaninchen.0913cc61.jpg","8jgZ5":"kaninchen-320w.2637860f.jpg","4q3zP":"kaninchen-480w.30e649df.jpg","GICf6":"kaninchen-640w.543d7d92.jpg","6wIu0":"meerschweinchen.d4f8a6d7.jpg","5csR4":"meerschweinchen-320w.5cfb9211.jpg","b5r04":"meerschweinchen-480w.b4077ff0.jpg","iAGdv":"meerschweinchen-640w.573ca2a2.jpg","2TTkF":"ratte.c2e236ba.jpg","fqVmk":"ratte-320w.5b242fdc.jpg","axZW5":"ratte-480w.67077747.jpg","hZ2ko":"ratte-640w.a77ec293.jpg","fHJhc":"rennmaus.9f6f1f58.jpg","8sZ2x":"rennmaus-320w.7003a712.jpg","eh5mz":"rennmaus-480w.dfe7af06.jpg","a22iY":"rennmaus-640w.2d906b5c.jpg","2f6SF":"zwerghamster.9f440aed.jpg","3DOg3":"zwerghamster-320w.cd594b82.jpg","h2Mdc":"zwerghamster-480w.5001c5da.jpg","jBBrJ":"zwerghamster-640w.7015e3ff.jpg","4fecT":"koenigspython.f8664a4a.jpg","dhcMT":"koenigspython-320w.faeeb59f.jpg","8LXue":"koenigspython-480w.20535e6c.jpg","iol6v":"koenigspython-640w.ccd432f0.jpg","dna2y":"kornnatter.f28477c9.jpg","jsdks":"kornnatter-320w.bae31957.jpg","gap2c":"kornnatter-480w.611a46dd.jpg","b6D9F":"kornnatter-640w.eb57b675.jpg","b9giA":"griechische_landschildkroete.00b5f7aa.jpg","guXWy":"griechische_landschildkroete-320w.ec4828b7.jpg","9BwQf":"griechische_landschildkroete-480w.794fa39a.jpg","a4cjX":"griechische_landschildkroete-640w.89eeb150.jpg","aONSO":"maurische_landschildkroete.64033a68.jpg","5B6yC":"maurische_landschildkroete-320w.01f542bd.jpg","47tRl":"maurische_landschildkroete-480w.90b3ea11.jpg","7h9bs":"maurische_landschildkroete-640w.f5931575.jpg","jxKrQ":"breitrandschildkroete.39ce8825.jpg","kxDVC":"breitrandschildkroete-320w.84da36f2.jpg","jqxWd":"breitrandschildkroete-480w.3e40c303.jpg","8PGSz":"breitrandschildkroete-640w.cee835a6.jpg","hmls9":"kronengecko.e56b5d72.jpg","lJ0qR":"kronengecko-320w.571c1b86.jpg","lXIyR":"kronengecko-480w.1c94951d.jpg","fYpw3":"kronengecko-640w.c9d5b991.jpg","9wgmL":"abgottschlange.73ef255e.jpg","622P1":"abgottschlange-320w.c5a83ff5.jpg","6kVrE":"abgottschlange-480w.78efec9d.jpg","dSz5c":"abgottschlange-640w.e4455e05.jpg","9xvHM":"gewoehnliche_moschusschildkroete.d05e16c8.jpg","WbF4i":"gewoehnliche_moschusschildkroete-320w.8430436e.jpg","c9r1H":"gewoehnliche_moschusschildkroete-480w.a92d9095.jpg","uyYP1":"gewoehnliche_moschusschildkroete-640w.67fa721a.jpg","4xCrD":"dreiecksnatter.1c44fca6.jpg","2i9JN":"dreiecksnatter-320w.a421788d.jpg","fEHCL":"dreiecksnatter-480w.cd22dd67.jpg","5Sl7O":"dreiecksnatter-640w.adf0a329.jpg","uC2CL":"grosser_madagaskar_taggecko.f00be3f7.jpg","7kJXl":"grosser_madagaskar_taggecko-320w.1573bc4d.jpg","2F1Fs":"grosser_madagaskar_taggecko-480w.0c990c99.jpg","7KYmj":"grosser_madagaskar_taggecko-640w.99914897.jpg","cq7Ig":"goldstaub_taggecko.1bc1d32f.jpg","4F7hs":"goldstaub_taggecko-320w.ed7c072d.jpg","gatDg":"goldstaub_taggecko-480w.39713f96.jpg","21YTn":"goldstaub_taggecko-640w.89145f74.jpg","3N6HV":"zwergbartagame.441c4766.jpg","54isN":"zwergbartagame-320w.dc885957.jpg","aIbhY":"zwergbartagame-480w.2dafd184.jpg","6XUpp":"zwergbartagame-640w.93b4b5d9.jpg","l6a6t":"streifenkoepfige_bartagame.1de9e77e.jpg","2VESc":"streifenkoepfige_bartagame-320w.b70a8f4c.jpg","cyB2u":"streifenkoepfige_bartagame-480w.759ef780.jpg","3KCd6":"streifenkoepfige_bartagame-640w.a5aa7f94.jpg","bqesX":"wellensittich.3301dce2.jpg","5Ufi5":"wellensittich-320w.d6a5b84d.jpg","lIVjI":"wellensittich-480w.ebfb90b8.jpg","jtOYA":"wellensittich-640w.cd63e18e.jpg","5GeT0":"agapornid.c812a41a.jpg","2bg71":"agapornid-320w.20eefed9.jpg","dcsFO":"agapornid-480w.e114c5a1.jpg","lzP8F":"agapornid-640w.4cfc1ec9.jpg","iacW9":"amazone.adc0ec30.jpg","6riQC":"amazone-320w.712510ba.jpg","gIZOQ":"amazone-480w.eab5a7c1.jpg","evHxn":"amazone-640w.598777ee.jpg","iPiKB":"kongo-graupapagei.e74fbf97.jpg","4KV4x":"kongo-graupapagei-320w.18243bae.jpg","fQk7Y":"kongo-graupapagei-480w.eeaf2b3a.jpg","fKVwA":"kongo-graupapagei-640w.9b4ff12e.jpg","kVIqW":"tarantapapagei.34e0d27c.jpg","7wELn":"tarantapapagei-320w.7841b5b4.jpg","eFz0B":"tarantapapagei-480w.9b1973db.jpg","NF8TK":"tarantapapagei-640w.debea40d.jpg","dYrEN":"rosellasittich.bcf230f3.jpg","hYlJJ":"rosellasittich-320w.7228bb45.jpg","6eZah":"rosellasittich-480w.2089c3f2.jpg","3LOig":"rosellasittich-640w.af47a262.jpg","asiUz":"schoensittich.1b2d5b71.jpg","6ZUhx":"schoensittich-320w.42939912.jpg","9s7Cd":"schoensittich-480w.3fa97a92.jpg","ieySe":"schoensittich-640w.8e377e1c.jpg","htxvf":"kanarienvogel.721ab31a.jpg","4ABfC":"kanarienvogel-320w.58be9190.jpg","jxBMP":"kanarienvogel-480w.d3e51601.jpg","kLU9d":"kanarienvogel-640w.f5601394.jpg","4AOCg":"gouldamadinen.7ddce718.jpg","9q6bx":"gouldamadinen-320w.c1502f8c.jpg","49En6":"gouldamadinen-480w.b02e4a7e.jpg","ftZQX":"gouldamadinen-640w.320f2a2c.jpg","gHCIh":"zebrafink.1c5f7f5b.jpg","3vCHu":"zebrafink-320w.3b61e0f0.jpg","21ugb":"zebrafink-480w.29acf448.jpg","fg2XQ":"zebrafink-640w.572c0b3f.jpg","e4Ch4":"goldbruestchen.99c3271a.jpg","fw7G1":"goldbruestchen-320w.086c5195.jpg","gyQzD":"goldbruestchen-480w.e37505f7.jpg","4J5Vd":"goldbruestchen-640w.ed736d6a.jpg","3SL2G":"grauastrild.b471d7dd.jpg","hyMyY":"grauastrild-320w.bfc18352.jpg","3m4ra":"grauastrild-480w.5e50f962.jpg","kKFsP":"grauastrild-640w.600a45bd.jpg","4zfhK":"diamanttaeubchen.0e0ebbce.jpg","lrQ3X":"diamanttaeubchen-320w.a31228ca.jpg","9pT2i":"diamanttaeubchen-480w.5fa0e66f.jpg","kqnGH":"diamanttaeubchen-640w.472cab25.jpg","huYVs":"ara.d5f7abe8.jpg","lQ8lF":"ara-320w.a9b1dc66.jpg","12D4m":"ara-480w.43d4f401.jpg","7SaQo":"ara-640w.2a7b67b1.jpg","doB6t":"kakadu.9205e7e0.jpg","1Vmyf":"kakadu-320w.5cfa351d.jpg","1In9k":"kakadu-480w.c84446b5.jpg","l6OPb":"kakadu-640w.46a27fde.jpg","iY8b4":"pony.dfdd65b1.jpg","21oOb":"pony-320w.bed6d7a6.jpg","jQ3yp":"pony-480w.2d5cd9de.jpg","fei9n":"pony-640w.f9294ff0.jpg","kE4Sj":"esel.a2449283.jpg","lDjP8":"esel-320w.35f8206a.jpg","f8Hxw":"esel-480w.b73827d7.jpg","9pP1I":"esel-640w.49cb424b.jpg","8CSZ7":"maultier.b3572c6a.jpg","lK3k0":"maultier-320w.7ed3e855.jpg","8r0xG":"maultier-480w.d46058b9.jpg","6Wts2":"maultier-640w.3e895141.jpg","9fUwQ":"maulesel.8b852691.jpg","etGW5":"maulesel-320w.83d9afa7.jpg","jZXhu":"maulesel-480w.1cc4bcbe.jpg","7r2vE":"maulesel-640w.6adcb014.jpg","dBCut":"index.981dc3ef.css"}'));


var $do9pw = parcelRequire("do9pw");
parcelRequire("dggmT");
var $i0Zoc = parcelRequire("i0Zoc");
var $c34d6ef872f89bec$var$script;




var $c34d6ef872f89bec$var$initialize = function() {
    $c34d6ef872f89bec$var$script = (parcelRequire("kgVKs"));
    if ($c34d6ef872f89bec$var$script.__esModule) $c34d6ef872f89bec$var$script = $c34d6ef872f89bec$var$script.default;
    $c34d6ef872f89bec$var$script.render = (parcelRequire("hMsms")).render;
    $c34d6ef872f89bec$var$script.__cssModules = {};
    (parcelRequire("7rELn")).default($c34d6ef872f89bec$var$script);
    $c34d6ef872f89bec$var$script.__scopeId = "data-v-e74703";
    $c34d6ef872f89bec$var$script.__file = "App.vue";
};
$c34d6ef872f89bec$var$initialize();
var $c34d6ef872f89bec$export$2e2bcd8739ae039 = $c34d6ef872f89bec$var$script;


/*!
  * vue-i18n v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ function $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $f330ac5f61e1368d$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $f330ac5f61e1368d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $l0HdX = parcelRequire("l0HdX");
var $f500ece5c74d6d3d$var$extendStatics = function extendStatics1(d, b) {
    $f500ece5c74d6d3d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f500ece5c74d6d3d$var$extendStatics(d, b);
};
function $f500ece5c74d6d3d$export$a8ba968b8961cb8a(d, b) {
    var __ = function __() {
        this.constructor = d;
    };
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f500ece5c74d6d3d$var$extendStatics(d, b);
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f500ece5c74d6d3d$export$18ce0697a983be9b = function __assign1() {
    $f500ece5c74d6d3d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f500ece5c74d6d3d$export$18ce0697a983be9b.apply(this, arguments);
};
function $f500ece5c74d6d3d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f500ece5c74d6d3d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f500ece5c74d6d3d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f500ece5c74d6d3d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    var accept = function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    };
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f500ece5c74d6d3d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f500ece5c74d6d3d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $l0HdX._)(x)) === "symbol" ? x : "".concat(x);
}
function $f500ece5c74d6d3d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $l0HdX._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f500ece5c74d6d3d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f500ece5c74d6d3d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f500ece5c74d6d3d$export$67ebef60e6f28a6(thisArg, body) {
    var verb = function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    };
    var step = function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    };
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
}
var $f500ece5c74d6d3d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f500ece5c74d6d3d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f500ece5c74d6d3d$export$45d3717a4c69092e(o, m, p);
}
function $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f500ece5c74d6d3d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f500ece5c74d6d3d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f500ece5c74d6d3d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f500ece5c74d6d3d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f500ece5c74d6d3d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f500ece5c74d6d3d$export$10c90e4f7922046c(v) {
    return this instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? (this.v = v, this) : new $f500ece5c74d6d3d$export$10c90e4f7922046c(v);
}
function $f500ece5c74d6d3d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    var verb = function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    };
    var resume = function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    };
    var step = function step(r) {
        r.value instanceof $f500ece5c74d6d3d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    };
    var fulfill = function fulfill(value) {
        resume("next", value);
    };
    var reject = function reject(value) {
        resume("throw", value);
    };
    var settle = function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
}
function $f500ece5c74d6d3d$export$bbd80228419bb833(o) {
    var verb = function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f500ece5c74d6d3d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    };
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
}
function $f500ece5c74d6d3d$export$e3b29a3d6162315f(o) {
    var verb = function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    };
    var settle = function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    };
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f500ece5c74d6d3d$export$19a8beecd37a4c45 === "function" ? $f500ece5c74d6d3d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
}
function $f500ece5c74d6d3d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f500ece5c74d6d3d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f500ece5c74d6d3d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f500ece5c74d6d3d$export$45d3717a4c69092e(result, mod, k);
    }
    $f500ece5c74d6d3d$var$__setModuleDefault(result, mod);
    return result;
}
function $f500ece5c74d6d3d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f500ece5c74d6d3d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f500ece5c74d6d3d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f500ece5c74d6d3d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f500ece5c74d6d3d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f500ece5c74d6d3d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f500ece5c74d6d3d$export$8f076105dc360e92(env) {
    var fail = function fail(e) {
        env.error = env.hasError ? new $f500ece5c74d6d3d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    };
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f500ece5c74d6d3d$export$2e2bcd8739ae039 = {
    __extends: $f500ece5c74d6d3d$export$a8ba968b8961cb8a,
    __assign: $f500ece5c74d6d3d$export$18ce0697a983be9b,
    __rest: $f500ece5c74d6d3d$export$3c9a16f847548506,
    __decorate: $f500ece5c74d6d3d$export$29e00dfd3077644b,
    __param: $f500ece5c74d6d3d$export$d5ad3fd78186038f,
    __metadata: $f500ece5c74d6d3d$export$f1db080c865becb9,
    __awaiter: $f500ece5c74d6d3d$export$1050f835b63b671e,
    __generator: $f500ece5c74d6d3d$export$67ebef60e6f28a6,
    __createBinding: $f500ece5c74d6d3d$export$45d3717a4c69092e,
    __exportStar: $f500ece5c74d6d3d$export$f33643c0debef087,
    __values: $f500ece5c74d6d3d$export$19a8beecd37a4c45,
    __read: $f500ece5c74d6d3d$export$8d051b38c9118094,
    __spread: $f500ece5c74d6d3d$export$afc72e2116322959,
    __spreadArrays: $f500ece5c74d6d3d$export$6388937ca91ccae8,
    __spreadArray: $f500ece5c74d6d3d$export$1216008129fb82ed,
    __await: $f500ece5c74d6d3d$export$10c90e4f7922046c,
    __asyncGenerator: $f500ece5c74d6d3d$export$e427f37a30a4de9b,
    __asyncDelegator: $f500ece5c74d6d3d$export$bbd80228419bb833,
    __asyncValues: $f500ece5c74d6d3d$export$e3b29a3d6162315f,
    __makeTemplateObject: $f500ece5c74d6d3d$export$4fb47efe1390b86f,
    __importStar: $f500ece5c74d6d3d$export$c21735bcef00d192,
    __importDefault: $f500ece5c74d6d3d$export$da59b14a69baef04,
    __classPrivateFieldGet: $f500ece5c74d6d3d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f500ece5c74d6d3d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f500ece5c74d6d3d$export$81fdc39f203e4e04,
    __addDisposableResource: $f500ece5c74d6d3d$export$88ac25d8e944e405,
    __disposeResources: $f500ece5c74d6d3d$export$8f076105dc360e92
};


/*!
  * shared v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ /**
 * Original Utilities
 * written by kazuya kawaguchi
 */ 
var $l0HdX = parcelRequire("l0HdX");
var $66fbc42080b842e5$export$620a268685f0ac45 = typeof window !== "undefined";
var $66fbc42080b842e5$export$bf7f2fce5c1cf636;
var $66fbc42080b842e5$export$83602b44513dc228;
var $66fbc42080b842e5$var$tag, $66fbc42080b842e5$var$name, $66fbc42080b842e5$var$startTag, $66fbc42080b842e5$var$endTag;
var $66fbc42080b842e5$var$RE_ARGS = /\{([0-9a-zA-Z]+)\}/g;
/* eslint-disable */ function $66fbc42080b842e5$export$d9468344d3651243(message) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    if (args.length === 1 && $66fbc42080b842e5$export$a6cdc56e425d0d0a(args[0])) args = args[0];
    if (!args || !args.hasOwnProperty) args = {};
    return message.replace($66fbc42080b842e5$var$RE_ARGS, function(match, identifier) {
        return args.hasOwnProperty(identifier) ? args[identifier] : "";
    });
}
var $66fbc42080b842e5$var$hasSymbol = typeof Symbol === "function" && (0, $l0HdX._)(Symbol.toStringTag) === "symbol";
var $66fbc42080b842e5$export$cd133c5e04906ece = function(name) {
    return $66fbc42080b842e5$var$hasSymbol ? Symbol(name) : name;
};
var $66fbc42080b842e5$export$5024ef1f92c9a364 = function(locale, key, source) {
    return $66fbc42080b842e5$export$d704025436eaed65({
        l: locale,
        k: key,
        s: source
    });
};
var $66fbc42080b842e5$export$d704025436eaed65 = function(json) {
    return JSON.stringify(json).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027");
};
var $66fbc42080b842e5$export$7e4aa119212bc614 = function(val) {
    return typeof val === "number" && isFinite(val);
};
var $66fbc42080b842e5$export$871608497c498473 = function(val) {
    return $66fbc42080b842e5$export$1dccc787cc36538b(val) === "[object Date]";
};
var $66fbc42080b842e5$export$49841c62b9eff15 = function(val) {
    return $66fbc42080b842e5$export$1dccc787cc36538b(val) === "[object RegExp]";
};
var $66fbc42080b842e5$export$83b788b1a3698c03 = function(val) {
    return $66fbc42080b842e5$export$53b83ca8eaab0383(val) && Object.keys(val).length === 0;
};
function $66fbc42080b842e5$export$c106dd0671a0fc2d(msg, err) {
    if (typeof console !== "undefined") {
        console.warn("[intlify] " + msg);
        /* istanbul ignore if */ if (err) console.warn(err.stack);
    }
}
var $66fbc42080b842e5$export$e6e34fd1f2686227 = Object.assign;
var $66fbc42080b842e5$var$_globalThis;
var $66fbc42080b842e5$export$ff5f2eeb11fc7e14 = function() {
    // prettier-ignore
    return $66fbc42080b842e5$var$_globalThis || ($66fbc42080b842e5$var$_globalThis = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {});
};
function $66fbc42080b842e5$export$4cf11838cdc2a8a8(rawText) {
    return rawText.replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;");
}
var $66fbc42080b842e5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $66fbc42080b842e5$export$b5a638e9b3fff9f3(obj, key) {
    return $66fbc42080b842e5$var$hasOwnProperty.call(obj, key);
}
/* eslint-enable */ /**
 * Useful Utilities By Evan you
 * Modified by kazuya kawaguchi
 * MIT License
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/index.ts
 * https://github.com/vuejs/vue-next/blob/master/packages/shared/src/codeframe.ts
 */ var $66fbc42080b842e5$export$43bee75e5e14138e = Array.isArray;
var $66fbc42080b842e5$export$f6e2535fb5126e54 = function(val) {
    return typeof val === "function";
};
var $66fbc42080b842e5$export$844ec244b1367d54 = function(val) {
    return typeof val === "string";
};
var $66fbc42080b842e5$export$f9ce7b637dfbe238 = function(val) {
    return typeof val === "boolean";
};
var $66fbc42080b842e5$export$a244864fd9645c7f = function(val) {
    return (typeof val === "undefined" ? "undefined" : (0, $l0HdX._)(val)) === "symbol";
};
var $66fbc42080b842e5$export$a6cdc56e425d0d0a = function(val) {
    return val !== null && typeof val === "object";
};
var $66fbc42080b842e5$export$4369c812aac99591 = function(val) {
    return $66fbc42080b842e5$export$a6cdc56e425d0d0a(val) && $66fbc42080b842e5$export$f6e2535fb5126e54(val.then) && $66fbc42080b842e5$export$f6e2535fb5126e54(val.catch);
};
var $66fbc42080b842e5$export$830c053460e5ddf6 = Object.prototype.toString;
var $66fbc42080b842e5$export$1dccc787cc36538b = function(value) {
    return $66fbc42080b842e5$export$830c053460e5ddf6.call(value);
};
var $66fbc42080b842e5$export$53b83ca8eaab0383 = function(val) {
    return $66fbc42080b842e5$export$1dccc787cc36538b(val) === "[object Object]";
};
// for converting list and named values to displayed strings.
var $66fbc42080b842e5$export$b5b1545233b45293 = function(val) {
    return val == null ? "" : $66fbc42080b842e5$export$43bee75e5e14138e(val) || $66fbc42080b842e5$export$53b83ca8eaab0383(val) && val.toString === $66fbc42080b842e5$export$830c053460e5ddf6 ? JSON.stringify(val, null, 2) : String(val);
};
var $66fbc42080b842e5$var$RANGE = 2;
function $66fbc42080b842e5$export$f9c0d8b6684a279b(source) {
    var start = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : source.length;
    var lines = source.split(/\r?\n/);
    var count = 0;
    var res = [];
    for(var i = 0; i < lines.length; i++){
        count += lines[i].length + 1;
        if (count >= start) {
            for(var j = i - $66fbc42080b842e5$var$RANGE; j <= i + $66fbc42080b842e5$var$RANGE || end > count; j++){
                if (j < 0 || j >= lines.length) continue;
                var line = j + 1;
                res.push("".concat(line).concat(" ".repeat(3 - String(line).length), "|  ").concat(lines[j]));
                var lineLength = lines[j].length;
                if (j === i) {
                    // push underline
                    var pad = start - (count - lineLength) + 1;
                    var length = Math.max(1, end > count ? lineLength - pad : end - start);
                    res.push("   |  " + " ".repeat(pad) + "^".repeat(length));
                } else if (j > i) {
                    if (end > count) {
                        var length1 = Math.max(Math.min(end - count, lineLength), 1);
                        res.push("   |  " + "^".repeat(length1));
                    }
                    count += lineLength + 1;
                }
            }
            break;
        }
    }
    return res.join("\n");
}
/**
 * Event emitter, forked from the below:
 * - original repository url: https://github.com/developit/mitt
 * - code url: https://github.com/developit/mitt/blob/master/src/index.ts
 * - author: Jason Miller (https://github.com/developit)
 * - license: MIT
 */ /**
 * Create a event emitter
 *
 * @returns An event emitter
 */ function $66fbc42080b842e5$export$6f5e8f34570e3ad1() {
    var events = new Map();
    var emitter = {
        events: events,
        on: function(event, handler) {
            var handlers = events.get(event);
            var added = handlers && handlers.push(handler);
            if (!added) events.set(event, [
                handler
            ]);
        },
        off: function(event, handler) {
            var handlers = events.get(event);
            if (handlers) handlers.splice(handlers.indexOf(handler) >>> 0, 1);
        },
        emit: function(event, payload) {
            (events.get(event) || []).slice().map(function(handler) {
                return handler(payload);
            });
            (events.get("*") || []).slice().map(function(handler) {
                return handler(event, payload);
            });
        }
    };
    return emitter;
}


/*!
  * core-base v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $3sHb8 = parcelRequire("3sHb8");

var $cv9Rk = parcelRequire("cv9Rk");

var $c6Xmf = parcelRequire("c6Xmf");

/*!
  * message-compiler v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $3sHb8 = parcelRequire("3sHb8");

var $584cbe1b1d0d168a$export$77436aae039469c4 = {
    // tokenizer error codes
    EXPECTED_TOKEN: 1,
    INVALID_TOKEN_IN_PLACEHOLDER: 2,
    UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
    UNKNOWN_ESCAPE_SEQUENCE: 4,
    INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
    UNBALANCED_CLOSING_BRACE: 6,
    UNTERMINATED_CLOSING_BRACE: 7,
    EMPTY_PLACEHOLDER: 8,
    NOT_ALLOW_NEST_PLACEHOLDER: 9,
    INVALID_LINKED_FORMAT: 10,
    // parser error codes
    MUST_HAVE_MESSAGES_IN_PLURAL: 11,
    UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
    UNEXPECTED_EMPTY_LINKED_KEY: 13,
    UNEXPECTED_LEXICAL_ANALYSIS: 14,
    // Special value for higher-order compilers to pick up the last code
    // to avoid collision of error codes. This should always be kept as the last
    // item.
    __EXTEND_POINT__: 15
};
var $584cbe1b1d0d168a$var$_obj;
/** @internal */ var $584cbe1b1d0d168a$export$d8bd0967cb58683 = ($584cbe1b1d0d168a$var$_obj = {}, // tokenizer error messages
(0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.EXPECTED_TOKEN, "Expected token: '{0}'"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, "Invalid token in placeholder: '{0}'"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, "Unterminated single quote in placeholder"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, "Unknown escape sequence: \\{0}"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, "Invalid unicode escape sequence: {0}"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, "Unbalanced closing brace"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, "Unterminated closing brace"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.EMPTY_PLACEHOLDER, "Empty placeholder"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, "Not allowed nest placeholder"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.INVALID_LINKED_FORMAT, "Invalid linked format"), // parser error messages
(0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, "Plural must have messages"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, "Unexpected empty linked modifier"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, "Unexpected empty linked key"), (0, $3sHb8._)($584cbe1b1d0d168a$var$_obj, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, "Unexpected lexical analysis in token: '{0}'"), $584cbe1b1d0d168a$var$_obj);
function $584cbe1b1d0d168a$export$21efa8bb37d5fecb(code, loc) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var domain = options.domain, messages = options.messages, args = options.args;
    var msg = code;
    var error = new SyntaxError(String(msg));
    error.code = code;
    if (loc) error.location = loc;
    error.domain = domain;
    return error;
}
/** @internal */ function $584cbe1b1d0d168a$export$ad0eb2c702f03471(error) {
    throw error;
}
var $584cbe1b1d0d168a$export$9ba8fa38cb18b1f3 = {
    start: {
        line: 1,
        column: 1,
        offset: 0
    },
    end: {
        line: 1,
        column: 1,
        offset: 0
    }
};
function $584cbe1b1d0d168a$export$edb4795983846c10(line, column, offset) {
    return {
        line: line,
        column: column,
        offset: offset
    };
}
function $584cbe1b1d0d168a$export$90c043f1c57770b8(start, end, source) {
    var loc = {
        start: start,
        end: end
    };
    if (source != null) loc.source = source;
    return loc;
}
var $584cbe1b1d0d168a$var$CHAR_SP = " ";
var $584cbe1b1d0d168a$var$CHAR_CR = "\r";
var $584cbe1b1d0d168a$var$CHAR_LF = "\n";
var $584cbe1b1d0d168a$var$CHAR_LS = String.fromCharCode(0x2028);
var $584cbe1b1d0d168a$var$CHAR_PS = String.fromCharCode(0x2029);
function $584cbe1b1d0d168a$var$createScanner(str) {
    var next = function next() {
        _peekOffset = 0;
        if (isLineEnd(_index)) {
            _line++;
            _column = 0;
        }
        if (isCRLF(_index)) _index++;
        _index++;
        _column++;
        return _buf[_index];
    };
    var peek = function peek() {
        if (isCRLF(_index + _peekOffset)) _peekOffset++;
        _peekOffset++;
        return _buf[_index + _peekOffset];
    };
    var reset = function reset() {
        _index = 0;
        _line = 1;
        _column = 1;
        _peekOffset = 0;
    };
    var resetPeek = function resetPeek() {
        var offset = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
        _peekOffset = offset;
    };
    var skipToPeek = function skipToPeek() {
        var target = _index + _peekOffset;
        // eslint-disable-next-line no-unmodified-loop-condition
        while(target !== _index)next();
        _peekOffset = 0;
    };
    var _buf = str;
    var _index = 0;
    var _line = 1;
    var _column = 1;
    var _peekOffset = 0;
    var isCRLF = function(index) {
        return _buf[index] === $584cbe1b1d0d168a$var$CHAR_CR && _buf[index + 1] === $584cbe1b1d0d168a$var$CHAR_LF;
    };
    var isLF = function(index) {
        return _buf[index] === $584cbe1b1d0d168a$var$CHAR_LF;
    };
    var isPS = function(index) {
        return _buf[index] === $584cbe1b1d0d168a$var$CHAR_PS;
    };
    var isLS = function(index) {
        return _buf[index] === $584cbe1b1d0d168a$var$CHAR_LS;
    };
    var isLineEnd = function(index) {
        return isCRLF(index) || isLF(index) || isPS(index) || isLS(index);
    };
    var index = function() {
        return _index;
    };
    var line = function() {
        return _line;
    };
    var column = function() {
        return _column;
    };
    var peekOffset = function() {
        return _peekOffset;
    };
    var charAt = function(offset) {
        return isCRLF(offset) || isPS(offset) || isLS(offset) ? $584cbe1b1d0d168a$var$CHAR_LF : _buf[offset];
    };
    var currentChar = function() {
        return charAt(_index);
    };
    var currentPeek = function() {
        return charAt(_index + _peekOffset);
    };
    return {
        index: index,
        line: line,
        column: column,
        peekOffset: peekOffset,
        charAt: charAt,
        currentChar: currentChar,
        currentPeek: currentPeek,
        next: next,
        peek: peek,
        reset: reset,
        resetPeek: resetPeek,
        skipToPeek: skipToPeek
    };
}
var $584cbe1b1d0d168a$var$EOF = undefined;
var $584cbe1b1d0d168a$var$LITERAL_DELIMITER = "'";
var $584cbe1b1d0d168a$var$ERROR_DOMAIN$1 = "tokenizer";
function $584cbe1b1d0d168a$var$createTokenizer(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var emitError = function emitError(code, pos, offset) {
        for(var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++){
            args[_key - 3] = arguments[_key];
        }
        var ctx = context();
        pos.column += offset;
        pos.offset += offset;
        if (onError) {
            var loc = $584cbe1b1d0d168a$export$90c043f1c57770b8(ctx.startLoc, pos);
            var err = $584cbe1b1d0d168a$export$21efa8bb37d5fecb(code, loc, {
                domain: $584cbe1b1d0d168a$var$ERROR_DOMAIN$1,
                args: args
            });
            onError(err);
        }
    };
    var getToken = function getToken(context, type, value) {
        context.endLoc = currentPosition();
        context.currentType = type;
        var token = {
            type: type
        };
        if (location) token.loc = $584cbe1b1d0d168a$export$90c043f1c57770b8(context.startLoc, context.endLoc);
        if (value != null) token.value = value;
        return token;
    };
    var eat = function eat(scnr, ch) {
        if (scnr.currentChar() === ch) {
            scnr.next();
            return ch;
        } else {
            emitError($584cbe1b1d0d168a$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
            return "";
        }
    };
    var peekSpaces = function peekSpaces(scnr) {
        var buf = "";
        while(scnr.currentPeek() === $584cbe1b1d0d168a$var$CHAR_SP || scnr.currentPeek() === $584cbe1b1d0d168a$var$CHAR_LF){
            buf += scnr.currentPeek();
            scnr.peek();
        }
        return buf;
    };
    var skipSpaces = function skipSpaces(scnr) {
        var buf = peekSpaces(scnr);
        scnr.skipToPeek();
        return buf;
    };
    var isIdentifierStart = function isIdentifierStart(ch) {
        if (ch === $584cbe1b1d0d168a$var$EOF) return false;
        var cc = ch.charCodeAt(0);
        return cc >= 97 && cc <= 122 || // a-z
        cc >= 65 && cc <= 90 || // A-Z
        cc === 95 // _
        ;
    };
    var isNumberStart = function isNumberStart(ch) {
        if (ch === $584cbe1b1d0d168a$var$EOF) return false;
        var cc = ch.charCodeAt(0);
        return cc >= 48 && cc <= 57; // 0-9
    };
    var isNamedIdentifierStart = function isNamedIdentifierStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        var ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    };
    var isListIdentifierStart = function isListIdentifierStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        var ch = scnr.currentPeek() === "-" ? scnr.peek() : scnr.currentPeek();
        var ret = isNumberStart(ch);
        scnr.resetPeek();
        return ret;
    };
    var isLiteralStart = function isLiteralStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 2 /* BraceLeft */ ) return false;
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === $584cbe1b1d0d168a$var$LITERAL_DELIMITER;
        scnr.resetPeek();
        return ret;
    };
    var isLinkedDotStart = function isLinkedDotStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 8 /* LinkedAlias */ ) return false;
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === "." /* LinkedDot */ ;
        scnr.resetPeek();
        return ret;
    };
    var isLinkedModifierStart = function isLinkedModifierStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 9 /* LinkedDot */ ) return false;
        peekSpaces(scnr);
        var ret = isIdentifierStart(scnr.currentPeek());
        scnr.resetPeek();
        return ret;
    };
    var isLinkedDelimiterStart = function isLinkedDelimiterStart(scnr, context) {
        var currentType = context.currentType;
        if (!(currentType === 8 /* LinkedAlias */  || currentType === 12 /* LinkedModifier */ )) return false;
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === ":" /* LinkedDelimiter */ ;
        scnr.resetPeek();
        return ret;
    };
    var isLinkedReferStart = function isLinkedReferStart(scnr, context) {
        var currentType = context.currentType;
        if (currentType !== 10 /* LinkedDelimiter */ ) return false;
        var fn = function() {
            var ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */ ) return isIdentifierStart(scnr.peek());
            else if (ch === "@" /* LinkedAlias */  || ch === "%" /* Modulo */  || ch === "|" /* Pipe */  || ch === ":" /* LinkedDelimiter */  || ch === "." /* LinkedDot */  || ch === $584cbe1b1d0d168a$var$CHAR_SP || !ch) return false;
            else if (ch === $584cbe1b1d0d168a$var$CHAR_LF) {
                scnr.peek();
                return fn();
            } else // other characters
            return isIdentifierStart(ch);
        };
        var ret = fn();
        scnr.resetPeek();
        return ret;
    };
    var isPluralStart = function isPluralStart(scnr) {
        peekSpaces(scnr);
        var ret = scnr.currentPeek() === "|" /* Pipe */ ;
        scnr.resetPeek();
        return ret;
    };
    var detectModuloStart = function detectModuloStart(scnr) {
        var spaces = peekSpaces(scnr);
        var ret = scnr.currentPeek() === "%" /* Modulo */  && scnr.peek() === "{" /* BraceLeft */ ;
        scnr.resetPeek();
        return {
            isModulo: ret,
            hasSpace: spaces.length > 0
        };
    };
    var isTextStart = function isTextStart(scnr) {
        var reset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var fn = function() {
            var hasSpace = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, prev = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", detectModulo = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
            var ch = scnr.currentPeek();
            if (ch === "{" /* BraceLeft */ ) return prev === "%" /* Modulo */  ? false : hasSpace;
            else if (ch === "@" /* LinkedAlias */  || !ch) return prev === "%" /* Modulo */  ? true : hasSpace;
            else if (ch === "%" /* Modulo */ ) {
                scnr.peek();
                return fn(hasSpace, "%" /* Modulo */ , true);
            } else if (ch === "|" /* Pipe */ ) return prev === "%" /* Modulo */  || detectModulo ? true : !(prev === $584cbe1b1d0d168a$var$CHAR_SP || prev === $584cbe1b1d0d168a$var$CHAR_LF);
            else if (ch === $584cbe1b1d0d168a$var$CHAR_SP) {
                scnr.peek();
                return fn(true, $584cbe1b1d0d168a$var$CHAR_SP, detectModulo);
            } else if (ch === $584cbe1b1d0d168a$var$CHAR_LF) {
                scnr.peek();
                return fn(true, $584cbe1b1d0d168a$var$CHAR_LF, detectModulo);
            } else return true;
        };
        var ret = fn();
        reset && scnr.resetPeek();
        return ret;
    };
    var takeChar = function takeChar(scnr, fn) {
        var ch = scnr.currentChar();
        if (ch === $584cbe1b1d0d168a$var$EOF) return $584cbe1b1d0d168a$var$EOF;
        if (fn(ch)) {
            scnr.next();
            return ch;
        }
        return null;
    };
    var takeIdentifierChar = function takeIdentifierChar(scnr) {
        var closure = function(ch) {
            var cc = ch.charCodeAt(0);
            return cc >= 97 && cc <= 122 || // a-z
            cc >= 65 && cc <= 90 || // A-Z
            cc >= 48 && cc <= 57 || // 0-9
            cc === 95 || // _
            cc === 36 // $
            ;
        };
        return takeChar(scnr, closure);
    };
    var takeDigit = function takeDigit(scnr) {
        var closure = function(ch) {
            var cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57; // 0-9
        };
        return takeChar(scnr, closure);
    };
    var takeHexDigit = function takeHexDigit(scnr) {
        var closure = function(ch) {
            var cc = ch.charCodeAt(0);
            return cc >= 48 && cc <= 57 || // 0-9
            cc >= 65 && cc <= 70 || // A-F
            cc >= 97 && cc <= 102; // a-f
        };
        return takeChar(scnr, closure);
    };
    var getDigits = function getDigits(scnr) {
        var ch = "";
        var num = "";
        while(ch = takeDigit(scnr))num += ch;
        return num;
    };
    var readModulo = function readModulo(scnr) {
        skipSpaces(scnr);
        var ch = scnr.currentChar();
        if (ch !== "%" /* Modulo */ ) emitError($584cbe1b1d0d168a$export$77436aae039469c4.EXPECTED_TOKEN, currentPosition(), 0, ch);
        scnr.next();
        return "%" /* Modulo */ ;
    };
    var readText = function readText(scnr) {
        var buf = "";
        while(true){
            var ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */  || ch === "}" /* BraceRight */  || ch === "@" /* LinkedAlias */  || ch === "|" /* Pipe */  || !ch) break;
            else if (ch === "%" /* Modulo */ ) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else break;
            } else if (ch === $584cbe1b1d0d168a$var$CHAR_SP || ch === $584cbe1b1d0d168a$var$CHAR_LF) {
                if (isTextStart(scnr)) {
                    buf += ch;
                    scnr.next();
                } else if (isPluralStart(scnr)) break;
                else {
                    buf += ch;
                    scnr.next();
                }
            } else {
                buf += ch;
                scnr.next();
            }
        }
        return buf;
    };
    var readNamedIdentifier = function readNamedIdentifier(scnr) {
        skipSpaces(scnr);
        var ch = "";
        var name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        if (scnr.currentChar() === $584cbe1b1d0d168a$var$EOF) emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return name;
    };
    var readListIdentifier = function readListIdentifier(scnr) {
        skipSpaces(scnr);
        var value = "";
        if (scnr.currentChar() === "-") {
            scnr.next();
            value += "-".concat(getDigits(scnr));
        } else value += getDigits(scnr);
        if (scnr.currentChar() === $584cbe1b1d0d168a$var$EOF) emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
        return value;
    };
    var readLiteral = function readLiteral(scnr) {
        skipSpaces(scnr);
        eat(scnr, "'");
        var ch = "";
        var literal = "";
        var fn = function(x) {
            return x !== $584cbe1b1d0d168a$var$LITERAL_DELIMITER && x !== $584cbe1b1d0d168a$var$CHAR_LF;
        };
        while(ch = takeChar(scnr, fn))if (ch === "\\") literal += readEscapeSequence(scnr);
        else literal += ch;
        var current = scnr.currentChar();
        if (current === $584cbe1b1d0d168a$var$CHAR_LF || current === $584cbe1b1d0d168a$var$EOF) {
            emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, currentPosition(), 0);
            // TODO: Is it correct really?
            if (current === $584cbe1b1d0d168a$var$CHAR_LF) {
                scnr.next();
                eat(scnr, "'");
            }
            return literal;
        }
        eat(scnr, "'");
        return literal;
    };
    var readEscapeSequence = function readEscapeSequence(scnr) {
        var ch = scnr.currentChar();
        switch(ch){
            case "\\":
            case "'":
                scnr.next();
                return "\\".concat(ch);
            case "u":
                return readUnicodeEscapeSequence(scnr, ch, 4);
            case "U":
                return readUnicodeEscapeSequence(scnr, ch, 6);
            default:
                emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNKNOWN_ESCAPE_SEQUENCE, currentPosition(), 0, ch);
                return "";
        }
    };
    var readUnicodeEscapeSequence = function readUnicodeEscapeSequence(scnr, unicode, digits) {
        eat(scnr, unicode);
        var sequence = "";
        for(var i = 0; i < digits; i++){
            var ch = takeHexDigit(scnr);
            if (!ch) {
                emitError($584cbe1b1d0d168a$export$77436aae039469c4.INVALID_UNICODE_ESCAPE_SEQUENCE, currentPosition(), 0, "\\".concat(unicode).concat(sequence).concat(scnr.currentChar()));
                break;
            }
            sequence += ch;
        }
        return "\\".concat(unicode).concat(sequence);
    };
    var readInvalidIdentifier = function readInvalidIdentifier(scnr) {
        skipSpaces(scnr);
        var ch = "";
        var identifiers = "";
        var closure = function(ch) {
            return ch !== "{" /* BraceLeft */  && ch !== "}" /* BraceRight */  && ch !== $584cbe1b1d0d168a$var$CHAR_SP && ch !== $584cbe1b1d0d168a$var$CHAR_LF;
        };
        while(ch = takeChar(scnr, closure))identifiers += ch;
        return identifiers;
    };
    var readLinkedModifier = function readLinkedModifier(scnr) {
        var ch = "";
        var name = "";
        while(ch = takeIdentifierChar(scnr))name += ch;
        return name;
    };
    var readLinkedRefer = function readLinkedRefer(scnr) {
        var fn = function() {
            var detect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, buf = arguments.length > 1 ? arguments[1] : void 0;
            var ch = scnr.currentChar();
            if (ch === "{" /* BraceLeft */  || ch === "%" /* Modulo */  || ch === "@" /* LinkedAlias */  || ch === "|" /* Pipe */  || !ch) return buf;
            else if (ch === $584cbe1b1d0d168a$var$CHAR_SP) return buf;
            else if (ch === $584cbe1b1d0d168a$var$CHAR_LF) {
                buf += ch;
                scnr.next();
                return fn(detect, buf);
            } else {
                buf += ch;
                scnr.next();
                return fn(true, buf);
            }
        };
        return fn(false, "");
    };
    var readPlural = function readPlural(scnr) {
        skipSpaces(scnr);
        var plural = eat(scnr, "|" /* Pipe */ );
        skipSpaces(scnr);
        return plural;
    };
    var readTokenInPlaceholder = // TODO: We need refactoring of token parsing ...
    function readTokenInPlaceholder(scnr, context) {
        var token = null;
        var ch = scnr.currentChar();
        switch(ch){
            case "{" /* BraceLeft */ :
                if (context.braceNest >= 1) emitError($584cbe1b1d0d168a$export$77436aae039469c4.NOT_ALLOW_NEST_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 2 /* BraceLeft */ , "{" /* BraceLeft */ );
                skipSpaces(scnr);
                context.braceNest++;
                return token;
            case "}" /* BraceRight */ :
                if (context.braceNest > 0 && context.currentType === 2 /* BraceLeft */ ) emitError($584cbe1b1d0d168a$export$77436aae039469c4.EMPTY_PLACEHOLDER, currentPosition(), 0);
                scnr.next();
                token = getToken(context, 3 /* BraceRight */ , "}" /* BraceRight */ );
                context.braceNest--;
                context.braceNest > 0 && skipSpaces(scnr);
                if (context.inLinked && context.braceNest === 0) context.inLinked = false;
                return token;
            case "@" /* LinkedAlias */ :
                if (context.braceNest > 0) emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                token = readTokenInLinked(scnr, context) || getEndToken(context);
                context.braceNest = 0;
                return token;
            default:
                var validNamedIdentifier = true;
                var validListIdentifier = true;
                var validLiteral = true;
                if (isPluralStart(scnr)) {
                    if (context.braceNest > 0) emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (context.braceNest > 0 && (context.currentType === 5 /* Named */  || context.currentType === 6 /* List */  || context.currentType === 7 /* Literal */ )) {
                    emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNTERMINATED_CLOSING_BRACE, currentPosition(), 0);
                    context.braceNest = 0;
                    return readToken(scnr, context);
                }
                if (validNamedIdentifier = isNamedIdentifierStart(scnr, context)) {
                    token = getToken(context, 5 /* Named */ , readNamedIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (validListIdentifier = isListIdentifierStart(scnr, context)) {
                    token = getToken(context, 6 /* List */ , readListIdentifier(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (validLiteral = isLiteralStart(scnr, context)) {
                    token = getToken(context, 7 /* Literal */ , readLiteral(scnr));
                    skipSpaces(scnr);
                    return token;
                }
                if (!validNamedIdentifier && !validListIdentifier && !validLiteral) {
                    // TODO: we should be re-designed invalid cases, when we will extend message syntax near the future ...
                    token = getToken(context, 13 /* InvalidPlace */ , readInvalidIdentifier(scnr));
                    emitError($584cbe1b1d0d168a$export$77436aae039469c4.INVALID_TOKEN_IN_PLACEHOLDER, currentPosition(), 0, token.value);
                    skipSpaces(scnr);
                    return token;
                }
                break;
        }
        return token;
    };
    var readToken = // TODO: We need refactoring of token parsing ...
    function readToken(scnr, context) {
        var token = {
            type: 14 /* EOF */ 
        };
        if (context.braceNest > 0) return readTokenInPlaceholder(scnr, context) || getEndToken(context);
        if (context.inLinked) return readTokenInLinked(scnr, context) || getEndToken(context);
        var ch = scnr.currentChar();
        switch(ch){
            case "{" /* BraceLeft */ :
                return readTokenInPlaceholder(scnr, context) || getEndToken(context);
            case "}" /* BraceRight */ :
                emitError($584cbe1b1d0d168a$export$77436aae039469c4.UNBALANCED_CLOSING_BRACE, currentPosition(), 0);
                scnr.next();
                return getToken(context, 3 /* BraceRight */ , "}" /* BraceRight */ );
            case "@" /* LinkedAlias */ :
                return readTokenInLinked(scnr, context) || getEndToken(context);
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                var _detectModuloStart = detectModuloStart(scnr), isModulo = _detectModuloStart.isModulo, hasSpace = _detectModuloStart.hasSpace;
                if (isModulo) return hasSpace ? getToken(context, 0 /* Text */ , readText(scnr)) : getToken(context, 4 /* Modulo */ , readModulo(scnr));
                if (isTextStart(scnr)) return getToken(context, 0 /* Text */ , readText(scnr));
                break;
        }
        return token;
    };
    var nextToken = function nextToken() {
        var currentType = _context.currentType, offset = _context.offset, startLoc = _context.startLoc, endLoc = _context.endLoc;
        _context.lastType = currentType;
        _context.lastOffset = offset;
        _context.lastStartLoc = startLoc;
        _context.lastEndLoc = endLoc;
        _context.offset = currentOffset();
        _context.startLoc = currentPosition();
        if (_scnr.currentChar() === $584cbe1b1d0d168a$var$EOF) return getToken(_context, 14 /* EOF */ );
        return readToken(_scnr, _context);
    };
    var location = options.location !== false;
    var _scnr = $584cbe1b1d0d168a$var$createScanner(source);
    var currentOffset = function() {
        return _scnr.index();
    };
    var currentPosition = function() {
        return $584cbe1b1d0d168a$export$edb4795983846c10(_scnr.line(), _scnr.column(), _scnr.index());
    };
    var _initLoc = currentPosition();
    var _initOffset = currentOffset();
    var _context = {
        currentType: 14 /* EOF */ ,
        offset: _initOffset,
        startLoc: _initLoc,
        endLoc: _initLoc,
        lastType: 14 /* EOF */ ,
        lastOffset: _initOffset,
        lastStartLoc: _initLoc,
        lastEndLoc: _initLoc,
        braceNest: 0,
        inLinked: false,
        text: ""
    };
    var context = function() {
        return _context;
    };
    var onError = options.onError;
    var getEndToken = function(context) {
        return getToken(context, 14 /* EOF */ );
    };
    // TODO: We need refactoring of token parsing ...
    function readTokenInLinked(scnr, context) {
        var currentType = context.currentType;
        var token = null;
        var ch = scnr.currentChar();
        if ((currentType === 8 /* LinkedAlias */  || currentType === 9 /* LinkedDot */  || currentType === 12 /* LinkedModifier */  || currentType === 10 /* LinkedDelimiter */ ) && (ch === $584cbe1b1d0d168a$var$CHAR_LF || ch === $584cbe1b1d0d168a$var$CHAR_SP)) emitError($584cbe1b1d0d168a$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
        switch(ch){
            case "@" /* LinkedAlias */ :
                scnr.next();
                token = getToken(context, 8 /* LinkedAlias */ , "@" /* LinkedAlias */ );
                context.inLinked = true;
                return token;
            case "." /* LinkedDot */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 9 /* LinkedDot */ , "." /* LinkedDot */ );
            case ":" /* LinkedDelimiter */ :
                skipSpaces(scnr);
                scnr.next();
                return getToken(context, 10 /* LinkedDelimiter */ , ":" /* LinkedDelimiter */ );
            default:
                if (isPluralStart(scnr)) {
                    token = getToken(context, 1 /* Pipe */ , readPlural(scnr));
                    // reset
                    context.braceNest = 0;
                    context.inLinked = false;
                    return token;
                }
                if (isLinkedDotStart(scnr, context) || isLinkedDelimiterStart(scnr, context)) {
                    skipSpaces(scnr);
                    return readTokenInLinked(scnr, context);
                }
                if (isLinkedModifierStart(scnr, context)) {
                    skipSpaces(scnr);
                    return getToken(context, 12 /* LinkedModifier */ , readLinkedModifier(scnr));
                }
                if (isLinkedReferStart(scnr, context)) {
                    skipSpaces(scnr);
                    if (ch === "{" /* BraceLeft */ ) // scan the placeholder
                    return readTokenInPlaceholder(scnr, context) || token;
                    else return getToken(context, 11 /* LinkedKey */ , readLinkedRefer(scnr));
                }
                if (currentType === 8 /* LinkedAlias */ ) emitError($584cbe1b1d0d168a$export$77436aae039469c4.INVALID_LINKED_FORMAT, currentPosition(), 0);
                context.braceNest = 0;
                context.inLinked = false;
                return readToken(scnr, context);
        }
    }
    return {
        nextToken: nextToken,
        currentOffset: currentOffset,
        currentPosition: currentPosition,
        context: context
    };
}
var $584cbe1b1d0d168a$export$9838302824baa7fa = "parser";
// Backslash backslash, backslash quote, uHHHH, UHHHHHH.
var $584cbe1b1d0d168a$var$KNOWN_ESCAPES = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g;
function $584cbe1b1d0d168a$var$fromEscapeSequence(match, codePoint4, codePoint6) {
    switch(match){
        case "\\\\":
            return "\\";
        case "\\'":
            return "'";
        default:
            {
                var codePoint = parseInt(codePoint4 || codePoint6, 16);
                if (codePoint <= 0xd7ff || codePoint >= 0xe000) return String.fromCodePoint(codePoint);
                // invalid ...
                // Replace them with U+FFFD REPLACEMENT CHARACTER.
                return "�";
            }
    }
}
function $584cbe1b1d0d168a$export$88a1156fad04455f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var emitError = function emitError(tokenzer, code, start, offset) {
        for(var _len = arguments.length, args = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++){
            args[_key - 4] = arguments[_key];
        }
        var end = tokenzer.currentPosition();
        end.offset += offset;
        end.column += offset;
        if (onError) {
            var loc = $584cbe1b1d0d168a$export$90c043f1c57770b8(start, end);
            var err = $584cbe1b1d0d168a$export$21efa8bb37d5fecb(code, loc, {
                domain: $584cbe1b1d0d168a$export$9838302824baa7fa,
                args: args
            });
            onError(err);
        }
    };
    var startNode = function startNode(type, offset, loc) {
        var node = {
            type: type,
            start: offset,
            end: offset
        };
        if (location) node.loc = {
            start: loc,
            end: loc
        };
        return node;
    };
    var endNode = function endNode(node, offset, pos, type) {
        node.end = offset;
        if (type) node.type = type;
        if (location && node.loc) node.loc.end = pos;
    };
    var parseText = function parseText(tokenizer, value) {
        var context = tokenizer.context();
        var node = startNode(3 /* Text */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    };
    var parseList = function parseList(tokenizer, index) {
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get brace left loc
        var node = startNode(5 /* List */ , offset, loc);
        node.index = parseInt(index, 10);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    };
    var parseNamed = function parseNamed(tokenizer, key) {
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get brace left loc
        var node = startNode(4 /* Named */ , offset, loc);
        node.key = key;
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    };
    var parseLiteral = function parseLiteral(tokenizer, value) {
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get brace left loc
        var node = startNode(9 /* Literal */ , offset, loc);
        node.value = value.replace($584cbe1b1d0d168a$var$KNOWN_ESCAPES, $584cbe1b1d0d168a$var$fromEscapeSequence);
        tokenizer.nextToken(); // skip brach right
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    };
    var parseLinkedModifier = function parseLinkedModifier(tokenizer) {
        var token = tokenizer.nextToken();
        var context = tokenizer.context();
        var offset = context.lastOffset, loc = context.lastStartLoc; // get linked dot loc
        var node = startNode(8 /* LinkedModifier */ , offset, loc);
        if (token.type !== 12 /* LinkedModifier */ ) {
            // empty modifier
            emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_MODIFIER, context.lastStartLoc, 0);
            node.value = "";
            endNode(node, offset, loc);
            return {
                nextConsumeToken: token,
                node: node
            };
        }
        // check token
        if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
        node.value = token.value || "";
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: node
        };
    };
    var parseLinkedKey = function parseLinkedKey(tokenizer, value) {
        var context = tokenizer.context();
        var node = startNode(7 /* LinkedKey */ , context.offset, context.startLoc);
        node.value = value;
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    };
    var parseLinked = function parseLinked(tokenizer) {
        var context = tokenizer.context();
        var linkedNode = startNode(6 /* Linked */ , context.offset, context.startLoc);
        var token = tokenizer.nextToken();
        if (token.type === 9 /* LinkedDot */ ) {
            var parsed = parseLinkedModifier(tokenizer);
            linkedNode.modifier = parsed.node;
            token = parsed.nextConsumeToken || tokenizer.nextToken();
        }
        // asset check token
        if (token.type !== 10 /* LinkedDelimiter */ ) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
        token = tokenizer.nextToken();
        // skip brace left
        if (token.type === 2 /* BraceLeft */ ) token = tokenizer.nextToken();
        switch(token.type){
            case 11 /* LinkedKey */ :
                if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                linkedNode.key = parseLinkedKey(tokenizer, token.value || "");
                break;
            case 5 /* Named */ :
                if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                linkedNode.key = parseNamed(tokenizer, token.value || "");
                break;
            case 6 /* List */ :
                if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                linkedNode.key = parseList(tokenizer, token.value || "");
                break;
            case 7 /* Literal */ :
                if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                linkedNode.key = parseLiteral(tokenizer, token.value || "");
                break;
            default:
                // empty key
                emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_EMPTY_LINKED_KEY, context.lastStartLoc, 0);
                var nextContext = tokenizer.context();
                var emptyLinkedKeyNode = startNode(7 /* LinkedKey */ , nextContext.offset, nextContext.startLoc);
                emptyLinkedKeyNode.value = "";
                endNode(emptyLinkedKeyNode, nextContext.offset, nextContext.startLoc);
                linkedNode.key = emptyLinkedKeyNode;
                endNode(linkedNode, nextContext.offset, nextContext.startLoc);
                return {
                    nextConsumeToken: token,
                    node: linkedNode
                };
        }
        endNode(linkedNode, tokenizer.currentOffset(), tokenizer.currentPosition());
        return {
            node: linkedNode
        };
    };
    var parseMessage = function parseMessage(tokenizer) {
        var context = tokenizer.context();
        var startOffset = context.currentType === 1 /* Pipe */  ? tokenizer.currentOffset() : context.offset;
        var startLoc = context.currentType === 1 /* Pipe */  ? context.endLoc : context.startLoc;
        var node = startNode(2 /* Message */ , startOffset, startLoc);
        node.items = [];
        var nextToken = null;
        do {
            var token = nextToken || tokenizer.nextToken();
            nextToken = null;
            switch(token.type){
                case 0 /* Text */ :
                    if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                    node.items.push(parseText(tokenizer, token.value || ""));
                    break;
                case 6 /* List */ :
                    if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                    node.items.push(parseList(tokenizer, token.value || ""));
                    break;
                case 5 /* Named */ :
                    if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                    node.items.push(parseNamed(tokenizer, token.value || ""));
                    break;
                case 7 /* Literal */ :
                    if (token.value == null) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, $584cbe1b1d0d168a$var$getTokenCaption(token));
                    node.items.push(parseLiteral(tokenizer, token.value || ""));
                    break;
                case 8 /* LinkedAlias */ :
                    var parsed = parseLinked(tokenizer);
                    node.items.push(parsed.node);
                    nextToken = parsed.nextConsumeToken || null;
                    break;
            }
        }while (context.currentType !== 14 /* EOF */  && context.currentType !== 1 /* Pipe */ );
        // adjust message node loc
        var endOffset = context.currentType === 1 /* Pipe */  ? context.lastOffset : tokenizer.currentOffset();
        var endLoc = context.currentType === 1 /* Pipe */  ? context.lastEndLoc : tokenizer.currentPosition();
        endNode(node, endOffset, endLoc);
        return node;
    };
    var parsePlural = function parsePlural(tokenizer, offset, loc, msgNode) {
        var context = tokenizer.context();
        var hasEmptyMessage = msgNode.items.length === 0;
        var node = startNode(1 /* Plural */ , offset, loc);
        node.cases = [];
        node.cases.push(msgNode);
        do {
            var msg = parseMessage(tokenizer);
            if (!hasEmptyMessage) hasEmptyMessage = msg.items.length === 0;
            node.cases.push(msg);
        }while (context.currentType !== 14 /* EOF */ );
        if (hasEmptyMessage) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.MUST_HAVE_MESSAGES_IN_PLURAL, loc, 0);
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    };
    var parseResource = function parseResource(tokenizer) {
        var context = tokenizer.context();
        var offset = context.offset, startLoc = context.startLoc;
        var msgNode = parseMessage(tokenizer);
        if (context.currentType === 14 /* EOF */ ) return msgNode;
        else return parsePlural(tokenizer, offset, startLoc, msgNode);
    };
    var parse = function parse(source) {
        var tokenizer = $584cbe1b1d0d168a$var$createTokenizer(source, (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, options));
        var context = tokenizer.context();
        var node = startNode(0 /* Resource */ , context.offset, context.startLoc);
        if (location && node.loc) node.loc.source = source;
        node.body = parseResource(tokenizer);
        // assert whether achieved to EOF
        if (context.currentType !== 14 /* EOF */ ) emitError(tokenizer, $584cbe1b1d0d168a$export$77436aae039469c4.UNEXPECTED_LEXICAL_ANALYSIS, context.lastStartLoc, 0, source[context.offset] || "");
        endNode(node, tokenizer.currentOffset(), tokenizer.currentPosition());
        return node;
    };
    var location = options.location !== false;
    var onError = options.onError;
    return {
        parse: parse
    };
}
function $584cbe1b1d0d168a$var$getTokenCaption(token) {
    if (token.type === 14 /* EOF */ ) return "EOF";
    var name = (token.value || "").replace(RegExp("\\r?\\n", "gu"), "\\n");
    return name.length > 10 ? name.slice(0, 9) + "…" : name;
}
function $584cbe1b1d0d168a$var$createTransformer(ast) {
    var options = arguments.length > 1 && arguments[1] !== void 0 // eslint-disable-line
     ? arguments[1] : {};
    var _context = {
        ast: ast,
        helpers: new Set()
    };
    var context = function() {
        return _context;
    };
    var helper = function(name) {
        _context.helpers.add(name);
        return name;
    };
    return {
        context: context,
        helper: helper
    };
}
function $584cbe1b1d0d168a$var$traverseNodes(nodes, transformer) {
    for(var i = 0; i < nodes.length; i++)$584cbe1b1d0d168a$var$traverseNode(nodes[i], transformer);
}
function $584cbe1b1d0d168a$var$traverseNode(node, transformer) {
    // TODO: if we need pre-hook of transform, should be implemented to here
    switch(node.type){
        case 1 /* Plural */ :
            $584cbe1b1d0d168a$var$traverseNodes(node.cases, transformer);
            transformer.helper("plural" /* PLURAL */ );
            break;
        case 2 /* Message */ :
            $584cbe1b1d0d168a$var$traverseNodes(node.items, transformer);
            break;
        case 6 /* Linked */ :
            var linked = node;
            $584cbe1b1d0d168a$var$traverseNode(linked.key, transformer);
            transformer.helper("linked" /* LINKED */ );
            transformer.helper("type" /* TYPE */ );
            break;
        case 5 /* List */ :
            transformer.helper("interpolate" /* INTERPOLATE */ );
            transformer.helper("list" /* LIST */ );
            break;
        case 4 /* Named */ :
            transformer.helper("interpolate" /* INTERPOLATE */ );
            transformer.helper("named" /* NAMED */ );
            break;
    }
// TODO: if we need post-hook of transform, should be implemented to here
}
// transform AST
function $584cbe1b1d0d168a$var$transform(ast) {
    var options = arguments.length > 1 && arguments[1] !== void 0 // eslint-disable-line
     ? arguments[1] : {};
    var transformer = $584cbe1b1d0d168a$var$createTransformer(ast);
    transformer.helper("normalize" /* NORMALIZE */ );
    // traverse
    ast.body && $584cbe1b1d0d168a$var$traverseNode(ast.body, transformer);
    // set meta information
    var context = transformer.context();
    ast.helpers = Array.from(context.helpers);
}
function $584cbe1b1d0d168a$var$createCodeGenerator(ast, options) {
    var push = function push(code, node) {
        _context.code += code;
    };
    var _newline = function _newline(n) {
        var withBreakLine = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
        var _breakLineCode = withBreakLine ? breakLineCode : "";
        push(_needIndent ? _breakLineCode + "  ".repeat(n) : _breakLineCode);
    };
    var indent = function indent() {
        var withNewLine = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var level = ++_context.indentLevel;
        withNewLine && _newline(level);
    };
    var deindent = function deindent() {
        var withNewLine = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        var level = --_context.indentLevel;
        withNewLine && _newline(level);
    };
    var newline = function newline() {
        _newline(_context.indentLevel);
    };
    var sourceMap = options.sourceMap, filename = options.filename, breakLineCode = options.breakLineCode, _needIndent = options.needIndent;
    var _context = {
        source: ast.loc.source,
        filename: filename,
        code: "",
        column: 1,
        line: 1,
        offset: 0,
        map: undefined,
        breakLineCode: breakLineCode,
        needIndent: _needIndent,
        indentLevel: 0
    };
    var context = function() {
        return _context;
    };
    var helper = function(key) {
        return "_".concat(key);
    };
    var needIndent = function() {
        return _context.needIndent;
    };
    return {
        context: context,
        push: push,
        indent: indent,
        deindent: deindent,
        newline: newline,
        helper: helper,
        needIndent: needIndent
    };
}
function $584cbe1b1d0d168a$var$generateLinkedNode(generator, node) {
    var helper = generator.helper;
    generator.push("".concat(helper("linked" /* LINKED */ ), "("));
    $584cbe1b1d0d168a$var$generateNode(generator, node.key);
    if (node.modifier) {
        generator.push(", ");
        $584cbe1b1d0d168a$var$generateNode(generator, node.modifier);
        generator.push(", _type");
    } else generator.push(", undefined, _type");
    generator.push(")");
}
function $584cbe1b1d0d168a$var$generateMessageNode(generator, node) {
    var helper = generator.helper, needIndent = generator.needIndent;
    generator.push("".concat(helper("normalize" /* NORMALIZE */ ), "(["));
    generator.indent(needIndent());
    var length = node.items.length;
    for(var i = 0; i < length; i++){
        $584cbe1b1d0d168a$var$generateNode(generator, node.items[i]);
        if (i === length - 1) break;
        generator.push(", ");
    }
    generator.deindent(needIndent());
    generator.push("])");
}
function $584cbe1b1d0d168a$var$generatePluralNode(generator, node) {
    var helper = generator.helper, needIndent = generator.needIndent;
    if (node.cases.length > 1) {
        generator.push("".concat(helper("plural" /* PLURAL */ ), "(["));
        generator.indent(needIndent());
        var length = node.cases.length;
        for(var i = 0; i < length; i++){
            $584cbe1b1d0d168a$var$generateNode(generator, node.cases[i]);
            if (i === length - 1) break;
            generator.push(", ");
        }
        generator.deindent(needIndent());
        generator.push("])");
    }
}
function $584cbe1b1d0d168a$var$generateResource(generator, node) {
    if (node.body) $584cbe1b1d0d168a$var$generateNode(generator, node.body);
    else generator.push("null");
}
function $584cbe1b1d0d168a$var$generateNode(generator, node) {
    var helper = generator.helper;
    switch(node.type){
        case 0 /* Resource */ :
            $584cbe1b1d0d168a$var$generateResource(generator, node);
            break;
        case 1 /* Plural */ :
            $584cbe1b1d0d168a$var$generatePluralNode(generator, node);
            break;
        case 2 /* Message */ :
            $584cbe1b1d0d168a$var$generateMessageNode(generator, node);
            break;
        case 6 /* Linked */ :
            $584cbe1b1d0d168a$var$generateLinkedNode(generator, node);
            break;
        case 8 /* LinkedModifier */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 7 /* LinkedKey */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 5 /* List */ :
            generator.push("".concat(helper("interpolate" /* INTERPOLATE */ ), "(").concat(helper("list" /* LIST */ ), "(").concat(node.index, "))"), node);
            break;
        case 4 /* Named */ :
            generator.push("".concat(helper("interpolate" /* INTERPOLATE */ ), "(").concat(helper("named" /* NAMED */ ), "(").concat(JSON.stringify(node.key), "))"), node);
            break;
        case 9 /* Literal */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        case 3 /* Text */ :
            generator.push(JSON.stringify(node.value), node);
            break;
        default:
    }
}
// generate code from AST
var $584cbe1b1d0d168a$var$generate = function(ast) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {} // eslint-disable-line
    ;
    var mode = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.mode) ? options.mode : "normal";
    var filename = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.filename) ? options.filename : "message.intl";
    var sourceMap = !!options.sourceMap;
    // prettier-ignore
    var breakLineCode = options.breakLineCode != null ? options.breakLineCode : mode === "arrow" ? ";" : "\n";
    var needIndent = options.needIndent ? options.needIndent : mode !== "arrow";
    var helpers = ast.helpers || [];
    var generator = $584cbe1b1d0d168a$var$createCodeGenerator(ast, {
        mode: mode,
        filename: filename,
        sourceMap: sourceMap,
        breakLineCode: breakLineCode,
        needIndent: needIndent
    });
    generator.push(mode === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {");
    generator.indent(needIndent);
    if (helpers.length > 0) {
        generator.push("const { ".concat(helpers.map(function(s) {
            return "".concat(s, ": _").concat(s);
        }).join(", "), " } = ctx"));
        generator.newline();
    }
    generator.push("return ");
    $584cbe1b1d0d168a$var$generateNode(generator, ast);
    generator.deindent(needIndent);
    generator.push("}");
    var _generator_context = generator.context(), code = _generator_context.code, map = _generator_context.map;
    return {
        ast: ast,
        code: code,
        map: map ? map.toJSON() : undefined // eslint-disable-line @typescript-eslint/no-explicit-any
    };
};
function $584cbe1b1d0d168a$export$3243579822c486a0(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var assignedOptions = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, options);
    // parse source codes
    var parser = $584cbe1b1d0d168a$export$88a1156fad04455f(assignedOptions);
    var ast = parser.parse(source);
    // transform ASTs
    $584cbe1b1d0d168a$var$transform(ast, assignedOptions);
    // generate javascript codes
    return $584cbe1b1d0d168a$var$generate(ast, assignedOptions);
}


/*!
  * devtools-if v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ var $bda2e334b96a7863$export$2058f72d18e5183a = {
    I18nInit: "i18n:init",
    FunctionTranslate: "function:translate"
};


var $1b33d9be5d32e050$var$pathStateMachine = [];
var $1b33d9be5d32e050$var$_obj;
$1b33d9be5d32e050$var$pathStateMachine[0 /* BEFORE_PATH */ ] = ($1b33d9be5d32e050$var$_obj = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj, "w" /* WORKSPACE */ , [
    0 /* BEFORE_PATH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj, "i" /* IDENT */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj, "o" /* END_OF_FAIL */ , [
    7 /* AFTER_PATH */ 
]), $1b33d9be5d32e050$var$_obj);
var $1b33d9be5d32e050$var$_obj1;
$1b33d9be5d32e050$var$pathStateMachine[1 /* IN_PATH */ ] = ($1b33d9be5d32e050$var$_obj1 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj1, "w" /* WORKSPACE */ , [
    1 /* IN_PATH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj1, "." /* DOT */ , [
    2 /* BEFORE_IDENT */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj1, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj1, "o" /* END_OF_FAIL */ , [
    7 /* AFTER_PATH */ 
]), $1b33d9be5d32e050$var$_obj1);
var $1b33d9be5d32e050$var$_obj2;
$1b33d9be5d32e050$var$pathStateMachine[2 /* BEFORE_IDENT */ ] = ($1b33d9be5d32e050$var$_obj2 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj2, "w" /* WORKSPACE */ , [
    2 /* BEFORE_IDENT */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj2, "i" /* IDENT */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj2, "0" /* ZERO */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), $1b33d9be5d32e050$var$_obj2);
var $1b33d9be5d32e050$var$_obj3;
$1b33d9be5d32e050$var$pathStateMachine[3 /* IN_IDENT */ ] = ($1b33d9be5d32e050$var$_obj3 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj3, "i" /* IDENT */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj3, "0" /* ZERO */ , [
    3 /* IN_IDENT */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj3, "w" /* WORKSPACE */ , [
    1 /* IN_PATH */ ,
    1 /* PUSH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj3, "." /* DOT */ , [
    2 /* BEFORE_IDENT */ ,
    1 /* PUSH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj3, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ ,
    1 /* PUSH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj3, "o" /* END_OF_FAIL */ , [
    7 /* AFTER_PATH */ ,
    1 /* PUSH */ 
]), $1b33d9be5d32e050$var$_obj3);
var $1b33d9be5d32e050$var$_obj4;
$1b33d9be5d32e050$var$pathStateMachine[4 /* IN_SUB_PATH */ ] = ($1b33d9be5d32e050$var$_obj4 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj4, "'" /* SINGLE_QUOTE */ , [
    5 /* IN_SINGLE_QUOTE */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj4, '"' /* DOUBLE_QUOTE */ , [
    6 /* IN_DOUBLE_QUOTE */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj4, "[" /* LEFT_BRACKET */ , [
    4 /* IN_SUB_PATH */ ,
    2 /* INC_SUB_PATH_DEPTH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj4, "]" /* RIGHT_BRACKET */ , [
    1 /* IN_PATH */ ,
    3 /* PUSH_SUB_PATH */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj4, "o" /* END_OF_FAIL */ , 8 /* ERROR */ ), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj4, "l" /* ELSE */ , [
    4 /* IN_SUB_PATH */ ,
    0 /* APPEND */ 
]), $1b33d9be5d32e050$var$_obj4);
var $1b33d9be5d32e050$var$_obj5;
$1b33d9be5d32e050$var$pathStateMachine[5 /* IN_SINGLE_QUOTE */ ] = ($1b33d9be5d32e050$var$_obj5 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj5, "'" /* SINGLE_QUOTE */ , [
    4 /* IN_SUB_PATH */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj5, "o" /* END_OF_FAIL */ , 8 /* ERROR */ ), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj5, "l" /* ELSE */ , [
    5 /* IN_SINGLE_QUOTE */ ,
    0 /* APPEND */ 
]), $1b33d9be5d32e050$var$_obj5);
var $1b33d9be5d32e050$var$_obj6;
$1b33d9be5d32e050$var$pathStateMachine[6 /* IN_DOUBLE_QUOTE */ ] = ($1b33d9be5d32e050$var$_obj6 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj6, '"' /* DOUBLE_QUOTE */ , [
    4 /* IN_SUB_PATH */ ,
    0 /* APPEND */ 
]), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj6, "o" /* END_OF_FAIL */ , 8 /* ERROR */ ), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj6, "l" /* ELSE */ , [
    6 /* IN_DOUBLE_QUOTE */ ,
    0 /* APPEND */ 
]), $1b33d9be5d32e050$var$_obj6);
/**
 * Check if an expression is a literal value.
 */ var $1b33d9be5d32e050$var$literalValueRE = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function $1b33d9be5d32e050$var$isLiteral(exp) {
    return $1b33d9be5d32e050$var$literalValueRE.test(exp);
}
/**
 * Strip quotes from a string
 */ function $1b33d9be5d32e050$var$stripQuotes(str) {
    var a = str.charCodeAt(0);
    var b = str.charCodeAt(str.length - 1);
    return a === b && (a === 0x22 || a === 0x27) ? str.slice(1, -1) : str;
}
/**
 * Determine the type of a character in a keypath.
 */ function $1b33d9be5d32e050$var$getPathCharType(ch) {
    if (ch === undefined || ch === null) return "o" /* END_OF_FAIL */ ;
    var code = ch.charCodeAt(0);
    switch(code){
        case 0x5b:
        case 0x5d:
        case 0x2e:
        case 0x22:
        case 0x27:
            return ch;
        case 0x5f:
        case 0x24:
        case 0x2d:
            return "i" /* IDENT */ ;
        case 0x09:
        case 0x0a:
        case 0x0d:
        case 0xa0:
        case 0xfeff:
        case 0x2028:
        case 0x2029:
            return "w" /* WORKSPACE */ ;
    }
    return "i" /* IDENT */ ;
}
/**
 * Format a subPath, return its plain form if it is
 * a literal string or number. Otherwise prepend the
 * dynamic indicator (*).
 */ function $1b33d9be5d32e050$var$formatSubPath(path) {
    var trimmed = path.trim();
    // invalid leading 0
    if (path.charAt(0) === "0" && isNaN(parseInt(path))) return false;
    return $1b33d9be5d32e050$var$isLiteral(trimmed) ? $1b33d9be5d32e050$var$stripQuotes(trimmed) : "*" /* ASTARISK */  + trimmed;
}
/**
 * Parse a string path into an array of segments
 */ function $1b33d9be5d32e050$export$98e6a39c04603d36(path) {
    var maybeUnescapeQuote = function maybeUnescapeQuote() {
        var nextChar = path[index + 1];
        if (mode === 5 /* IN_SINGLE_QUOTE */  && nextChar === "'" /* SINGLE_QUOTE */  || mode === 6 /* IN_DOUBLE_QUOTE */  && nextChar === '"' /* DOUBLE_QUOTE */ ) {
            index++;
            newChar = "\\" + nextChar;
            actions[0 /* APPEND */ ]();
            return true;
        }
    };
    var keys = [];
    var index = -1;
    var mode = 0 /* BEFORE_PATH */ ;
    var subPathDepth = 0;
    var c;
    var key; // eslint-disable-line
    var newChar;
    var type;
    var transition;
    var action;
    var typeMap;
    var actions = [];
    actions[0 /* APPEND */ ] = function() {
        if (key === undefined) key = newChar;
        else key += newChar;
    };
    actions[1 /* PUSH */ ] = function() {
        if (key !== undefined) {
            keys.push(key);
            key = undefined;
        }
    };
    actions[2 /* INC_SUB_PATH_DEPTH */ ] = function() {
        actions[0 /* APPEND */ ]();
        subPathDepth++;
    };
    actions[3 /* PUSH_SUB_PATH */ ] = function() {
        if (subPathDepth > 0) {
            subPathDepth--;
            mode = 4 /* IN_SUB_PATH */ ;
            actions[0 /* APPEND */ ]();
        } else {
            subPathDepth = 0;
            if (key === undefined) return false;
            key = $1b33d9be5d32e050$var$formatSubPath(key);
            if (key === false) return false;
            else actions[1 /* PUSH */ ]();
        }
    };
    while(mode !== null){
        index++;
        c = path[index];
        if (c === "\\" && maybeUnescapeQuote()) continue;
        type = $1b33d9be5d32e050$var$getPathCharType(c);
        typeMap = $1b33d9be5d32e050$var$pathStateMachine[mode];
        transition = typeMap[type] || typeMap["l" /* ELSE */ ] || 8 /* ERROR */ ;
        // check parse error
        if (transition === 8 /* ERROR */ ) return;
        mode = transition[0];
        if (transition[1] !== undefined) {
            action = actions[transition[1]];
            if (action) {
                newChar = c;
                if (action() === false) return;
            }
        }
        // check parse finish
        if (mode === 7 /* AFTER_PATH */ ) return keys;
    }
}
// path token cache
var $1b33d9be5d32e050$var$cache = new Map();
/**
 * key-value message resolver
 *
 * @remarks
 * Resolves messages with the key-value structure. Note that messages with a hierarchical structure such as objects cannot be resolved
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $1b33d9be5d32e050$export$b365de4c3506886c(obj, path) {
    return (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(obj) ? obj[path] : null;
}
/**
 * message resolver
 *
 * @remarks
 * Resolves messages. messages with a hierarchical structure such as objects can be resolved. This resolver is used in VueI18n as default.
 *
 * @param obj - A target object to be resolved with path
 * @param path - A {@link Path | path} to resolve the value of message
 *
 * @returns A resolved {@link PathValue | path value}
 *
 * @VueI18nGeneral
 */ function $1b33d9be5d32e050$export$d812c8e1906863d0(obj, path) {
    // check object
    if (!(0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(obj)) return null;
    // parse path
    var hit = $1b33d9be5d32e050$var$cache.get(path);
    if (!hit) {
        hit = $1b33d9be5d32e050$export$98e6a39c04603d36(path);
        if (hit) $1b33d9be5d32e050$var$cache.set(path, hit);
    }
    // check hit
    if (!hit) return null;
    // resolve path value
    var len = hit.length;
    var last = obj;
    var i = 0;
    while(i < len){
        var val = last[hit[i]];
        if (val === undefined) return null;
        last = val;
        i++;
    }
    return last;
}
var $1b33d9be5d32e050$var$DEFAULT_MODIFIER = function(str) {
    return str;
};
var $1b33d9be5d32e050$var$DEFAULT_MESSAGE = function(ctx) {
    return "";
}; // eslint-disable-line
var $1b33d9be5d32e050$export$12b53af6b8529bfc = "text";
var $1b33d9be5d32e050$var$DEFAULT_NORMALIZE = function(values) {
    return values.length === 0 ? "" : values.join("");
};
var $1b33d9be5d32e050$var$DEFAULT_INTERPOLATE = (0, $66fbc42080b842e5$export$b5b1545233b45293);
function $1b33d9be5d32e050$var$pluralDefault(choice, choicesLength) {
    choice = Math.abs(choice);
    if (choicesLength === 2) // prettier-ignore
    return choice ? choice > 1 ? 1 : 0 : 1;
    return choice ? Math.min(choice, 2) : 0;
}
function $1b33d9be5d32e050$var$getPluralIndex(options) {
    // prettier-ignore
    var index = (0, $66fbc42080b842e5$export$7e4aa119212bc614)(options.pluralIndex) ? options.pluralIndex : -1;
    // prettier-ignore
    return options.named && ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(options.named.count) || (0, $66fbc42080b842e5$export$7e4aa119212bc614)(options.named.n)) ? (0, $66fbc42080b842e5$export$7e4aa119212bc614)(options.named.count) ? options.named.count : (0, $66fbc42080b842e5$export$7e4aa119212bc614)(options.named.n) ? options.named.n : index : index;
}
function $1b33d9be5d32e050$var$normalizeNamed(pluralIndex, props) {
    if (!props.count) props.count = pluralIndex;
    if (!props.n) props.n = pluralIndex;
}
function $1b33d9be5d32e050$export$70de3b14beda2f5e() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var message = function message(key) {
        // prettier-ignore
        var msg = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.messages) ? options.messages(key) : (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.messages) ? options.messages[key] : false;
        return !msg ? options.parent ? options.parent.message(key) // resolve from parent messages
         : $1b33d9be5d32e050$var$DEFAULT_MESSAGE : msg;
    };
    var locale = options.locale;
    var pluralIndex = $1b33d9be5d32e050$var$getPluralIndex(options);
    var pluralRule = (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $66fbc42080b842e5$export$844ec244b1367d54)(locale) && (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? options.pluralRules[locale] : $1b33d9be5d32e050$var$pluralDefault;
    var orgPluralRule = (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.pluralRules) && (0, $66fbc42080b842e5$export$844ec244b1367d54)(locale) && (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.pluralRules[locale]) ? $1b33d9be5d32e050$var$pluralDefault : undefined;
    var plural = function(messages) {
        return messages[pluralRule(pluralIndex, messages.length, orgPluralRule)];
    };
    var _list = options.list || [];
    var list = function(index) {
        return _list[index];
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var _named = options.named || {};
    (0, $66fbc42080b842e5$export$7e4aa119212bc614)(options.pluralIndex) && $1b33d9be5d32e050$var$normalizeNamed(pluralIndex, _named);
    var named = function(key) {
        return _named[key];
    };
    var _modifier = function(name) {
        return options.modifiers ? options.modifiers[name] : $1b33d9be5d32e050$var$DEFAULT_MODIFIER;
    };
    var normalize = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.processor) && (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.processor.normalize) ? options.processor.normalize : $1b33d9be5d32e050$var$DEFAULT_NORMALIZE;
    var interpolate = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.processor) && (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.processor.interpolate) ? options.processor.interpolate : $1b33d9be5d32e050$var$DEFAULT_INTERPOLATE;
    var type = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.processor) && (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.processor.type) ? options.processor.type : $1b33d9be5d32e050$export$12b53af6b8529bfc;
    var linked = function(key) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var _args = (0, $cv9Rk._)(args, 2), arg1 = _args[0], arg2 = _args[1];
        var type = "text";
        var modifier = "";
        if (args.length === 1) {
            if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(arg1)) {
                modifier = arg1.modifier || modifier;
                type = arg1.type || type;
            } else if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
        } else if (args.length === 2) {
            if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg1)) modifier = arg1 || modifier;
            if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg2)) type = arg2 || type;
        }
        var msg = message(key)(ctx);
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        if (type === "vnode" && (0, $66fbc42080b842e5$export$43bee75e5e14138e)(msg) && modifier) msg = msg[0];
        return modifier ? _modifier(modifier)(msg, type) : msg;
    };
    var _obj;
    var ctx = (_obj = {}, (0, $3sHb8._)(_obj, "list" /* LIST */ , list), (0, $3sHb8._)(_obj, "named" /* NAMED */ , named), (0, $3sHb8._)(_obj, "plural" /* PLURAL */ , plural), (0, $3sHb8._)(_obj, "linked" /* LINKED */ , linked), (0, $3sHb8._)(_obj, "message" /* MESSAGE */ , message), (0, $3sHb8._)(_obj, "type" /* TYPE */ , type), (0, $3sHb8._)(_obj, "interpolate" /* INTERPOLATE */ , interpolate), (0, $3sHb8._)(_obj, "normalize" /* NORMALIZE */ , normalize), _obj);
    return ctx;
}
var $1b33d9be5d32e050$var$devtools = null;
function $1b33d9be5d32e050$export$c893d6c8966908b9(hook) {
    $1b33d9be5d32e050$var$devtools = hook;
}
function $1b33d9be5d32e050$export$8bd08e70642dc6f4() {
    return $1b33d9be5d32e050$var$devtools;
}
function $1b33d9be5d32e050$export$725afc6a300324a0(i18n, version, meta) {
    // TODO: queue if devtools is undefined
    $1b33d9be5d32e050$var$devtools && $1b33d9be5d32e050$var$devtools.emit((0, $bda2e334b96a7863$export$2058f72d18e5183a).I18nInit, {
        timestamp: Date.now(),
        i18n: i18n,
        version: version,
        meta: meta
    });
}
var $1b33d9be5d32e050$export$190d71a47ff3f767 = /* #__PURE__*/ $1b33d9be5d32e050$var$createDevToolsHook((0, $bda2e334b96a7863$export$2058f72d18e5183a).FunctionTranslate);
function $1b33d9be5d32e050$var$createDevToolsHook(hook) {
    return function(payloads) {
        return $1b33d9be5d32e050$var$devtools && $1b33d9be5d32e050$var$devtools.emit(hook, payloads);
    };
}
var $1b33d9be5d32e050$export$b6a676a18b27d4c8 = {
    NOT_FOUND_KEY: 1,
    FALLBACK_TO_TRANSLATE: 2,
    CANNOT_FORMAT_NUMBER: 3,
    FALLBACK_TO_NUMBER_FORMAT: 4,
    CANNOT_FORMAT_DATE: 5,
    FALLBACK_TO_DATE_FORMAT: 6,
    __EXTEND_POINT__: 7
};
var $1b33d9be5d32e050$var$_obj7;
/** @internal */ var $1b33d9be5d32e050$var$warnMessages = ($1b33d9be5d32e050$var$_obj7 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj7, $1b33d9be5d32e050$export$b6a676a18b27d4c8.NOT_FOUND_KEY, "Not found '{key}' key in '{locale}' locale messages."), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj7, $1b33d9be5d32e050$export$b6a676a18b27d4c8.FALLBACK_TO_TRANSLATE, "Fall back to translate '{key}' key with '{target}' locale."), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj7, $1b33d9be5d32e050$export$b6a676a18b27d4c8.CANNOT_FORMAT_NUMBER, "Cannot format a number value due to not supported Intl.NumberFormat."), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj7, $1b33d9be5d32e050$export$b6a676a18b27d4c8.FALLBACK_TO_NUMBER_FORMAT, "Fall back to number format '{key}' key with '{target}' locale."), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj7, $1b33d9be5d32e050$export$b6a676a18b27d4c8.CANNOT_FORMAT_DATE, "Cannot format a date value due to not supported Intl.DateTimeFormat."), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj7, $1b33d9be5d32e050$export$b6a676a18b27d4c8.FALLBACK_TO_DATE_FORMAT, "Fall back to datetime format '{key}' key with '{target}' locale."), $1b33d9be5d32e050$var$_obj7);
function $1b33d9be5d32e050$export$ae7a7631f2b2bb7(code) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $66fbc42080b842e5$export$d9468344d3651243).apply(void 0, [
        $1b33d9be5d32e050$var$warnMessages[code]
    ].concat((0, $c6Xmf._)(args)));
}
/**
 * Fallback with simple implemenation
 *
 * @remarks
 * A fallback locale function implemented with a simple fallback algorithm.
 *
 * Basically, it returns the value as specified in the `fallbackLocale` props, and is processed with the fallback inside intlify.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nGeneral
 */ function $1b33d9be5d32e050$export$e3330076537ef9d1(ctx, fallback, start // eslint-disable-line @typescript-eslint/no-unused-vars
) {
    // prettier-ignore
    return (0, $c6Xmf._)(new Set([
        start
    ].concat((0, $c6Xmf._)((0, $66fbc42080b842e5$export$43bee75e5e14138e)(fallback) ? fallback : (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(fallback) ? Object.keys(fallback) : (0, $66fbc42080b842e5$export$844ec244b1367d54)(fallback) ? [
        fallback
    ] : [
        start
    ]))));
}
/**
 * Fallback with locale chain
 *
 * @remarks
 * A fallback locale function implemented with a fallback chain algorithm. It's used in VueI18n as default.
 *
 * @param ctx - A {@link CoreContext | context}
 * @param fallback - A {@link FallbackLocale | fallback locale}
 * @param start - A starting {@link Locale | locale}
 *
 * @returns Fallback locales
 *
 * @VueI18nSee [Fallbacking](../guide/essentials/fallback)
 *
 * @VueI18nGeneral
 */ function $1b33d9be5d32e050$export$71df9db82dc445(ctx, fallback, start) {
    var startLocale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(start) ? start : $1b33d9be5d32e050$export$1af4c7e47ad72f44;
    var context = ctx;
    if (!context.__localeChainCache) context.__localeChainCache = new Map();
    var chain = context.__localeChainCache.get(startLocale);
    if (!chain) {
        chain = [];
        // first block defined by start
        var block = [
            start
        ];
        // while any intervening block found
        while((0, $66fbc42080b842e5$export$43bee75e5e14138e)(block))block = $1b33d9be5d32e050$var$appendBlockToChain(chain, block, fallback);
        // prettier-ignore
        // last block defined by default
        var defaults = (0, $66fbc42080b842e5$export$43bee75e5e14138e)(fallback) || !(0, $66fbc42080b842e5$export$53b83ca8eaab0383)(fallback) ? fallback : fallback["default"] ? fallback["default"] : null;
        // convert defaults to array
        block = (0, $66fbc42080b842e5$export$844ec244b1367d54)(defaults) ? [
            defaults
        ] : defaults;
        if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(block)) $1b33d9be5d32e050$var$appendBlockToChain(chain, block, false);
        context.__localeChainCache.set(startLocale, chain);
    }
    return chain;
}
function $1b33d9be5d32e050$var$appendBlockToChain(chain, block, blocks) {
    var follow = true;
    for(var i = 0; i < block.length && (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(follow); i++){
        var locale = block[i];
        if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(locale)) follow = $1b33d9be5d32e050$var$appendLocaleToChain(chain, block[i], blocks);
    }
    return follow;
}
function $1b33d9be5d32e050$var$appendLocaleToChain(chain, locale, blocks) {
    var follow;
    var tokens = locale.split("-");
    do {
        var target = tokens.join("-");
        follow = $1b33d9be5d32e050$var$appendItemToChain(chain, target, blocks);
        tokens.splice(-1, 1);
    }while (tokens.length && follow === true);
    return follow;
}
function $1b33d9be5d32e050$var$appendItemToChain(chain, target, blocks) {
    var follow = false;
    if (!chain.includes(target)) {
        follow = true;
        if (target) {
            follow = target[target.length - 1] !== "!";
            var locale = target.replace(/!/g, "");
            chain.push(locale);
            if (((0, $66fbc42080b842e5$export$43bee75e5e14138e)(blocks) || (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(blocks)) && blocks[locale] // eslint-disable-line @typescript-eslint/no-explicit-any
            ) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            follow = blocks[locale];
        }
    }
    return follow;
}
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Intlify core-base version
 * @internal
 */ var $1b33d9be5d32e050$export$a4ad2735b021c132 = "9.2.2";
var $1b33d9be5d32e050$export$b7f13a18d1d0f835 = -1;
var $1b33d9be5d32e050$export$1af4c7e47ad72f44 = "en-US";
var $1b33d9be5d32e050$export$a04371e9dbb3870b = "";
var $1b33d9be5d32e050$var$capitalize = function(str) {
    return "".concat(str.charAt(0).toLocaleUpperCase()).concat(str.substr(1));
};
function $1b33d9be5d32e050$var$getDefaultLinkedModifiers() {
    return {
        upper: function(val, type) {
            // prettier-ignore
            return type === "text" && (0, $66fbc42080b842e5$export$844ec244b1367d54)(val) ? val.toUpperCase() : type === "vnode" && (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toUpperCase() : val;
        },
        lower: function(val, type) {
            // prettier-ignore
            return type === "text" && (0, $66fbc42080b842e5$export$844ec244b1367d54)(val) ? val.toLowerCase() : type === "vnode" && (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? val.children.toLowerCase() : val;
        },
        capitalize: function(val, type) {
            // prettier-ignore
            return type === "text" && (0, $66fbc42080b842e5$export$844ec244b1367d54)(val) ? $1b33d9be5d32e050$var$capitalize(val) : type === "vnode" && (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(val) && "__v_isVNode" in val ? $1b33d9be5d32e050$var$capitalize(val.children) : val;
        }
    };
}
var $1b33d9be5d32e050$var$_compiler;
function $1b33d9be5d32e050$export$6ee2fbe83628b40b(compiler) {
    $1b33d9be5d32e050$var$_compiler = compiler;
}
var $1b33d9be5d32e050$var$_resolver;
/**
 * Register the message resolver
 *
 * @param resolver - A {@link MessageResolver} function
 *
 * @VueI18nGeneral
 */ function $1b33d9be5d32e050$export$45dacdc710815463(resolver) {
    $1b33d9be5d32e050$var$_resolver = resolver;
}
var $1b33d9be5d32e050$var$_fallbacker;
/**
 * Register the locale fallbacker
 *
 * @param fallbacker - A {@link LocaleFallbacker} function
 *
 * @VueI18nGeneral
 */ function $1b33d9be5d32e050$export$fd8ec9dd8067edec(fallbacker) {
    $1b33d9be5d32e050$var$_fallbacker = fallbacker;
}
// Additional Meta for Intlify DevTools
var $1b33d9be5d32e050$var$_additionalMeta = null;
var $1b33d9be5d32e050$export$605703447dca72aa = function(meta) {
    $1b33d9be5d32e050$var$_additionalMeta = meta;
};
var $1b33d9be5d32e050$export$817795a14e5c6622 = function() {
    return $1b33d9be5d32e050$var$_additionalMeta;
};
var $1b33d9be5d32e050$var$_fallbackContext = null;
var $1b33d9be5d32e050$export$e16aca6786e72a5e = function(context) {
    $1b33d9be5d32e050$var$_fallbackContext = context;
};
var $1b33d9be5d32e050$export$3adddc434faa9e35 = function() {
    return $1b33d9be5d32e050$var$_fallbackContext;
};
// ID for CoreContext
var $1b33d9be5d32e050$var$_cid = 0;
function $1b33d9be5d32e050$export$3599d465b05a74a5() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    // setup options
    var version = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.version) ? options.version : $1b33d9be5d32e050$export$a4ad2735b021c132;
    var locale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.locale) ? options.locale : $1b33d9be5d32e050$export$1af4c7e47ad72f44;
    var fallbackLocale = (0, $66fbc42080b842e5$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    var messages = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.messages) ? options.messages : (0, $3sHb8._)({}, locale, {});
    var datetimeFormats = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : (0, $3sHb8._)({}, locale, {});
    var numberFormats = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : (0, $3sHb8._)({}, locale, {});
    var modifiers = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, options.modifiers || {}, $1b33d9be5d32e050$var$getDefaultLinkedModifiers());
    var pluralRules = options.pluralRules || {};
    var missing = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    var missingWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    var fallbackWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    var fallbackFormat = !!options.fallbackFormat;
    var unresolving = !!options.unresolving;
    var postTranslation = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    var processor = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.processor) ? options.processor : null;
    var warnHtmlMessage = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    var escapeParameter = !!options.escapeParameter;
    var messageCompiler = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.messageCompiler) ? options.messageCompiler : $1b33d9be5d32e050$var$_compiler;
    var messageResolver = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.messageResolver) ? options.messageResolver : $1b33d9be5d32e050$var$_resolver || $1b33d9be5d32e050$export$b365de4c3506886c;
    var localeFallbacker = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.localeFallbacker) ? options.localeFallbacker : $1b33d9be5d32e050$var$_fallbacker || $1b33d9be5d32e050$export$e3330076537ef9d1;
    var fallbackContext = (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.fallbackContext) ? options.fallbackContext : undefined;
    var onWarn = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.onWarn) ? options.onWarn : (0, $66fbc42080b842e5$export$c106dd0671a0fc2d);
    // setup internal options
    var internalOptions = options;
    var __datetimeFormatters = (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(internalOptions.__datetimeFormatters) ? internalOptions.__datetimeFormatters : new Map();
    var __numberFormatters = (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(internalOptions.__numberFormatters) ? internalOptions.__numberFormatters : new Map();
    var __meta = (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(internalOptions.__meta) ? internalOptions.__meta : {};
    $1b33d9be5d32e050$var$_cid++;
    var context = {
        version: version,
        cid: $1b33d9be5d32e050$var$_cid,
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        modifiers: modifiers,
        pluralRules: pluralRules,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackFormat: fallbackFormat,
        unresolving: unresolving,
        postTranslation: postTranslation,
        processor: processor,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageCompiler: messageCompiler,
        messageResolver: messageResolver,
        localeFallbacker: localeFallbacker,
        fallbackContext: fallbackContext,
        onWarn: onWarn,
        __meta: __meta
    };
    context.datetimeFormats = datetimeFormats;
    context.numberFormats = numberFormats;
    context.__datetimeFormatters = __datetimeFormatters;
    context.__numberFormatters = __numberFormatters;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) $1b33d9be5d32e050$export$725afc6a300324a0(context, version, __meta);
    return context;
}
/** @internal */ function $1b33d9be5d32e050$export$d9435df38da77a63(fallback, key) {
    return fallback instanceof RegExp ? fallback.test(key) : fallback;
}
/** @internal */ function $1b33d9be5d32e050$export$e419d347a4a2eb71(missing, key) {
    return missing instanceof RegExp ? missing.test(key) : missing;
}
/** @internal */ function $1b33d9be5d32e050$export$bc779048ece0c567(context, key, locale, missingWarn, type) {
    var missing = context.missing, onWarn = context.onWarn;
    if (missing !== null) {
        var ret = missing(context, locale, key, type);
        return (0, $66fbc42080b842e5$export$844ec244b1367d54)(ret) ? ret : key;
    } else return key;
}
/** @internal */ function $1b33d9be5d32e050$export$c743ad8a3cc01530(ctx, locale, fallback) {
    var context = ctx;
    context.__localeChainCache = new Map();
    ctx.localeFallbacker(ctx, fallback, locale);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ var $1b33d9be5d32e050$var$RE_HTML_TAG = /<\/?[\w\s="/.':;#-\/]+>/;
var $1b33d9be5d32e050$var$WARN_MESSAGE = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function $1b33d9be5d32e050$var$checkHtmlMessage(source, options) {
    var warnHtmlMessage = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    if (warnHtmlMessage && $1b33d9be5d32e050$var$RE_HTML_TAG.test(source)) (0, $66fbc42080b842e5$export$c106dd0671a0fc2d)((0, $66fbc42080b842e5$export$d9468344d3651243)($1b33d9be5d32e050$var$WARN_MESSAGE, {
        source: source
    }));
}
var $1b33d9be5d32e050$var$defaultOnCacheKey = function(source) {
    return source;
};
var $1b33d9be5d32e050$var$compileCache = Object.create(null);
function $1b33d9be5d32e050$export$2683c80ae3fe544() {
    $1b33d9be5d32e050$var$compileCache = Object.create(null);
}
function $1b33d9be5d32e050$export$1ea8807c727891fc(source) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    {
        // check caches
        var onCacheKey = options.onCacheKey || $1b33d9be5d32e050$var$defaultOnCacheKey;
        var key = onCacheKey(source);
        var cached = $1b33d9be5d32e050$var$compileCache[key];
        if (cached) return cached;
        // compile error detecting
        var occurred = false;
        var onError = options.onError || (0, $584cbe1b1d0d168a$export$ad0eb2c702f03471);
        options.onError = function(err) {
            occurred = true;
            onError(err);
        };
        // compile
        var code = (0, $584cbe1b1d0d168a$export$3243579822c486a0)(source, options).code;
        // evaluate function
        var msg = new Function("return ".concat(code))();
        // if occurred compile error, don't cache
        return !occurred ? $1b33d9be5d32e050$var$compileCache[key] = msg : msg;
    }
}
var $1b33d9be5d32e050$var$code = (0, $584cbe1b1d0d168a$export$77436aae039469c4).__EXTEND_POINT__;
var $1b33d9be5d32e050$var$inc = function() {
    return ++$1b33d9be5d32e050$var$code;
};
var $1b33d9be5d32e050$export$1d4dfd6045c40277 = {
    INVALID_ARGUMENT: $1b33d9be5d32e050$var$code,
    INVALID_DATE_ARGUMENT: $1b33d9be5d32e050$var$inc(),
    INVALID_ISO_DATE_ARGUMENT: $1b33d9be5d32e050$var$inc(),
    __EXTEND_POINT__: $1b33d9be5d32e050$var$inc() // 18
};
function $1b33d9be5d32e050$export$3d702f7ac45b0a6b(code) {
    return (0, $584cbe1b1d0d168a$export$21efa8bb37d5fecb)(code, null, undefined);
}
var $1b33d9be5d32e050$var$_obj8;
/** @internal */ var $1b33d9be5d32e050$var$errorMessages = ($1b33d9be5d32e050$var$_obj8 = {}, (0, $3sHb8._)($1b33d9be5d32e050$var$_obj8, $1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_ARGUMENT, "Invalid arguments"), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj8, $1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT, "The date provided is an invalid Date object.Make sure your Date represents a valid date."), (0, $3sHb8._)($1b33d9be5d32e050$var$_obj8, $1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT, "The argument provided is not a valid ISO date string"), $1b33d9be5d32e050$var$_obj8);
var $1b33d9be5d32e050$var$NOOP_MESSAGE_FUNCTION = function() {
    return "";
};
var $1b33d9be5d32e050$export$92c0a039cf358271 = function(val) {
    return (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(val);
};
// implementation of `translate` function
function $1b33d9be5d32e050$export$d73ee8ef04f5226a(context) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var fallbackFormat = context.fallbackFormat, postTranslation = context.postTranslation, unresolving = context.unresolving, messageCompiler = context.messageCompiler, fallbackLocale = context.fallbackLocale, messages = context.messages;
    var _parseTranslateArgs_apply = (0, $cv9Rk._)($1b33d9be5d32e050$export$8d9616744e22681a.apply(void 0, (0, $c6Xmf._)(args)), 2), key = _parseTranslateArgs_apply[0], options = _parseTranslateArgs_apply[1];
    var missingWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    var fallbackWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    var escapeParameter = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.escapeParameter) ? options.escapeParameter : context.escapeParameter;
    var resolvedMessage = !!options.resolvedMessage;
    // prettier-ignore
    var defaultMsgOrKey = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.default) || (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.default) // default by function option
     ? !(0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.default) ? options.default : !messageCompiler ? function() {
        return key;
    } : key : fallbackFormat // default by `fallbackFormat` option
     ? !messageCompiler ? function() {
        return key;
    } : key : "";
    var enableDefaultMsg = fallbackFormat || defaultMsgOrKey !== "";
    var locale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    // escape params
    escapeParameter && $1b33d9be5d32e050$var$escapeParams(options);
    // resolve message format
    // eslint-disable-next-line prefer-const
    var _ref = (0, $cv9Rk._)(!resolvedMessage ? $1b33d9be5d32e050$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) : [
        key,
        locale,
        messages[locale] || {}
    ], 3), formatScope = _ref[0], targetLocale = _ref[1], message = _ref[2];
    // NOTE:
    //  Fix to work around `ssrTransfrom` bug in Vite.
    //  https://github.com/vitejs/vite/issues/4306
    //  To get around this, use temporary variables.
    //  https://github.com/nuxt/framework/issues/1461#issuecomment-954606243
    var format = formatScope;
    // if you use default message, set it as message format!
    var cacheBaseKey = key;
    if (!resolvedMessage && !((0, $66fbc42080b842e5$export$844ec244b1367d54)(format) || $1b33d9be5d32e050$export$92c0a039cf358271(format))) {
        if (enableDefaultMsg) {
            format = defaultMsgOrKey;
            cacheBaseKey = format;
        }
    }
    // checking message format and target locale
    if (!resolvedMessage && (!((0, $66fbc42080b842e5$export$844ec244b1367d54)(format) || $1b33d9be5d32e050$export$92c0a039cf358271(format)) || !(0, $66fbc42080b842e5$export$844ec244b1367d54)(targetLocale))) return unresolving ? $1b33d9be5d32e050$export$b7f13a18d1d0f835 : key;
    // setup compile error detecting
    var occurred = false;
    var errorDetector = function() {
        occurred = true;
    };
    // compile message format
    var msg = !$1b33d9be5d32e050$export$92c0a039cf358271(format) ? $1b33d9be5d32e050$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) : format;
    // if occurred compile error, return the message format
    if (occurred) return format;
    // evaluate message with context
    var ctxOptions = $1b33d9be5d32e050$var$getMessageContextOptions(context, targetLocale, message, options);
    var msgContext = $1b33d9be5d32e050$export$70de3b14beda2f5e(ctxOptions);
    var messaged = $1b33d9be5d32e050$var$evaluateMessage(context, msg, msgContext);
    // if use post translation option, proceed it with handler
    var ret = postTranslation ? postTranslation(messaged, key) : messaged;
    // NOTE: experimental !!
    if (__INTLIFY_PROD_DEVTOOLS__) {
        // prettier-ignore
        var payloads = {
            timestamp: Date.now(),
            key: (0, $66fbc42080b842e5$export$844ec244b1367d54)(key) ? key : $1b33d9be5d32e050$export$92c0a039cf358271(format) ? format.key : "",
            locale: targetLocale || ($1b33d9be5d32e050$export$92c0a039cf358271(format) ? format.locale : ""),
            format: (0, $66fbc42080b842e5$export$844ec244b1367d54)(format) ? format : $1b33d9be5d32e050$export$92c0a039cf358271(format) ? format.source : "",
            message: ret
        };
        payloads.meta = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, context.__meta, $1b33d9be5d32e050$export$817795a14e5c6622() || {});
        $1b33d9be5d32e050$export$190d71a47ff3f767(payloads);
    }
    return ret;
}
function $1b33d9be5d32e050$var$escapeParams(options) {
    if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(options.list)) options.list = options.list.map(function(item) {
        return (0, $66fbc42080b842e5$export$844ec244b1367d54)(item) ? (0, $66fbc42080b842e5$export$4cf11838cdc2a8a8)(item) : item;
    });
    else if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.named)) Object.keys(options.named).forEach(function(key) {
        if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(options.named[key])) options.named[key] = (0, $66fbc42080b842e5$export$4cf11838cdc2a8a8)(options.named[key]);
    });
}
function $1b33d9be5d32e050$var$resolveMessageFormat(context, key, locale, fallbackLocale, fallbackWarn, missingWarn) {
    var messages = context.messages, onWarn = context.onWarn, resolveValue = context.messageResolver, localeFallbacker = context.localeFallbacker;
    var locales = localeFallbacker(context, fallbackLocale, locale); // eslint-disable-line @typescript-eslint/no-explicit-any
    var message = {};
    var targetLocale;
    var format = null;
    var from = locale;
    var to = null;
    var type = "translate";
    for(var i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        message = messages[targetLocale] || {};
        // for vue-devtools timeline event
        var start = null;
        var startTag = void 0;
        var endTag = void 0;
        if ((format = resolveValue(message, key)) === null) // if null, resolve with object key path
        format = message[key]; // eslint-disable-line @typescript-eslint/no-explicit-any
        if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(format) || (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(format)) break;
        var missingRet = $1b33d9be5d32e050$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type);
        if (missingRet !== key) format = missingRet;
        from = to;
    }
    return [
        format,
        targetLocale,
        message
    ];
}
function $1b33d9be5d32e050$var$compileMessageFormat(context, key, targetLocale, format, cacheBaseKey, errorDetector) {
    var messageCompiler = context.messageCompiler, warnHtmlMessage = context.warnHtmlMessage;
    if ($1b33d9be5d32e050$export$92c0a039cf358271(format)) {
        var msg = format;
        msg.locale = msg.locale || targetLocale;
        msg.key = msg.key || key;
        return msg;
    }
    if (messageCompiler == null) {
        var msg1 = function() {
            return format;
        };
        msg1.locale = targetLocale;
        msg1.key = key;
        return msg1;
    }
    // for vue-devtools timeline event
    var start = null;
    var startTag;
    var endTag;
    var msg2 = messageCompiler(format, $1b33d9be5d32e050$var$getCompileOptions(context, targetLocale, cacheBaseKey, format, warnHtmlMessage, errorDetector));
    msg2.locale = targetLocale;
    msg2.key = key;
    msg2.source = format;
    return msg2;
}
function $1b33d9be5d32e050$var$evaluateMessage(context, msg, msgCtx) {
    // for vue-devtools timeline event
    var start = null;
    var startTag;
    var endTag;
    var messaged = msg(msgCtx);
    return messaged;
}
/** @internal */ function $1b33d9be5d32e050$export$8d9616744e22681a() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $cv9Rk._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
    var options = {};
    if (!(0, $66fbc42080b842e5$export$844ec244b1367d54)(arg1) && !(0, $66fbc42080b842e5$export$7e4aa119212bc614)(arg1) && !$1b33d9be5d32e050$export$92c0a039cf358271(arg1)) throw $1b33d9be5d32e050$export$3d702f7ac45b0a6b($1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    // prettier-ignore
    var key = (0, $66fbc42080b842e5$export$7e4aa119212bc614)(arg1) ? String(arg1) : $1b33d9be5d32e050$export$92c0a039cf358271(arg1) ? arg1 : arg1;
    if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
    else if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg2)) options.default = arg2;
    else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg2) && !(0, $66fbc42080b842e5$export$83b788b1a3698c03)(arg2)) options.named = arg2;
    else if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(arg2)) options.list = arg2;
    if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(arg3)) options.plural = arg3;
    else if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg3)) options.default = arg3;
    else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg3)) (0, $66fbc42080b842e5$export$e6e34fd1f2686227)(options, arg3);
    return [
        key,
        options
    ];
}
function $1b33d9be5d32e050$var$getCompileOptions(context, locale, key, source, warnHtmlMessage, errorDetector) {
    return {
        warnHtmlMessage: warnHtmlMessage,
        onError: function(err) {
            errorDetector && errorDetector(err);
            throw err;
        },
        onCacheKey: function(source) {
            return (0, $66fbc42080b842e5$export$5024ef1f92c9a364)(locale, key, source);
        }
    };
}
function $1b33d9be5d32e050$var$getMessageContextOptions(context, locale, message, options) {
    var modifiers = context.modifiers, pluralRules = context.pluralRules, resolveValue = context.messageResolver, fallbackLocale = context.fallbackLocale, fallbackWarn = context.fallbackWarn, missingWarn = context.missingWarn, fallbackContext = context.fallbackContext;
    var resolveMessage = function(key) {
        var val = resolveValue(message, key);
        // fallback to root context
        if (val == null && fallbackContext) {
            var _resolveMessageFormat = (0, $cv9Rk._)($1b33d9be5d32e050$var$resolveMessageFormat(fallbackContext, key, locale, fallbackLocale, fallbackWarn, missingWarn), 3), _$message = _resolveMessageFormat[2];
            val = resolveValue(_$message, key);
        }
        if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(val)) {
            var occurred = false;
            var errorDetector = function() {
                occurred = true;
            };
            var msg = $1b33d9be5d32e050$var$compileMessageFormat(context, key, locale, val, key, errorDetector);
            return !occurred ? msg : $1b33d9be5d32e050$var$NOOP_MESSAGE_FUNCTION;
        } else if ($1b33d9be5d32e050$export$92c0a039cf358271(val)) return val;
        else // TODO: should be implemented warning message
        return $1b33d9be5d32e050$var$NOOP_MESSAGE_FUNCTION;
    };
    var ctxOptions = {
        locale: locale,
        modifiers: modifiers,
        pluralRules: pluralRules,
        messages: resolveMessage
    };
    if (context.processor) ctxOptions.processor = context.processor;
    if (options.list) ctxOptions.list = options.list;
    if (options.named) ctxOptions.named = options.named;
    if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(options.plural)) ctxOptions.pluralIndex = options.plural;
    return ctxOptions;
}
var $1b33d9be5d32e050$var$intlDefined = typeof Intl !== "undefined";
var $1b33d9be5d32e050$var$Availabilities = {
    dateTimeFormat: $1b33d9be5d32e050$var$intlDefined && typeof Intl.DateTimeFormat !== "undefined",
    numberFormat: $1b33d9be5d32e050$var$intlDefined && typeof Intl.NumberFormat !== "undefined"
};
// implementation of `datetime` function
function $1b33d9be5d32e050$export$7ba4466dbd0f07e1(context) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var datetimeFormats = context.datetimeFormats, unresolving = context.unresolving, fallbackLocale = context.fallbackLocale, onWarn = context.onWarn, localeFallbacker = context.localeFallbacker;
    var __datetimeFormatters = context.__datetimeFormatters;
    var _parseDateTimeArgs_apply = (0, $cv9Rk._)($1b33d9be5d32e050$export$165524b21a0d6b5e.apply(void 0, (0, $c6Xmf._)(args)), 4), key = _parseDateTimeArgs_apply[0], value = _parseDateTimeArgs_apply[1], options = _parseDateTimeArgs_apply[2], overrides = _parseDateTimeArgs_apply[3];
    var missingWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    var fallbackWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    var part = !!options.part;
    var locale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    var locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $66fbc42080b842e5$export$844ec244b1367d54)(key) || key === "") return new Intl.DateTimeFormat(locale, overrides).format(value);
    // resolve format
    var datetimeFormat = {};
    var targetLocale;
    var format = null;
    var from = locale;
    var to = null;
    var type = "datetime format";
    for(var i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        datetimeFormat = datetimeFormats[targetLocale] || {};
        format = datetimeFormat[key];
        if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(format)) break;
        $1b33d9be5d32e050$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $66fbc42080b842e5$export$53b83ca8eaab0383)(format) || !(0, $66fbc42080b842e5$export$844ec244b1367d54)(targetLocale)) return unresolving ? $1b33d9be5d32e050$export$b7f13a18d1d0f835 : key;
    var id = "".concat(targetLocale, "__").concat(key);
    if (!(0, $66fbc42080b842e5$export$83b788b1a3698c03)(overrides)) id = "".concat(id, "__").concat(JSON.stringify(overrides));
    var formatter = __datetimeFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.DateTimeFormat(targetLocale, (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, format, overrides));
        __datetimeFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ var $1b33d9be5d32e050$export$c77049eaf05b1508 = [
    "localeMatcher",
    "weekday",
    "era",
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "timeZoneName",
    "formatMatcher",
    "hour12",
    "timeZone",
    "dateStyle",
    "timeStyle",
    "calendar",
    "dayPeriod",
    "numberingSystem",
    "hourCycle",
    "fractionalSecondDigits"
];
/** @internal */ function $1b33d9be5d32e050$export$165524b21a0d6b5e() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $cv9Rk._)(args, 4), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2], arg4 = _args[3];
    var options = {};
    var overrides = {};
    var value;
    if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg1)) {
        // Only allow ISO strings - other date formats are often supported,
        // but may cause different results in different browsers.
        var matches = arg1.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
        if (!matches) throw $1b33d9be5d32e050$export$3d702f7ac45b0a6b($1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        // Some browsers can not parse the iso datetime separated by space,
        // this is a compromise solution by replace the 'T'/' ' with 'T'
        var dateTime = matches[3] ? matches[3].trim().startsWith("T") ? "".concat(matches[1].trim()).concat(matches[3].trim()) : "".concat(matches[1].trim(), "T").concat(matches[3].trim()) : matches[1].trim();
        value = new Date(dateTime);
        try {
            // This will fail if the date is not valid
            value.toISOString();
        } catch (e) {
            throw $1b33d9be5d32e050$export$3d702f7ac45b0a6b($1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_ISO_DATE_ARGUMENT);
        }
    } else if ((0, $66fbc42080b842e5$export$871608497c498473)(arg1)) {
        if (isNaN(arg1.getTime())) throw $1b33d9be5d32e050$export$3d702f7ac45b0a6b($1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_DATE_ARGUMENT);
        value = arg1;
    } else if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(arg1)) value = arg1;
    else throw $1b33d9be5d32e050$export$3d702f7ac45b0a6b($1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach(function(key) {
        if ($1b33d9be5d32e050$export$c77049eaf05b1508.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $1b33d9be5d32e050$export$5bc4fc7cf15d6ccd(ctx, locale, format) {
    var context = ctx;
    for(var key in format){
        var id = "".concat(locale, "__").concat(key);
        if (!context.__datetimeFormatters.has(id)) continue;
        context.__datetimeFormatters.delete(id);
    }
}
// implementation of `number` function
function $1b33d9be5d32e050$export$98e628dec113755e(context) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    var numberFormats = context.numberFormats, unresolving = context.unresolving, fallbackLocale = context.fallbackLocale, onWarn = context.onWarn, localeFallbacker = context.localeFallbacker;
    var __numberFormatters = context.__numberFormatters;
    var _parseNumberArgs_apply = (0, $cv9Rk._)($1b33d9be5d32e050$export$d0e2eec8b686cf72.apply(void 0, (0, $c6Xmf._)(args)), 4), key = _parseNumberArgs_apply[0], value = _parseNumberArgs_apply[1], options = _parseNumberArgs_apply[2], overrides = _parseNumberArgs_apply[3];
    var missingWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.missingWarn) ? options.missingWarn : context.missingWarn;
    var fallbackWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackWarn) ? options.fallbackWarn : context.fallbackWarn;
    var part = !!options.part;
    var locale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.locale) ? options.locale : context.locale;
    var locales = localeFallbacker(context, fallbackLocale, locale);
    if (!(0, $66fbc42080b842e5$export$844ec244b1367d54)(key) || key === "") return new Intl.NumberFormat(locale, overrides).format(value);
    // resolve format
    var numberFormat = {};
    var targetLocale;
    var format = null;
    var from = locale;
    var to = null;
    var type = "number format";
    for(var i = 0; i < locales.length; i++){
        targetLocale = to = locales[i];
        numberFormat = numberFormats[targetLocale] || {};
        format = numberFormat[key];
        if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(format)) break;
        $1b33d9be5d32e050$export$bc779048ece0c567(context, key, targetLocale, missingWarn, type); // eslint-disable-line @typescript-eslint/no-explicit-any
        from = to;
    }
    // checking format and target locale
    if (!(0, $66fbc42080b842e5$export$53b83ca8eaab0383)(format) || !(0, $66fbc42080b842e5$export$844ec244b1367d54)(targetLocale)) return unresolving ? $1b33d9be5d32e050$export$b7f13a18d1d0f835 : key;
    var id = "".concat(targetLocale, "__").concat(key);
    if (!(0, $66fbc42080b842e5$export$83b788b1a3698c03)(overrides)) id = "".concat(id, "__").concat(JSON.stringify(overrides));
    var formatter = __numberFormatters.get(id);
    if (!formatter) {
        formatter = new Intl.NumberFormat(targetLocale, (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, format, overrides));
        __numberFormatters.set(id, formatter);
    }
    return !part ? formatter.format(value) : formatter.formatToParts(value);
}
/** @internal */ var $1b33d9be5d32e050$export$c39a7c3789c46ed6 = [
    "localeMatcher",
    "style",
    "currency",
    "currencyDisplay",
    "currencySign",
    "useGrouping",
    "minimumIntegerDigits",
    "minimumFractionDigits",
    "maximumFractionDigits",
    "minimumSignificantDigits",
    "maximumSignificantDigits",
    "compactDisplay",
    "notation",
    "signDisplay",
    "unit",
    "unitDisplay",
    "roundingMode",
    "roundingPriority",
    "roundingIncrement",
    "trailingZeroDisplay"
];
/** @internal */ function $1b33d9be5d32e050$export$d0e2eec8b686cf72() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _args = (0, $cv9Rk._)(args, 4), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2], arg4 = _args[3];
    var options = {};
    var overrides = {};
    if (!(0, $66fbc42080b842e5$export$7e4aa119212bc614)(arg1)) throw $1b33d9be5d32e050$export$3d702f7ac45b0a6b($1b33d9be5d32e050$export$1d4dfd6045c40277.INVALID_ARGUMENT);
    var value = arg1;
    if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg2)) options.key = arg2;
    else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg2)) Object.keys(arg2).forEach(function(key) {
        if ($1b33d9be5d32e050$export$c39a7c3789c46ed6.includes(key)) overrides[key] = arg2[key];
        else options[key] = arg2[key];
    });
    if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg3)) options.locale = arg3;
    else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg3)) overrides = arg3;
    if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg4)) overrides = arg4;
    return [
        options.key || "",
        value,
        options,
        overrides
    ];
}
/** @internal */ function $1b33d9be5d32e050$export$6a8717b3043a4f23(ctx, locale, format) {
    var context = ctx;
    for(var key in format){
        var id = "".concat(locale, "__").concat(key);
        if (!context.__numberFormatters.has(id)) continue;
        context.__numberFormatters.delete(id);
    }
}
if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $66fbc42080b842e5$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;


parcelRequire("dggmT");
var $lIPIy = parcelRequire("lIPIy");
var $yQ0Ka = parcelRequire("yQ0Ka");
function $2234c616837e5fb9$export$5a2d366b2d9f38f6() {
    return $2234c616837e5fb9$export$c22522a4dfa48e9c().__VUE_DEVTOOLS_GLOBAL_HOOK__;
}
function $2234c616837e5fb9$export$c22522a4dfa48e9c() {
    // @ts-ignore
    return typeof navigator !== "undefined" && typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : {};
}
var $2234c616837e5fb9$export$bc32a04c49ed7464 = typeof Proxy === "function";


var $d7d504888ba6b535$export$b1499c3bd2a3f4df = "devtools-plugin:setup";
var $d7d504888ba6b535$export$a0897f44accbe922 = "plugin:settings:set";




var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $c6Xmf = parcelRequire("c6Xmf");


var $1e2631e5a160aabf$var$supported;
var $1e2631e5a160aabf$var$perf;
function $1e2631e5a160aabf$export$70d26280bc1ca547() {
    var _a;
    if ($1e2631e5a160aabf$var$supported !== undefined) return $1e2631e5a160aabf$var$supported;
    if (typeof window !== "undefined" && window.performance) {
        $1e2631e5a160aabf$var$supported = true;
        $1e2631e5a160aabf$var$perf = window.performance;
    } else if (typeof $parcel$global !== "undefined" && ((_a = $parcel$global.perf_hooks) === null || _a === void 0 ? void 0 : _a.performance)) {
        $1e2631e5a160aabf$var$supported = true;
        $1e2631e5a160aabf$var$perf = $parcel$global.perf_hooks.performance;
    } else $1e2631e5a160aabf$var$supported = false;
    return $1e2631e5a160aabf$var$supported;
}
function $1e2631e5a160aabf$export$461939dd4422153() {
    return $1e2631e5a160aabf$export$70d26280bc1ca547() ? $1e2631e5a160aabf$var$perf.now() : Date.now();
}


var $486c7e00e56ca2ca$export$5728f3776e9b2ac1 = /*#__PURE__*/ function() {
    "use strict";
    function ApiProxy(plugin, hook) {
        var _this = this;
        (0, $4GJKx._)(this, ApiProxy);
        this.target = null;
        this.targetQueue = [];
        this.onQueue = [];
        this.plugin = plugin;
        this.hook = hook;
        var defaultSettings = {};
        if (plugin.settings) for(var id in plugin.settings){
            var item = plugin.settings[id];
            defaultSettings[id] = item.defaultValue;
        }
        var localSettingsSaveId = "__vue-devtools-plugin-settings__".concat(plugin.id);
        var currentSettings = Object.assign({}, defaultSettings);
        try {
            var raw = localStorage.getItem(localSettingsSaveId);
            var data = JSON.parse(raw);
            Object.assign(currentSettings, data);
        } catch (e) {
        // noop
        }
        this.fallbacks = {
            getSettings: function() {
                return currentSettings;
            },
            setSettings: function(value) {
                try {
                    localStorage.setItem(localSettingsSaveId, JSON.stringify(value));
                } catch (e) {
                // noop
                }
                currentSettings = value;
            },
            now: function() {
                return (0, $1e2631e5a160aabf$export$461939dd4422153)();
            }
        };
        if (hook) hook.on((0, $d7d504888ba6b535$export$a0897f44accbe922), function(pluginId, value) {
            if (pluginId === _this.plugin.id) _this.fallbacks.setSettings(value);
        });
        this.proxiedOn = new Proxy({}, {
            get: function(_target, prop) {
                if (_this.target) return _this.target.on[prop];
                else return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    _this.onQueue.push({
                        method: prop,
                        args: args
                    });
                };
            }
        });
        this.proxiedTarget = new Proxy({}, {
            get: function(_target, prop) {
                if (_this.target) return _this.target[prop];
                else if (prop === "on") return _this.proxiedOn;
                else if (Object.keys(_this.fallbacks).includes(prop)) return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    var _this_fallbacks;
                    _this.targetQueue.push({
                        method: prop,
                        args: args,
                        resolve: function() {}
                    });
                    return (_this_fallbacks = _this.fallbacks)[prop].apply(_this_fallbacks, (0, $c6Xmf._)(args));
                };
                else return function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return new Promise(function(resolve) {
                        _this.targetQueue.push({
                            method: prop,
                            args: args,
                            resolve: resolve
                        });
                    });
                };
            }
        });
    }
    (0, $1wc17._)(ApiProxy, [
        {
            key: "setRealTarget",
            value: function setRealTarget(target) {
                var _this = this;
                return (0, $f330ac5f61e1368d$export$7c398597f8905a1)(function() {
                    var _this_target_on, _this_target, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, item, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, item1, _, err;
                    return (0, $f500ece5c74d6d3d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _this.target = target;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = _this.onQueue[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        item = _step.value;
                                        (_this_target_on = _this.target.on)[item.method].apply(_this_target_on, (0, $c6Xmf._)(item.args));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    6,
                                    7,
                                    8
                                ]);
                                _iterator1 = _this.targetQueue[Symbol.iterator]();
                                _state.label = 2;
                            case 2:
                                if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                                    3,
                                    5
                                ];
                                item1 = _step1.value;
                                _ = item1.resolve;
                                return [
                                    4,
                                    (_this_target = _this.target)[item1.method].apply(_this_target, (0, $c6Xmf._)(item1.args))
                                ];
                            case 3:
                                _.apply(item1, [
                                    _state.sent()
                                ]);
                                _state.label = 4;
                            case 4:
                                _iteratorNormalCompletion1 = true;
                                return [
                                    3,
                                    2
                                ];
                            case 5:
                                return [
                                    3,
                                    8
                                ];
                            case 6:
                                err = _state.sent();
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                                return [
                                    3,
                                    8
                                ];
                            case 7:
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                                return [
                                    7
                                ];
                            case 8:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            }
        }
    ]);
    return ApiProxy;
}();





function $29d63a5003645f5b$export$63b9a9bba9f20f3e(pluginDescriptor, setupFn) {
    var descriptor = pluginDescriptor;
    var target = (0, $2234c616837e5fb9$export$c22522a4dfa48e9c)();
    var hook = (0, $2234c616837e5fb9$export$5a2d366b2d9f38f6)();
    var enableProxy = (0, $2234c616837e5fb9$export$bc32a04c49ed7464) && descriptor.enableEarlyProxy;
    if (hook && (target.__VUE_DEVTOOLS_PLUGIN_API_AVAILABLE__ || !enableProxy)) hook.emit((0, $d7d504888ba6b535$export$b1499c3bd2a3f4df), pluginDescriptor, setupFn);
    else {
        var proxy = enableProxy ? new (0, $486c7e00e56ca2ca$export$5728f3776e9b2ac1)(descriptor, hook) : null;
        var list = target.__VUE_DEVTOOLS_PLUGINS__ = target.__VUE_DEVTOOLS_PLUGINS__ || [];
        list.push({
            pluginDescriptor: descriptor,
            setupFn: setupFn,
            proxy: proxy
        });
        if (proxy) setupFn(proxy.proxiedTarget);
    }
}


/*!
  * vue-devtools v9.2.2
  * (c) 2022 kazuya kawaguchi
  * Released under the MIT License.
  */ 
var $3sHb8 = parcelRequire("3sHb8");
var $522a53da754fcde0$var$_obj;
var $522a53da754fcde0$export$587da00aa063e3b8 = ($522a53da754fcde0$var$_obj = {}, (0, $3sHb8._)($522a53da754fcde0$var$_obj, "vue-devtools-plugin-vue-i18n" /* PLUGIN */ , "Vue I18n devtools"), (0, $3sHb8._)($522a53da754fcde0$var$_obj, "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ , "I18n Resources"), (0, $3sHb8._)($522a53da754fcde0$var$_obj, "vue-i18n-timeline" /* TIMELINE */ , "Vue I18n"), $522a53da754fcde0$var$_obj);
var $522a53da754fcde0$export$51fbf4f94c542453 = (0, $3sHb8._)({}, "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ , "Search for scopes ...");
var $522a53da754fcde0$export$9698bf68c8ec8b3c = (0, $3sHb8._)({}, "vue-i18n-timeline" /* TIMELINE */ , 0xffcd19);


/**
 * Vue I18n Version
 *
 * @remarks
 * Semver format. Same format as the package.json `version` field.
 *
 * @VueI18nGeneral
 */ var $621d7fdcae12fe9c$export$a4ad2735b021c132 = "9.2.2";
/**
 * This is only called in esm-bundler builds.
 * istanbul-ignore-next
 */ function $621d7fdcae12fe9c$var$initFeatureFlags() {
    var needWarn = false;
    if (typeof __VUE_I18N_FULL_INSTALL__ !== "boolean") {
        needWarn = true;
        (0, $66fbc42080b842e5$export$ff5f2eeb11fc7e14)().__VUE_I18N_FULL_INSTALL__ = true;
    }
    if (typeof __VUE_I18N_LEGACY_API__ !== "boolean") {
        needWarn = true;
        (0, $66fbc42080b842e5$export$ff5f2eeb11fc7e14)().__VUE_I18N_LEGACY_API__ = true;
    }
    if (typeof __INTLIFY_PROD_DEVTOOLS__ !== "boolean") (0, $66fbc42080b842e5$export$ff5f2eeb11fc7e14)().__INTLIFY_PROD_DEVTOOLS__ = false;
}
var $621d7fdcae12fe9c$var$code$1 = (0, $1b33d9be5d32e050$export$b6a676a18b27d4c8).__EXTEND_POINT__;
var $621d7fdcae12fe9c$var$inc$1 = function() {
    return ++$621d7fdcae12fe9c$var$code$1;
};
var $621d7fdcae12fe9c$var$I18nWarnCodes = {
    FALLBACK_TO_ROOT: $621d7fdcae12fe9c$var$code$1,
    NOT_SUPPORTED_PRESERVE: $621d7fdcae12fe9c$var$inc$1(),
    NOT_SUPPORTED_FORMATTER: $621d7fdcae12fe9c$var$inc$1(),
    NOT_SUPPORTED_PRESERVE_DIRECTIVE: $621d7fdcae12fe9c$var$inc$1(),
    NOT_SUPPORTED_GET_CHOICE_INDEX: $621d7fdcae12fe9c$var$inc$1(),
    COMPONENT_NAME_LEGACY_COMPATIBLE: $621d7fdcae12fe9c$var$inc$1(),
    NOT_FOUND_PARENT_SCOPE: $621d7fdcae12fe9c$var$inc$1() // 13
};
var $621d7fdcae12fe9c$var$_obj;
var $621d7fdcae12fe9c$var$warnMessages = ($621d7fdcae12fe9c$var$_obj = {}, (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj, $621d7fdcae12fe9c$var$I18nWarnCodes.FALLBACK_TO_ROOT, "Fall back to {type} '{key}' with root locale."), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj, $621d7fdcae12fe9c$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE, "Not supported 'preserve'."), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj, $621d7fdcae12fe9c$var$I18nWarnCodes.NOT_SUPPORTED_FORMATTER, "Not supported 'formatter'."), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj, $621d7fdcae12fe9c$var$I18nWarnCodes.NOT_SUPPORTED_PRESERVE_DIRECTIVE, "Not supported 'preserveDirectiveContent'."), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj, $621d7fdcae12fe9c$var$I18nWarnCodes.NOT_SUPPORTED_GET_CHOICE_INDEX, "Not supported 'getChoiceIndex'."), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj, $621d7fdcae12fe9c$var$I18nWarnCodes.COMPONENT_NAME_LEGACY_COMPATIBLE, "Component name legacy compatible: '{name}' -> 'i18n'"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj, $621d7fdcae12fe9c$var$I18nWarnCodes.NOT_FOUND_PARENT_SCOPE, "Not found parent scope. use the global scope."), $621d7fdcae12fe9c$var$_obj);
function $621d7fdcae12fe9c$var$getWarnMessage(code) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $66fbc42080b842e5$export$d9468344d3651243).apply(void 0, [
        $621d7fdcae12fe9c$var$warnMessages[code]
    ].concat((0, $c6Xmf._)(args)));
}
var $621d7fdcae12fe9c$var$code = (0, $584cbe1b1d0d168a$export$77436aae039469c4).__EXTEND_POINT__;
var $621d7fdcae12fe9c$var$inc = function() {
    return ++$621d7fdcae12fe9c$var$code;
};
var $621d7fdcae12fe9c$var$I18nErrorCodes = {
    // composer module errors
    UNEXPECTED_RETURN_TYPE: $621d7fdcae12fe9c$var$code,
    // legacy module errors
    INVALID_ARGUMENT: $621d7fdcae12fe9c$var$inc(),
    // i18n module errors
    MUST_BE_CALL_SETUP_TOP: $621d7fdcae12fe9c$var$inc(),
    NOT_INSLALLED: $621d7fdcae12fe9c$var$inc(),
    NOT_AVAILABLE_IN_LEGACY_MODE: $621d7fdcae12fe9c$var$inc(),
    // directive module errors
    REQUIRED_VALUE: $621d7fdcae12fe9c$var$inc(),
    INVALID_VALUE: $621d7fdcae12fe9c$var$inc(),
    // vue-devtools errors
    CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: $621d7fdcae12fe9c$var$inc(),
    NOT_INSLALLED_WITH_PROVIDE: $621d7fdcae12fe9c$var$inc(),
    // unexpected error
    UNEXPECTED_ERROR: $621d7fdcae12fe9c$var$inc(),
    // not compatible legacy vue-i18n constructor
    NOT_COMPATIBLE_LEGACY_VUE_I18N: $621d7fdcae12fe9c$var$inc(),
    // bridge support vue 2.x only
    BRIDGE_SUPPORT_VUE_2_ONLY: $621d7fdcae12fe9c$var$inc(),
    // need to define `i18n` option in `allowComposition: true` and `useScope: 'local' at `useI18n``
    MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION: $621d7fdcae12fe9c$var$inc(),
    // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
    NOT_AVAILABLE_COMPOSITION_IN_LEGACY: $621d7fdcae12fe9c$var$inc(),
    // for enhancement
    __EXTEND_POINT__: $621d7fdcae12fe9c$var$inc() // 29
};
function $621d7fdcae12fe9c$var$createI18nError(code) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return (0, $584cbe1b1d0d168a$export$21efa8bb37d5fecb)(code, null, undefined);
}
var $621d7fdcae12fe9c$var$_obj1;
var $621d7fdcae12fe9c$var$errorMessages = ($621d7fdcae12fe9c$var$_obj1 = {}, (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE, "Unexpected return type in composer"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.INVALID_ARGUMENT, "Invalid argument"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP, "Must be called at the top of a `setup` function"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.NOT_INSLALLED, "Need to install with `app.use` function"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR, "Unexpected error"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE, "Not available in legacy mode"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.REQUIRED_VALUE, "Required in value: {0}"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.INVALID_VALUE, "Invalid value"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN, "Cannot setup vue-devtools plugin"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE, "Need to install with `provide` function"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N, "Not compatible legacy VueI18n."), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.BRIDGE_SUPPORT_VUE_2_ONLY, "vue-i18n-bridge support Vue 2.x only"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION, "Must define ‘i18n’ option or custom block in Composition API with using local scope in Legacy API mode"), (0, $3sHb8._)($621d7fdcae12fe9c$var$_obj1, $621d7fdcae12fe9c$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY, "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"), $621d7fdcae12fe9c$var$_obj1);
var $621d7fdcae12fe9c$var$TransrateVNodeSymbol = /* #__PURE__*/ (0, $66fbc42080b842e5$export$cd133c5e04906ece)("__transrateVNode");
var $621d7fdcae12fe9c$var$DatetimePartsSymbol = /* #__PURE__*/ (0, $66fbc42080b842e5$export$cd133c5e04906ece)("__datetimeParts");
var $621d7fdcae12fe9c$var$NumberPartsSymbol = /* #__PURE__*/ (0, $66fbc42080b842e5$export$cd133c5e04906ece)("__numberParts");
var $621d7fdcae12fe9c$var$EnableEmitter = /* #__PURE__*/ (0, $66fbc42080b842e5$export$cd133c5e04906ece)("__enableEmitter");
var $621d7fdcae12fe9c$var$DisableEmitter = /* #__PURE__*/ (0, $66fbc42080b842e5$export$cd133c5e04906ece)("__disableEmitter");
var $621d7fdcae12fe9c$var$SetPluralRulesSymbol = (0, $66fbc42080b842e5$export$cd133c5e04906ece)("__setPluralRules");
(0, $66fbc42080b842e5$export$cd133c5e04906ece)("__intlifyMeta");
var $621d7fdcae12fe9c$var$InejctWithOption = /* #__PURE__*/ (0, $66fbc42080b842e5$export$cd133c5e04906ece)("__injectWithOption");
var $621d7fdcae12fe9c$var$__VUE_I18N_BRIDGE__ = "__VUE_I18N_BRIDGE__";
/* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Transform flat json in obj to normal json in obj
 */ function $621d7fdcae12fe9c$var$handleFlatJson(obj) {
    // check obj
    if (!(0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(obj)) return obj;
    for(var key in obj){
        // check key
        if (!(0, $66fbc42080b842e5$export$b5a638e9b3fff9f3)(obj, key)) continue;
        // handle for normal json
        if (!key.includes(".")) // recursive process value if value is also a object
        {
            if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(obj[key])) $621d7fdcae12fe9c$var$handleFlatJson(obj[key]);
        } else {
            // go to the last object
            var subKeys = key.split(".");
            var lastIndex = subKeys.length - 1;
            var currentObj = obj;
            for(var i = 0; i < lastIndex; i++){
                if (!(subKeys[i] in currentObj)) currentObj[subKeys[i]] = {};
                currentObj = currentObj[subKeys[i]];
            }
            // update last object value, delete old property
            currentObj[subKeys[lastIndex]] = obj[key];
            delete obj[key];
            // recursive process value if value is also a object
            if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(currentObj[subKeys[lastIndex]])) $621d7fdcae12fe9c$var$handleFlatJson(currentObj[subKeys[lastIndex]]);
        }
    }
    return obj;
}
function $621d7fdcae12fe9c$var$getLocaleMessages(locale, options) {
    var messages = options.messages, __i18n = options.__i18n, messageResolver = options.messageResolver, flatJson = options.flatJson;
    // prettier-ignore
    var ret = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(messages) ? messages : (0, $66fbc42080b842e5$export$43bee75e5e14138e)(__i18n) ? {} : (0, $3sHb8._)({}, locale, {});
    // merge locale messages of i18n custom block
    if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(__i18n)) __i18n.forEach(function(custom) {
        if ("locale" in custom && "resource" in custom) {
            var _$locale = custom.locale, resource = custom.resource;
            if (_$locale) {
                ret[_$locale] = ret[_$locale] || {};
                $621d7fdcae12fe9c$var$deepCopy(resource, ret[_$locale]);
            } else $621d7fdcae12fe9c$var$deepCopy(resource, ret);
        } else (0, $66fbc42080b842e5$export$844ec244b1367d54)(custom) && $621d7fdcae12fe9c$var$deepCopy(JSON.parse(custom), ret);
    });
    // handle messages for flat json
    if (messageResolver == null && flatJson) {
        for(var key in ret)if ((0, $66fbc42080b842e5$export$b5a638e9b3fff9f3)(ret, key)) $621d7fdcae12fe9c$var$handleFlatJson(ret[key]);
    }
    return ret;
}
var $621d7fdcae12fe9c$var$isNotObjectOrIsArray = function(val1) {
    return !(0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(val1) || (0, $66fbc42080b842e5$export$43bee75e5e14138e)(val1);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $621d7fdcae12fe9c$var$deepCopy(src, des) {
    // src and des should both be objects, and non of then can be a array
    if ($621d7fdcae12fe9c$var$isNotObjectOrIsArray(src) || $621d7fdcae12fe9c$var$isNotObjectOrIsArray(des)) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.INVALID_VALUE);
    for(var key in src)if ((0, $66fbc42080b842e5$export$b5a638e9b3fff9f3)(src, key)) {
        if ($621d7fdcae12fe9c$var$isNotObjectOrIsArray(src[key]) || $621d7fdcae12fe9c$var$isNotObjectOrIsArray(des[key])) // replace with src[key] when:
        // src[key] or des[key] is not a object, or
        // src[key] or des[key] is a array
        des[key] = src[key];
        else // src[key] and des[key] are both object, merge them
        $621d7fdcae12fe9c$var$deepCopy(src[key], des[key]);
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $621d7fdcae12fe9c$var$getComponentOptions(instance) {
    return instance.type;
}
function $621d7fdcae12fe9c$var$adjustI18nResources(global, options, componentOptions // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    var messages = (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.messages) ? options.messages : {};
    if ("__i18nGlobal" in componentOptions) messages = $621d7fdcae12fe9c$var$getLocaleMessages(global.locale.value, {
        messages: messages,
        __i18n: componentOptions.__i18nGlobal
    });
    // merge locale messages
    var locales = Object.keys(messages);
    if (locales.length) locales.forEach(function(locale) {
        global.mergeLocaleMessage(locale, messages[locale]);
    });
    // merge datetime formats
    if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.datetimeFormats)) {
        var locales1 = Object.keys(options.datetimeFormats);
        if (locales1.length) locales1.forEach(function(locale) {
            global.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
        });
    }
    // merge number formats
    if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(options.numberFormats)) {
        var locales2 = Object.keys(options.numberFormats);
        if (locales2.length) locales2.forEach(function(locale) {
            global.mergeNumberFormat(locale, options.numberFormats[locale]);
        });
    }
}
function $621d7fdcae12fe9c$var$createTextNode(key) {
    return (0, $lIPIy.createVNode)((0, $lIPIy.Text), null, key, 0);
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ // extend VNode interface
var $621d7fdcae12fe9c$var$DEVTOOLS_META = "__INTLIFY_META__";
var $621d7fdcae12fe9c$var$composerID = 0;
function $621d7fdcae12fe9c$var$defineCoreMissingHandler(missing) {
    return function(ctx, locale, key, type) {
        return missing(locale, key, (0, $lIPIy.getCurrentInstance)() || undefined, type);
    };
}
// for Intlify DevTools
var $621d7fdcae12fe9c$var$getMetaInfo = function() {
    var instance = (0, $lIPIy.getCurrentInstance)();
    var meta = null; // eslint-disable-line @typescript-eslint/no-explicit-any
    return instance && (meta = $621d7fdcae12fe9c$var$getComponentOptions(instance)[$621d7fdcae12fe9c$var$DEVTOOLS_META]) ? (0, $3sHb8._)({}, $621d7fdcae12fe9c$var$DEVTOOLS_META, meta) : null;
};
/**
 * Create composer interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $621d7fdcae12fe9c$var$createComposer() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, VueI18nLegacy = arguments.length > 1 ? arguments[1] : void 0;
    var trackReactivityValues = // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    };
    var getPostTranslationHandler = // getPostTranslationHandler
    function getPostTranslationHandler() {
        return (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(_postTranslation) ? _postTranslation : null;
    };
    var setPostTranslationHandler = // setPostTranslationHandler
    function setPostTranslationHandler(handler1) {
        _postTranslation = handler1;
        _context.postTranslation = handler1;
    };
    var getMissingHandler = // getMissingHandler
    function getMissingHandler() {
        return _missing;
    };
    var setMissingHandler = // setMissingHandler
    function setMissingHandler(handler1) {
        if (handler1 !== null) _runtimeMissing = $621d7fdcae12fe9c$var$defineCoreMissingHandler(handler1);
        _missing = handler1;
        _context.missing = _runtimeMissing;
    };
    var isResolvedTranslateMessage = function isResolvedTranslateMessage(type, arg // eslint-disable-line @typescript-eslint/no-explicit-any
    ) {
        return type !== "translate" || !arg.resolvedMessage;
    };
    var t = // t
    function t() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $1b33d9be5d32e050$export$d73ee8ef04f5226a), null, [
                context
            ].concat((0, $c6Xmf._)(args)));
        }, function() {
            return (0, $1b33d9be5d32e050$export$8d9616744e22681a).apply(void 0, (0, $c6Xmf._)(args));
        }, "translate", function(root) {
            return Reflect.apply(root.t, root, (0, $c6Xmf._)(args));
        }, function(key) {
            return key;
        }, function(val1) {
            return (0, $66fbc42080b842e5$export$844ec244b1367d54)(val1);
        });
    };
    var rt = // rt
    function rt() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _args = (0, $cv9Rk._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
        if (arg3 && !(0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(arg3)) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.INVALID_ARGUMENT);
        return t.apply(void 0, [
            arg1,
            arg2,
            (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({
                resolvedMessage: true
            }, arg3 || {})
        ]);
    };
    var d = // d
    function d() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $1b33d9be5d32e050$export$7ba4466dbd0f07e1), null, [
                context
            ].concat((0, $c6Xmf._)(args)));
        }, function() {
            return (0, $1b33d9be5d32e050$export$165524b21a0d6b5e).apply(void 0, (0, $c6Xmf._)(args));
        }, "datetime format", function(root) {
            return Reflect.apply(root.d, root, (0, $c6Xmf._)(args));
        }, function() {
            return 0, $1b33d9be5d32e050$export$a04371e9dbb3870b;
        }, function(val1) {
            return (0, $66fbc42080b842e5$export$844ec244b1367d54)(val1);
        });
    };
    var n = // n
    function n() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $1b33d9be5d32e050$export$98e628dec113755e), null, [
                context
            ].concat((0, $c6Xmf._)(args)));
        }, function() {
            return (0, $1b33d9be5d32e050$export$d0e2eec8b686cf72).apply(void 0, (0, $c6Xmf._)(args));
        }, "number format", function(root) {
            return Reflect.apply(root.n, root, (0, $c6Xmf._)(args));
        }, function() {
            return 0, $1b33d9be5d32e050$export$a04371e9dbb3870b;
        }, function(val1) {
            return (0, $66fbc42080b842e5$export$844ec244b1367d54)(val1);
        });
    };
    var normalize = // for custom processor
    function normalize(values) {
        return values.map(function(val1) {
            return (0, $66fbc42080b842e5$export$844ec244b1367d54)(val1) || (0, $66fbc42080b842e5$export$7e4aa119212bc614)(val1) || (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(val1) ? $621d7fdcae12fe9c$var$createTextNode(String(val1)) : val1;
        });
    };
    var transrateVNode = // transrateVNode, using for `i18n-t` component
    function transrateVNode() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _root;
        return wrapWithDeps(function(context) {
            var ret;
            var _context = context;
            try {
                _context.processor = processor;
                ret = Reflect.apply((0, $1b33d9be5d32e050$export$d73ee8ef04f5226a), null, [
                    _context
                ].concat((0, $c6Xmf._)(args)));
            } finally{
                _context.processor = null;
            }
            return ret;
        }, function() {
            return (0, $1b33d9be5d32e050$export$8d9616744e22681a).apply(void 0, (0, $c6Xmf._)(args));
        }, "translate", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function(root) {
            return (_root = root)[$621d7fdcae12fe9c$var$TransrateVNodeSymbol].apply(_root, (0, $c6Xmf._)(args));
        }, function(key) {
            return [
                $621d7fdcae12fe9c$var$createTextNode(key)
            ];
        }, function(val1) {
            return (0, $66fbc42080b842e5$export$43bee75e5e14138e)(val1);
        });
    };
    var numberParts = // numberParts, using for `i18n-n` component
    function numberParts() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _root;
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $1b33d9be5d32e050$export$98e628dec113755e), null, [
                context
            ].concat((0, $c6Xmf._)(args)));
        }, function() {
            return (0, $1b33d9be5d32e050$export$d0e2eec8b686cf72).apply(void 0, (0, $c6Xmf._)(args));
        }, "number format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function(root) {
            return (_root = root)[$621d7fdcae12fe9c$var$NumberPartsSymbol].apply(_root, (0, $c6Xmf._)(args));
        }, function() {
            return [];
        }, function(val1) {
            return (0, $66fbc42080b842e5$export$844ec244b1367d54)(val1) || (0, $66fbc42080b842e5$export$43bee75e5e14138e)(val1);
        });
    };
    var datetimeParts = // datetimeParts, using for `i18n-d` component
    function datetimeParts() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _root;
        return wrapWithDeps(function(context) {
            return Reflect.apply((0, $1b33d9be5d32e050$export$7ba4466dbd0f07e1), null, [
                context
            ].concat((0, $c6Xmf._)(args)));
        }, function() {
            return (0, $1b33d9be5d32e050$export$165524b21a0d6b5e).apply(void 0, (0, $c6Xmf._)(args));
        }, "datetime format", // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function(root) {
            return (_root = root)[$621d7fdcae12fe9c$var$DatetimePartsSymbol].apply(_root, (0, $c6Xmf._)(args));
        }, function() {
            return [];
        }, function(val1) {
            return (0, $66fbc42080b842e5$export$844ec244b1367d54)(val1) || (0, $66fbc42080b842e5$export$43bee75e5e14138e)(val1);
        });
    };
    var setPluralRules = function setPluralRules(rules) {
        _pluralRules = rules;
        _context.pluralRules = _pluralRules;
    };
    var te = // te
    function te(key, locale) {
        var targetLocale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(locale) ? locale : _locale.value;
        var message = getLocaleMessage(targetLocale);
        return _context.messageResolver(message, key) !== null;
    };
    var resolveMessages = function resolveMessages(key) {
        var messages = null;
        var locales = (0, $1b33d9be5d32e050$export$71df9db82dc445)(_context, _fallbackLocale.value, _locale.value);
        for(var i = 0; i < locales.length; i++){
            var targetLocaleMessages = _messages.value[locales[i]] || {};
            var messageValue = _context.messageResolver(targetLocaleMessages, key);
            if (messageValue != null) {
                messages = messageValue;
                break;
            }
        }
        return messages;
    };
    var tm = // tm
    function tm(key) {
        var messages = resolveMessages(key);
        // prettier-ignore
        return messages != null ? messages : __root ? __root.tm(key) || {} : {};
    };
    var getLocaleMessage = // getLocaleMessage
    function getLocaleMessage(locale) {
        return _messages.value[locale] || {};
    };
    var setLocaleMessage = // setLocaleMessage
    function setLocaleMessage(locale, message) {
        _messages.value[locale] = message;
        _context.messages = _messages.value;
    };
    var mergeLocaleMessage = // mergeLocaleMessage
    function mergeLocaleMessage(locale, message) {
        _messages.value[locale] = _messages.value[locale] || {};
        $621d7fdcae12fe9c$var$deepCopy(message, _messages.value[locale]);
        _context.messages = _messages.value;
    };
    var getDateTimeFormat = // getDateTimeFormat
    function getDateTimeFormat(locale) {
        return _datetimeFormats.value[locale] || {};
    };
    var setDateTimeFormat = // setDateTimeFormat
    function setDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = format;
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $1b33d9be5d32e050$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    };
    var mergeDateTimeFormat = // mergeDateTimeFormat
    function mergeDateTimeFormat(locale, format) {
        _datetimeFormats.value[locale] = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)(_datetimeFormats.value[locale] || {}, format);
        _context.datetimeFormats = _datetimeFormats.value;
        (0, $1b33d9be5d32e050$export$5bc4fc7cf15d6ccd)(_context, locale, format);
    };
    var getNumberFormat = // getNumberFormat
    function getNumberFormat(locale) {
        return _numberFormats.value[locale] || {};
    };
    var setNumberFormat = // setNumberFormat
    function setNumberFormat(locale, format) {
        _numberFormats.value[locale] = format;
        _context.numberFormats = _numberFormats.value;
        (0, $1b33d9be5d32e050$export$6a8717b3043a4f23)(_context, locale, format);
    };
    var mergeNumberFormat = // mergeNumberFormat
    function mergeNumberFormat(locale, format) {
        _numberFormats.value[locale] = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)(_numberFormats.value[locale] || {}, format);
        _context.numberFormats = _numberFormats.value;
        (0, $1b33d9be5d32e050$export$6a8717b3043a4f23)(_context, locale, format);
    };
    var __root = options.__root;
    var _isGlobal = __root === undefined;
    var _inheritLocale = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    var _locale = (0, $yQ0Ka.ref)(// prettier-ignore
    __root && _inheritLocale ? __root.locale.value : (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $1b33d9be5d32e050$export$1af4c7e47ad72f44));
    var _fallbackLocale = (0, $yQ0Ka.ref)(// prettier-ignore
    __root && _inheritLocale ? __root.fallbackLocale.value : (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    var _messages = (0, $yQ0Ka.ref)($621d7fdcae12fe9c$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    var _datetimeFormats = (0, $yQ0Ka.ref)((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : (0, $3sHb8._)({}, _locale.value, {}));
    // prettier-ignore
    var _numberFormats = (0, $yQ0Ka.ref)((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : (0, $3sHb8._)({}, _locale.value, {}));
    // warning suppress options
    // prettier-ignore
    var _missingWarn = __root ? __root.missingWarn : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    var _fallbackWarn = __root ? __root.fallbackWarn : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    var _fallbackRoot = __root ? __root.fallbackRoot : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    var _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    var _missing = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    var _runtimeMissing = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.missing) ? $621d7fdcae12fe9c$var$defineCoreMissingHandler(options.missing) : null;
    // postTranslation handler
    var _postTranslation = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    var _warnHtmlMessage = __root ? __root.warnHtmlMessage : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    var _escapeParameter = !!options.escapeParameter;
    // custom linked modifiers
    // prettier-ignore
    var _modifiers = __root ? __root.modifiers : (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    var _pluralRules = options.pluralRules || __root && __root.pluralRules;
    // runtime context
    // eslint-disable-next-line prefer-const
    var _context;
    var getCoreContext = function() {
        _isGlobal && (0, $1b33d9be5d32e050$export$e16aca6786e72a5e)(null);
        var ctxOptions = {
            version: $621d7fdcae12fe9c$export$a4ad2735b021c132,
            locale: _locale.value,
            fallbackLocale: _fallbackLocale.value,
            messages: _messages.value,
            modifiers: _modifiers,
            pluralRules: _pluralRules,
            missing: _runtimeMissing === null ? undefined : _runtimeMissing,
            missingWarn: _missingWarn,
            fallbackWarn: _fallbackWarn,
            fallbackFormat: _fallbackFormat,
            unresolving: true,
            postTranslation: _postTranslation === null ? undefined : _postTranslation,
            warnHtmlMessage: _warnHtmlMessage,
            escapeParameter: _escapeParameter,
            messageResolver: options.messageResolver,
            __meta: {
                framework: "vue"
            }
        };
        ctxOptions.datetimeFormats = _datetimeFormats.value;
        ctxOptions.numberFormats = _numberFormats.value;
        ctxOptions.__datetimeFormatters = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(_context) ? _context.__datetimeFormatters : undefined;
        ctxOptions.__numberFormatters = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(_context) ? _context.__numberFormatters : undefined;
        var ctx = (0, $1b33d9be5d32e050$export$3599d465b05a74a5)(ctxOptions);
        _isGlobal && (0, $1b33d9be5d32e050$export$e16aca6786e72a5e)(ctx);
        return ctx;
    };
    _context = getCoreContext();
    (0, $1b33d9be5d32e050$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
    // locale
    var locale = (0, $yQ0Ka.computed)({
        get: function() {
            return _locale.value;
        },
        set: function(val1) {
            _locale.value = val1;
            _context.locale = _locale.value;
        }
    });
    // fallbackLocale
    var fallbackLocale = (0, $yQ0Ka.computed)({
        get: function() {
            return _fallbackLocale.value;
        },
        set: function(val1) {
            _fallbackLocale.value = val1;
            _context.fallbackLocale = _fallbackLocale.value;
            (0, $1b33d9be5d32e050$export$c743ad8a3cc01530)(_context, _locale.value, val1);
        }
    });
    // messages
    var messages = (0, $yQ0Ka.computed)(function() {
        return _messages.value;
    });
    // datetimeFormats
    var datetimeFormats = /* #__PURE__*/ (0, $yQ0Ka.computed)(function() {
        return _datetimeFormats.value;
    });
    // numberFormats
    var numberFormats = /* #__PURE__*/ (0, $yQ0Ka.computed)(function() {
        return _numberFormats.value;
    });
    var wrapWithDeps = function(fn, argumentParser, warnType, fallbackSuccess, fallbackFail, successCondition) {
        trackReactivityValues(); // track reactive dependency
        // NOTE: experimental !!
        var ret;
        if (__INTLIFY_PROD_DEVTOOLS__) try {
            (0, $1b33d9be5d32e050$export$605703447dca72aa)($621d7fdcae12fe9c$var$getMetaInfo());
            if (!_isGlobal) _context.fallbackContext = __root ? (0, $1b33d9be5d32e050$export$3adddc434faa9e35)() : undefined;
            ret = fn(_context);
        } finally{
            (0, $1b33d9be5d32e050$export$605703447dca72aa)(null);
            if (!_isGlobal) _context.fallbackContext = undefined;
        }
        else ret = fn(_context);
        if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(ret) && ret === (0, $1b33d9be5d32e050$export$b7f13a18d1d0f835)) {
            var _argumentParser = (0, $cv9Rk._)(argumentParser(), 2), key = _argumentParser[0], arg2 = _argumentParser[1];
            return __root && _fallbackRoot ? fallbackSuccess(__root) : fallbackFail(key);
        } else if (successCondition(ret)) return ret;
        else /* istanbul ignore next */ throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_RETURN_TYPE);
    };
    var interpolate = function(val1) {
        return val1;
    };
    var processor = {
        normalize: normalize,
        interpolate: interpolate,
        type: "vnode"
    };
    // for debug
    $621d7fdcae12fe9c$var$composerID++;
    // watch root locale & fallbackLocale
    if (__root && (0, $66fbc42080b842e5$export$620a268685f0ac45)) {
        (0, $lIPIy.watch)(__root.locale, function(val1) {
            if (_inheritLocale) {
                _locale.value = val1;
                _context.locale = val1;
                (0, $1b33d9be5d32e050$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
        (0, $lIPIy.watch)(__root.fallbackLocale, function(val1) {
            if (_inheritLocale) {
                _fallbackLocale.value = val1;
                _context.fallbackLocale = val1;
                (0, $1b33d9be5d32e050$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        });
    }
    // define basic composition API!
    var composer = (0, $3sHb8._)({
        id: $621d7fdcae12fe9c$var$composerID,
        locale: locale,
        fallbackLocale: fallbackLocale,
        get inheritLocale () {
            return _inheritLocale;
        },
        set inheritLocale (val){
            _inheritLocale = val;
            if (val && __root) {
                _locale.value = __root.locale.value;
                _fallbackLocale.value = __root.fallbackLocale.value;
                (0, $1b33d9be5d32e050$export$c743ad8a3cc01530)(_context, _locale.value, _fallbackLocale.value);
            }
        },
        get availableLocales () {
            return Object.keys(_messages.value).sort();
        },
        messages: messages,
        get modifiers () {
            return _modifiers;
        },
        get pluralRules () {
            return _pluralRules || {};
        },
        get isGlobal () {
            return _isGlobal;
        },
        get missingWarn () {
            return _missingWarn;
        },
        set missingWarn (val){
            _missingWarn = val;
            _context.missingWarn = _missingWarn;
        },
        get fallbackWarn () {
            return _fallbackWarn;
        },
        set fallbackWarn (val){
            _fallbackWarn = val;
            _context.fallbackWarn = _fallbackWarn;
        },
        get fallbackRoot () {
            return _fallbackRoot;
        },
        set fallbackRoot (val){
            _fallbackRoot = val;
        },
        get fallbackFormat () {
            return _fallbackFormat;
        },
        set fallbackFormat (val){
            _fallbackFormat = val;
            _context.fallbackFormat = _fallbackFormat;
        },
        get warnHtmlMessage () {
            return _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            _warnHtmlMessage = val;
            _context.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _escapeParameter;
        },
        set escapeParameter (val){
            _escapeParameter = val;
            _context.escapeParameter = val;
        },
        t: t,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler
    }, $621d7fdcae12fe9c$var$SetPluralRulesSymbol, setPluralRules);
    composer.datetimeFormats = datetimeFormats;
    composer.numberFormats = numberFormats;
    composer.rt = rt;
    composer.te = te;
    composer.tm = tm;
    composer.d = d;
    composer.n = n;
    composer.getDateTimeFormat = getDateTimeFormat;
    composer.setDateTimeFormat = setDateTimeFormat;
    composer.mergeDateTimeFormat = mergeDateTimeFormat;
    composer.getNumberFormat = getNumberFormat;
    composer.setNumberFormat = setNumberFormat;
    composer.mergeNumberFormat = mergeNumberFormat;
    composer[$621d7fdcae12fe9c$var$InejctWithOption] = options.__injectWithOption;
    composer[$621d7fdcae12fe9c$var$TransrateVNodeSymbol] = transrateVNode;
    composer[$621d7fdcae12fe9c$var$DatetimePartsSymbol] = datetimeParts;
    composer[$621d7fdcae12fe9c$var$NumberPartsSymbol] = numberParts;
    var emitter;
    return composer;
}
/* eslint-enable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Convert to I18n Composer Options from VueI18n Options
 *
 * @internal
 */ function $621d7fdcae12fe9c$var$convertComposerOptions(options) {
    var locale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $1b33d9be5d32e050$export$1af4c7e47ad72f44);
    var fallbackLocale = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : locale;
    var missing = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.missing) ? options.missing : undefined;
    var missingWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.silentTranslationWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.silentTranslationWarn) ? !options.silentTranslationWarn : true;
    var fallbackWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.silentFallbackWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.silentFallbackWarn) ? !options.silentFallbackWarn : true;
    var fallbackRoot = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    var fallbackFormat = !!options.formatFallbackMessages;
    var modifiers = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    var pluralizationRules = options.pluralizationRules;
    var postTranslation = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : undefined;
    var warnHtmlMessage = (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.warnHtmlInMessage) ? options.warnHtmlInMessage !== "off" : true;
    var escapeParameter = !!options.escapeParameterHtml;
    var inheritLocale = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.sync) ? options.sync : true;
    var messages = options.messages;
    if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.sharedMessages)) {
        var sharedMessages = options.sharedMessages;
        var locales = Object.keys(sharedMessages);
        messages = locales.reduce(function(messages, locale) {
            var message = messages[locale] || (messages[locale] = {});
            (0, $66fbc42080b842e5$export$e6e34fd1f2686227)(message, sharedMessages[locale]);
            return messages;
        }, messages || {});
    }
    var __i18n = options.__i18n, __root = options.__root, __injectWithOption = options.__injectWithOption;
    var datetimeFormats = options.datetimeFormats;
    var numberFormats = options.numberFormats;
    var flatJson = options.flatJson;
    return {
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        flatJson: flatJson,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        missing: missing,
        missingWarn: missingWarn,
        fallbackWarn: fallbackWarn,
        fallbackRoot: fallbackRoot,
        fallbackFormat: fallbackFormat,
        modifiers: modifiers,
        pluralRules: pluralizationRules,
        postTranslation: postTranslation,
        warnHtmlMessage: warnHtmlMessage,
        escapeParameter: escapeParameter,
        messageResolver: options.messageResolver,
        inheritLocale: inheritLocale,
        __i18n: __i18n,
        __root: __root,
        __injectWithOption: __injectWithOption
    };
}
/**
 * create VueI18n interface factory
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $621d7fdcae12fe9c$var$createVueI18n() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, VueI18nLegacy = arguments.length > 1 ? arguments[1] : void 0;
    {
        var composer = $621d7fdcae12fe9c$var$createComposer($621d7fdcae12fe9c$var$convertComposerOptions(options));
        // defines VueI18n
        var vueI18n = {
            // id
            id: composer.id,
            // locale
            get locale () {
                return composer.locale.value;
            },
            set locale (val){
                composer.locale.value = val;
            },
            // fallbackLocale
            get fallbackLocale () {
                return composer.fallbackLocale.value;
            },
            set fallbackLocale (val){
                composer.fallbackLocale.value = val;
            },
            // messages
            get messages () {
                return composer.messages.value;
            },
            // datetimeFormats
            get datetimeFormats () {
                return composer.datetimeFormats.value;
            },
            // numberFormats
            get numberFormats () {
                return composer.numberFormats.value;
            },
            // availableLocales
            get availableLocales () {
                return composer.availableLocales;
            },
            // formatter
            get formatter () {
                // dummy
                return {
                    interpolate: function() {
                        return [];
                    }
                };
            },
            set formatter (val){},
            // missing
            get missing () {
                return composer.getMissingHandler();
            },
            set missing (handler){
                composer.setMissingHandler(handler);
            },
            // silentTranslationWarn
            get silentTranslationWarn () {
                return (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(composer.missingWarn) ? !composer.missingWarn : composer.missingWarn;
            },
            set silentTranslationWarn (val){
                composer.missingWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // silentFallbackWarn
            get silentFallbackWarn () {
                return (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(composer.fallbackWarn) ? !composer.fallbackWarn : composer.fallbackWarn;
            },
            set silentFallbackWarn (val){
                composer.fallbackWarn = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(val) ? !val : val;
            },
            // modifiers
            get modifiers () {
                return composer.modifiers;
            },
            // formatFallbackMessages
            get formatFallbackMessages () {
                return composer.fallbackFormat;
            },
            set formatFallbackMessages (val){
                composer.fallbackFormat = val;
            },
            // postTranslation
            get postTranslation () {
                return composer.getPostTranslationHandler();
            },
            set postTranslation (handler){
                composer.setPostTranslationHandler(handler);
            },
            // sync
            get sync () {
                return composer.inheritLocale;
            },
            set sync (val){
                composer.inheritLocale = val;
            },
            // warnInHtmlMessage
            get warnHtmlInMessage () {
                return composer.warnHtmlMessage ? "warn" : "off";
            },
            set warnHtmlInMessage (val){
                composer.warnHtmlMessage = val !== "off";
            },
            // escapeParameterHtml
            get escapeParameterHtml () {
                return composer.escapeParameter;
            },
            set escapeParameterHtml (val){
                composer.escapeParameter = val;
            },
            // preserveDirectiveContent
            get preserveDirectiveContent () {
                return true;
            },
            set preserveDirectiveContent (val){},
            // pluralizationRules
            get pluralizationRules () {
                return composer.pluralRules || {};
            },
            // for internal
            __composer: composer,
            // t
            t: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _args = (0, $cv9Rk._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
                var options = {};
                var list = null;
                var named = null;
                if (!(0, $66fbc42080b842e5$export$844ec244b1367d54)(arg1)) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.INVALID_ARGUMENT);
                var key = arg1;
                if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            rt: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Reflect.apply(composer.rt, composer, (0, $c6Xmf._)(args));
            },
            // tc
            tc: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _args = (0, $cv9Rk._)(args, 3), arg1 = _args[0], arg2 = _args[1], arg3 = _args[2];
                var options = {
                    plural: 1
                };
                var list = null;
                var named = null;
                if (!(0, $66fbc42080b842e5$export$844ec244b1367d54)(arg1)) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.INVALID_ARGUMENT);
                var key = arg1;
                if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg2)) options.locale = arg2;
                else if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(arg2)) options.plural = arg2;
                else if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(arg2)) list = arg2;
                else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg2)) named = arg2;
                if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(arg3)) options.locale = arg3;
                else if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(arg3)) list = arg3;
                else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(arg3)) named = arg3;
                // return composer.t(key, (list || named || {}) as any, options)
                return Reflect.apply(composer.t, composer, [
                    key,
                    list || named || {},
                    options
                ]);
            },
            // te
            te: function(key, locale) {
                return composer.te(key, locale);
            },
            // tm
            tm: function(key) {
                return composer.tm(key);
            },
            // getLocaleMessage
            getLocaleMessage: function(locale) {
                return composer.getLocaleMessage(locale);
            },
            // setLocaleMessage
            setLocaleMessage: function(locale, message) {
                composer.setLocaleMessage(locale, message);
            },
            // mergeLocaleMessage
            mergeLocaleMessage: function(locale, message) {
                composer.mergeLocaleMessage(locale, message);
            },
            // d
            d: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Reflect.apply(composer.d, composer, (0, $c6Xmf._)(args));
            },
            // getDateTimeFormat
            getDateTimeFormat: function(locale) {
                return composer.getDateTimeFormat(locale);
            },
            // setDateTimeFormat
            setDateTimeFormat: function(locale, format) {
                composer.setDateTimeFormat(locale, format);
            },
            // mergeDateTimeFormat
            mergeDateTimeFormat: function(locale, format) {
                composer.mergeDateTimeFormat(locale, format);
            },
            // n
            n: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return Reflect.apply(composer.n, composer, (0, $c6Xmf._)(args));
            },
            // getNumberFormat
            getNumberFormat: function(locale) {
                return composer.getNumberFormat(locale);
            },
            // setNumberFormat
            setNumberFormat: function(locale, format) {
                composer.setNumberFormat(locale, format);
            },
            // mergeNumberFormat
            mergeNumberFormat: function(locale, format) {
                composer.mergeNumberFormat(locale, format);
            },
            // getChoiceIndex
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            getChoiceIndex: function(choice, choicesLength) {
                return -1;
            },
            // for internal
            __onComponentInstanceCreated: function(target) {
                var componentInstanceCreatedListener = options.componentInstanceCreatedListener;
                if (componentInstanceCreatedListener) componentInstanceCreatedListener(target, vueI18n);
            }
        };
        var emitter;
        return vueI18n;
    }
}
/* eslint-enable @typescript-eslint/no-explicit-any */ var $621d7fdcae12fe9c$var$baseFormatProps = {
    tag: {
        type: [
            String,
            Object
        ]
    },
    locale: {
        type: String
    },
    scope: {
        type: String,
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        validator: function(val1 /* ComponetI18nScope */ ) {
            return val1 === "parent" || val1 === "global";
        },
        default: "parent" /* ComponetI18nScope */ 
    },
    i18n: {
        type: Object
    }
};
function $621d7fdcae12fe9c$var$getInterpolateArg(// eslint-disable-next-line @typescript-eslint/no-explicit-any
param, keys) {
    var slots = param.slots;
    if (keys.length === 1 && keys[0] === "default") {
        // default slot with list
        var ret = slots.default ? slots.default() : [];
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return ret.reduce(function(slot, current) {
            return slot = (0, $c6Xmf._)(slot).concat((0, $c6Xmf._)((0, $66fbc42080b842e5$export$43bee75e5e14138e)(current.children) ? current.children : [
                current
            ]));
        }, []);
    } else // named slots
    return keys.reduce(function(arg, key) {
        var slot = slots[key];
        if (slot) arg[key] = slot();
        return arg;
    }, {});
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $621d7fdcae12fe9c$var$getFragmentableTag(tag) {
    return 0, $lIPIy.Fragment;
}
/**
 * Translation Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [TranslationProps](component#translationprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Component Interpolation](../guide/advanced/component)
 *
 * @example
 * ```html
 * <div id="app">
 *   <!-- ... -->
 *   <i18n path="term" tag="label" for="tos">
 *     <a :href="url" target="_blank">{{ $t('tos') }}</a>
 *   </i18n>
 *   <!-- ... -->
 * </div>
 * ```
 * ```js
 * import { createApp } from 'vue'
 * import { createI18n } from 'vue-i18n'
 *
 * const messages = {
 *   en: {
 *     tos: 'Term of Service',
 *     term: 'I accept xxx {0}.'
 *   },
 *   ja: {
 *     tos: '利用規約',
 *     term: '私は xxx の{0}に同意します。'
 *   }
 * }
 *
 * const i18n = createI18n({
 *   locale: 'en',
 *   messages
 * })
 *
 * const app = createApp({
 *   data: {
 *     url: '/term'
 *   }
 * }).use(i18n).mount('#app')
 * ```
 *
 * @VueI18nComponent
 */ var $621d7fdcae12fe9c$export$b63289fbda65eed1 = /* defineComponent */ {
    /* eslint-disable */ name: "i18n-t",
    props: (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({
        keypath: {
            type: String,
            required: true
        },
        plural: {
            type: [
                Number,
                String
            ],
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            validator: function(val1) {
                return (0, $66fbc42080b842e5$export$7e4aa119212bc614)(val1) || !isNaN(val1);
            }
        }
    }, $621d7fdcae12fe9c$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup: function(props, context) {
        var slots = context.slots, attrs = context.attrs;
        // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
        var i18n = props.i18n || $621d7fdcae12fe9c$export$3f3caade1c12f8c9({
            useScope: props.scope,
            __useComponent: true
        });
        return function() {
            var keys = Object.keys(slots).filter(function(key) {
                return key !== "_";
            });
            var options = {};
            if (props.locale) options.locale = props.locale;
            if (props.plural !== undefined) options.plural = (0, $66fbc42080b842e5$export$844ec244b1367d54)(props.plural) ? +props.plural : props.plural;
            var arg = $621d7fdcae12fe9c$var$getInterpolateArg(context, keys);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var children = i18n[$621d7fdcae12fe9c$var$TransrateVNodeSymbol](props.keypath, arg, options);
            var assignedAttrs = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, attrs);
            var tag = (0, $66fbc42080b842e5$export$844ec244b1367d54)(props.tag) || (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $621d7fdcae12fe9c$var$getFragmentableTag();
            return (0, $lIPIy.h)(tag, assignedAttrs, children);
        };
    }
};
function $621d7fdcae12fe9c$var$isVNode(target) {
    return (0, $66fbc42080b842e5$export$43bee75e5e14138e)(target) && !(0, $66fbc42080b842e5$export$844ec244b1367d54)(target[0]);
}
function $621d7fdcae12fe9c$var$renderFormatter(props, context, slotKeys, partFormatter) {
    var slots = context.slots, attrs = context.attrs;
    return function() {
        var options = {
            part: true
        };
        var overrides = {};
        if (props.locale) options.locale = props.locale;
        if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(props.format)) options.key = props.format;
        else if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(props.format)) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(props.format.key)) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            options.key = props.format.key;
            // Filter out number format options only
            overrides = Object.keys(props.format).reduce(function(options, prop) {
                return slotKeys.includes(prop) ? (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, options, (0, $3sHb8._)({}, prop, props.format[prop])) // eslint-disable-line @typescript-eslint/no-explicit-any
                 : options;
            }, {});
        }
        var parts = partFormatter.apply(void 0, [
            props.value,
            options,
            overrides
        ]);
        var children = [
            options.key
        ];
        if ((0, $66fbc42080b842e5$export$43bee75e5e14138e)(parts)) children = parts.map(function(part, index) {
            var slot = slots[part.type];
            var _obj;
            var node = slot ? slot((_obj = {}, (0, $3sHb8._)(_obj, part.type, part.value), (0, $3sHb8._)(_obj, "index", index), (0, $3sHb8._)(_obj, "parts", parts), _obj)) : [
                part.value
            ];
            if ($621d7fdcae12fe9c$var$isVNode(node)) node[0].key = "".concat(part.type, "-").concat(index);
            return node;
        });
        else if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(parts)) children = [
            parts
        ];
        var assignedAttrs = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, attrs);
        var tag = (0, $66fbc42080b842e5$export$844ec244b1367d54)(props.tag) || (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(props.tag) ? props.tag : $621d7fdcae12fe9c$var$getFragmentableTag();
        return (0, $lIPIy.h)(tag, assignedAttrs, children);
    };
}
/**
 * Number Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/number#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.NumberFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-numberformat)
 *
 * @VueI18nComponent
 */ var $621d7fdcae12fe9c$export$27bce688931fdfcc = /* defineComponent */ {
    /* eslint-disable */ name: "i18n-n",
    props: (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({
        value: {
            type: Number,
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $621d7fdcae12fe9c$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup: function(props, context) {
        var // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _i18n;
        var i18n = props.i18n || $621d7fdcae12fe9c$export$3f3caade1c12f8c9({
            useScope: "parent",
            __useComponent: true
        });
        return $621d7fdcae12fe9c$var$renderFormatter(props, context, (0, $1b33d9be5d32e050$export$c39a7c3789c46ed6), function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (_i18n = i18n)[$621d7fdcae12fe9c$var$NumberPartsSymbol].apply(_i18n, (0, $c6Xmf._)(args));
        });
    }
};
/**
 * Datetime Format Component
 *
 * @remarks
 * See the following items for property about details
 *
 * @VueI18nSee [FormattableProps](component#formattableprops)
 * @VueI18nSee [BaseFormatProps](component#baseformatprops)
 * @VueI18nSee [Custom Formatting](../guide/essentials/datetime#custom-formatting)
 *
 * @VueI18nDanger
 * Not supported IE, due to no support `Intl.DateTimeFormat#formatToParts` in [IE](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/formatToParts)
 *
 * If you want to use it, you need to use [polyfill](https://github.com/formatjs/formatjs/tree/main/packages/intl-datetimeformat)
 *
 * @VueI18nComponent
 */ var $621d7fdcae12fe9c$export$64ca50867510e64e = /*defineComponent */ {
    /* eslint-disable */ name: "i18n-d",
    props: (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({
        value: {
            type: [
                Number,
                Date
            ],
            required: true
        },
        format: {
            type: [
                String,
                Object
            ]
        }
    }, $621d7fdcae12fe9c$var$baseFormatProps),
    /* eslint-enable */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setup: function(props, context) {
        var // eslint-disable-next-line @typescript-eslint/no-explicit-any
        _i18n;
        var i18n = props.i18n || $621d7fdcae12fe9c$export$3f3caade1c12f8c9({
            useScope: "parent",
            __useComponent: true
        });
        return $621d7fdcae12fe9c$var$renderFormatter(props, context, (0, $1b33d9be5d32e050$export$c77049eaf05b1508), function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (_i18n = i18n)[$621d7fdcae12fe9c$var$DatetimePartsSymbol].apply(_i18n, (0, $c6Xmf._)(args));
        });
    }
};
function $621d7fdcae12fe9c$var$getComposer$2(i18n, instance) {
    var i18nInternal = i18n;
    if (i18n.mode === "composition") return i18nInternal.__getInstance(instance) || i18n.global;
    else {
        var vueI18n = i18nInternal.__getInstance(instance);
        return vueI18n != null ? vueI18n.__composer : i18n.global.__composer;
    }
}
function $621d7fdcae12fe9c$export$8a5a05546006d0b5(i18n) {
    var _process = function(binding) {
        var instance = binding.instance, modifiers = binding.modifiers, value = binding.value;
        /* istanbul ignore if */ if (!instance || !instance.$) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR);
        var composer = $621d7fdcae12fe9c$var$getComposer$2(i18n, instance.$);
        var parsedValue = $621d7fdcae12fe9c$var$parseValue(value);
        return [
            Reflect.apply(composer.t, composer, (0, $c6Xmf._)($621d7fdcae12fe9c$var$makeParams(parsedValue))),
            composer
        ];
    };
    var register = function(el, binding) {
        var _process1 = (0, $cv9Rk._)(_process(binding), 2), textContent = _process1[0], composer = _process1[1];
        if ((0, $66fbc42080b842e5$export$620a268685f0ac45) && i18n.global === composer) // global scope only
        el.__i18nWatcher = (0, $lIPIy.watch)(composer.locale, function() {
            binding.instance && binding.instance.$forceUpdate();
        });
        el.__composer = composer;
        el.textContent = textContent;
    };
    var unregister = function(el) {
        if ((0, $66fbc42080b842e5$export$620a268685f0ac45) && el.__i18nWatcher) {
            el.__i18nWatcher();
            el.__i18nWatcher = undefined;
            delete el.__i18nWatcher;
        }
        if (el.__composer) {
            el.__composer = undefined;
            delete el.__composer;
        }
    };
    var update = function(el, param) {
        var value = param.value;
        if (el.__composer) {
            var composer = el.__composer;
            var parsedValue = $621d7fdcae12fe9c$var$parseValue(value);
            el.textContent = Reflect.apply(composer.t, composer, (0, $c6Xmf._)($621d7fdcae12fe9c$var$makeParams(parsedValue)));
        }
    };
    var getSSRProps = function(binding) {
        var _process1 = (0, $cv9Rk._)(_process(binding), 1), textContent = _process1[0];
        return {
            textContent: textContent
        };
    };
    return {
        created: register,
        unmounted: unregister,
        beforeUpdate: update,
        getSSRProps: getSSRProps
    };
}
function $621d7fdcae12fe9c$var$parseValue(value) {
    if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(value)) return {
        path: value
    };
    else if ((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(value)) {
        if (!("path" in value)) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.REQUIRED_VALUE, "path");
        return value;
    } else throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.INVALID_VALUE);
}
function $621d7fdcae12fe9c$var$makeParams(value) {
    var path = value.path, locale = value.locale, args = value.args, choice = value.choice, plural = value.plural;
    var options = {};
    var named = args || {};
    if ((0, $66fbc42080b842e5$export$844ec244b1367d54)(locale)) options.locale = locale;
    if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(choice)) options.plural = choice;
    if ((0, $66fbc42080b842e5$export$7e4aa119212bc614)(plural)) options.plural = plural;
    return [
        path,
        named,
        options
    ];
}
function $621d7fdcae12fe9c$var$apply(app, i18n) {
    for(var _len = arguments.length, options = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        options[_key - 2] = arguments[_key];
    }
    var pluginOptions = (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options[0]) ? options[0] : {};
    var useI18nComponentName = !!pluginOptions.useI18nComponentName;
    var globalInstall = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(pluginOptions.globalInstall) ? pluginOptions.globalInstall : true;
    if (globalInstall) {
        // install components
        app.component(!useI18nComponentName ? $621d7fdcae12fe9c$export$b63289fbda65eed1.name : "i18n", $621d7fdcae12fe9c$export$b63289fbda65eed1);
        app.component($621d7fdcae12fe9c$export$27bce688931fdfcc.name, $621d7fdcae12fe9c$export$27bce688931fdfcc);
        app.component($621d7fdcae12fe9c$export$64ca50867510e64e.name, $621d7fdcae12fe9c$export$64ca50867510e64e);
    }
    app.directive("t", $621d7fdcae12fe9c$export$8a5a05546006d0b5(i18n));
}
var $621d7fdcae12fe9c$var$VUE_I18N_COMPONENT_TYPES = "vue-i18n: composer properties";
var $621d7fdcae12fe9c$var$devtoolsApi;
function $621d7fdcae12fe9c$var$enableDevTools(app, i18n) {
    return $621d7fdcae12fe9c$var$_enableDevTools.apply(this, arguments);
}
function $621d7fdcae12fe9c$var$_enableDevTools() {
    $621d7fdcae12fe9c$var$_enableDevTools = (0, $f330ac5f61e1368d$export$7c398597f8905a1)(function(app, i18n) {
        return (0, $f500ece5c74d6d3d$export$67ebef60e6f28a6)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve, reject) {
                    try {
                        (0, $29d63a5003645f5b$export$63b9a9bba9f20f3e)({
                            id: "vue-devtools-plugin-vue-i18n" /* PLUGIN */ ,
                            label: (0, $522a53da754fcde0$export$587da00aa063e3b8)["vue-devtools-plugin-vue-i18n" /* PLUGIN */ ],
                            packageName: "vue-i18n",
                            homepage: "https://vue-i18n.intlify.dev",
                            logo: "https://vue-i18n.intlify.dev/vue-i18n-devtools-logo.png",
                            componentStateTypes: [
                                $621d7fdcae12fe9c$var$VUE_I18N_COMPONENT_TYPES
                            ],
                            app: app // eslint-disable-line @typescript-eslint/no-explicit-any
                        }, function(api) {
                            $621d7fdcae12fe9c$var$devtoolsApi = api;
                            api.on.visitComponentTree(function(param) {
                                var componentInstance = param.componentInstance, treeNode = param.treeNode;
                                $621d7fdcae12fe9c$var$updateComponentTreeTags(componentInstance, treeNode, i18n);
                            });
                            api.on.inspectComponent(function(param) {
                                var componentInstance = param.componentInstance, instanceData = param.instanceData;
                                if (componentInstance.vnode.el && componentInstance.vnode.el.__VUE_I18N__ && instanceData) {
                                    if (i18n.mode === "legacy") // ignore global scope on legacy mode
                                    {
                                        if (componentInstance.vnode.el.__VUE_I18N__ !== i18n.global.__composer) $621d7fdcae12fe9c$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                                    } else $621d7fdcae12fe9c$var$inspectComposer(instanceData, componentInstance.vnode.el.__VUE_I18N__);
                                }
                            });
                            api.addInspector({
                                id: "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ,
                                label: (0, $522a53da754fcde0$export$587da00aa063e3b8)["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ],
                                icon: "language",
                                treeFilterPlaceholder: (0, $522a53da754fcde0$export$51fbf4f94c542453)["vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ]
                            });
                            api.on.getInspectorTree(function(payload) {
                                if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ) $621d7fdcae12fe9c$var$registerScope(payload, i18n);
                            });
                            var roots = new Map();
                            api.on.getInspectorState(function() {
                                var _ref = (0, $f330ac5f61e1368d$export$7c398597f8905a1)(function(payload) {
                                    var _ref, root, instance;
                                    return (0, $f500ece5c74d6d3d$export$67ebef60e6f28a6)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ )) return [
                                                    3,
                                                    4
                                                ];
                                                api.unhighlightElement();
                                                $621d7fdcae12fe9c$var$inspectScope(payload, i18n);
                                                if (!(payload.nodeId === "global")) return [
                                                    3,
                                                    3
                                                ];
                                                if (!!roots.has(payload.app)) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    api.getComponentInstances(payload.app)
                                                ];
                                            case 1:
                                                _ref = (0, $cv9Rk._).apply(void 0, [
                                                    _state.sent(),
                                                    1
                                                ]), root = _ref[0];
                                                roots.set(payload.app, root);
                                                _state.label = 2;
                                            case 2:
                                                api.highlightElement(roots.get(payload.app));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                instance = $621d7fdcae12fe9c$var$getComponentInstance(payload.nodeId, i18n);
                                                instance && api.highlightElement(instance);
                                                _state.label = 4;
                                            case 4:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                });
                                return function(payload) {
                                    return _ref.apply(this, arguments);
                                };
                            }());
                            api.on.editInspectorState(function(payload) {
                                if (payload.app === app && payload.inspectorId === "vue-i18n-resource-inspector" /* CUSTOM_INSPECTOR */ ) $621d7fdcae12fe9c$var$editScope(payload, i18n);
                            });
                            api.addTimelineLayer({
                                id: "vue-i18n-timeline" /* TIMELINE */ ,
                                label: (0, $522a53da754fcde0$export$587da00aa063e3b8)["vue-i18n-timeline" /* TIMELINE */ ],
                                color: (0, $522a53da754fcde0$export$9698bf68c8ec8b3c)["vue-i18n-timeline" /* TIMELINE */ ]
                            });
                            resolve(true);
                        });
                    } catch (e) {
                        console.error(e);
                        reject(false);
                    }
                })
            ];
        });
    });
    return $621d7fdcae12fe9c$var$_enableDevTools.apply(this, arguments);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $621d7fdcae12fe9c$var$getI18nScopeLable(instance) {
    return instance.type.name || instance.type.displayName || instance.type.__file || "Anonymous";
}
function $621d7fdcae12fe9c$var$updateComponentTreeTags(instance, treeNode, i18n) {
    // prettier-ignore
    var global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    if (instance && instance.vnode.el && instance.vnode.el.__VUE_I18N__) // add custom tags local scope only
    {
        if (instance.vnode.el.__VUE_I18N__ !== global) {
            var tag = {
                label: "i18n (".concat($621d7fdcae12fe9c$var$getI18nScopeLable(instance), " Scope)"),
                textColor: 0x000000,
                backgroundColor: 0xffcd19
            };
            treeNode.tags.push(tag);
        }
    }
}
function $621d7fdcae12fe9c$var$inspectComposer(instanceData, composer) {
    var type = $621d7fdcae12fe9c$var$VUE_I18N_COMPONENT_TYPES;
    instanceData.state.push({
        type: type,
        key: "locale",
        editable: true,
        value: composer.locale.value
    });
    instanceData.state.push({
        type: type,
        key: "availableLocales",
        editable: false,
        value: composer.availableLocales
    });
    instanceData.state.push({
        type: type,
        key: "fallbackLocale",
        editable: true,
        value: composer.fallbackLocale.value
    });
    instanceData.state.push({
        type: type,
        key: "inheritLocale",
        editable: true,
        value: composer.inheritLocale
    });
    instanceData.state.push({
        type: type,
        key: "messages",
        editable: false,
        value: $621d7fdcae12fe9c$var$getLocaleMessageValue(composer.messages.value)
    });
    instanceData.state.push({
        type: type,
        key: "datetimeFormats",
        editable: false,
        value: composer.datetimeFormats.value
    });
    instanceData.state.push({
        type: type,
        key: "numberFormats",
        editable: false,
        value: composer.numberFormats.value
    });
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $621d7fdcae12fe9c$var$getLocaleMessageValue(messages) {
    var value = {};
    Object.keys(messages).forEach(function(key) {
        var v = messages[key];
        if ((0, $66fbc42080b842e5$export$f6e2535fb5126e54)(v) && "source" in v) value[key] = $621d7fdcae12fe9c$var$getMessageFunctionDetails(v);
        else if ((0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(v)) value[key] = $621d7fdcae12fe9c$var$getLocaleMessageValue(v);
        else value[key] = v;
    });
    return value;
}
var $621d7fdcae12fe9c$var$ESC = {
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "&": "&amp;"
};
function $621d7fdcae12fe9c$var$escape(s) {
    return s.replace(/[<>"&]/g, $621d7fdcae12fe9c$var$escapeChar);
}
function $621d7fdcae12fe9c$var$escapeChar(a) {
    return $621d7fdcae12fe9c$var$ESC[a] || a;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $621d7fdcae12fe9c$var$getMessageFunctionDetails(func) {
    var argString = func.source ? '("'.concat($621d7fdcae12fe9c$var$escape(func.source), '")') : "(?)";
    return {
        _custom: {
            type: "function",
            display: "<span>ƒ</span> ".concat(argString)
        }
    };
}
function $621d7fdcae12fe9c$var$registerScope(payload, i18n) {
    payload.rootNodes.push({
        id: "global",
        label: "Global Scope"
    });
    // prettier-ignore
    var global = i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = i18n.__instances[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $cv9Rk._)(_step.value, 2), keyInstance = _step_value[0], instance = _step_value[1];
            // prettier-ignore
            var composer = i18n.mode === "composition" ? instance : instance.__composer;
            if (global === composer) continue;
            payload.rootNodes.push({
                id: composer.id.toString(),
                label: "".concat($621d7fdcae12fe9c$var$getI18nScopeLable(keyInstance), " Scope")
            });
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $621d7fdcae12fe9c$var$getComponentInstance(nodeId, i18n) {
    var instance = null;
    if (nodeId !== "global") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = i18n.__instances.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $cv9Rk._)(_step.value, 2), component = _step_value[0], composer = _step_value[1];
                if (composer.id.toString() === nodeId) {
                    instance = component;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return instance;
}
function $621d7fdcae12fe9c$var$getComposer$1(nodeId, i18n) {
    if (nodeId === "global") return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
    else {
        var instance = Array.from(i18n.__instances.values()).find(function(item) {
            return item.id.toString() === nodeId;
        });
        if (instance) return i18n.mode === "composition" ? instance : instance.__composer;
        else return null;
    }
}
function $621d7fdcae12fe9c$var$inspectScope(payload, i18n) {
    var composer = $621d7fdcae12fe9c$var$getComposer$1(payload.nodeId, i18n);
    if (composer) // TODO:
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    payload.state = $621d7fdcae12fe9c$var$makeScopeInspectState(composer);
    return null;
}
function $621d7fdcae12fe9c$var$makeScopeInspectState(composer) {
    var state = {};
    var localeType = "Locale related info";
    var localeStates = [
        {
            type: localeType,
            key: "locale",
            editable: true,
            value: composer.locale.value
        },
        {
            type: localeType,
            key: "fallbackLocale",
            editable: true,
            value: composer.fallbackLocale.value
        },
        {
            type: localeType,
            key: "availableLocales",
            editable: false,
            value: composer.availableLocales
        },
        {
            type: localeType,
            key: "inheritLocale",
            editable: true,
            value: composer.inheritLocale
        }
    ];
    state[localeType] = localeStates;
    var localeMessagesType = "Locale messages info";
    var localeMessagesStates = [
        {
            type: localeMessagesType,
            key: "messages",
            editable: false,
            value: $621d7fdcae12fe9c$var$getLocaleMessageValue(composer.messages.value)
        }
    ];
    state[localeMessagesType] = localeMessagesStates;
    {
        var datetimeFormatsType = "Datetime formats info";
        var datetimeFormatsStates = [
            {
                type: datetimeFormatsType,
                key: "datetimeFormats",
                editable: false,
                value: composer.datetimeFormats.value
            }
        ];
        state[datetimeFormatsType] = datetimeFormatsStates;
        var numberFormatsType = "Datetime formats info";
        var numberFormatsStates = [
            {
                type: numberFormatsType,
                key: "numberFormats",
                editable: false,
                value: composer.numberFormats.value
            }
        ];
        state[numberFormatsType] = numberFormatsStates;
    }
    return state;
}
function $621d7fdcae12fe9c$var$addTimelineEvent(event, payload) {
    if ($621d7fdcae12fe9c$var$devtoolsApi) {
        var groupId;
        if (payload && "groupId" in payload) {
            groupId = payload.groupId;
            delete payload.groupId;
        }
        $621d7fdcae12fe9c$var$devtoolsApi.addTimelineEvent({
            layerId: "vue-i18n-timeline" /* TIMELINE */ ,
            event: {
                title: event,
                groupId: groupId,
                time: Date.now(),
                meta: {},
                data: payload || {},
                logType: event === "compile-error" /* COMPILE_ERROR */  ? "error" : event === "fallback" /* FALBACK */  || event === "missing" /* MISSING */  ? "warning" : "default"
            }
        });
    }
}
function $621d7fdcae12fe9c$var$editScope(payload, i18n) {
    var composer = $621d7fdcae12fe9c$var$getComposer$1(payload.nodeId, i18n);
    if (composer) {
        var _payload_path = (0, $cv9Rk._)(payload.path, 1), field = _payload_path[0];
        if (field === "locale" && (0, $66fbc42080b842e5$export$844ec244b1367d54)(payload.state.value)) composer.locale.value = payload.state.value;
        else if (field === "fallbackLocale" && ((0, $66fbc42080b842e5$export$844ec244b1367d54)(payload.state.value) || (0, $66fbc42080b842e5$export$43bee75e5e14138e)(payload.state.value) || (0, $66fbc42080b842e5$export$a6cdc56e425d0d0a)(payload.state.value))) composer.fallbackLocale.value = payload.state.value;
        else if (field === "inheritLocale" && (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(payload.state.value)) composer.inheritLocale = payload.state.value;
    }
}
/**
 * Supports compatibility for legacy vue-i18n APIs
 * This mixin is used when we use vue-i18n@v9.x or later
 */ function $621d7fdcae12fe9c$var$defineMixin(vuei18n, composer, i18n) {
    return {
        beforeCreate: function() {
            var _this = this;
            var _this_$i18n, _this_$i18n1, _this_$i18n2, _this_$i18n3, _this_$i18n4;
            var instance = (0, $lIPIy.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR);
            var options = this.$options;
            if (options.i18n) {
                var optionsI18n = options.i18n;
                if (options.__i18n) optionsI18n.__i18n = options.__i18n;
                optionsI18n.__root = composer;
                if (this === this.$root) this.$i18n = $621d7fdcae12fe9c$var$mergeToRoot(vuei18n, optionsI18n);
                else {
                    optionsI18n.__injectWithOption = true;
                    this.$i18n = $621d7fdcae12fe9c$var$createVueI18n(optionsI18n);
                }
            } else if (options.__i18n) {
                if (this === this.$root) this.$i18n = $621d7fdcae12fe9c$var$mergeToRoot(vuei18n, options);
                else this.$i18n = $621d7fdcae12fe9c$var$createVueI18n({
                    __i18n: options.__i18n,
                    __injectWithOption: true,
                    __root: composer
                });
            } else // set global
            this.$i18n = vuei18n;
            if (options.__i18nGlobal) $621d7fdcae12fe9c$var$adjustI18nResources(composer, options, options);
            vuei18n.__onComponentInstanceCreated(this.$i18n);
            i18n.__setInstance(instance, this.$i18n);
            // defines vue-i18n legacy APIs
            this.$t = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n = _this.$i18n).t.apply(_this_$i18n, (0, $c6Xmf._)(args));
            };
            this.$rt = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n1 = _this.$i18n).rt.apply(_this_$i18n1, (0, $c6Xmf._)(args));
            };
            this.$tc = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n2 = _this.$i18n).tc.apply(_this_$i18n2, (0, $c6Xmf._)(args));
            };
            this.$te = function(key, locale) {
                return _this.$i18n.te(key, locale);
            };
            this.$d = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n3 = _this.$i18n).d.apply(_this_$i18n3, (0, $c6Xmf._)(args));
            };
            this.$n = function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_this_$i18n4 = _this.$i18n).n.apply(_this_$i18n4, (0, $c6Xmf._)(args));
            };
            this.$tm = function(key) {
                return _this.$i18n.tm(key);
            };
        },
        mounted: function() {
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$i18n) {
                this.$el.__VUE_I18N__ = this.$i18n.__composer;
                var emitter = this.__v_emitter = (0, $66fbc42080b842e5$export$6f5e8f34570e3ad1)();
                var _vueI18n = this.$i18n;
                _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                emitter.on("*", $621d7fdcae12fe9c$var$addTimelineEvent);
            }
        },
        unmounted: function() {
            var instance = (0, $lIPIy.getCurrentInstance)();
            /* istanbul ignore if */ if (!instance) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR);
            /* istanbul ignore if */ if (__VUE_PROD_DEVTOOLS__ && true && this.$el && this.$el.__VUE_I18N__) {
                if (this.__v_emitter) {
                    this.__v_emitter.off("*", $621d7fdcae12fe9c$var$addTimelineEvent);
                    delete this.__v_emitter;
                }
                if (this.$i18n) {
                    var _vueI18n = this.$i18n;
                    _vueI18n.__disableEmitter && _vueI18n.__disableEmitter();
                    delete this.$el.__VUE_I18N__;
                }
            }
            delete this.$t;
            delete this.$rt;
            delete this.$tc;
            delete this.$te;
            delete this.$d;
            delete this.$n;
            delete this.$tm;
            i18n.__deleteInstance(instance);
            delete this.$i18n;
        }
    };
}
function $621d7fdcae12fe9c$var$mergeToRoot(root, options) {
    root.locale = options.locale || root.locale;
    root.fallbackLocale = options.fallbackLocale || root.fallbackLocale;
    root.missing = options.missing || root.missing;
    root.silentTranslationWarn = options.silentTranslationWarn || root.silentFallbackWarn;
    root.silentFallbackWarn = options.silentFallbackWarn || root.silentFallbackWarn;
    root.formatFallbackMessages = options.formatFallbackMessages || root.formatFallbackMessages;
    root.postTranslation = options.postTranslation || root.postTranslation;
    root.warnHtmlInMessage = options.warnHtmlInMessage || root.warnHtmlInMessage;
    root.escapeParameterHtml = options.escapeParameterHtml || root.escapeParameterHtml;
    root.sync = options.sync || root.sync;
    root.__composer[$621d7fdcae12fe9c$var$SetPluralRulesSymbol](options.pluralizationRules || root.pluralizationRules);
    var messages = $621d7fdcae12fe9c$var$getLocaleMessages(root.locale, {
        messages: options.messages,
        __i18n: options.__i18n
    });
    Object.keys(messages).forEach(function(locale) {
        return root.mergeLocaleMessage(locale, messages[locale]);
    });
    if (options.datetimeFormats) Object.keys(options.datetimeFormats).forEach(function(locale) {
        return root.mergeDateTimeFormat(locale, options.datetimeFormats[locale]);
    });
    if (options.numberFormats) Object.keys(options.numberFormats).forEach(function(locale) {
        return root.mergeNumberFormat(locale, options.numberFormats[locale]);
    });
    return root;
}
/**
 * Injection key for {@link useI18n}
 *
 * @remarks
 * The global injection key for I18n instances with `useI18n`. this injection key is used in Web Components.
 * Specify the i18n instance created by {@link createI18n} together with `provide` function.
 *
 * @VueI18nGeneral
 */ var $621d7fdcae12fe9c$export$b19990ca6e622dd2 = /* #__PURE__*/ (0, $66fbc42080b842e5$export$cd133c5e04906ece)("global-vue-i18n");
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function $621d7fdcae12fe9c$export$920091e3d72d80ee() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, VueI18nLegacy = arguments.length > 1 ? arguments[1] : void 0;
    var __getInstance = function __getInstance(component) {
        return __instances.get(component) || null;
    };
    var __setInstance = function __setInstance(component, instance) {
        __instances.set(component, instance);
    };
    var __deleteInstance = function __deleteInstance(component) {
        __instances.delete(component);
    };
    // prettier-ignore
    var __legacyMode = __VUE_I18N_LEGACY_API__ && (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.legacy) ? options.legacy : __VUE_I18N_LEGACY_API__;
    // prettier-ignore
    var __globalInjection = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.globalInjection) ? options.globalInjection : true;
    // prettier-ignore
    var __allowComposition = __VUE_I18N_LEGACY_API__ && __legacyMode ? !!options.allowComposition : true;
    var __instances = new Map();
    var _createGlobal = (0, $cv9Rk._)($621d7fdcae12fe9c$var$createGlobal(options, __legacyMode), 2), globalScope = _createGlobal[0], __global = _createGlobal[1];
    var symbol = (0, $66fbc42080b842e5$export$cd133c5e04906ece)("");
    {
        var i18n = {
            // mode
            get mode () {
                return __VUE_I18N_LEGACY_API__ && __legacyMode ? "legacy" : "composition";
            },
            // allowComposition
            get allowComposition () {
                return __allowComposition;
            },
            install: // install plugin
            function(app) {
                for(var _len = arguments.length, options = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    options[_key - 1] = arguments[_key];
                }
                return (0, $f330ac5f61e1368d$export$7c398597f8905a1)(function() {
                    var unmountApp, ret, emitter, _vueI18n, _composer;
                    return (0, $f500ece5c74d6d3d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (__VUE_PROD_DEVTOOLS__ && true) app.__VUE_I18N__ = i18n;
                                // setup global provider
                                app.__VUE_I18N_SYMBOL__ = symbol;
                                app.provide(app.__VUE_I18N_SYMBOL__, i18n);
                                // global method and properties injection for Composition API
                                if (!__legacyMode && __globalInjection) $621d7fdcae12fe9c$var$injectGlobalFields(app, i18n.global);
                                // install built-in components and directive
                                if (__VUE_I18N_FULL_INSTALL__) $621d7fdcae12fe9c$var$apply.apply(void 0, [
                                    app,
                                    i18n
                                ].concat((0, $c6Xmf._)(options)));
                                // setup mixin for Legacy API
                                if (__VUE_I18N_LEGACY_API__ && __legacyMode) app.mixin($621d7fdcae12fe9c$var$defineMixin(__global, __global.__composer, i18n));
                                unmountApp = app.unmount;
                                app.unmount = function() {
                                    i18n.dispose();
                                    unmountApp();
                                };
                                if (!(__VUE_PROD_DEVTOOLS__ && true)) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    $621d7fdcae12fe9c$var$enableDevTools(app, i18n)
                                ];
                            case 1:
                                ret = _state.sent();
                                if (!ret) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN);
                                emitter = (0, $66fbc42080b842e5$export$6f5e8f34570e3ad1)();
                                if (__legacyMode) {
                                    _vueI18n = __global;
                                    _vueI18n.__enableEmitter && _vueI18n.__enableEmitter(emitter);
                                } else {
                                    _composer = __global;
                                    _composer[$621d7fdcae12fe9c$var$EnableEmitter] && _composer[$621d7fdcae12fe9c$var$EnableEmitter](emitter);
                                }
                                emitter.on("*", $621d7fdcae12fe9c$var$addTimelineEvent);
                                _state.label = 2;
                            case 2:
                                return [
                                    2
                                ];
                        }
                    });
                })();
            },
            // global accessor
            get global () {
                return __global;
            },
            dispose: function() {
                globalScope.stop();
            },
            // @internal
            __instances: __instances,
            // @internal
            __getInstance: __getInstance,
            // @internal
            __setInstance: __setInstance,
            // @internal
            __deleteInstance: __deleteInstance
        };
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function $621d7fdcae12fe9c$export$3f3caade1c12f8c9() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var instance = (0, $lIPIy.getCurrentInstance)();
    if (instance == null) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.MUST_BE_CALL_SETUP_TOP);
    if (!instance.isCE && instance.appContext.app != null && !instance.appContext.app.__VUE_I18N_SYMBOL__) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.NOT_INSLALLED);
    var i18n = $621d7fdcae12fe9c$var$getI18nInstance(instance);
    var global = $621d7fdcae12fe9c$var$getGlobalComposer(i18n);
    var componentOptions = $621d7fdcae12fe9c$var$getComponentOptions(instance);
    var scope = $621d7fdcae12fe9c$var$getScope(options, componentOptions);
    if (__VUE_I18N_LEGACY_API__) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {
        if (i18n.mode === "legacy" && !options.__useComponent) {
            if (!i18n.allowComposition) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.NOT_AVAILABLE_IN_LEGACY_MODE);
            return $621d7fdcae12fe9c$var$useI18nForLegacy(instance, scope, global, options);
        }
    }
    if (scope === "global") {
        $621d7fdcae12fe9c$var$adjustI18nResources(global, options, componentOptions);
        return global;
    }
    if (scope === "parent") {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var composer = $621d7fdcae12fe9c$var$getComposer(i18n, instance, options.__useComponent);
        if (composer == null) composer = global;
        return composer;
    }
    var i18nInternal = i18n;
    var composer1 = i18nInternal.__getInstance(instance);
    if (composer1 == null) {
        var composerOptions = (0, $66fbc42080b842e5$export$e6e34fd1f2686227)({}, options);
        if ("__i18n" in componentOptions) composerOptions.__i18n = componentOptions.__i18n;
        if (global) composerOptions.__root = global;
        composer1 = $621d7fdcae12fe9c$var$createComposer(composerOptions);
        $621d7fdcae12fe9c$var$setupLifeCycle(i18nInternal, instance, composer1);
        i18nInternal.__setInstance(instance, composer1);
    }
    return composer1;
}
/**
 * Cast to VueI18n legacy compatible type
 *
 * @remarks
 * This API is provided only with [vue-i18n-bridge](https://vue-i18n.intlify.dev/guide/migration/ways.html#what-is-vue-i18n-bridge).
 *
 * The purpose of this function is to convert an {@link I18n} instance created with {@link createI18n | createI18n(legacy: true)} into a `vue-i18n@v8.x` compatible instance of `new VueI18n` in a TypeScript environment.
 *
 * @param i18n - An instance of {@link I18n}
 * @returns A i18n instance which is casted to {@link VueI18n} type
 *
 * @VueI18nTip
 * :new: provided by **vue-i18n-bridge only**
 *
 * @VueI18nGeneral
 */ var $621d7fdcae12fe9c$export$ec8a89fa64fbfb0 = function(i18n) {
    if (!($621d7fdcae12fe9c$var$__VUE_I18N_BRIDGE__ in i18n)) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.NOT_COMPATIBLE_LEGACY_VUE_I18N);
    return i18n;
};
function $621d7fdcae12fe9c$var$createGlobal(options, legacyMode, VueI18nLegacy // eslint-disable-line @typescript-eslint/no-explicit-any
) {
    var scope = (0, $yQ0Ka.effectScope)();
    {
        var obj = __VUE_I18N_LEGACY_API__ && legacyMode ? scope.run(function() {
            return $621d7fdcae12fe9c$var$createVueI18n(options);
        }) : scope.run(function() {
            return $621d7fdcae12fe9c$var$createComposer(options);
        });
        if (obj == null) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR);
        return [
            scope,
            obj
        ];
    }
}
function $621d7fdcae12fe9c$var$getI18nInstance(instance) {
    {
        var i18n = (0, $lIPIy.inject)(!instance.isCE ? instance.appContext.app.__VUE_I18N_SYMBOL__ : $621d7fdcae12fe9c$export$b19990ca6e622dd2);
        /* istanbul ignore if */ if (!i18n) throw $621d7fdcae12fe9c$var$createI18nError(!instance.isCE ? $621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR : $621d7fdcae12fe9c$var$I18nErrorCodes.NOT_INSLALLED_WITH_PROVIDE);
        return i18n;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $621d7fdcae12fe9c$var$getScope(options, componentOptions) {
    // prettier-ignore
    return (0, $66fbc42080b842e5$export$83b788b1a3698c03)(options) ? "__i18n" in componentOptions ? "local" : "global" : !options.useScope ? "local" : options.useScope;
}
function $621d7fdcae12fe9c$var$getGlobalComposer(i18n) {
    // prettier-ignore
    return i18n.mode === "composition" ? i18n.global : i18n.global.__composer;
}
function $621d7fdcae12fe9c$var$getComposer(i18n, target) {
    var useComponent = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var composer = null;
    var root = target.root;
    var current = target.parent;
    while(current != null){
        var i18nInternal = i18n;
        if (i18n.mode === "composition") composer = i18nInternal.__getInstance(current);
        else if (__VUE_I18N_LEGACY_API__) {
            var vueI18n = i18nInternal.__getInstance(current);
            if (vueI18n != null) {
                composer = vueI18n.__composer;
                if (useComponent && composer && !composer[$621d7fdcae12fe9c$var$InejctWithOption] // eslint-disable-line @typescript-eslint/no-explicit-any
                ) composer = null;
            }
        }
        if (composer != null) break;
        if (root === current) break;
        current = current.parent;
    }
    return composer;
}
function $621d7fdcae12fe9c$var$setupLifeCycle(i18n, target, composer) {
    var emitter = null;
    (0, $lIPIy.onMounted)(function() {
        // inject composer instance to DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el) {
            target.vnode.el.__VUE_I18N__ = composer;
            emitter = (0, $66fbc42080b842e5$export$6f5e8f34570e3ad1)();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var _composer = composer;
            _composer[$621d7fdcae12fe9c$var$EnableEmitter] && _composer[$621d7fdcae12fe9c$var$EnableEmitter](emitter);
            emitter.on("*", $621d7fdcae12fe9c$var$addTimelineEvent);
        }
    }, target);
    (0, $lIPIy.onUnmounted)(function() {
        // remove composer instance from DOM for intlify-devtools
        if (__VUE_PROD_DEVTOOLS__ && true && target.vnode.el && target.vnode.el.__VUE_I18N__) {
            emitter && emitter.off("*", $621d7fdcae12fe9c$var$addTimelineEvent);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            var _composer = composer;
            _composer[$621d7fdcae12fe9c$var$DisableEmitter] && _composer[$621d7fdcae12fe9c$var$DisableEmitter]();
            delete target.vnode.el.__VUE_I18N__;
        }
        i18n.__deleteInstance(target);
    }, target);
}
function $621d7fdcae12fe9c$var$useI18nForLegacy(instance, scope, root) {
    var options = arguments.length > 3 && arguments[3] !== void 0 // eslint-disable-line @typescript-eslint/no-explicit-any
     ? arguments[3] : {};
    var trackReactivityValues = // track reactivity
    function trackReactivityValues() {
        return [
            _locale.value,
            _fallbackLocale.value,
            _messages.value,
            _datetimeFormats.value,
            _numberFormats.value
        ];
    };
    var getPostTranslationHandler = function getPostTranslationHandler() {
        return _composer.value ? _composer.value.getPostTranslationHandler() : _postTranslation;
    };
    var setPostTranslationHandler = function setPostTranslationHandler(handler1) {
        if (_composer.value) _composer.value.setPostTranslationHandler(handler1);
    };
    var getMissingHandler = function getMissingHandler() {
        return _composer.value ? _composer.value.getMissingHandler() : _missing;
    };
    var setMissingHandler = function setMissingHandler(handler1) {
        if (_composer.value) _composer.value.setMissingHandler(handler1);
    };
    var warpWithDeps = function warpWithDeps(fn) {
        trackReactivityValues();
        return fn();
    };
    var t = function t() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _composer.value ? warpWithDeps(function() {
            return Reflect.apply(_composer.value.t, null, (0, $c6Xmf._)(args));
        }) : warpWithDeps(function() {
            return "";
        });
    };
    var rt = function rt() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _composer.value ? Reflect.apply(_composer.value.rt, null, (0, $c6Xmf._)(args)) : "";
    };
    var d = function d() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _composer.value ? warpWithDeps(function() {
            return Reflect.apply(_composer.value.d, null, (0, $c6Xmf._)(args));
        }) : warpWithDeps(function() {
            return "";
        });
    };
    var n = function n() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return _composer.value ? warpWithDeps(function() {
            return Reflect.apply(_composer.value.n, null, (0, $c6Xmf._)(args));
        }) : warpWithDeps(function() {
            return "";
        });
    };
    var tm = function tm(key) {
        return _composer.value ? _composer.value.tm(key) : {};
    };
    var te = function te(key, locale) {
        return _composer.value ? _composer.value.te(key, locale) : false;
    };
    var getLocaleMessage = function getLocaleMessage(locale) {
        return _composer.value ? _composer.value.getLocaleMessage(locale) : {};
    };
    var setLocaleMessage = function setLocaleMessage(locale, message) {
        if (_composer.value) {
            _composer.value.setLocaleMessage(locale, message);
            _messages.value[locale] = message;
        }
    };
    var mergeLocaleMessage = function mergeLocaleMessage(locale, message) {
        if (_composer.value) _composer.value.mergeLocaleMessage(locale, message);
    };
    var getDateTimeFormat = function getDateTimeFormat(locale) {
        return _composer.value ? _composer.value.getDateTimeFormat(locale) : {};
    };
    var setDateTimeFormat = function setDateTimeFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setDateTimeFormat(locale, format);
            _datetimeFormats.value[locale] = format;
        }
    };
    var mergeDateTimeFormat = function mergeDateTimeFormat(locale, format) {
        if (_composer.value) _composer.value.mergeDateTimeFormat(locale, format);
    };
    var getNumberFormat = function getNumberFormat(locale) {
        return _composer.value ? _composer.value.getNumberFormat(locale) : {};
    };
    var setNumberFormat = function setNumberFormat(locale, format) {
        if (_composer.value) {
            _composer.value.setNumberFormat(locale, format);
            _numberFormats.value[locale] = format;
        }
    };
    var mergeNumberFormat = function mergeNumberFormat(locale, format) {
        if (_composer.value) _composer.value.mergeNumberFormat(locale, format);
    };
    var sync = function sync(composer) {
        composer.locale.value = _locale.value;
        composer.fallbackLocale.value = _fallbackLocale.value;
        Object.keys(_messages.value).forEach(function(locale) {
            composer.mergeLocaleMessage(locale, _messages.value[locale]);
        });
        Object.keys(_datetimeFormats.value).forEach(function(locale) {
            composer.mergeDateTimeFormat(locale, _datetimeFormats.value[locale]);
        });
        Object.keys(_numberFormats.value).forEach(function(locale) {
            composer.mergeNumberFormat(locale, _numberFormats.value[locale]);
        });
        composer.escapeParameter = _escapeParameter;
        composer.fallbackFormat = _fallbackFormat;
        composer.fallbackRoot = _fallbackRoot;
        composer.fallbackWarn = _fallbackWarn;
        composer.missingWarn = _missingWarn;
        composer.warnHtmlMessage = _warnHtmlMessage;
    };
    var isLocale = scope === "local";
    var _composer = (0, $yQ0Ka.shallowRef)(null);
    if (isLocale && instance.proxy && !(instance.proxy.$options.i18n || instance.proxy.$options.__i18n)) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.MUST_DEFINE_I18N_OPTION_IN_ALLOW_COMPOSITION);
    var _inheritLocale = (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.inheritLocale) ? options.inheritLocale : true;
    var _locale = (0, $yQ0Ka.ref)(// prettier-ignore
    isLocale && _inheritLocale ? root.locale.value : (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.locale) ? options.locale : (0, $1b33d9be5d32e050$export$1af4c7e47ad72f44));
    var _fallbackLocale = (0, $yQ0Ka.ref)(// prettier-ignore
    isLocale && _inheritLocale ? root.fallbackLocale.value : (0, $66fbc42080b842e5$export$844ec244b1367d54)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$43bee75e5e14138e)(options.fallbackLocale) || (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.fallbackLocale) || options.fallbackLocale === false ? options.fallbackLocale : _locale.value);
    var _messages = (0, $yQ0Ka.ref)($621d7fdcae12fe9c$var$getLocaleMessages(_locale.value, options));
    // prettier-ignore
    var _datetimeFormats = (0, $yQ0Ka.ref)((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.datetimeFormats) ? options.datetimeFormats : (0, $3sHb8._)({}, _locale.value, {}));
    // prettier-ignore
    var _numberFormats = (0, $yQ0Ka.ref)((0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.numberFormats) ? options.numberFormats : (0, $3sHb8._)({}, _locale.value, {}));
    // prettier-ignore
    var _missingWarn = isLocale ? root.missingWarn : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.missingWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.missingWarn) ? options.missingWarn : true;
    // prettier-ignore
    var _fallbackWarn = isLocale ? root.fallbackWarn : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackWarn) || (0, $66fbc42080b842e5$export$49841c62b9eff15)(options.fallbackWarn) ? options.fallbackWarn : true;
    // prettier-ignore
    var _fallbackRoot = isLocale ? root.fallbackRoot : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.fallbackRoot) ? options.fallbackRoot : true;
    // configure fall back to root
    var _fallbackFormat = !!options.fallbackFormat;
    // runtime missing
    var _missing = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.missing) ? options.missing : null;
    // postTranslation handler
    var _postTranslation = (0, $66fbc42080b842e5$export$f6e2535fb5126e54)(options.postTranslation) ? options.postTranslation : null;
    // prettier-ignore
    var _warnHtmlMessage = isLocale ? root.warnHtmlMessage : (0, $66fbc42080b842e5$export$f9ce7b637dfbe238)(options.warnHtmlMessage) ? options.warnHtmlMessage : true;
    var _escapeParameter = !!options.escapeParameter;
    // prettier-ignore
    var _modifiers = isLocale ? root.modifiers : (0, $66fbc42080b842e5$export$53b83ca8eaab0383)(options.modifiers) ? options.modifiers : {};
    // pluralRules
    var _pluralRules = options.pluralRules || isLocale && root.pluralRules;
    // locale
    var locale = (0, $yQ0Ka.computed)({
        get: function() {
            return _composer.value ? _composer.value.locale.value : _locale.value;
        },
        set: function(val1) {
            if (_composer.value) _composer.value.locale.value = val1;
            _locale.value = val1;
        }
    });
    // fallbackLocale
    var fallbackLocale = (0, $yQ0Ka.computed)({
        get: function() {
            return _composer.value ? _composer.value.fallbackLocale.value : _fallbackLocale.value;
        },
        set: function(val1) {
            if (_composer.value) _composer.value.fallbackLocale.value = val1;
            _fallbackLocale.value = val1;
        }
    });
    // messages
    var messages = (0, $yQ0Ka.computed)(function() {
        if (_composer.value) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _composer.value.messages.value;
        else // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return _messages.value;
    });
    var datetimeFormats = (0, $yQ0Ka.computed)(function() {
        return _datetimeFormats.value;
    });
    var numberFormats = (0, $yQ0Ka.computed)(function() {
        return _numberFormats.value;
    });
    var wrapper = {
        get id () {
            return _composer.value ? _composer.value.id : -1;
        },
        locale: locale,
        fallbackLocale: fallbackLocale,
        messages: messages,
        datetimeFormats: datetimeFormats,
        numberFormats: numberFormats,
        get inheritLocale () {
            return _composer.value ? _composer.value.inheritLocale : _inheritLocale;
        },
        set inheritLocale (val){
            if (_composer.value) _composer.value.inheritLocale = val;
        },
        get availableLocales () {
            return _composer.value ? _composer.value.availableLocales : Object.keys(_messages.value);
        },
        get modifiers () {
            return _composer.value ? _composer.value.modifiers : _modifiers;
        },
        get pluralRules () {
            return _composer.value ? _composer.value.pluralRules : _pluralRules;
        },
        get isGlobal () {
            return _composer.value ? _composer.value.isGlobal : false;
        },
        get missingWarn () {
            return _composer.value ? _composer.value.missingWarn : _missingWarn;
        },
        set missingWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackWarn () {
            return _composer.value ? _composer.value.fallbackWarn : _fallbackWarn;
        },
        set fallbackWarn (val){
            if (_composer.value) _composer.value.missingWarn = val;
        },
        get fallbackRoot () {
            return _composer.value ? _composer.value.fallbackRoot : _fallbackRoot;
        },
        set fallbackRoot (val){
            if (_composer.value) _composer.value.fallbackRoot = val;
        },
        get fallbackFormat () {
            return _composer.value ? _composer.value.fallbackFormat : _fallbackFormat;
        },
        set fallbackFormat (val){
            if (_composer.value) _composer.value.fallbackFormat = val;
        },
        get warnHtmlMessage () {
            return _composer.value ? _composer.value.warnHtmlMessage : _warnHtmlMessage;
        },
        set warnHtmlMessage (val){
            if (_composer.value) _composer.value.warnHtmlMessage = val;
        },
        get escapeParameter () {
            return _composer.value ? _composer.value.escapeParameter : _escapeParameter;
        },
        set escapeParameter (val){
            if (_composer.value) _composer.value.escapeParameter = val;
        },
        t: t,
        getPostTranslationHandler: getPostTranslationHandler,
        setPostTranslationHandler: setPostTranslationHandler,
        getMissingHandler: getMissingHandler,
        setMissingHandler: setMissingHandler,
        rt: rt,
        d: d,
        n: n,
        tm: tm,
        te: te,
        getLocaleMessage: getLocaleMessage,
        setLocaleMessage: setLocaleMessage,
        mergeLocaleMessage: mergeLocaleMessage,
        getDateTimeFormat: getDateTimeFormat,
        setDateTimeFormat: setDateTimeFormat,
        mergeDateTimeFormat: mergeDateTimeFormat,
        getNumberFormat: getNumberFormat,
        setNumberFormat: setNumberFormat,
        mergeNumberFormat: mergeNumberFormat
    };
    (0, $lIPIy.onBeforeMount)(function() {
        if (instance.proxy == null || instance.proxy.$i18n == null) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.NOT_AVAILABLE_COMPOSITION_IN_LEGACY);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var composer = _composer.value = instance.proxy.$i18n.__composer;
        if (scope === "global") {
            _locale.value = composer.locale.value;
            _fallbackLocale.value = composer.fallbackLocale.value;
            _messages.value = composer.messages.value;
            _datetimeFormats.value = composer.datetimeFormats.value;
            _numberFormats.value = composer.numberFormats.value;
        } else if (isLocale) sync(composer);
    });
    return wrapper;
}
var $621d7fdcae12fe9c$var$globalExportProps = [
    "locale",
    "fallbackLocale",
    "availableLocales"
];
var $621d7fdcae12fe9c$var$globalExportMethods = [
    "t",
    "rt",
    "d",
    "n",
    "tm"
];
function $621d7fdcae12fe9c$var$injectGlobalFields(app, composer) {
    var i18n = Object.create(null);
    $621d7fdcae12fe9c$var$globalExportProps.forEach(function(prop) {
        var desc = Object.getOwnPropertyDescriptor(composer, prop);
        if (!desc) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR);
        var wrap = (0, $yQ0Ka.isRef)(desc.value) // check computed props
         ? {
            get: function() {
                return desc.value.value;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            set: function(val1) {
                desc.value.value = val1;
            }
        } : {
            get: function() {
                return desc.get && desc.get();
            }
        };
        Object.defineProperty(i18n, prop, wrap);
    });
    app.config.globalProperties.$i18n = i18n;
    $621d7fdcae12fe9c$var$globalExportMethods.forEach(function(method) {
        var desc = Object.getOwnPropertyDescriptor(composer, method);
        if (!desc || !desc.value) throw $621d7fdcae12fe9c$var$createI18nError($621d7fdcae12fe9c$var$I18nErrorCodes.UNEXPECTED_ERROR);
        Object.defineProperty(app.config.globalProperties, "$".concat(method), desc);
    });
}
// register message compiler at vue-i18n
(0, $1b33d9be5d32e050$export$6ee2fbe83628b40b)((0, $1b33d9be5d32e050$export$1ea8807c727891fc));
// register message resolver at vue-i18n
(0, $1b33d9be5d32e050$export$45dacdc710815463)((0, $1b33d9be5d32e050$export$d812c8e1906863d0));
// register fallback locale at vue-i18n
(0, $1b33d9be5d32e050$export$fd8ec9dd8067edec)((0, $1b33d9be5d32e050$export$71df9db82dc445));
$621d7fdcae12fe9c$var$initFeatureFlags();
// NOTE: experimental !!
if (__INTLIFY_PROD_DEVTOOLS__) {
    var $621d7fdcae12fe9c$var$target = (0, $66fbc42080b842e5$export$ff5f2eeb11fc7e14)();
    $621d7fdcae12fe9c$var$target.__INTLIFY__ = true;
    (0, $1b33d9be5d32e050$export$c893d6c8966908b9)($621d7fdcae12fe9c$var$target.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}


var $352877516eff5992$exports = {};
$352877516eff5992$exports = {
    "de_CH": {
        "txt": {
            "title": "Tierhaltungs-Rechner",
            "buttonNext": "Weiter",
            "buttonPrevious": "Zur\xfcck",
            "buttonClose": "Schliessen",
            "buttonAcceptWarning": "Verstanden",
            "domain": "tierhaltungsrechner.ch",
            "link": "https://www.tierhaltungsrechner.ch",
            "trButton": {
                "cta": "Erfahre mehr \xfcber artgerechte Haltung:",
                "buttonText": "Tierhaltungsrechner \xf6ffnen"
            },
            "categories": {
                "rodents": {
                    "name": "Nager & Kaninchen"
                },
                "reptiles": {
                    "name": "Reptilien"
                },
                "birds": {
                    "name": "V\xf6gel"
                },
                "equidae": {
                    "name": "Equiden"
                }
            },
            "animals": {
                "rodents": {
                    "degu": {
                        "name": "Degu",
                        "namePlural": "Degus",
                        "minAnimalsErrorMessage": "Degus sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Degus sollten in Gruppen von 2-5 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Degus sollten in Gruppen von 2-5 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 5 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, reine M\xe4nnchengruppe, ein kastriertes M\xe4nnchen mit mehreren Weibchen\n"
                        },
                        "laws": {
                            "furnishing": "Geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste), Sandbad\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Degus sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Degu",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_degu_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "dwarfHamster": {
                        "name": "Zwerghamster",
                        "namePlural": "Zwerghamster",
                        "minAnimalsWarningMessage": "Achtung, die Haltung von Zwerghamstern ist sehr anspruchsvoll und h\xf6chstens f\xfcr erfahrene Nagerhalter m\xf6glich.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich!",
                        "recommendations": {
                            "socialStructure": "Die Zwerghamsterhaltung ist anspruchsvoll und erfordert viel Erfahrung. Erkundigen Sie sich vor dem Kauf bei Fachpersonen, welche Arten in welchen Gruppengr\xf6ssen und Gruppenzusammenstellungen gehalten werden k\xf6nnen.\n"
                        },
                        "laws": {
                            "furnishing": "Kletterm\xf6glichkeiten, geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu, Stroh, K\xf6rnerbeimischungen), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Sowohl die Einzel- wie auch Gruppenhaltung von Zwerghamstern ist erlaubt.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "fancyMouse": {
                        "name": "Farbmaus",
                        "namePlural": "Farbm\xe4use",
                        "minAnimalsErrorMessage": "Farbm\xe4use sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Farbm\xe4use sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Farbm\xe4use sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, ein kastriertes M\xe4nnchen mit mehreren Weibchen\n"
                        },
                        "laws": {
                            "furnishing": "Kletterm\xf6glichkeiten, geeignete Einstreu, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu, Stroh, K\xf6rnerbeimischungen), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Farbm\xe4use sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Farbmaus",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "gerbil": {
                        "name": "Rennmaus",
                        "namePlural": "Rennm\xe4use",
                        "minAnimalsErrorMessage": "Rennm\xe4use sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Rennm\xe4use sollten in Gruppen von 2 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Rennm\xe4use sollten in Gruppen von 2 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, reine M\xe4nnchengruppe, ein kastriertes M\xe4nnchen mit einem Weibchen\n"
                        },
                        "laws": {
                            "furnishing": "Geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste), Sandbad\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Rennm\xe4use sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Rennmaus",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_rennmaus_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "goldenHamster": {
                        "name": "Goldhamster",
                        "namePlural": "Goldhamster",
                        "maxAnimalsErrorMessage": "Goldhamster sind Einzelg\xe4nger und m\xfcssen alleine gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: Einzelhaltung\n"
                        },
                        "laws": {
                            "furnishing": "Kletterm\xf6glichkeiten, geeignete Einstreu zum Graben, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu, Stroh, K\xf6rnerbeimischungen), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Goldhamster sind Einzelg\xe4nger und m\xfcssen alleine gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Goldhamster",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_goldhamster_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "guineaPig": {
                        "name": "Meerschweinchen",
                        "namePlural": "Meerschweinchen",
                        "minAnimalsErrorMessage": "Meerschweinchen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Meerschweinchen sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Meerschweinchen sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellung: reine Weibchengruppe, ein kastriertes M\xe4nnchen mit mehreren Weibchen, z.T. auch reine M\xe4nnchengruppen m\xf6glich\n"
                        },
                        "laws": {
                            "furnishing": "Geeignete Einstreu, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere,  grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste), Vitamin C-haltiges Futter\n",
                            "raisedAreas": "Begehbare erh\xf6hte Fl\xe4chen k\xf6nnen bis zu einem Drittel der geforderten Mindestfl\xe4che angerechnet werden, vorausgesetzt die Fl\xe4che unter der erh\xf6hten Ebene kann von den Tieren auch genutzt werden.\n",
                            "socialStructure": "Meerschweinchen sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Meerschweinchen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_meerschweinchen_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "rabbit": {
                        "name": "Kaninchen",
                        "namePlural": "Kaninchen",
                        "minAnimalsErrorMessage": "Kaninchen sind soziale Tiere. Die Einzelhaltung ist nur erlaubt, wenn H\xf6r- bzw. Geruchkontakt zu Artgenossen besteht!",
                        "maxAnimalsWarningMessage": "Ab einer Gruppengr\xf6sse von 3 Tieren existieren derzeit nur Empfehlungen zur Mindestfl\xe4che. Die aktuellen Fl\xe4chenempfehlungen sind sehr klein und werden derzeit \xfcberarbeitet.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Kaninchen sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellung: ein kastriertes M\xe4nnchen mit 1 oder 2 Weibchen, 2 kastrierte M\xe4nnchen mit 2 - 4 Weibchen, reine Weibchengruppen z.T. auch m\xf6glich\n"
                        },
                        "laws": {
                            "furnishing": "R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Begehbare erh\xf6hte Fl\xe4chen k\xf6nnen der geforderten Mindestfl\xe4che angerechnet werden, vorausgesetzt die Fl\xe4che unter der erh\xf6hten Ebene kann von den Tieren auch genutzt werden (mind. 20 cm).\n",
                            "socialStructure": "Kaninchen sind soziale Tiere. Eine Einzelhaltung ist nur erlaubt, wenn sie H\xf6r- und Geruchkontakt zu Artgenossen haben.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Kaninchen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    },
                    "rat": {
                        "name": "Ratte",
                        "namePlural": "Ratten",
                        "minAnimalsErrorMessage": "Ratten sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Maximale Gruppengr\xf6sse \xfcberschritten. Ratten sollten in Gruppen von 2 - 6 Tieren gehalten werden.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Ratten sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Empfohlene Gruppengr\xf6sse: 2 - 6 Tiere\nGruppenzusammenstellungen: reine M\xe4nnchengruppen, reine Weibchengruppen, gemischte Gruppe mit kastrierten M\xe4nnchen\n"
                        },
                        "laws": {
                            "furnishing": "geeignete Einstreu, R\xfcckzugsm\xf6glichkeiten f\xfcr alle Tiere, geeignetes Nestmaterial, grob strukturiertes Futter (Heu oder Stroh), Nageobjekte (frische \xc4ste)\n",
                            "raisedAreas": "Erh\xf6hte Fl\xe4chen d\xfcrfen nicht bei der Mindestfl\xe4che angerechnet werden.\n",
                            "socialStructure": "Ratten sind soziale Tiere und d\xfcrfen nicht ohne Artgenossen gehalten werden.\n"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merblatt Ratten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_ratten_de.pdf"
                            },
                            "1": {
                                "text": "Brosch\xfcre Nager und Kaninchen tiergerecht halten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste Tierhaltung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_de.pdf"
                            },
                            "3": {
                                "text": "STS Merkblatt Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Checkliste Zoofachgesch\xe4ft",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_de.pdf"
                            }
                        }
                    }
                },
                "reptiles": {
                    "royalPython": {
                        "name": "K\xf6nigspython",
                        "namePlural": "K\xf6nigspythons",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigspythons. K\xf6nigspythons sind gut zu vergesellschaften mit Artgenossen.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigspythons. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigspythons. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Badem\xf6glichkeit, Versteckm\xf6glichkeiten, artgem\xe4sse Temperatur und klimatische Bedingungen, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "Ja"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Kletterm\xf6glichkeiten, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste und erh\xf6hte Fl\xe4chen,  Wetbox, Badebecken,  Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 26-32\xb0C, lokaler W\xe4rmespot 36\xb0C, nachts Abk\xfchlung, K\xf6nigspythons sind untereinander recht gut vertr\xe4glich und k\xf6nnen bei ausreichend grossem Terrarium auch zu zweit oder zu dritt gehalten werden.\n",
                            "waterBasin": "Badebecken"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt K\xf6nigspython",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_k%C3%B6nigspython_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "cornSnake": {
                        "name": "Kornnatter",
                        "namePlural": "Kornnattern",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kornnattern. Kornnattern sind gut zu vergesellschaften mit Artgenossen.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kornnattern. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kornnattern. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Versteckm\xf6glichkeiten, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Badebecken, Kletterm\xf6glichkeiten, lockeres Bodensubstrat, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste, Wetbox, Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 24-28\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen.\n",
                            "waterBasin": "Badebecken"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Kornnatter",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_kornnatter_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "greekTortoise": {
                        "name": "Griechische Landschildkr\xf6te",
                        "namePlural": "Griechische Landschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten und Boden zum Graben, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Zugang zu nat\xfcrlichem Sonnenlicht, zus\xe4tzlich Auslauf im Freien, M\xf6glichkeit zum \xdcberwintern\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Freilandgehege mit ausbruchsicherer Umz\xe4unung und Abtrennm\xf6glichkeiten, Schutzhaus, z.B. Treibhaus, Fr\xfchbeet, abwechslungsreicher, teilweise grabbarer Bodengrund (Steine, Sand, Kies, Jurakalk etc.), Sonnenpl\xe4tze, R\xfcckzugsm\xf6glichkeiten, z.B. Bepflanzung, Wurzeln, Steine etc., Wasser sowie artgem\xe4sses Futter (Heu, Kr\xe4uter)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die \xdcberwinterung, an die Einrichtung des Geheges und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Eine sichere \xdcberwinterungsm\xf6glichkeit ist wichtig.\n",
                            "more": "Landschildkr\xf6ten haben eine sehr hohe Lebenserwartung (40-80 Jahre)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Europ\xe4ische Landschildkr\xf6ten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_de.pdf"
                            },
                            "1": {
                                "text": "Tierfreundliche Schildkr\xf6tenhaltung in der Praxis",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_de.pdf"
                            },
                            "2": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "moorishTortoise": {
                        "name": "Maurische Landschildkr\xf6te",
                        "namePlural": "Maurische Landschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten und Boden zum Graben, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Zugang zu nat\xfcrlichem Sonnenlicht, zus\xe4tzlich Auslauf im Freien, M\xf6glichkeit zum \xdcberwintern\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Freilandgehege mit ausbruchsicherer Umz\xe4unung und Abtrennm\xf6glichkeiten, Schutzhaus, z.B. Treibhaus, Fr\xfchbeet, abwechslungsreicher, teilweise grabbarer Bodengrund (Steine, Sand, Kies, Jurakalk etc.), Sonnenpl\xe4tze, R\xfcckzugsm\xf6glichkeiten, z.B. Bepflanzung, Wurzeln, Steine etc., Wasser sowie artgem\xe4sses Futter (Heu, Kr\xe4uter)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die \xdcberwinterung, an die Einrichtung des Geheges und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Eine sichere \xdcberwinterungsm\xf6glichkeit ist wichtig.\n",
                            "more": "Landschildkr\xf6ten haben eine sehr hohe Lebenserwartung (40-80 Jahre)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Europ\xe4ische Landschildkr\xf6ten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_de.pdf"
                            },
                            "1": {
                                "text": "Tierfreundliche Schildkr\xf6tenhaltung in der Praxis",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_de.pdf"
                            },
                            "2": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "wideShelledTortoise": {
                        "name": "Breitrandschildkr\xf6te",
                        "namePlural": "Breitrandschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Landschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten und Boden zum Graben, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Zugang zu nat\xfcrlichem Sonnenlicht, zus\xe4tzlich Auslauf im Freien, M\xf6glichkeit zum \xdcberwintern\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Freilandgehege mit ausbruchsicherer Umz\xe4unung und Abtrennm\xf6glichkeiten, Schutzhaus, z.B. Treibhaus, Fr\xfchbeet, abwechslungsreicher, teilweise grabbarer Bodengrund (Steine, Sand, Kies, Jurakalk etc.), Sonnenpl\xe4tze, R\xfcckzugsm\xf6glichkeiten, z.B. Bepflanzung, Wurzeln, Steine etc., Wasser sowie artgem\xe4sses Futter (Heu, Kr\xe4uter)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die \xdcberwinterung, an die Einrichtung des Geheges und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Eine sichere \xdcberwinterungsm\xf6glichkeit ist wichtig.\n",
                            "more": "Landschildkr\xf6ten haben eine sehr hohe Lebenserwartung (40-80 Jahre)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Europ\xe4ische Landschildkr\xf6ten",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_de.pdf"
                            },
                            "1": {
                                "text": "Tierfreundliche Schildkr\xf6tenhaltung in der Praxis",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_de.pdf"
                            },
                            "2": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "crownedGecko": {
                        "name": "Kronengecko",
                        "namePlural": "Kronengeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kronengeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kronengeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Kronengeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten, artgem\xe4sse Temperatur und klimatische Bedingungen, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere (z.B. Korkr\xf6hren, Wurzeln, Pflanzen), Kletterm\xf6glichkeiten (z.B. fein verzweigte \xc4ste, Pflanzen), Bodengrund zum Graben, Wasser sowie artgem\xe4sses Futter (Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, nachts Abk\xfchlung. Wintertemperaturen 5\xb0-6\xb0C tiefer. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich, ihre Vergesellschaftung ist nicht vorzusehen.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "boaConstrictor": {
                        "name": "Abgottschlange",
                        "namePlural": "Abgottschlangen",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Abgottschlangen. Abgottschlangen sind untereinander recht gut vertr\xe4glich und k\xf6nnen bei ausreichend grossem Terrarium auch zu zweit oder zu dritt gehalten werden.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Abgottschlangen. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Abgottschlangen. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Badem\xf6glichkeit, Versteckm\xf6glichkeiten, artgem\xe4sse Temperatur und klimatische Bedingungen, Kletterm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "Ja"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Kletterm\xf6glichkeiten, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste und erh\xf6hte Fl\xe4chen,  Wetbox, Badebecken,  Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 26-32\xb0C, lokaler W\xe4rmespot 36\xb0C, nachts Abk\xfchlung, Abgottschlangen sind untereinander recht gut vertr\xe4glich und k\xf6nnen bei ausreichend grossem Terrarium auch zu zweit oder zu dritt gehalten werden.\n",
                            "more": "Abgottschlangen k\xf6nnen \xfcber 4m lang werden. Die hier angegebenen Werte gelten f\xfcr Tiere bis 250cm L\xe4nge. Gr\xf6ssere Tiere ben\xf6tigen gr\xf6ssere Gehege.\n",
                            "waterBasin": "Badebecken 0.5 m\xb2"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "muskTurtle": {
                        "name": "Gew\xf6hnliche Moschusschildkr\xf6te",
                        "namePlural": "Gew\xf6hnliche Moschusschildkr\xf6ten",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schildkr\xf6ten wird die Panzerl\xe4nge des gr\xf6ssten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Moschusschildkr\xf6ten. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Moschusschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Moschusschildkr\xf6ten. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Versteckm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "zus\xe4tzlich zur Fl\xe4che"
                        },
                        "recommendations": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Sonnenplatz sowie eine UV-emittierende Lichtquelle, Versteckm\xf6glichkeiten\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-28\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung, eine k\xfchle \xdcberwinterung ist zu empfehlen.\n",
                            "waterBasin": "der Gesamtfl\xe4che"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "kingSnake": {
                        "name": "K\xf6nigsnatter",
                        "namePlural": "K\xf6nigsnattern",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Schlangen wird die gesamte K\xf6rperl\xe4nge gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigsnattern.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigsnattern. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von K\xf6nigsnattern. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Artgem\xe4sse Temperatur und klimatische Bedingungen, Versteckm\xf6glichkeiten\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die Beleuchtung muss so installiert sein, dass sich die Tiere nicht daran verbrennen k\xf6nnen, Badebecken, Kletterm\xf6glichkeiten, lockeres Bodensubstrat, Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, \xc4ste, Wetbox, Wasser sowie artgem\xe4sses Futter (Futtertiere)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen.\n",
                            "more": "K\xf6nigsnattern ern\xe4hren sich auch von anderen Schlangen und d\xfcrfen deshalb nicht mit anderen Schlangen vergesellschaftet werden.\n",
                            "waterBasin": "Badebecken"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "madagascarDayGecko": {
                        "name": "Grosser Madagaskar Taggecko",
                        "namePlural": "Grosse Madagaskar Taggeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Horizontale und vertikale Kletterm\xf6glichkeiten, Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang zum Licht haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht an den Lampen verbrennen k\xf6nnen, System zur Produktion der f\xfcr die jeweilige Art n\xf6tigen Luftfeuchtigkeit, z.B. Vernebler, Beregnungsanlage, Spr\xfchflasche, Bepflanzung, Wasserfall etc., Messsystem f\xfcr Temperatur und Luftfeuchtigkeit, vielf\xe4ltige und artgem\xe4sse, mindestens k\xf6rperdicke Kletterm\xf6glichkeiten (R\xfcckwand, \xc4ste, Bambusst\xe4be, breitbl\xe4ttrige Pflanzen etc.), artgem\xe4sse R\xfcckzugsm\xf6glichkeiten durch Bepflanzung, Wurzeln, Steine, aufgeschnittene Bambusrohre etc., artgem\xe4sser Bodengrund, Wasser sowie artgem\xe4sses Futter (Insekten, Nektar, Fruchtbrei)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 40\xb0C, nachts Abk\xfchlung. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich, ihre Vergesellschaftung ist nicht vorzusehen.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Grosser Madagaskar-Taggecko",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "goldDustDayGecko": {
                        "name": "Goldstaub Taggecko",
                        "namePlural": "Goldstaub Taggeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Taggeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Horizontale und vertikale Kletterm\xf6glichkeiten, Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang zum Licht haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht an den Lampen verbrennen k\xf6nnen, System zur Produktion der f\xfcr die jeweilige Art n\xf6tigen Luftfeuchtigkeit, z.B. Vernebler, Beregnungsanlage, Spr\xfchflasche, Bepflanzung, Wasserfall etc., Messsystem f\xfcr Temperatur und Luftfeuchtigkeit, vielf\xe4ltige und artgem\xe4sse, mindestens k\xf6rperdicke Kletterm\xf6glichkeiten (R\xfcckwand, \xc4ste, Bambusst\xe4be, breitbl\xe4ttrige Pflanzen etc.), artgem\xe4sse R\xfcckzugsm\xf6glichkeiten durch Bepflanzung, Wurzeln, Steine, aufgeschnittene Bambusrohre etc., artgem\xe4sser Bodengrund, Wasser sowie artgem\xe4sses Futter (Insekten, Nektar, Fruchtbrei)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 40\xb0C, nachts Abk\xfchlung. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich, ihre Vergesellschaftung ist nicht vorzusehen.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Grosser Madagaskar-Taggecko",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "leopardGecko": {
                        "name": "Leopardgecko",
                        "namePlural": "Leopardgeckos",
                        "article": "der",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Leopardgeckos. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Leopardgeckos. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Leopardgeckos. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Versteckm\xf6glichkeiten, Grabm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Beleuchtung.\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "UV-emittierende Lampen und Grundbeleuchtung; Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere (z.B. Korkr\xf6hren, Wurzeln, mind. ein leicht feuchtes Versteck), Kletterm\xf6glichkeiten (z.B. Steinaufbauten, R\xfcckwand, Wurzeln), Bodengrund zum Graben, Wasser sowie artgem\xe4sses Futter (Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Winterruhe, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 22-28\xb0C, lokaler W\xe4rmespot 35\xb0C, nachts Abk\xfchlung. M\xe4nnliche Tiere sind territorial, ihre Vergesellschaftung ist nicht empfehlenswert.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Grosser Leopardgeckos",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_leopardgecko_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "dwarfBeardedDragon": {
                        "name": "Zwergbartagame",
                        "namePlural": "Zwergbartagamen",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander meist unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Kletter- und Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle.\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Erh\xf6hte Liegefl\xe4chen, UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht daran verbrennen k\xf6nnen (kein direkter Kontakt zum Leuchtk\xf6rper m\xf6glich), Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, Badem\xf6glichkeit, Kletterm\xf6glichkeiten und Felsen, Sand zum Graben, Wasser sowie artgem\xe4sses Futter (Frischfutter, Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Winterruhe, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 45\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen. Auch wenn Bartagamen ausserhalb der Paarungszeit Einzelg\xe4nger sind, ist die Gesellschaft von Artgenossen eine wichtige Bereicherung der Verhaltensoptionen im Terrarium, sofern die Tiere vertr\xe4glich sind.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Streifenk\xf6pfige Bartagame",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    },
                    "centralBeardedDragon": {
                        "name": "Streifenk\xf6pfige Bartagame",
                        "namePlural": "Streifenk\xf6pfige Bartagamen",
                        "article": "die",
                        "articlePlural": "die",
                        "textLength": "Bei Echsen wird die K\xf6rperl\xe4nge (ohne Schwanz) des l\xe4ngsten Tiers gemessen.",
                        "minAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich.",
                        "maxAnimalsWarningMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. M\xe4nnliche Tiere sind untereinander unvertr\xe4glich. Eine solch hohe Anzahl Tiere ist nicht zu empfehlen.",
                        "maxAnimalsErrorMessage": "Bitte informieren Sie sich \xfcber die Sozialstruktur von Bartagamen. Eine solch hohe Anzahl Tiere ist abzulehnen.",
                        "laws": {
                            "furnishing": "Kletter- und Versteckm\xf6glichkeiten, artgem\xe4sse klimatische Bedingungen und Sonnenplatz sowie eine UV-emittierende Lichtquelle.\n",
                            "socialStructure": "Soziale Struktur beachten. Unter Umst\xe4nden m\xfcssen die Tiere einzeln gehalten werden.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Erh\xf6hte Liegefl\xe4chen, UV-emittierende Lampen und Grundbeleuchtung, die UV-Beleuchtung muss so installiert sein, dass alle Tiere Zugang haben (passende Platzierung und ausreichende Anzahl Sonnenpl\xe4tze), sich aber nicht daran verbrennen k\xf6nnen (kein direkter Kontakt zum Leuchtk\xf6rper m\xf6glich), Messsystem f\xfcr Temperatur- und Feuchtigkeitskontrolle, mindestens so viele R\xfcckzugsm\xf6glichkeiten wie Tiere, z.B. Korkr\xf6hren, Wurzeln, Badem\xf6glichkeit, Kletterm\xf6glichkeiten und Felsen, Sand zum Graben, Wasser sowie artgem\xe4sses Futter (Frischfutter, Insekten)\n",
                            "socialStructure": "Die artspezifischen Anspr\xfcche an den Lebensraum, an das Sozialverhalten, an das Klima, an die Winterruhe, an die Einrichtung des Terrariums und an die F\xfctterung m\xfcssen ber\xfccksichtigt werden. Grundtemperatur 25-30\xb0C, lokaler W\xe4rmespot 45\xb0C, nachts Abk\xfchlung, je nach Herkunftsklima ist eine k\xfchle \xdcberwinterung zu empfehlen. Auch wenn Bartagamen ausserhalb der Paarungszeit Einzelg\xe4nger sind, ist die Gesellschaft von Artgenossen eine wichtige Bereicherung der Verhaltensoptionen im Terrarium, sofern die Tiere vertr\xe4glich sind.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Merkblatt Streifenk\xf6pfige Bartagame",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_de.pdf"
                            }
                        }
                    }
                },
                "birds": {
                    "diamondDove": {
                        "name": "Diamantt\xe4ubchen",
                        "namePlural": "Diamantt\xe4ubchen",
                        "minAnimalsErrorMessage": "Diamantt\xe4ubchen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Diamantt\xe4ubchen gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein, und in Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Diamantt\xe4ubchen sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung mit mehreren Brutpaaren.",
                            "indoor": "Diamantt\xe4ubchen k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Variante der Haltung von Diamantt\xe4ubchen stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Diamantt\xe4ubchen sind generell sehr friedlich und k\xf6nnen bei entsprechendem Fachwissen mit anderen friedlichen Vogelarten gemeinsam gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "canary": {
                        "name": "Kanarienvogel",
                        "namePlural": "Kanarienv\xf6gel",
                        "minAnimalsErrorMessage": "Kanarienv\xf6gel sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Kanarien gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Kanarienv\xf6gel sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Kanarienv\xf6gel k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Variante der Kanarienhaltung stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Eine gemeinsame Haltung mit einer anderen Vogelart ist nur f\xfcr Personen mit viel Fachwissen empfehlenswert.\nAchtung: Bei Kanarienv\xf6geln gibt es  Zuchtrichtungen (z.B. einige Positurkanarien), welche zu den Qualzuchten geh\xf6ren, bitte keine solchen Tiere kaufen."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Kanarienvogel",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_kanarien_de.pdf"
                            }
                        }
                    },
                    "zebraFinch": {
                        "name": "Zebrafink",
                        "namePlural": "Zebrafinken",
                        "minAnimalsErrorMessage": "Zebrafinken sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Zebrafinken gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Zebrafinken sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Zebrafinken k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Variante der Zebrafinkenhaltung stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 12\xb0C)  Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden. Achtung: Im Winterhalbjahr Innenhaltung n\xf6tig!",
                            "specificNeeds": "Eine gemeinsame Haltung mit einer anderen Vogelart ist nur f\xfcr Personen mit viel Fachwissen empfehlenswert."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Zebrafinken",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_zebrafinken_de.pdf"
                            }
                        }
                    },
                    "grayWaxbill": {
                        "name": "Grauastrild",
                        "namePlural": "Grauastrilden",
                        "minAnimalsErrorMessage": "Grauastrilden sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Grauastrilden gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Grauastrilden sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Grauastrilden k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Nur im Sommerhalbjahr m\xf6glich, da Gouldamadinen k\xe4lteempfindlich sind. Im Sommerhalbjahr Aussengehege, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 18\xb0C) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Eine gemeinsame Haltung mit einer anderen Vogelart ist nur f\xfcr Personen mit viel Fachwissen empfehlenswert."
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "goldenBreasted": {
                        "name": "Goldbr\xfcstchen",
                        "namePlural": "Goldbr\xfcstchen",
                        "minAnimalsErrorMessage": "Goldbr\xfcstchen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Goldbr\xfcstchen gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Goldbr\xfcstchen sollten paarweise gehalten werden, da die M\xe4nnchen w\xe4hrend der Brutzeit auf artgleiche Rivalen aggressiv reagieren k\xf6nnen.",
                            "indoor": "Goldbr\xfcstchen k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Nur im Sommerhalbjahr m\xf6glich, da Goldbr\xfcstchen k\xe4lteempfindlich sind. Im Sommerhalbjahr Aussengehege, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 15\xb0C) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n",
                            "specificNeeds": '"langlebig, sehr aktiver Vogel, braucht ger\xe4umige Voliere mit Gras und Schilf. \nEine gemeinsame Haltung mit einer anderen Vogelart ist anspruchsvoll und nur f\xfcr Personen mit viel Fachwissen empfehlenswert."'
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "gouldianMadine": {
                        "name": "Gouldamadine",
                        "namePlural": "Gouldamadinen",
                        "minAnimalsErrorMessage": "Gouldamadinen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Gouldamadinen sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Gouldamadinen k\xf6nnen in Innenr\xe4umen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Nur im Sommerhalbjahr m\xf6glich, da Gouldamadinen k\xe4lteempfindlich sind. Im Sommerhalbjahr Aussengehege, welche aus einer Voliere und einem angrenzenden, beheizbaren (mindestens 18\xb0C) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden. Im Winterhalbjahr brauchen Gouldamadinen zwingend Innenhaltung (siehe oben).",
                            "specificNeeds": "Viel Deckung und gen\xfcgend Versteckm\xf6glichkeiten sind f\xfcr die scheuen V\xf6gel elementar. \n\nEine gemeinsame Haltung mit einer anderen Vogelart ist anspruchsvoll und nur f\xfcr Personen mit viel Fachwissen empfehlenswert.\nAuf den Kauf von Farbzuchtmorphen sollte verzichtet werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Gouldamadinen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Gouldamadinen_de.pdf"
                            }
                        }
                    },
                    "budgerigar": {
                        "name": "Wellensittich",
                        "namePlural": "Wellensittiche",
                        "minAnimalsErrorMessage": "Wellensittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Wellensittiche sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren (mindestens 2, besser 3) Brutpaaren. Daf\xfcr ist eine grosse Voliere n\xf6tig, da M\xe4nnchen w\xe4hrend der Brutzeit den Nistplatz verteidigen.",
                            "indoor": "Wellensittiche k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n",
                            "specificNeeds": '"Wellensittiche brauchen vielf\xe4ltige Kletterm\xf6glichkeiten in Form von verschiedenen, nat\xfcrlichen \xc4sten (Hasel, Weide, Buche, ungespritzte Obstb\xe4ume). Diese dienen gleichzeitig als Nagematerial und sollten regelm\xe4ssig erneuert werden.\n\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert. Extreme Zuchtformen (Bsp. V\xf6gel mit Federhauben) sollen nicht erworben werden. "'
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Wellensittiche",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_wellensittiche_de.pdf"
                            }
                        }
                    },
                    "agapornid": {
                        "name": "Agapornid (Unzertrennliche)",
                        "namePlural": "Agaporniden (Unzertrennliche)",
                        "minAnimalsErrorMessage": "Agaporniden sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme. Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Agaporniden sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Agaporniden k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n\n",
                            "specificNeeds": '"F\xfcr die Heimtierhaltung kommen in erster Linie Pfirsichk\xf6pfchen, Rosenk\xf6pfchen, Schwarzk\xf6pfchen und Russk\xf6pfchen in Frage. Die anderen Agapornidenarten sind anspruchsvoller und daher f\xfcr Anf\xe4nger nicht empfehlenswert.\nEinige Agapornidenarten k\xf6nnen ziemlich aggressiv sein und sind nicht f\xfcr die gemeinsame Haltung mit anderen Arten geeignet.\n\nAgaporniden k\xf6nnen ziemlich laut sein. Daher muss auch die Nachbarschaft mit der Haltung einverstanden sein."'
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Agaporniden",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_de.pdf"
                            }
                        }
                    },
                    "tarantaParrot": {
                        "name": "Tarantapapagei (Bergpapagei)",
                        "namePlural": "Tarantapapageien (Bergpapageien)",
                        "minAnimalsErrorMessage": "Tarantapapageien sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Tarantapapageien sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Tarantapapageien k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen.  Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.\n\n",
                            "specificNeeds": "Tarantapapageien stellen die gr\xf6sste Art der Agaporniden (Unzertrennliche) dar. \nDie Haltung von dieser Agaporniden-Art ist anspruchsvoll und nicht f\xfcr Anf\xe4nger geeignet.\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert. \nTarantapapageien k\xf6nnen zudem ziemlich laut sein. Daher muss auch die Nachbarschaft mit der Haltung einverstanden sein."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Agaporniden",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_de.pdf"
                            }
                        }
                    },
                    "cockatiel": {
                        "name": "Nymphensittich",
                        "namePlural": "Nymphensittiche",
                        "minAnimalsErrorMessage": "Nymphensittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Nymphensittiche sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Nymphensittiche k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicherem) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Nymphensittiche brauchen vielf\xe4ltige Kletterm\xf6glichkeiten in Form von verschiedenen, nat\xfcrlichen \xc4sten (Hasel, Weide, Buche, ungespritzte Obstb\xe4ume). Diese dienen gleichzeitig als Nagematerial und sollten regelm\xe4ssig erneuert werden.\n\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Nymphensittiche",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Nymphensittiche_de.pdf"
                            }
                        }
                    },
                    "beautifulParakeet": {
                        "name": "Sch\xf6nsittich",
                        "namePlural": "Sch\xf6nsittiche",
                        "minAnimalsErrorMessage": "Sch\xf6nsittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung eines Brutpaares ist am tiergerechtesten. Es muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, denn Sch\xf6nsittiche k\xf6nnen sowohl auf Artgenossen als auch auf andere Vogelarten ziemlich aggressiv  reagieren.",
                        "maxAnimalsErrorMessage": "Achtung! Die Haltung von Sch\xf6nsittichen ist aspruchsvoll: Sch\xf6nsittiche sollten als Paar gehalten werden, da sie aggressiv auf Artgenossen und andere Vogelarten reagieren k\xf6nnen.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein, und in Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Sch\xf6nsittiche sind sehr gesellig, k\xf6nnen aber sehr aggressiv gegen\xfcber anderen V\xf6geln, auch Artgenossen, sein. F\xfcr Sch\xf6nsittiche ist daher eine Paarhaltung zu empfehlen.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": '"Sch\xf6nsittiche ben\xf6tigen eine m\xf6glichst grosse Freiflugfl\xe4che, da ihr Flug geradlinig ist. Sie ben\xf6tigen zudem ausreichend Besch\xe4ftigung und Nagem\xf6glichkeiten in Form von verschiedenen ungiftigen, frischen \xc4sten.\nVon einer Vergesellschaftung mit anderen Vogelarten ist abzuraten , da sie aggressiv reagieren k\xf6nnen. "'
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "rosellaConure": {
                        "name": "Rosellasittich",
                        "namePlural": "Rosellasittiche",
                        "minAnimalsErrorMessage": "Rosellasittiche sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 20 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Rosellasittiche sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren. Bei der Haltung von mehreren Paaren muss die Voliere sehr gross sein, da die M\xe4nnchen w\xe4hrend der der Balz- und Brutzeit sehr aggressiv sind.",
                            "indoor": "Rosellasittiche k\xf6nnen in grossz\xfcgigen Volieren oder in Vogelzimmern gehalten werden. Herk\xf6mmliche Vogelk\xe4fige sind viel zu klein f\xfcr eine artgerechte Haltung. Hohe und schmale Volieren sind ungeeignet, weil V\xf6gel zum Fliegen horizontalen Raum ben\xf6tigen. Glasvitrinen eignen sich ebenfalls nicht.",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicheren) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": '"Rosellasittiche ben\xf6tigen eine m\xf6glichst grosse Freiflugfl\xe4che, da sie sehr lebhaft sind. Sie ben\xf6tigen zudem ausreichend Besch\xe4ftigung und Nagem\xf6glichkeiten in Form von verschiedenen ungiftigen, frischen \xc4sten.\nEine Vergesellschaftung mit anderen Arten ist m\xf6glich, jedoch nur f\xfcr fachkundige Vogelhalter empfehlenswert. "'
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "cockatoo": {
                        "name": "Kakadu",
                        "namePlural": "Kakadus",
                        "minAnimalsErrorMessage": "Kakadus sind soziale Tiere. Die Einzelhaltung ist deshalb verboten! Die Haltung von Kakadus (ausser Nymphensittich) ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Kakakdus zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsWarningMessage": "Die Haltung von Kakadus (ausser Nymphensittich) ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Kakakdus zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsErrorMessage": "Die Haltung von Kakadus (ausser Nymphensittich) ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Kakakdus zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "laws": {},
                        "recommendations": {
                            "general": "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Ara-/Kakadu-Haltung ab. Der Platzbedarf f\xfcr eine tiergerechte Ara-/Kakadu-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden. Die Haltung von Kakadus oder Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Vor dem Kauf eines Kakadus oder Aras muss ein Sachkundekurs (SKN) absolviert werden. Zudem muss ein Gesuch an das kantonale Veterin\xe4ramt des Wohnsitzkantons gestellt werden und gezeigt werden, dass alle gesetzlich vorgeschriebenen Anforderungen in Bezug auf Haltung, Pflege und Erwerb erf\xfcllt werden k\xf6nnen. Wenn Sie beabsichtigen  Kakadus oder Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "macaw": {
                        "name": "Ara",
                        "namePlural": "Aras",
                        "minAnimalsErrorMessage": "Aras sind soziale Tiere. Die Einzelhaltung ist deshalb verboten! \nDie Haltung von Grosspapageien wie Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsWarningMessage": "Die Haltung von Grosspapageien wie Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "maxAnimalsErrorMessage": "Die Haltung von Grosspapageien wie Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Wenn Sie beabsichtigen Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons.",
                        "laws": {},
                        "recommendations": {
                            "general": "Aus Tierschutzgr\xfcnden r\xe4t der Schweizer Tierschutz STS von der privaten Ara-/Kakadu-Haltung ab. Der Platzbedarf f\xfcr eine tiergerechte Ara-/Kakadu-Haltung ist immens und kann von privaten Haltern meistens nicht erf\xfcllt werden. Die Haltung von Kakadus oder Aras ist \xe4usserst anspruchsvoll und bewilligungspflichtig. Vor dem Kauf eines Kakadus oder Aras muss ein Sachkundekurs (SKN) absolviert werden. Zudem muss ein Gesuch an das kantonale Veterin\xe4ramt des Wohnsitzkantons gestellt werden und gezeigt werden, dass alle gesetzlich vorgeschriebenen Anforderungen in Bezug auf Haltung, Pflege und Erwerb erf\xfcllt werden k\xf6nnen. Wenn Sie beabsichtigen  Kakadus oder Aras zu halten, wenden Sie sich f\xfcr weitere Informationen an das kantonale Veterin\xe4ramt Ihres Wohnkantons."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "congoGreyParrot": {
                        "name": "Kongo-Graupapagei",
                        "namePlural": "Kongo-Graupapageien",
                        "minAnimalsErrorMessage": "Graupapageien sind soziale Tiere. Die Einzelhaltung ist daher verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 6 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Graupapageien sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Eine reine Innenhaltung ist f\xfcr Graupapageien nicht tiergerecht. ",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostsicher) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Eine tiergerechte Haltung von Graupapgageien ist h\xf6chst anspruchsvoll. \nDer Handel mit diesen \xe4usserst langlebigen Tieren boomt und es gibt sehr viele Angebote von skrupellosen Anbieteren (z.B. Handaufzuchten, Importe aus unklarer Quelle). Graupapageien k\xf6nnen laut sein, daher muss die Nachbarschaft mit der Haltung ebenfalls einverstanden sein. \n\nAus Tierschutzgr\xfcnden sollten Sie auf den Kauf von Tieren aus Handaufzuchten verzichten."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Graupapageien",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_graupapageien_de.pdf"
                            }
                        }
                    },
                    "amazon": {
                        "name": "Amazone",
                        "namePlural": "Amazonen",
                        "minAnimalsErrorMessage": "Amazonen sind soziale Tiere. Die Einzelhaltung ist deshalb verboten!",
                        "maxAnimalsWarningMessage": "Die Haltung mehrerer Brutpaare gemeinsam ist am tiergerechtesten. Allerdings muss unbedingt auf die individuellen Vertr\xe4glichkeiten der Tiere geachtet werden, insbesondere w\xe4hrend der Balz- und Brutzeit. F\xfcr die Haltung von mehr als einem Brutpaar muss  eine grossz\xfcgige Voliere mit vielen R\xfcckzugs- und Ausweichm\xf6glichkeiten gew\xe4hlt werden.",
                        "maxAnimalsErrorMessage": "Bitte gib eine Zahl von maximal 6 oder weniger an.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein, und in Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "Einzelhaltung verboten",
                            "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestmassen nur um das absolute Minimum handelt. V\xf6gel in kleineren K\xe4figen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. F\xfcr eine tiergerechte Vogelhaltung braucht es um ein Vielfaches gr\xf6ssere Volieren und eine gut strukturierte Einrichtung (siehe Empfehlungen)."
                        },
                        "recommendations": {
                            "furnishing": "Nur einem Ende befestigte \xc4ste (=federnde Sitzgelegenheiten), verschiedene Seile, Schaukeln, von der Decke h\xe4ngende Plattformen, Vogelbad (Badeh\xe4uschen oder flache Schale), aufgeh\xe4ngte Kalksteine/Sepiaschalen, Magengrit in flacher Schale, geeignete UV-Lampen bei Haltungen in Innenr\xe4umen, als Bodengrund Sand, Kieselsteine oder Buchenholzgranulat. Die Gitterst\xe4be des Geheges m\xfcssen horziontal ausgerichtet sein. Rundk\xe4fige sind tierschutzwidrig und abzulehnen.",
                            "socialStructure": "Amazonen sind sehr gesellig. Am artgerechtesten ist eine Gruppenhaltung von mehreren Brutpaaren.",
                            "indoor": "Eine reine Innenhaltung ist f\xfcr Amazonen nicht tiergerecht. ",
                            "outdoor": "Die tiergerechteste Haltungsform stellen Aussengehege dar, welche aus einer Voliere und einem angrenzenden, beheizbaren (frostfrei) Innenbereich (Bsp. Gartenh\xe4uschen) bestehen. Die Voliere muss oben teilweise gedeckt sein (Witterungsschutz), und soll auf mindestens zwei Seiten mit einem Sichtschutz (Bepflanzung, blickdichtes Windschutznetz o.\xe4.) versehen werden.",
                            "specificNeeds": "Amazonen sind laute V\xf6gel, daher muss die Nachbarschaft mit der Haltung ebenfalls einverstanden sein. \n\nEs existieren verschiedene Amazonenarten, und nicht jede ist als Heimtier geeignet. Am h\xe4ufigsten ist die Blaustirnamazone. Jede Art hat ihre eigenen, artspezifischen Bed\xfcrfnisse in Bezug auf Haltung, Klima, F\xfctterung, und Sozialstruktur. Bitte informieren Sie sich bei ausgewiesenen Fachpersonen oder absolvieren Sie einen Sachkundekurs vor dem Kauf.\nAus Tierschutzgr\xfcnden sollten Sie auf den Kauf von Tieren aus Handaufzuchten verzichten."
                        },
                        "links": {
                            "0": {
                                "text": "V\xf6gel Tiergerecht halten - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_d_Voegel_A4_web.pdf"
                            }
                        }
                    }
                },
                "equidae": {
                    "horse": {
                        "name": "Pferd",
                        "namePlural": "Pferde",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem Artgenossen, also einem anderen Pferd.",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Wenn immer m\xf6glich",
                            "socialStructure": "Pferde sollten direkten Kontakt zu anderen Pferden haben. Pferde und Esel sprechen eine andere Sprache und haben unterschiedliche Anforderungen an ihre Haltung und F\xfctterung.",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Pferde 2 x 2 h / Woche; Ungenutzte Pferde t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "pony": {
                        "name": "Pony",
                        "namePlural": "Ponys",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem Artgenossen, also mit einem anderen Pony oder Pferd.",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Wenn immer m\xf6glich, jedoch dem Ern\xe4hrungszustand anpassen!",
                            "socialStructure": "Ponys sollten direkten Kontakt zu anderen Ponys oder Pferden haben. ",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden.",
                            "specialRequirements": "Bei jungem, eiwei\xdf- bzw. fruktanreichem Gras besteht insbesondere bei Ponys eine gesteigerte Gefahr an Verfettung, vor allem wenn die Ponys nicht ausreichend bewegt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Ponys 2 x 2 h / Woche; Ungenutzte Ponys t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "donkey": {
                        "name": "Esel",
                        "namePlural": "Esel",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem Artgenossen, also in diesem Fall mit einem anderen Esel.  ",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Begrenzter Weidegang f\xfcr Esel, mehr Bewegung auf grossen Trockenpl\xe4tzen",
                            "socialStructure": "Esel brauchen den direkten Kontakt zu Artgenossen, also anderen Eseln. Sie unterscheiden sich in ihrem Verhalten und ihrer Physiologie von den Pferden. Zus\xe4tzliche Futter- und Besch\xe4ftigungsangebote mit hohem Faseranteil wie \xc4ste und Stroh sind vorzusehen.",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden.",
                            "specialRequirements": "Esel sind sehr effiziente Futterverwerter. Sie brauchen energiearme Nahrung mit niedrigem Zucker- und Proteingehalt, aber hohem Rohfaseranteil. Das Fell der Esel ist kaum wasserabweisend. Bei N\xe4sse sind Esel krankheitsanf\xe4llig. Sie brauchen stets einen trockenen Unterstand. Esel ben\xf6tigen trockenen Untergrund, sonst drohen Hufprobleme."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Esel 2 x 2 h / Woche; Ungenutzte Esel t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Esel",
                                "file": "https://www.tierschutz.com/esel"
                            },
                            "1": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "mule": {
                        "name": "Maultier",
                        "namePlural": "Maultiere",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontaktt zu anderen Equiden haben. Optimalerweise mit einem anderen Maultier",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Begrenzter Weidegang",
                            "socialStructure": "Maultiere bevorzugen den Kontakt zu anderen Maultieren. Selbstverst\xe4ndlich k\xf6nnen Maultiere mit ihrer Mutterstute gehalten werden. Dabei ist aber ihre Physiologie in Bezug auf die F\xfctterung und Weidegang zu beachten. ",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Maultiere 2 x 2 h / Woche; Ungenutzte Maultiere t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "STS Webseite Esel",
                                "file": "https://www.tierschutz.com/esel"
                            },
                            "2": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    },
                    "hinny": {
                        "name": "Maulesel",
                        "namePlural": "Maulesel",
                        "minAnimalsWarningMessage": "Achtung: Equiden m\xfcssen mindestens Sicht-, H\xf6r- und Geruchkontakt zu anderen Equiden haben. Optimalerweise mit einem anderen Maulesel.",
                        "maxAnimalsWarningMessage": "Bei f\xfcnf und mehr gut vertr\xe4glichen Equiden kann die Gesamtliegefl\xe4che um maximal 20 Prozent verkleinert werden, dies wurde bei den folgenden Resultaten ber\xfccksichtigt. Der STS empfiehlt diese Reduktion nicht.",
                        "recommendations": {
                            "pasturing": "Begrenzter Weidegang",
                            "socialStructure": "Maultesel bevorzugen den direkten Kontakt zu Mauleseln. Sie k\xf6nnen aber auch mit Esel und/oder Pferden gehalten werden. Dabei ist aber ihre Physiologie in Bezug auf die F\xfctterung und Weidegang zu beachten.",
                            "activity": "Alle Equiden sollten t\xe4glich besch\xe4ftigt werden."
                        },
                        "laws": {
                            "runoutTime": "Genutzte Maulesel 2 x 2 h / Woche; Ungenutzte Maulesel t\xe4glich 2h",
                            "pasturing": "nicht vorgeschrieben",
                            "structuring": "Werden Equiden in Gruppen gehalten, so m\xfcssen Ausweich- und R\xfcckzugsm\xf6glichkeiten vorhanden sein; keine Ausweich- und R\xfcckzugsm\xf6glichkeiten sind erforderlich f\xfcr abgesetzte Fohlen sowie Jungtiere bis zum Beginn der regelm\xe4ssigen Nutzung, l\xe4ngstens jedoch bis zum Alter von 30 Monaten. Es d\xfcrfen keine Sackgassen vorhanden sein. Equiden d\xfcrfen nicht angebunden gehalten werden.",
                            "exercise": "Equiden ist t\xe4glich ausreichend Bewegung zu gew\xe4hren. Zur Bewegung z\xe4hlen die Nutzung und der Auslauf. Bei extremen Witterungs- und Bodenverh\xe4ltnissen kann der Auslauf ausnahmsweise auf einer \xfcberdachten Fl\xe4che gew\xe4hrt werden.",
                            "activity": "Equiden muss zur arttypischen Besch\xe4ftigung ausreichend Raufutter wie Futterstroh zur Verf\xfcgung stehen, ausgenommen w\xe4hrend des Weidegangs.",
                            "socialStructure": "Equiden m\xfcssen Sicht-, H\xf6r- und Geruchkontakt zu einem anderen Equide haben. Equiden m\xfcssen nach dem Absetzen vom Muttertier bis zum Alter von 30 Monaten oder bis zum Beginn der regelm\xe4ssigen Nutzung in Gruppen gehalten werden."
                        },
                        "links": {
                            "0": {
                                "text": "STS Webseite Pferdehaltung",
                                "file": "https://www.tierschutz.com/pferde"
                            },
                            "1": {
                                "text": "STS Webseite Esel",
                                "file": "https://www.tierschutz.com/esel"
                            },
                            "2": {
                                "text": "Tierschutzverordnung",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                            }
                        }
                    }
                }
            },
            "screenCategory": {
                "title": "Kategorie ausw\xe4hlen"
            },
            "screenAnimal": {
                "title": "Welches Tier m\xf6chtest du halten?",
                "multipleBirdsButton": "Mehrere Arten zusammen halten",
                "equidaeInfo": "Die berechneten Werte gelten nur f\xfcr Equiden \xfcber 30 Monaten."
            },
            "screenMultipleBirds": {
                "warning": "Um zwei oder mehr Vogelarten zusammen zu halten, muss die Gehegegr\xf6sse f\xfcr alle Arten separat berechnet werden, aber mit der Gesamtzahl V\xf6gel. Das gr\xf6sste berechnete Gehege entspricht den gesetzlichen Mindestmassen.",
                "infoText": "Werden in einem Gehege zwei oder mehr Vogelarten gemeinsam gehalten, so entspricht die gesetzliche Gehegemindestgr\xf6sse immer den Platz-Anforderungen an die gr\xf6sste Vogelart. Werden zum Beispiel zwei Wellensittiche und zwei Nymphensittiche in einem Gehege zusammen gehalten, entspricht die minimale Gehegegr\xf6sse den Anforderungen f\xfcr vier Nymphensittiche, da dies die gr\xf6sste Vogelart im Gehege ist. Die gemeinsame Haltung von mehreren Vogelarten ist nur f\xfcr erfahrene Vogelhalter geeignet. Informieren Sie sich stets sorgf\xe4ltig, welche Vogelarten gemeinsam gehalten werden k\xf6nnen."
            },
            "screenNumber": {
                "title": "Wie viele {animals} m\xf6chtest du halten?"
            },
            "screenWeight": {
                "title": "Wie schwer sind die {animals}?"
            },
            "screenLength": {
                "title": "Wie lange ist {article} gr\xf6sste {animal}?",
                "error": "Bitte eine Zahl zwischen {min} und {max} eingeben."
            },
            "screenWithersHeight": {
                "title": "Wie hoch ist die Widerrist-H\xf6he der einzelnen Tiere?",
                "error": "Bitte eine Zahl zwischen {min} und {max} eingeben.",
                "animal": "Tier"
            },
            "screenResults": {
                "title": "So solltest du {number} {animals} halten",
                "example": "Beispiel",
                "exampleEquidae": "Beispiel f\xfcr Boxengr\xf6sse",
                "stsRecommendation": "Tierschutz-Empfehlung",
                "law": "Gesetz",
                "stsAreaRecommendation": "Mindestfl\xe4che (Innenmasse)",
                "stsLengthRecommendation": {
                    "upto2reptiles": "Mindestl\xe4nge (Innenmasse)",
                    "morethan2reptiles": "Zus\xe4tzlich mindestens in der L\xe4nge"
                },
                "stsWidthRecommendation": {
                    "upto2reptiles": "Mindestbreite (Innenmasse)",
                    "morethan2reptiles": "Zus\xe4tzlich mindestens in der Breite"
                },
                "stsHeightRecommendation": "Mindesth\xf6he Gehege (Innenmasse)",
                "stsBeddingRecommendation": "Mindesteinstreutiefe",
                "stsWaterBasinRecommendation": "Wasserbecken",
                "tolerance": "Toleranzwert",
                "toleranceInfo": "Am 1. September 2008 bestehende Stallungen, die die Toleranzwerte erf\xfcllen, m\xfcssen nicht angepasst werden. Muss ein Stall wegen Unterschreiten eines Toleranzwertes angepasst werden, so bleibt der Anspruch auf den anderen Toleranzwert erhalten.",
                "noTolerance": "kein Toleranzwert",
                "stsLayingAreaRecommendation": "Liegefl\xe4che",
                "stsClearWidthRecommendation": "Lichte Breite",
                "stsClearWidthRecommendationInfo": "2 x Widerrist des gr\xf6ssten Tieres",
                "stsClearHeightRecommendation": "Lichte H\xf6he",
                "stsRunoutTimeRecommendation": "Auslaufzeit",
                "stsRunoutTimeRecommendationText": "Am besten 24 h freier Zugang zum Allwetterauslauf aber mindestens 4 Stunden t\xe4glich",
                "stsRunoutAreaRecommendation": "Auslauffl\xe4che",
                "stsPasturingRecommendation": "Weidegang",
                "stsLatticeSpacing": "Maximaler Gitterabstand",
                "lawMinimalArea": "Mindestfl\xe4che (Innenmasse)",
                "lawMinimalLength": "Mindestl\xe4nge (Innenmasse)",
                "lawMinimalWidth": "Mindestbreite (Innenmasse)",
                "lawMinimalHeight": "Mindesth\xf6he Gehege (Innenmasse)",
                "lawMinimalBedding": "Mindesteinstreutiefe",
                "lawWaterBasin": "Wasserbecken",
                "lawReptilesInfo": {
                    "text": "Bei der Haltung der eingegebenen Anzahl Tiere muss sichergestellt werden, dass f\xfcr die jeweilige Tierart s\xe4mtliche gesetzlichen Anforderungen {link} erf\xfcllt sind.",
                    "linkText": "gem\xe4ss Anhang 2, Tabelle 5 TSchV",
                    "linkURL": "https://www.fedlex.admin.ch/eli/cc/2008/416/de"
                },
                "lawVolume": "Volumen",
                "lawLayingArea": "Liegefl\xe4che Einraumlaufstall",
                "layingAreaInfo": "Liegefl\xe4chen r\xe4umlich nicht vom Fressbereich getrennt, weitere Bedingungen siehe Tierschutzverordnung Tabelle 7.",
                "lawLayingAreaMultiroom": "Liegefl\xe4che Mehrraumlaufstall",
                "layingAreaMultiroomInfo": "Liegefl\xe4che sind r\xe4umlich, z. B. durch eine Wand oder andere Raumteiler, vom Fress- und Bewegungsbereich getrennt. Weitere Bedingungen siehe Tierschutzverordnung Tabelle 7.",
                "lawClearWidth": "Lichte Breite",
                "lawClearWidthInfo": "1.5 x Widerrist des gr\xf6ssten Tieres",
                "lawClearHeight": "Lichte H\xf6he",
                "lawRunoutTime": "Auslaufzeit",
                "lawRunoutAreaAdjacent": "Auslauffl\xe4che angrenzend",
                "lawRunoutAreaNonadjacent": "Auslauffl\xe4che nicht angrenzend",
                "lawPasturing": "Weidegang",
                "additionalRecommendations": {
                    "title": "Weitere Empfehlungen",
                    "furnishing": "Einrichtung",
                    "socialStructure": "Sozialstruktur",
                    "socialSturctureAndSpecificNeeds": "Sozialstruktur und artspezifische Bed\xfcrfnisse",
                    "indoorOutdoor": "Aussen- oder Innenhaltung",
                    "indoor": "Innenhaltung",
                    "outdoor": "Aussenhaltung",
                    "specificNeeds": "Besondere artspezifische Bed\xfcrfnisse",
                    "specialRequirements": "Spezielle Anforderungen",
                    "more": "Weiteres",
                    "activity": "Bewegung"
                },
                "additionalLaws": {
                    "title": "Weitere gesetzliche Vorschriften",
                    "furnishing": "Einrichtung",
                    "raisedAreas": "Erh\xf6hte Fl\xe4chen",
                    "socialStructure": "Sozialstruktur",
                    "structuring": "Strukturierung",
                    "activity": "Bewegung",
                    "exercise": "Besch\xe4ftigung"
                },
                "lawDetails": "Bitte beachten Sie, dass es sich bei den gesetzlichen Mindestvorschriften nur um das absolute Minimum handelt. Tiere in kleineren Gehegen zu halten ist in der Schweiz verboten und aus Sicht des STS Tierqu\xe4lerei. \nF\xfcr eine tiergerechte Haltung braucht es sehr viel gr\xf6ssere Fl\xe4chen und eine gut strukturierte Einrichtung (siehe Empfehlungen).",
                "furnishing": "Gesetzlich geforderte Einrichtung",
                "additionalInfo": "F\xfcr mehr Informationen"
            }
        }
    },
    "fr_CH": {
        "txt": {
            "title": "Calculateur enclos animaux",
            "buttonNext": "Suivant",
            "buttonPrevious": "Retour",
            "buttonClose": "Fermer",
            "buttonAcceptWarning": "Compris",
            "domain": "calculateur-enclos-animaux.ch",
            "link": "https://www.calculateur-enclos-animaux.ch/",
            "trButton": {
                "cta": "Pour en savoir plus sur le bien-\xeatre des animaux :",
                "buttonText": "Ouvrir le calculateur des enclos pour animaux"
            },
            "categories": {
                "rodents": {
                    "name": "Rongeurs & lapins"
                },
                "reptiles": {
                    "name": "Reptiles"
                },
                "birds": {
                    "name": "Oiseaux"
                },
                "equidae": {
                    "name": "\xc9quid\xe9s"
                }
            },
            "animals": {
                "rodents": {
                    "degu": {
                        "name": "D\xe8gue",
                        "namePlural": "D\xe8gues",
                        "minAnimalsErrorMessage": "Les d\xe8gues sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les d\xe8gues doivent \xeatre d\xe9tenus en groupes de 2 \xe0 5 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les d\xe8gues doivent \xeatre d\xe9tenus en groupes de 2 \xe0 5 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe: 2 \xe0 5 animaux\nComposition du groupe: groupe uniquement de femelles, groupe uniquement de m\xe2les, un m\xe2le castr\xe9 avec plusieurs femelles\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, fourrage grossier (foin ou paille), objets \xe0 ronger (branches fra\xeeches...), bain de sable\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les d\xe8gues sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenus sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: D\xe8gue du Chili",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_degu_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "dwarfHamster": {
                        "name": "Hamster nain",
                        "namePlural": "Hamsters nains",
                        "minAnimalsWarningMessage": "Attention, la d\xe9tention de hamsters nains est tr\xe8s d\xe9licate et r\xe9serv\xe9e \xe0 des d\xe9tenteurs de rongeurs exp\xe9riment\xe9s.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe!",
                        "recommendations": {
                            "socialStructure": "La d\xe9tention de hamsters nains est d\xe9licate et demande beaucoup d’exp\xe9rience. Avant d’acheter, renseignez-vous aupr\xe8s des professionnels pour savoir quelles esp\xe8ces peuvent \xeatre d\xe9tenues dans quelles tailles et compositions de groupes\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper, liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "La d\xe9tention individuelle et en groupe de hamsters nains est autoris\xe9e.\n"
                        },
                        "links": {
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "fancyMouse": {
                        "name": "Souris domestique",
                        "namePlural": "Souris domestiques",
                        "minAnimalsErrorMessage": "Les souris domestiques sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les souris domestiques doivent \xeatre d\xe9tenues en groupes de 2 \xe0 6 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les souris domestiques doivent \xeatre d\xe9tenues en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: groupe uniquement de femelles, un m\xe2le castr\xe9 avec plusieurs femelles\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper, liti\xe8re adapt\xe9e, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les souris domestiques sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenues sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Souris domestique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_farbm%C3%A4use_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "gerbil": {
                        "name": "Gerbille",
                        "namePlural": "Gerbilles",
                        "minAnimalsErrorMessage": "Les gerbilles sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les gerbilles doivent \xeatre d\xe9tenues en groupes de 2 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les gerbilles doivent \xeatre d\xe9tenues en groupes de 2 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \nComposition du groupe: groupe uniquement de femelles, groupe uniquement de m\xe2les, un m\xe2le castr\xe9 avec une femelle\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel adapt\xe9 pour faire un nid, fourrage grossier (foin ou paille), objets \xe0 ronger (branches fra\xeeches...), bain de sable\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les gerbilles sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenues sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Gerbilles de Mongolie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_rennmaus_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "goldenHamster": {
                        "name": "Hamster dor\xe9",
                        "namePlural": "Hamsters dor\xe9s",
                        "maxAnimalsErrorMessage": "Les hamsters dor\xe9s sont des animaux solitaires et doivent \xeatre d\xe9tenus seuls.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 1\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper, liti\xe8re adapt\xe9e pour creuser, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les hamsters dor\xe9s sont des animaux solitaires et doivent \xeatre d\xe9tenus seuls.\n",
                            "links": {
                                "0": {
                                    "text": "Feulle d’information PSA: Hamster dor\xe9 de Syrie",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_goldhamster_fr.pdf"
                                },
                                "1": {
                                    "text": "D\xe9tenir des rongeurs et des Lapins",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                                },
                                "2": {
                                    "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                                },
                                "3": {
                                    "text": "Assortiment des animaleries et boutiques en ligne",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                                },
                                "4": {
                                    "text": "Check-list animaleries",
                                    "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                                }
                            }
                        }
                    },
                    "guineaPig": {
                        "name": "Cochon d’Inde",
                        "namePlural": "Cochons d’Inde",
                        "minAnimalsErrorMessage": "Les cochons d’Inde sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les cochons d’Inde doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les cochons d’Inde doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: groupe uniquement de femelles ou un m\xe2le castr\xe9 avec plusieurs femelles, parfois aussi en groupes uniquement de m\xe2les\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e, possibilit\xe9s de retrait pour tous les animaux, objets \xe0 ronger (branches fra\xeeches...), fourrage grossier (foin ou paille), aliments contenant de la vitamine C\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es praticables peuvent \xeatre compt\xe9es jusqu’\xe0 un tiers de la surface minimale requise, \xe0 condition que la surface inf\xe9rieure soit aussi utilisable par les animaux.\n",
                            "socialStructure": "Les cochons d’Inde sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenus sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Cochons d’Inde",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_meerschweinchen_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "rabbit": {
                        "name": "Lapin",
                        "namePlural": "Lapins",
                        "minAnimalsErrorMessage": "Les lapins sont des animaux sociaux. La d\xe9tention individuelle n’est autoris\xe9e qu’en cas de contact auditif ou olfactif avec d’autres cong\xe9n\xe8res!",
                        "maxAnimalsWarningMessage": "Actuellement, \xe0 partir d'une taille de groupe de trois animaux, les recommandations concernent uniquement la surface minimale. Les recommandations actuelles en mati\xe8re de surface sont tr\xe8s r\xe9duites et en cours de r\xe9vision.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les lapins doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: un m\xe2le castr\xe9 avec 1 ou 2 femelles, 2 m\xe2les castr\xe9s avec 2 \xe0 4 femelles, des groupes uniquement de femelles sont parfois aussi possibles\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe9s de retrait pour tous les animaux, objets \xe0 ronger (branches fra\xeeches...), fourrage grossier (foin ou paille)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es praticables peuvent \xeatre compt\xe9es dans la surface minimale requise, \xe0 condition que la surface inf\xe9rieure soit aussi utilisable par les animaux.\n",
                            "socialStructure": "Les lapins sont des animaux sociaux. La d\xe9tention individuelle n’est autoris\xe9e qu’en cas de contact auditif et olfactif avec d’autres cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Lapin",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    },
                    "rat": {
                        "name": "Rat",
                        "namePlural": "Rats",
                        "minAnimalsErrorMessage": "Les rats sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "Taille maximale du groupe d\xe9pass\xe9e. Les rats doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "maxAnimalsErrorMessage": "Une d\xe9tention respectueuse des animaux dans un enclos n’est plus possible avec cette taille de groupe! Les rats doivent \xeatre d\xe9tenus en groupes de 2 \xe0 6 animaux.",
                        "recommendations": {
                            "socialStructure": "Taille de groupe recommand\xe9e: 2 \xe0 6 animaux\nComposition du groupe: groupes uniquement de m\xe2les, groupes uniquement de femelles, groupe mixte avec m\xe2les castr\xe9s\n"
                        },
                        "laws": {
                            "furnishing": "Liti\xe8re adapt\xe9e, possibilit\xe9s de retrait pour tous les animaux, mat\xe9riel de nidification appropri\xe9, fourrage grossier (foin, paille, m\xe9langes de graines), objets \xe0 ronger (branches fra\xeeches...)\n",
                            "raisedAreas": "Les plateformes sur\xe9lev\xe9es ne doivent pas \xeatre compt\xe9es dans la surface minimale.\n",
                            "socialStructure": "Les rats sont des animaux sociaux et ne doivent pas \xeatre d\xe9tenus sans cong\xe9n\xe8res.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Feulle d’information PSA: Le rat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_ratten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tenir des rongeurs et des Lapins",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Nager_A4_web.pdf"
                            },
                            "2": {
                                "text": "Checkliste \xe0 l’attention des futurs d\xe9tenteurs d‘animaux",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/checkliste_fr.pdf"
                            },
                            "3": {
                                "text": "Assortiment des animaleries et boutiques en ligne",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_assortiment_animaleries.pdf"
                            },
                            "4": {
                                "text": "Check-list animaleries",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_fr.pdf"
                            }
                        }
                    }
                },
                "reptiles": {
                    "royalPython": {
                        "name": "Python royal",
                        "namePlural": "Pythons royaux",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des pythons royaux. Les pythons royaux cohabitent bien avec leurs cong\xe9n\xe8res.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des pythons royaux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des pythons royaux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9 de baignade, possibilit\xe9s de se cacher, temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "Oui"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, possibilit\xe9s de grimper, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches et plateformes sur\xe9lev\xe9es, Wetbox, bassin, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 26-32 \xb0C, spot chauffant \xe0 36 \xb0C, baisser la temp\xe9rature la nuit, les pythons royaux s’entendent tr\xe8s bien entre eux et peuvent \xeatre d\xe9tenus par deux ou par trois si le terrarium est assez grand.\n",
                            "waterBasin": "Bassins"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Python royal",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_k%C3%B6nigspython_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "cornSnake": {
                        "name": "Serpent des bl\xe9s",
                        "namePlural": "Serpents des bl\xe9s",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents des bl\xe9s. Les serpents des bl\xe9s cohabitent bien avec leurs cong\xe9n\xe8res.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents des bl\xe9s. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des serpents des bl\xe9s. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de se cacher, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, bassin, possibilit\xe9s de grimper, substrat meuble, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches, Wetbox, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 24-28 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e.\n",
                            "waterBasin": "Bassins"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Serpent des bl\xe9s",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_kornnatter_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "greekTortoise": {
                        "name": "Tortue d’Hermann",
                        "namePlural": "Tortues d’Hermann",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et sol pour creuser, place au soleil ainsi que des lampes \xe9mettand des UV, acc\xe8s \xe0 la lumi\xe8re naturelle du soleil, sorties \xe0 l’ext\xe9rieur, possibilit\xe9 d’hiberner\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Enclos ext\xe9rieur avec cl\xf4ture anti-fugue et possibilit\xe9s de s\xe9paration, abri clos, p. ex. serre, couche \xe0 semis, substrat vari\xe9 en partie creusable (pierres, sable, gravier, calcaire du Jura…), points chauds, possibilit\xe9 de retrait, p. ex. v\xe9g\xe9tation, racines, pierres etc., eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (foin, herbes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’hibernation, d’am\xe9nagement de l’enclos et d’alimentation. La possibilit\xe9 d’hiberner en toute s\xe9curit\xe9 est importante.\n",
                            "more": "Les tortues terrestres ont une esp\xe9rance de vie tr\xe8s longue (40-80 ans)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informations de base sur la d\xe9tention des Tortues terrestres europ\xe9ennes,",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tention respectueuse des tortues dans la pratique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_fr.pdff"
                            },
                            "2": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "moorishTortoise": {
                        "name": "Tortue mauresque",
                        "namePlural": "Tortues mauresques",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et sol pour creuser, place au soleil ainsi que des lampes \xe9mettand des UV, acc\xe8s \xe0 la lumi\xe8re naturelle du soleil, sorties \xe0 l’ext\xe9rieur, possibilit\xe9 d’hiberner\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Enclos ext\xe9rieur avec cl\xf4ture anti-fugue et possibilit\xe9s de s\xe9paration, abri clos, p. ex. serre, couche \xe0 semis, substrat vari\xe9 en partie creusable (pierres, sable, gravier, calcaire du Jura…), points chauds, possibilit\xe9 de retrait, p. ex. v\xe9g\xe9tation, racines, pierres etc., eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (foin, herbes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’hibernation, d’am\xe9nagement de l’enclos et d’alimentation. La possibilit\xe9 d’hiberner en toute s\xe9curit\xe9 est importante.\n",
                            "more": "Les tortues terrestres ont une esp\xe9rance de vie tr\xe8s longue (40-80 ans)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informations de base sur la d\xe9tention des Tortues terrestres europ\xe9ennes,",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tention respectueuse des tortues dans la pratique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_fr.pdff"
                            },
                            "2": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "wideShelledTortoise": {
                        "name": "Tortue bord\xe9e",
                        "namePlural": "Tortues bord\xe9es",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des tortues terrestres. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et sol pour creuser, place au soleil ainsi que des lampes \xe9mettand des UV, acc\xe8s \xe0 la lumi\xe8re naturelle du soleil, sorties \xe0 l’ext\xe9rieur, possibilit\xe9 d’hiberner\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Enclos ext\xe9rieur avec cl\xf4ture anti-fugue et possibilit\xe9s de s\xe9paration, abri clos, p. ex. serre, couche \xe0 semis, substrat vari\xe9 en partie creusable (pierres, sable, gravier, calcaire du Jura…), points chauds, possibilit\xe9 de retrait, p. ex. v\xe9g\xe9tation, racines, pierres etc., eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (foin, herbes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’hibernation, d’am\xe9nagement de l’enclos et d’alimentation. La possibilit\xe9 d’hiberner en toute s\xe9curit\xe9 est importante.\n",
                            "more": "Les tortues terrestres ont une esp\xe9rance de vie tr\xe8s longue (40-80 ans)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informations de base sur la d\xe9tention des Tortues terrestres europ\xe9ennes,",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_fr.pdf"
                            },
                            "1": {
                                "text": "D\xe9tention respectueuse des tortues dans la pratique",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_fr.pdff"
                            },
                            "2": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "crownedGecko": {
                        "name": "Gecko \xe0 cr\xeate",
                        "namePlural": "Geckos \xe0 cr\xeate",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos \xe0 cr\xeate. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos \xe0 cr\xeate. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos \xe0 cr\xeate. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher, temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux (p. ex. tubes de li\xe8ge, racines, plantes), possibilit\xe9s de grimper (p. ex. branches finement ramifi\xe9es, plantes), substrat pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, baisser la temp\xe9rature la nuit. Temp\xe9ratures hivernales inf\xe9rieures de 5-6 \xb0C. Les m\xe2les ne s’entendent pas entre eux, ne pas compter sur leur socialisation.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "boaConstrictor": {
                        "name": "Boa constricteur",
                        "namePlural": "Boas constricteurs",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des boas constricteurs. Les boas constricteurs s’entendent tr\xe8s bien entre eux et peuvent \xeatre d\xe9tenus par deux ou par trois si le terrarium est assez grand.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des boas constricteurs. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des boas constricteurs. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9 de baignade, possibilit\xe9s de se cacher, temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de grimper\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, possibilit\xe9s de grimper, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches et plateformes sur\xe9lev\xe9es, Wetbox, bassin, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 22-30 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit, les boas constricteurs s’entendent tr\xe8s bien entre eux et peuvent \xeatre d\xe9tenus par deux ou par trois si le terrarium est assez grand.\n",
                            "more": "Les boas constricteurs peuvent atteindre plus de 4 m de long. Les donn\xe9es indiqu\xe9es ici concernent des animaux mesurant jusqu’\xe0 250 cm de longueur. Les animaux plus grands ont besoin de plus grands enclos.\n",
                            "waterBasin": "Bassin 0.5 m\xb2"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "muskTurtle": {
                        "name": "Sternotherus odoratus",
                        "namePlural": "Sternotherus odoratus",
                        "textLength": "Pour les tortues, on mesure la longueur de la carapace.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des sternotherus odoratus. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des sternotherus odoratus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des sternotherus odoratus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, place au soleil ainsi que des lampes \xe9mettand des UV, possibilit\xe9s de se cacher\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "en plus de la surface"
                        },
                        "recommendations": {
                            "furnishing": "D\xe9tention en ext\xe9rieur recommand\xe9e en \xe9t\xe9, lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. racines, branches, pierres, feuillage, partie terrestre facilement accessible, nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-28 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit, hibernation dans un endroit frais recommand\xe9e.\n",
                            "waterBasin": "de la surface totale"
                        },
                        "links": {
                            "0": {
                                "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                                "file": "https://www.tierschutz.com/publikationen/heimtiere/infothek/gehege/broschuere_gehege_reptilien.pdf"
                            },
                            "1": {
                                "text": "Merkblatt Reptilien als Heimtiere",
                                "file": "http://www.tierschutz.com/publikationen/heimtiere/infothek/reptilien/reptilien_heimtiere.pdf"
                            }
                        }
                    },
                    "kingSnake": {
                        "name": "Serpent roi",
                        "namePlural": "Serpents rois",
                        "textLength": "Pour les serpents, on mesure toute la longueur du corps.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents rois.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des serpents rois. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des serpents rois. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Temp\xe9rature et conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce, possibilit\xe9s de se cacher\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage doit \xeatre install\xe9 de mani\xe8re \xe0 ce que les animaux ne puissent pas s’y br\xfbler, bassin, possibilit\xe9s de grimper, substrat meuble, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, branches, Wetbox, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (proies)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 35 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e.\n",
                            "more": "Les serpents rois se nourrissent \xe9galement d’autres serpents et ne doivent donc pas \xeatre d\xe9tenus avec d’autres serpents.\n",
                            "waterBasin": "Bassins"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "madagascarDayGecko": {
                        "name": "Gecko diurne de Madagascar",
                        "namePlural": "Geckos diurnes de Madagascar",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux aient acc\xe8s \xe0 la lumi\xe8re (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas se br\xfbler aux lampes, syst\xe8me de production de l’humidit\xe9 de l’air n\xe9cessaire, p. ex. n\xe9buliseur, syst\xe8me d’aspersion, vaporisateur, v\xe9g\xe9tation, cascade, etc., syst\xe8me de mesure de la temp\xe9rature et de l’humidit\xe9 de l’air, possibilit\xe9s de grimper vari\xe9es et adapt\xe9es \xe0 l’esp\xe8ce, au moins de l’\xe9paisseur du corps (paroi arri\xe8re, branches, b\xe2tons de bambou, plantes \xe0 feuilles larges, etc.), possibilit\xe9s de retrait adapt\xe9es \xe0 l’esp\xe8ce (v\xe9g\xe9tation, racines, pierres, tiges de bambou coup\xe9es, etc.), substrat adapt\xe9, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes, nectar, pulpe de fruit)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 40\xb0C, baisser la temp\xe9rature la nuit. Les m\xe2les ne s’entendent pas entre eux, ne pas compter sur leur socialisation.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Grand gecko diurne de Madagascar",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_it.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "goldDustDayGecko": {
                        "name": "Gecko diurne \xe0 poussi\xe8re d’or",
                        "namePlural": "Geckos diurnes \xe0 poussi\xe8re d’or",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos diurnes. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux aient acc\xe8s \xe0 la lumi\xe8re (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas se br\xfbler aux lampes, syst\xe8me de production de l’humidit\xe9 de l’air n\xe9cessaire, p. ex. n\xe9buliseur, syst\xe8me d’aspersion, vaporisateur, v\xe9g\xe9tation, cascade, etc., syst\xe8me de mesure de la temp\xe9rature et de l’humidit\xe9 de l’air, possibilit\xe9s de grimper vari\xe9es et adapt\xe9es \xe0 l’esp\xe8ce, au moins de l’\xe9paisseur du corps (paroi arri\xe8re, branches, b\xe2tons de bambou, plantes \xe0 feuilles larges, etc.), possibilit\xe9s de retrait adapt\xe9es \xe0 l’esp\xe8ce (v\xe9g\xe9tation, racines, pierres, tiges de bambou coup\xe9es, etc.), substrat adapt\xe9, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes, nectar, pulpe de fruit)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 40\xb0C, baisser la temp\xe9rature la nuit. Les animaux m\xe2les ne s’entendent pas entre eux, ne pas compter sur leur socialisation.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "leopardGecko": {
                        "name": "Gecko l\xe9opard",
                        "namePlural": "Gecko l\xe9opards",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos l\xe9opards. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des geckos l\xe9opards. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des geckos l\xe9opards. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher, possibilit\xe9s de creuser, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et \xe9clairage\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampes \xe9mettant des UV et \xe9clairage de base, syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux (p. ex. tubes de li\xe8ge, racines, au moins une cachette l\xe9g\xe8rement humide), possibilit\xe9s de grimper (p. ex. structures rocheuses, paroi arri\xe8re, racines), substrat pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, de repos hivernal, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 22-28 \xb0C, spot chauffant \xe0 35\xb0C, baisser la temp\xe9rature la nuit. Les m\xe2les sont territoriaux et la socialisation n’est pas recommand\xe9e.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Gecko l\xe9opard",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_leopardgecko_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "dwarfBeardedDragon": {
                        "name": "Agame barbu nain",
                        "namePlural": "Agames barbus nains",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent g\xe9n\xe9ralement pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent pas entre eux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des agames barbus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et de grimper, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Plateformes sur\xe9lev\xe9es, lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux y aient acc\xe8s (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas s’y br\xfbler (pas de contact direct possible avec la lampe), syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, possibilit\xe9 de baignade, possibilit\xe9s de grimper et rochers, sable pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (nourriture fra\xeeche, insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, de repos hivernal, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 45 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e. M\xeame si les agames barbus sont des solitaires en dehors de la p\xe9riode d’accouplement, la compagnie de cong\xe9n\xe8res est un enrichissement important, \xe0 condition que les animaux s’entendent.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Agame barbu",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_fr.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    },
                    "centralBeardedDragon": {
                        "name": "Pogona vitticeps",
                        "namePlural": "Pogona vitticeps",
                        "textLength": "Pour les l\xe9zards, on mesure la longueur du corps sans la queue.",
                        "minAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent pas entre eux.",
                        "maxAnimalsWarningMessage": "Informez-vous sur la structure sociale des agames barbus. Les m\xe2les ne s’entendent pas entre eux. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas recommand\xe9.",
                        "maxAnimalsErrorMessage": "Informez-vous sur la structure sociale des agames barbus. Un nombre aussi \xe9lev\xe9 d’animaux n’est pas acceptable.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de se cacher et de grimper, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et Possibilit\xe9s de grimper \xe0 l’horizontale et \xe0 la verticale, possibilit\xe9s de se cacher, conditions climatiques adapt\xe9es \xe0 l’esp\xe8ce et place au soleil ainsi que des lampes \xe9mettand des UV\n",
                            "socialStructure": "Respecter la structure sociale. D\xe9tention isol\xe9e des animaux \xe9ventuellement possible.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Plateformes sur\xe9lev\xe9es, lampes \xe9mettant des UV et \xe9clairage de base, l’\xe9clairage UV doit \xeatre install\xe9 de mani\xe8re \xe0 ce que tous les animaux y aient acc\xe8s (placement appropri\xe9 et nombre suffisant de points chauds), mais ne puissent pas s’y br\xfbler (pas de contact direct possible avec la lampe), syst\xe8me de mesure pour le contr\xf4le de la temp\xe9rature et de l’humidit\xe9, au moins autant de possibilit\xe9s de retrait que d’animaux, p. ex. tubes de li\xe8ge, racines, possibilit\xe9 de baignade, possibilit\xe9s de grimper et rochers, sable pour creuser, eau et nourriture adapt\xe9e \xe0 l’esp\xe8ce (nourriture fra\xeeche, insectes)\n",
                            "socialStructure": "Prendre en compte les besoins sp\xe9cifiques de l’esp\xe8ce en mati\xe8re d’habitat, de comportement social, de climat, de repos hivernal, d’am\xe9nagement du terrarium et d’alimentation. Temp\xe9rature de base 25-30 \xb0C, spot chauffant \xe0 45 \xb0C, baisser la temp\xe9rature la nuit; selon le climat d’origine, hibernation dans un endroit frais recommand\xe9e. M\xeame si les agames barbus sont des solitaires en dehors de la p\xe9riode d’accouplement, la compagnie de cong\xe9n\xe8res est un enrichissement important, \xe0 condition que les animaux s’entendent.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information Agame barbu",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Reptiles: Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Feuille d'information Des reptiles pour animaux de compagnie",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_fr.pdf"
                            }
                        }
                    }
                },
                "birds": {
                    "diamondDove": {
                        "name": "Colombe (g\xe9op\xe9lie) diamant",
                        "namePlural": "Colombes (g\xe9op\xe9lies) diamants",
                        "minAnimalsErrorMessage": "Les colombes diamants sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des colombes diamants est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "Possibilit\xe9s de baignade, perchoirs souples de diff\xe9rentes \xe9paisseurs et orientations ainsi qu’une mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les colombes diamants sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe avec plusieurs couples nicheurs.",
                            "indoor": "Les colombes diamants peuvent \xeatre d\xe9tenues \xe0 l’int\xe9rieur dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La variante la plus respectueuse des animaux pour d\xe9tenir des colombes diamants est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les colombes diamants sont g\xe9n\xe9ralement tr\xe8s paisibles et peuvent \xeatre d\xe9tenues avec d’autres esp\xe8ces d’oiseaux paisibles \xe0 condition d’avoir les comp\xe9tences n\xe9cessaires. \nLes colombes diamants aiment passer beaucoup de temps au sol pendant la journ\xe9e. Il est donc essentiel qu’elles disposent d’une surface au sol spacieuse. Elles sont tr\xe8s agiles en vol, elles doivent donc disposer aussi d’un espace de vol suffisant."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "canary": {
                        "name": "Canari",
                        "namePlural": "Canaris",
                        "minAnimalsErrorMessage": "Les canaris sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des canaris est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les canaris sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les canaris peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La variante la plus respectueuse des animaux pour d\xe9tenir des canaris est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "D\xe9tenir des canaris avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances. Attention: il existe des vari\xe9t\xe9s d’\xe9levage de canaris (p. ex. certains canaris de posture) qui font partie des pratiques d’\xe9levage associ\xe9es \xe0 de grandes souffrances qu’il est fortement d\xe9conseill\xe9 d’acheter."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Kanarienvogel",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_kanarien_fr.pdf"
                            }
                        }
                    },
                    "zebraFinch": {
                        "name": "Diamant mandarin",
                        "namePlural": "Diamants mandarins",
                        "minAnimalsErrorMessage": "Les diamants mandarins sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des diamants mandarins est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les diamants mandarins sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les diamants mandarins peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La variante la plus respectueuse des animaux pour d\xe9tenir des diamants mandarins est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (au moins 12 \xb0C). Une partie du toit de la voli\xe8re doit \xeatrecouverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.). Attention: il faut les d\xe9tenir en int\xe9rieur en automne et en hiver!",
                            "specificNeeds": "D\xe9tenir des diamants mandarins avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Zebrafinken",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_zebrafinken_fr.pdf"
                            }
                        }
                    },
                    "grayWaxbill": {
                        "name": "Astrild cendr\xe9",
                        "namePlural": "Astrilds cendr\xe9s",
                        "minAnimalsErrorMessage": "Les astrilds cendr\xe9s sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des astrilds cendr\xe9s est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les astrilds cendr\xe9s sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les astrilds cendr\xe9s peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "Possible uniquement au printemps et en \xe9t\xe9, car les astrilds cendr\xe9s sont sensibles au froid. Au printemps et en \xe9t\xe9, en enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin), chauffable (au moins 18 \xb0C).  Une partie du toit de la voli\xe8re doit \xeatre couvert (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "D\xe9tenir des astrilds cendr\xe9s avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "goldenBreasted": {
                        "name": "Bengali z\xe9br\xe9",
                        "namePlural": "Bengalis z\xe9br\xe9s",
                        "minAnimalsErrorMessage": "Les bengalis z\xe9br\xe9s sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des bengalis z\xe9br\xe9s est en groupe. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les bengalis z\xe9br\xe9s doivent \xeatre d\xe9tenus en couple car les m\xe2les peuvent \xeatre agressifs envers des rivaux de la m\xeame esp\xe8ce pendant la p\xe9riode de nidification.",
                            "indoor": "Les bengalis z\xe9br\xe9s peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "Possible uniquement au printemps et en \xe9t\xe9, car les bengalis z\xe9br\xe9s sont sensibles au froid. Au printemps et en \xe9t\xe9, en enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin), chauffable (au moins 15 \xb0C).  Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Cet oiseau d’une grande long\xe9vit\xe9, tr\xe8s actif, a besoin d’une voli\xe8re spacieuse avec de l’herbe et des roseaux.\nD\xe9tenir des bengalis z\xe9br\xe9s avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "gouldianMadine": {
                        "name": "Diamant de Gould",
                        "namePlural": "Diamants de Gould",
                        "minAnimalsErrorMessage": "Les diamants de Gould sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des diamants de Gould est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les diamants de Gould sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe avec plusieurs couples nicheurs.",
                            "indoor": "Les diamants de Gould peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "Possible uniquement au printemps et en \xe9t\xe9, car les diamants de Gould sont sensibles au froid. Au printemps et en \xe9t\xe9, en enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin), chauffable (au moins 18 \xb0C).  Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.). Les diamants de Gould doivent \xeatre d\xe9tenus \xe0 l’int\xe9rieur en automne et en hiver (voir ci-dessus).",
                            "specificNeeds": '"Beaucoup de couvert et suffisamment de possibilit\xe9s de se cacher sont essentiels pour ces oiseaux craintifs. \n\nD\xe9tenir des diamants de Gould avec une autre esp\xe8ce d’oiseau n’est recommand\xe9 que pour des personnes ayant de solides connaissances.\nIl faut s’abstenir d’acheter des mutations de couleurs obtenues par \xe9levage. "'
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Gouldamadinen",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Gouldamadinen_fr.pdf"
                            }
                        }
                    },
                    "budgerigar": {
                        "name": "Perruche ondul\xe9e",
                        "namePlural": "Perruches ondul\xe9es",
                        "minAnimalsErrorMessage": "Les perruches ondul\xe9es sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perruches ondul\xe9es est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perruches ondul\xe9es sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs (au moins 2, de pr\xe9f\xe9rence 3). Cela n\xe9cessite une grande voli\xe8re, car les m\xe2les d\xe9fendent le nid en p\xe9riode de nidification.",
                            "indoor": "Les perruches ondul\xe9es peuvent \xeatre d\xe9tenues dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perruches ondul\xe9es est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les perruches ondul\xe9es ont besoin de possibilit\xe9s de grimper vari\xe9es sous forme de branches naturelles p. ex. de noisetier, saule, h\xeatre, arbres fruitiers non trait\xe9s. Elles servent \xe9galement de mat\xe9riel \xe0 ronger et doivent \xeatre renouvel\xe9es r\xe9guli\xe8rement.\n\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s. Il faut s’abstenir d’acheter des vari\xe9t\xe9s d’\xe9levage extr\xeames (p. ex. des oiseaux avec des huppes)."
                        },
                        "links": {
                            "0": {
                                "text": "STS Merkblatt Wellensittiche",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_wellensittiche_fr.pdf"
                            }
                        }
                    },
                    "agapornid": {
                        "name": "Ins\xe9parable",
                        "namePlural": "Ins\xe9parables",
                        "minAnimalsErrorMessage": "Les ins\xe9parables sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les ins\xe9parables sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les ins\xe9parables peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les ins\xe9parables de Fischer, les ins\xe9parables rosegorges, les ins\xe9parables masqu\xe9s et les ins\xe9parables \xe0 joues noires sont les principales esp\xe8ces \xe0 consid\xe9rer comme animaux de compagnie. Les autres esp\xe8ces d’ins\xe9parables sont plus exigeantes et donc d\xe9conseill\xe9es aux d\xe9butants.\nCertaines esp\xe8ces d’ins\xe9parables peuvent \xeatre assez agressives et ne conviennent pas pour \xeatre d\xe9tenues avec d’autres esp\xe8ces.\n\nLes ins\xe9parables peuvent \xeatre assez bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis."
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information SPA: Ins\xe9parables",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_fr.pdf"
                            }
                        }
                    },
                    "tarantaParrot": {
                        "name": "Ins\xe9parable d’Abyssinie",
                        "namePlural": "Ins\xe9parables d’Abyssinie",
                        "minAnimalsErrorMessage": "Les ins\xe9parables d’Abyssinie sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables d’Abyssinie est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "Gesetzlich vorgeschrieben sind eine Badegelegenheit, federnde Sitzstangen von unterschiedlicher Dicke und Ausrichtung sowie die Gabe von Vogelsand zur freien Aufnahme.Ein Drittel des Volumens muss frei von Strukturen sein. In Gehegen, welche kleiner als 2 m2 sind, darf das Verh\xe4ltnis von L\xe4nge zu Breite, bezogen auf die Mindestfl\xe4che, maximal 2:1 betragen. Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les ins\xe9parables d’Abyssinie sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les ins\xe9parables d’Abyssinie peuvent \xeatre d\xe9tenus dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel).  Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les ins\xe9parables d’Abyssinie sont la plus grande esp\xe8ce d’ins\xe9parables. \nLa d\xe9tention de cette esp\xe8ce d’ins\xe9parables est exigeante et ne convient pas aux d\xe9butants.\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s. \nLes ins\xe9parables d’Abyssinie peuvent aussi \xeatre assez bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis."
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information SPA: Ins\xe9parables",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_fr.pdf"
                            }
                        }
                    },
                    "cockatiel": {
                        "name": "Calopsitte \xe9l\xe9gante",
                        "namePlural": "Calopsittes \xe9l\xe9gantes",
                        "minAnimalsErrorMessage": "Les calopsittes \xe9l\xe9gantes sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des calopsittes \xe9l\xe9gantes est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les calopsittes \xe9l\xe9gantes sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "Les calopsittes \xe9l\xe9gantes peuvent \xeatre d\xe9tenues dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des ins\xe9parables est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les calopsittes \xe9l\xe9gantes ont besoin de possibilit\xe9s de grimper vari\xe9es sous forme de branches naturelles p. ex. de noisetier, saule, h\xeatre, arbres fruitiers non trait\xe9s. Elles servent \xe9galement de mat\xe9riel \xe0 ronger et doivent \xeatre renouvel\xe9es r\xe9guli\xe8rement.\n\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s."
                        },
                        "links": {
                            "0": {
                                "text": "Feuille d'information SPA: Calopsitte \xe9l\xe9gante",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Nymphensittiche_fr.pdf"
                            }
                        }
                    },
                    "beautifulParakeet": {
                        "name": "Perruche turquoisine",
                        "namePlural": "Perruches turquoisines",
                        "minAnimalsErrorMessage": "Les perruches turquoisines sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perruches turquoisines est en couple nicheur. Il est essentiel d’\xeatre attentif aux compatibilit\xe9s individuelles des animaux, car les perruches turquoisines peuvent r\xe9agir de mani\xe8re assez agressive envers leurs cong\xe9n\xe8res ainsi qu’envers d’autres esp\xe8ces d’oiseaux.",
                        "maxAnimalsErrorMessage": "Attention! La d\xe9tention de perruches turquoisines est exigeante. Les perruches turquoisines doivent \xeatre d\xe9tenues en couple car elles peuvent \xeatre agressives envers leurs cong\xe9n\xe8res et d’autres esp\xe8ces d’oiseaux.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures, et dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perruches turquoisines sont tr\xe8s sociables mais peuvent \xeatre tr\xe8s agressives envers les autres oiseaux, y compris ceux de leur propre esp\xe8ce. Il est donc recommand\xe9 de d\xe9tenir les perruches turquoisines en couple.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perruches turquoisines est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les perruches turquoisines ont besoin d’une surface de vol libre aussi grande que possible, car leur vol est rectiligne. Elles ont \xe9galement besoin de beaucoup d’occupation et de possibilit\xe9s de ronger sous forme de branches fra\xeeches vari\xe9es non toxiques.\nIl n’est pas conseill\xe9 de les socialiser avec d’autres esp\xe8ces d’oiseaux, car elles peuvent r\xe9agir de mani\xe8re agressive."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "rosellaConure": {
                        "name": "Perruche omnicolore",
                        "namePlural": "Perruches omnicolores",
                        "minAnimalsErrorMessage": "Les perruches omnicolores sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perruches omnicolores est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 20.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perruches omnicolores sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs. Il faut une tr\xe8s grande voli\xe8re en cas de d\xe9tention de plusieurs couples, \xe9tant donn\xe9 que les m\xe2les sont tr\xe8s agressifs pendant la p\xe9riode de pariade et de nidification.",
                            "indoor": "Les perruches omnicolores peuvent \xeatre d\xe9tenues dans des voli\xe8res spacieuses ou dans des pi\xe8ces sp\xe9cialement am\xe9nag\xe9es pour les oiseaux. Les cages \xe0 oiseaux classiques sont beaucoup trop petites pour les d\xe9tenir conform\xe9ment aux besoins de leur esp\xe8ce. Les voli\xe8res hautes et \xe9troites ne sont pas adapt\xe9es parce que les oiseaux ont besoin d’espace horizontal pour voler. Les vitrines ne se pr\xeatent pas non plus \xe0 la d\xe9tention des oiseaux.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perruches omnicolores est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les perruches omnicolores ont besoin d’une surface de vol libre aussi grande que possible, car elles sont tr\xe8s actives. Elles ont \xe9galement besoin de beaucoup d’occupation et de possibilit\xe9s de ronger sous forme de branches fra\xeeches vari\xe9es non toxiques.\nLa socialisation avec d’autres esp\xe8ces est possible, mais uniquement recommand\xe9e \xe0 des d\xe9tenteurs d’oiseaux exp\xe9riment\xe9s."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "cockatoo": {
                        "name": "Cacato\xe8s",
                        "namePlural": "Cacato\xe8s",
                        "minAnimalsErrorMessage": "Les cacato\xe8s sont des animaux sociaux. La d\xe9tention individuelle est donc interdite! La d\xe9tention de cacato\xe8s (\xe0 l’exception des calopsittes \xe9l\xe9gantes) est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des cacato\xe8s, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsWarningMessage": "La d\xe9tention de cacato\xe8s (\xe0 l’exception des calopsittes \xe9l\xe9gantes) est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des cacato\xe8s, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsErrorMessage": "La d\xe9tention de cacato\xe8s (\xe0 l’exception des calopsittes \xe9l\xe9gantes) est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des cacato\xe8s, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "laws": {},
                        "recommendations": {
                            "general": "Pour des raisons de protection des animaux, la Protection Suisse des Animaux PSA d\xe9conseille la d\xe9tention priv\xe9e d'ara/cacato\xe8s. . L'espace n\xe9cessaire \xe0 une d\xe9tention d'ara/cacato\xe8s conforme aux besoins des animaux est immense et ne peut g\xe9n\xe9ralement pas \xeatre rempli par des d\xe9tenteurs priv\xe9s. La d\xe9tention de cacato\xe8s ou d'aras est extr\xeamement exigeante et soumise \xe0 autorisation. Toute personne int\xe9ress\xe9e par l’achat de cacato\xe8s doit suivre un cours pour l’obtention de l’attestation de comp\xe9tences avant l’achat.\nEn outre, il faut d\xe9poser une demande aupr\xe8s de l’office v\xe9t\xe9rinaire cantonal du canton de domicile et prouver que toutes les exigences l\xe9gales en mati\xe8re de d\xe9tention, de soins et d’acquisition peuvent \xeatre remplies. Si vous avez l'intention de d\xe9tenir des cacato\xe8s ou des aras, veuillez vous adresser \xe0 l'office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour de plus amples informations."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "macaw": {
                        "name": "Ara",
                        "namePlural": "Aras",
                        "minAnimalsErrorMessage": "Les aras sont des animaux sociaux. La d\xe9tention individuelle est donc interdite! \nLa d\xe9tention de grands perroquets tels que les aras est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des aras, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsWarningMessage": "La d\xe9tention de grands perroquets tels que les aras est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des aras, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour en savoir plus.",
                        "maxAnimalsErrorMessage": "La d\xe9tention de grands perroquets tels que les aras est extr\xeamement exigeante et soumise \xe0 autorisation. Si vous avez l’intention de d\xe9tenir des aras, adressez-vous \xe0 l’office v\xe9t\xe9rinaire cantonal de votre canton de domicile pour en savoir plus.",
                        "laws": {},
                        "recommendations": {
                            "general": "Pour des raisons de protection des animaux, la Protection Suisse des Animaux PSA d\xe9conseille la d\xe9tention priv\xe9e d'ara/cacato\xe8s. . L'espace n\xe9cessaire \xe0 une d\xe9tention d'ara/cacato\xe8s conforme aux besoins des animaux est immense et ne peut g\xe9n\xe9ralement pas \xeatre rempli par des d\xe9tenteurs priv\xe9s. La d\xe9tention de cacato\xe8s ou d'aras est extr\xeamement exigeante et soumise \xe0 autorisation. Toute personne int\xe9ress\xe9e par l’achat de cacato\xe8s doit suivre un cours pour l’obtention de l’attestation de comp\xe9tences avant l’achat.\nEn outre, il faut d\xe9poser une demande aupr\xe8s de l’office v\xe9t\xe9rinaire cantonal du canton de domicile et prouver que toutes les exigences l\xe9gales en mati\xe8re de d\xe9tention, de soins et d’acquisition peuvent \xeatre remplies. Si vous avez l'intention de d\xe9tenir des cacato\xe8s ou des aras, veuillez vous adresser \xe0 l'office v\xe9t\xe9rinaire cantonal de votre canton de r\xe9sidence pour de plus amples informations."
                        },
                        "links": {
                            "0": {
                                "text": "Fachinformation Tierschutz - Bewilligungspflicht f\xfcr die Haltung von Grosspapageien - Bundesamt f\xfcr Lebensmittelsicherheit und Veterin\xe4rwesen BLV",
                                "file": "https://www.blv.admin.ch/dam/blv/de/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/D_3.1_Fachinformation_Bewilligungspflicht_f%C3%BCr_Grosspapageien.pdf"
                            }
                        }
                    },
                    "congoGreyParrot": {
                        "name": "Perroquet jaco/Gris du Gabon",
                        "namePlural": "Perroquets jaco",
                        "minAnimalsErrorMessage": "Les perroquets jaco sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des perroquets jaco est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 6.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures. Dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les perroquets jaco sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de plusieurs couples nicheurs.",
                            "indoor": "La d\xe9tention exclusivement \xe0 l’int\xe9rieur ne convient pas aux perroquets jaco.",
                            "outdoor": "La forme de d\xe9tention la plus respectueuse des perroquets jaco est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "La d\xe9tention de perroquets jaco respectueuse des animaux est extr\xeamement exigeante. \nLe commerce de ces animaux d’une tr\xe8s grande long\xe9vit\xe9 est en plein essor et les offres de fournisseurs peu scrupuleux sont tr\xe8s nombreuses (p. ex. \xe9levage \xe0 la main, importations de sources peu claires). Les perroquets jaco peuvent \xeatre bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis.\n\nPour des raisons de protection des animaux, il faut s’abstenir d’acheter des animaux \xe9lev\xe9s \xe0 la main."
                        },
                        "links": {
                            "0": {
                                "text": "FEUILLE D’INFORMATION PSA - Perroquet jaco",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_graupapageien_fr.pdf"
                            }
                        }
                    },
                    "amazon": {
                        "name": "Amazone",
                        "namePlural": "Amazone",
                        "minAnimalsErrorMessage": "Les amazones sont des animaux sociaux. La d\xe9tention individuelle est donc interdite!",
                        "maxAnimalsWarningMessage": "La forme de d\xe9tention la plus respectueuse des amazones est en groupe de couples nicheurs. Cependant, il faut \xeatre attentif aux compatibilit\xe9s individuelles des animaux, notamment pendant la p\xe9riode de pariade et de nidification. Pour d\xe9tenir plus d’un couple nicheur, il faut opter pour une voli\xe8re spacieuse avec de nombreuses possibilit\xe9s d’\xe9vitement et de retrait.",
                        "maxAnimalsErrorMessage": "Veuillez indiquer un nombre inf\xe9rieur ou \xe9gal \xe0 6.",
                        "laws": {
                            "furnishing": "La loi exige une possibilit\xe9 de baignade, des perchoirs souples d’\xe9paisseurs et d’orientations diff\xe9rentes ainsi que la mise \xe0 disposition de sable convenant \xe0 son absorption. Un tiers du volume doit \xeatre libre de structures, et dans les enclos inf\xe9rieurs \xe0 2 m\xb2, le rapport longueur/largeur, rapport\xe9 \xe0 la surface minimale, ne doit pas d\xe9passer 2:1. Tous les psittaciformes doivent avoir suffisamment de branches naturelles \xe0 ronger et pour grimper.",
                            "socialStructure": "D\xe9tention individuelle interdite",
                            "lawDetails": "N’oubliez pas que les dimensions minimales l\xe9gales ne correspondent qu’au strict minimum. La d\xe9tention des oiseaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. La d\xe9tention respectueuse des oiseaux n\xe9cessite des voli\xe8res nettement plus grandes et un am\xe9nagement bien structur\xe9 (voir recommandations)."
                        },
                        "recommendations": {
                            "furnishing": "Branches fix\xe9es \xe0 une seule extr\xe9mit\xe9 (= perchoirs souples), cordes vari\xe9es, balan\xe7oires, plateformes suspendues au plafond, bain (petite baignoire ou r\xe9cipient plat), pierres calcaires / os de s\xe8che suspendus, grit dans une gamelle plate, lampes UV appropri\xe9es pour d\xe9tention \xe0 l’int\xe9rieur, comme substrat: sable, gravier ou pellets de h\xeatre. Les barreaux de l’enclos doivent \xeatre horizontaux. Les cages rondes ne sont pas conformes \xe0 la protection des animaux et sont \xe0 proscrire.",
                            "socialStructure": "Les amazones sont tr\xe8s sociables. La forme de d\xe9tention la plus respectueuse de l’esp\xe8ce est en groupe de couples nicheurs.",
                            "indoor": "La d\xe9tention exclusivement \xe0 l’int\xe9rieur ne convient pas aux amazones.",
                            "outdoor": "a forme de d\xe9tention la plus respectueuse des amazones est un enclos ext\xe9rieur, compos\xe9 d’une voli\xe8re et d’un espace int\xe9rieur adjacent (p. ex. un abri de jardin) chauffable (\xe0 l’abri du gel). Une partie du toit de la voli\xe8re doit \xeatre couverte (protection contre les intemp\xe9ries) et disposer d’\xe9crans visuels sur au moins deux c\xf4t\xe9s (v\xe9g\xe9tation, filet brise-vent opaque, etc.).",
                            "specificNeeds": "Les amazones sont des oiseaux bruyants. Par cons\xe9quent, les voisins devraient \xeatres avertis.\n\nIl existe diff\xe9rentes esp\xe8ces d’amazones, et toutes ne conviennent pas comme animaux de compagnie. La plus commune est l’amazone \xe0 front bleu. Chaque esp\xe8ce a ses propres besoins sp\xe9cifiques en termes de d\xe9tention, de climat, d’alimentation et de structure sociale. Vous pouvez obtenir des informations aupr\xe8s de sp\xe9cialistes chevronn\xe9s ou suivre un cours sp\xe9cialis\xe9 avant l’achat.\nPour des raisons de protection des animaux, il faut s’abstenir d’acheter des animaux \xe9lev\xe9s \xe0 la main."
                        },
                        "links": {
                            "0": {
                                "text": "D\xe9tenir des oiseaux en respectant leurs besoins - Enclos adapt\xe9s et am\xe9nagement ad\xe9quat",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_f_Voegel_A4_web.pdf"
                            }
                        }
                    }
                },
                "equidae": {
                    "horse": {
                        "name": "Cheval",
                        "namePlural": "Chevaux",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un cong\xe9n\xe8re de la m\xeame esp\xe8ce, donc dans ce cas avec un autre cheval.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "Autant que possible",
                            "socialStructure": "Les chevaux doivent avoir un contact direct avec d'autres chevaux. Les chevaux et les \xe2nes parlent un langage diff\xe9rent et ont des besoins diff\xe9rents en mati\xe8re de d\xe9tention et d'alimentation.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement."
                        },
                        "laws": {
                            "runoutTime": "Chevaux utilis\xe9s : 2 x 2 h / semaine ; Chevaux non utilis\xe9s : 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition; de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "pony": {
                        "name": "Poney",
                        "namePlural": "Poneys",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un cong\xe9n\xe8re de la m\xeame esp\xe8ce, donc dans ce cas avec un autre poney ou un autre cheval.",
                        "maxAnimalsWarningMessage": '"Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.',
                        "recommendations": {
                            "pasturing": "Autant que possible, adapter toutefois l'alimentation \xe0 l'\xe9tat d’embonpoint !",
                            "socialStructure": "Les poneys doivent avoir un contact direct avec d'autres poneys ou d’autres chevaux.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement.",
                            "specialRequirements": "La jeune herbe, riche en prot\xe9ines ou en fructanes, repr\xe9sente un risque accru de surpoids, en particulier chez les poneys, et surtout s'ils ne font pas suffisamment d'exercice."
                        },
                        "laws": {
                            "runoutTime": "Poneys utilis\xe9s 2 x 2 h / semaine ; Poneys non utilis\xe9s 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "donkey": {
                        "name": "\xc2ne",
                        "namePlural": "\xc2nes",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un cong\xe9n\xe8re de la m\xeame esp\xe8ce, donc dans ce cas avec un autre \xe2ne.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "P\xe2turage limit\xe9 pour les \xe2nes, plus de mouvement sur de grandes places s\xe8ches",
                            "socialStructure": "Les \xe2nes ont besoin d'un contact direct avec des cong\xe9n\xe8res de la m\xeame esp\xe8ce, c'est-\xe0-dire avec d'autres \xe2nes. Leur comportement et leur physiologie diff\xe8rent de ceux des chevaux. Des aliments riches en fibres, comme des branches et de la paille, ainsi que des activit\xe9s suppl\xe9mentaires sont \xe0 pr\xe9voir.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement.",
                            "specialRequirements": "Les \xe2nes sont des transformateurs de fourrage tr\xe8s efficaces. Ils ont besoin d'une alimentation pauvre en \xe9nergie, \xe0 faible teneur en sucre et en prot\xe9ines, mais riche en fibres. Le pelage des \xe2nes n'est gu\xe8re imperm\xe9able. Les \xe2nes sont sensibles aux maladies lorsqu'ils sont mouill\xe9s. Ils ont besoin d'un abri sec accessible en permanence. Les \xe2nes ont besoin d'un sol sec, sinon ils risquent des probl\xe8mes de sabots."
                        },
                        "laws": {
                            "runoutTime": "\xc2nes utilis\xe9s : 2 x 2 h / semaine ; \xc2nes non utilis\xe9s : 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des \xe2nes",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-danes/"
                            },
                            "1": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "mule": {
                        "name": "Mulet",
                        "namePlural": "Mulets",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement, avec un autre mulet.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "P\xe2turage limit\xe9",
                            "socialStructure": "Les mulets ont besoin de contact avec d'autres mulets. Ils peuvent bien entendu \xeatre d\xe9tenues avec des chevaux. Il faut toutefois tenir compte de leur physiologie en ce qui concerne l'alimentation et l’acc\xe8s au p\xe2turage.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement."
                        },
                        "laws": {
                            "runoutTime": "Mulets utilis\xe9s 2 x 2 h / semaine ; Mulets non utilis\xe9s 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Site web de la PSA sur la d\xe9tention des \xe2nes",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-danes/"
                            },
                            "2": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    },
                    "hinny": {
                        "name": "Bardot",
                        "namePlural": "Bardots",
                        "minAnimalsWarningMessage": "Attention : les \xe9quid\xe9s doivent au moins avoir un contact visuel, auditif et olfactif avec d'autres \xe9quid\xe9s. Id\xe9alement avec un autre bardot.",
                        "maxAnimalsWarningMessage": "Pour cinq \xe9quid\xe9s ou plus qui s’entendent bien, la surface totale peut \xeatre r\xe9duite de 20 % au maximum, ce qui a \xe9t\xe9 pris en compte dans les r\xe9sultats. La PSA ne recommande pas cette r\xe9duction.",
                        "recommendations": {
                            "pasturing": "P\xe2turage limit\xe9",
                            "socialStructure": "Les bardots ont besoin de contact direct avec d’autres bardots. Ils peuvent aussi \xeatre d\xe9tenus avec des \xe2nes. Il faut toutefois tenir compte de leur physiologie en ce qui concerne l'alimentation et l’acc\xe8s au p\xe2turage.",
                            "activity": "Tous les \xe9quid\xe9s devraient \xeatre occup\xe9s quotidiennement."
                        },
                        "laws": {
                            "runoutTime": "Bardots utilis\xe9s 2 x 2 h / semaine ; Bardots non utilis\xe9s 2h par jour",
                            "pasturing": "Aucune prescription",
                            "structuring": "Des am\xe9nagements permettant aux \xe9quid\xe9s de s’\xe9viter ou de se retirer doivent \xeatre \xe0 disposition de tels am\xe9nagements ne sont pas exig\xe9s pour les poulains sevr\xe9s et les jeunes \xe9quid\xe9s jusqu’au d\xe9but de leur utilisation r\xe9guli\xe8re, au plus tard cependant jusqu’\xe0 l’\xe2ge de 30 mois. Il ne doit pas y avoir de cul-de-sacs. Les \xe9quid\xe9s ne doivent pas \xeatre d\xe9tenus \xe0 l'attache.",
                            "exercise": "Les \xe9quid\xe9s doivent b\xe9n\xe9ficier d'un exercice quotidien suffisant. L'exercice comprend l'utilisation et la sortie. Lorsque les conditions m\xe9t\xe9orologiques ou l’\xe9tat du sol sont extr\xeamement d\xe9favorables, une surface couverte peut \xeatre exceptionnellement utilis\xe9e pour la sortie des \xe9quid\xe9s.",
                            "activity": "Les \xe9quid\xe9s doivent disposer de suffisamment de fourrage grossier, tel que de la paille fourrag\xe8re, pour l'occupation propre \xe0 leur esp\xe8ce, sauf pendant le p\xe2turage.",
                            "socialStructure": "Les \xe9quid\xe9s doivent avoir un contact visuel, auditif et olfactif avec un autre \xe9quid\xe9. Les \xe9quid\xe9s doivent \xeatre d\xe9tenus en groupe apr\xe8s le sevrage jusqu'\xe0 l'\xe2ge de 30 mois ou jusqu'au d\xe9but de leur utilisation r\xe9guli\xe8re."
                        },
                        "links": {
                            "0": {
                                "text": "Site web de la PSA sur la d\xe9tention des chevaux",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-de-chevaux/"
                            },
                            "1": {
                                "text": "Site web de la PSA sur la d\xe9tention des \xe2nes",
                                "file": "https://tierschutz.com/fr/detention-des-animaux/detention-danimaux-de-compagnie/detention-danes/"
                            },
                            "2": {
                                "text": "Ordonnance sur la protection des animaux",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                            }
                        }
                    }
                }
            },
            "screenCategory": {
                "title": "S\xe9lectionner la cat\xe9gorie"
            },
            "screenAnimal": {
                "title": "Quel animal voudrais-tu d\xe9tenir?",
                "multipleBirdsButton": "Garder plusieurs esp\xe8ces ensemble",
                "equidaeInfo": "Les valeurs calcul\xe9es ne sont valables que pour les \xe9quid\xe9s de plus de 30 mois."
            },
            "screenMultipleBirds": {
                "warning": "Pour d\xe9tenir deux esp\xe8ces d'oiseaux ou plus ensemble, la taille de l'enclos doit \xeatre calcul\xe9e s\xe9par\xe9ment pour chaque esp\xe8ce, mais avec le nombre total d'oiseaux. Le plus grand enclos calcul\xe9 correspond aux dimensions minimales l\xe9gales.",
                "infoText": "Si deux esp\xe8ces d'oiseaux ou plus sont d\xe9tenues ensemble dans un enclos, la taille minimale l\xe9gale de l'enclos correspond toujours aux exigences en mati\xe8re de place pour la plus grande esp\xe8ce d'oiseaux. Par exemple, si deux perruches ondul\xe9es et deux perruches nymphes sont d\xe9tenues ensemble dans un enclos, la taille minimale de l'enclos correspond aux exigences pour quatre perruches nymphes, car il s'agit de la plus grande esp\xe8ce d'oiseaux dans l'enclos. La d\xe9tention commune de plusieurs esp\xe8ces d'oiseaux ne convient qu'aux d\xe9tenteurs d'oiseaux exp\xe9riment\xe9s. Informez-vous toujours soigneusement sur les esp\xe8ces d'oiseaux qui peuvent \xeatre d\xe9tenues ensemble."
            },
            "screenNumber": {
                "title": "Combien de {animals} aimerais-tu d\xe9tenir?"
            },
            "screenWeight": {
                "title": "Quel est le poids des {animals}?"
            },
            "screenLength": {
                "title": "Quelle est la longueur du / de la / de l’{animal} le/la plus grand/e?",
                "error": "Entrer un nombre entre {min} et {max}."
            },
            "screenWithersHeight": {
                "title": "Quelle est la hauteur au garrot de chaque animal ?",
                "error": "Entrer un nombre entre {min} et {max}.",
                "animal": "Animal"
            },
            "screenResults": {
                "title": "Tu devrais d\xe9tenir {number} {animals} ainsi",
                "example": "Par exemple",
                "exampleEquidae": "Exemple de taille de box",
                "stsRecommendation": "Recommandation Protection des animaux",
                "law": "Loi (Ordonnance suisse sur la protection des animaux)",
                "stsAreaRecommendation": "Surface minimale (dimensions int\xe9rieures)",
                "stsLengthRecommendation": {
                    "upto2reptiles": "Longueur minimale (dimensions int\xe9rieures)",
                    "morethan2reptiles": "En plus, au moins en longueur"
                },
                "stsWidthRecommendation": {
                    "upto2reptiles": "Largeur minimale (dimensions int\xe9rieures)",
                    "morethan2reptiles": "En plus, au moins en largeur"
                },
                "stsHeightRecommendation": "Hauteur minimale de l’enclos (dimensions int\xe9rieures)",
                "stsBeddingRecommendation": "Profondeur minimale de la liti\xe8re",
                "stsWaterBasinRecommendation": "Bassin d'eau",
                "tolerance": "Valeur de tol\xe9rance",
                "toleranceInfo": "Les \xe9curies existant le 1er septembre 2008 ne doivent pas \xeatre adapt\xe9es si leurs dimensions correspondent aux valeurs de tol\xe9rance. Si une \xe9curie doit \xeatre adapt\xe9e parce que l’une des valeurs de tol\xe9rance n’est pas respect\xe9e, l’autre valeur de tol\xe9rance reste valable.",
                "noTolerance": "Pas de valeur de tol\xe9rance",
                "stsLayingAreaRecommendation": "Surface de repos",
                "stsClearWidthRecommendation": "Largeur int\xe9rieure",
                "stsClearWidthRecommendationInfo": "2 x taille au garrot de l’animal le plus grand",
                "stsClearHeightRecommendation": "Hauteur int\xe9rieure",
                "stsRunoutTimeRecommendation": "Temps de sortie",
                "stsRunoutTimeRecommendationText": "De pr\xe9f\xe9rence libre acc\xe8s 24h/24 \xe0 l'aire de sortie tout temps mais au moins 4 heures par jour",
                "stsRunoutAreaRecommendation": "Surface de l'aire de sortie",
                "stsPasturingRecommendation": "P\xe2turage",
                "stsLatticeSpacing": "Distance maximale entre les barreaux",
                "lawMinimalArea": "Surface minimale (dimensions int\xe9rieures)",
                "lawMinimalLength": "Longueur minimale (dimensions int\xe9rieures)",
                "lawMinimalWidth": "Largeur minimale (dimensions int\xe9rieures)",
                "lawMinimalHeight": "Hauteur minimale de l’enclos (dimensions int\xe9rieures)",
                "lawMinimalBedding": "Profondeur minimale de la liti\xe8re",
                "lawWaterBasin": "Bassin d'eau",
                "lawReptilesInfo": {
                    "text": "Lors de la d\xe9tention du nombre d'animaux entr\xe9, il faut s'assurer que toutes les exigences l\xe9gales {link} sont remplies pour l'esp\xe8ce animale concern\xe9e.",
                    "linkText": "selon l'annexe 2, tableau 5 OPAn",
                    "linkURL": "https://www.fedlex.admin.ch/eli/cc/2008/416/fr"
                },
                "lawVolume": "Volume",
                "lawLayingArea": "Surface de repos en stabulation libre \xe0 un compartiment",
                "layingAreaInfo": "Aires de repos non s\xe9par\xe9es de l'aire d'alimentation ; pour les autres conditions, voir l'ordonnance sur la protection des animaux, tableau 7.",
                "lawLayingAreaMultiroom": "Surface de repos en stabulation libre \xe0 plusieurs compartiments",
                "layingAreaMultiroomInfo": "Aires de repos s\xe9par\xe9es de l'aire d'alimentation ; pour les autres conditions, voir l'ordonnance sur la protection des animaux, tableau 7.",
                "lawClearWidth": "Largeur int\xe9rieure ",
                "lawClearWidthInfo": "1,5 x taille au garrot de l’animal le plus grand ",
                "lawClearHeight": "Hauteur int\xe9rieure",
                "lawRunoutTime": "Temps de sortie",
                "lawRunoutAreaAdjacent": "Aire de sortie attenante \xe0 l'\xe9curie",
                "lawRunoutAreaNonadjacent": "Aire de sortie non attenante \xe0 l'\xe9curie",
                "lawPasturing": "P\xe2turage",
                "additionalRecommendations": {
                    "title": "Autres recommandations",
                    "furnishing": "Am\xe9nagement",
                    "socialStructure": "Structure sociale et besoins sp\xe9cifiques \xe0 l’esp\xe8ce",
                    "indoor": "D\xe9tention \xe0 l'int\xe9rieur",
                    "outdoor": "D\xe9tention \xe0 l'ext\xe9rieur",
                    "specificNeeds": "Besoins sp\xe9cifiques \xe0 l'esp\xe8ce",
                    "specialRequirements": "Exigences",
                    "activity": "Mouvement",
                    "more": "Autres"
                },
                "additionalLaws": {
                    "title": "Autres dispositions l\xe9gales",
                    "furnishing": "Am\xe9nagement",
                    "raisedAreas": "Plateformes sur\xe9lev\xe9es",
                    "socialStructure": "Structure sociale",
                    "structuring": "Structuration de l'espace",
                    "activity": "Mouvement",
                    "exercise": "Occupation"
                },
                "lawDetails": "Veuillez noter que les prescriptions l\xe9gales minimales ne correspondent qu’au strict minimum. La d\xe9tention des animaux dans des cages plus petites est interdite en Suisse et constitue, du point de vue de la PSA, de la maltraitance animale. \nPour d\xe9tenir les animaux dans des conditions conformes \xe0 leurs besoins, il faut des surfaces nettement plus spacieuses et des am\xe9nagements bien structur\xe9s (voir recommandations).\n",
                "additionalInfo": "Pour plus d’informations"
            }
        }
    },
    "it_CH": {
        "txt": {
            "title": "Calcolatore per la detenzione di animali",
            "buttonNext": "Continua",
            "buttonPrevious": "Indietro",
            "buttonClose": "Chiudere",
            "buttonAcceptWarning": "Compreso",
            "domain": "calcolatore-detenzione-animali.ch",
            "link": "https://www.calcolatore-detenzione-animali.ch",
            "trButton": {
                "cta": "Per saperne di pi\xf9 sulla detezione adeguata alla specie:",
                "buttonText": "Aprire il calcolatore per la detenzione di animali"
            },
            "categories": {
                "rodents": {
                    "name": "Roditori e conigli"
                },
                "reptiles": {
                    "name": "Rettili"
                },
                "birds": {
                    "name": "Uccelli"
                },
                "equidae": {
                    "name": "Equidi"
                }
            },
            "animals": {
                "rodents": {
                    "degu": {
                        "name": "Degu",
                        "namePlural": "Degu",
                        "minAnimalsErrorMessage": "I degu sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I degu dovrebbero essere detenuti in gruppi di 2-5 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I degu dovrebbero essere detenuti in gruppi di 2-5 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 5 animali\nComposizione del gruppo: gruppo di sole femmine, gruppo di soli maschi, un maschio castrato con pi\xf9 femmine\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, foraggio grezzo (fieno o paglia), oggetti da rosicchiare come rami freschi, bagno di sabbia\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I degu sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Degu comune",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_degu_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "dwarfHamster": {
                        "name": "Criceto nano",
                        "namePlural": "Criceti nani",
                        "minAnimalsWarningMessage": "Attenzione, la detenzione dei criceti nani \xe8 molto impegnativa e possibile solamente per detentori di roditori esperti.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto!",
                        "recommendations": {
                            "socialStructure": "La detenzione di criceti nani \xe8 impegnativa e richiede molta esperienza. Prima di acquistare, informarsi presso degli esperti in merito a quali specie possono essere detenute in quali dimensioni del gruppo e con quale composizioni\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi, lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno, paglia, miscele di semi), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "Per i criceti nani \xe8 consentita sia la detenzione individuale sia in gruppo.\n"
                        },
                        "links": {
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "fancyMouse": {
                        "name": "Topo domestico",
                        "namePlural": "Topi domestici",
                        "minAnimalsErrorMessage": "I topi domestici sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I topi domestici dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "maxAnimalsErrorMessage": "Eine tiergerechte Haltung in einem Gehege ist mit dieser Gruppengr\xf6sse nicht mehr m\xf6glich! Farbm\xe4use sollten in Gruppen von 2-6 Tieren gehalten werden.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: gruppo di sole femmine, un maschio castrato con pi\xf9 femmine\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi, lettiera adatta, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno, paglia, miscele di semi), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I topi domestici sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Topo domestico",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_farbm%C3%A4use_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "gerbil": {
                        "name": "Gerbillino",
                        "namePlural": "Gerbillini",
                        "minAnimalsErrorMessage": "I gerbillini sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I gerbillini dovrebbero essere detenuti in gruppi di 2 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I gerbillini dovrebbero essere detenuti in gruppi di 2 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 animali,\nComposizione del gruppo: gruppo di sole femmine, gruppo di soli maschi, un maschio castrato con una femmina\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale per il nido adeguato, foraggio grezzo (fieno o paglia), bagno di sabbia, oggetti da rosicchiare (rami freschi)\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I gerbillini sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Mongolische Rennm\xe4use",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_rennmaus_de.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "goldenHamster": {
                        "name": "Criceto dorato",
                        "namePlural": "Criceti dorati",
                        "maxAnimalsErrorMessage": "I criceti dorati sono animali solitari e devono essere detenuti da soli.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 1 animale\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi, lettiera adatta per scavare, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno, paglia, miscele di semi), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I criceti dorati sono animali solitari e devono essere detenuti da soli.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Il criceto dorato siriano",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "guineaPig": {
                        "name": "Porcellino d'India",
                        "namePlural": "porcellini d'India",
                        "minAnimalsErrorMessage": "I porcellini d'India sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I porcellini d'India dovrebbero essere tenuti in gruppi di 2-6 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I porcellini d'India dovrebbero essere tenuti in gruppi di 2-6 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: gruppo di sole femmine oppure un maschio castrato con pi\xf9 femmine, in parte possibili anche gruppi di soli maschi\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta, possibilit\xe0 di rifugiarsi per tutti gli animali, oggetti da rosicchiare come rami freschi, foraggio grezzo (fieno o paglia), alimenti contenenti vitamina C\n",
                            "raisedAreas": "Le superfici rialzate calpestabili possono essere conteggiate fino a un terzo per la superficie minima richiesta, a condizione che l'area sotto il livello rialzato possa essere utilizzata anche dagli animali.\n",
                            "socialStructure": "I porcellini d'India sono animali sociali e non possono essere tenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Porcellini d’India – Cavia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_meerschweinchen_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "rabbit": {
                        "name": "Coniglio",
                        "namePlural": "Conigli",
                        "minAnimalsErrorMessage": "I conigli sono animali sociali. La detenzione individuale \xe8 consentita solo se gli animali hanno un contatto uditivo o olfattivo con i loro simili!",
                        "maxAnimalsWarningMessage": "A partire da un gruppo di 3 animali, attualmente esistono solo delle raccomandazioni per quanto concerne la superficie minima. Le superfici ad oggi raccomandate sono piuttosto piccole e attualmente sono in fase di revisione.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I conigli dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: un maschio castrato con 1 o 2 femmine, 2 maschi castrati con 2 - 4 femmine, in parte possibili anche gruppi di sole femmine\n"
                        },
                        "laws": {
                            "furnishing": "Possibilit\xe0 di rifugiarsi per tutti gli animali, oggetti da rosicchiare come rami freschi, foraggio grezzo (fieno o paglia)\n",
                            "raisedAreas": "Le superfici rialzate calpestabili possono essere conteggiate fino a un terzo per la superficie minima richiesta, a condizione che l'area sotto il livello rialzato possa essere utilizzata anche dagli animali.\n",
                            "socialStructure": "I conigli sono animali sociali. La detenzione individuale \xe8 consentita solo se gli animali hanno un contatto uditivo o olfattivo con i loro simili!\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Coniglio",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_kaninchen_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    },
                    "rat": {
                        "name": "Ratto",
                        "namePlural": "Ratti",
                        "minAnimalsErrorMessage": "I ratti sono animali sociali. La detenzione individuale \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La dimensione massima del gruppo \xe8 stata superata. I ratti dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "maxAnimalsErrorMessage": "Con questa dimensione dei gruppi non \xe8 pi\xf9 possibile una detenzione rispettosa degli animali in un recinto! I ratti dovrebbero essere detenuti in gruppi di 2-6 animali.",
                        "recommendations": {
                            "socialStructure": "Dimensione del gruppo: 2 - 6 animali\nComposizione del gruppo: gruppo di soli maschi, gruppo di sole femmine, gruppo misto con maschi castrati\n"
                        },
                        "laws": {
                            "furnishing": "Lettiera adatta, possibilit\xe0 di rifugiarsi per tutti gli animali, materiale adatto alla preparazione del nido, foraggio grezzo (fieno o paglia), oggetti da rosicchiare come rami freschi\n",
                            "raisedAreas": "Le superfici rialzate non possono essere conteggiate per la superficie minima.\n",
                            "socialStructure": "I ratti sono animali sociali e non possono essere detenuti senza loro simili.\n"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo PSA: Ratto",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/nager_kaninchen/mb_ratten_it.pdf"
                            },
                            "1": {
                                "text": "Roditori e Conigli - Detenzione Adeguata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Nager_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio Informativo PSA Sortiment Zoofachhandlungen und Onlineshops",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/mb_sortiment_zoofachhandel.pdf"
                            },
                            "4": {
                                "text": "Check-list Negozi zoologici",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/flyer_Zoofachhandel_it.pdf"
                            }
                        }
                    }
                },
                "reptiles": {
                    "royalPython": {
                        "name": "Pitone reale",
                        "namePlural": "Pitoni reali",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei pitoni reali. I pitoni reali sono adatti a socializzare con i conspecifici.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei pitoni reali. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei pitoni reali. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di fare il bagno, nascondigli, condizioni climatiche e di temperatura adatte alla specie, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "s\xec"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo tale che gli animali non possano scottarsi, possibilit\xe0 di arrampicarsi, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami e aree rialzate, wetbox, vasca d'acqua, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 26-32\xb0C, spot di calore locale 36\xb0C, raffreddamento notturno, i pitoni reali sono abbastanza bene compatibili tra loro e possono essere tenuti anche in coppia o a tre se il terrario \xe8 abbastanza grande.\n",
                            "waterBasin": "Vasca d'acqua"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Pitone reale",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_k%C3%B6nigspython_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "cornSnake": {
                        "name": "Serpente del grano",
                        "namePlural": "Serpenti del grano",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti del grano. I serpenti del grano sono adatti a socializzare con i conspecifici.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti del grano. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei serpenti del grano. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Condizioni climatiche e di temperatura adatte alla specie, nascondigli, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo che gli animali non possano bruciarsi, vasche d'acqua, possibilit\xe0 di arrampicarsi, substrato di fondo sciolto, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami, wetbox, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 24-28\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco.\n",
                            "waterBasin": "Vasca d'acqua"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Serpe del grano",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_kornnatter_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "greekTortoise": {
                        "name": "Testuggine greca",
                        "namePlural": "Testuggini greche",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Nascondigli e terreno su cui scavare, punt di sole e lampada a emissione UV, accesso alla luce naturale del sole, ulteriore uscita all'aperto, possibilit\xe0 di svernare\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Recinto esterno con recinzione a prova di fuga e possibilit\xe0 di separazione, casa riparo, ad esempio serra, letto caldo, substrato del terreno vario e parzialmente scavabile (sassi, sabbia, ghiaia, calcare giurassico, ecc.), aree per prendere il sole, possibilit\xe0 di ritirarsi, ad esempio con piante, radici, pietre, ecc., acqua e mangime adatto alla specie (fieno, erbe)\n",
                            "socialStructure": "\xc8 necessario tenere conto dei requisiti specifici della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, lo svernamento, la progettazione dello recinto e della mangiatoia. \xc8 importante disporre di una struttura di svernamento sicura.\n",
                            "more": "Le testuggini hanno un'aspettativa di vita molto elevata (40-80 anni)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni di base sulla detenzione di testuggini europee",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Landschildkro%CC%88ten_it.pdf"
                            },
                            "1": {
                                "text": "Detenzione di tartarughe rispettosa degli animali nella pratica",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_it.pdf"
                            },
                            "2": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "moorishTortoise": {
                        "name": "Testuggine moresca",
                        "namePlural": "Testuggini moresche",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Nascondigli e terreno su cui scavare, punt di sole e lampada a emissione UV, accesso alla luce naturale del sole, ulteriore uscita all'aperto, possibilit\xe0 di svernare\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Recinto esterno con recinzione a prova di fuga e possibilit\xe0 di separazione, casa riparo, ad esempio serra, letto caldo, substrato del terreno vario e parzialmente scavabile (sassi, sabbia, ghiaia, calcare giurassico, ecc.), aree per prendere il sole, possibilit\xe0 di ritirarsi, ad esempio con piante, radici, pietre, ecc., acqua e mangime adatto alla specie (fieno, erbe)\n",
                            "socialStructure": "\xc8 necessario tenere conto dei requisiti specifici della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, lo svernamento, la progettazione dello recinto e della mangiatoia. \xc8 importante disporre di una struttura di svernamento sicura.\n",
                            "more": "Le testuggini hanno un'aspettativa di vita molto elevata (40-80 anni)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni di base sulla detenzione di testuggini europee",
                                "file": "http://www.protezione-animali.com/pubblicazioni/animali_da_compagnia/infothek/reptilien/mb_landschildkroeten.pdf"
                            },
                            "1": {
                                "text": "Detenzione di tartarughe rispettosa degli animali nella pratica",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_it.pdf"
                            },
                            "2": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "wideShelledTortoise": {
                        "name": "Testuggine marginata",
                        "namePlural": "Testuggini marginate",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle testuggini. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Nascondigli e terreno su cui scavare, punt di sole e lampada a emissione UV, accesso alla luce naturale del sole, ulteriore uscita all'aperto, possibilit\xe0 di svernare\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Recinto esterno con recinzione a prova di fuga e possibilit\xe0 di separazione, casa riparo, ad esempio serra, letto caldo, substrato del terreno vario e parzialmente scavabile (sassi, sabbia, ghiaia, calcare giurassico, ecc.), aree per prendere il sole, possibilit\xe0 di ritirarsi, ad esempio con piante, radici, pietre, ecc., acqua e mangime adatto alla specie (fieno, erbe)\n",
                            "socialStructure": "\xc8 necessario tenere conto dei requisiti specifici della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, lo svernamento, la progettazione dello recinto e della mangiatoia. \xc8 importante disporre di una struttura di svernamento sicura.\n",
                            "more": "Le testuggini hanno un'aspettativa di vita molto elevata (40-80 anni)\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni di base sulla detenzione di testuggini europee",
                                "file": "http://www.protezione-animali.com/pubblicazioni/animali_da_compagnia/infothek/reptilien/mb_landschildkroeten.pdf"
                            },
                            "1": {
                                "text": "Detenzione di tartarughe rispettosa degli animali nella pratica",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_schildkro%CC%88tenhaltung_praxis_it.pdf"
                            },
                            "2": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "3": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "crownedGecko": {
                        "name": "Geco coronato",
                        "namePlural": "Gechi coronati",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi coronati. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi coronati. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi coronati. Un numero cos\xec elevato di animali deve essere respinto.",
                        "laws": {
                            "furnishing": "Nascondigli, condizioni climatiche e di temperatura adatte alla specie, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritirarsi quanti sono gli animali (ad esempio tubi di sughero, radici, piante), possibilit\xe0 di arrampicarsi (ad esempio rami finemente ramificati, piante), substrato del terreno per scavare, acqua e cibo adatto alla specie (insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, raffreddamento notturno. Temperature invernali inferiori di 5\xb0-6\xb0C. I maschi sono incompatibili tra loro, la loro socializzazione non deve essere prevista.\n",
                            "waterBasin": "-"
                        }
                    },
                    "links": {
                        "0": {
                            "text": "Reptilien - Passende Gehege und die richtige Einrichtung",
                            "file": "https://www.tierschutz.com/publikationen/heimtiere/infothek/gehege/broschuere_gehege_reptilien.pdf"
                        },
                        "1": {
                            "text": "Merkblatt Reptilien als Heimtiere",
                            "file": "http://www.tierschutz.com/publikationen/heimtiere/infothek/reptilien/reptilien_heimtiere.pdf"
                        }
                    },
                    "boaConstrictor": {
                        "name": "Boa constrictor",
                        "namePlural": "Boa constrictor",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei boa constrictor. I boa constrictor sono abbastanza compatibili tra loro e possono essere tenuti in coppia o a tre se il terrario \xe8 abbastanza grande.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei boa constrictor. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei boa constrictor. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di fare il bagno, nascondigli, condizioni climatiche e di temperatura adatte alla specie, possibilit\xe0 di arrampicarsi\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo tale che gli animali non possano scottarsi, possibilit\xe0 di arrampicarsi, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami e aree rialzate, wetbox, vasca d'acqua, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 22-30\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, i boa constrictor sono abbastanza compatibili tra loro e possono essere tenuti anche in coppia o a tre se il terrario \xe8 abbastanza grande.\n",
                            "more": "I boa constrictor possono superare i 4 metri di lunghezza. I valori qui indicati si riferiscono ad animali di lunghezza fino a 250 cm. Gli animali pi\xf9 grandi hanno bisogno di recinti pi\xf9 grandi.\n",
                            "waterBasin": "Vasca d'acqua 0.5 m\xb2"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "muskTurtle": {
                        "name": "Tartaruga muschiata comune",
                        "namePlural": "Tartarughe muschiate comuni",
                        "textLength": "Per le testuggini o tartarughe, si misura la lunghezza del carapace dell'animale pi\xf9 grande.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale delle tartarughe muschiate. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale delle tartarughe muschiate. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale delle tartarughe muschiate. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Condizioni climatiche e di temperatura, di illuminazione adatte alla specie, punt di sole e lampada a emissione UV, nascondigli\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "in aggiunta all’area"
                        },
                        "recommendations": {
                            "furnishing": "Si raccomanda una sistemazione all'aperto in estate, lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo che gli animali non possano scottarsi, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di rifugiarsi quanti sono gli animali, ad esempio radici, rami, pietre, fogliame, parte di terreno facilmente accessibile, cibo adeguato alla specie (animali da pasto)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-28\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, si consiglia uno svernamento al fresco.\n",
                            "waterBasin": "dell’area complessiva"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "kingSnake": {
                        "name": "Serpente reale",
                        "namePlural": "Serpenti reali",
                        "textLength": "Per i serpenti, si misura la lunghezza totale del corpo dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti reali.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei serpenti reali. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei serpenti reali. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Condizioni climatiche e di temperatura adeguate alla specie, nascondigli\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione deve essere installata in modo che gli animali non possano bruciarsi, vasche d'acqua, possibilit\xe0 di arrampicarsi, substrato di fondo sciolto, sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, rami, wetbox, acqua e cibo adatto alla specie (animali da mangiare)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco.\n",
                            "more": "I serpenti reali si nutrono anche di altri serpenti e non devono quindi essere socializzati con altre serpenti.\n",
                            "waterBasin": "Vasca d'acqua"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "madagascarDayGecko": {
                        "name": "Geco diurno gigante del Madagascar",
                        "namePlural": "Gechi diurni giganti del Madagascar",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo che tutti gli animali abbiano accesso alla luce (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano scottarsi sulle lampade, sistema per produrre l'umidit\xe0 necessaria alle rispettive specie, ad esempio nebulizzatore, impianto di irrigazione, bottiglia a spruzzo, piantumazione, cascata, ecc. Sistema di misurazione della temperatura e dell'umidit\xe0 dell’aria, possibilit\xe0 di arrampicata diversificate e adatte alla specie, spesse almeno quanto il corpo (parete di fondo, rami, bastoni di bamb\xf9, piante a foglia larga, ecc.), possibilit\xe0 di ritiro adatte alla specie attraverso piante, radici, pietre, canne di bamb\xf9 tagliate, ecc., substrato adatto alla specie, acqua e cibo adatto alla specie (insetti, nettare, polpa di frutta).\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 40\xb0C, raffreddamento notturno. I maschi sono incompatibili tra loro, la loro socializzazione non deve essere prevista.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Geco gigante del Madagascar",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_taggecko_de.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "goldDustDayGecko": {
                        "name": "Geco diurno polvere d'oro",
                        "namePlural": "Gechi diurni polvere d'oro",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi diurni. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo che tutti gli animali abbiano accesso alla luce (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano bruciarsi sulle lampade, sistema per produrre l'umidit\xe0 necessaria alle rispettive specie, ad esempio nebulizzatore, impianto di irrigazione, bottiglia a spruzzo, piantumazione, cascata ecc. Sistema di misurazione della temperatura e dell'umidit\xe0 dell’aria, possibilit\xe0 di arrampicata diversificate e adatte alla specie, spesse almeno quanto il corpo (parete di fondo, rami, bastoni di bamb\xf9, piante a foglia larga, ecc.), possibilit\xe0 di ritiro adatte alla specie attraverso piante, radici, pietre, canne di bamb\xf9 tagliate, ecc., substrato adatto alla specie, acqua e cibo adatto alla specie (insetti, nettare, polpa di frutta).\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie per quanto riguarda l'habitat, il comportamento sociale, il clima, l'allestimento del terrario e l'alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 40\xb0C, raffreddamento notturno. I maschi sono incompatibili tra loro, la loro socializzazione non deve essere prevista.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "1": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "leopardGecko": {
                        "name": "Geco leopardo",
                        "namePlural": "Gechi leopardi",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi leopardo. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei gechi leopardo. Un numero cos\xec elevato di animali non \xe8 raccomandabile. I maschi sono incompatibili tra loro.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei gechi leopardo. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Nascondigli, possibilit\xe0 di scavare, condizioni climatiche e di illuminazione adatte alla specie.\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Lampade a emissione UV e illuminazione di base; sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno altrettante possibilit\xe0 di rifugio per gli animali (ad esempio tubi di sughero, radici, almeno un nascondiglio leggermente umido), possibilit\xe0 di arrampicarsi (ad esempio strutture in pietra, parete posteriore, radici), substrato per scavare, acqua e cibo adatto alla specie (insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie in termini di habitat, comportamento sociale, clima, svernamento, allestimento del terrario e alimentazione. Temperatura di base 22-28\xb0C, spot di calore locale 35\xb0C, raffreddamento notturno. I maschi sono territoriali, la loro socializzazione \xe8 sconsigliata.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Geco leopardo",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_leopardgecko_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "dwarfBeardedDragon": {
                        "name": "Drago barbuto nano",
                        "namePlural": "Draghi barbuti nani",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono di solito incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono incompatibili tra loro. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei draghi barbuti. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi e nascondersi, condizioni climatiche e di illuminazione adatte alla specie, Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Aree di riposo rialzate, lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo tale che tutti gli animali possano accedervi (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano scottarsi sulla lampada (il contatto diretto con la fonte luminosa non deve essere possibile), sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, possibilit\xe0 di fare il bagno, possibilit\xe0 di arrampicarsi e rocce, sabbia per scavare, acqua e cibo adatto alla specie (cibo fresco, insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie in termini di habitat, comportamento sociale, clima, svernamento, allestimento del terrario e alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 45\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco. Anche se i draghi barbuti sono animali solitari al di fuori della stagione degli amori, la compagnia di conspecifici \xe8 un importante arricchimento delle opzioni comportamentali nel terrario, purch\xe9 gli animali siano compatibili.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Drago barbuto dalla testa striata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_it.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    },
                    "centralBeardedDragon": {
                        "name": "Drago barbuto dalla testa striata",
                        "namePlural": "Draghi barbuti dalla testa striata",
                        "textLength": "Per le lucertole, si misura la lunghezza del corpo (senza coda) dell'animale pi\xf9 lungo.",
                        "minAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono incompatibili tra loro.",
                        "maxAnimalsWarningMessage": "Informatevi sulla struttura sociale dei draghi barbuti. I maschi sono incompatibili tra loro. Un numero cos\xec elevato di animali non \xe8 raccomandabile.",
                        "maxAnimalsErrorMessage": "Informatevi sulla struttura sociale dei draghi barbuti. Un numero cos\xec elevato di animali deve essere respinto",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di arrampicarsi e nascondersi, condizioni climatiche e di illuminazione adatte alla specie, Possibilit\xe0 di arrampicarsi orizzontalmente e verticalmente, nascondigli, condizioni climatiche e di illuminazione adatte alla specie, punt di sole e lampada a emissione UV\n",
                            "socialStructure": "Rispettare la struttura sociale. In determinate circostanze gli animali devono essere detenuti singolarmente.\n",
                            "waterBasin": "-"
                        },
                        "recommendations": {
                            "furnishing": "Aree di riposo rialzate, lampade a emissione UV e illuminazione di base, l'illuminazione UV deve essere installata in modo tale che tutti gli animali possano accedervi (collocazione adeguata e numero sufficiente di punti soleggiati), ma non possano scottarsi sulla lampada (il contatto diretto con la fonte luminosa non deve essere possibile), sistema di misurazione per il controllo della temperatura e dell'umidit\xe0, almeno tante possibilit\xe0 di ritiro quanti sono gli animali, ad esempio tubi di sughero, radici, possibilit\xe0 di fare il bagno, possibilit\xe0 di arrampicarsi e rocce, sabbia per scavare, acqua e cibo adatto alla specie (cibo fresco, insetti)\n",
                            "socialStructure": "Occorre tenere conto delle esigenze specifiche della specie in termini di habitat, comportamento sociale, clima, svernamento, allestimento del terrario e alimentazione. Temperatura di base 25-30\xb0C, spot di calore locale 45\xb0C, raffreddamento notturno, a seconda del clima di origine si consiglia uno svernamento al fresco. Anche se i draghi barbuti sono animali solitari al di fuori della stagione degli amori, la compagnia di conspecifici \xe8 un importante arricchimento delle opzioni comportamentali nel terrario, purch\xe9 gli animali siano compatibili.\n",
                            "waterBasin": "-"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio informativo Drago barbuto dalla testa striata",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_bartagame_de.pdf"
                            },
                            "1": {
                                "text": "Rettili: Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Reptilien_A4_web.pdf"
                            },
                            "2": {
                                "text": "Foglio informativo Rettili come animali da compagnia",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/reptilien/mb_Reptilien_als_Heimtiere_it.pdf"
                            }
                        }
                    }
                },
                "birds": {
                    "diamondDove": {
                        "name": "Tortora diamantina",
                        "namePlural": "Tortore diamantine",
                        "minAnimalsErrorMessage": "Le tortore diamantine sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 tortore diamantine insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le tortore diamantine sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppo con pi\xf9 coppie riproduttive.",
                            "indoor": "Le tortore diamantine possono essere detenute in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La variante di detenzione pi\xf9 rispettosa per le tortore diamantine \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetta dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": '"Le tortore diamantine sono generalmente molto pacifiche e si possono detenere con altre specie di uccelli pacifici se si dispone di un’esperienza adeguata. \nAlle tortore diamantine piace trascorrere molto tempo a terra durante il giorno, quindi \xe8 necessario prestare particolare attenzione a garantire che la voliera abbia un’ampia superficie sul fondo. Sono agili volatrici, quindi \xe8 importante assicurare anche che ci sia spazio sufficiente per il volo."'
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "canary": {
                        "name": "Canarino",
                        "namePlural": "Canarini",
                        "minAnimalsErrorMessage": "I canarini sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 canarini insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I canarini sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I canarini possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La variante di detenzione pi\xf9 rispettosa per i canarini \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetta dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "La detenzione comune insieme ad altre specie di uccelli \xe8 consigliata solo alle persone con molte conoscenze specialistiche.\nAttenzione: Per i canarini esistono delle razze d’allevamento (ad es. alcuni canarini di forma e posizione) che appartengono alle razze da tortura, quind si prega di non comprare questi animali"
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Canarino",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_kanarien_it.pdf"
                            }
                        }
                    },
                    "zebraFinch": {
                        "name": "Diamante mandarino",
                        "namePlural": "Diamanti mandarini",
                        "minAnimalsErrorMessage": "I diamanti mandarini sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 diamanti mandarini insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I diamanti mandarini sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I diamanti mandarini possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La variante di detenzione pi\xf9 rispettosa per i diamanti mandarini \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (minimo 12\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.). Attenzione: Nella stagione invernale \xe8 necessaria la detenzione all’interno!",
                            "specificNeeds": "La detenzione comune insieme ad altre specie di uccelli \xe8 consigliata solo alle persone con molte conoscenze specialistiche."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Diamante mandarino",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_zebrafinken_it.pdf"
                            }
                        }
                    },
                    "grayWaxbill": {
                        "name": "Becco di corallo",
                        "namePlural": "Becchi di corallo",
                        "minAnimalsErrorMessage": "I becchi di corallo sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 becchi di corallo insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I becchi di corallo sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I becchi di corallo possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "Possibile solo nei mesi estivi, poich\xe9 i becchi di corallo sono sensibili al freddo. Nei mesi estivi, parco esterno costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (minimo 18\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "La detenzione comune insieme ad altre specie di uccelli \xe8 consigliata solo alle persone con molte conoscenze specialistiche."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "goldenBreasted": {
                        "name": "Bengalino ventre arancio",
                        "namePlural": "Bengalini ventre arancio",
                        "minAnimalsErrorMessage": "I bengalini ventre arancio sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 bengalini ventre arancio insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I bengalini ventre arancio dovrebbero essere detenuti in coppia poich\xe9 i maschi possono essere aggressivi nei confronti dei rivali della stessa specie durante la stagione riproduttiva.",
                            "indoor": "I bengalini ventre arancio possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "Possibile solo nei mesi estivi, poich\xe9 i bengalini ventre arancio sono sensibili al freddo. Nei mesi estivi, parco esterno costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (minimo 15\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Uccello longevo, molto attivo, necessita di una voliera spaziosa con erba e canne. \nLa detenzione comune insieme ad altre specie di uccelli \xe8 impegnativa e consigliata solo alle persone con molte conoscenze specialistiche."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "gouldianMadine": {
                        "name": "Diamante di Gould",
                        "namePlural": "Diamanti di Gould",
                        "minAnimalsErrorMessage": "I diamante di Gould sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I diamanti di Gould sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "I diamanti di Gould possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "Possibile solo nei mesi estivi, poich\xe9 i diamanti di Gould sono sensibili al freddo. Nei mesi estivi, parco esterno costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (minimo 18\xb0C) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.). Nella stagione invernale, i diamanti di Gould devono assolutamente essere detenuti all’interno (vedi sopra).",
                            "specificNeeds": "Numerose possibilit\xe0 di riparo e abbastanza nascondigli sono essenziali per gli uccelli timidi. \nLa detenzione comune insieme ad altre specie di uccelli \xe8 impegnativa e consigliata solo alle persone con molte conoscenze specialistiche.\nEvitare l’acquisto di specie morfo-cromatico d’allevamento."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Diamanti di Gould",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Gouldamadinen_it.pdf"
                            }
                        }
                    },
                    "budgerigar": {
                        "name": "Parrocchetto ondulato",
                        "namePlural": "Parrocchetti ondulati",
                        "minAnimalsErrorMessage": "I parrocchetti ondulati sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I parrocchetti ondulati sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive (almeno 2, meglio 3). Ci\xf2 richiede una grande voliera, poich\xe9 i maschi difendono il sito di nidificazione durante la stagione riproduttiva.",
                            "indoor": "I parrocchetti ondulati possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "I parrocchetti ondulati hanno bisogno di svariate opportunit\xe0 di arrampicarsi sotto forma di vari rami naturali (nocciolo, salice, faggio, alberi da frutto non trattati). Questi servono anche come materiale da rosicchiare e devono essere rinnovati regolarmente.\n\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli. Evitare di acquistare forme di allevamento estreme (ad esempio uccelli con creste)."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA - Parrocchetto ondulato",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_wellensittiche_it.pdf"
                            }
                        }
                    },
                    "agapornid": {
                        "name": "Inseparabile",
                        "namePlural": "Inseparabili",
                        "minAnimalsErrorMessage": "Gli inseparabili sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1.  Allen Papageienartigen m\xfcssen reichlich Natur\xe4ste als Nage- und Kletterm\xf6glichkeit zur Verf\xfcgung stehen.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Gli inseparabili sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "Gli inseparabili possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": " La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Per la detenzione domestica, considerare prima di tutto specie come inseparabili di Fischer, facciarosa, mascherato e guancenere. Le altre specie di agapornidi sono pi\xf9 impegnative e sono quindi sconsigliate per i principianti.\nAlcune specie di agapornidi possono essere piuttosto aggressive e non sono adatte per essere detenute con altre specie.\n\nGli agapornidi possono essere piuttosto rumorosi. Pertanto, anche il vicinato deve essere d'accordo con la loro detenzione."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Inseparabili",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_it.pdf"
                            }
                        }
                    },
                    "tarantaParrot": {
                        "name": "Inseparabile alinere",
                        "namePlural": "Inseparabili alinere",
                        "minAnimalsErrorMessage": "Gli inseparabili alinere sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Gli inseparabili alinere sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "Gli inseparabili alinere possono essere detenuti in voliere di grandi dimensioni o in stanze per uccelli. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino).  La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Gli inseparabili alinere rappresentano la pi\xf9 grande specie di agapornidi (inseparabili). \nDetenere questa specie di agapornidi \xe8 impegnativo e non \xe8 quindi adatta ai principianti.\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli. \nGli inseparabili alinere possono essere piuttosto rumorosi. Pertanto, anche il vicinato deve essere d'accordo con la loro detenzione."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Inseparabili",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Agaporniden_it.pdf"
                            }
                        }
                    },
                    "cockatiel": {
                        "name": "Calopsitta",
                        "namePlural": "Calopsitte",
                        "minAnimalsErrorMessage": "Le calopsitte sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le calopsitte sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "Le calopsitte possono essere detenute in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Le calopsitte hanno bisogno di svariate opportunit\xe0 di arrampicarsi sotto forma di vari rami naturali (nocciolo, salice, faggio, alberi da frutto non trattati). Questi servono anche come materiale da rosicchiare e devono essere rinnovati regolarmente.\n\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Calopsitta",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_Nymphensittiche_it.pdf"
                            }
                        }
                    },
                    "beautifulParakeet": {
                        "name": "Pappagallo turchese",
                        "namePlural": "Pappagalli turchesi",
                        "minAnimalsErrorMessage": "I pappagalli turchesi sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione comune di una coppia di riproduzione \xe8 la pi\xf9 rispettosa degli animali. \xc8 fondamentale prestare attenzione alla tolleranza individuale degli animali, perch\xe9 i pappagalli turchesi possono reagire in modo piuttosto aggressivo ai conspecifici cos\xec come ad altre specie di uccelli.",
                        "maxAnimalsErrorMessage": "Attenzione! La detenzione dei pappagalli turchesi \xe8  impegnativa: i pappagalli turchesi devono essere detenuti in coppia poich\xe9 possono reagire in modo aggressivo ai conspecifici e ad altre specie di uccelli.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I pappagalli turchesi sono molto socievoli, ma possono essere piuttosto aggressivi verso altri uccelli, anche conspecifici. Per i pappagalli turchesi si raccomanda quindi la detenzione in coppia.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "I pappagalli turchesi hanno bisogno di un'area di volo libera pi\xf9 ampia possibile perch\xe9 il loro volo \xe8 rettilineo. Hanno anche bisogno di essere occupati e di avere opportunit\xe0 di rosicchiare sotto forma di una variet\xe0 di rami freschi e non tossici.\nEvitare la socializzazione con altre specie di uccelli poich\xe9 possono reagire in modo aggressivo."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "rosellaConure": {
                        "name": "Rosella orientale",
                        "namePlural": "Roselle orientali",
                        "minAnimalsErrorMessage": "Le roselle orientali sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 20 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le roselle orientali sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive. In caso di detenzione di pi\xf9 coppie, la voliera deve essere molto grande perch\xe9 i maschi sono molto aggressivi durante la stagione del corteggiamento e il periodo della cova.",
                            "indoor": "Le roselle orientali possono essere detenute in voliere di grandi dimensioni o in stanze per uccelli. Le tradizionali gabbie per uccelli sono troppo piccole per una detenzione conforme alla specie. Le voliere alte e strette non sono idonee, poich\xe9 gli uccelli necessitano di spazio orizzontale per volare. Allo stesso modo, anche le vetrine non sono idonee.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Le roselle orientali hanno bisogno di un'area di volo libera pi\xf9 ampia possibile perch\xe9 sono molto vivaci. Hanno anche bisogno di essere occupati e di avere opportunit\xe0 di rosicchiare sotto forma di una variet\xe0 di rami freschi e non tossici.\nLa socializzazione con altre specie \xe8 possibile, ma consigliata solo per detentori esperti di uccelli."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    },
                    "cockatoo": {
                        "name": "Cacatua",
                        "namePlural": "Cacatua",
                        "minAnimalsErrorMessage": "I cacatua sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata! La detenzione dei cacatua (ad eccezione delle calopsitte) \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere dei cacatua, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsWarningMessage": "La detenzione dei cacatua (ad eccezione delle calopsitte) \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere dei cacatua, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsErrorMessage": "La detenzione dei cacatua (ad eccezione delle calopsitte) \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere dei cacatua, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "laws": {},
                        "recommendations": {
                            "general": "Per motivi di benessere degli animali, la Protezione Svizzera degli Animali PSA sconsiglia l'allevamento privato di ara/cacatua. I requisiti di spazio per tenere gli ara/cacatua in modo rispettoso degli animali sono immensi e di solito non possono essere soddisfatti dai detentori privati. L'allevamento di cacatua o ara \xe8 estremamente impegnativo e richiede un'autorizzazione. Prima di acquistare un cacatua o un ara, \xe8 necessario completare un corso per esperti (SKN). Inoltre, \xe8 necessario presentare una domanda all'ufficio veterinario cantonale del cantone di residenza e dimostrare di poter soddisfare tutti i requisiti prescritti dalla legge in materia di detenzione, cura e acquisto. Se intendete allevare cacatua o ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per ulteriori informazioni."
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni tecniche − Protezione degli animali. Obbligo di autorizzazione per la detenzione di pappagalli di grossataglia",
                                "file": "https://www.blv.admin.ch/dam/blv/it/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/IT_3.1_Fachinformation_Bewilligungspflicht_fu%CC%88r_Grosspapageien_IT.pdf"
                            }
                        }
                    },
                    "macaw": {
                        "name": "Ara",
                        "namePlural": "Ara",
                        "minAnimalsErrorMessage": "Gli ara sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata! \nLa detenzione dei pappagalli di grandi dimensioni come gli ara \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere degi ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsWarningMessage": "La detenzione dei pappagalli di grandi dimensioni come gli ara \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere degi ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "maxAnimalsErrorMessage": "La detenzione dei pappagalli di grandi dimensioni come gli ara \xe8 estremamente impegnativa e necessita di un permesso. Se avete intenzione di detenere degi ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per maggiori informazioni.",
                        "laws": {},
                        "recommendations": {
                            "general": "Per motivi di benessere degli animali, la Protezione Svizzera degli Animali PSA sconsiglia l'allevamento privato di ara/cacatua. I requisiti di spazio per tenere gli ara/cacatua in modo rispettoso degli animali sono immensi e di solito non possono essere soddisfatti dai detentori privati. L'allevamento di cacatua o ara \xe8 estremamente impegnativo e richiede un'autorizzazione. Prima di acquistare un cacatua o un ara, \xe8 necessario completare un corso per esperti (SKN). Inoltre, \xe8 necessario presentare una domanda all'ufficio veterinario cantonale del cantone di residenza e dimostrare di poter soddisfare tutti i requisiti prescritti dalla legge in materia di detenzione, cura e acquisto. Se intendete allevare cacatua o ara, contattate l'ufficio veterinario cantonale del vostro cantone di residenza per ulteriori informazioni."
                        },
                        "links": {
                            "0": {
                                "text": "Informazioni tecniche − Protezione degli animali. Obbligo di autorizzazione per la detenzione di pappagalli di grossataglia",
                                "file": "https://www.blv.admin.ch/dam/blv/it/dokumente/tiere/heim-und-wildtierhaltung/fi-bew-pflicht-grosspapageien.pdf.download.pdf/IT_3.1_Fachinformation_Bewilligungspflicht_fu%CC%88r_Grosspapageien_IT.pdf"
                            }
                        }
                    },
                    "congoGreyParrot": {
                        "name": "Pappagallo cenerino",
                        "namePlural": "Pappagalli cenerini",
                        "minAnimalsErrorMessage": "I pappagalli cenerini sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 6 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "I pappagalli cenerini sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "La sola detenzione all’interno non \xe8 rispettosa degli animali per i pappagalli cenerini.",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interno adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Una detenzione rispettosa dei pappagalli cenerini \xe8 estremamente impegnativa. \nIl commercio di questi animali estremamente longevi \xe8 in forte espansione e ci sono molte offerte da parte di fornitori senza scrupoli (ad es. allevamento a mano, importazioni da fonti poco chiare). I pappagalli cenerini possono essere piuttosto rumorosi,pertanto anche il vicinato deve essere d'accordo con la loro detenzione. \n\nPer motivi di protezione degli animali,evitare di acquistare animali provenienti da allevamenti a mano."
                        },
                        "links": {
                            "0": {
                                "text": "Foglio Informativo PSA Pappagallo cenerino",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/voegel/mb_graupapageien_it.pdf"
                            }
                        }
                    },
                    "amazon": {
                        "name": "Amazzone",
                        "namePlural": "Amazzoni",
                        "minAnimalsErrorMessage": "Le amazzoni sono animali sociali. La detenzione di esemplari singoli \xe8 quindi vietata!",
                        "maxAnimalsWarningMessage": "La detenzione di pi\xf9 coppie riproduttive insieme \xe8 la pi\xf9 rispettosa degli animali. Tuttavia, \xe8 fondamentale prestare attenzione alla tolleranza individuale degli animali, soprattutto durante la stagione del corteggiamento e il periodo della cova. Per detenere pi\xf9 di una coppia riproduttiva, \xe8 necessario scegliere una voliera spaziosa con molte possibilit\xe0 di rifugio e opzioni alternative.",
                        "maxAnimalsErrorMessage": "Inserire un numero di 6 o meno.",
                        "laws": {
                            "furnishing": "Per legge sono obbligatori una possibilit\xe0 di bagnarsi, posatoi flessibili di diverso spessore e orientamento nonch\xe9 la fornitura di sabbia per uccelli a cui poter attingere in autonomia. Un terzo del volume deve essere privo di strutture. Nei parchi con una superficie inferiore a 2 m2, il rapporto fra lunghezza e larghezza, riferito alla superficie minima, deve essere al massimo di 2:1. Tutti i pappagalli devono avere a disposizione molti rami naturali da rosicchiare e per arrampicarsi.",
                            "socialStructure": "La detenzione singola \xe8 vietata",
                            "lawDetails": "Si prega di notare che le dimensioni minime previste per legge rappresentano solo dei requisiti minimi assoluti. In Svizzera \xe8 vietato detenere animali in gabbie pi\xf9 piccole e costituisce un maltrattamento degli animali. Per una detenzione degli uccelli rispettosa degli animali sono necessarie delle voliere molto pi\xf9 ampie e attrezzature ben strutturate (vedi raccomandazioni)."
                        },
                        "recommendations": {
                            "furnishing": "Rami fissati a una sola estremit\xe0 (= posatoi flessibili), corde varie, altalene, piatteforme appese al soffitto, vaschetta da bagno per uccelli (bacinella per il bagno o vasca bassa), pietre calcaree/ossi di seppia appesi, graniglia per la digestione in una ciotola piatta, lampade UV appropriate in caso di detenzione in locali chiusi, come fondo del suolo sabbia, ghiaia o trucioli di faggio. Le sbarre della recinzione devono essere disposte in orizzontale. Le gabbie rotonde sono contrarie alla protezione degli animali e vanno quindi evitate.",
                            "socialStructure": "Le amazzoni sono molto socievoli. Per rispettare il pi\xf9 possibile le esigenze di questa specie, occorre detenere gli animali in gruppi di pi\xf9 coppie riproduttive.",
                            "indoor": "La sola detenzione all’interno non \xe8 rispettosa degli animali per le amazzoni",
                            "outdoor": "La forma di detenzione pi\xf9 rispettosa degli animali \xe8 un parco esterno, costituito da una voliera e da un locale interna adiacente che pu\xf2 essere riscaldato (protetto dal gelo) (ad es. una casetta da giardino). La voliera deve essere parzialmente coperta nella parte superiore (protezione dalle intemperie) e va schermata su almeno due lati (piante o arbusti, rete frangivento coprente, ecc.).",
                            "specificNeeds": "Le amazzoni possono essere piuttosto rumorose,pertanto anche il vicinato deve essere d'accordo con la loro detenzione. \n\nEsistono diverse specie di amazzoni e non tutte sono adatte per la detenzione domestica. La pi\xf9 diffusa \xe8 l’amazzone fronteblu. Ogni specie ha le proprie esigenze specifiche in termini di detenzione, clima, alimentazione e struttura sociale. Si prega di richiedere informazioni a degli esperti riconosciuti o di seguire un corso specialistico prima dell'acquisto.\nPer motivi di protezione degli animali,evitare di acquistare animali provenienti da allevamenti a mano."
                        },
                        "links": {
                            "0": {
                                "text": "Uccelli - Detenzione adeguata - Parchi e attrezzature idonei",
                                "file": "https://www.tierhaltungsrechner.ch/files/merkblaetter/Brosch_Gehege_i_Voegel_A4_web.pdf"
                            }
                        }
                    }
                },
                "equidae": {
                    "horse": {
                        "name": "Cavallo",
                        "namePlural": "Cavalli",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro cavallo.",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Quando possibile",
                            "socialStructure": "I cavalli devono avere un contatto diretto con altri cavalli. I cavalli e gli asini parlano una lingua diversa e hanno esigenze differenti per quanto concerne la detenzione e l’alimentazione. ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente."
                        },
                        "laws": {
                            "runoutTime": "Cavalli utilizzati 2 x 2 h / settimana; cavalli non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "pony": {
                        "name": "Pony",
                        "namePlural": "Pony",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro pony o cavallo.",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Quando possibile, adeguare tuttavia lo stato dell’alimentazione!",
                            "socialStructure": "I pony devono avere un contatto diretto con altri pony o cavalli. ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente.",
                            "specialRequirements": "Con l'erba giovane, ricca di proteine​e fruttani, sussiste un aumento del rischio di obesit\xe0, soprattutto nei pony, specie se questi ultimi non si muovono a sufficienza."
                        },
                        "laws": {
                            "runoutTime": "Pony utilizzati 2 x 2 h / settimana; pony non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "donkey": {
                        "name": "Asino",
                        "namePlural": "Asini",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro asino.  ",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Pascolo limitato per gli asini, pi\xf9 movimento su ampie aree asciutte.",
                            "socialStructure": "Gli asini hanno bisogno del contatto diretto con i conspecifici, quindi con altri asini. Si differenziano dai cavalli per il comportamento e la fisiologia. Bisogna fornire loro cibo e occupazioni aggiuntivi con un alto contenuto di fibre come rami e paglia.",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente.",
                            "specialRequirements": "Gli asini sono animali che assimilano il cibo in modo molto efficiente. Hanno bisogno di alimenti ipocalorici a basso contenuto di zuccheri e proteine,​ma ricchi di fibre. Il manto degli asini \xe8 difficilmente idrorepellente, quindi quando sono bagnati, gli asini sono soggetti a malattie. Hanno sempre bisogno di un riparo asciutto. Gli asini hanno bisogno di terreno asciutto, altrimenti c'\xe8 il rischio che insorgano problemi agli zoccoli."
                        },
                        "laws": {
                            "runoutTime": "Muli utilizzati 2 x 2 h / settimana; muli non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "mule": {
                        "name": "Mulo",
                        "namePlural": "Muli",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro mulo.",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Pascolo limitato",
                            "socialStructure": "I muli preferiscono il contatto con altri muli. Naturalmente i muli possono essere tenuti con la madre cavalla. Tuttavia, bisogna tenere conto della loro fisiologia per quanto concerne alimentazione e pascolo.  ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente."
                        },
                        "laws": {
                            "runoutTime": "Muli utilizzati 2 x 2 h / settimana; muli non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    },
                    "hinny": {
                        "name": "Bardotto",
                        "namePlural": "Bardotti",
                        "minAnimalsWarningMessage": "Attenzione: gli equidi devono avere almeno un contatto visivo, acustico e olfattivo con altri equidi. Preferibilmente con un conspecifico, in questo caso con un altro bardotto. ",
                        "maxAnimalsWarningMessage": "In caso di cinque o pi\xf9 equidi molto compatibili fra loro, la superficie globale pu\xf2 essere ridotta al massimo del 20 per cento; nei seguenti risultati \xe8 stato tenuto conto di questo. La PSA non raccomanda questa riduzione.",
                        "recommendations": {
                            "pasturing": "Pascolo limitato",
                            "socialStructure": "I bardotti prediligono il contatto diretto con altri bardotti. Tuttavia possono anche essere detenuti con asini e/o cavalli. Tuttavia, bisogna tenere conto della loro fisiologia per quanto concerne alimentazione e pascolo.  ",
                            "activity": "Tutti gli equidi devono essere occupati quotidianamente."
                        },
                        "laws": {
                            "runoutTime": "Bardotti utilizzati 2 x 2 h / settimana; bardotti non utilizzati 2h al giorno",
                            "pasturing": "non prescritto",
                            "structuring": "Se gli equidi sono detenuti in gruppo, devono essere previste strutture che permettono loro di evitarsi e di ritirarsi; per i puledri svezzati e gli animali giovani non sono necessarie strutture per evitarsi e ritirarsi fino all'inizio del loro utilizzo regolare, tuttavia al pi\xf9 tardi fino al raggiungimento dei 30 mesi di et\xe0. Non devono essere presenti vicoli ciechi. Gli equidi non devono essere tenuti legati.",
                            "exercise": "Agli equidi deve essere concesso sufficiente movimento ogni giorno. Il movimento comprende l’utilizzazione e l’uscita all’aperto. In presenza di condizioni del terreno o meteorologiche estreme \xe8 possibile, in via eccezionale, far uscire gli equidi su una superficie coperta.",
                            "activity": "Gli equidi devono disporre di sufficiente foraggio grezzo per le esigenze di occupazione tipiche della specie, ad esempio paglia da foraggio, eccetto durante il pascolo.",
                            "socialStructure": "Gli equidi devono avere un contatto visivo, acustico e olfattivo con altri equidi. Dopo lo svezzamento da parte della madre, gli equidi devono essere detenuti in gruppo fino al raggiungimento dei 30 mesi di et\xe0 o fino all’inizio del loro utilizzo regolare."
                        },
                        "links": {
                            "0": {
                                "text": "Sito web dell'PSA sull'allevamento dei cavalli",
                                "file": "https://www.tierschutz.com/it/pferde"
                            },
                            "1": {
                                "text": "Ordinanza sulla protezione degli animali",
                                "file": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                            }
                        }
                    }
                }
            },
            "screenCategory": {
                "title": "Selezionare la categoria"
            },
            "screenAnimal": {
                "title": "Quale animale vuoi detenere?",
                "multipleBirdsButton": "Tenere insieme pi\xf9 specie",
                "equidaeInfo": "I valori calcolati si applicano solo a equidi di et\xe0 superiore a 30 mesi."
            },
            "screenMultipleBirds": {
                "warning": "Per tenere insieme due o pi\xf9 specie di uccelli, le dimensioni dello stabulario devono essere calcolate separatamente per tutte le specie, ma con il numero totale di uccelli. Lo stabulario pi\xf9 grande calcolato rispetta le dimensioni minime previste dalla legge.",
                "infoText": "Se due o pi\xf9 specie di uccelli sono tenute insieme in uno stabulario, le dimensioni minime legali dello stabulario corrispondono sempre allo spazio necessario per la specie pi\xf9 grande. Ad esempio, se si tengono insieme due pappagallini e due cacatua in uno stesso recinto, le dimensioni minime dello stabulario saranno quelle richieste per quattro cacatua, in quanto si tratta della specie pi\xf9 grande presente nello stabulario. L'allevamento di pi\xf9 specie di uccelli insieme \xe8 adatto solo agli allevatori esperti. Informatevi sempre bene sulle specie di uccelli che possono essere tenute insieme."
            },
            "screenNumber": {
                "title": "Quanti {animals} vuoi detenere?"
            },
            "screenWeight": {
                "title": "Quanto pesano gli {animals}?"
            },
            "screenLength": {
                "title": "Quanto \xe8 lungo {animal} pi\xf9 grande?",
                "error": "Inserire un numero compreso tra {min} e {max}."
            },
            "screenWithersHeight": {
                "title": "Qual \xe8 l'altezza al garrese dei singoli animali?",
                "error": "Inserire un numero compreso tra {min} e {max}.",
                "animal": "Livello"
            },
            "screenResults": {
                "title": "Ecco come dovresti detenere {number} {animals}",
                "example": "Per esempio",
                "exampleEquidae": "Esempio per la dimensione del box",
                "stsRecommendation": "Raccomandazione della protezione degli animali",
                "law": "Legge (Ordinanza federale sulla protezione degli animali)",
                "stsAreaRecommendation": "Area minima (dimensioni interne)",
                "stsLengthRecommendation": {
                    "upto2reptiles": "Lunghezza minima (dimensioni interne)",
                    "morethan2reptiles": "In pi\xf9, come minimo in lunghezza"
                },
                "stsWidthRecommendation": {
                    "upto2reptiles": "Larghezza minima (dimensioni interne)",
                    "morethan2reptiles": "In pi\xf9, come minimo in larghezza"
                },
                "stsHeightRecommendation": "Altezza minima del recinto (dimensioni interne)",
                "stsBeddingRecommendation": "Profondit\xe0 minima della lettiera",
                "stsWaterBasinRecommendation": "Bacino d'acqua",
                "tolerance": "Valore di tolleranza",
                "toleranceInfo": "Le stalle esistenti al 1\xb0 settembre 2008 che soddisfano i valori di tolleranza non necessitano di adeguamento. Se una stalla deve essere modificata perch\xe9 scende al di sotto di un valore di tolleranza, rimane invariato il diritto all'altro valore di tolleranza.",
                "noTolerance": "Nessun valore di tolleranza",
                "stsLayingAreaRecommendation": "Superficie di riposo",
                "stsClearWidthRecommendation": "Larghezza netta",
                "stsClearWidthRecommendationInfo": "2 x garrese dell’animale pi\xf9 grande",
                "stsClearHeightRecommendation": "Altezza netta",
                "stsRunoutTimeRecommendation": "Tempo di uscita all’aperto",
                "stsRunoutTimeRecommendationText": "Preferibilmente accesso libero 24 ore dall’uscita all’aperto in qualsiasi stagione, ma almeno 4 ore al giorno",
                "stsRunoutAreaRecommendation": "Superficie di uscita all’aperto",
                "stsPasturingRecommendation": "Pascolo",
                "stsLatticeSpacing": "Distanza massima fra le sbarre",
                "lawMinimalArea": "Area minima (dimensioni interne)",
                "lawMinimalLength": "Lunghezza minima  (dimensioni interne)",
                "lawMinimalWidth": "Larghezza minima (dimensioni interne)",
                "lawMinimalHeight": "Altezza minima del recinto (dimensioni interne)",
                "lawMinimalBedding": "Profondit\xe0 minima della lettiera",
                "lawWaterBasin": "Bacino d'acqua",
                "lawReptilesInfo": {
                    "text": "Quando si detiene il numero di animali indicato, \xe8 necessario garantire che tutti i requisiti previsti dalla {link} siano soddisfatti per le rispettive specie animali.",
                    "linkText": "legge secondo l’allegato 2, tabella 5 OPan",
                    "linkURL": "https://www.fedlex.admin.ch/eli/cc/2008/416/it"
                },
                "lawVolume": "Volume",
                "lawLayingArea": "Stalla a stabulazione singola",
                "layingAreaInfo": "Superfici di riposo non separate spazialmente dall’area di alimentazione, per ulteriori condizioni vedere l'Ordinanza sulla protezione degli animali, tabella 7.",
                "lawLayingAreaMultiroom": "La superficie di riposo \xe8 separata spazialmente dall'area di movimento e alimentazione, per ulteriori condizioni vedere l'Ordinanza sulla protezione degli animali, tabella 7.",
                "layingAreaMultiroomInfo": "Aires de repos s\xe9par\xe9es de l'aire d'alimentation ; pour les autres conditions, voir l'ordonnance sur la protection des animaux, tableau 7.",
                "lawClearWidth": "Larghezza netta",
                "lawClearWidthInfo": "1.5 x garrese dell’animale pi\xf9 grande",
                "lawClearHeight": "Altezza netta",
                "lawRunoutTime": "Tempo di uscita all’aperto",
                "lawRunoutAreaAdjacent": "Superficie di uscita all’aperto adiacente",
                "lawRunoutAreaNonadjacent": "Superficie di uscita all’aperto non adiacente",
                "lawPasturing": "Pascolo",
                "additionalRecommendations": {
                    "title": "Ulteriori raccomandazioni",
                    "furnishing": "Attrezzatura",
                    "socialStructure": "Struttura sociale e bisogni specifici della specie",
                    "indoor": "Detenzione interna",
                    "outdoor": "Detenzione all'aperto",
                    "specificNeeds": "Esigenze specifiche della specie",
                    "specialRequirements": "Altre esigenze",
                    "activity": "Movimento",
                    "more": "Inoltre"
                },
                "additionalLaws": {
                    "title": "Altre disposizioni di legge",
                    "furnishing": "Attrezzatura",
                    "raisedAreas": "Superfici rialzate",
                    "socialStructure": "Struttura sociale",
                    "structuring": "Struttura",
                    "activity": "Occupazione",
                    "exercise": "Movimento"
                },
                "lawDetails": "Si prega di notare che i requisiti minimi previsti per legge rappresentano solo dei valori minimi in assoluto. In Svizzera \xe8 vietato tenere animali in gabbie pi\xf9 piccole e maltrattarli. \nPer una detenzione rispettosa degli animali sono necessarie superfici molto pi\xf9 grandi e un’attrezzatura ben strutturata (vedi raccomandazioni).\n",
                "additionalInfo": "Per maggiori informazioni"
            }
        }
    }
};


var $b505edbfee5318f0$exports = {};
"use strict";
var $b505edbfee5318f0$var$__importDefault = $b505edbfee5318f0$exports && $b505edbfee5318f0$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($b505edbfee5318f0$exports, "__esModule", {
    value: true
});

var $b505edbfee5318f0$var$es6_object_assign_1 = $b505edbfee5318f0$var$__importDefault((parcelRequire("d0ZGJ")));
$b505edbfee5318f0$var$es6_object_assign_1.default.polyfill();

var $b505edbfee5318f0$var$vue3_logger_1 = $b505edbfee5318f0$var$__importDefault((parcelRequire("hpBw0")));
$b505edbfee5318f0$exports.default = $b505edbfee5318f0$var$vue3_logger_1.default;


var $521c837f559cbd2c$exports = {};
$521c837f559cbd2c$exports = "@import \"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400;0,700;0,900;1,400&display=swap\";@-webkit-keyframes beat-e74703{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.075);transform:scale(1.075)}20%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes beat-e74703{0%{-webkit-transform:scale(1);transform:scale(1)}10%{-webkit-transform:scale(1.075);transform:scale(1.075)}20%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(1);transform:scale(1)}}@-webkit-keyframes tooltips-vert-e74703{to{opacity:.9;-webkit-transform:translate(-50%);transform:translate(-50%)}}@keyframes tooltips-vert-e74703{to{opacity:.9;-webkit-transform:translate(-50%);transform:translate(-50%)}}@-webkit-keyframes tooltips-horz-e74703{to{opacity:.9;-webkit-transform:translateY(-50%);transform:translateY(-50%)}}@keyframes tooltips-horz-e74703{to{opacity:.9;-webkit-transform:translateY(-50%);transform:translateY(-50%)}}@-webkit-keyframes turn-e74703{0%{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}50%{-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}to{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}}@keyframes turn-e74703{0%{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}50%{-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,65deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}to{-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:rotate3d(0,1,0,20deg)scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y))}}@media (prefers-reduced-motion:reduce){body .tr-wrapper .screen-results .results .results-visual .cube-container .cube[data-v-e74703]{-webkit-animation:none;animation:none;-webkit-transform:rotate3d(1,1,0,45deg);transform:rotate3d(1,1,0,45deg)}}body .tr-wrapper[data-v-e74703],body .tr-wrapper[data-v-e74703]:before,body .tr-wrapper[data-v-e74703]:after,body .tr-wrapper [data-v-e74703],body .tr-wrapper [data-v-e74703]:before,body .tr-wrapper [data-v-e74703]:after{all:revert}body .tr-wrapper[data-v-e74703],body .tr-wrapper [data-v-e74703]{font-size:100%;font:inherit;vertical-align:baseline;box-sizing:content-box;border:0;margin:0;padding:0}body .tr-button[data-v-e74703]{color:#000;background-color:#fff;border:3px solid #ff7b00;border-radius:10px;flex-wrap:nowrap;padding:.5em 2em .5em .5em;font-family:Roboto,sans-serif;font-size:18px;font-weight:700;display:inline-flex}body .tr-button .logo[data-v-e74703]{margin-top:2px;margin-right:1em}body .tr-button .logo img[data-v-e74703]{max-width:100px}body .tr-button p[data-v-e74703]{margin:.5em 0 .75em}body .tr-button button[data-v-e74703]{color:#fff;letter-spacing:.02rem;cursor:pointer;background-color:#ff7b00;border:2px solid #ff7b00;border-radius:24px;flex-wrap:nowrap;align-content:center;justify-content:flex-start;margin-bottom:1em;padding:0;font-family:Roboto,sans-serif;font-size:18px;font-weight:700;transition:all .2s;display:inline-flex;position:relative;overflow:hidden}body .tr-button button[data-v-e74703]:hover{background-color:#5f4bb6;border-color:#5f4bb6;-webkit-transform:scale(1.02);transform:scale(1.02)}body .tr-button button span[data-v-e74703]{flex-grow:1}body .tr-button button span.tr-icon[data-v-e74703]{background-color:#ff7b00;justify-content:center;align-items:center;padding:5px 12px;display:flex}body .tr-button button span.tr-icon img[data-v-e74703]{height:34px;-webkit-animation:2.5s linear infinite beat-e74703;animation:2.5s linear infinite beat-e74703}body .tr-button button span.tr-button-text[data-v-e74703]{padding:10px 20px}body .tr-button.style-full[data-v-e74703],body .tr-button.hidden[data-v-e74703],body .tr-wrapper.style-button[data-v-e74703]:not(.open){display:none}body .tr-wrapper[data-v-e74703]{--tr-visual-3d-scale:1;color:#000;background-color:#fff;padding:2em 4em 4em;font-family:Roboto,sans-serif;font-size:16px;font-weight:400;position:relative;box-shadow:0 1em 2em -.5em rgba(0,0,0,.35)}body .tr-wrapper.style-button.open[data-v-e74703]{z-index:999;width:calc(96% - 8em);position:absolute;top:10px;left:2%}body .tr-wrapper .close-button[data-v-e74703]{cursor:pointer;z-index:99;background-color:#ff7b00;border-radius:20px;flex-flow:column;justify-content:center;align-items:center;width:65px;height:65px;transition:all .15s;display:none;position:absolute;top:20px;left:20px}body .tr-wrapper .close-button[data-v-e74703]:hover,body .tr-wrapper .close-button[data-v-e74703]:focus{background-color:#fff}body .tr-wrapper .close-button:hover .icon-cross[data-v-e74703]:before,body .tr-wrapper .close-button:hover .icon-cross[data-v-e74703]:after,body .tr-wrapper .close-button:focus .icon-cross[data-v-e74703]:before,body .tr-wrapper .close-button:focus .icon-cross[data-v-e74703]:after{background-color:#ff7b00}body .tr-wrapper .close-button .icon-cross[data-v-e74703]{background:0 0;border:0;width:40px;height:40px;margin:0;padding:0;position:relative}body .tr-wrapper .close-button .icon-cross[data-v-e74703]:before,body .tr-wrapper .close-button .icon-cross[data-v-e74703]:after{content:\"\";background:#fff;border-radius:6px;height:6px;position:absolute;top:17px;left:0;right:0}body .tr-wrapper .close-button .icon-cross[data-v-e74703]:before{-webkit-transform:rotate(45deg);transform:rotate(45deg)}body .tr-wrapper .close-button .icon-cross[data-v-e74703]:after{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}body .tr-wrapper .close-button .icon-cross span[data-v-e74703]{display:block}body .tr-wrapper.style-button.open .close-button[data-v-e74703]{display:flex}body .tr-wrapper .logos[data-v-e74703]{max-width:1450px;margin:0 auto;position:relative}body .tr-wrapper .logo.logo-sts[data-v-e74703]{max-width:350px}body .tr-wrapper .tierschutz-rechner[data-v-e74703]{max-width:1000px;margin:0 auto}body .tr-wrapper .footer[data-v-e74703]{flex-wrap:wrap;justify-content:space-between;padding-top:4rem;display:flex}body .tr-wrapper .footer .backlinks[data-v-e74703],body .tr-wrapper .footer .logos[data-v-e74703]{margin:2rem 0 0}body .tr-wrapper .footer .backlinks p[data-v-e74703]{margin-bottom:0}body .tr-wrapper .footer .backlinks a[data-v-e74703]{letter-spacing:.02em;font-family:Roboto,sans-serif;font-size:1.4rem;font-weight:600;text-decoration:none}body .tr-wrapper .footer .backlinks a[data-v-e74703]:hover{text-decoration:underline}body .tr-wrapper .footer .backlinks p.email a[data-v-e74703]{font-size:1.125rem}body .tr-wrapper .footer .logos[data-v-e74703]{text-align:right}body .tr-wrapper h2[data-v-e74703]{color:#000;text-align:center;letter-spacing:.02em;margin-top:.2em;margin-bottom:1em;font-family:Roboto,sans-serif;font-size:3em;font-weight:700}body .tr-wrapper p[data-v-e74703],body .tr-wrapper label[data-v-e74703],body .tr-wrapper h3[data-v-e74703]{color:#000;margin-bottom:1em;font-size:1.8em}body .tr-wrapper .screen>p[data-v-e74703]:first-child{font-family:Roboto,sans-serif;font-weight:700}body .tr-wrapper h3[data-v-e74703]{border-bottom:2px solid #ff7b00;padding-bottom:1em}body .tr-wrapper h4[data-v-e74703]{color:#000;margin-bottom:1rem;font-family:Roboto,sans-serif;font-size:2.4rem;font-weight:700}body .tr-wrapper h5[data-v-e74703]{color:#000;font-weight:700}body .tr-wrapper hr[data-v-e74703]{border-bottom:1px solid #333;margin-bottom:2em}body .tr-wrapper ul[data-v-e74703]{margin-left:1em}body .tr-wrapper ul li[data-v-e74703]{margin-bottom:.5em}body .tr-wrapper a[data-v-e74703],body .tr-wrapper a[data-v-e74703]:hover{color:#000}body .tr-wrapper span[data-tooltip][data-v-e74703]{color:#000;vertical-align:super;cursor:pointer;font-weight:700;position:relative}body .tr-wrapper span[data-tooltip][data-v-e74703]:before,body .tr-wrapper span[data-tooltip][data-v-e74703]:after{-webkit-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;opacity:0;font-size:1rem;display:none;position:absolute}body .tr-wrapper span[data-tooltip][data-v-e74703]:before{content:\"\";z-index:1000;border:5px solid transparent}body .tr-wrapper span[data-tooltip][data-v-e74703]:after{content:attr(data-tooltip);z-index:1000;text-align:center;white-space:normal;text-overflow:ellipsis;color:#fff;background:#333;border-radius:.3ch;min-width:12em;max-width:21em;padding:1ch 1.5ch;overflow:hidden;box-shadow:0 1em 2em -.5em rgba(0,0,0,.35)}body .tr-wrapper span[data-tooltip][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-v-e74703]:hover:after{display:block}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):before,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:before{border-top-color:#333;border-bottom-width:0;bottom:100%}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):after,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:after{bottom:calc(100% + 5px)}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):before,body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):after,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:before,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:after{left:50%;-webkit-transform:translate(-50%,-.5em);transform:translate(-50%,-.5em)}body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:before{border-top-width:0;border-bottom-color:#333;top:100%}body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:after{top:calc(100% + 5px)}body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:before,body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:after{left:50%;-webkit-transform:translate(-50%,.5em);transform:translate(-50%,.5em)}body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:before{border-left-color:#333;border-right-width:0;top:50%;left:-5px;-webkit-transform:translate(-.5em,-50%);transform:translate(-.5em,-50%)}body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:after{top:50%;right:calc(100% + 5px);-webkit-transform:translate(-.5em,-50%);transform:translate(-.5em,-50%)}body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:before{border-left-width:0;border-right-color:#333;top:50%;right:-5px;-webkit-transform:translate(.5em,-50%);transform:translate(.5em,-50%)}body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:after{top:50%;left:calc(100% + 5px);-webkit-transform:translate(.5em,-50%);transform:translate(.5em,-50%)}body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):hover:before,body .tr-wrapper span[data-tooltip][data-v-e74703]:not([data-flow]):hover:after,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=up][data-v-e74703]:hover:after,body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=down][data-v-e74703]:hover:after{-webkit-animation:.3s ease-out forwards tooltips-vert-e74703;animation:.3s ease-out forwards tooltips-vert-e74703}body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=left][data-v-e74703]:hover:after,body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:hover:before,body .tr-wrapper span[data-tooltip][data-flow^=right][data-v-e74703]:hover:after{-webkit-animation:.3s ease-out forwards tooltips-horz-e74703;animation:.3s ease-out forwards tooltips-horz-e74703}body .tr-wrapper span[data-tooltip=\"\"][data-v-e74703]:before,body .tr-wrapper span[data-tooltip=\"\"][data-v-e74703]:after{display:none!important}body .tr-wrapper .screen-image-wrapper[data-v-e74703]{aspect-ratio:5/3;background-color:#fff;border-radius:20px;max-width:325px;margin:2em 0;padding:10% 0;overflow:hidden;box-shadow:0 .6em 1.5em rgba(0,0,0,.2)}body .tr-wrapper .screen-image-wrapper img[data-v-e74703]{object-fit:cover;width:100%;margin-top:-16%;transition:opacity .2s;display:block}body .tr-wrapper .screen-length .screen-image-wrapper[data-v-e74703]{aspect-ratio:auto;max-width:546px;padding:80px 40px}body .tr-wrapper .screen-length .screen-image-wrapper img[data-v-e74703]{margin-top:0}body .tr-wrapper .bottom-navi[data-v-e74703]{margin-top:4rem}body .tr-wrapper .warning[data-v-e74703]{color:#000;text-align:center;background-color:#edd82e;border-radius:.7em;margin-bottom:1em;padding:1em;font-size:1rem;font-weight:700}body .tr-wrapper .warning p[data-v-e74703]{color:#000;margin-bottom:0;font-size:1.4rem}body .tr-wrapper input[data-v-e74703]:focus{outline:none}body .tr-wrapper input[type=number][data-v-e74703]{-webkit-appearance:textfield;-ms-appearance:textfield;appearance:textfield}body .tr-wrapper input[type=number][data-v-e74703]::-webkit-inner-spin-button{-webkit-appearance:none}body .tr-wrapper input[type=number][data-v-e74703]::-webkit-outer-spin-button{-webkit-appearance:none}body .tr-wrapper .number-input[data-v-e74703]{border:0;width:325px;margin-bottom:1em;margin-right:1em;display:inline-flex}body .tr-wrapper .number-input[data-v-e74703],body .tr-wrapper .number-input [data-v-e74703]{box-sizing:border-box}body .tr-wrapper .number-input button[data-v-e74703]{-webkit-appearance:none;cursor:pointer;background-color:#fff;border:none;border-radius:0 20px 20px 0;outline:none;justify-content:center;align-items:center;width:4rem;height:4rem;margin:0;position:relative}body .tr-wrapper .number-input button.minus[data-v-e74703]{border:1px solid #333;border-right:none;border-radius:20px 0 0 20px}body .tr-wrapper .number-input button.plus[data-v-e74703]{border:1px solid #333;border-left:none}body .tr-wrapper .number-input button[data-v-e74703]:after{color:#bcbcbc;content:\"-\";font-size:2em;display:inline-block}body .tr-wrapper .number-input button.plus[data-v-e74703]:after{content:\"+\"}body .tr-wrapper .number-input input[type=number][data-v-e74703]{text-align:center;color:#000;border:1px solid #333;border-left:2px;border-right:2px;width:100%;max-width:calc(100% - 8rem);height:4rem;padding:.5rem;font-size:1.8em}body .tr-wrapper .withers-height-input[data-v-e74703],body .tr-wrapper .length-input[data-v-e74703]{background-color:#fff;border:1px solid #333;border-radius:20px;width:325px;margin-bottom:1em;font-size:1.8em;display:inline-block}body .tr-wrapper .withers-height-input input[data-v-e74703],body .tr-wrapper .length-input input[data-v-e74703]{text-align:center;border-radius:20px;width:calc(100% - 2.5em);height:4rem}body .tr-wrapper .withers-height-input[data-v-e74703]{padding-left:1em;display:block}body .tr-wrapper .withers-height-input input[data-v-e74703]{width:calc(100% - 6em)}body .tr-wrapper .screen-withers-height .button-forward[data-v-e74703]{margin-left:0}body .tr-wrapper .select-wrapper[data-v-e74703]{margin-bottom:1em;display:inline-block;position:relative}body .tr-wrapper .select-wrapper select[data-v-e74703]{text-align:center;color:#000;-webkit-appearance:none;-ms-appearance:none;appearance:none;background-color:#fff;background-image:url(\"data:image/svg+xml;utf8,<svg width='24px' height='24px' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><rect x='0' fill='none' width='24' height='24'/><g><path d='M7 10l5 5 5-5'/></g></svg>\");background-position:right 12px center;background-repeat:no-repeat;background-size:3rem;border:none;border-radius:20px;width:325px;max-width:100%;height:4rem;font-size:1.8em;padding:0!important}body .tr-wrapper .button[data-v-e74703]{color:#fff;cursor:pointer;background-color:#ff7b00;border:none;border-radius:.7em;height:4rem;margin:0 1em;padding:0 1.5em;font-size:1.8em;line-height:4rem;transition:all .2s ease-out}body .tr-wrapper .button.button-forward[data-v-e74703]:after{content:\"→\";padding-left:1.2em;font-size:3.6rem;line-height:.5;position:relative;top:.3rem}body .tr-wrapper .button.button-back[data-v-e74703]{margin-left:0}body .tr-wrapper .button.button-back[data-v-e74703]:before{content:\"←\";padding-right:.4em;font-size:3.6rem;line-height:.5;position:relative;top:.3rem}body .tr-wrapper .button[data-v-e74703]:hover{color:#fff;background-color:#5f4bb6}body .tr-wrapper .error-overlay[data-v-e74703],body .tr-wrapper .message-overlay[data-v-e74703]{color:#fff;text-align:center;background-color:#d31c1c;border-radius:1.8em;width:80%;margin:0 auto;padding:3em;font-weight:700;position:absolute;top:5em;left:5%;box-shadow:3px 4px 4px rgba(1,1,1,.3)}body .tr-wrapper .error-overlay span.warning-icon[data-v-e74703],body .tr-wrapper .message-overlay span.warning-icon[data-v-e74703]{text-align:center;width:4em;height:4em;margin:0 auto 1em;display:block}body .tr-wrapper .error-overlay button[data-v-e74703],body .tr-wrapper .message-overlay button[data-v-e74703]{color:#fff;cursor:pointer;background-color:transparent;border:2px solid #fff;border-radius:.7em;padding:.4em 1em;font-size:1.8em}body .tr-wrapper .error-overlay button[data-v-e74703]:hover,body .tr-wrapper .message-overlay button[data-v-e74703]:hover{color:#d31c1c;background-color:#fff}body .tr-wrapper .message-container[data-v-e74703]{margin:4em 0;position:relative}body .tr-wrapper .message-container button.message-button[data-v-e74703]{margin:0}body .tr-wrapper .message-container .message-overlay[data-v-e74703]{z-index:10;background-color:#ff7b00;top:-3em}body .tr-wrapper .message-container .multiple-birds-info.message-overlay[data-v-e74703]{top:-22em}body .tr-wrapper .screen[data-v-e74703]{padding:0;position:relative}body .tr-wrapper .screen-category-selection .image-buttons[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons[data-v-e74703]{flex-wrap:wrap;align-content:flex-start;justify-content:left;align-items:flex-start;gap:40px;display:flex}body .tr-wrapper .screen-category-selection .image-buttons button.image-button[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]{cursor:pointer;color:#fff;background-color:#ff7b00;border:none;border-radius:20px;max-width:220px;padding:0;transition:all .2s ease-out;box-shadow:0 .6em 1.5em rgba(0,0,0,.2)}body .tr-wrapper .screen-category-selection .image-buttons button.image-button .image-wrapper[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button .image-wrapper[data-v-e74703]{aspect-ratio:8/7;border:2px solid #ff7b00;border-radius:16px;transition:all .2s ease-out;overflow:hidden}body .tr-wrapper .screen-category-selection .image-buttons button.image-button img[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button img[data-v-e74703]{max-width:220px;margin-top:-6%;transition:opacity .2s;display:block}body .tr-wrapper .screen-category-selection .image-buttons button.image-button span[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button span[data-v-e74703]{padding:.5em 1em;font-size:1.2em;font-weight:700;display:block}body .tr-wrapper .screen-category-selection .image-buttons button.image-button[data-v-e74703]:hover,body .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]:hover{background-color:#5f4bb6}body .tr-wrapper .screen-category-selection .image-buttons button.image-button:hover .image-wrapper[data-v-e74703],body .tr-wrapper .screen-animal-selection .image-buttons button.image-button:hover .image-wrapper[data-v-e74703]{border-color:#5f4bb6}body .tr-wrapper .screen-category-selection .animal-info[data-v-e74703],body .tr-wrapper .screen-animal-selection .animal-info[data-v-e74703]{margin-top:1em;font-size:1.4em}body .tr-wrapper .screen-results .warning[data-v-e74703]{text-align:left}body .tr-wrapper .screen-results span.warning-icon[data-v-e74703]{float:left;text-align:center;margin-top:.2rem;margin-bottom:.2em;margin-right:1em;display:block}body .tr-wrapper .screen-results span.warning-icon object[data-v-e74703]{width:3.5em;max-width:3.5em}body .tr-wrapper .screen-results .results[data-v-e74703]{flex-wrap:wrap;gap:20px;display:flex}body .tr-wrapper .screen-results .results .results-panel[data-v-e74703]{width:100%;max-width:calc(50% - 10px)}body .tr-wrapper .screen-results .results .results-text p[data-v-e74703]{font-size:1.4rem;font-weight:700}body .tr-wrapper .screen-results .results .results-text p .value[data-v-e74703]{color:#000;font-weight:400}body .tr-wrapper .screen-results .results .results-text p.recommendation-length[data-v-e74703],body .tr-wrapper .screen-results .results .results-text p.law-length[data-v-e74703]{border:2px solid #ff7b00;border-bottom:none;margin-bottom:0;padding:1em 1em 0;font-size:1.125rem}body .tr-wrapper .screen-results .results .results-text p.recommendation-width[data-v-e74703],body .tr-wrapper .screen-results .results .results-text p.law-width[data-v-e74703]{border:2px solid #ff7b00;border-top:none;padding:1em;font-size:1.125rem}body .tr-wrapper .screen-results .results .results-text p.reptiles-law-text[data-v-e74703]{border:2px solid #fff;padding:1em;font-size:1.125rem}body .tr-wrapper .screen-results .results .results-text .tolerance[data-v-e74703]{color:#000;font-weight:400}body .tr-wrapper .screen-results .results .results-text .tolerance span[data-tooltip][data-v-e74703]{color:#000}body .tr-wrapper .screen-results .results .results-visual[data-v-e74703]{padding-top:50%;position:relative}body .tr-wrapper .screen-results .results .results-visual .rectangle[data-v-e74703]{background-color:#fff;border:2px dashed #333;width:80%;height:33%;position:absolute;top:0;left:0}body .tr-wrapper .screen-results .results .results-visual .rectangle span[data-v-e74703]{color:#ed7b2e;font-size:1.2rem;font-weight:700}body .tr-wrapper .screen-results .results .results-visual .rectangle .right-pane[data-v-e74703]{border-left:2px solid #ed7b2e;width:20px;height:100%;position:absolute;right:0}body .tr-wrapper .screen-results .results .results-visual .rectangle .bottom-pane[data-v-e74703]{border-top:2px solid #ed7b2e;width:100%;height:20px;position:absolute;bottom:0}body .tr-wrapper .screen-results .results .results-visual .rectangle .area[data-v-e74703]{text-align:center;color:#fff;width:100%;position:absolute;top:calc(50% - 1em)}body .tr-wrapper .screen-results .results .results-visual .rectangle .width[data-v-e74703]{text-align:center;background-color:#fff;padding:.4em 1em;position:absolute;top:-1.2em;left:calc(50% - 2em)}body .tr-wrapper .screen-results .results .results-visual .rectangle .height[data-v-e74703]{text-align:right;background-color:#fff;width:4em;padding:.5em .4em;position:absolute;top:calc(50% - 1.2em);right:0}body .tr-wrapper .screen-results .results .results-visual .rectangle .caption[data-v-e74703]{font-size:1.25em;position:absolute;bottom:-2.5em}body .tr-wrapper .screen-results .results .results-visual .cube-container[data-v-e74703]{-webkit-perspective:500px;perspective:500px;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));-webkit-transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));transform:scale3d(var(--tr-visual-3d-scale),var(--tr-visual-3d-scale),var(--tr-visual-3d-scale));width:200px;height:200px;margin:100px;position:absolute;top:0;left:0}body .tr-wrapper .screen-results .results .results-visual .cube-container .cube[data-v-e74703]{-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));-webkit-transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));transform:scale3d(var(--tr-visual-3d-scale-x),var(--tr-visual-3d-scale-z),var(--tr-visual-3d-scale-y));width:120px;height:200px;-webkit-animation:10s linear infinite turn-e74703;animation:10s linear infinite turn-e74703;position:relative}body .tr-wrapper .screen-results .results .results-visual .cube-container .face[data-v-e74703]{opacity:1;background:rgba(160,73,16,.3);border:1px solid #000;justify-content:center;align-items:center;width:200px;height:200px;font-size:1.4rem;transition:-webkit-transform .5s,-webkit-transform .5s,-webkit-transform .5s,-webkit-transform .5s,transform .5s;display:flex;position:absolute}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.front[data-v-e74703]{-webkit-transform:translateZ(100px);transform:translateZ(100px)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.back[data-v-e74703]{-webkit-transform:translateZ(-100px)rotateY(180deg);transform:translateZ(-100px)rotateY(180deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.left[data-v-e74703]{-webkit-transform:translate(-100px)rotateY(-90deg);transform:translate(-100px)rotateY(-90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.right[data-v-e74703]{-webkit-transform:translate(100px)rotateY(90deg);transform:translate(100px)rotateY(90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.top[data-v-e74703]{-webkit-transform:translateY(-100px)rotateX(90deg);transform:translateY(-100px)rotateX(90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .face.bottom[data-v-e74703]{-webkit-transform:translateY(100px)rotateX(-90deg);transform:translateY(100px)rotateX(-90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement[data-v-e74703]{justify-content:center;align-items:flex-end;width:200px;height:200px;font-size:1.4rem;display:flex;position:absolute}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement.length[data-v-e74703]{-webkit-transform:translateZ(100px);transform:translateZ(100px)}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement.height[data-v-e74703]{-webkit-transform:translateZ(100px)rotate(90deg);transform:translateZ(100px)rotate(90deg)}body .tr-wrapper .screen-results .results .results-visual .cube-container .measurement.width[data-v-e74703]{-webkit-transform:translate(-100px)rotateY(-90deg);transform:translate(-100px)rotateY(-90deg)}@media (prefers-reduced-motion:reduce){body .tr-wrapper .screen-results .results .results-visual .cube-container .cube[data-v-e74703]{-webkit-animation:none;animation:none;-webkit-transform:rotate3d(1,1,0,45deg);transform:rotate3d(1,1,0,45deg)}}body .tr-wrapper .screen-results .results .results-visual .cube-container .caption[data-v-e74703]{width:20em;font-size:1.25em;position:absolute;bottom:-2.5em;left:-1em}body .tr-wrapper .screen-results .details[data-v-e74703]{color:#000;font-size:1.4rem}body .tr-wrapper .screen-results .details p[data-v-e74703]{color:#000;margin:.5em 0;font-size:1.4rem}body .tr-wrapper .screen-results.madagascarDayGecko .results .results-visual .rectangle[data-v-e74703],body .tr-wrapper .screen-results.goldDustDayGecko .results .results-visual .rectangle[data-v-e74703]{height:41%}body .tr-wrapper .screen-results.macaw .results .results-panel[data-v-e74703],body .tr-wrapper .screen-results.cockatoo .results .results-panel[data-v-e74703]{display:none}body .tr-wrapper .screen-results.equidae .results[data-v-e74703]{justify-content:center}body .tr-wrapper .screen-results.equidae .results .results-visual[data-v-e74703]{max-width:50%;padding-top:32%}body .tr-wrapper .screen-results.equidae .results .results-visual .cube-container[data-v-e74703]{margin-top:20px}body .tr-wrapper .screen-results.equidae .results .results-text[data-v-e74703]{flex-wrap:wrap;gap:20px;max-width:100%;display:flex}body .tr-wrapper .screen-results.equidae .results .results-text .results-text-recommendations[data-v-e74703],body .tr-wrapper .screen-results.equidae .results .results-text .results-text-laws[data-v-e74703]{min-width:360px;max-width:calc(50% - 10px)}body .tr-wrapper .reptiles-revision .screen-animal-selection[data-v-e74703],body .tr-wrapper .reptiles-revision .screen-length[data-v-e74703],body .tr-wrapper .reptiles-revision .screen-number[data-v-e74703],body .tr-wrapper .reptiles-revision .screen-results[data-v-e74703]{display:none}body .sts-tierhaltungsrechner.max1400 .tr-wrapper.style-button.open[data-v-e74703]{padding-top:100px}body .sts-tierhaltungsrechner.max1400 .tr-wrapper .logos .logo.logo-sts[data-v-e74703]{max-width:300px}body .sts-tierhaltungsrechner.max1400 .tr-wrapper .footer[data-v-e74703]{max-width:1000px;margin:0 auto}body .sts-tierhaltungsrechner.max1400 .tr-wrapper h2[data-v-e74703]{text-align:left;max-width:75%}body .sts-tierhaltungsrechner.max884 .tr-wrapper[data-v-e74703]{padding:2em}body .sts-tierhaltungsrechner.max884 .tr-wrapper.style-button.open[data-v-e74703]{width:calc(96% - 4em);padding-top:100px}body .sts-tierhaltungsrechner.max884 .tr-wrapper .close-button[data-v-e74703]{left:2em;right:auto}body .sts-tierhaltungsrechner.max884 .tr-wrapper .footer .logos[data-v-e74703]{text-align:left}body .sts-tierhaltungsrechner.max884 .tr-wrapper .logo.logo-sts[data-v-e74703]{max-width:250px}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-animal-selection .image-buttons[data-v-e74703]{gap:20px 2%}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]{max-width:32%}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-animal-selection .image-buttons button.image-button img[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max884 .tr-wrapper .screen-results.horse .results .results-visual .cube-container[data-v-e74703]{margin-top:0}body .sts-tierhaltungsrechner.max756 .tr-wrapper .logos .logo.logo-sts[data-v-e74703]{max-width:250px;top:1em}body .sts-tierhaltungsrechner.max756 .tr-wrapper h2[data-v-e74703]{text-align:left;max-width:70%;font-size:3.5em}body .sts-tierhaltungsrechner.max756 .tr-wrapper .number-input[data-v-e74703]{display:flex}body .sts-tierhaltungsrechner.max756 .tr-wrapper .button[data-v-e74703]{width:325px;margin:0!important;padding:0!important}body .sts-tierhaltungsrechner.max756 .tr-wrapper .message-container .message-overlay[data-v-e74703]{left:0;right:0}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-animal-selection .image-buttons button.image-button span[data-v-e74703]{font-size:1em}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-number .error-overlay[data-v-e74703]{width:calc(100% - 6em);left:0}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-panel[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-panel .rectangle[data-v-e74703]{width:100%;height:100%}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-visual[data-v-e74703]{margin-bottom:4em}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .results .results-visual .cube-container[data-v-e74703]{margin-top:60px}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .screen-results.horse .results .results-visual .cube-container[data-v-e74703]{margin-top:10px}body .sts-tierhaltungsrechner.max756 .tr-wrapper .screen-results .screen-results.equidae .results .results-visual[data-v-e74703]{padding-top:40%}body .sts-tierhaltungsrechner.max540[data-v-e74703]{--tr-visual-3d-scale:.8}body .sts-tierhaltungsrechner.max540 .tr-button[data-v-e74703]{flex-wrap:wrap;justify-content:center;padding:1em}body .sts-tierhaltungsrechner.max540 .tr-button .logo[data-v-e74703]{margin-bottom:.5em;margin-right:.5em}body .sts-tierhaltungsrechner.max540 .tr-wrapper[data-v-e74703]{padding:2em 1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper.style-button.open[data-v-e74703]{width:calc(96% - 2em);padding-top:100px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .close-button[data-v-e74703]{left:1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper h2[data-v-e74703]{text-align:left;max-width:70%;font-size:3em}body .sts-tierhaltungsrechner.max540 .tr-wrapper p[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper label[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper h3[data-v-e74703]{margin-bottom:1em;font-size:1.4rem}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-image-wrapper[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-image-wrapper img[data-v-e74703]{width:80%;margin:-10% auto 0}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-length .screen-image-wrapper[data-v-e74703]{aspect-ratio:auto;padding:60px 20px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .number-input[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper .withers-height-input[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper .length-input[data-v-e74703]{width:100%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .select-wrapper[data-v-e74703],body .sts-tierhaltungsrechner.max540 .tr-wrapper .select-wrapper select[data-v-e74703]{width:100%!important}body .sts-tierhaltungsrechner.max540 .tr-wrapper .button[data-v-e74703]{width:100%;margin:0 0 1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons[data-v-e74703]{gap:20px 2%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons button.image-button[data-v-e74703]{max-width:48%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons button.image-button img[data-v-e74703]{max-width:100%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-animal-selection .image-buttons button.image-button span[data-v-e74703]{font-size:1em}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results .results .results-visual[data-v-e74703]{margin-bottom:10em}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results .results .results-visual .cube-container[data-v-e74703]{margin:40px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results.horse .results .results-visual[data-v-e74703]{padding-top:10%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results.horse .results .results-visual .cube-container[data-v-e74703]{margin-left:80px}body .sts-tierhaltungsrechner.max540 .tr-wrapper .screen-results.equidae .results .results-visual[data-v-e74703]{padding-top:30%}body .sts-tierhaltungsrechner.max540 .tr-wrapper .bottom-navi[data-v-e74703]{margin-top:2em}";


var $61428dc1a1443e1a$var$style = document.createElement("style");
$61428dc1a1443e1a$var$style.appendChild(document.createTextNode((0, (/*@__PURE__*/$parcel$interopDefault($521c837f559cbd2c$exports)))));
document.head.appendChild($61428dc1a1443e1a$var$style);
var $61428dc1a1443e1a$var$thrInit = function thrInit() {
    var trWidthClasses = // Class names depending on width
    function trWidthClasses() {
        appElements.forEach(function(instance) {
            instance.classList.remove("max1400", "max884", "max756", "max540");
            if (instance.offsetWidth <= 1400) instance.classList.add("max1400");
            if (instance.offsetWidth <= 884) instance.classList.add("max884");
            if (instance.offsetWidth <= 756) instance.classList.add("max756");
            if (instance.offsetWidth <= 540) instance.classList.add("max540");
        //new ResizeObserver(trWidthClasses).observe(instance);
        });
    };
    var appElements = document.querySelectorAll(".sts-tierhaltungsrechner");
    console.log(appElements);
    appElements.forEach(function(instance) {
        // Default Config
        var tierhaltungsrechnerDefaultConfig = {
            locale: "de_CH",
            enableLogs: false,
            preselectCategory: false,
            preselectAnimal: false,
            style: "full",
            historyMode: "internal"
        };
        var thrConfig = {};
        // Read config from global object tierhaltungsrechnerConfig.
        // Deprecated config method, but still implemented for compatibility.
        /* global tierhaltungsrechnerConfig */ if (typeof tierhaltungsrechnerConfig === "object") thrConfig = (0, $do9pw._)({}, tierhaltungsrechnerDefaultConfig, tierhaltungsrechnerConfig);
        else thrConfig = tierhaltungsrechnerDefaultConfig;
        // Read config from data attributes in the DOM element.
        if (typeof instance.dataset === "object") thrConfig = (0, $do9pw._)({}, thrConfig, instance.dataset);
        console.log(thrConfig);
        // Logging config
        var loggingOptions = {
            isEnabled: thrConfig.enableLogs,
            logLevel: "debug",
            stringifyArguments: true,
            showLogLevel: true,
            showMethodName: false,
            separator: "|",
            showConsoleColors: true
        };
        // I18N
        var i18n = (0, $621d7fdcae12fe9c$export$920091e3d72d80ee)({
            locale: thrConfig.locale,
            fallbackLocale: tierhaltungsrechnerDefaultConfig.locale,
            messages: (0, (/*@__PURE__*/$parcel$interopDefault($352877516eff5992$exports)))
        });
        // Initialize App
        var app = (0, $i0Zoc.createApp)((0, $c34d6ef872f89bec$export$2e2bcd8739ae039), {
            thrConfig: thrConfig
        });
        app.use(i18n);
        app.use((0, (/*@__PURE__*/$parcel$interopDefault($b505edbfee5318f0$exports))), loggingOptions);
        app.mount(instance);
    });
    // Events to set class names
    window.addEventListener("load", function() {
        trWidthClasses();
    });
    document.addEventListener("DOMContentLoaded", function() {
        trWidthClasses();
    });
/*

// Load Analytics
  function dynamicallyLoadScript(url) {
    var script = document.createElement('script');
    script.src = 'https://www.googletagmanager.com/gtag/js?id=G-K34PW3LPX1';

    document.head.appendChild(script);
  }

// Load a script
  function loadScript(url, callback) {
    var head = document.head;
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;

// Bind the event to the callback function.
    script.onreadystatechange = callback;
    script.onload = callback;

// Load script
    head.appendChild(script);
  }

// Start Analytics
  function runAnalytics() {
    window.dataLayer = window.dataLayer || [];

    window.gtagTR = function() {
      window.dataLayer.push(arguments);
    };

    window.gtagTR('js', new Date());

    window.gtagTR('config', 'G-K34PW3LPX1');
  }

  loadScript('https://www.googletagmanager.com/gtag/js?id=G-K34PW3LPX1',
      runAnalytics);

*/ };
$61428dc1a1443e1a$var$thrInit();

})();
//# sourceMappingURL=index.2baac22b.js.map
